
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireb02c"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireb02c"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("9uDRS", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $6e95d752d99da952$export$ffb0004e005737fa; }, function (v) { return $6e95d752d99da952$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $6e95d752d99da952$export$34b9dba7ce09269b; }, function (v) { return $6e95d752d99da952$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $6e95d752d99da952$export$25062201e9e25d76; }, function (v) { return $6e95d752d99da952$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6e95d752d99da952$export$ffb0004e005737fa;
var $6e95d752d99da952$export$34b9dba7ce09269b;
var $6e95d752d99da952$export$25062201e9e25d76;
"use strict";

var $69Mlo = parcelRequire("69Mlo");
var $6e95d752d99da952$var$k = Symbol.for("react.element"), $6e95d752d99da952$var$l = Symbol.for("react.fragment"), $6e95d752d99da952$var$m = Object.prototype.hasOwnProperty, $6e95d752d99da952$var$n = $69Mlo.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $6e95d752d99da952$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $6e95d752d99da952$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$6e95d752d99da952$var$m.call(a, b) && !$6e95d752d99da952$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $6e95d752d99da952$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $6e95d752d99da952$var$n.current
    };
}
$6e95d752d99da952$export$ffb0004e005737fa = $6e95d752d99da952$var$l;
$6e95d752d99da952$export$34b9dba7ce09269b = $6e95d752d99da952$var$q;
$6e95d752d99da952$export$25062201e9e25d76 = $6e95d752d99da952$var$q;

});
parcelRegister("69Mlo", function(module, exports) {
"use strict";

module.exports = (parcelRequire("9kO8w"));

});
parcelRegister("9kO8w", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $6cbcdf58350ae140$export$dca3b0875bd9a954; }, function (v) { return $6cbcdf58350ae140$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $6cbcdf58350ae140$export$16fa2f45be04daa8; }, function (v) { return $6cbcdf58350ae140$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $6cbcdf58350ae140$export$ffb0004e005737fa; }, function (v) { return $6cbcdf58350ae140$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $6cbcdf58350ae140$export$e2c29f18771995cb; }, function (v) { return $6cbcdf58350ae140$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $6cbcdf58350ae140$export$221d75b3f55bb0bd; }, function (v) { return $6cbcdf58350ae140$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $6cbcdf58350ae140$export$5f8d39834fd61797; }, function (v) { return $6cbcdf58350ae140$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $6cbcdf58350ae140$export$74bf444e3cd11ea5; }, function (v) { return $6cbcdf58350ae140$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $6cbcdf58350ae140$export$ae55be85d98224ed; }, function (v) { return $6cbcdf58350ae140$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $6cbcdf58350ae140$export$3ba232387fd5d6dd; }, function (v) { return $6cbcdf58350ae140$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $6cbcdf58350ae140$export$e530037191fcd5d7; }, function (v) { return $6cbcdf58350ae140$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $6cbcdf58350ae140$export$fd42f52fd3ae1109; }, function (v) { return $6cbcdf58350ae140$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $6cbcdf58350ae140$export$c8a8987d4410bf2d; }, function (v) { return $6cbcdf58350ae140$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $6cbcdf58350ae140$export$d38cd72104c1f0e9; }, function (v) { return $6cbcdf58350ae140$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $6cbcdf58350ae140$export$7d1e3a5e95ceca43; }, function (v) { return $6cbcdf58350ae140$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $6cbcdf58350ae140$export$257a8862b851cb5b; }, function (v) { return $6cbcdf58350ae140$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $6cbcdf58350ae140$export$a8257692ac88316c; }, function (v) { return $6cbcdf58350ae140$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $6cbcdf58350ae140$export$488013bae63b21da; }, function (v) { return $6cbcdf58350ae140$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $6cbcdf58350ae140$export$7c73462e0d25e514; }, function (v) { return $6cbcdf58350ae140$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $6cbcdf58350ae140$export$7568632d0d33d16d; }, function (v) { return $6cbcdf58350ae140$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $6cbcdf58350ae140$export$88948ce120ea2619; }, function (v) { return $6cbcdf58350ae140$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $6cbcdf58350ae140$export$35808ee640e87ca7; }, function (v) { return $6cbcdf58350ae140$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $6cbcdf58350ae140$export$fae74005e78b1a27; }, function (v) { return $6cbcdf58350ae140$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $6cbcdf58350ae140$export$dc8fbce3eb94dc1e; }, function (v) { return $6cbcdf58350ae140$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $6cbcdf58350ae140$export$6a7bc4e911dc01cf; }, function (v) { return $6cbcdf58350ae140$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $6cbcdf58350ae140$export$6d9c69b0de29b591; }, function (v) { return $6cbcdf58350ae140$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $6cbcdf58350ae140$export$f680877a34711e37; }, function (v) { return $6cbcdf58350ae140$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $6cbcdf58350ae140$export$d5a552a76deda3c2; }, function (v) { return $6cbcdf58350ae140$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $6cbcdf58350ae140$export$aaabe4eda9ed9969; }, function (v) { return $6cbcdf58350ae140$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $6cbcdf58350ae140$export$e5c5a5f917a5871c; }, function (v) { return $6cbcdf58350ae140$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $6cbcdf58350ae140$export$1538c33de8887b59; }, function (v) { return $6cbcdf58350ae140$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $6cbcdf58350ae140$export$13e3392192263954; }, function (v) { return $6cbcdf58350ae140$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $6cbcdf58350ae140$export$b8f5890fc79d6aca; }, function (v) { return $6cbcdf58350ae140$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $6cbcdf58350ae140$export$60241385465d0a34; }, function (v) { return $6cbcdf58350ae140$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $6cbcdf58350ae140$export$306c0aa65ff9ec16; }, function (v) { return $6cbcdf58350ae140$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $6cbcdf58350ae140$export$7b286972b8d8ccbf; }, function (v) { return $6cbcdf58350ae140$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $6cbcdf58350ae140$export$83d89fbfd8236492; }, function (v) { return $6cbcdf58350ae140$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6cbcdf58350ae140$export$dca3b0875bd9a954;
var $6cbcdf58350ae140$export$16fa2f45be04daa8;
var $6cbcdf58350ae140$export$ffb0004e005737fa;
var $6cbcdf58350ae140$export$e2c29f18771995cb;
var $6cbcdf58350ae140$export$221d75b3f55bb0bd;
var $6cbcdf58350ae140$export$5f8d39834fd61797;
var $6cbcdf58350ae140$export$74bf444e3cd11ea5;
var $6cbcdf58350ae140$export$ae55be85d98224ed;
var $6cbcdf58350ae140$export$3ba232387fd5d6dd;
var $6cbcdf58350ae140$export$e530037191fcd5d7;
var $6cbcdf58350ae140$export$fd42f52fd3ae1109;
var $6cbcdf58350ae140$export$c8a8987d4410bf2d;
var $6cbcdf58350ae140$export$d38cd72104c1f0e9;
var $6cbcdf58350ae140$export$7d1e3a5e95ceca43;
var $6cbcdf58350ae140$export$257a8862b851cb5b;
var $6cbcdf58350ae140$export$a8257692ac88316c;
var $6cbcdf58350ae140$export$488013bae63b21da;
var $6cbcdf58350ae140$export$7c73462e0d25e514;
var $6cbcdf58350ae140$export$7568632d0d33d16d;
var $6cbcdf58350ae140$export$88948ce120ea2619;
var $6cbcdf58350ae140$export$35808ee640e87ca7;
var $6cbcdf58350ae140$export$fae74005e78b1a27;
var $6cbcdf58350ae140$export$dc8fbce3eb94dc1e;
var $6cbcdf58350ae140$export$6a7bc4e911dc01cf;
var $6cbcdf58350ae140$export$6d9c69b0de29b591;
var $6cbcdf58350ae140$export$f680877a34711e37;
var $6cbcdf58350ae140$export$d5a552a76deda3c2;
var $6cbcdf58350ae140$export$aaabe4eda9ed9969;
var $6cbcdf58350ae140$export$e5c5a5f917a5871c;
var $6cbcdf58350ae140$export$1538c33de8887b59;
var $6cbcdf58350ae140$export$13e3392192263954;
var $6cbcdf58350ae140$export$b8f5890fc79d6aca;
var $6cbcdf58350ae140$export$60241385465d0a34;
var $6cbcdf58350ae140$export$306c0aa65ff9ec16;
var $6cbcdf58350ae140$export$7b286972b8d8ccbf;
var $6cbcdf58350ae140$export$83d89fbfd8236492;
"use strict";
var $6cbcdf58350ae140$var$l = Symbol.for("react.element"), $6cbcdf58350ae140$var$n = Symbol.for("react.portal"), $6cbcdf58350ae140$var$p = Symbol.for("react.fragment"), $6cbcdf58350ae140$var$q = Symbol.for("react.strict_mode"), $6cbcdf58350ae140$var$r = Symbol.for("react.profiler"), $6cbcdf58350ae140$var$t = Symbol.for("react.provider"), $6cbcdf58350ae140$var$u = Symbol.for("react.context"), $6cbcdf58350ae140$var$v = Symbol.for("react.forward_ref"), $6cbcdf58350ae140$var$w = Symbol.for("react.suspense"), $6cbcdf58350ae140$var$x = Symbol.for("react.memo"), $6cbcdf58350ae140$var$y = Symbol.for("react.lazy"), $6cbcdf58350ae140$var$z = Symbol.iterator;
function $6cbcdf58350ae140$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $6cbcdf58350ae140$var$z && a[$6cbcdf58350ae140$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $6cbcdf58350ae140$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $6cbcdf58350ae140$var$C = Object.assign, $6cbcdf58350ae140$var$D = {};
function $6cbcdf58350ae140$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $6cbcdf58350ae140$var$D;
    this.updater = e || $6cbcdf58350ae140$var$B;
}
$6cbcdf58350ae140$var$E.prototype.isReactComponent = {};
$6cbcdf58350ae140$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$6cbcdf58350ae140$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $6cbcdf58350ae140$var$F() {}
$6cbcdf58350ae140$var$F.prototype = $6cbcdf58350ae140$var$E.prototype;
function $6cbcdf58350ae140$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $6cbcdf58350ae140$var$D;
    this.updater = e || $6cbcdf58350ae140$var$B;
}
var $6cbcdf58350ae140$var$H = $6cbcdf58350ae140$var$G.prototype = new $6cbcdf58350ae140$var$F;
$6cbcdf58350ae140$var$H.constructor = $6cbcdf58350ae140$var$G;
$6cbcdf58350ae140$var$C($6cbcdf58350ae140$var$H, $6cbcdf58350ae140$var$E.prototype);
$6cbcdf58350ae140$var$H.isPureReactComponent = !0;
var $6cbcdf58350ae140$var$I = Array.isArray, $6cbcdf58350ae140$var$J = Object.prototype.hasOwnProperty, $6cbcdf58350ae140$var$K = {
    current: null
}, $6cbcdf58350ae140$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $6cbcdf58350ae140$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$6cbcdf58350ae140$var$J.call(b, d) && !$6cbcdf58350ae140$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $6cbcdf58350ae140$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $6cbcdf58350ae140$var$K.current
    };
}
function $6cbcdf58350ae140$var$N(a, b) {
    return {
        $$typeof: $6cbcdf58350ae140$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $6cbcdf58350ae140$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $6cbcdf58350ae140$var$l;
}
function $6cbcdf58350ae140$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $6cbcdf58350ae140$var$P = /\/+/g;
function $6cbcdf58350ae140$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $6cbcdf58350ae140$var$escape("" + a.key) : b.toString(36);
}
function $6cbcdf58350ae140$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $6cbcdf58350ae140$var$l:
                case $6cbcdf58350ae140$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $6cbcdf58350ae140$var$Q(h, 0) : d, $6cbcdf58350ae140$var$I(c) ? (e = "", null != a && (e = a.replace($6cbcdf58350ae140$var$P, "$&/") + "/"), $6cbcdf58350ae140$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($6cbcdf58350ae140$var$O(c) && (c = $6cbcdf58350ae140$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($6cbcdf58350ae140$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($6cbcdf58350ae140$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $6cbcdf58350ae140$var$Q(k, g);
        h += $6cbcdf58350ae140$var$R(k, b, e, f, c);
    }
    else if (f = $6cbcdf58350ae140$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $6cbcdf58350ae140$var$Q(k, g++), h += $6cbcdf58350ae140$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $6cbcdf58350ae140$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $6cbcdf58350ae140$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $6cbcdf58350ae140$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $6cbcdf58350ae140$var$U = {
    current: null
}, $6cbcdf58350ae140$var$V = {
    transition: null
}, $6cbcdf58350ae140$var$W = {
    ReactCurrentDispatcher: $6cbcdf58350ae140$var$U,
    ReactCurrentBatchConfig: $6cbcdf58350ae140$var$V,
    ReactCurrentOwner: $6cbcdf58350ae140$var$K
};
function $6cbcdf58350ae140$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$6cbcdf58350ae140$export$dca3b0875bd9a954 = {
    map: $6cbcdf58350ae140$var$S,
    forEach: function(a, b, e) {
        $6cbcdf58350ae140$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $6cbcdf58350ae140$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $6cbcdf58350ae140$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$6cbcdf58350ae140$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$6cbcdf58350ae140$export$16fa2f45be04daa8 = $6cbcdf58350ae140$var$E;
$6cbcdf58350ae140$export$ffb0004e005737fa = $6cbcdf58350ae140$var$p;
$6cbcdf58350ae140$export$e2c29f18771995cb = $6cbcdf58350ae140$var$r;
$6cbcdf58350ae140$export$221d75b3f55bb0bd = $6cbcdf58350ae140$var$G;
$6cbcdf58350ae140$export$5f8d39834fd61797 = $6cbcdf58350ae140$var$q;
$6cbcdf58350ae140$export$74bf444e3cd11ea5 = $6cbcdf58350ae140$var$w;
$6cbcdf58350ae140$export$ae55be85d98224ed = $6cbcdf58350ae140$var$W;
$6cbcdf58350ae140$export$3ba232387fd5d6dd = $6cbcdf58350ae140$var$X;
$6cbcdf58350ae140$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $6cbcdf58350ae140$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $6cbcdf58350ae140$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$6cbcdf58350ae140$var$J.call(b, f) && !$6cbcdf58350ae140$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $6cbcdf58350ae140$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$6cbcdf58350ae140$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $6cbcdf58350ae140$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $6cbcdf58350ae140$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$6cbcdf58350ae140$export$c8a8987d4410bf2d = $6cbcdf58350ae140$var$M;
$6cbcdf58350ae140$export$d38cd72104c1f0e9 = function(a) {
    var b = $6cbcdf58350ae140$var$M.bind(null, a);
    b.type = a;
    return b;
};
$6cbcdf58350ae140$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$6cbcdf58350ae140$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $6cbcdf58350ae140$var$v,
        render: a
    };
};
$6cbcdf58350ae140$export$a8257692ac88316c = $6cbcdf58350ae140$var$O;
$6cbcdf58350ae140$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $6cbcdf58350ae140$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $6cbcdf58350ae140$var$T
    };
};
$6cbcdf58350ae140$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $6cbcdf58350ae140$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$6cbcdf58350ae140$export$7568632d0d33d16d = function(a) {
    var b = $6cbcdf58350ae140$var$V.transition;
    $6cbcdf58350ae140$var$V.transition = {};
    try {
        a();
    } finally{
        $6cbcdf58350ae140$var$V.transition = b;
    }
};
$6cbcdf58350ae140$export$88948ce120ea2619 = $6cbcdf58350ae140$var$X;
$6cbcdf58350ae140$export$35808ee640e87ca7 = function(a, b) {
    return $6cbcdf58350ae140$var$U.current.useCallback(a, b);
};
$6cbcdf58350ae140$export$fae74005e78b1a27 = function(a) {
    return $6cbcdf58350ae140$var$U.current.useContext(a);
};
$6cbcdf58350ae140$export$dc8fbce3eb94dc1e = function() {};
$6cbcdf58350ae140$export$6a7bc4e911dc01cf = function(a) {
    return $6cbcdf58350ae140$var$U.current.useDeferredValue(a);
};
$6cbcdf58350ae140$export$6d9c69b0de29b591 = function(a, b) {
    return $6cbcdf58350ae140$var$U.current.useEffect(a, b);
};
$6cbcdf58350ae140$export$f680877a34711e37 = function() {
    return $6cbcdf58350ae140$var$U.current.useId();
};
$6cbcdf58350ae140$export$d5a552a76deda3c2 = function(a, b, e) {
    return $6cbcdf58350ae140$var$U.current.useImperativeHandle(a, b, e);
};
$6cbcdf58350ae140$export$aaabe4eda9ed9969 = function(a, b) {
    return $6cbcdf58350ae140$var$U.current.useInsertionEffect(a, b);
};
$6cbcdf58350ae140$export$e5c5a5f917a5871c = function(a, b) {
    return $6cbcdf58350ae140$var$U.current.useLayoutEffect(a, b);
};
$6cbcdf58350ae140$export$1538c33de8887b59 = function(a, b) {
    return $6cbcdf58350ae140$var$U.current.useMemo(a, b);
};
$6cbcdf58350ae140$export$13e3392192263954 = function(a, b, e) {
    return $6cbcdf58350ae140$var$U.current.useReducer(a, b, e);
};
$6cbcdf58350ae140$export$b8f5890fc79d6aca = function(a) {
    return $6cbcdf58350ae140$var$U.current.useRef(a);
};
$6cbcdf58350ae140$export$60241385465d0a34 = function(a) {
    return $6cbcdf58350ae140$var$U.current.useState(a);
};
$6cbcdf58350ae140$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $6cbcdf58350ae140$var$U.current.useSyncExternalStore(a, b, e);
};
$6cbcdf58350ae140$export$7b286972b8d8ccbf = function() {
    return $6cbcdf58350ae140$var$U.current.useTransition();
};
$6cbcdf58350ae140$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("58tS1", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $3bd4deb882852edb$export$ae55be85d98224ed; }, function (v) { return $3bd4deb882852edb$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $3bd4deb882852edb$export$d39a5bbd09211389; }, function (v) { return $3bd4deb882852edb$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $3bd4deb882852edb$export$882461b6382ed46c; }, function (v) { return $3bd4deb882852edb$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $3bd4deb882852edb$export$466bfc07425424d5; }, function (v) { return $3bd4deb882852edb$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $3bd4deb882852edb$export$cd75ccfd720a3cd4; }, function (v) { return $3bd4deb882852edb$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $3bd4deb882852edb$export$fa8d919ba61d84db; }, function (v) { return $3bd4deb882852edb$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $3bd4deb882852edb$export$757ceba2d55c277e; }, function (v) { return $3bd4deb882852edb$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $3bd4deb882852edb$export$b3890eb0ae9dca99; }, function (v) { return $3bd4deb882852edb$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $3bd4deb882852edb$export$502457920280e6be; }, function (v) { return $3bd4deb882852edb$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $3bd4deb882852edb$export$c78a37762a8d58e1; }, function (v) { return $3bd4deb882852edb$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $3bd4deb882852edb$export$dc54d992c10e8a18; }, function (v) { return $3bd4deb882852edb$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $3bd4deb882852edb$export$83d89fbfd8236492; }, function (v) { return $3bd4deb882852edb$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $3bd4deb882852edb$export$ae55be85d98224ed;
var $3bd4deb882852edb$export$d39a5bbd09211389;
var $3bd4deb882852edb$export$882461b6382ed46c;
var $3bd4deb882852edb$export$466bfc07425424d5;
var $3bd4deb882852edb$export$cd75ccfd720a3cd4;
var $3bd4deb882852edb$export$fa8d919ba61d84db;
var $3bd4deb882852edb$export$757ceba2d55c277e;
var $3bd4deb882852edb$export$b3890eb0ae9dca99;
var $3bd4deb882852edb$export$502457920280e6be;
var $3bd4deb882852edb$export$c78a37762a8d58e1;
var $3bd4deb882852edb$export$dc54d992c10e8a18;
var $3bd4deb882852edb$export$83d89fbfd8236492;
"use strict";

var $69Mlo = parcelRequire("69Mlo");

var $euyry = parcelRequire("euyry");
function $3bd4deb882852edb$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $3bd4deb882852edb$var$da = new Set, $3bd4deb882852edb$var$ea = {};
function $3bd4deb882852edb$var$fa(a, b) {
    $3bd4deb882852edb$var$ha(a, b);
    $3bd4deb882852edb$var$ha(a + "Capture", b);
}
function $3bd4deb882852edb$var$ha(a, b) {
    $3bd4deb882852edb$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$3bd4deb882852edb$var$da.add(b[a]);
}
var $3bd4deb882852edb$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $3bd4deb882852edb$var$ja = Object.prototype.hasOwnProperty, $3bd4deb882852edb$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $3bd4deb882852edb$var$la = {}, $3bd4deb882852edb$var$ma = {};
function $3bd4deb882852edb$var$oa(a) {
    if ($3bd4deb882852edb$var$ja.call($3bd4deb882852edb$var$ma, a)) return !0;
    if ($3bd4deb882852edb$var$ja.call($3bd4deb882852edb$var$la, a)) return !1;
    if ($3bd4deb882852edb$var$ka.test(a)) return $3bd4deb882852edb$var$ma[a] = !0;
    $3bd4deb882852edb$var$la[a] = !0;
    return !1;
}
function $3bd4deb882852edb$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $3bd4deb882852edb$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $3bd4deb882852edb$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $3bd4deb882852edb$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $3bd4deb882852edb$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $3bd4deb882852edb$var$z[a] = new $3bd4deb882852edb$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $3bd4deb882852edb$var$z[b] = new $3bd4deb882852edb$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $3bd4deb882852edb$var$z[a] = new $3bd4deb882852edb$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $3bd4deb882852edb$var$z[a] = new $3bd4deb882852edb$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $3bd4deb882852edb$var$z[a] = new $3bd4deb882852edb$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $3bd4deb882852edb$var$z[a] = new $3bd4deb882852edb$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $3bd4deb882852edb$var$z[a] = new $3bd4deb882852edb$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $3bd4deb882852edb$var$z[a] = new $3bd4deb882852edb$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $3bd4deb882852edb$var$z[a] = new $3bd4deb882852edb$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $3bd4deb882852edb$var$ra = /[\-:]([a-z])/g;
function $3bd4deb882852edb$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($3bd4deb882852edb$var$ra, $3bd4deb882852edb$var$sa);
    $3bd4deb882852edb$var$z[b] = new $3bd4deb882852edb$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($3bd4deb882852edb$var$ra, $3bd4deb882852edb$var$sa);
    $3bd4deb882852edb$var$z[b] = new $3bd4deb882852edb$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($3bd4deb882852edb$var$ra, $3bd4deb882852edb$var$sa);
    $3bd4deb882852edb$var$z[b] = new $3bd4deb882852edb$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $3bd4deb882852edb$var$z[a] = new $3bd4deb882852edb$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$3bd4deb882852edb$var$z.xlinkHref = new $3bd4deb882852edb$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $3bd4deb882852edb$var$z[a] = new $3bd4deb882852edb$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $3bd4deb882852edb$var$ta(a, b, c, d) {
    var e = $3bd4deb882852edb$var$z.hasOwnProperty(b) ? $3bd4deb882852edb$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $3bd4deb882852edb$var$qa(b, c, e, d) && (c = null), d || null === e ? $3bd4deb882852edb$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $3bd4deb882852edb$var$ua = $69Mlo.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $3bd4deb882852edb$var$va = Symbol.for("react.element"), $3bd4deb882852edb$var$wa = Symbol.for("react.portal"), $3bd4deb882852edb$var$ya = Symbol.for("react.fragment"), $3bd4deb882852edb$var$za = Symbol.for("react.strict_mode"), $3bd4deb882852edb$var$Aa = Symbol.for("react.profiler"), $3bd4deb882852edb$var$Ba = Symbol.for("react.provider"), $3bd4deb882852edb$var$Ca = Symbol.for("react.context"), $3bd4deb882852edb$var$Da = Symbol.for("react.forward_ref"), $3bd4deb882852edb$var$Ea = Symbol.for("react.suspense"), $3bd4deb882852edb$var$Fa = Symbol.for("react.suspense_list"), $3bd4deb882852edb$var$Ga = Symbol.for("react.memo"), $3bd4deb882852edb$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $3bd4deb882852edb$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $3bd4deb882852edb$var$Ja = Symbol.iterator;
function $3bd4deb882852edb$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $3bd4deb882852edb$var$Ja && a[$3bd4deb882852edb$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $3bd4deb882852edb$var$A = Object.assign, $3bd4deb882852edb$var$La;
function $3bd4deb882852edb$var$Ma(a) {
    if (void 0 === $3bd4deb882852edb$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $3bd4deb882852edb$var$La = b && b[1] || "";
    }
    return "\n" + $3bd4deb882852edb$var$La + a;
}
var $3bd4deb882852edb$var$Na = !1;
function $3bd4deb882852edb$var$Oa(a, b) {
    if (!a || $3bd4deb882852edb$var$Na) return "";
    $3bd4deb882852edb$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $3bd4deb882852edb$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $3bd4deb882852edb$var$Ma(a) : "";
}
function $3bd4deb882852edb$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $3bd4deb882852edb$var$Ma(a.type);
        case 16:
            return $3bd4deb882852edb$var$Ma("Lazy");
        case 13:
            return $3bd4deb882852edb$var$Ma("Suspense");
        case 19:
            return $3bd4deb882852edb$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $3bd4deb882852edb$var$Oa(a.type, !1), a;
        case 11:
            return a = $3bd4deb882852edb$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $3bd4deb882852edb$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $3bd4deb882852edb$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $3bd4deb882852edb$var$ya:
            return "Fragment";
        case $3bd4deb882852edb$var$wa:
            return "Portal";
        case $3bd4deb882852edb$var$Aa:
            return "Profiler";
        case $3bd4deb882852edb$var$za:
            return "StrictMode";
        case $3bd4deb882852edb$var$Ea:
            return "Suspense";
        case $3bd4deb882852edb$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $3bd4deb882852edb$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $3bd4deb882852edb$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $3bd4deb882852edb$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $3bd4deb882852edb$var$Ga:
            return b = a.displayName || null, null !== b ? b : $3bd4deb882852edb$var$Qa(a.type) || "Memo";
        case $3bd4deb882852edb$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $3bd4deb882852edb$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $3bd4deb882852edb$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $3bd4deb882852edb$var$Qa(b);
        case 8:
            return b === $3bd4deb882852edb$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $3bd4deb882852edb$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $3bd4deb882852edb$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $3bd4deb882852edb$var$Ua(a) {
    var b = $3bd4deb882852edb$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $3bd4deb882852edb$var$Va(a) {
    a._valueTracker || (a._valueTracker = $3bd4deb882852edb$var$Ua(a));
}
function $3bd4deb882852edb$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $3bd4deb882852edb$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $3bd4deb882852edb$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $3bd4deb882852edb$var$Ya(a, b) {
    var c = b.checked;
    return $3bd4deb882852edb$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $3bd4deb882852edb$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $3bd4deb882852edb$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $3bd4deb882852edb$var$ab(a, b) {
    b = b.checked;
    null != b && $3bd4deb882852edb$var$ta(a, "checked", b, !1);
}
function $3bd4deb882852edb$var$bb(a, b) {
    $3bd4deb882852edb$var$ab(a, b);
    var c = $3bd4deb882852edb$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $3bd4deb882852edb$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $3bd4deb882852edb$var$cb(a, b.type, $3bd4deb882852edb$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $3bd4deb882852edb$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $3bd4deb882852edb$var$cb(a, b, c) {
    if ("number" !== b || $3bd4deb882852edb$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $3bd4deb882852edb$var$eb = Array.isArray;
function $3bd4deb882852edb$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $3bd4deb882852edb$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $3bd4deb882852edb$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($3bd4deb882852edb$var$p(91));
    return $3bd4deb882852edb$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $3bd4deb882852edb$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($3bd4deb882852edb$var$p(92));
            if ($3bd4deb882852edb$var$eb(c)) {
                if (1 < c.length) throw Error($3bd4deb882852edb$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $3bd4deb882852edb$var$Sa(c)
    };
}
function $3bd4deb882852edb$var$ib(a, b) {
    var c = $3bd4deb882852edb$var$Sa(b.value), d = $3bd4deb882852edb$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $3bd4deb882852edb$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $3bd4deb882852edb$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $3bd4deb882852edb$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $3bd4deb882852edb$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $3bd4deb882852edb$var$mb, $3bd4deb882852edb$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $3bd4deb882852edb$var$mb = $3bd4deb882852edb$var$mb || document.createElement("div");
        $3bd4deb882852edb$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $3bd4deb882852edb$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $3bd4deb882852edb$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $3bd4deb882852edb$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $3bd4deb882852edb$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($3bd4deb882852edb$var$pb).forEach(function(a) {
    $3bd4deb882852edb$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $3bd4deb882852edb$var$pb[b] = $3bd4deb882852edb$var$pb[a];
    });
});
function $3bd4deb882852edb$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $3bd4deb882852edb$var$pb.hasOwnProperty(a) && $3bd4deb882852edb$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $3bd4deb882852edb$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $3bd4deb882852edb$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $3bd4deb882852edb$var$tb = $3bd4deb882852edb$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $3bd4deb882852edb$var$ub(a, b) {
    if (b) {
        if ($3bd4deb882852edb$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($3bd4deb882852edb$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($3bd4deb882852edb$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($3bd4deb882852edb$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($3bd4deb882852edb$var$p(62));
    }
}
function $3bd4deb882852edb$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $3bd4deb882852edb$var$wb = null;
function $3bd4deb882852edb$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $3bd4deb882852edb$var$yb = null, $3bd4deb882852edb$var$zb = null, $3bd4deb882852edb$var$Ab = null;
function $3bd4deb882852edb$var$Bb(a) {
    if (a = $3bd4deb882852edb$var$Cb(a)) {
        if ("function" !== typeof $3bd4deb882852edb$var$yb) throw Error($3bd4deb882852edb$var$p(280));
        var b = a.stateNode;
        b && (b = $3bd4deb882852edb$var$Db(b), $3bd4deb882852edb$var$yb(a.stateNode, a.type, b));
    }
}
function $3bd4deb882852edb$var$Eb(a) {
    $3bd4deb882852edb$var$zb ? $3bd4deb882852edb$var$Ab ? $3bd4deb882852edb$var$Ab.push(a) : $3bd4deb882852edb$var$Ab = [
        a
    ] : $3bd4deb882852edb$var$zb = a;
}
function $3bd4deb882852edb$var$Fb() {
    if ($3bd4deb882852edb$var$zb) {
        var a = $3bd4deb882852edb$var$zb, b = $3bd4deb882852edb$var$Ab;
        $3bd4deb882852edb$var$Ab = $3bd4deb882852edb$var$zb = null;
        $3bd4deb882852edb$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$3bd4deb882852edb$var$Bb(b[a]);
    }
}
function $3bd4deb882852edb$var$Gb(a, b) {
    return a(b);
}
function $3bd4deb882852edb$var$Hb() {}
var $3bd4deb882852edb$var$Ib = !1;
function $3bd4deb882852edb$var$Jb(a, b, c) {
    if ($3bd4deb882852edb$var$Ib) return a(b, c);
    $3bd4deb882852edb$var$Ib = !0;
    try {
        return $3bd4deb882852edb$var$Gb(a, b, c);
    } finally{
        if ($3bd4deb882852edb$var$Ib = !1, null !== $3bd4deb882852edb$var$zb || null !== $3bd4deb882852edb$var$Ab) $3bd4deb882852edb$var$Hb(), $3bd4deb882852edb$var$Fb();
    }
}
function $3bd4deb882852edb$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $3bd4deb882852edb$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($3bd4deb882852edb$var$p(231, b, typeof c));
    return c;
}
var $3bd4deb882852edb$var$Lb = !1;
if ($3bd4deb882852edb$var$ia) try {
    var $3bd4deb882852edb$var$Mb = {};
    Object.defineProperty($3bd4deb882852edb$var$Mb, "passive", {
        get: function() {
            $3bd4deb882852edb$var$Lb = !0;
        }
    });
    window.addEventListener("test", $3bd4deb882852edb$var$Mb, $3bd4deb882852edb$var$Mb);
    window.removeEventListener("test", $3bd4deb882852edb$var$Mb, $3bd4deb882852edb$var$Mb);
} catch (a) {
    $3bd4deb882852edb$var$Lb = !1;
}
function $3bd4deb882852edb$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $3bd4deb882852edb$var$Ob = !1, $3bd4deb882852edb$var$Pb = null, $3bd4deb882852edb$var$Qb = !1, $3bd4deb882852edb$var$Rb = null, $3bd4deb882852edb$var$Sb = {
    onError: function(a) {
        $3bd4deb882852edb$var$Ob = !0;
        $3bd4deb882852edb$var$Pb = a;
    }
};
function $3bd4deb882852edb$var$Tb(a, b, c, d, e, f, g, h, k) {
    $3bd4deb882852edb$var$Ob = !1;
    $3bd4deb882852edb$var$Pb = null;
    $3bd4deb882852edb$var$Nb.apply($3bd4deb882852edb$var$Sb, arguments);
}
function $3bd4deb882852edb$var$Ub(a, b, c, d, e, f, g, h, k) {
    $3bd4deb882852edb$var$Tb.apply(this, arguments);
    if ($3bd4deb882852edb$var$Ob) {
        if ($3bd4deb882852edb$var$Ob) {
            var l = $3bd4deb882852edb$var$Pb;
            $3bd4deb882852edb$var$Ob = !1;
            $3bd4deb882852edb$var$Pb = null;
        } else throw Error($3bd4deb882852edb$var$p(198));
        $3bd4deb882852edb$var$Qb || ($3bd4deb882852edb$var$Qb = !0, $3bd4deb882852edb$var$Rb = l);
    }
}
function $3bd4deb882852edb$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $3bd4deb882852edb$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $3bd4deb882852edb$var$Xb(a) {
    if ($3bd4deb882852edb$var$Vb(a) !== a) throw Error($3bd4deb882852edb$var$p(188));
}
function $3bd4deb882852edb$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $3bd4deb882852edb$var$Vb(a);
        if (null === b) throw Error($3bd4deb882852edb$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $3bd4deb882852edb$var$Xb(e), a;
                if (f === d) return $3bd4deb882852edb$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($3bd4deb882852edb$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($3bd4deb882852edb$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($3bd4deb882852edb$var$p(190));
    }
    if (3 !== c.tag) throw Error($3bd4deb882852edb$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $3bd4deb882852edb$var$Zb(a) {
    a = $3bd4deb882852edb$var$Yb(a);
    return null !== a ? $3bd4deb882852edb$var$$b(a) : null;
}
function $3bd4deb882852edb$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $3bd4deb882852edb$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $3bd4deb882852edb$var$ac = $euyry.unstable_scheduleCallback, $3bd4deb882852edb$var$bc = $euyry.unstable_cancelCallback, $3bd4deb882852edb$var$cc = $euyry.unstable_shouldYield, $3bd4deb882852edb$var$dc = $euyry.unstable_requestPaint, $3bd4deb882852edb$var$B = $euyry.unstable_now, $3bd4deb882852edb$var$ec = $euyry.unstable_getCurrentPriorityLevel, $3bd4deb882852edb$var$fc = $euyry.unstable_ImmediatePriority, $3bd4deb882852edb$var$gc = $euyry.unstable_UserBlockingPriority, $3bd4deb882852edb$var$hc = $euyry.unstable_NormalPriority, $3bd4deb882852edb$var$ic = $euyry.unstable_LowPriority, $3bd4deb882852edb$var$jc = $euyry.unstable_IdlePriority, $3bd4deb882852edb$var$kc = null, $3bd4deb882852edb$var$lc = null;
function $3bd4deb882852edb$var$mc(a) {
    if ($3bd4deb882852edb$var$lc && "function" === typeof $3bd4deb882852edb$var$lc.onCommitFiberRoot) try {
        $3bd4deb882852edb$var$lc.onCommitFiberRoot($3bd4deb882852edb$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $3bd4deb882852edb$var$oc = Math.clz32 ? Math.clz32 : $3bd4deb882852edb$var$nc, $3bd4deb882852edb$var$pc = Math.log, $3bd4deb882852edb$var$qc = Math.LN2;
function $3bd4deb882852edb$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($3bd4deb882852edb$var$pc(a) / $3bd4deb882852edb$var$qc | 0) | 0;
}
var $3bd4deb882852edb$var$rc = 64, $3bd4deb882852edb$var$sc = 4194304;
function $3bd4deb882852edb$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $3bd4deb882852edb$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $3bd4deb882852edb$var$tc(h) : (f &= g, 0 !== f && (d = $3bd4deb882852edb$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $3bd4deb882852edb$var$tc(g) : 0 !== f && (d = $3bd4deb882852edb$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $3bd4deb882852edb$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $3bd4deb882852edb$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $3bd4deb882852edb$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $3bd4deb882852edb$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $3bd4deb882852edb$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $3bd4deb882852edb$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $3bd4deb882852edb$var$yc() {
    var a = $3bd4deb882852edb$var$rc;
    $3bd4deb882852edb$var$rc <<= 1;
    0 === ($3bd4deb882852edb$var$rc & 4194240) && ($3bd4deb882852edb$var$rc = 64);
    return a;
}
function $3bd4deb882852edb$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $3bd4deb882852edb$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $3bd4deb882852edb$var$oc(b);
    a[b] = c;
}
function $3bd4deb882852edb$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $3bd4deb882852edb$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $3bd4deb882852edb$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $3bd4deb882852edb$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $3bd4deb882852edb$var$C = 0;
function $3bd4deb882852edb$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $3bd4deb882852edb$var$Ec, $3bd4deb882852edb$var$Fc, $3bd4deb882852edb$var$Gc, $3bd4deb882852edb$var$Hc, $3bd4deb882852edb$var$Ic, $3bd4deb882852edb$var$Jc = !1, $3bd4deb882852edb$var$Kc = [], $3bd4deb882852edb$var$Lc = null, $3bd4deb882852edb$var$Mc = null, $3bd4deb882852edb$var$Nc = null, $3bd4deb882852edb$var$Oc = new Map, $3bd4deb882852edb$var$Pc = new Map, $3bd4deb882852edb$var$Qc = [], $3bd4deb882852edb$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $3bd4deb882852edb$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $3bd4deb882852edb$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $3bd4deb882852edb$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $3bd4deb882852edb$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $3bd4deb882852edb$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $3bd4deb882852edb$var$Pc.delete(b.pointerId);
    }
}
function $3bd4deb882852edb$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $3bd4deb882852edb$var$Cb(b), null !== b && $3bd4deb882852edb$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $3bd4deb882852edb$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $3bd4deb882852edb$var$Lc = $3bd4deb882852edb$var$Tc($3bd4deb882852edb$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $3bd4deb882852edb$var$Mc = $3bd4deb882852edb$var$Tc($3bd4deb882852edb$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $3bd4deb882852edb$var$Nc = $3bd4deb882852edb$var$Tc($3bd4deb882852edb$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $3bd4deb882852edb$var$Oc.set(f, $3bd4deb882852edb$var$Tc($3bd4deb882852edb$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $3bd4deb882852edb$var$Pc.set(f, $3bd4deb882852edb$var$Tc($3bd4deb882852edb$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $3bd4deb882852edb$var$Vc(a) {
    var b = $3bd4deb882852edb$var$Wc(a.target);
    if (null !== b) {
        var c = $3bd4deb882852edb$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $3bd4deb882852edb$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $3bd4deb882852edb$var$Ic(a.priority, function() {
                        $3bd4deb882852edb$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $3bd4deb882852edb$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $3bd4deb882852edb$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $3bd4deb882852edb$var$wb = d;
            c.target.dispatchEvent(d);
            $3bd4deb882852edb$var$wb = null;
        } else return b = $3bd4deb882852edb$var$Cb(c), null !== b && $3bd4deb882852edb$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $3bd4deb882852edb$var$Zc(a, b, c) {
    $3bd4deb882852edb$var$Xc(a) && c.delete(b);
}
function $3bd4deb882852edb$var$$c() {
    $3bd4deb882852edb$var$Jc = !1;
    null !== $3bd4deb882852edb$var$Lc && $3bd4deb882852edb$var$Xc($3bd4deb882852edb$var$Lc) && ($3bd4deb882852edb$var$Lc = null);
    null !== $3bd4deb882852edb$var$Mc && $3bd4deb882852edb$var$Xc($3bd4deb882852edb$var$Mc) && ($3bd4deb882852edb$var$Mc = null);
    null !== $3bd4deb882852edb$var$Nc && $3bd4deb882852edb$var$Xc($3bd4deb882852edb$var$Nc) && ($3bd4deb882852edb$var$Nc = null);
    $3bd4deb882852edb$var$Oc.forEach($3bd4deb882852edb$var$Zc);
    $3bd4deb882852edb$var$Pc.forEach($3bd4deb882852edb$var$Zc);
}
function $3bd4deb882852edb$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $3bd4deb882852edb$var$Jc || ($3bd4deb882852edb$var$Jc = !0, $euyry.unstable_scheduleCallback($euyry.unstable_NormalPriority, $3bd4deb882852edb$var$$c)));
}
function $3bd4deb882852edb$var$bd(a) {
    function b(b) {
        return $3bd4deb882852edb$var$ad(b, a);
    }
    if (0 < $3bd4deb882852edb$var$Kc.length) {
        $3bd4deb882852edb$var$ad($3bd4deb882852edb$var$Kc[0], a);
        for(var c = 1; c < $3bd4deb882852edb$var$Kc.length; c++){
            var d = $3bd4deb882852edb$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $3bd4deb882852edb$var$Lc && $3bd4deb882852edb$var$ad($3bd4deb882852edb$var$Lc, a);
    null !== $3bd4deb882852edb$var$Mc && $3bd4deb882852edb$var$ad($3bd4deb882852edb$var$Mc, a);
    null !== $3bd4deb882852edb$var$Nc && $3bd4deb882852edb$var$ad($3bd4deb882852edb$var$Nc, a);
    $3bd4deb882852edb$var$Oc.forEach(b);
    $3bd4deb882852edb$var$Pc.forEach(b);
    for(c = 0; c < $3bd4deb882852edb$var$Qc.length; c++)d = $3bd4deb882852edb$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $3bd4deb882852edb$var$Qc.length && (c = $3bd4deb882852edb$var$Qc[0], null === c.blockedOn);)$3bd4deb882852edb$var$Vc(c), null === c.blockedOn && $3bd4deb882852edb$var$Qc.shift();
}
var $3bd4deb882852edb$var$cd = $3bd4deb882852edb$var$ua.ReactCurrentBatchConfig, $3bd4deb882852edb$var$dd = !0;
function $3bd4deb882852edb$var$ed(a, b, c, d) {
    var e = $3bd4deb882852edb$var$C, f = $3bd4deb882852edb$var$cd.transition;
    $3bd4deb882852edb$var$cd.transition = null;
    try {
        $3bd4deb882852edb$var$C = 1, $3bd4deb882852edb$var$fd(a, b, c, d);
    } finally{
        $3bd4deb882852edb$var$C = e, $3bd4deb882852edb$var$cd.transition = f;
    }
}
function $3bd4deb882852edb$var$gd(a, b, c, d) {
    var e = $3bd4deb882852edb$var$C, f = $3bd4deb882852edb$var$cd.transition;
    $3bd4deb882852edb$var$cd.transition = null;
    try {
        $3bd4deb882852edb$var$C = 4, $3bd4deb882852edb$var$fd(a, b, c, d);
    } finally{
        $3bd4deb882852edb$var$C = e, $3bd4deb882852edb$var$cd.transition = f;
    }
}
function $3bd4deb882852edb$var$fd(a, b, c, d) {
    if ($3bd4deb882852edb$var$dd) {
        var e = $3bd4deb882852edb$var$Yc(a, b, c, d);
        if (null === e) $3bd4deb882852edb$var$hd(a, b, d, $3bd4deb882852edb$var$id, c), $3bd4deb882852edb$var$Sc(a, d);
        else if ($3bd4deb882852edb$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($3bd4deb882852edb$var$Sc(a, d), b & 4 && -1 < $3bd4deb882852edb$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $3bd4deb882852edb$var$Cb(e);
                null !== f && $3bd4deb882852edb$var$Ec(f);
                f = $3bd4deb882852edb$var$Yc(a, b, c, d);
                null === f && $3bd4deb882852edb$var$hd(a, b, d, $3bd4deb882852edb$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $3bd4deb882852edb$var$hd(a, b, d, null, c);
    }
}
var $3bd4deb882852edb$var$id = null;
function $3bd4deb882852edb$var$Yc(a, b, c, d) {
    $3bd4deb882852edb$var$id = null;
    a = $3bd4deb882852edb$var$xb(d);
    a = $3bd4deb882852edb$var$Wc(a);
    if (null !== a) {
        if (b = $3bd4deb882852edb$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $3bd4deb882852edb$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $3bd4deb882852edb$var$id = a;
    return null;
}
function $3bd4deb882852edb$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($3bd4deb882852edb$var$ec()){
                case $3bd4deb882852edb$var$fc:
                    return 1;
                case $3bd4deb882852edb$var$gc:
                    return 4;
                case $3bd4deb882852edb$var$hc:
                case $3bd4deb882852edb$var$ic:
                    return 16;
                case $3bd4deb882852edb$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $3bd4deb882852edb$var$kd = null, $3bd4deb882852edb$var$ld = null, $3bd4deb882852edb$var$md = null;
function $3bd4deb882852edb$var$nd() {
    if ($3bd4deb882852edb$var$md) return $3bd4deb882852edb$var$md;
    var a, b = $3bd4deb882852edb$var$ld, c = b.length, d, e = "value" in $3bd4deb882852edb$var$kd ? $3bd4deb882852edb$var$kd.value : $3bd4deb882852edb$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $3bd4deb882852edb$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $3bd4deb882852edb$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $3bd4deb882852edb$var$pd() {
    return !0;
}
function $3bd4deb882852edb$var$qd() {
    return !1;
}
function $3bd4deb882852edb$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $3bd4deb882852edb$var$pd : $3bd4deb882852edb$var$qd;
        this.isPropagationStopped = $3bd4deb882852edb$var$qd;
        return this;
    }
    $3bd4deb882852edb$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $3bd4deb882852edb$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $3bd4deb882852edb$var$pd);
        },
        persist: function() {},
        isPersistent: $3bd4deb882852edb$var$pd
    });
    return b;
}
var $3bd4deb882852edb$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $3bd4deb882852edb$var$td = $3bd4deb882852edb$var$rd($3bd4deb882852edb$var$sd), $3bd4deb882852edb$var$ud = $3bd4deb882852edb$var$A({}, $3bd4deb882852edb$var$sd, {
    view: 0,
    detail: 0
}), $3bd4deb882852edb$var$vd = $3bd4deb882852edb$var$rd($3bd4deb882852edb$var$ud), $3bd4deb882852edb$var$wd, $3bd4deb882852edb$var$xd, $3bd4deb882852edb$var$yd, $3bd4deb882852edb$var$Ad = $3bd4deb882852edb$var$A({}, $3bd4deb882852edb$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $3bd4deb882852edb$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $3bd4deb882852edb$var$yd && ($3bd4deb882852edb$var$yd && "mousemove" === a.type ? ($3bd4deb882852edb$var$wd = a.screenX - $3bd4deb882852edb$var$yd.screenX, $3bd4deb882852edb$var$xd = a.screenY - $3bd4deb882852edb$var$yd.screenY) : $3bd4deb882852edb$var$xd = $3bd4deb882852edb$var$wd = 0, $3bd4deb882852edb$var$yd = a);
        return $3bd4deb882852edb$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $3bd4deb882852edb$var$xd;
    }
}), $3bd4deb882852edb$var$Bd = $3bd4deb882852edb$var$rd($3bd4deb882852edb$var$Ad), $3bd4deb882852edb$var$Cd = $3bd4deb882852edb$var$A({}, $3bd4deb882852edb$var$Ad, {
    dataTransfer: 0
}), $3bd4deb882852edb$var$Dd = $3bd4deb882852edb$var$rd($3bd4deb882852edb$var$Cd), $3bd4deb882852edb$var$Ed = $3bd4deb882852edb$var$A({}, $3bd4deb882852edb$var$ud, {
    relatedTarget: 0
}), $3bd4deb882852edb$var$Fd = $3bd4deb882852edb$var$rd($3bd4deb882852edb$var$Ed), $3bd4deb882852edb$var$Gd = $3bd4deb882852edb$var$A({}, $3bd4deb882852edb$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $3bd4deb882852edb$var$Hd = $3bd4deb882852edb$var$rd($3bd4deb882852edb$var$Gd), $3bd4deb882852edb$var$Id = $3bd4deb882852edb$var$A({}, $3bd4deb882852edb$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $3bd4deb882852edb$var$Jd = $3bd4deb882852edb$var$rd($3bd4deb882852edb$var$Id), $3bd4deb882852edb$var$Kd = $3bd4deb882852edb$var$A({}, $3bd4deb882852edb$var$sd, {
    data: 0
}), $3bd4deb882852edb$var$Ld = $3bd4deb882852edb$var$rd($3bd4deb882852edb$var$Kd), $3bd4deb882852edb$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $3bd4deb882852edb$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $3bd4deb882852edb$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $3bd4deb882852edb$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $3bd4deb882852edb$var$Od[a]) ? !!b[a] : !1;
}
function $3bd4deb882852edb$var$zd() {
    return $3bd4deb882852edb$var$Pd;
}
var $3bd4deb882852edb$var$Qd = $3bd4deb882852edb$var$A({}, $3bd4deb882852edb$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $3bd4deb882852edb$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $3bd4deb882852edb$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $3bd4deb882852edb$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $3bd4deb882852edb$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $3bd4deb882852edb$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $3bd4deb882852edb$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $3bd4deb882852edb$var$Rd = $3bd4deb882852edb$var$rd($3bd4deb882852edb$var$Qd), $3bd4deb882852edb$var$Sd = $3bd4deb882852edb$var$A({}, $3bd4deb882852edb$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $3bd4deb882852edb$var$Td = $3bd4deb882852edb$var$rd($3bd4deb882852edb$var$Sd), $3bd4deb882852edb$var$Ud = $3bd4deb882852edb$var$A({}, $3bd4deb882852edb$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $3bd4deb882852edb$var$zd
}), $3bd4deb882852edb$var$Vd = $3bd4deb882852edb$var$rd($3bd4deb882852edb$var$Ud), $3bd4deb882852edb$var$Wd = $3bd4deb882852edb$var$A({}, $3bd4deb882852edb$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $3bd4deb882852edb$var$Xd = $3bd4deb882852edb$var$rd($3bd4deb882852edb$var$Wd), $3bd4deb882852edb$var$Yd = $3bd4deb882852edb$var$A({}, $3bd4deb882852edb$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $3bd4deb882852edb$var$Zd = $3bd4deb882852edb$var$rd($3bd4deb882852edb$var$Yd), $3bd4deb882852edb$var$$d = [
    9,
    13,
    27,
    32
], $3bd4deb882852edb$var$ae = $3bd4deb882852edb$var$ia && "CompositionEvent" in window, $3bd4deb882852edb$var$be = null;
$3bd4deb882852edb$var$ia && "documentMode" in document && ($3bd4deb882852edb$var$be = document.documentMode);
var $3bd4deb882852edb$var$ce = $3bd4deb882852edb$var$ia && "TextEvent" in window && !$3bd4deb882852edb$var$be, $3bd4deb882852edb$var$de = $3bd4deb882852edb$var$ia && (!$3bd4deb882852edb$var$ae || $3bd4deb882852edb$var$be && 8 < $3bd4deb882852edb$var$be && 11 >= $3bd4deb882852edb$var$be), $3bd4deb882852edb$var$ee = String.fromCharCode(32), $3bd4deb882852edb$var$fe = !1;
function $3bd4deb882852edb$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $3bd4deb882852edb$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $3bd4deb882852edb$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $3bd4deb882852edb$var$ie = !1;
function $3bd4deb882852edb$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $3bd4deb882852edb$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $3bd4deb882852edb$var$fe = !0;
            return $3bd4deb882852edb$var$ee;
        case "textInput":
            return a = b.data, a === $3bd4deb882852edb$var$ee && $3bd4deb882852edb$var$fe ? null : a;
        default:
            return null;
    }
}
function $3bd4deb882852edb$var$ke(a, b) {
    if ($3bd4deb882852edb$var$ie) return "compositionend" === a || !$3bd4deb882852edb$var$ae && $3bd4deb882852edb$var$ge(a, b) ? (a = $3bd4deb882852edb$var$nd(), $3bd4deb882852edb$var$md = $3bd4deb882852edb$var$ld = $3bd4deb882852edb$var$kd = null, $3bd4deb882852edb$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $3bd4deb882852edb$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $3bd4deb882852edb$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $3bd4deb882852edb$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$3bd4deb882852edb$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $3bd4deb882852edb$var$ne(a, b, c, d) {
    $3bd4deb882852edb$var$Eb(d);
    b = $3bd4deb882852edb$var$oe(b, "onChange");
    0 < b.length && (c = new $3bd4deb882852edb$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $3bd4deb882852edb$var$pe = null, $3bd4deb882852edb$var$qe = null;
function $3bd4deb882852edb$var$re(a) {
    $3bd4deb882852edb$var$se(a, 0);
}
function $3bd4deb882852edb$var$te(a) {
    var b = $3bd4deb882852edb$var$ue(a);
    if ($3bd4deb882852edb$var$Wa(b)) return a;
}
function $3bd4deb882852edb$var$ve(a, b) {
    if ("change" === a) return b;
}
var $3bd4deb882852edb$var$we = !1;
if ($3bd4deb882852edb$var$ia) {
    var $3bd4deb882852edb$var$xe;
    if ($3bd4deb882852edb$var$ia) {
        var $3bd4deb882852edb$var$ye = "oninput" in document;
        if (!$3bd4deb882852edb$var$ye) {
            var $3bd4deb882852edb$var$ze = document.createElement("div");
            $3bd4deb882852edb$var$ze.setAttribute("oninput", "return;");
            $3bd4deb882852edb$var$ye = "function" === typeof $3bd4deb882852edb$var$ze.oninput;
        }
        $3bd4deb882852edb$var$xe = $3bd4deb882852edb$var$ye;
    } else $3bd4deb882852edb$var$xe = !1;
    $3bd4deb882852edb$var$we = $3bd4deb882852edb$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $3bd4deb882852edb$var$Ae() {
    $3bd4deb882852edb$var$pe && ($3bd4deb882852edb$var$pe.detachEvent("onpropertychange", $3bd4deb882852edb$var$Be), $3bd4deb882852edb$var$qe = $3bd4deb882852edb$var$pe = null);
}
function $3bd4deb882852edb$var$Be(a) {
    if ("value" === a.propertyName && $3bd4deb882852edb$var$te($3bd4deb882852edb$var$qe)) {
        var b = [];
        $3bd4deb882852edb$var$ne(b, $3bd4deb882852edb$var$qe, a, $3bd4deb882852edb$var$xb(a));
        $3bd4deb882852edb$var$Jb($3bd4deb882852edb$var$re, b);
    }
}
function $3bd4deb882852edb$var$Ce(a, b, c) {
    "focusin" === a ? ($3bd4deb882852edb$var$Ae(), $3bd4deb882852edb$var$pe = b, $3bd4deb882852edb$var$qe = c, $3bd4deb882852edb$var$pe.attachEvent("onpropertychange", $3bd4deb882852edb$var$Be)) : "focusout" === a && $3bd4deb882852edb$var$Ae();
}
function $3bd4deb882852edb$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $3bd4deb882852edb$var$te($3bd4deb882852edb$var$qe);
}
function $3bd4deb882852edb$var$Ee(a, b) {
    if ("click" === a) return $3bd4deb882852edb$var$te(b);
}
function $3bd4deb882852edb$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $3bd4deb882852edb$var$te(b);
}
function $3bd4deb882852edb$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $3bd4deb882852edb$var$He = "function" === typeof Object.is ? Object.is : $3bd4deb882852edb$var$Ge;
function $3bd4deb882852edb$var$Ie(a, b) {
    if ($3bd4deb882852edb$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$3bd4deb882852edb$var$ja.call(b, e) || !$3bd4deb882852edb$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $3bd4deb882852edb$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $3bd4deb882852edb$var$Ke(a, b) {
    var c = $3bd4deb882852edb$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $3bd4deb882852edb$var$Je(c);
    }
}
function $3bd4deb882852edb$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $3bd4deb882852edb$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $3bd4deb882852edb$var$Me() {
    for(var a = window, b = $3bd4deb882852edb$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $3bd4deb882852edb$var$Xa(a.document);
    }
    return b;
}
function $3bd4deb882852edb$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $3bd4deb882852edb$var$Oe(a) {
    var b = $3bd4deb882852edb$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $3bd4deb882852edb$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $3bd4deb882852edb$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $3bd4deb882852edb$var$Ke(c, f);
                var g = $3bd4deb882852edb$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $3bd4deb882852edb$var$Pe = $3bd4deb882852edb$var$ia && "documentMode" in document && 11 >= document.documentMode, $3bd4deb882852edb$var$Qe = null, $3bd4deb882852edb$var$Re = null, $3bd4deb882852edb$var$Se = null, $3bd4deb882852edb$var$Te = !1;
function $3bd4deb882852edb$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $3bd4deb882852edb$var$Te || null == $3bd4deb882852edb$var$Qe || $3bd4deb882852edb$var$Qe !== $3bd4deb882852edb$var$Xa(d) || (d = $3bd4deb882852edb$var$Qe, "selectionStart" in d && $3bd4deb882852edb$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $3bd4deb882852edb$var$Se && $3bd4deb882852edb$var$Ie($3bd4deb882852edb$var$Se, d) || ($3bd4deb882852edb$var$Se = d, d = $3bd4deb882852edb$var$oe($3bd4deb882852edb$var$Re, "onSelect"), 0 < d.length && (b = new $3bd4deb882852edb$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $3bd4deb882852edb$var$Qe)));
}
function $3bd4deb882852edb$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $3bd4deb882852edb$var$We = {
    animationend: $3bd4deb882852edb$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $3bd4deb882852edb$var$Ve("Animation", "AnimationIteration"),
    animationstart: $3bd4deb882852edb$var$Ve("Animation", "AnimationStart"),
    transitionend: $3bd4deb882852edb$var$Ve("Transition", "TransitionEnd")
}, $3bd4deb882852edb$var$Xe = {}, $3bd4deb882852edb$var$Ye = {};
$3bd4deb882852edb$var$ia && ($3bd4deb882852edb$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $3bd4deb882852edb$var$We.animationend.animation, delete $3bd4deb882852edb$var$We.animationiteration.animation, delete $3bd4deb882852edb$var$We.animationstart.animation), "TransitionEvent" in window || delete $3bd4deb882852edb$var$We.transitionend.transition);
function $3bd4deb882852edb$var$Ze(a) {
    if ($3bd4deb882852edb$var$Xe[a]) return $3bd4deb882852edb$var$Xe[a];
    if (!$3bd4deb882852edb$var$We[a]) return a;
    var b = $3bd4deb882852edb$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $3bd4deb882852edb$var$Ye) return $3bd4deb882852edb$var$Xe[a] = b[c];
    return a;
}
var $3bd4deb882852edb$var$$e = $3bd4deb882852edb$var$Ze("animationend"), $3bd4deb882852edb$var$af = $3bd4deb882852edb$var$Ze("animationiteration"), $3bd4deb882852edb$var$bf = $3bd4deb882852edb$var$Ze("animationstart"), $3bd4deb882852edb$var$cf = $3bd4deb882852edb$var$Ze("transitionend"), $3bd4deb882852edb$var$df = new Map, $3bd4deb882852edb$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $3bd4deb882852edb$var$ff(a, b) {
    $3bd4deb882852edb$var$df.set(a, b);
    $3bd4deb882852edb$var$fa(b, [
        a
    ]);
}
for(var $3bd4deb882852edb$var$gf = 0; $3bd4deb882852edb$var$gf < $3bd4deb882852edb$var$ef.length; $3bd4deb882852edb$var$gf++){
    var $3bd4deb882852edb$var$hf = $3bd4deb882852edb$var$ef[$3bd4deb882852edb$var$gf], $3bd4deb882852edb$var$jf = $3bd4deb882852edb$var$hf.toLowerCase(), $3bd4deb882852edb$var$kf = $3bd4deb882852edb$var$hf[0].toUpperCase() + $3bd4deb882852edb$var$hf.slice(1);
    $3bd4deb882852edb$var$ff($3bd4deb882852edb$var$jf, "on" + $3bd4deb882852edb$var$kf);
}
$3bd4deb882852edb$var$ff($3bd4deb882852edb$var$$e, "onAnimationEnd");
$3bd4deb882852edb$var$ff($3bd4deb882852edb$var$af, "onAnimationIteration");
$3bd4deb882852edb$var$ff($3bd4deb882852edb$var$bf, "onAnimationStart");
$3bd4deb882852edb$var$ff("dblclick", "onDoubleClick");
$3bd4deb882852edb$var$ff("focusin", "onFocus");
$3bd4deb882852edb$var$ff("focusout", "onBlur");
$3bd4deb882852edb$var$ff($3bd4deb882852edb$var$cf, "onTransitionEnd");
$3bd4deb882852edb$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$3bd4deb882852edb$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$3bd4deb882852edb$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$3bd4deb882852edb$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$3bd4deb882852edb$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$3bd4deb882852edb$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$3bd4deb882852edb$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$3bd4deb882852edb$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$3bd4deb882852edb$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$3bd4deb882852edb$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $3bd4deb882852edb$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $3bd4deb882852edb$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($3bd4deb882852edb$var$lf));
function $3bd4deb882852edb$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $3bd4deb882852edb$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $3bd4deb882852edb$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $3bd4deb882852edb$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $3bd4deb882852edb$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($3bd4deb882852edb$var$Qb) throw a = $3bd4deb882852edb$var$Rb, $3bd4deb882852edb$var$Qb = !1, $3bd4deb882852edb$var$Rb = null, a;
}
function $3bd4deb882852edb$var$D(a, b) {
    var c = b[$3bd4deb882852edb$var$of];
    void 0 === c && (c = b[$3bd4deb882852edb$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($3bd4deb882852edb$var$pf(b, a, 2, !1), c.add(d));
}
function $3bd4deb882852edb$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $3bd4deb882852edb$var$pf(c, a, d, b);
}
var $3bd4deb882852edb$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $3bd4deb882852edb$var$sf(a) {
    if (!a[$3bd4deb882852edb$var$rf]) {
        a[$3bd4deb882852edb$var$rf] = !0;
        $3bd4deb882852edb$var$da.forEach(function(b) {
            "selectionchange" !== b && ($3bd4deb882852edb$var$mf.has(b) || $3bd4deb882852edb$var$qf(b, !1, a), $3bd4deb882852edb$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$3bd4deb882852edb$var$rf] || (b[$3bd4deb882852edb$var$rf] = !0, $3bd4deb882852edb$var$qf("selectionchange", !1, b));
    }
}
function $3bd4deb882852edb$var$pf(a, b, c, d) {
    switch($3bd4deb882852edb$var$jd(b)){
        case 1:
            var e = $3bd4deb882852edb$var$ed;
            break;
        case 4:
            e = $3bd4deb882852edb$var$gd;
            break;
        default:
            e = $3bd4deb882852edb$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$3bd4deb882852edb$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $3bd4deb882852edb$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $3bd4deb882852edb$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $3bd4deb882852edb$var$Jb(function() {
        var d = f, e = $3bd4deb882852edb$var$xb(c), g = [];
        a: {
            var h = $3bd4deb882852edb$var$df.get(a);
            if (void 0 !== h) {
                var k = $3bd4deb882852edb$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $3bd4deb882852edb$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $3bd4deb882852edb$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $3bd4deb882852edb$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $3bd4deb882852edb$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $3bd4deb882852edb$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $3bd4deb882852edb$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $3bd4deb882852edb$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $3bd4deb882852edb$var$Vd;
                        break;
                    case $3bd4deb882852edb$var$$e:
                    case $3bd4deb882852edb$var$af:
                    case $3bd4deb882852edb$var$bf:
                        k = $3bd4deb882852edb$var$Hd;
                        break;
                    case $3bd4deb882852edb$var$cf:
                        k = $3bd4deb882852edb$var$Xd;
                        break;
                    case "scroll":
                        k = $3bd4deb882852edb$var$vd;
                        break;
                    case "wheel":
                        k = $3bd4deb882852edb$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $3bd4deb882852edb$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $3bd4deb882852edb$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $3bd4deb882852edb$var$Kb(w, x), null != F && t.push($3bd4deb882852edb$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $3bd4deb882852edb$var$wb && (n = c.relatedTarget || c.fromElement) && ($3bd4deb882852edb$var$Wc(n) || n[$3bd4deb882852edb$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $3bd4deb882852edb$var$Wc(n) : null, null !== n && (J = $3bd4deb882852edb$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $3bd4deb882852edb$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $3bd4deb882852edb$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $3bd4deb882852edb$var$ue(k);
                        u = null == n ? h : $3bd4deb882852edb$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $3bd4deb882852edb$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $3bd4deb882852edb$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $3bd4deb882852edb$var$vf(F))u++;
                            for(; 0 < w - u;)t = $3bd4deb882852edb$var$vf(t), w--;
                            for(; 0 < u - w;)x = $3bd4deb882852edb$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $3bd4deb882852edb$var$vf(t);
                                x = $3bd4deb882852edb$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $3bd4deb882852edb$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $3bd4deb882852edb$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $3bd4deb882852edb$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $3bd4deb882852edb$var$ve;
                else if ($3bd4deb882852edb$var$me(h)) {
                    if ($3bd4deb882852edb$var$we) na = $3bd4deb882852edb$var$Fe;
                    else {
                        na = $3bd4deb882852edb$var$De;
                        var xa = $3bd4deb882852edb$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $3bd4deb882852edb$var$Ee);
                if (na && (na = na(a, d))) {
                    $3bd4deb882852edb$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $3bd4deb882852edb$var$cb(h, "number", h.value);
            }
            xa = d ? $3bd4deb882852edb$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($3bd4deb882852edb$var$me(xa) || "true" === xa.contentEditable) $3bd4deb882852edb$var$Qe = xa, $3bd4deb882852edb$var$Re = d, $3bd4deb882852edb$var$Se = null;
                    break;
                case "focusout":
                    $3bd4deb882852edb$var$Se = $3bd4deb882852edb$var$Re = $3bd4deb882852edb$var$Qe = null;
                    break;
                case "mousedown":
                    $3bd4deb882852edb$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $3bd4deb882852edb$var$Te = !1;
                    $3bd4deb882852edb$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($3bd4deb882852edb$var$Pe) break;
                case "keydown":
                case "keyup":
                    $3bd4deb882852edb$var$Ue(g, c, e);
            }
            var $a;
            if ($3bd4deb882852edb$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $3bd4deb882852edb$var$ie ? $3bd4deb882852edb$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($3bd4deb882852edb$var$de && "ko" !== c.locale && ($3bd4deb882852edb$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $3bd4deb882852edb$var$ie && ($a = $3bd4deb882852edb$var$nd()) : ($3bd4deb882852edb$var$kd = e, $3bd4deb882852edb$var$ld = "value" in $3bd4deb882852edb$var$kd ? $3bd4deb882852edb$var$kd.value : $3bd4deb882852edb$var$kd.textContent, $3bd4deb882852edb$var$ie = !0)), xa = $3bd4deb882852edb$var$oe(d, ba), 0 < xa.length && (ba = new $3bd4deb882852edb$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $3bd4deb882852edb$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $3bd4deb882852edb$var$ce ? $3bd4deb882852edb$var$je(a, c) : $3bd4deb882852edb$var$ke(a, c)) d = $3bd4deb882852edb$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $3bd4deb882852edb$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $3bd4deb882852edb$var$se(g, b);
    });
}
function $3bd4deb882852edb$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $3bd4deb882852edb$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $3bd4deb882852edb$var$Kb(a, c), null != f && d.unshift($3bd4deb882852edb$var$tf(a, f, e)), f = $3bd4deb882852edb$var$Kb(a, b), null != f && d.push($3bd4deb882852edb$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $3bd4deb882852edb$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $3bd4deb882852edb$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $3bd4deb882852edb$var$Kb(c, f), null != k && g.unshift($3bd4deb882852edb$var$tf(c, k, h))) : e || (k = $3bd4deb882852edb$var$Kb(c, f), null != k && g.push($3bd4deb882852edb$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $3bd4deb882852edb$var$xf = /\r\n?/g, $3bd4deb882852edb$var$yf = /\u0000|\uFFFD/g;
function $3bd4deb882852edb$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($3bd4deb882852edb$var$xf, "\n").replace($3bd4deb882852edb$var$yf, "");
}
function $3bd4deb882852edb$var$Af(a, b, c) {
    b = $3bd4deb882852edb$var$zf(b);
    if ($3bd4deb882852edb$var$zf(a) !== b && c) throw Error($3bd4deb882852edb$var$p(425));
}
function $3bd4deb882852edb$var$Bf() {}
var $3bd4deb882852edb$var$Cf = null, $3bd4deb882852edb$var$Df = null;
function $3bd4deb882852edb$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $3bd4deb882852edb$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $3bd4deb882852edb$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $3bd4deb882852edb$var$Hf = "function" === typeof Promise ? Promise : void 0, $3bd4deb882852edb$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $3bd4deb882852edb$var$Hf ? function(a) {
    return $3bd4deb882852edb$var$Hf.resolve(null).then(a).catch($3bd4deb882852edb$var$If);
} : $3bd4deb882852edb$var$Ff;
function $3bd4deb882852edb$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $3bd4deb882852edb$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $3bd4deb882852edb$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $3bd4deb882852edb$var$bd(b);
}
function $3bd4deb882852edb$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $3bd4deb882852edb$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $3bd4deb882852edb$var$Nf = Math.random().toString(36).slice(2), $3bd4deb882852edb$var$Of = "__reactFiber$" + $3bd4deb882852edb$var$Nf, $3bd4deb882852edb$var$Pf = "__reactProps$" + $3bd4deb882852edb$var$Nf, $3bd4deb882852edb$var$uf = "__reactContainer$" + $3bd4deb882852edb$var$Nf, $3bd4deb882852edb$var$of = "__reactEvents$" + $3bd4deb882852edb$var$Nf, $3bd4deb882852edb$var$Qf = "__reactListeners$" + $3bd4deb882852edb$var$Nf, $3bd4deb882852edb$var$Rf = "__reactHandles$" + $3bd4deb882852edb$var$Nf;
function $3bd4deb882852edb$var$Wc(a) {
    var b = a[$3bd4deb882852edb$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$3bd4deb882852edb$var$uf] || c[$3bd4deb882852edb$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $3bd4deb882852edb$var$Mf(a); null !== a;){
                if (c = a[$3bd4deb882852edb$var$Of]) return c;
                a = $3bd4deb882852edb$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $3bd4deb882852edb$var$Cb(a) {
    a = a[$3bd4deb882852edb$var$Of] || a[$3bd4deb882852edb$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $3bd4deb882852edb$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($3bd4deb882852edb$var$p(33));
}
function $3bd4deb882852edb$var$Db(a) {
    return a[$3bd4deb882852edb$var$Pf] || null;
}
var $3bd4deb882852edb$var$Sf = [], $3bd4deb882852edb$var$Tf = -1;
function $3bd4deb882852edb$var$Uf(a) {
    return {
        current: a
    };
}
function $3bd4deb882852edb$var$E(a) {
    0 > $3bd4deb882852edb$var$Tf || (a.current = $3bd4deb882852edb$var$Sf[$3bd4deb882852edb$var$Tf], $3bd4deb882852edb$var$Sf[$3bd4deb882852edb$var$Tf] = null, $3bd4deb882852edb$var$Tf--);
}
function $3bd4deb882852edb$var$G(a, b) {
    $3bd4deb882852edb$var$Tf++;
    $3bd4deb882852edb$var$Sf[$3bd4deb882852edb$var$Tf] = a.current;
    a.current = b;
}
var $3bd4deb882852edb$var$Vf = {}, $3bd4deb882852edb$var$H = $3bd4deb882852edb$var$Uf($3bd4deb882852edb$var$Vf), $3bd4deb882852edb$var$Wf = $3bd4deb882852edb$var$Uf(!1), $3bd4deb882852edb$var$Xf = $3bd4deb882852edb$var$Vf;
function $3bd4deb882852edb$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $3bd4deb882852edb$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $3bd4deb882852edb$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $3bd4deb882852edb$var$$f() {
    $3bd4deb882852edb$var$E($3bd4deb882852edb$var$Wf);
    $3bd4deb882852edb$var$E($3bd4deb882852edb$var$H);
}
function $3bd4deb882852edb$var$ag(a, b, c) {
    if ($3bd4deb882852edb$var$H.current !== $3bd4deb882852edb$var$Vf) throw Error($3bd4deb882852edb$var$p(168));
    $3bd4deb882852edb$var$G($3bd4deb882852edb$var$H, b);
    $3bd4deb882852edb$var$G($3bd4deb882852edb$var$Wf, c);
}
function $3bd4deb882852edb$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($3bd4deb882852edb$var$p(108, $3bd4deb882852edb$var$Ra(a) || "Unknown", e));
    return $3bd4deb882852edb$var$A({}, c, d);
}
function $3bd4deb882852edb$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $3bd4deb882852edb$var$Vf;
    $3bd4deb882852edb$var$Xf = $3bd4deb882852edb$var$H.current;
    $3bd4deb882852edb$var$G($3bd4deb882852edb$var$H, a);
    $3bd4deb882852edb$var$G($3bd4deb882852edb$var$Wf, $3bd4deb882852edb$var$Wf.current);
    return !0;
}
function $3bd4deb882852edb$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($3bd4deb882852edb$var$p(169));
    c ? (a = $3bd4deb882852edb$var$bg(a, b, $3bd4deb882852edb$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $3bd4deb882852edb$var$E($3bd4deb882852edb$var$Wf), $3bd4deb882852edb$var$E($3bd4deb882852edb$var$H), $3bd4deb882852edb$var$G($3bd4deb882852edb$var$H, a)) : $3bd4deb882852edb$var$E($3bd4deb882852edb$var$Wf);
    $3bd4deb882852edb$var$G($3bd4deb882852edb$var$Wf, c);
}
var $3bd4deb882852edb$var$eg = null, $3bd4deb882852edb$var$fg = !1, $3bd4deb882852edb$var$gg = !1;
function $3bd4deb882852edb$var$hg(a) {
    null === $3bd4deb882852edb$var$eg ? $3bd4deb882852edb$var$eg = [
        a
    ] : $3bd4deb882852edb$var$eg.push(a);
}
function $3bd4deb882852edb$var$ig(a) {
    $3bd4deb882852edb$var$fg = !0;
    $3bd4deb882852edb$var$hg(a);
}
function $3bd4deb882852edb$var$jg() {
    if (!$3bd4deb882852edb$var$gg && null !== $3bd4deb882852edb$var$eg) {
        $3bd4deb882852edb$var$gg = !0;
        var a = 0, b = $3bd4deb882852edb$var$C;
        try {
            var c = $3bd4deb882852edb$var$eg;
            for($3bd4deb882852edb$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $3bd4deb882852edb$var$eg = null;
            $3bd4deb882852edb$var$fg = !1;
        } catch (e) {
            throw null !== $3bd4deb882852edb$var$eg && ($3bd4deb882852edb$var$eg = $3bd4deb882852edb$var$eg.slice(a + 1)), $3bd4deb882852edb$var$ac($3bd4deb882852edb$var$fc, $3bd4deb882852edb$var$jg), e;
        } finally{
            $3bd4deb882852edb$var$C = b, $3bd4deb882852edb$var$gg = !1;
        }
    }
    return null;
}
var $3bd4deb882852edb$var$kg = [], $3bd4deb882852edb$var$lg = 0, $3bd4deb882852edb$var$mg = null, $3bd4deb882852edb$var$ng = 0, $3bd4deb882852edb$var$og = [], $3bd4deb882852edb$var$pg = 0, $3bd4deb882852edb$var$qg = null, $3bd4deb882852edb$var$rg = 1, $3bd4deb882852edb$var$sg = "";
function $3bd4deb882852edb$var$tg(a, b) {
    $3bd4deb882852edb$var$kg[$3bd4deb882852edb$var$lg++] = $3bd4deb882852edb$var$ng;
    $3bd4deb882852edb$var$kg[$3bd4deb882852edb$var$lg++] = $3bd4deb882852edb$var$mg;
    $3bd4deb882852edb$var$mg = a;
    $3bd4deb882852edb$var$ng = b;
}
function $3bd4deb882852edb$var$ug(a, b, c) {
    $3bd4deb882852edb$var$og[$3bd4deb882852edb$var$pg++] = $3bd4deb882852edb$var$rg;
    $3bd4deb882852edb$var$og[$3bd4deb882852edb$var$pg++] = $3bd4deb882852edb$var$sg;
    $3bd4deb882852edb$var$og[$3bd4deb882852edb$var$pg++] = $3bd4deb882852edb$var$qg;
    $3bd4deb882852edb$var$qg = a;
    var d = $3bd4deb882852edb$var$rg;
    a = $3bd4deb882852edb$var$sg;
    var e = 32 - $3bd4deb882852edb$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $3bd4deb882852edb$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $3bd4deb882852edb$var$rg = 1 << 32 - $3bd4deb882852edb$var$oc(b) + e | c << e | d;
        $3bd4deb882852edb$var$sg = f + a;
    } else $3bd4deb882852edb$var$rg = 1 << f | c << e | d, $3bd4deb882852edb$var$sg = a;
}
function $3bd4deb882852edb$var$vg(a) {
    null !== a.return && ($3bd4deb882852edb$var$tg(a, 1), $3bd4deb882852edb$var$ug(a, 1, 0));
}
function $3bd4deb882852edb$var$wg(a) {
    for(; a === $3bd4deb882852edb$var$mg;)$3bd4deb882852edb$var$mg = $3bd4deb882852edb$var$kg[--$3bd4deb882852edb$var$lg], $3bd4deb882852edb$var$kg[$3bd4deb882852edb$var$lg] = null, $3bd4deb882852edb$var$ng = $3bd4deb882852edb$var$kg[--$3bd4deb882852edb$var$lg], $3bd4deb882852edb$var$kg[$3bd4deb882852edb$var$lg] = null;
    for(; a === $3bd4deb882852edb$var$qg;)$3bd4deb882852edb$var$qg = $3bd4deb882852edb$var$og[--$3bd4deb882852edb$var$pg], $3bd4deb882852edb$var$og[$3bd4deb882852edb$var$pg] = null, $3bd4deb882852edb$var$sg = $3bd4deb882852edb$var$og[--$3bd4deb882852edb$var$pg], $3bd4deb882852edb$var$og[$3bd4deb882852edb$var$pg] = null, $3bd4deb882852edb$var$rg = $3bd4deb882852edb$var$og[--$3bd4deb882852edb$var$pg], $3bd4deb882852edb$var$og[$3bd4deb882852edb$var$pg] = null;
}
var $3bd4deb882852edb$var$xg = null, $3bd4deb882852edb$var$yg = null, $3bd4deb882852edb$var$I = !1, $3bd4deb882852edb$var$zg = null;
function $3bd4deb882852edb$var$Ag(a, b) {
    var c = $3bd4deb882852edb$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $3bd4deb882852edb$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $3bd4deb882852edb$var$xg = a, $3bd4deb882852edb$var$yg = $3bd4deb882852edb$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $3bd4deb882852edb$var$xg = a, $3bd4deb882852edb$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $3bd4deb882852edb$var$qg ? {
                id: $3bd4deb882852edb$var$rg,
                overflow: $3bd4deb882852edb$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $3bd4deb882852edb$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $3bd4deb882852edb$var$xg = a, $3bd4deb882852edb$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $3bd4deb882852edb$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $3bd4deb882852edb$var$Eg(a) {
    if ($3bd4deb882852edb$var$I) {
        var b = $3bd4deb882852edb$var$yg;
        if (b) {
            var c = b;
            if (!$3bd4deb882852edb$var$Cg(a, b)) {
                if ($3bd4deb882852edb$var$Dg(a)) throw Error($3bd4deb882852edb$var$p(418));
                b = $3bd4deb882852edb$var$Lf(c.nextSibling);
                var d = $3bd4deb882852edb$var$xg;
                b && $3bd4deb882852edb$var$Cg(a, b) ? $3bd4deb882852edb$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $3bd4deb882852edb$var$I = !1, $3bd4deb882852edb$var$xg = a);
            }
        } else {
            if ($3bd4deb882852edb$var$Dg(a)) throw Error($3bd4deb882852edb$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $3bd4deb882852edb$var$I = !1;
            $3bd4deb882852edb$var$xg = a;
        }
    }
}
function $3bd4deb882852edb$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $3bd4deb882852edb$var$xg = a;
}
function $3bd4deb882852edb$var$Gg(a) {
    if (a !== $3bd4deb882852edb$var$xg) return !1;
    if (!$3bd4deb882852edb$var$I) return $3bd4deb882852edb$var$Fg(a), $3bd4deb882852edb$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$3bd4deb882852edb$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $3bd4deb882852edb$var$yg)) {
        if ($3bd4deb882852edb$var$Dg(a)) throw $3bd4deb882852edb$var$Hg(), Error($3bd4deb882852edb$var$p(418));
        for(; b;)$3bd4deb882852edb$var$Ag(a, b), b = $3bd4deb882852edb$var$Lf(b.nextSibling);
    }
    $3bd4deb882852edb$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($3bd4deb882852edb$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $3bd4deb882852edb$var$yg = $3bd4deb882852edb$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $3bd4deb882852edb$var$yg = null;
        }
    } else $3bd4deb882852edb$var$yg = $3bd4deb882852edb$var$xg ? $3bd4deb882852edb$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $3bd4deb882852edb$var$Hg() {
    for(var a = $3bd4deb882852edb$var$yg; a;)a = $3bd4deb882852edb$var$Lf(a.nextSibling);
}
function $3bd4deb882852edb$var$Ig() {
    $3bd4deb882852edb$var$yg = $3bd4deb882852edb$var$xg = null;
    $3bd4deb882852edb$var$I = !1;
}
function $3bd4deb882852edb$var$Jg(a) {
    null === $3bd4deb882852edb$var$zg ? $3bd4deb882852edb$var$zg = [
        a
    ] : $3bd4deb882852edb$var$zg.push(a);
}
var $3bd4deb882852edb$var$Kg = $3bd4deb882852edb$var$ua.ReactCurrentBatchConfig;
function $3bd4deb882852edb$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($3bd4deb882852edb$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($3bd4deb882852edb$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($3bd4deb882852edb$var$p(284));
        if (!c._owner) throw Error($3bd4deb882852edb$var$p(290, a));
    }
    return a;
}
function $3bd4deb882852edb$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($3bd4deb882852edb$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $3bd4deb882852edb$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $3bd4deb882852edb$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $3bd4deb882852edb$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $3bd4deb882852edb$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $3bd4deb882852edb$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $3bd4deb882852edb$var$Ha && $3bd4deb882852edb$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $3bd4deb882852edb$var$Lg(a, b, c), d.return = a, d;
        d = $3bd4deb882852edb$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $3bd4deb882852edb$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $3bd4deb882852edb$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $3bd4deb882852edb$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $3bd4deb882852edb$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $3bd4deb882852edb$var$va:
                    return c = $3bd4deb882852edb$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $3bd4deb882852edb$var$Lg(a, null, b), c.return = a, c;
                case $3bd4deb882852edb$var$wa:
                    return b = $3bd4deb882852edb$var$Sg(b, a.mode, c), b.return = a, b;
                case $3bd4deb882852edb$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($3bd4deb882852edb$var$eb(b) || $3bd4deb882852edb$var$Ka(b)) return b = $3bd4deb882852edb$var$Tg(b, a.mode, c, null), b.return = a, b;
            $3bd4deb882852edb$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $3bd4deb882852edb$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $3bd4deb882852edb$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $3bd4deb882852edb$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($3bd4deb882852edb$var$eb(c) || $3bd4deb882852edb$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $3bd4deb882852edb$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $3bd4deb882852edb$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $3bd4deb882852edb$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $3bd4deb882852edb$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($3bd4deb882852edb$var$eb(d) || $3bd4deb882852edb$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $3bd4deb882852edb$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $3bd4deb882852edb$var$I && $3bd4deb882852edb$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $3bd4deb882852edb$var$I && $3bd4deb882852edb$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $3bd4deb882852edb$var$I && $3bd4deb882852edb$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $3bd4deb882852edb$var$Ka(h);
        if ("function" !== typeof l) throw Error($3bd4deb882852edb$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($3bd4deb882852edb$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $3bd4deb882852edb$var$I && $3bd4deb882852edb$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $3bd4deb882852edb$var$I && $3bd4deb882852edb$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $3bd4deb882852edb$var$I && $3bd4deb882852edb$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $3bd4deb882852edb$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $3bd4deb882852edb$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $3bd4deb882852edb$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $3bd4deb882852edb$var$Ha && $3bd4deb882852edb$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $3bd4deb882852edb$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $3bd4deb882852edb$var$ya ? (d = $3bd4deb882852edb$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $3bd4deb882852edb$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $3bd4deb882852edb$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $3bd4deb882852edb$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $3bd4deb882852edb$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $3bd4deb882852edb$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($3bd4deb882852edb$var$eb(f)) return n(a, d, f, h);
            if ($3bd4deb882852edb$var$Ka(f)) return t(a, d, f, h);
            $3bd4deb882852edb$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $3bd4deb882852edb$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $3bd4deb882852edb$var$Ug = $3bd4deb882852edb$var$Og(!0), $3bd4deb882852edb$var$Vg = $3bd4deb882852edb$var$Og(!1), $3bd4deb882852edb$var$Wg = $3bd4deb882852edb$var$Uf(null), $3bd4deb882852edb$var$Xg = null, $3bd4deb882852edb$var$Yg = null, $3bd4deb882852edb$var$Zg = null;
function $3bd4deb882852edb$var$$g() {
    $3bd4deb882852edb$var$Zg = $3bd4deb882852edb$var$Yg = $3bd4deb882852edb$var$Xg = null;
}
function $3bd4deb882852edb$var$ah(a) {
    var b = $3bd4deb882852edb$var$Wg.current;
    $3bd4deb882852edb$var$E($3bd4deb882852edb$var$Wg);
    a._currentValue = b;
}
function $3bd4deb882852edb$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $3bd4deb882852edb$var$ch(a, b) {
    $3bd4deb882852edb$var$Xg = a;
    $3bd4deb882852edb$var$Zg = $3bd4deb882852edb$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($3bd4deb882852edb$var$dh = !0), a.firstContext = null);
}
function $3bd4deb882852edb$var$eh(a) {
    var b = a._currentValue;
    if ($3bd4deb882852edb$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $3bd4deb882852edb$var$Yg) {
            if (null === $3bd4deb882852edb$var$Xg) throw Error($3bd4deb882852edb$var$p(308));
            $3bd4deb882852edb$var$Yg = a;
            $3bd4deb882852edb$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $3bd4deb882852edb$var$Yg = $3bd4deb882852edb$var$Yg.next = a;
    }
    return b;
}
var $3bd4deb882852edb$var$fh = null;
function $3bd4deb882852edb$var$gh(a) {
    null === $3bd4deb882852edb$var$fh ? $3bd4deb882852edb$var$fh = [
        a
    ] : $3bd4deb882852edb$var$fh.push(a);
}
function $3bd4deb882852edb$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $3bd4deb882852edb$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $3bd4deb882852edb$var$ih(a, d);
}
function $3bd4deb882852edb$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $3bd4deb882852edb$var$jh = !1;
function $3bd4deb882852edb$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $3bd4deb882852edb$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $3bd4deb882852edb$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $3bd4deb882852edb$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($3bd4deb882852edb$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $3bd4deb882852edb$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $3bd4deb882852edb$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $3bd4deb882852edb$var$ih(a, c);
}
function $3bd4deb882852edb$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $3bd4deb882852edb$var$Cc(a, c);
    }
}
function $3bd4deb882852edb$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $3bd4deb882852edb$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $3bd4deb882852edb$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $3bd4deb882852edb$var$A({}, q, r);
                            break a;
                        case 2:
                            $3bd4deb882852edb$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $3bd4deb882852edb$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $3bd4deb882852edb$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($3bd4deb882852edb$var$p(191, e));
            e.call(d);
        }
    }
}
var $3bd4deb882852edb$var$th = {}, $3bd4deb882852edb$var$uh = $3bd4deb882852edb$var$Uf($3bd4deb882852edb$var$th), $3bd4deb882852edb$var$vh = $3bd4deb882852edb$var$Uf($3bd4deb882852edb$var$th), $3bd4deb882852edb$var$wh = $3bd4deb882852edb$var$Uf($3bd4deb882852edb$var$th);
function $3bd4deb882852edb$var$xh(a) {
    if (a === $3bd4deb882852edb$var$th) throw Error($3bd4deb882852edb$var$p(174));
    return a;
}
function $3bd4deb882852edb$var$yh(a, b) {
    $3bd4deb882852edb$var$G($3bd4deb882852edb$var$wh, b);
    $3bd4deb882852edb$var$G($3bd4deb882852edb$var$vh, a);
    $3bd4deb882852edb$var$G($3bd4deb882852edb$var$uh, $3bd4deb882852edb$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $3bd4deb882852edb$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $3bd4deb882852edb$var$lb(b, a);
    }
    $3bd4deb882852edb$var$E($3bd4deb882852edb$var$uh);
    $3bd4deb882852edb$var$G($3bd4deb882852edb$var$uh, b);
}
function $3bd4deb882852edb$var$zh() {
    $3bd4deb882852edb$var$E($3bd4deb882852edb$var$uh);
    $3bd4deb882852edb$var$E($3bd4deb882852edb$var$vh);
    $3bd4deb882852edb$var$E($3bd4deb882852edb$var$wh);
}
function $3bd4deb882852edb$var$Ah(a) {
    $3bd4deb882852edb$var$xh($3bd4deb882852edb$var$wh.current);
    var b = $3bd4deb882852edb$var$xh($3bd4deb882852edb$var$uh.current);
    var c = $3bd4deb882852edb$var$lb(b, a.type);
    b !== c && ($3bd4deb882852edb$var$G($3bd4deb882852edb$var$vh, a), $3bd4deb882852edb$var$G($3bd4deb882852edb$var$uh, c));
}
function $3bd4deb882852edb$var$Bh(a) {
    $3bd4deb882852edb$var$vh.current === a && ($3bd4deb882852edb$var$E($3bd4deb882852edb$var$uh), $3bd4deb882852edb$var$E($3bd4deb882852edb$var$vh));
}
var $3bd4deb882852edb$var$L = $3bd4deb882852edb$var$Uf(0);
function $3bd4deb882852edb$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $3bd4deb882852edb$var$Dh = [];
function $3bd4deb882852edb$var$Eh() {
    for(var a = 0; a < $3bd4deb882852edb$var$Dh.length; a++)$3bd4deb882852edb$var$Dh[a]._workInProgressVersionPrimary = null;
    $3bd4deb882852edb$var$Dh.length = 0;
}
var $3bd4deb882852edb$var$Fh = $3bd4deb882852edb$var$ua.ReactCurrentDispatcher, $3bd4deb882852edb$var$Gh = $3bd4deb882852edb$var$ua.ReactCurrentBatchConfig, $3bd4deb882852edb$var$Hh = 0, $3bd4deb882852edb$var$M = null, $3bd4deb882852edb$var$N = null, $3bd4deb882852edb$var$O = null, $3bd4deb882852edb$var$Ih = !1, $3bd4deb882852edb$var$Jh = !1, $3bd4deb882852edb$var$Kh = 0, $3bd4deb882852edb$var$Lh = 0;
function $3bd4deb882852edb$var$P() {
    throw Error($3bd4deb882852edb$var$p(321));
}
function $3bd4deb882852edb$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$3bd4deb882852edb$var$He(a[c], b[c])) return !1;
    return !0;
}
function $3bd4deb882852edb$var$Nh(a, b, c, d, e, f) {
    $3bd4deb882852edb$var$Hh = f;
    $3bd4deb882852edb$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $3bd4deb882852edb$var$Fh.current = null === a || null === a.memoizedState ? $3bd4deb882852edb$var$Oh : $3bd4deb882852edb$var$Ph;
    a = c(d, e);
    if ($3bd4deb882852edb$var$Jh) {
        f = 0;
        do {
            $3bd4deb882852edb$var$Jh = !1;
            $3bd4deb882852edb$var$Kh = 0;
            if (25 <= f) throw Error($3bd4deb882852edb$var$p(301));
            f += 1;
            $3bd4deb882852edb$var$O = $3bd4deb882852edb$var$N = null;
            b.updateQueue = null;
            $3bd4deb882852edb$var$Fh.current = $3bd4deb882852edb$var$Qh;
            a = c(d, e);
        }while ($3bd4deb882852edb$var$Jh);
    }
    $3bd4deb882852edb$var$Fh.current = $3bd4deb882852edb$var$Rh;
    b = null !== $3bd4deb882852edb$var$N && null !== $3bd4deb882852edb$var$N.next;
    $3bd4deb882852edb$var$Hh = 0;
    $3bd4deb882852edb$var$O = $3bd4deb882852edb$var$N = $3bd4deb882852edb$var$M = null;
    $3bd4deb882852edb$var$Ih = !1;
    if (b) throw Error($3bd4deb882852edb$var$p(300));
    return a;
}
function $3bd4deb882852edb$var$Sh() {
    var a = 0 !== $3bd4deb882852edb$var$Kh;
    $3bd4deb882852edb$var$Kh = 0;
    return a;
}
function $3bd4deb882852edb$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $3bd4deb882852edb$var$O ? $3bd4deb882852edb$var$M.memoizedState = $3bd4deb882852edb$var$O = a : $3bd4deb882852edb$var$O = $3bd4deb882852edb$var$O.next = a;
    return $3bd4deb882852edb$var$O;
}
function $3bd4deb882852edb$var$Uh() {
    if (null === $3bd4deb882852edb$var$N) {
        var a = $3bd4deb882852edb$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $3bd4deb882852edb$var$N.next;
    var b = null === $3bd4deb882852edb$var$O ? $3bd4deb882852edb$var$M.memoizedState : $3bd4deb882852edb$var$O.next;
    if (null !== b) $3bd4deb882852edb$var$O = b, $3bd4deb882852edb$var$N = a;
    else {
        if (null === a) throw Error($3bd4deb882852edb$var$p(310));
        $3bd4deb882852edb$var$N = a;
        a = {
            memoizedState: $3bd4deb882852edb$var$N.memoizedState,
            baseState: $3bd4deb882852edb$var$N.baseState,
            baseQueue: $3bd4deb882852edb$var$N.baseQueue,
            queue: $3bd4deb882852edb$var$N.queue,
            next: null
        };
        null === $3bd4deb882852edb$var$O ? $3bd4deb882852edb$var$M.memoizedState = $3bd4deb882852edb$var$O = a : $3bd4deb882852edb$var$O = $3bd4deb882852edb$var$O.next = a;
    }
    return $3bd4deb882852edb$var$O;
}
function $3bd4deb882852edb$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $3bd4deb882852edb$var$Wh(a) {
    var b = $3bd4deb882852edb$var$Uh(), c = b.queue;
    if (null === c) throw Error($3bd4deb882852edb$var$p(311));
    c.lastRenderedReducer = a;
    var d = $3bd4deb882852edb$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($3bd4deb882852edb$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $3bd4deb882852edb$var$M.lanes |= m;
                $3bd4deb882852edb$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $3bd4deb882852edb$var$He(d, b.memoizedState) || ($3bd4deb882852edb$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $3bd4deb882852edb$var$M.lanes |= f, $3bd4deb882852edb$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $3bd4deb882852edb$var$Xh(a) {
    var b = $3bd4deb882852edb$var$Uh(), c = b.queue;
    if (null === c) throw Error($3bd4deb882852edb$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $3bd4deb882852edb$var$He(f, b.memoizedState) || ($3bd4deb882852edb$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $3bd4deb882852edb$var$Yh() {}
function $3bd4deb882852edb$var$Zh(a, b) {
    var c = $3bd4deb882852edb$var$M, d = $3bd4deb882852edb$var$Uh(), e = b(), f = !$3bd4deb882852edb$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $3bd4deb882852edb$var$dh = !0);
    d = d.queue;
    $3bd4deb882852edb$var$$h($3bd4deb882852edb$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $3bd4deb882852edb$var$O && $3bd4deb882852edb$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $3bd4deb882852edb$var$bi(9, $3bd4deb882852edb$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $3bd4deb882852edb$var$Q) throw Error($3bd4deb882852edb$var$p(349));
        0 !== ($3bd4deb882852edb$var$Hh & 30) || $3bd4deb882852edb$var$di(c, b, e);
    }
    return e;
}
function $3bd4deb882852edb$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $3bd4deb882852edb$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $3bd4deb882852edb$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $3bd4deb882852edb$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $3bd4deb882852edb$var$ei(b) && $3bd4deb882852edb$var$fi(a);
}
function $3bd4deb882852edb$var$ai(a, b, c) {
    return c(function() {
        $3bd4deb882852edb$var$ei(b) && $3bd4deb882852edb$var$fi(a);
    });
}
function $3bd4deb882852edb$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$3bd4deb882852edb$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $3bd4deb882852edb$var$fi(a) {
    var b = $3bd4deb882852edb$var$ih(a, 1);
    null !== b && $3bd4deb882852edb$var$gi(b, a, 1, -1);
}
function $3bd4deb882852edb$var$hi(a) {
    var b = $3bd4deb882852edb$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $3bd4deb882852edb$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $3bd4deb882852edb$var$ii.bind(null, $3bd4deb882852edb$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $3bd4deb882852edb$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $3bd4deb882852edb$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $3bd4deb882852edb$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $3bd4deb882852edb$var$ji() {
    return $3bd4deb882852edb$var$Uh().memoizedState;
}
function $3bd4deb882852edb$var$ki(a, b, c, d) {
    var e = $3bd4deb882852edb$var$Th();
    $3bd4deb882852edb$var$M.flags |= a;
    e.memoizedState = $3bd4deb882852edb$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $3bd4deb882852edb$var$li(a, b, c, d) {
    var e = $3bd4deb882852edb$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $3bd4deb882852edb$var$N) {
        var g = $3bd4deb882852edb$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $3bd4deb882852edb$var$Mh(d, g.deps)) {
            e.memoizedState = $3bd4deb882852edb$var$bi(b, c, f, d);
            return;
        }
    }
    $3bd4deb882852edb$var$M.flags |= a;
    e.memoizedState = $3bd4deb882852edb$var$bi(1 | b, c, f, d);
}
function $3bd4deb882852edb$var$mi(a, b) {
    return $3bd4deb882852edb$var$ki(8390656, 8, a, b);
}
function $3bd4deb882852edb$var$$h(a, b) {
    return $3bd4deb882852edb$var$li(2048, 8, a, b);
}
function $3bd4deb882852edb$var$ni(a, b) {
    return $3bd4deb882852edb$var$li(4, 2, a, b);
}
function $3bd4deb882852edb$var$oi(a, b) {
    return $3bd4deb882852edb$var$li(4, 4, a, b);
}
function $3bd4deb882852edb$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $3bd4deb882852edb$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $3bd4deb882852edb$var$li(4, 4, $3bd4deb882852edb$var$pi.bind(null, b, a), c);
}
function $3bd4deb882852edb$var$ri() {}
function $3bd4deb882852edb$var$si(a, b) {
    var c = $3bd4deb882852edb$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $3bd4deb882852edb$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $3bd4deb882852edb$var$ti(a, b) {
    var c = $3bd4deb882852edb$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $3bd4deb882852edb$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $3bd4deb882852edb$var$ui(a, b, c) {
    if (0 === ($3bd4deb882852edb$var$Hh & 21)) return a.baseState && (a.baseState = !1, $3bd4deb882852edb$var$dh = !0), a.memoizedState = c;
    $3bd4deb882852edb$var$He(c, b) || (c = $3bd4deb882852edb$var$yc(), $3bd4deb882852edb$var$M.lanes |= c, $3bd4deb882852edb$var$rh |= c, a.baseState = !0);
    return b;
}
function $3bd4deb882852edb$var$vi(a, b) {
    var c = $3bd4deb882852edb$var$C;
    $3bd4deb882852edb$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $3bd4deb882852edb$var$Gh.transition;
    $3bd4deb882852edb$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $3bd4deb882852edb$var$C = c, $3bd4deb882852edb$var$Gh.transition = d;
    }
}
function $3bd4deb882852edb$var$wi() {
    return $3bd4deb882852edb$var$Uh().memoizedState;
}
function $3bd4deb882852edb$var$xi(a, b, c) {
    var d = $3bd4deb882852edb$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($3bd4deb882852edb$var$zi(a)) $3bd4deb882852edb$var$Ai(b, c);
    else if (c = $3bd4deb882852edb$var$hh(a, b, c, d), null !== c) {
        var e = $3bd4deb882852edb$var$R();
        $3bd4deb882852edb$var$gi(c, a, d, e);
        $3bd4deb882852edb$var$Bi(c, b, d);
    }
}
function $3bd4deb882852edb$var$ii(a, b, c) {
    var d = $3bd4deb882852edb$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($3bd4deb882852edb$var$zi(a)) $3bd4deb882852edb$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($3bd4deb882852edb$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $3bd4deb882852edb$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $3bd4deb882852edb$var$hh(a, b, e, d);
        null !== c && (e = $3bd4deb882852edb$var$R(), $3bd4deb882852edb$var$gi(c, a, d, e), $3bd4deb882852edb$var$Bi(c, b, d));
    }
}
function $3bd4deb882852edb$var$zi(a) {
    var b = a.alternate;
    return a === $3bd4deb882852edb$var$M || null !== b && b === $3bd4deb882852edb$var$M;
}
function $3bd4deb882852edb$var$Ai(a, b) {
    $3bd4deb882852edb$var$Jh = $3bd4deb882852edb$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $3bd4deb882852edb$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $3bd4deb882852edb$var$Cc(a, c);
    }
}
var $3bd4deb882852edb$var$Rh = {
    readContext: $3bd4deb882852edb$var$eh,
    useCallback: $3bd4deb882852edb$var$P,
    useContext: $3bd4deb882852edb$var$P,
    useEffect: $3bd4deb882852edb$var$P,
    useImperativeHandle: $3bd4deb882852edb$var$P,
    useInsertionEffect: $3bd4deb882852edb$var$P,
    useLayoutEffect: $3bd4deb882852edb$var$P,
    useMemo: $3bd4deb882852edb$var$P,
    useReducer: $3bd4deb882852edb$var$P,
    useRef: $3bd4deb882852edb$var$P,
    useState: $3bd4deb882852edb$var$P,
    useDebugValue: $3bd4deb882852edb$var$P,
    useDeferredValue: $3bd4deb882852edb$var$P,
    useTransition: $3bd4deb882852edb$var$P,
    useMutableSource: $3bd4deb882852edb$var$P,
    useSyncExternalStore: $3bd4deb882852edb$var$P,
    useId: $3bd4deb882852edb$var$P,
    unstable_isNewReconciler: !1
}, $3bd4deb882852edb$var$Oh = {
    readContext: $3bd4deb882852edb$var$eh,
    useCallback: function(a, b) {
        $3bd4deb882852edb$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $3bd4deb882852edb$var$eh,
    useEffect: $3bd4deb882852edb$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $3bd4deb882852edb$var$ki(4194308, 4, $3bd4deb882852edb$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $3bd4deb882852edb$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $3bd4deb882852edb$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $3bd4deb882852edb$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $3bd4deb882852edb$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $3bd4deb882852edb$var$xi.bind(null, $3bd4deb882852edb$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $3bd4deb882852edb$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $3bd4deb882852edb$var$hi,
    useDebugValue: $3bd4deb882852edb$var$ri,
    useDeferredValue: function(a) {
        return $3bd4deb882852edb$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $3bd4deb882852edb$var$hi(!1), b = a[0];
        a = $3bd4deb882852edb$var$vi.bind(null, a[1]);
        $3bd4deb882852edb$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $3bd4deb882852edb$var$M, e = $3bd4deb882852edb$var$Th();
        if ($3bd4deb882852edb$var$I) {
            if (void 0 === c) throw Error($3bd4deb882852edb$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $3bd4deb882852edb$var$Q) throw Error($3bd4deb882852edb$var$p(349));
            0 !== ($3bd4deb882852edb$var$Hh & 30) || $3bd4deb882852edb$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $3bd4deb882852edb$var$mi($3bd4deb882852edb$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $3bd4deb882852edb$var$bi(9, $3bd4deb882852edb$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $3bd4deb882852edb$var$Th(), b = $3bd4deb882852edb$var$Q.identifierPrefix;
        if ($3bd4deb882852edb$var$I) {
            var c = $3bd4deb882852edb$var$sg;
            var d = $3bd4deb882852edb$var$rg;
            c = (d & ~(1 << 32 - $3bd4deb882852edb$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $3bd4deb882852edb$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $3bd4deb882852edb$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $3bd4deb882852edb$var$Ph = {
    readContext: $3bd4deb882852edb$var$eh,
    useCallback: $3bd4deb882852edb$var$si,
    useContext: $3bd4deb882852edb$var$eh,
    useEffect: $3bd4deb882852edb$var$$h,
    useImperativeHandle: $3bd4deb882852edb$var$qi,
    useInsertionEffect: $3bd4deb882852edb$var$ni,
    useLayoutEffect: $3bd4deb882852edb$var$oi,
    useMemo: $3bd4deb882852edb$var$ti,
    useReducer: $3bd4deb882852edb$var$Wh,
    useRef: $3bd4deb882852edb$var$ji,
    useState: function() {
        return $3bd4deb882852edb$var$Wh($3bd4deb882852edb$var$Vh);
    },
    useDebugValue: $3bd4deb882852edb$var$ri,
    useDeferredValue: function(a) {
        var b = $3bd4deb882852edb$var$Uh();
        return $3bd4deb882852edb$var$ui(b, $3bd4deb882852edb$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $3bd4deb882852edb$var$Wh($3bd4deb882852edb$var$Vh)[0], b = $3bd4deb882852edb$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $3bd4deb882852edb$var$Yh,
    useSyncExternalStore: $3bd4deb882852edb$var$Zh,
    useId: $3bd4deb882852edb$var$wi,
    unstable_isNewReconciler: !1
}, $3bd4deb882852edb$var$Qh = {
    readContext: $3bd4deb882852edb$var$eh,
    useCallback: $3bd4deb882852edb$var$si,
    useContext: $3bd4deb882852edb$var$eh,
    useEffect: $3bd4deb882852edb$var$$h,
    useImperativeHandle: $3bd4deb882852edb$var$qi,
    useInsertionEffect: $3bd4deb882852edb$var$ni,
    useLayoutEffect: $3bd4deb882852edb$var$oi,
    useMemo: $3bd4deb882852edb$var$ti,
    useReducer: $3bd4deb882852edb$var$Xh,
    useRef: $3bd4deb882852edb$var$ji,
    useState: function() {
        return $3bd4deb882852edb$var$Xh($3bd4deb882852edb$var$Vh);
    },
    useDebugValue: $3bd4deb882852edb$var$ri,
    useDeferredValue: function(a) {
        var b = $3bd4deb882852edb$var$Uh();
        return null === $3bd4deb882852edb$var$N ? b.memoizedState = a : $3bd4deb882852edb$var$ui(b, $3bd4deb882852edb$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $3bd4deb882852edb$var$Xh($3bd4deb882852edb$var$Vh)[0], b = $3bd4deb882852edb$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $3bd4deb882852edb$var$Yh,
    useSyncExternalStore: $3bd4deb882852edb$var$Zh,
    useId: $3bd4deb882852edb$var$wi,
    unstable_isNewReconciler: !1
};
function $3bd4deb882852edb$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $3bd4deb882852edb$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $3bd4deb882852edb$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $3bd4deb882852edb$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $3bd4deb882852edb$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $3bd4deb882852edb$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $3bd4deb882852edb$var$R(), e = $3bd4deb882852edb$var$yi(a), f = $3bd4deb882852edb$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $3bd4deb882852edb$var$nh(a, f, e);
        null !== b && ($3bd4deb882852edb$var$gi(b, a, e, d), $3bd4deb882852edb$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $3bd4deb882852edb$var$R(), e = $3bd4deb882852edb$var$yi(a), f = $3bd4deb882852edb$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $3bd4deb882852edb$var$nh(a, f, e);
        null !== b && ($3bd4deb882852edb$var$gi(b, a, e, d), $3bd4deb882852edb$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $3bd4deb882852edb$var$R(), d = $3bd4deb882852edb$var$yi(a), e = $3bd4deb882852edb$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $3bd4deb882852edb$var$nh(a, e, d);
        null !== b && ($3bd4deb882852edb$var$gi(b, a, d, c), $3bd4deb882852edb$var$oh(b, a, d));
    }
};
function $3bd4deb882852edb$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$3bd4deb882852edb$var$Ie(c, d) || !$3bd4deb882852edb$var$Ie(e, f) : !0;
}
function $3bd4deb882852edb$var$Gi(a, b, c) {
    var d = !1, e = $3bd4deb882852edb$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $3bd4deb882852edb$var$eh(f) : (e = $3bd4deb882852edb$var$Zf(b) ? $3bd4deb882852edb$var$Xf : $3bd4deb882852edb$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $3bd4deb882852edb$var$Yf(a, e) : $3bd4deb882852edb$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $3bd4deb882852edb$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $3bd4deb882852edb$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $3bd4deb882852edb$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $3bd4deb882852edb$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $3bd4deb882852edb$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $3bd4deb882852edb$var$eh(f) : (f = $3bd4deb882852edb$var$Zf(b) ? $3bd4deb882852edb$var$Xf : $3bd4deb882852edb$var$H.current, e.context = $3bd4deb882852edb$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($3bd4deb882852edb$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $3bd4deb882852edb$var$Ei.enqueueReplaceState(e, e.state, null), $3bd4deb882852edb$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $3bd4deb882852edb$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $3bd4deb882852edb$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $3bd4deb882852edb$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $3bd4deb882852edb$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $3bd4deb882852edb$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $3bd4deb882852edb$var$Ni(a, b, c) {
    c = $3bd4deb882852edb$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $3bd4deb882852edb$var$Oi || ($3bd4deb882852edb$var$Oi = !0, $3bd4deb882852edb$var$Pi = d);
        $3bd4deb882852edb$var$Li(a, b);
    };
    return c;
}
function $3bd4deb882852edb$var$Qi(a, b, c) {
    c = $3bd4deb882852edb$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $3bd4deb882852edb$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $3bd4deb882852edb$var$Li(a, b);
        "function" !== typeof d && (null === $3bd4deb882852edb$var$Ri ? $3bd4deb882852edb$var$Ri = new Set([
            this
        ]) : $3bd4deb882852edb$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $3bd4deb882852edb$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $3bd4deb882852edb$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $3bd4deb882852edb$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $3bd4deb882852edb$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $3bd4deb882852edb$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $3bd4deb882852edb$var$mh(-1, 1), b.tag = 2, $3bd4deb882852edb$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $3bd4deb882852edb$var$Wi = $3bd4deb882852edb$var$ua.ReactCurrentOwner, $3bd4deb882852edb$var$dh = !1;
function $3bd4deb882852edb$var$Xi(a, b, c, d) {
    b.child = null === a ? $3bd4deb882852edb$var$Vg(b, null, c, d) : $3bd4deb882852edb$var$Ug(b, a.child, c, d);
}
function $3bd4deb882852edb$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $3bd4deb882852edb$var$ch(b, e);
    d = $3bd4deb882852edb$var$Nh(a, b, c, d, f, e);
    c = $3bd4deb882852edb$var$Sh();
    if (null !== a && !$3bd4deb882852edb$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $3bd4deb882852edb$var$Zi(a, b, e);
    $3bd4deb882852edb$var$I && c && $3bd4deb882852edb$var$vg(b);
    b.flags |= 1;
    $3bd4deb882852edb$var$Xi(a, b, d, e);
    return b.child;
}
function $3bd4deb882852edb$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$3bd4deb882852edb$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $3bd4deb882852edb$var$bj(a, b, f, d, e);
        a = $3bd4deb882852edb$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $3bd4deb882852edb$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $3bd4deb882852edb$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $3bd4deb882852edb$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $3bd4deb882852edb$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($3bd4deb882852edb$var$Ie(f, d) && a.ref === b.ref) {
            if ($3bd4deb882852edb$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($3bd4deb882852edb$var$dh = !0);
            else return b.lanes = a.lanes, $3bd4deb882852edb$var$Zi(a, b, e);
        }
    }
    return $3bd4deb882852edb$var$cj(a, b, c, d, e);
}
function $3bd4deb882852edb$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $3bd4deb882852edb$var$G($3bd4deb882852edb$var$ej, $3bd4deb882852edb$var$fj), $3bd4deb882852edb$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $3bd4deb882852edb$var$G($3bd4deb882852edb$var$ej, $3bd4deb882852edb$var$fj), $3bd4deb882852edb$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $3bd4deb882852edb$var$G($3bd4deb882852edb$var$ej, $3bd4deb882852edb$var$fj);
            $3bd4deb882852edb$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $3bd4deb882852edb$var$G($3bd4deb882852edb$var$ej, $3bd4deb882852edb$var$fj), $3bd4deb882852edb$var$fj |= d;
    $3bd4deb882852edb$var$Xi(a, b, e, c);
    return b.child;
}
function $3bd4deb882852edb$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $3bd4deb882852edb$var$cj(a, b, c, d, e) {
    var f = $3bd4deb882852edb$var$Zf(c) ? $3bd4deb882852edb$var$Xf : $3bd4deb882852edb$var$H.current;
    f = $3bd4deb882852edb$var$Yf(b, f);
    $3bd4deb882852edb$var$ch(b, e);
    c = $3bd4deb882852edb$var$Nh(a, b, c, d, f, e);
    d = $3bd4deb882852edb$var$Sh();
    if (null !== a && !$3bd4deb882852edb$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $3bd4deb882852edb$var$Zi(a, b, e);
    $3bd4deb882852edb$var$I && d && $3bd4deb882852edb$var$vg(b);
    b.flags |= 1;
    $3bd4deb882852edb$var$Xi(a, b, c, e);
    return b.child;
}
function $3bd4deb882852edb$var$hj(a, b, c, d, e) {
    if ($3bd4deb882852edb$var$Zf(c)) {
        var f = !0;
        $3bd4deb882852edb$var$cg(b);
    } else f = !1;
    $3bd4deb882852edb$var$ch(b, e);
    if (null === b.stateNode) $3bd4deb882852edb$var$ij(a, b), $3bd4deb882852edb$var$Gi(b, c, d), $3bd4deb882852edb$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $3bd4deb882852edb$var$eh(l) : (l = $3bd4deb882852edb$var$Zf(c) ? $3bd4deb882852edb$var$Xf : $3bd4deb882852edb$var$H.current, l = $3bd4deb882852edb$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $3bd4deb882852edb$var$Hi(b, g, d, l);
        $3bd4deb882852edb$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $3bd4deb882852edb$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $3bd4deb882852edb$var$Wf.current || $3bd4deb882852edb$var$jh ? ("function" === typeof m && ($3bd4deb882852edb$var$Di(b, c, m, d), k = b.memoizedState), (h = $3bd4deb882852edb$var$jh || $3bd4deb882852edb$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $3bd4deb882852edb$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $3bd4deb882852edb$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $3bd4deb882852edb$var$eh(k) : (k = $3bd4deb882852edb$var$Zf(c) ? $3bd4deb882852edb$var$Xf : $3bd4deb882852edb$var$H.current, k = $3bd4deb882852edb$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $3bd4deb882852edb$var$Hi(b, g, d, k);
        $3bd4deb882852edb$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $3bd4deb882852edb$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $3bd4deb882852edb$var$Wf.current || $3bd4deb882852edb$var$jh ? ("function" === typeof y && ($3bd4deb882852edb$var$Di(b, c, y, d), n = b.memoizedState), (l = $3bd4deb882852edb$var$jh || $3bd4deb882852edb$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $3bd4deb882852edb$var$jj(a, b, c, d, f, e);
}
function $3bd4deb882852edb$var$jj(a, b, c, d, e, f) {
    $3bd4deb882852edb$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $3bd4deb882852edb$var$dg(b, c, !1), $3bd4deb882852edb$var$Zi(a, b, f);
    d = b.stateNode;
    $3bd4deb882852edb$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $3bd4deb882852edb$var$Ug(b, a.child, null, f), b.child = $3bd4deb882852edb$var$Ug(b, null, h, f)) : $3bd4deb882852edb$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $3bd4deb882852edb$var$dg(b, c, !0);
    return b.child;
}
function $3bd4deb882852edb$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $3bd4deb882852edb$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $3bd4deb882852edb$var$ag(a, b.context, !1);
    $3bd4deb882852edb$var$yh(a, b.containerInfo);
}
function $3bd4deb882852edb$var$lj(a, b, c, d, e) {
    $3bd4deb882852edb$var$Ig();
    $3bd4deb882852edb$var$Jg(e);
    b.flags |= 256;
    $3bd4deb882852edb$var$Xi(a, b, c, d);
    return b.child;
}
var $3bd4deb882852edb$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $3bd4deb882852edb$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $3bd4deb882852edb$var$oj(a, b, c) {
    var d = b.pendingProps, e = $3bd4deb882852edb$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $3bd4deb882852edb$var$G($3bd4deb882852edb$var$L, e & 1);
    if (null === a) {
        $3bd4deb882852edb$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $3bd4deb882852edb$var$pj(g, d, 0, null), a = $3bd4deb882852edb$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $3bd4deb882852edb$var$nj(c), b.memoizedState = $3bd4deb882852edb$var$mj, a) : $3bd4deb882852edb$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $3bd4deb882852edb$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $3bd4deb882852edb$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $3bd4deb882852edb$var$Pg(h, f) : (f = $3bd4deb882852edb$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $3bd4deb882852edb$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $3bd4deb882852edb$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $3bd4deb882852edb$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $3bd4deb882852edb$var$qj(a, b) {
    b = $3bd4deb882852edb$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $3bd4deb882852edb$var$sj(a, b, c, d) {
    null !== d && $3bd4deb882852edb$var$Jg(d);
    $3bd4deb882852edb$var$Ug(b, a.child, null, c);
    a = $3bd4deb882852edb$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $3bd4deb882852edb$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $3bd4deb882852edb$var$Ki(Error($3bd4deb882852edb$var$p(422))), $3bd4deb882852edb$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $3bd4deb882852edb$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $3bd4deb882852edb$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $3bd4deb882852edb$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $3bd4deb882852edb$var$nj(g);
        b.memoizedState = $3bd4deb882852edb$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $3bd4deb882852edb$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($3bd4deb882852edb$var$p(419));
        d = $3bd4deb882852edb$var$Ki(f, d, void 0);
        return $3bd4deb882852edb$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($3bd4deb882852edb$var$dh || h) {
        d = $3bd4deb882852edb$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $3bd4deb882852edb$var$ih(a, e), $3bd4deb882852edb$var$gi(d, a, e, -1));
        }
        $3bd4deb882852edb$var$tj();
        d = $3bd4deb882852edb$var$Ki(Error($3bd4deb882852edb$var$p(421)));
        return $3bd4deb882852edb$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $3bd4deb882852edb$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $3bd4deb882852edb$var$yg = $3bd4deb882852edb$var$Lf(e.nextSibling);
    $3bd4deb882852edb$var$xg = b;
    $3bd4deb882852edb$var$I = !0;
    $3bd4deb882852edb$var$zg = null;
    null !== a && ($3bd4deb882852edb$var$og[$3bd4deb882852edb$var$pg++] = $3bd4deb882852edb$var$rg, $3bd4deb882852edb$var$og[$3bd4deb882852edb$var$pg++] = $3bd4deb882852edb$var$sg, $3bd4deb882852edb$var$og[$3bd4deb882852edb$var$pg++] = $3bd4deb882852edb$var$qg, $3bd4deb882852edb$var$rg = a.id, $3bd4deb882852edb$var$sg = a.overflow, $3bd4deb882852edb$var$qg = b);
    b = $3bd4deb882852edb$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $3bd4deb882852edb$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $3bd4deb882852edb$var$bh(a.return, b, c);
}
function $3bd4deb882852edb$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $3bd4deb882852edb$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $3bd4deb882852edb$var$Xi(a, b, d.children, c);
    d = $3bd4deb882852edb$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $3bd4deb882852edb$var$vj(a, c, b);
            else if (19 === a.tag) $3bd4deb882852edb$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $3bd4deb882852edb$var$G($3bd4deb882852edb$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $3bd4deb882852edb$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $3bd4deb882852edb$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $3bd4deb882852edb$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $3bd4deb882852edb$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $3bd4deb882852edb$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $3bd4deb882852edb$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $3bd4deb882852edb$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $3bd4deb882852edb$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($3bd4deb882852edb$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $3bd4deb882852edb$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $3bd4deb882852edb$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $3bd4deb882852edb$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $3bd4deb882852edb$var$kj(b);
            $3bd4deb882852edb$var$Ig();
            break;
        case 5:
            $3bd4deb882852edb$var$Ah(b);
            break;
        case 1:
            $3bd4deb882852edb$var$Zf(b.type) && $3bd4deb882852edb$var$cg(b);
            break;
        case 4:
            $3bd4deb882852edb$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $3bd4deb882852edb$var$G($3bd4deb882852edb$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $3bd4deb882852edb$var$G($3bd4deb882852edb$var$L, $3bd4deb882852edb$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $3bd4deb882852edb$var$oj(a, b, c);
                $3bd4deb882852edb$var$G($3bd4deb882852edb$var$L, $3bd4deb882852edb$var$L.current & 1);
                a = $3bd4deb882852edb$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $3bd4deb882852edb$var$G($3bd4deb882852edb$var$L, $3bd4deb882852edb$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $3bd4deb882852edb$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $3bd4deb882852edb$var$G($3bd4deb882852edb$var$L, $3bd4deb882852edb$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $3bd4deb882852edb$var$dj(a, b, c);
    }
    return $3bd4deb882852edb$var$Zi(a, b, c);
}
var $3bd4deb882852edb$var$zj, $3bd4deb882852edb$var$Aj, $3bd4deb882852edb$var$Bj, $3bd4deb882852edb$var$Cj;
$3bd4deb882852edb$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$3bd4deb882852edb$var$Aj = function() {};
$3bd4deb882852edb$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $3bd4deb882852edb$var$xh($3bd4deb882852edb$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $3bd4deb882852edb$var$Ya(a, e);
                d = $3bd4deb882852edb$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $3bd4deb882852edb$var$A({}, e, {
                    value: void 0
                });
                d = $3bd4deb882852edb$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $3bd4deb882852edb$var$gb(a, e);
                d = $3bd4deb882852edb$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $3bd4deb882852edb$var$Bf);
        }
        $3bd4deb882852edb$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($3bd4deb882852edb$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($3bd4deb882852edb$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $3bd4deb882852edb$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$3bd4deb882852edb$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $3bd4deb882852edb$var$Dj(a, b) {
    if (!$3bd4deb882852edb$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $3bd4deb882852edb$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $3bd4deb882852edb$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $3bd4deb882852edb$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $3bd4deb882852edb$var$S(b), null;
        case 1:
            return $3bd4deb882852edb$var$Zf(b.type) && $3bd4deb882852edb$var$$f(), $3bd4deb882852edb$var$S(b), null;
        case 3:
            d = b.stateNode;
            $3bd4deb882852edb$var$zh();
            $3bd4deb882852edb$var$E($3bd4deb882852edb$var$Wf);
            $3bd4deb882852edb$var$E($3bd4deb882852edb$var$H);
            $3bd4deb882852edb$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $3bd4deb882852edb$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $3bd4deb882852edb$var$zg && ($3bd4deb882852edb$var$Fj($3bd4deb882852edb$var$zg), $3bd4deb882852edb$var$zg = null));
            $3bd4deb882852edb$var$Aj(a, b);
            $3bd4deb882852edb$var$S(b);
            return null;
        case 5:
            $3bd4deb882852edb$var$Bh(b);
            var e = $3bd4deb882852edb$var$xh($3bd4deb882852edb$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $3bd4deb882852edb$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($3bd4deb882852edb$var$p(166));
                    $3bd4deb882852edb$var$S(b);
                    return null;
                }
                a = $3bd4deb882852edb$var$xh($3bd4deb882852edb$var$uh.current);
                if ($3bd4deb882852edb$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$3bd4deb882852edb$var$Of] = b;
                    d[$3bd4deb882852edb$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $3bd4deb882852edb$var$D("cancel", d);
                            $3bd4deb882852edb$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $3bd4deb882852edb$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $3bd4deb882852edb$var$lf.length; e++)$3bd4deb882852edb$var$D($3bd4deb882852edb$var$lf[e], d);
                            break;
                        case "source":
                            $3bd4deb882852edb$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $3bd4deb882852edb$var$D("error", d);
                            $3bd4deb882852edb$var$D("load", d);
                            break;
                        case "details":
                            $3bd4deb882852edb$var$D("toggle", d);
                            break;
                        case "input":
                            $3bd4deb882852edb$var$Za(d, f);
                            $3bd4deb882852edb$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $3bd4deb882852edb$var$D("invalid", d);
                            break;
                        case "textarea":
                            $3bd4deb882852edb$var$hb(d, f), $3bd4deb882852edb$var$D("invalid", d);
                    }
                    $3bd4deb882852edb$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $3bd4deb882852edb$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $3bd4deb882852edb$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $3bd4deb882852edb$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $3bd4deb882852edb$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $3bd4deb882852edb$var$Va(d);
                            $3bd4deb882852edb$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $3bd4deb882852edb$var$Va(d);
                            $3bd4deb882852edb$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $3bd4deb882852edb$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $3bd4deb882852edb$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$3bd4deb882852edb$var$Of] = b;
                    a[$3bd4deb882852edb$var$Pf] = d;
                    $3bd4deb882852edb$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $3bd4deb882852edb$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $3bd4deb882852edb$var$D("cancel", a);
                                $3bd4deb882852edb$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $3bd4deb882852edb$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $3bd4deb882852edb$var$lf.length; e++)$3bd4deb882852edb$var$D($3bd4deb882852edb$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $3bd4deb882852edb$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $3bd4deb882852edb$var$D("error", a);
                                $3bd4deb882852edb$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $3bd4deb882852edb$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $3bd4deb882852edb$var$Za(a, d);
                                e = $3bd4deb882852edb$var$Ya(a, d);
                                $3bd4deb882852edb$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $3bd4deb882852edb$var$A({}, d, {
                                    value: void 0
                                });
                                $3bd4deb882852edb$var$D("invalid", a);
                                break;
                            case "textarea":
                                $3bd4deb882852edb$var$hb(a, d);
                                e = $3bd4deb882852edb$var$gb(a, d);
                                $3bd4deb882852edb$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $3bd4deb882852edb$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $3bd4deb882852edb$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $3bd4deb882852edb$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $3bd4deb882852edb$var$ob(a, k) : "number" === typeof k && $3bd4deb882852edb$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($3bd4deb882852edb$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $3bd4deb882852edb$var$D("scroll", a) : null != k && $3bd4deb882852edb$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $3bd4deb882852edb$var$Va(a);
                                $3bd4deb882852edb$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $3bd4deb882852edb$var$Va(a);
                                $3bd4deb882852edb$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $3bd4deb882852edb$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $3bd4deb882852edb$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $3bd4deb882852edb$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $3bd4deb882852edb$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $3bd4deb882852edb$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $3bd4deb882852edb$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($3bd4deb882852edb$var$p(166));
                c = $3bd4deb882852edb$var$xh($3bd4deb882852edb$var$wh.current);
                $3bd4deb882852edb$var$xh($3bd4deb882852edb$var$uh.current);
                if ($3bd4deb882852edb$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$3bd4deb882852edb$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $3bd4deb882852edb$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $3bd4deb882852edb$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $3bd4deb882852edb$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$3bd4deb882852edb$var$Of] = b, b.stateNode = d;
            }
            $3bd4deb882852edb$var$S(b);
            return null;
        case 13:
            $3bd4deb882852edb$var$E($3bd4deb882852edb$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($3bd4deb882852edb$var$I && null !== $3bd4deb882852edb$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $3bd4deb882852edb$var$Hg(), $3bd4deb882852edb$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $3bd4deb882852edb$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($3bd4deb882852edb$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($3bd4deb882852edb$var$p(317));
                        f[$3bd4deb882852edb$var$Of] = b;
                    } else $3bd4deb882852edb$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $3bd4deb882852edb$var$S(b);
                    f = !1;
                } else null !== $3bd4deb882852edb$var$zg && ($3bd4deb882852edb$var$Fj($3bd4deb882852edb$var$zg), $3bd4deb882852edb$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($3bd4deb882852edb$var$L.current & 1) ? 0 === $3bd4deb882852edb$var$T && ($3bd4deb882852edb$var$T = 3) : $3bd4deb882852edb$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $3bd4deb882852edb$var$S(b);
            return null;
        case 4:
            return $3bd4deb882852edb$var$zh(), $3bd4deb882852edb$var$Aj(a, b), null === a && $3bd4deb882852edb$var$sf(b.stateNode.containerInfo), $3bd4deb882852edb$var$S(b), null;
        case 10:
            return $3bd4deb882852edb$var$ah(b.type._context), $3bd4deb882852edb$var$S(b), null;
        case 17:
            return $3bd4deb882852edb$var$Zf(b.type) && $3bd4deb882852edb$var$$f(), $3bd4deb882852edb$var$S(b), null;
        case 19:
            $3bd4deb882852edb$var$E($3bd4deb882852edb$var$L);
            f = b.memoizedState;
            if (null === f) return $3bd4deb882852edb$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $3bd4deb882852edb$var$Dj(f, !1);
                else {
                    if (0 !== $3bd4deb882852edb$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $3bd4deb882852edb$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $3bd4deb882852edb$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $3bd4deb882852edb$var$G($3bd4deb882852edb$var$L, $3bd4deb882852edb$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $3bd4deb882852edb$var$B() > $3bd4deb882852edb$var$Gj && (b.flags |= 128, d = !0, $3bd4deb882852edb$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $3bd4deb882852edb$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $3bd4deb882852edb$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$3bd4deb882852edb$var$I) return $3bd4deb882852edb$var$S(b), null;
                    } else 2 * $3bd4deb882852edb$var$B() - f.renderingStartTime > $3bd4deb882852edb$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $3bd4deb882852edb$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $3bd4deb882852edb$var$B(), b.sibling = null, c = $3bd4deb882852edb$var$L.current, $3bd4deb882852edb$var$G($3bd4deb882852edb$var$L, d ? c & 1 | 2 : c & 1), b;
            $3bd4deb882852edb$var$S(b);
            return null;
        case 22:
        case 23:
            return $3bd4deb882852edb$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($3bd4deb882852edb$var$fj & 1073741824) && ($3bd4deb882852edb$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $3bd4deb882852edb$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($3bd4deb882852edb$var$p(156, b.tag));
}
function $3bd4deb882852edb$var$Ij(a, b) {
    $3bd4deb882852edb$var$wg(b);
    switch(b.tag){
        case 1:
            return $3bd4deb882852edb$var$Zf(b.type) && $3bd4deb882852edb$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $3bd4deb882852edb$var$zh(), $3bd4deb882852edb$var$E($3bd4deb882852edb$var$Wf), $3bd4deb882852edb$var$E($3bd4deb882852edb$var$H), $3bd4deb882852edb$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $3bd4deb882852edb$var$Bh(b), null;
        case 13:
            $3bd4deb882852edb$var$E($3bd4deb882852edb$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($3bd4deb882852edb$var$p(340));
                $3bd4deb882852edb$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $3bd4deb882852edb$var$E($3bd4deb882852edb$var$L), null;
        case 4:
            return $3bd4deb882852edb$var$zh(), null;
        case 10:
            return $3bd4deb882852edb$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $3bd4deb882852edb$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $3bd4deb882852edb$var$Jj = !1, $3bd4deb882852edb$var$U = !1, $3bd4deb882852edb$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $3bd4deb882852edb$var$V = null;
function $3bd4deb882852edb$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $3bd4deb882852edb$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $3bd4deb882852edb$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $3bd4deb882852edb$var$W(a, b, d);
    }
}
var $3bd4deb882852edb$var$Nj = !1;
function $3bd4deb882852edb$var$Oj(a, b) {
    $3bd4deb882852edb$var$Cf = $3bd4deb882852edb$var$dd;
    a = $3bd4deb882852edb$var$Me();
    if ($3bd4deb882852edb$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $3bd4deb882852edb$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $3bd4deb882852edb$var$dd = !1;
    for($3bd4deb882852edb$var$V = b; null !== $3bd4deb882852edb$var$V;)if (b = $3bd4deb882852edb$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $3bd4deb882852edb$var$V = a;
    else for(; null !== $3bd4deb882852edb$var$V;){
        b = $3bd4deb882852edb$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $3bd4deb882852edb$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($3bd4deb882852edb$var$p(163));
            }
        } catch (F) {
            $3bd4deb882852edb$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $3bd4deb882852edb$var$V = a;
            break;
        }
        $3bd4deb882852edb$var$V = b.return;
    }
    n = $3bd4deb882852edb$var$Nj;
    $3bd4deb882852edb$var$Nj = !1;
    return n;
}
function $3bd4deb882852edb$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $3bd4deb882852edb$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $3bd4deb882852edb$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $3bd4deb882852edb$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $3bd4deb882852edb$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $3bd4deb882852edb$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$3bd4deb882852edb$var$Of], delete b[$3bd4deb882852edb$var$Pf], delete b[$3bd4deb882852edb$var$of], delete b[$3bd4deb882852edb$var$Qf], delete b[$3bd4deb882852edb$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $3bd4deb882852edb$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $3bd4deb882852edb$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $3bd4deb882852edb$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $3bd4deb882852edb$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $3bd4deb882852edb$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($3bd4deb882852edb$var$Vj(a, b, c), a = a.sibling; null !== a;)$3bd4deb882852edb$var$Vj(a, b, c), a = a.sibling;
}
function $3bd4deb882852edb$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($3bd4deb882852edb$var$Wj(a, b, c), a = a.sibling; null !== a;)$3bd4deb882852edb$var$Wj(a, b, c), a = a.sibling;
}
var $3bd4deb882852edb$var$X = null, $3bd4deb882852edb$var$Xj = !1;
function $3bd4deb882852edb$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$3bd4deb882852edb$var$Zj(a, b, c), c = c.sibling;
}
function $3bd4deb882852edb$var$Zj(a, b, c) {
    if ($3bd4deb882852edb$var$lc && "function" === typeof $3bd4deb882852edb$var$lc.onCommitFiberUnmount) try {
        $3bd4deb882852edb$var$lc.onCommitFiberUnmount($3bd4deb882852edb$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $3bd4deb882852edb$var$U || $3bd4deb882852edb$var$Lj(c, b);
        case 6:
            var d = $3bd4deb882852edb$var$X, e = $3bd4deb882852edb$var$Xj;
            $3bd4deb882852edb$var$X = null;
            $3bd4deb882852edb$var$Yj(a, b, c);
            $3bd4deb882852edb$var$X = d;
            $3bd4deb882852edb$var$Xj = e;
            null !== $3bd4deb882852edb$var$X && ($3bd4deb882852edb$var$Xj ? (a = $3bd4deb882852edb$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $3bd4deb882852edb$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $3bd4deb882852edb$var$X && ($3bd4deb882852edb$var$Xj ? (a = $3bd4deb882852edb$var$X, c = c.stateNode, 8 === a.nodeType ? $3bd4deb882852edb$var$Kf(a.parentNode, c) : 1 === a.nodeType && $3bd4deb882852edb$var$Kf(a, c), $3bd4deb882852edb$var$bd(a)) : $3bd4deb882852edb$var$Kf($3bd4deb882852edb$var$X, c.stateNode));
            break;
        case 4:
            d = $3bd4deb882852edb$var$X;
            e = $3bd4deb882852edb$var$Xj;
            $3bd4deb882852edb$var$X = c.stateNode.containerInfo;
            $3bd4deb882852edb$var$Xj = !0;
            $3bd4deb882852edb$var$Yj(a, b, c);
            $3bd4deb882852edb$var$X = d;
            $3bd4deb882852edb$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$3bd4deb882852edb$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $3bd4deb882852edb$var$Mj(c, b, g) : 0 !== (f & 4) && $3bd4deb882852edb$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $3bd4deb882852edb$var$Yj(a, b, c);
            break;
        case 1:
            if (!$3bd4deb882852edb$var$U && ($3bd4deb882852edb$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $3bd4deb882852edb$var$W(c, b, h);
            }
            $3bd4deb882852edb$var$Yj(a, b, c);
            break;
        case 21:
            $3bd4deb882852edb$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($3bd4deb882852edb$var$U = (d = $3bd4deb882852edb$var$U) || null !== c.memoizedState, $3bd4deb882852edb$var$Yj(a, b, c), $3bd4deb882852edb$var$U = d) : $3bd4deb882852edb$var$Yj(a, b, c);
            break;
        default:
            $3bd4deb882852edb$var$Yj(a, b, c);
    }
}
function $3bd4deb882852edb$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $3bd4deb882852edb$var$Kj);
        b.forEach(function(b) {
            var d = $3bd4deb882852edb$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $3bd4deb882852edb$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $3bd4deb882852edb$var$X = h.stateNode;
                        $3bd4deb882852edb$var$Xj = !1;
                        break a;
                    case 3:
                        $3bd4deb882852edb$var$X = h.stateNode.containerInfo;
                        $3bd4deb882852edb$var$Xj = !0;
                        break a;
                    case 4:
                        $3bd4deb882852edb$var$X = h.stateNode.containerInfo;
                        $3bd4deb882852edb$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $3bd4deb882852edb$var$X) throw Error($3bd4deb882852edb$var$p(160));
            $3bd4deb882852edb$var$Zj(f, g, e);
            $3bd4deb882852edb$var$X = null;
            $3bd4deb882852edb$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $3bd4deb882852edb$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$3bd4deb882852edb$var$dk(b, a), b = b.sibling;
}
function $3bd4deb882852edb$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $3bd4deb882852edb$var$ck(b, a);
            $3bd4deb882852edb$var$ek(a);
            if (d & 4) {
                try {
                    $3bd4deb882852edb$var$Pj(3, a, a.return), $3bd4deb882852edb$var$Qj(3, a);
                } catch (t) {
                    $3bd4deb882852edb$var$W(a, a.return, t);
                }
                try {
                    $3bd4deb882852edb$var$Pj(5, a, a.return);
                } catch (t) {
                    $3bd4deb882852edb$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $3bd4deb882852edb$var$ck(b, a);
            $3bd4deb882852edb$var$ek(a);
            d & 512 && null !== c && $3bd4deb882852edb$var$Lj(c, c.return);
            break;
        case 5:
            $3bd4deb882852edb$var$ck(b, a);
            $3bd4deb882852edb$var$ek(a);
            d & 512 && null !== c && $3bd4deb882852edb$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $3bd4deb882852edb$var$ob(e, "");
                } catch (t) {
                    $3bd4deb882852edb$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $3bd4deb882852edb$var$ab(e, f);
                    $3bd4deb882852edb$var$vb(h, g);
                    var l = $3bd4deb882852edb$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $3bd4deb882852edb$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $3bd4deb882852edb$var$nb(e, q) : "children" === m ? $3bd4deb882852edb$var$ob(e, q) : $3bd4deb882852edb$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $3bd4deb882852edb$var$bb(e, f);
                            break;
                        case "textarea":
                            $3bd4deb882852edb$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $3bd4deb882852edb$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $3bd4deb882852edb$var$fb(e, !!f.multiple, f.defaultValue, !0) : $3bd4deb882852edb$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$3bd4deb882852edb$var$Pf] = f;
                } catch (t) {
                    $3bd4deb882852edb$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $3bd4deb882852edb$var$ck(b, a);
            $3bd4deb882852edb$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($3bd4deb882852edb$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $3bd4deb882852edb$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $3bd4deb882852edb$var$ck(b, a);
            $3bd4deb882852edb$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $3bd4deb882852edb$var$bd(b.containerInfo);
            } catch (t) {
                $3bd4deb882852edb$var$W(a, a.return, t);
            }
            break;
        case 4:
            $3bd4deb882852edb$var$ck(b, a);
            $3bd4deb882852edb$var$ek(a);
            break;
        case 13:
            $3bd4deb882852edb$var$ck(b, a);
            $3bd4deb882852edb$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($3bd4deb882852edb$var$fk = $3bd4deb882852edb$var$B()));
            d & 4 && $3bd4deb882852edb$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($3bd4deb882852edb$var$U = (l = $3bd4deb882852edb$var$U) || m, $3bd4deb882852edb$var$ck(b, a), $3bd4deb882852edb$var$U = l) : $3bd4deb882852edb$var$ck(b, a);
            $3bd4deb882852edb$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($3bd4deb882852edb$var$V = a, m = a.child; null !== m;){
                    for(q = $3bd4deb882852edb$var$V = m; null !== $3bd4deb882852edb$var$V;){
                        r = $3bd4deb882852edb$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $3bd4deb882852edb$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $3bd4deb882852edb$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $3bd4deb882852edb$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $3bd4deb882852edb$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $3bd4deb882852edb$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $3bd4deb882852edb$var$V = y) : $3bd4deb882852edb$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $3bd4deb882852edb$var$rb("display", g));
                            } catch (t) {
                                $3bd4deb882852edb$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $3bd4deb882852edb$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $3bd4deb882852edb$var$ck(b, a);
            $3bd4deb882852edb$var$ek(a);
            d & 4 && $3bd4deb882852edb$var$ak(a);
            break;
        case 21:
            break;
        default:
            $3bd4deb882852edb$var$ck(b, a), $3bd4deb882852edb$var$ek(a);
    }
}
function $3bd4deb882852edb$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($3bd4deb882852edb$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($3bd4deb882852edb$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($3bd4deb882852edb$var$ob(e, ""), d.flags &= -33);
                    var f = $3bd4deb882852edb$var$Uj(a);
                    $3bd4deb882852edb$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $3bd4deb882852edb$var$Uj(a);
                    $3bd4deb882852edb$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($3bd4deb882852edb$var$p(161));
            }
        } catch (k) {
            $3bd4deb882852edb$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $3bd4deb882852edb$var$hk(a, b, c) {
    $3bd4deb882852edb$var$V = a;
    $3bd4deb882852edb$var$ik(a, b, c);
}
function $3bd4deb882852edb$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $3bd4deb882852edb$var$V;){
        var e = $3bd4deb882852edb$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $3bd4deb882852edb$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $3bd4deb882852edb$var$U;
                h = $3bd4deb882852edb$var$Jj;
                var l = $3bd4deb882852edb$var$U;
                $3bd4deb882852edb$var$Jj = g;
                if (($3bd4deb882852edb$var$U = k) && !l) for($3bd4deb882852edb$var$V = e; null !== $3bd4deb882852edb$var$V;)g = $3bd4deb882852edb$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $3bd4deb882852edb$var$jk(e) : null !== k ? (k.return = g, $3bd4deb882852edb$var$V = k) : $3bd4deb882852edb$var$jk(e);
                for(; null !== f;)$3bd4deb882852edb$var$V = f, $3bd4deb882852edb$var$ik(f, b, c), f = f.sibling;
                $3bd4deb882852edb$var$V = e;
                $3bd4deb882852edb$var$Jj = h;
                $3bd4deb882852edb$var$U = l;
            }
            $3bd4deb882852edb$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $3bd4deb882852edb$var$V = f) : $3bd4deb882852edb$var$kk(a, b, c);
    }
}
function $3bd4deb882852edb$var$kk(a) {
    for(; null !== $3bd4deb882852edb$var$V;){
        var b = $3bd4deb882852edb$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $3bd4deb882852edb$var$U || $3bd4deb882852edb$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$3bd4deb882852edb$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $3bd4deb882852edb$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $3bd4deb882852edb$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $3bd4deb882852edb$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $3bd4deb882852edb$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($3bd4deb882852edb$var$p(163));
                }
                $3bd4deb882852edb$var$U || b.flags & 512 && $3bd4deb882852edb$var$Rj(b);
            } catch (r) {
                $3bd4deb882852edb$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $3bd4deb882852edb$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $3bd4deb882852edb$var$V = c;
            break;
        }
        $3bd4deb882852edb$var$V = b.return;
    }
}
function $3bd4deb882852edb$var$gk(a) {
    for(; null !== $3bd4deb882852edb$var$V;){
        var b = $3bd4deb882852edb$var$V;
        if (b === a) {
            $3bd4deb882852edb$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $3bd4deb882852edb$var$V = c;
            break;
        }
        $3bd4deb882852edb$var$V = b.return;
    }
}
function $3bd4deb882852edb$var$jk(a) {
    for(; null !== $3bd4deb882852edb$var$V;){
        var b = $3bd4deb882852edb$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $3bd4deb882852edb$var$Qj(4, b);
                    } catch (k) {
                        $3bd4deb882852edb$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $3bd4deb882852edb$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $3bd4deb882852edb$var$Rj(b);
                    } catch (k) {
                        $3bd4deb882852edb$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $3bd4deb882852edb$var$Rj(b);
                    } catch (k) {
                        $3bd4deb882852edb$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $3bd4deb882852edb$var$W(b, b.return, k);
        }
        if (b === a) {
            $3bd4deb882852edb$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $3bd4deb882852edb$var$V = h;
            break;
        }
        $3bd4deb882852edb$var$V = b.return;
    }
}
var $3bd4deb882852edb$var$lk = Math.ceil, $3bd4deb882852edb$var$mk = $3bd4deb882852edb$var$ua.ReactCurrentDispatcher, $3bd4deb882852edb$var$nk = $3bd4deb882852edb$var$ua.ReactCurrentOwner, $3bd4deb882852edb$var$ok = $3bd4deb882852edb$var$ua.ReactCurrentBatchConfig, $3bd4deb882852edb$var$K = 0, $3bd4deb882852edb$var$Q = null, $3bd4deb882852edb$var$Y = null, $3bd4deb882852edb$var$Z = 0, $3bd4deb882852edb$var$fj = 0, $3bd4deb882852edb$var$ej = $3bd4deb882852edb$var$Uf(0), $3bd4deb882852edb$var$T = 0, $3bd4deb882852edb$var$pk = null, $3bd4deb882852edb$var$rh = 0, $3bd4deb882852edb$var$qk = 0, $3bd4deb882852edb$var$rk = 0, $3bd4deb882852edb$var$sk = null, $3bd4deb882852edb$var$tk = null, $3bd4deb882852edb$var$fk = 0, $3bd4deb882852edb$var$Gj = Infinity, $3bd4deb882852edb$var$uk = null, $3bd4deb882852edb$var$Oi = !1, $3bd4deb882852edb$var$Pi = null, $3bd4deb882852edb$var$Ri = null, $3bd4deb882852edb$var$vk = !1, $3bd4deb882852edb$var$wk = null, $3bd4deb882852edb$var$xk = 0, $3bd4deb882852edb$var$yk = 0, $3bd4deb882852edb$var$zk = null, $3bd4deb882852edb$var$Ak = -1, $3bd4deb882852edb$var$Bk = 0;
function $3bd4deb882852edb$var$R() {
    return 0 !== ($3bd4deb882852edb$var$K & 6) ? $3bd4deb882852edb$var$B() : -1 !== $3bd4deb882852edb$var$Ak ? $3bd4deb882852edb$var$Ak : $3bd4deb882852edb$var$Ak = $3bd4deb882852edb$var$B();
}
function $3bd4deb882852edb$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($3bd4deb882852edb$var$K & 2) && 0 !== $3bd4deb882852edb$var$Z) return $3bd4deb882852edb$var$Z & -$3bd4deb882852edb$var$Z;
    if (null !== $3bd4deb882852edb$var$Kg.transition) return 0 === $3bd4deb882852edb$var$Bk && ($3bd4deb882852edb$var$Bk = $3bd4deb882852edb$var$yc()), $3bd4deb882852edb$var$Bk;
    a = $3bd4deb882852edb$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $3bd4deb882852edb$var$jd(a.type);
    return a;
}
function $3bd4deb882852edb$var$gi(a, b, c, d) {
    if (50 < $3bd4deb882852edb$var$yk) throw $3bd4deb882852edb$var$yk = 0, $3bd4deb882852edb$var$zk = null, Error($3bd4deb882852edb$var$p(185));
    $3bd4deb882852edb$var$Ac(a, c, d);
    if (0 === ($3bd4deb882852edb$var$K & 2) || a !== $3bd4deb882852edb$var$Q) a === $3bd4deb882852edb$var$Q && (0 === ($3bd4deb882852edb$var$K & 2) && ($3bd4deb882852edb$var$qk |= c), 4 === $3bd4deb882852edb$var$T && $3bd4deb882852edb$var$Ck(a, $3bd4deb882852edb$var$Z)), $3bd4deb882852edb$var$Dk(a, d), 1 === c && 0 === $3bd4deb882852edb$var$K && 0 === (b.mode & 1) && ($3bd4deb882852edb$var$Gj = $3bd4deb882852edb$var$B() + 500, $3bd4deb882852edb$var$fg && $3bd4deb882852edb$var$jg());
}
function $3bd4deb882852edb$var$Dk(a, b) {
    var c = a.callbackNode;
    $3bd4deb882852edb$var$wc(a, b);
    var d = $3bd4deb882852edb$var$uc(a, a === $3bd4deb882852edb$var$Q ? $3bd4deb882852edb$var$Z : 0);
    if (0 === d) null !== c && $3bd4deb882852edb$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $3bd4deb882852edb$var$bc(c);
        if (1 === b) 0 === a.tag ? $3bd4deb882852edb$var$ig($3bd4deb882852edb$var$Ek.bind(null, a)) : $3bd4deb882852edb$var$hg($3bd4deb882852edb$var$Ek.bind(null, a)), $3bd4deb882852edb$var$Jf(function() {
            0 === ($3bd4deb882852edb$var$K & 6) && $3bd4deb882852edb$var$jg();
        }), c = null;
        else {
            switch($3bd4deb882852edb$var$Dc(d)){
                case 1:
                    c = $3bd4deb882852edb$var$fc;
                    break;
                case 4:
                    c = $3bd4deb882852edb$var$gc;
                    break;
                case 16:
                    c = $3bd4deb882852edb$var$hc;
                    break;
                case 536870912:
                    c = $3bd4deb882852edb$var$jc;
                    break;
                default:
                    c = $3bd4deb882852edb$var$hc;
            }
            c = $3bd4deb882852edb$var$Fk(c, $3bd4deb882852edb$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $3bd4deb882852edb$var$Gk(a, b) {
    $3bd4deb882852edb$var$Ak = -1;
    $3bd4deb882852edb$var$Bk = 0;
    if (0 !== ($3bd4deb882852edb$var$K & 6)) throw Error($3bd4deb882852edb$var$p(327));
    var c = a.callbackNode;
    if ($3bd4deb882852edb$var$Hk() && a.callbackNode !== c) return null;
    var d = $3bd4deb882852edb$var$uc(a, a === $3bd4deb882852edb$var$Q ? $3bd4deb882852edb$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $3bd4deb882852edb$var$Ik(a, d);
    else {
        b = d;
        var e = $3bd4deb882852edb$var$K;
        $3bd4deb882852edb$var$K |= 2;
        var f = $3bd4deb882852edb$var$Jk();
        if ($3bd4deb882852edb$var$Q !== a || $3bd4deb882852edb$var$Z !== b) $3bd4deb882852edb$var$uk = null, $3bd4deb882852edb$var$Gj = $3bd4deb882852edb$var$B() + 500, $3bd4deb882852edb$var$Kk(a, b);
        for(;;)try {
            $3bd4deb882852edb$var$Lk();
            break;
        } catch (h) {
            $3bd4deb882852edb$var$Mk(a, h);
        }
        $3bd4deb882852edb$var$$g();
        $3bd4deb882852edb$var$mk.current = f;
        $3bd4deb882852edb$var$K = e;
        null !== $3bd4deb882852edb$var$Y ? b = 0 : ($3bd4deb882852edb$var$Q = null, $3bd4deb882852edb$var$Z = 0, b = $3bd4deb882852edb$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $3bd4deb882852edb$var$xc(a), 0 !== e && (d = e, b = $3bd4deb882852edb$var$Nk(a, e)));
        if (1 === b) throw c = $3bd4deb882852edb$var$pk, $3bd4deb882852edb$var$Kk(a, 0), $3bd4deb882852edb$var$Ck(a, d), $3bd4deb882852edb$var$Dk(a, $3bd4deb882852edb$var$B()), c;
        if (6 === b) $3bd4deb882852edb$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$3bd4deb882852edb$var$Ok(e) && (b = $3bd4deb882852edb$var$Ik(a, d), 2 === b && (f = $3bd4deb882852edb$var$xc(a), 0 !== f && (d = f, b = $3bd4deb882852edb$var$Nk(a, f))), 1 === b)) throw c = $3bd4deb882852edb$var$pk, $3bd4deb882852edb$var$Kk(a, 0), $3bd4deb882852edb$var$Ck(a, d), $3bd4deb882852edb$var$Dk(a, $3bd4deb882852edb$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($3bd4deb882852edb$var$p(345));
                case 2:
                    $3bd4deb882852edb$var$Pk(a, $3bd4deb882852edb$var$tk, $3bd4deb882852edb$var$uk);
                    break;
                case 3:
                    $3bd4deb882852edb$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $3bd4deb882852edb$var$fk + 500 - $3bd4deb882852edb$var$B(), 10 < b)) {
                        if (0 !== $3bd4deb882852edb$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $3bd4deb882852edb$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $3bd4deb882852edb$var$Ff($3bd4deb882852edb$var$Pk.bind(null, a, $3bd4deb882852edb$var$tk, $3bd4deb882852edb$var$uk), b);
                        break;
                    }
                    $3bd4deb882852edb$var$Pk(a, $3bd4deb882852edb$var$tk, $3bd4deb882852edb$var$uk);
                    break;
                case 4:
                    $3bd4deb882852edb$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $3bd4deb882852edb$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $3bd4deb882852edb$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $3bd4deb882852edb$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $3bd4deb882852edb$var$Ff($3bd4deb882852edb$var$Pk.bind(null, a, $3bd4deb882852edb$var$tk, $3bd4deb882852edb$var$uk), d);
                        break;
                    }
                    $3bd4deb882852edb$var$Pk(a, $3bd4deb882852edb$var$tk, $3bd4deb882852edb$var$uk);
                    break;
                case 5:
                    $3bd4deb882852edb$var$Pk(a, $3bd4deb882852edb$var$tk, $3bd4deb882852edb$var$uk);
                    break;
                default:
                    throw Error($3bd4deb882852edb$var$p(329));
            }
        }
    }
    $3bd4deb882852edb$var$Dk(a, $3bd4deb882852edb$var$B());
    return a.callbackNode === c ? $3bd4deb882852edb$var$Gk.bind(null, a) : null;
}
function $3bd4deb882852edb$var$Nk(a, b) {
    var c = $3bd4deb882852edb$var$sk;
    a.current.memoizedState.isDehydrated && ($3bd4deb882852edb$var$Kk(a, b).flags |= 256);
    a = $3bd4deb882852edb$var$Ik(a, b);
    2 !== a && (b = $3bd4deb882852edb$var$tk, $3bd4deb882852edb$var$tk = c, null !== b && $3bd4deb882852edb$var$Fj(b));
    return a;
}
function $3bd4deb882852edb$var$Fj(a) {
    null === $3bd4deb882852edb$var$tk ? $3bd4deb882852edb$var$tk = a : $3bd4deb882852edb$var$tk.push.apply($3bd4deb882852edb$var$tk, a);
}
function $3bd4deb882852edb$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$3bd4deb882852edb$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $3bd4deb882852edb$var$Ck(a, b) {
    b &= ~$3bd4deb882852edb$var$rk;
    b &= ~$3bd4deb882852edb$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $3bd4deb882852edb$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $3bd4deb882852edb$var$Ek(a) {
    if (0 !== ($3bd4deb882852edb$var$K & 6)) throw Error($3bd4deb882852edb$var$p(327));
    $3bd4deb882852edb$var$Hk();
    var b = $3bd4deb882852edb$var$uc(a, 0);
    if (0 === (b & 1)) return $3bd4deb882852edb$var$Dk(a, $3bd4deb882852edb$var$B()), null;
    var c = $3bd4deb882852edb$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $3bd4deb882852edb$var$xc(a);
        0 !== d && (b = d, c = $3bd4deb882852edb$var$Nk(a, d));
    }
    if (1 === c) throw c = $3bd4deb882852edb$var$pk, $3bd4deb882852edb$var$Kk(a, 0), $3bd4deb882852edb$var$Ck(a, b), $3bd4deb882852edb$var$Dk(a, $3bd4deb882852edb$var$B()), c;
    if (6 === c) throw Error($3bd4deb882852edb$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $3bd4deb882852edb$var$Pk(a, $3bd4deb882852edb$var$tk, $3bd4deb882852edb$var$uk);
    $3bd4deb882852edb$var$Dk(a, $3bd4deb882852edb$var$B());
    return null;
}
function $3bd4deb882852edb$var$Qk(a, b) {
    var c = $3bd4deb882852edb$var$K;
    $3bd4deb882852edb$var$K |= 1;
    try {
        return a(b);
    } finally{
        $3bd4deb882852edb$var$K = c, 0 === $3bd4deb882852edb$var$K && ($3bd4deb882852edb$var$Gj = $3bd4deb882852edb$var$B() + 500, $3bd4deb882852edb$var$fg && $3bd4deb882852edb$var$jg());
    }
}
function $3bd4deb882852edb$var$Rk(a) {
    null !== $3bd4deb882852edb$var$wk && 0 === $3bd4deb882852edb$var$wk.tag && 0 === ($3bd4deb882852edb$var$K & 6) && $3bd4deb882852edb$var$Hk();
    var b = $3bd4deb882852edb$var$K;
    $3bd4deb882852edb$var$K |= 1;
    var c = $3bd4deb882852edb$var$ok.transition, d = $3bd4deb882852edb$var$C;
    try {
        if ($3bd4deb882852edb$var$ok.transition = null, $3bd4deb882852edb$var$C = 1, a) return a();
    } finally{
        $3bd4deb882852edb$var$C = d, $3bd4deb882852edb$var$ok.transition = c, $3bd4deb882852edb$var$K = b, 0 === ($3bd4deb882852edb$var$K & 6) && $3bd4deb882852edb$var$jg();
    }
}
function $3bd4deb882852edb$var$Hj() {
    $3bd4deb882852edb$var$fj = $3bd4deb882852edb$var$ej.current;
    $3bd4deb882852edb$var$E($3bd4deb882852edb$var$ej);
}
function $3bd4deb882852edb$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $3bd4deb882852edb$var$Gf(c));
    if (null !== $3bd4deb882852edb$var$Y) for(c = $3bd4deb882852edb$var$Y.return; null !== c;){
        var d = c;
        $3bd4deb882852edb$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $3bd4deb882852edb$var$$f();
                break;
            case 3:
                $3bd4deb882852edb$var$zh();
                $3bd4deb882852edb$var$E($3bd4deb882852edb$var$Wf);
                $3bd4deb882852edb$var$E($3bd4deb882852edb$var$H);
                $3bd4deb882852edb$var$Eh();
                break;
            case 5:
                $3bd4deb882852edb$var$Bh(d);
                break;
            case 4:
                $3bd4deb882852edb$var$zh();
                break;
            case 13:
                $3bd4deb882852edb$var$E($3bd4deb882852edb$var$L);
                break;
            case 19:
                $3bd4deb882852edb$var$E($3bd4deb882852edb$var$L);
                break;
            case 10:
                $3bd4deb882852edb$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $3bd4deb882852edb$var$Hj();
        }
        c = c.return;
    }
    $3bd4deb882852edb$var$Q = a;
    $3bd4deb882852edb$var$Y = a = $3bd4deb882852edb$var$Pg(a.current, null);
    $3bd4deb882852edb$var$Z = $3bd4deb882852edb$var$fj = b;
    $3bd4deb882852edb$var$T = 0;
    $3bd4deb882852edb$var$pk = null;
    $3bd4deb882852edb$var$rk = $3bd4deb882852edb$var$qk = $3bd4deb882852edb$var$rh = 0;
    $3bd4deb882852edb$var$tk = $3bd4deb882852edb$var$sk = null;
    if (null !== $3bd4deb882852edb$var$fh) {
        for(b = 0; b < $3bd4deb882852edb$var$fh.length; b++)if (c = $3bd4deb882852edb$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $3bd4deb882852edb$var$fh = null;
    }
    return a;
}
function $3bd4deb882852edb$var$Mk(a, b) {
    do {
        var c = $3bd4deb882852edb$var$Y;
        try {
            $3bd4deb882852edb$var$$g();
            $3bd4deb882852edb$var$Fh.current = $3bd4deb882852edb$var$Rh;
            if ($3bd4deb882852edb$var$Ih) {
                for(var d = $3bd4deb882852edb$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $3bd4deb882852edb$var$Ih = !1;
            }
            $3bd4deb882852edb$var$Hh = 0;
            $3bd4deb882852edb$var$O = $3bd4deb882852edb$var$N = $3bd4deb882852edb$var$M = null;
            $3bd4deb882852edb$var$Jh = !1;
            $3bd4deb882852edb$var$Kh = 0;
            $3bd4deb882852edb$var$nk.current = null;
            if (null === c || null === c.return) {
                $3bd4deb882852edb$var$T = 1;
                $3bd4deb882852edb$var$pk = b;
                $3bd4deb882852edb$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $3bd4deb882852edb$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $3bd4deb882852edb$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $3bd4deb882852edb$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $3bd4deb882852edb$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $3bd4deb882852edb$var$Si(f, l, b);
                            $3bd4deb882852edb$var$tj();
                            break a;
                        }
                        k = Error($3bd4deb882852edb$var$p(426));
                    }
                } else if ($3bd4deb882852edb$var$I && h.mode & 1) {
                    var J = $3bd4deb882852edb$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $3bd4deb882852edb$var$Vi(J, g, h, f, b);
                        $3bd4deb882852edb$var$Jg($3bd4deb882852edb$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $3bd4deb882852edb$var$Ji(k, h);
                4 !== $3bd4deb882852edb$var$T && ($3bd4deb882852edb$var$T = 2);
                null === $3bd4deb882852edb$var$sk ? $3bd4deb882852edb$var$sk = [
                    f
                ] : $3bd4deb882852edb$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $3bd4deb882852edb$var$Ni(f, k, b);
                            $3bd4deb882852edb$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $3bd4deb882852edb$var$Ri || !$3bd4deb882852edb$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $3bd4deb882852edb$var$Qi(f, h, b);
                                $3bd4deb882852edb$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $3bd4deb882852edb$var$Sk(c);
        } catch (na) {
            b = na;
            $3bd4deb882852edb$var$Y === c && null !== c && ($3bd4deb882852edb$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $3bd4deb882852edb$var$Jk() {
    var a = $3bd4deb882852edb$var$mk.current;
    $3bd4deb882852edb$var$mk.current = $3bd4deb882852edb$var$Rh;
    return null === a ? $3bd4deb882852edb$var$Rh : a;
}
function $3bd4deb882852edb$var$tj() {
    if (0 === $3bd4deb882852edb$var$T || 3 === $3bd4deb882852edb$var$T || 2 === $3bd4deb882852edb$var$T) $3bd4deb882852edb$var$T = 4;
    null === $3bd4deb882852edb$var$Q || 0 === ($3bd4deb882852edb$var$rh & 268435455) && 0 === ($3bd4deb882852edb$var$qk & 268435455) || $3bd4deb882852edb$var$Ck($3bd4deb882852edb$var$Q, $3bd4deb882852edb$var$Z);
}
function $3bd4deb882852edb$var$Ik(a, b) {
    var c = $3bd4deb882852edb$var$K;
    $3bd4deb882852edb$var$K |= 2;
    var d = $3bd4deb882852edb$var$Jk();
    if ($3bd4deb882852edb$var$Q !== a || $3bd4deb882852edb$var$Z !== b) $3bd4deb882852edb$var$uk = null, $3bd4deb882852edb$var$Kk(a, b);
    for(;;)try {
        $3bd4deb882852edb$var$Tk();
        break;
    } catch (e) {
        $3bd4deb882852edb$var$Mk(a, e);
    }
    $3bd4deb882852edb$var$$g();
    $3bd4deb882852edb$var$K = c;
    $3bd4deb882852edb$var$mk.current = d;
    if (null !== $3bd4deb882852edb$var$Y) throw Error($3bd4deb882852edb$var$p(261));
    $3bd4deb882852edb$var$Q = null;
    $3bd4deb882852edb$var$Z = 0;
    return $3bd4deb882852edb$var$T;
}
function $3bd4deb882852edb$var$Tk() {
    for(; null !== $3bd4deb882852edb$var$Y;)$3bd4deb882852edb$var$Uk($3bd4deb882852edb$var$Y);
}
function $3bd4deb882852edb$var$Lk() {
    for(; null !== $3bd4deb882852edb$var$Y && !$3bd4deb882852edb$var$cc();)$3bd4deb882852edb$var$Uk($3bd4deb882852edb$var$Y);
}
function $3bd4deb882852edb$var$Uk(a) {
    var b = $3bd4deb882852edb$var$Vk(a.alternate, a, $3bd4deb882852edb$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $3bd4deb882852edb$var$Sk(a) : $3bd4deb882852edb$var$Y = b;
    $3bd4deb882852edb$var$nk.current = null;
}
function $3bd4deb882852edb$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $3bd4deb882852edb$var$Ej(c, b, $3bd4deb882852edb$var$fj), null !== c) {
                $3bd4deb882852edb$var$Y = c;
                return;
            }
        } else {
            c = $3bd4deb882852edb$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $3bd4deb882852edb$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $3bd4deb882852edb$var$T = 6;
                $3bd4deb882852edb$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $3bd4deb882852edb$var$Y = b;
            return;
        }
        $3bd4deb882852edb$var$Y = b = a;
    }while (null !== b);
    0 === $3bd4deb882852edb$var$T && ($3bd4deb882852edb$var$T = 5);
}
function $3bd4deb882852edb$var$Pk(a, b, c) {
    var d = $3bd4deb882852edb$var$C, e = $3bd4deb882852edb$var$ok.transition;
    try {
        $3bd4deb882852edb$var$ok.transition = null, $3bd4deb882852edb$var$C = 1, $3bd4deb882852edb$var$Wk(a, b, c, d);
    } finally{
        $3bd4deb882852edb$var$ok.transition = e, $3bd4deb882852edb$var$C = d;
    }
    return null;
}
function $3bd4deb882852edb$var$Wk(a, b, c, d) {
    do $3bd4deb882852edb$var$Hk();
    while (null !== $3bd4deb882852edb$var$wk);
    if (0 !== ($3bd4deb882852edb$var$K & 6)) throw Error($3bd4deb882852edb$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($3bd4deb882852edb$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $3bd4deb882852edb$var$Bc(a, f);
    a === $3bd4deb882852edb$var$Q && ($3bd4deb882852edb$var$Y = $3bd4deb882852edb$var$Q = null, $3bd4deb882852edb$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $3bd4deb882852edb$var$vk || ($3bd4deb882852edb$var$vk = !0, $3bd4deb882852edb$var$Fk($3bd4deb882852edb$var$hc, function() {
        $3bd4deb882852edb$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $3bd4deb882852edb$var$ok.transition;
        $3bd4deb882852edb$var$ok.transition = null;
        var g = $3bd4deb882852edb$var$C;
        $3bd4deb882852edb$var$C = 1;
        var h = $3bd4deb882852edb$var$K;
        $3bd4deb882852edb$var$K |= 4;
        $3bd4deb882852edb$var$nk.current = null;
        $3bd4deb882852edb$var$Oj(a, c);
        $3bd4deb882852edb$var$dk(c, a);
        $3bd4deb882852edb$var$Oe($3bd4deb882852edb$var$Df);
        $3bd4deb882852edb$var$dd = !!$3bd4deb882852edb$var$Cf;
        $3bd4deb882852edb$var$Df = $3bd4deb882852edb$var$Cf = null;
        a.current = c;
        $3bd4deb882852edb$var$hk(c, a, e);
        $3bd4deb882852edb$var$dc();
        $3bd4deb882852edb$var$K = h;
        $3bd4deb882852edb$var$C = g;
        $3bd4deb882852edb$var$ok.transition = f;
    } else a.current = c;
    $3bd4deb882852edb$var$vk && ($3bd4deb882852edb$var$vk = !1, $3bd4deb882852edb$var$wk = a, $3bd4deb882852edb$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($3bd4deb882852edb$var$Ri = null);
    $3bd4deb882852edb$var$mc(c.stateNode, d);
    $3bd4deb882852edb$var$Dk(a, $3bd4deb882852edb$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($3bd4deb882852edb$var$Oi) throw $3bd4deb882852edb$var$Oi = !1, a = $3bd4deb882852edb$var$Pi, $3bd4deb882852edb$var$Pi = null, a;
    0 !== ($3bd4deb882852edb$var$xk & 1) && 0 !== a.tag && $3bd4deb882852edb$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $3bd4deb882852edb$var$zk ? $3bd4deb882852edb$var$yk++ : ($3bd4deb882852edb$var$yk = 0, $3bd4deb882852edb$var$zk = a) : $3bd4deb882852edb$var$yk = 0;
    $3bd4deb882852edb$var$jg();
    return null;
}
function $3bd4deb882852edb$var$Hk() {
    if (null !== $3bd4deb882852edb$var$wk) {
        var a = $3bd4deb882852edb$var$Dc($3bd4deb882852edb$var$xk), b = $3bd4deb882852edb$var$ok.transition, c = $3bd4deb882852edb$var$C;
        try {
            $3bd4deb882852edb$var$ok.transition = null;
            $3bd4deb882852edb$var$C = 16 > a ? 16 : a;
            if (null === $3bd4deb882852edb$var$wk) var d = !1;
            else {
                a = $3bd4deb882852edb$var$wk;
                $3bd4deb882852edb$var$wk = null;
                $3bd4deb882852edb$var$xk = 0;
                if (0 !== ($3bd4deb882852edb$var$K & 6)) throw Error($3bd4deb882852edb$var$p(331));
                var e = $3bd4deb882852edb$var$K;
                $3bd4deb882852edb$var$K |= 4;
                for($3bd4deb882852edb$var$V = a.current; null !== $3bd4deb882852edb$var$V;){
                    var f = $3bd4deb882852edb$var$V, g = f.child;
                    if (0 !== ($3bd4deb882852edb$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($3bd4deb882852edb$var$V = l; null !== $3bd4deb882852edb$var$V;){
                                    var m = $3bd4deb882852edb$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $3bd4deb882852edb$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $3bd4deb882852edb$var$V = q;
                                    else for(; null !== $3bd4deb882852edb$var$V;){
                                        m = $3bd4deb882852edb$var$V;
                                        var r = m.sibling, y = m.return;
                                        $3bd4deb882852edb$var$Sj(m);
                                        if (m === l) {
                                            $3bd4deb882852edb$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $3bd4deb882852edb$var$V = r;
                                            break;
                                        }
                                        $3bd4deb882852edb$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $3bd4deb882852edb$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $3bd4deb882852edb$var$V = g;
                    else b: for(; null !== $3bd4deb882852edb$var$V;){
                        f = $3bd4deb882852edb$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $3bd4deb882852edb$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $3bd4deb882852edb$var$V = x;
                            break b;
                        }
                        $3bd4deb882852edb$var$V = f.return;
                    }
                }
                var w = a.current;
                for($3bd4deb882852edb$var$V = w; null !== $3bd4deb882852edb$var$V;){
                    g = $3bd4deb882852edb$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $3bd4deb882852edb$var$V = u;
                    else b: for(g = w; null !== $3bd4deb882852edb$var$V;){
                        h = $3bd4deb882852edb$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $3bd4deb882852edb$var$Qj(9, h);
                            }
                        } catch (na) {
                            $3bd4deb882852edb$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $3bd4deb882852edb$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $3bd4deb882852edb$var$V = F;
                            break b;
                        }
                        $3bd4deb882852edb$var$V = h.return;
                    }
                }
                $3bd4deb882852edb$var$K = e;
                $3bd4deb882852edb$var$jg();
                if ($3bd4deb882852edb$var$lc && "function" === typeof $3bd4deb882852edb$var$lc.onPostCommitFiberRoot) try {
                    $3bd4deb882852edb$var$lc.onPostCommitFiberRoot($3bd4deb882852edb$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $3bd4deb882852edb$var$C = c, $3bd4deb882852edb$var$ok.transition = b;
        }
    }
    return !1;
}
function $3bd4deb882852edb$var$Xk(a, b, c) {
    b = $3bd4deb882852edb$var$Ji(c, b);
    b = $3bd4deb882852edb$var$Ni(a, b, 1);
    a = $3bd4deb882852edb$var$nh(a, b, 1);
    b = $3bd4deb882852edb$var$R();
    null !== a && ($3bd4deb882852edb$var$Ac(a, 1, b), $3bd4deb882852edb$var$Dk(a, b));
}
function $3bd4deb882852edb$var$W(a, b, c) {
    if (3 === a.tag) $3bd4deb882852edb$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $3bd4deb882852edb$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $3bd4deb882852edb$var$Ri || !$3bd4deb882852edb$var$Ri.has(d))) {
                a = $3bd4deb882852edb$var$Ji(c, a);
                a = $3bd4deb882852edb$var$Qi(b, a, 1);
                b = $3bd4deb882852edb$var$nh(b, a, 1);
                a = $3bd4deb882852edb$var$R();
                null !== b && ($3bd4deb882852edb$var$Ac(b, 1, a), $3bd4deb882852edb$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $3bd4deb882852edb$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $3bd4deb882852edb$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $3bd4deb882852edb$var$Q === a && ($3bd4deb882852edb$var$Z & c) === c && (4 === $3bd4deb882852edb$var$T || 3 === $3bd4deb882852edb$var$T && ($3bd4deb882852edb$var$Z & 130023424) === $3bd4deb882852edb$var$Z && 500 > $3bd4deb882852edb$var$B() - $3bd4deb882852edb$var$fk ? $3bd4deb882852edb$var$Kk(a, 0) : $3bd4deb882852edb$var$rk |= c);
    $3bd4deb882852edb$var$Dk(a, b);
}
function $3bd4deb882852edb$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $3bd4deb882852edb$var$sc, $3bd4deb882852edb$var$sc <<= 1, 0 === ($3bd4deb882852edb$var$sc & 130023424) && ($3bd4deb882852edb$var$sc = 4194304)));
    var c = $3bd4deb882852edb$var$R();
    a = $3bd4deb882852edb$var$ih(a, b);
    null !== a && ($3bd4deb882852edb$var$Ac(a, b, c), $3bd4deb882852edb$var$Dk(a, c));
}
function $3bd4deb882852edb$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $3bd4deb882852edb$var$Yk(a, c);
}
function $3bd4deb882852edb$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($3bd4deb882852edb$var$p(314));
    }
    null !== d && d.delete(b);
    $3bd4deb882852edb$var$Yk(a, c);
}
var $3bd4deb882852edb$var$Vk;
$3bd4deb882852edb$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $3bd4deb882852edb$var$Wf.current) $3bd4deb882852edb$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $3bd4deb882852edb$var$dh = !1, $3bd4deb882852edb$var$yj(a, b, c);
            $3bd4deb882852edb$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $3bd4deb882852edb$var$dh = !1, $3bd4deb882852edb$var$I && 0 !== (b.flags & 1048576) && $3bd4deb882852edb$var$ug(b, $3bd4deb882852edb$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $3bd4deb882852edb$var$ij(a, b);
            a = b.pendingProps;
            var e = $3bd4deb882852edb$var$Yf(b, $3bd4deb882852edb$var$H.current);
            $3bd4deb882852edb$var$ch(b, c);
            e = $3bd4deb882852edb$var$Nh(null, b, d, a, e, c);
            var f = $3bd4deb882852edb$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $3bd4deb882852edb$var$Zf(d) ? (f = !0, $3bd4deb882852edb$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $3bd4deb882852edb$var$kh(b), e.updater = $3bd4deb882852edb$var$Ei, b.stateNode = e, e._reactInternals = b, $3bd4deb882852edb$var$Ii(b, d, a, c), b = $3bd4deb882852edb$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $3bd4deb882852edb$var$I && f && $3bd4deb882852edb$var$vg(b), $3bd4deb882852edb$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $3bd4deb882852edb$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $3bd4deb882852edb$var$Zk(d);
                a = $3bd4deb882852edb$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $3bd4deb882852edb$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $3bd4deb882852edb$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $3bd4deb882852edb$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $3bd4deb882852edb$var$$i(null, b, d, $3bd4deb882852edb$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($3bd4deb882852edb$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $3bd4deb882852edb$var$Ci(d, e), $3bd4deb882852edb$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $3bd4deb882852edb$var$Ci(d, e), $3bd4deb882852edb$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $3bd4deb882852edb$var$kj(b);
                if (null === a) throw Error($3bd4deb882852edb$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $3bd4deb882852edb$var$lh(a, b);
                $3bd4deb882852edb$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $3bd4deb882852edb$var$Ji(Error($3bd4deb882852edb$var$p(423)), b);
                        b = $3bd4deb882852edb$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $3bd4deb882852edb$var$Ji(Error($3bd4deb882852edb$var$p(424)), b);
                        b = $3bd4deb882852edb$var$lj(a, b, d, c, e);
                        break a;
                    } else for($3bd4deb882852edb$var$yg = $3bd4deb882852edb$var$Lf(b.stateNode.containerInfo.firstChild), $3bd4deb882852edb$var$xg = b, $3bd4deb882852edb$var$I = !0, $3bd4deb882852edb$var$zg = null, c = $3bd4deb882852edb$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $3bd4deb882852edb$var$Ig();
                    if (d === e) {
                        b = $3bd4deb882852edb$var$Zi(a, b, c);
                        break a;
                    }
                    $3bd4deb882852edb$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $3bd4deb882852edb$var$Ah(b), null === a && $3bd4deb882852edb$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $3bd4deb882852edb$var$Ef(d, e) ? g = null : null !== f && $3bd4deb882852edb$var$Ef(d, f) && (b.flags |= 32), $3bd4deb882852edb$var$gj(a, b), $3bd4deb882852edb$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $3bd4deb882852edb$var$Eg(b), null;
        case 13:
            return $3bd4deb882852edb$var$oj(a, b, c);
        case 4:
            return $3bd4deb882852edb$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $3bd4deb882852edb$var$Ug(b, null, d, c) : $3bd4deb882852edb$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $3bd4deb882852edb$var$Ci(d, e), $3bd4deb882852edb$var$Yi(a, b, d, e, c);
        case 7:
            return $3bd4deb882852edb$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $3bd4deb882852edb$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $3bd4deb882852edb$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $3bd4deb882852edb$var$G($3bd4deb882852edb$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($3bd4deb882852edb$var$He(f.value, g)) {
                        if (f.children === e.children && !$3bd4deb882852edb$var$Wf.current) {
                            b = $3bd4deb882852edb$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $3bd4deb882852edb$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $3bd4deb882852edb$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($3bd4deb882852edb$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $3bd4deb882852edb$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $3bd4deb882852edb$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $3bd4deb882852edb$var$ch(b, c), e = $3bd4deb882852edb$var$eh(e), d = d(e), b.flags |= 1, $3bd4deb882852edb$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $3bd4deb882852edb$var$Ci(d, b.pendingProps), e = $3bd4deb882852edb$var$Ci(d.type, e), $3bd4deb882852edb$var$$i(a, b, d, e, c);
        case 15:
            return $3bd4deb882852edb$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $3bd4deb882852edb$var$Ci(d, e), $3bd4deb882852edb$var$ij(a, b), b.tag = 1, $3bd4deb882852edb$var$Zf(d) ? (a = !0, $3bd4deb882852edb$var$cg(b)) : a = !1, $3bd4deb882852edb$var$ch(b, c), $3bd4deb882852edb$var$Gi(b, d, e), $3bd4deb882852edb$var$Ii(b, d, e, c), $3bd4deb882852edb$var$jj(null, b, d, !0, a, c);
        case 19:
            return $3bd4deb882852edb$var$xj(a, b, c);
        case 22:
            return $3bd4deb882852edb$var$dj(a, b, c);
    }
    throw Error($3bd4deb882852edb$var$p(156, b.tag));
};
function $3bd4deb882852edb$var$Fk(a, b) {
    return $3bd4deb882852edb$var$ac(a, b);
}
function $3bd4deb882852edb$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $3bd4deb882852edb$var$Bg(a, b, c, d) {
    return new $3bd4deb882852edb$var$$k(a, b, c, d);
}
function $3bd4deb882852edb$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $3bd4deb882852edb$var$Zk(a) {
    if ("function" === typeof a) return $3bd4deb882852edb$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $3bd4deb882852edb$var$Da) return 11;
        if (a === $3bd4deb882852edb$var$Ga) return 14;
    }
    return 2;
}
function $3bd4deb882852edb$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $3bd4deb882852edb$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $3bd4deb882852edb$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $3bd4deb882852edb$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $3bd4deb882852edb$var$ya:
            return $3bd4deb882852edb$var$Tg(c.children, e, f, b);
        case $3bd4deb882852edb$var$za:
            g = 8;
            e |= 8;
            break;
        case $3bd4deb882852edb$var$Aa:
            return a = $3bd4deb882852edb$var$Bg(12, c, b, e | 2), a.elementType = $3bd4deb882852edb$var$Aa, a.lanes = f, a;
        case $3bd4deb882852edb$var$Ea:
            return a = $3bd4deb882852edb$var$Bg(13, c, b, e), a.elementType = $3bd4deb882852edb$var$Ea, a.lanes = f, a;
        case $3bd4deb882852edb$var$Fa:
            return a = $3bd4deb882852edb$var$Bg(19, c, b, e), a.elementType = $3bd4deb882852edb$var$Fa, a.lanes = f, a;
        case $3bd4deb882852edb$var$Ia:
            return $3bd4deb882852edb$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $3bd4deb882852edb$var$Ba:
                    g = 10;
                    break a;
                case $3bd4deb882852edb$var$Ca:
                    g = 9;
                    break a;
                case $3bd4deb882852edb$var$Da:
                    g = 11;
                    break a;
                case $3bd4deb882852edb$var$Ga:
                    g = 14;
                    break a;
                case $3bd4deb882852edb$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($3bd4deb882852edb$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $3bd4deb882852edb$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $3bd4deb882852edb$var$Tg(a, b, c, d) {
    a = $3bd4deb882852edb$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $3bd4deb882852edb$var$pj(a, b, c, d) {
    a = $3bd4deb882852edb$var$Bg(22, a, d, b);
    a.elementType = $3bd4deb882852edb$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $3bd4deb882852edb$var$Qg(a, b, c) {
    a = $3bd4deb882852edb$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $3bd4deb882852edb$var$Sg(a, b, c) {
    b = $3bd4deb882852edb$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $3bd4deb882852edb$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $3bd4deb882852edb$var$zc(0);
    this.expirationTimes = $3bd4deb882852edb$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $3bd4deb882852edb$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $3bd4deb882852edb$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $3bd4deb882852edb$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $3bd4deb882852edb$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $3bd4deb882852edb$var$kh(f);
    return a;
}
function $3bd4deb882852edb$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $3bd4deb882852edb$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $3bd4deb882852edb$var$dl(a) {
    if (!a) return $3bd4deb882852edb$var$Vf;
    a = a._reactInternals;
    a: {
        if ($3bd4deb882852edb$var$Vb(a) !== a || 1 !== a.tag) throw Error($3bd4deb882852edb$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($3bd4deb882852edb$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($3bd4deb882852edb$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($3bd4deb882852edb$var$Zf(c)) return $3bd4deb882852edb$var$bg(a, c, b);
    }
    return b;
}
function $3bd4deb882852edb$var$el(a, b, c, d, e, f, g, h, k) {
    a = $3bd4deb882852edb$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $3bd4deb882852edb$var$dl(null);
    c = a.current;
    d = $3bd4deb882852edb$var$R();
    e = $3bd4deb882852edb$var$yi(c);
    f = $3bd4deb882852edb$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $3bd4deb882852edb$var$nh(c, f, e);
    a.current.lanes = e;
    $3bd4deb882852edb$var$Ac(a, e, d);
    $3bd4deb882852edb$var$Dk(a, d);
    return a;
}
function $3bd4deb882852edb$var$fl(a, b, c, d) {
    var e = b.current, f = $3bd4deb882852edb$var$R(), g = $3bd4deb882852edb$var$yi(e);
    c = $3bd4deb882852edb$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $3bd4deb882852edb$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $3bd4deb882852edb$var$nh(e, b, g);
    null !== a && ($3bd4deb882852edb$var$gi(a, e, g, f), $3bd4deb882852edb$var$oh(a, e, g));
    return g;
}
function $3bd4deb882852edb$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $3bd4deb882852edb$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $3bd4deb882852edb$var$il(a, b) {
    $3bd4deb882852edb$var$hl(a, b);
    (a = a.alternate) && $3bd4deb882852edb$var$hl(a, b);
}
function $3bd4deb882852edb$var$jl() {
    return null;
}
var $3bd4deb882852edb$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $3bd4deb882852edb$var$ll(a) {
    this._internalRoot = a;
}
$3bd4deb882852edb$var$ml.prototype.render = $3bd4deb882852edb$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($3bd4deb882852edb$var$p(409));
    $3bd4deb882852edb$var$fl(a, b, null, null);
};
$3bd4deb882852edb$var$ml.prototype.unmount = $3bd4deb882852edb$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $3bd4deb882852edb$var$Rk(function() {
            $3bd4deb882852edb$var$fl(null, a, null, null);
        });
        b[$3bd4deb882852edb$var$uf] = null;
    }
};
function $3bd4deb882852edb$var$ml(a) {
    this._internalRoot = a;
}
$3bd4deb882852edb$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $3bd4deb882852edb$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $3bd4deb882852edb$var$Qc.length && 0 !== b && b < $3bd4deb882852edb$var$Qc[c].priority; c++);
        $3bd4deb882852edb$var$Qc.splice(c, 0, a);
        0 === c && $3bd4deb882852edb$var$Vc(a);
    }
};
function $3bd4deb882852edb$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $3bd4deb882852edb$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $3bd4deb882852edb$var$pl() {}
function $3bd4deb882852edb$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $3bd4deb882852edb$var$gl(g);
                f.call(a);
            };
        }
        var g = $3bd4deb882852edb$var$el(b, d, a, 0, null, !1, !1, "", $3bd4deb882852edb$var$pl);
        a._reactRootContainer = g;
        a[$3bd4deb882852edb$var$uf] = g.current;
        $3bd4deb882852edb$var$sf(8 === a.nodeType ? a.parentNode : a);
        $3bd4deb882852edb$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $3bd4deb882852edb$var$gl(k);
            h.call(a);
        };
    }
    var k = $3bd4deb882852edb$var$bl(a, 0, !1, null, null, !1, !1, "", $3bd4deb882852edb$var$pl);
    a._reactRootContainer = k;
    a[$3bd4deb882852edb$var$uf] = k.current;
    $3bd4deb882852edb$var$sf(8 === a.nodeType ? a.parentNode : a);
    $3bd4deb882852edb$var$Rk(function() {
        $3bd4deb882852edb$var$fl(b, k, c, d);
    });
    return k;
}
function $3bd4deb882852edb$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $3bd4deb882852edb$var$gl(g);
                h.call(a);
            };
        }
        $3bd4deb882852edb$var$fl(b, g, a, e);
    } else g = $3bd4deb882852edb$var$ql(c, b, a, e, d);
    return $3bd4deb882852edb$var$gl(g);
}
$3bd4deb882852edb$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $3bd4deb882852edb$var$tc(b.pendingLanes);
                0 !== c && ($3bd4deb882852edb$var$Cc(b, c | 1), $3bd4deb882852edb$var$Dk(b, $3bd4deb882852edb$var$B()), 0 === ($3bd4deb882852edb$var$K & 6) && ($3bd4deb882852edb$var$Gj = $3bd4deb882852edb$var$B() + 500, $3bd4deb882852edb$var$jg()));
            }
            break;
        case 13:
            $3bd4deb882852edb$var$Rk(function() {
                var b = $3bd4deb882852edb$var$ih(a, 1);
                if (null !== b) {
                    var c = $3bd4deb882852edb$var$R();
                    $3bd4deb882852edb$var$gi(b, a, 1, c);
                }
            }), $3bd4deb882852edb$var$il(a, 1);
    }
};
$3bd4deb882852edb$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $3bd4deb882852edb$var$ih(a, 134217728);
        if (null !== b) {
            var c = $3bd4deb882852edb$var$R();
            $3bd4deb882852edb$var$gi(b, a, 134217728, c);
        }
        $3bd4deb882852edb$var$il(a, 134217728);
    }
};
$3bd4deb882852edb$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $3bd4deb882852edb$var$yi(a), c = $3bd4deb882852edb$var$ih(a, b);
        if (null !== c) {
            var d = $3bd4deb882852edb$var$R();
            $3bd4deb882852edb$var$gi(c, a, b, d);
        }
        $3bd4deb882852edb$var$il(a, b);
    }
};
$3bd4deb882852edb$var$Hc = function() {
    return $3bd4deb882852edb$var$C;
};
$3bd4deb882852edb$var$Ic = function(a, b) {
    var c = $3bd4deb882852edb$var$C;
    try {
        return $3bd4deb882852edb$var$C = a, b();
    } finally{
        $3bd4deb882852edb$var$C = c;
    }
};
$3bd4deb882852edb$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $3bd4deb882852edb$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $3bd4deb882852edb$var$Db(d);
                        if (!e) throw Error($3bd4deb882852edb$var$p(90));
                        $3bd4deb882852edb$var$Wa(d);
                        $3bd4deb882852edb$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $3bd4deb882852edb$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $3bd4deb882852edb$var$fb(a, !!c.multiple, b, !1);
    }
};
$3bd4deb882852edb$var$Gb = $3bd4deb882852edb$var$Qk;
$3bd4deb882852edb$var$Hb = $3bd4deb882852edb$var$Rk;
var $3bd4deb882852edb$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $3bd4deb882852edb$var$Cb,
        $3bd4deb882852edb$var$ue,
        $3bd4deb882852edb$var$Db,
        $3bd4deb882852edb$var$Eb,
        $3bd4deb882852edb$var$Fb,
        $3bd4deb882852edb$var$Qk
    ]
}, $3bd4deb882852edb$var$tl = {
    findFiberByHostInstance: $3bd4deb882852edb$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $3bd4deb882852edb$var$ul = {
    bundleType: $3bd4deb882852edb$var$tl.bundleType,
    version: $3bd4deb882852edb$var$tl.version,
    rendererPackageName: $3bd4deb882852edb$var$tl.rendererPackageName,
    rendererConfig: $3bd4deb882852edb$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $3bd4deb882852edb$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $3bd4deb882852edb$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $3bd4deb882852edb$var$tl.findFiberByHostInstance || $3bd4deb882852edb$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $3bd4deb882852edb$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$3bd4deb882852edb$var$vl.isDisabled && $3bd4deb882852edb$var$vl.supportsFiber) try {
        $3bd4deb882852edb$var$kc = $3bd4deb882852edb$var$vl.inject($3bd4deb882852edb$var$ul), $3bd4deb882852edb$var$lc = $3bd4deb882852edb$var$vl;
    } catch (a) {}
}
$3bd4deb882852edb$export$ae55be85d98224ed = $3bd4deb882852edb$var$sl;
$3bd4deb882852edb$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$3bd4deb882852edb$var$nl(b)) throw Error($3bd4deb882852edb$var$p(200));
    return $3bd4deb882852edb$var$cl(a, b, null, c);
};
$3bd4deb882852edb$export$882461b6382ed46c = function(a, b) {
    if (!$3bd4deb882852edb$var$nl(a)) throw Error($3bd4deb882852edb$var$p(299));
    var c = !1, d = "", e = $3bd4deb882852edb$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $3bd4deb882852edb$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$3bd4deb882852edb$var$uf] = b.current;
    $3bd4deb882852edb$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $3bd4deb882852edb$var$ll(b);
};
$3bd4deb882852edb$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($3bd4deb882852edb$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($3bd4deb882852edb$var$p(268, a));
    }
    a = $3bd4deb882852edb$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$3bd4deb882852edb$export$cd75ccfd720a3cd4 = function(a) {
    return $3bd4deb882852edb$var$Rk(a);
};
$3bd4deb882852edb$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$3bd4deb882852edb$var$ol(b)) throw Error($3bd4deb882852edb$var$p(200));
    return $3bd4deb882852edb$var$rl(null, a, b, !0, c);
};
$3bd4deb882852edb$export$757ceba2d55c277e = function(a, b, c) {
    if (!$3bd4deb882852edb$var$nl(a)) throw Error($3bd4deb882852edb$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $3bd4deb882852edb$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $3bd4deb882852edb$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$3bd4deb882852edb$var$uf] = b.current;
    $3bd4deb882852edb$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $3bd4deb882852edb$var$ml(b);
};
$3bd4deb882852edb$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$3bd4deb882852edb$var$ol(b)) throw Error($3bd4deb882852edb$var$p(200));
    return $3bd4deb882852edb$var$rl(null, a, b, !1, c);
};
$3bd4deb882852edb$export$502457920280e6be = function(a) {
    if (!$3bd4deb882852edb$var$ol(a)) throw Error($3bd4deb882852edb$var$p(40));
    return a._reactRootContainer ? ($3bd4deb882852edb$var$Rk(function() {
        $3bd4deb882852edb$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$3bd4deb882852edb$var$uf] = null;
        });
    }), !0) : !1;
};
$3bd4deb882852edb$export$c78a37762a8d58e1 = $3bd4deb882852edb$var$Qk;
$3bd4deb882852edb$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$3bd4deb882852edb$var$ol(c)) throw Error($3bd4deb882852edb$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($3bd4deb882852edb$var$p(38));
    return $3bd4deb882852edb$var$rl(a, b, c, !1, d);
};
$3bd4deb882852edb$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("euyry", function(module, exports) {
"use strict";

module.exports = (parcelRequire("89pGa"));

});
parcelRegister("89pGa", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $5ef315552d9018ed$export$c4744153514ff05d; }, function (v) { return $5ef315552d9018ed$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $5ef315552d9018ed$export$3e506c1ccc9cc1a7; }, function (v) { return $5ef315552d9018ed$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $5ef315552d9018ed$export$e26fe2ed2fa76875; }, function (v) { return $5ef315552d9018ed$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $5ef315552d9018ed$export$502329bbf4b505b1; }, function (v) { return $5ef315552d9018ed$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $5ef315552d9018ed$export$6e3807111c4874c4; }, function (v) { return $5ef315552d9018ed$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $5ef315552d9018ed$export$c27134553091fb3a; }, function (v) { return $5ef315552d9018ed$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $5ef315552d9018ed$export$33ee1acdc04fd2a2; }, function (v) { return $5ef315552d9018ed$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $5ef315552d9018ed$export$b00a404bbd5edef2; }, function (v) { return $5ef315552d9018ed$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $5ef315552d9018ed$export$8352ce38b91d0c62; }, function (v) { return $5ef315552d9018ed$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $5ef315552d9018ed$export$d66a1c1c77bd778b; }, function (v) { return $5ef315552d9018ed$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $5ef315552d9018ed$export$d3dfb8e4810cb555; }, function (v) { return $5ef315552d9018ed$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $5ef315552d9018ed$export$839f9183b0465a69; }, function (v) { return $5ef315552d9018ed$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $5ef315552d9018ed$export$72fdf0e06517287b; }, function (v) { return $5ef315552d9018ed$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $5ef315552d9018ed$export$4b844e58a3e414b4; }, function (v) { return $5ef315552d9018ed$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $5ef315552d9018ed$export$816d2913ae6b83b1; }, function (v) { return $5ef315552d9018ed$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $5ef315552d9018ed$export$61bcfe829111a1d0; }, function (v) { return $5ef315552d9018ed$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $5ef315552d9018ed$export$7ee8c9beb337bc3f; }, function (v) { return $5ef315552d9018ed$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $5ef315552d9018ed$export$b5836b71941fa3ed; }, function (v) { return $5ef315552d9018ed$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $5ef315552d9018ed$export$cf845f2c119da08a; }, function (v) { return $5ef315552d9018ed$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $5ef315552d9018ed$export$c4744153514ff05d;
var $5ef315552d9018ed$export$3e506c1ccc9cc1a7;
var $5ef315552d9018ed$export$e26fe2ed2fa76875;
var $5ef315552d9018ed$export$502329bbf4b505b1;
var $5ef315552d9018ed$export$6e3807111c4874c4;
var $5ef315552d9018ed$export$c27134553091fb3a;
var $5ef315552d9018ed$export$33ee1acdc04fd2a2;
var $5ef315552d9018ed$export$b00a404bbd5edef2;
var $5ef315552d9018ed$export$8352ce38b91d0c62;
var $5ef315552d9018ed$export$d66a1c1c77bd778b;
var $5ef315552d9018ed$export$d3dfb8e4810cb555;
var $5ef315552d9018ed$export$839f9183b0465a69;
var $5ef315552d9018ed$export$72fdf0e06517287b;
var $5ef315552d9018ed$export$4b844e58a3e414b4;
var $5ef315552d9018ed$export$816d2913ae6b83b1;
var $5ef315552d9018ed$export$61bcfe829111a1d0;
var $5ef315552d9018ed$export$7ee8c9beb337bc3f;
var $5ef315552d9018ed$export$b5836b71941fa3ed;
var $5ef315552d9018ed$export$cf845f2c119da08a;
"use strict";
function $5ef315552d9018ed$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $5ef315552d9018ed$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $5ef315552d9018ed$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $5ef315552d9018ed$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $5ef315552d9018ed$var$g(C, c)) n < e && 0 > $5ef315552d9018ed$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $5ef315552d9018ed$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $5ef315552d9018ed$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $5ef315552d9018ed$var$l = performance;
    $5ef315552d9018ed$export$c4744153514ff05d = function() {
        return $5ef315552d9018ed$var$l.now();
    };
} else {
    var $5ef315552d9018ed$var$p = Date, $5ef315552d9018ed$var$q = $5ef315552d9018ed$var$p.now();
    $5ef315552d9018ed$export$c4744153514ff05d = function() {
        return $5ef315552d9018ed$var$p.now() - $5ef315552d9018ed$var$q;
    };
}
var $5ef315552d9018ed$var$r = [], $5ef315552d9018ed$var$t = [], $5ef315552d9018ed$var$u = 1, $5ef315552d9018ed$var$v = null, $5ef315552d9018ed$var$y = 3, $5ef315552d9018ed$var$z = !1, $5ef315552d9018ed$var$A = !1, $5ef315552d9018ed$var$B = !1, $5ef315552d9018ed$var$D = "function" === typeof setTimeout ? setTimeout : null, $5ef315552d9018ed$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $5ef315552d9018ed$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $5ef315552d9018ed$var$G(a) {
    for(var b = $5ef315552d9018ed$var$h($5ef315552d9018ed$var$t); null !== b;){
        if (null === b.callback) $5ef315552d9018ed$var$k($5ef315552d9018ed$var$t);
        else if (b.startTime <= a) $5ef315552d9018ed$var$k($5ef315552d9018ed$var$t), b.sortIndex = b.expirationTime, $5ef315552d9018ed$var$f($5ef315552d9018ed$var$r, b);
        else break;
        b = $5ef315552d9018ed$var$h($5ef315552d9018ed$var$t);
    }
}
function $5ef315552d9018ed$var$H(a) {
    $5ef315552d9018ed$var$B = !1;
    $5ef315552d9018ed$var$G(a);
    if (!$5ef315552d9018ed$var$A) {
        if (null !== $5ef315552d9018ed$var$h($5ef315552d9018ed$var$r)) $5ef315552d9018ed$var$A = !0, $5ef315552d9018ed$var$I($5ef315552d9018ed$var$J);
        else {
            var b = $5ef315552d9018ed$var$h($5ef315552d9018ed$var$t);
            null !== b && $5ef315552d9018ed$var$K($5ef315552d9018ed$var$H, b.startTime - a);
        }
    }
}
function $5ef315552d9018ed$var$J(a, b) {
    $5ef315552d9018ed$var$A = !1;
    $5ef315552d9018ed$var$B && ($5ef315552d9018ed$var$B = !1, $5ef315552d9018ed$var$E($5ef315552d9018ed$var$L), $5ef315552d9018ed$var$L = -1);
    $5ef315552d9018ed$var$z = !0;
    var c = $5ef315552d9018ed$var$y;
    try {
        $5ef315552d9018ed$var$G(b);
        for($5ef315552d9018ed$var$v = $5ef315552d9018ed$var$h($5ef315552d9018ed$var$r); null !== $5ef315552d9018ed$var$v && (!($5ef315552d9018ed$var$v.expirationTime > b) || a && !$5ef315552d9018ed$var$M());){
            var d = $5ef315552d9018ed$var$v.callback;
            if ("function" === typeof d) {
                $5ef315552d9018ed$var$v.callback = null;
                $5ef315552d9018ed$var$y = $5ef315552d9018ed$var$v.priorityLevel;
                var e = d($5ef315552d9018ed$var$v.expirationTime <= b);
                b = $5ef315552d9018ed$export$c4744153514ff05d();
                "function" === typeof e ? $5ef315552d9018ed$var$v.callback = e : $5ef315552d9018ed$var$v === $5ef315552d9018ed$var$h($5ef315552d9018ed$var$r) && $5ef315552d9018ed$var$k($5ef315552d9018ed$var$r);
                $5ef315552d9018ed$var$G(b);
            } else $5ef315552d9018ed$var$k($5ef315552d9018ed$var$r);
            $5ef315552d9018ed$var$v = $5ef315552d9018ed$var$h($5ef315552d9018ed$var$r);
        }
        if (null !== $5ef315552d9018ed$var$v) var w = !0;
        else {
            var m = $5ef315552d9018ed$var$h($5ef315552d9018ed$var$t);
            null !== m && $5ef315552d9018ed$var$K($5ef315552d9018ed$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $5ef315552d9018ed$var$v = null, $5ef315552d9018ed$var$y = c, $5ef315552d9018ed$var$z = !1;
    }
}
var $5ef315552d9018ed$var$N = !1, $5ef315552d9018ed$var$O = null, $5ef315552d9018ed$var$L = -1, $5ef315552d9018ed$var$P = 5, $5ef315552d9018ed$var$Q = -1;
function $5ef315552d9018ed$var$M() {
    return $5ef315552d9018ed$export$c4744153514ff05d() - $5ef315552d9018ed$var$Q < $5ef315552d9018ed$var$P ? !1 : !0;
}
function $5ef315552d9018ed$var$R() {
    if (null !== $5ef315552d9018ed$var$O) {
        var a = $5ef315552d9018ed$export$c4744153514ff05d();
        $5ef315552d9018ed$var$Q = a;
        var b = !0;
        try {
            b = $5ef315552d9018ed$var$O(!0, a);
        } finally{
            b ? $5ef315552d9018ed$var$S() : ($5ef315552d9018ed$var$N = !1, $5ef315552d9018ed$var$O = null);
        }
    } else $5ef315552d9018ed$var$N = !1;
}
var $5ef315552d9018ed$var$S;
if ("function" === typeof $5ef315552d9018ed$var$F) $5ef315552d9018ed$var$S = function() {
    $5ef315552d9018ed$var$F($5ef315552d9018ed$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $5ef315552d9018ed$var$T = new MessageChannel, $5ef315552d9018ed$var$U = $5ef315552d9018ed$var$T.port2;
    $5ef315552d9018ed$var$T.port1.onmessage = $5ef315552d9018ed$var$R;
    $5ef315552d9018ed$var$S = function() {
        $5ef315552d9018ed$var$U.postMessage(null);
    };
} else $5ef315552d9018ed$var$S = function() {
    $5ef315552d9018ed$var$D($5ef315552d9018ed$var$R, 0);
};
function $5ef315552d9018ed$var$I(a) {
    $5ef315552d9018ed$var$O = a;
    $5ef315552d9018ed$var$N || ($5ef315552d9018ed$var$N = !0, $5ef315552d9018ed$var$S());
}
function $5ef315552d9018ed$var$K(a, b) {
    $5ef315552d9018ed$var$L = $5ef315552d9018ed$var$D(function() {
        a($5ef315552d9018ed$export$c4744153514ff05d());
    }, b);
}
$5ef315552d9018ed$export$3e506c1ccc9cc1a7 = 5;
$5ef315552d9018ed$export$e26fe2ed2fa76875 = 1;
$5ef315552d9018ed$export$502329bbf4b505b1 = 4;
$5ef315552d9018ed$export$6e3807111c4874c4 = 3;
$5ef315552d9018ed$export$c27134553091fb3a = null;
$5ef315552d9018ed$export$33ee1acdc04fd2a2 = 2;
$5ef315552d9018ed$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$5ef315552d9018ed$export$8352ce38b91d0c62 = function() {
    $5ef315552d9018ed$var$A || $5ef315552d9018ed$var$z || ($5ef315552d9018ed$var$A = !0, $5ef315552d9018ed$var$I($5ef315552d9018ed$var$J));
};
$5ef315552d9018ed$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $5ef315552d9018ed$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$5ef315552d9018ed$export$d3dfb8e4810cb555 = function() {
    return $5ef315552d9018ed$var$y;
};
$5ef315552d9018ed$export$839f9183b0465a69 = function() {
    return $5ef315552d9018ed$var$h($5ef315552d9018ed$var$r);
};
$5ef315552d9018ed$export$72fdf0e06517287b = function(a) {
    switch($5ef315552d9018ed$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $5ef315552d9018ed$var$y;
    }
    var c = $5ef315552d9018ed$var$y;
    $5ef315552d9018ed$var$y = b;
    try {
        return a();
    } finally{
        $5ef315552d9018ed$var$y = c;
    }
};
$5ef315552d9018ed$export$4b844e58a3e414b4 = function() {};
$5ef315552d9018ed$export$816d2913ae6b83b1 = function() {};
$5ef315552d9018ed$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $5ef315552d9018ed$var$y;
    $5ef315552d9018ed$var$y = a;
    try {
        return b();
    } finally{
        $5ef315552d9018ed$var$y = c;
    }
};
$5ef315552d9018ed$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $5ef315552d9018ed$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $5ef315552d9018ed$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $5ef315552d9018ed$var$f($5ef315552d9018ed$var$t, a), null === $5ef315552d9018ed$var$h($5ef315552d9018ed$var$r) && a === $5ef315552d9018ed$var$h($5ef315552d9018ed$var$t) && ($5ef315552d9018ed$var$B ? ($5ef315552d9018ed$var$E($5ef315552d9018ed$var$L), $5ef315552d9018ed$var$L = -1) : $5ef315552d9018ed$var$B = !0, $5ef315552d9018ed$var$K($5ef315552d9018ed$var$H, c - d))) : (a.sortIndex = e, $5ef315552d9018ed$var$f($5ef315552d9018ed$var$r, a), $5ef315552d9018ed$var$A || $5ef315552d9018ed$var$z || ($5ef315552d9018ed$var$A = !0, $5ef315552d9018ed$var$I($5ef315552d9018ed$var$J)));
    return a;
};
$5ef315552d9018ed$export$b5836b71941fa3ed = $5ef315552d9018ed$var$M;
$5ef315552d9018ed$export$cf845f2c119da08a = function(a) {
    var b = $5ef315552d9018ed$var$y;
    return function() {
        var c = $5ef315552d9018ed$var$y;
        $5ef315552d9018ed$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $5ef315552d9018ed$var$y = c;
        }
    };
};

});



parcelRegister("jAXlF", function(module, exports) {
/**
 * @license React
 * react-reconciler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 

module.exports = function $$$reconciler($$$hostConfig) {
    var exports = {};
    "use strict";
    var aa = (parcelRequire("69Mlo")), ba = (parcelRequire("euyry")), ca = Object.assign;
    function n(a) {
        for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
        return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
    }
    var da = aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, ea = Symbol.for("react.element"), fa = Symbol.for("react.portal"), ha = Symbol.for("react.fragment"), ia = Symbol.for("react.strict_mode"), ja = Symbol.for("react.profiler"), ka = Symbol.for("react.provider"), la = Symbol.for("react.context"), ma = Symbol.for("react.forward_ref"), na = Symbol.for("react.suspense"), oa = Symbol.for("react.suspense_list"), pa = Symbol.for("react.memo"), qa = Symbol.for("react.lazy");
    Symbol.for("react.scope");
    Symbol.for("react.debug_trace_mode");
    var ra = Symbol.for("react.offscreen");
    Symbol.for("react.legacy_hidden");
    Symbol.for("react.cache");
    Symbol.for("react.tracing_marker");
    var sa = Symbol.iterator;
    function ta(a) {
        if (null === a || "object" !== typeof a) return null;
        a = sa && a[sa] || a["@@iterator"];
        return "function" === typeof a ? a : null;
    }
    function ua(a) {
        if (null == a) return null;
        if ("function" === typeof a) return a.displayName || a.name || null;
        if ("string" === typeof a) return a;
        switch(a){
            case ha:
                return "Fragment";
            case fa:
                return "Portal";
            case ja:
                return "Profiler";
            case ia:
                return "StrictMode";
            case na:
                return "Suspense";
            case oa:
                return "SuspenseList";
        }
        if ("object" === typeof a) switch(a.$$typeof){
            case la:
                return (a.displayName || "Context") + ".Consumer";
            case ka:
                return (a._context.displayName || "Context") + ".Provider";
            case ma:
                var b = a.render;
                a = a.displayName;
                a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
                return a;
            case pa:
                return b = a.displayName || null, null !== b ? b : ua(a.type) || "Memo";
            case qa:
                b = a._payload;
                a = a._init;
                try {
                    return ua(a(b));
                } catch (c) {}
        }
        return null;
    }
    function va(a) {
        var b = a.type;
        switch(a.tag){
            case 24:
                return "Cache";
            case 9:
                return (b.displayName || "Context") + ".Consumer";
            case 10:
                return (b._context.displayName || "Context") + ".Provider";
            case 18:
                return "DehydratedFragment";
            case 11:
                return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            case 7:
                return "Fragment";
            case 5:
                return b;
            case 4:
                return "Portal";
            case 3:
                return "Root";
            case 6:
                return "Text";
            case 16:
                return ua(b);
            case 8:
                return b === ia ? "StrictMode" : "Mode";
            case 22:
                return "Offscreen";
            case 12:
                return "Profiler";
            case 21:
                return "Scope";
            case 13:
                return "Suspense";
            case 19:
                return "SuspenseList";
            case 25:
                return "TracingMarker";
            case 1:
            case 0:
            case 17:
            case 2:
            case 14:
            case 15:
                if ("function" === typeof b) return b.displayName || b.name || null;
                if ("string" === typeof b) return b;
        }
        return null;
    }
    function wa(a) {
        var b = a, c = a;
        if (a.alternate) for(; b.return;)b = b.return;
        else {
            a = b;
            do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
            while (a);
        }
        return 3 === b.tag ? c : null;
    }
    function xa(a) {
        if (wa(a) !== a) throw Error(n(188));
    }
    function za(a) {
        var b = a.alternate;
        if (!b) {
            b = wa(a);
            if (null === b) throw Error(n(188));
            return b !== a ? null : a;
        }
        for(var c = a, d = b;;){
            var e = c.return;
            if (null === e) break;
            var f = e.alternate;
            if (null === f) {
                d = e.return;
                if (null !== d) {
                    c = d;
                    continue;
                }
                break;
            }
            if (e.child === f.child) {
                for(f = e.child; f;){
                    if (f === c) return xa(e), a;
                    if (f === d) return xa(e), b;
                    f = f.sibling;
                }
                throw Error(n(188));
            }
            if (c.return !== d.return) c = e, d = f;
            else {
                for(var g = !1, h = e.child; h;){
                    if (h === c) {
                        g = !0;
                        c = e;
                        d = f;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = e;
                        c = f;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) {
                    for(h = f.child; h;){
                        if (h === c) {
                            g = !0;
                            c = f;
                            d = e;
                            break;
                        }
                        if (h === d) {
                            g = !0;
                            d = f;
                            c = e;
                            break;
                        }
                        h = h.sibling;
                    }
                    if (!g) throw Error(n(189));
                }
            }
            if (c.alternate !== d) throw Error(n(190));
        }
        if (3 !== c.tag) throw Error(n(188));
        return c.stateNode.current === c ? a : b;
    }
    function Aa(a) {
        a = za(a);
        return null !== a ? Ba(a) : null;
    }
    function Ba(a) {
        if (5 === a.tag || 6 === a.tag) return a;
        for(a = a.child; null !== a;){
            var b = Ba(a);
            if (null !== b) return b;
            a = a.sibling;
        }
        return null;
    }
    function Ca(a) {
        if (5 === a.tag || 6 === a.tag) return a;
        for(a = a.child; null !== a;){
            if (4 !== a.tag) {
                var b = Ca(a);
                if (null !== b) return b;
            }
            a = a.sibling;
        }
        return null;
    }
    var Da = Array.isArray, Ea = $$$hostConfig.getPublicInstance, Fa = $$$hostConfig.getRootHostContext, Ga = $$$hostConfig.getChildHostContext, Ha = $$$hostConfig.prepareForCommit, Ia = $$$hostConfig.resetAfterCommit, Ja = $$$hostConfig.createInstance, Ka = $$$hostConfig.appendInitialChild, La = $$$hostConfig.finalizeInitialChildren, Ma = $$$hostConfig.prepareUpdate, Na = $$$hostConfig.shouldSetTextContent, Oa = $$$hostConfig.createTextInstance, Pa = $$$hostConfig.scheduleTimeout, Qa = $$$hostConfig.cancelTimeout, Ra = $$$hostConfig.noTimeout, Sa = $$$hostConfig.isPrimaryRenderer, Ta = $$$hostConfig.supportsMutation, Ua = $$$hostConfig.supportsPersistence, Va = $$$hostConfig.supportsHydration, Wa = $$$hostConfig.getInstanceFromNode, Xa = $$$hostConfig.preparePortalMount, Ya = $$$hostConfig.getCurrentEventPriority, Za = $$$hostConfig.detachDeletedInstance, $a = $$$hostConfig.supportsMicrotasks, ab = $$$hostConfig.scheduleMicrotask, bb = $$$hostConfig.supportsTestSelectors, cb = $$$hostConfig.findFiberRoot, db = $$$hostConfig.getBoundingRect, eb = $$$hostConfig.getTextContent, fb = $$$hostConfig.isHiddenSubtree, gb = $$$hostConfig.matchAccessibilityRole, hb = $$$hostConfig.setFocusIfFocusable, ib = $$$hostConfig.setupIntersectionObserver, jb = $$$hostConfig.appendChild, kb = $$$hostConfig.appendChildToContainer, lb = $$$hostConfig.commitTextUpdate, mb = $$$hostConfig.commitMount, nb = $$$hostConfig.commitUpdate, ob = $$$hostConfig.insertBefore, pb = $$$hostConfig.insertInContainerBefore, qb = $$$hostConfig.removeChild, rb = $$$hostConfig.removeChildFromContainer, sb = $$$hostConfig.resetTextContent, tb = $$$hostConfig.hideInstance, ub = $$$hostConfig.hideTextInstance, vb = $$$hostConfig.unhideInstance, wb = $$$hostConfig.unhideTextInstance, xb = $$$hostConfig.clearContainer, yb = $$$hostConfig.cloneInstance, zb = $$$hostConfig.createContainerChildSet, Ab = $$$hostConfig.appendChildToContainerChildSet, Bb = $$$hostConfig.finalizeContainerChildren, Cb = $$$hostConfig.replaceContainerChildren, Eb = $$$hostConfig.cloneHiddenInstance, Fb = $$$hostConfig.cloneHiddenTextInstance, Gb = $$$hostConfig.canHydrateInstance, Hb = $$$hostConfig.canHydrateTextInstance, Ib = $$$hostConfig.canHydrateSuspenseInstance, Jb = $$$hostConfig.isSuspenseInstancePending, Kb = $$$hostConfig.isSuspenseInstanceFallback, Lb = $$$hostConfig.getSuspenseInstanceFallbackErrorDetails, Mb = $$$hostConfig.registerSuspenseInstanceRetry, Nb = $$$hostConfig.getNextHydratableSibling, Ob = $$$hostConfig.getFirstHydratableChild, Pb = $$$hostConfig.getFirstHydratableChildWithinContainer, Qb = $$$hostConfig.getFirstHydratableChildWithinSuspenseInstance, Rb = $$$hostConfig.hydrateInstance, Sb = $$$hostConfig.hydrateTextInstance, Tb = $$$hostConfig.hydrateSuspenseInstance, Ub = $$$hostConfig.getNextHydratableInstanceAfterSuspenseInstance, Vb = $$$hostConfig.commitHydratedContainer, Wb = $$$hostConfig.commitHydratedSuspenseInstance, Xb = $$$hostConfig.clearSuspenseBoundary, Yb = $$$hostConfig.clearSuspenseBoundaryFromContainer, Zb = $$$hostConfig.shouldDeleteUnhydratedTailInstances, $b = $$$hostConfig.didNotMatchHydratedContainerTextInstance, ac = $$$hostConfig.didNotMatchHydratedTextInstance, bc;
    function cc(a) {
        if (void 0 === bc) try {
            throw Error();
        } catch (c) {
            var b = c.stack.trim().match(/\n( *(at )?)/);
            bc = b && b[1] || "";
        }
        return "\n" + bc + a;
    }
    var dc = !1;
    function ec(a, b) {
        if (!a || dc) return "";
        dc = !0;
        var c = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        try {
            if (b) {
                if (b = function() {
                    throw Error();
                }, Object.defineProperty(b.prototype, "props", {
                    set: function() {
                        throw Error();
                    }
                }), "object" === typeof Reflect && Reflect.construct) {
                    try {
                        Reflect.construct(b, []);
                    } catch (l) {
                        var d = l;
                    }
                    Reflect.construct(a, [], b);
                } else {
                    try {
                        b.call();
                    } catch (l) {
                        d = l;
                    }
                    a.call(b.prototype);
                }
            } else {
                try {
                    throw Error();
                } catch (l) {
                    d = l;
                }
                a();
            }
        } catch (l) {
            if (l && d && "string" === typeof l.stack) {
                for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
                for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                    if (1 !== g || 1 !== h) {
                        do if (g--, h--, 0 > h || e[g] !== f[h]) {
                            var k = "\n" + e[g].replace(" at new ", " at ");
                            a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                            return k;
                        }
                        while (1 <= g && 0 <= h);
                    }
                    break;
                }
            }
        } finally{
            dc = !1, Error.prepareStackTrace = c;
        }
        return (a = a ? a.displayName || a.name : "") ? cc(a) : "";
    }
    var fc = Object.prototype.hasOwnProperty, gc = [], hc = -1;
    function ic(a) {
        return {
            current: a
        };
    }
    function q(a) {
        0 > hc || (a.current = gc[hc], gc[hc] = null, hc--);
    }
    function v(a, b) {
        hc++;
        gc[hc] = a.current;
        a.current = b;
    }
    var jc = {}, x = ic(jc), z = ic(!1), kc = jc;
    function mc(a, b) {
        var c = a.type.contextTypes;
        if (!c) return jc;
        var d = a.stateNode;
        if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
        var e = {}, f;
        for(f in c)e[f] = b[f];
        d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
        return e;
    }
    function A(a) {
        a = a.childContextTypes;
        return null !== a && void 0 !== a;
    }
    function nc() {
        q(z);
        q(x);
    }
    function oc(a, b, c) {
        if (x.current !== jc) throw Error(n(168));
        v(x, b);
        v(z, c);
    }
    function pc(a, b, c) {
        var d = a.stateNode;
        b = b.childContextTypes;
        if ("function" !== typeof d.getChildContext) return c;
        d = d.getChildContext();
        for(var e in d)if (!(e in b)) throw Error(n(108, va(a) || "Unknown", e));
        return ca({}, c, d);
    }
    function qc(a) {
        a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || jc;
        kc = x.current;
        v(x, a);
        v(z, z.current);
        return !0;
    }
    function rc(a, b, c) {
        var d = a.stateNode;
        if (!d) throw Error(n(169));
        c ? (a = pc(a, b, kc), d.__reactInternalMemoizedMergedChildContext = a, q(z), q(x), v(x, a)) : q(z);
        v(z, c);
    }
    var tc = Math.clz32 ? Math.clz32 : sc, uc = Math.log, vc = Math.LN2;
    function sc(a) {
        a >>>= 0;
        return 0 === a ? 32 : 31 - (uc(a) / vc | 0) | 0;
    }
    var wc = 64, xc = 4194304;
    function yc(a) {
        switch(a & -a){
            case 1:
                return 1;
            case 2:
                return 2;
            case 4:
                return 4;
            case 8:
                return 8;
            case 16:
                return 16;
            case 32:
                return 32;
            case 64:
            case 128:
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
                return a & 4194240;
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
            case 67108864:
                return a & 130023424;
            case 134217728:
                return 134217728;
            case 268435456:
                return 268435456;
            case 536870912:
                return 536870912;
            case 1073741824:
                return 1073741824;
            default:
                return a;
        }
    }
    function zc(a, b) {
        var c = a.pendingLanes;
        if (0 === c) return 0;
        var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
        if (0 !== g) {
            var h = g & ~e;
            0 !== h ? d = yc(h) : (f &= g, 0 !== f && (d = yc(f)));
        } else g = c & ~e, 0 !== g ? d = yc(g) : 0 !== f && (d = yc(f));
        if (0 === d) return 0;
        if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
        0 !== (d & 4) && (d |= c & 16);
        b = a.entangledLanes;
        if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - tc(b), e = 1 << c, d |= a[c], b &= ~e;
        return d;
    }
    function Ac(a, b) {
        switch(a){
            case 1:
            case 2:
            case 4:
                return b + 250;
            case 8:
            case 16:
            case 32:
            case 64:
            case 128:
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
                return b + 5E3;
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
            case 67108864:
                return -1;
            case 134217728:
            case 268435456:
            case 536870912:
            case 1073741824:
                return -1;
            default:
                return -1;
        }
    }
    function Bc(a, b) {
        for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
            var g = 31 - tc(f), h = 1 << g, k = e[g];
            if (-1 === k) {
                if (0 === (h & c) || 0 !== (h & d)) e[g] = Ac(h, b);
            } else k <= b && (a.expiredLanes |= h);
            f &= ~h;
        }
    }
    function Cc(a) {
        a = a.pendingLanes & -1073741825;
        return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
    }
    function Dc() {
        var a = wc;
        wc <<= 1;
        0 === (wc & 4194240) && (wc = 64);
        return a;
    }
    function Ec(a) {
        for(var b = [], c = 0; 31 > c; c++)b.push(a);
        return b;
    }
    function Fc(a, b, c) {
        a.pendingLanes |= b;
        536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
        a = a.eventTimes;
        b = 31 - tc(b);
        a[b] = c;
    }
    function Gc(a, b) {
        var c = a.pendingLanes & ~b;
        a.pendingLanes = b;
        a.suspendedLanes = 0;
        a.pingedLanes = 0;
        a.expiredLanes &= b;
        a.mutableReadLanes &= b;
        a.entangledLanes &= b;
        b = a.entanglements;
        var d = a.eventTimes;
        for(a = a.expirationTimes; 0 < c;){
            var e = 31 - tc(c), f = 1 << e;
            b[e] = 0;
            d[e] = -1;
            a[e] = -1;
            c &= ~f;
        }
    }
    function Hc(a, b) {
        var c = a.entangledLanes |= b;
        for(a = a.entanglements; c;){
            var d = 31 - tc(c), e = 1 << d;
            e & b | a[d] & b && (a[d] |= b);
            c &= ~e;
        }
    }
    var C = 0;
    function Ic(a) {
        a &= -a;
        return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
    }
    var Jc = ba.unstable_scheduleCallback, Kc = ba.unstable_cancelCallback, Lc = ba.unstable_shouldYield, Mc = ba.unstable_requestPaint, D = ba.unstable_now, Nc = ba.unstable_ImmediatePriority, Oc = ba.unstable_UserBlockingPriority, Pc = ba.unstable_NormalPriority, Qc = ba.unstable_IdlePriority, Rc = null, Sc = null;
    function Tc(a) {
        if (Sc && "function" === typeof Sc.onCommitFiberRoot) try {
            Sc.onCommitFiberRoot(Rc, a, void 0, 128 === (a.current.flags & 128));
        } catch (b) {}
    }
    function Uc(a, b) {
        return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
    }
    var Vc = "function" === typeof Object.is ? Object.is : Uc, Wc = null, Xc = !1, Yc = !1;
    function Zc(a) {
        null === Wc ? Wc = [
            a
        ] : Wc.push(a);
    }
    function $c(a) {
        Xc = !0;
        Zc(a);
    }
    function ad() {
        if (!Yc && null !== Wc) {
            Yc = !0;
            var a = 0, b = C;
            try {
                var c = Wc;
                for(C = 1; a < c.length; a++){
                    var d = c[a];
                    do d = d(!0);
                    while (null !== d);
                }
                Wc = null;
                Xc = !1;
            } catch (e) {
                throw null !== Wc && (Wc = Wc.slice(a + 1)), Jc(Nc, ad), e;
            } finally{
                C = b, Yc = !1;
            }
        }
        return null;
    }
    var bd = [], cd = 0, dd = null, ed = 0, fd = [], gd = 0, hd = null, id = 1, jd = "";
    function kd(a, b) {
        bd[cd++] = ed;
        bd[cd++] = dd;
        dd = a;
        ed = b;
    }
    function ld(a, b, c) {
        fd[gd++] = id;
        fd[gd++] = jd;
        fd[gd++] = hd;
        hd = a;
        var d = id;
        a = jd;
        var e = 32 - tc(d) - 1;
        d &= ~(1 << e);
        c += 1;
        var f = 32 - tc(b) + e;
        if (30 < f) {
            var g = e - e % 5;
            f = (d & (1 << g) - 1).toString(32);
            d >>= g;
            e -= g;
            id = 1 << 32 - tc(b) + e | c << e | d;
            jd = f + a;
        } else id = 1 << f | c << e | d, jd = a;
    }
    function md(a) {
        null !== a.return && (kd(a, 1), ld(a, 1, 0));
    }
    function nd(a) {
        for(; a === dd;)dd = bd[--cd], bd[cd] = null, ed = bd[--cd], bd[cd] = null;
        for(; a === hd;)hd = fd[--gd], fd[gd] = null, jd = fd[--gd], fd[gd] = null, id = fd[--gd], fd[gd] = null;
    }
    var od = null, pd = null, F = !1, qd = !1, rd = null;
    function sd(a, b) {
        var c = td(5, null, null, 0);
        c.elementType = "DELETED";
        c.stateNode = b;
        c.return = a;
        b = a.deletions;
        null === b ? (a.deletions = [
            c
        ], a.flags |= 16) : b.push(c);
    }
    function ud(a, b) {
        switch(a.tag){
            case 5:
                return b = Gb(b, a.type, a.pendingProps), null !== b ? (a.stateNode = b, od = a, pd = Ob(b), !0) : !1;
            case 6:
                return b = Hb(b, a.pendingProps), null !== b ? (a.stateNode = b, od = a, pd = null, !0) : !1;
            case 13:
                b = Ib(b);
                if (null !== b) {
                    var c = null !== hd ? {
                        id: id,
                        overflow: jd
                    } : null;
                    a.memoizedState = {
                        dehydrated: b,
                        treeContext: c,
                        retryLane: 1073741824
                    };
                    c = td(18, null, null, 0);
                    c.stateNode = b;
                    c.return = a;
                    a.child = c;
                    od = a;
                    pd = null;
                    return !0;
                }
                return !1;
            default:
                return !1;
        }
    }
    function vd(a) {
        return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
    }
    function wd(a) {
        if (F) {
            var b = pd;
            if (b) {
                var c = b;
                if (!ud(a, b)) {
                    if (vd(a)) throw Error(n(418));
                    b = Nb(c);
                    var d = od;
                    b && ud(a, b) ? sd(d, c) : (a.flags = a.flags & -4097 | 2, F = !1, od = a);
                }
            } else {
                if (vd(a)) throw Error(n(418));
                a.flags = a.flags & -4097 | 2;
                F = !1;
                od = a;
            }
        }
    }
    function xd(a) {
        for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
        od = a;
    }
    function yd(a) {
        if (!Va || a !== od) return !1;
        if (!F) return xd(a), F = !0, !1;
        if (3 !== a.tag && (5 !== a.tag || Zb(a.type) && !Na(a.type, a.memoizedProps))) {
            var b = pd;
            if (b) {
                if (vd(a)) throw zd(), Error(n(418));
                for(; b;)sd(a, b), b = Nb(b);
            }
        }
        xd(a);
        if (13 === a.tag) {
            if (!Va) throw Error(n(316));
            a = a.memoizedState;
            a = null !== a ? a.dehydrated : null;
            if (!a) throw Error(n(317));
            pd = Ub(a);
        } else pd = od ? Nb(a.stateNode) : null;
        return !0;
    }
    function zd() {
        for(var a = pd; a;)a = Nb(a);
    }
    function Ad() {
        Va && (pd = od = null, qd = F = !1);
    }
    function Bd(a) {
        null === rd ? rd = [
            a
        ] : rd.push(a);
    }
    var Cd = da.ReactCurrentBatchConfig;
    function Dd(a, b) {
        if (Vc(a, b)) return !0;
        if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
        var c = Object.keys(a), d = Object.keys(b);
        if (c.length !== d.length) return !1;
        for(d = 0; d < c.length; d++){
            var e = c[d];
            if (!fc.call(b, e) || !Vc(a[e], b[e])) return !1;
        }
        return !0;
    }
    function Ed(a) {
        switch(a.tag){
            case 5:
                return cc(a.type);
            case 16:
                return cc("Lazy");
            case 13:
                return cc("Suspense");
            case 19:
                return cc("SuspenseList");
            case 0:
            case 2:
            case 15:
                return a = ec(a.type, !1), a;
            case 11:
                return a = ec(a.type.render, !1), a;
            case 1:
                return a = ec(a.type, !0), a;
            default:
                return "";
        }
    }
    function Fd(a, b, c) {
        a = c.ref;
        if (null !== a && "function" !== typeof a && "object" !== typeof a) {
            if (c._owner) {
                c = c._owner;
                if (c) {
                    if (1 !== c.tag) throw Error(n(309));
                    var d = c.stateNode;
                }
                if (!d) throw Error(n(147, a));
                var e = d, f = "" + a;
                if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
                b = function(a) {
                    var b = e.refs;
                    null === a ? delete b[f] : b[f] = a;
                };
                b._stringRef = f;
                return b;
            }
            if ("string" !== typeof a) throw Error(n(284));
            if (!c._owner) throw Error(n(290, a));
        }
        return a;
    }
    function Gd(a, b) {
        a = Object.prototype.toString.call(b);
        throw Error(n(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
    }
    function Hd(a) {
        var b = a._init;
        return b(a._payload);
    }
    function Id(a) {
        function b(b, c) {
            if (a) {
                var d = b.deletions;
                null === d ? (b.deletions = [
                    c
                ], b.flags |= 16) : d.push(c);
            }
        }
        function c(c, d) {
            if (!a) return null;
            for(; null !== d;)b(c, d), d = d.sibling;
            return null;
        }
        function d(a, b) {
            for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
            return a;
        }
        function e(a, b) {
            a = Jd(a, b);
            a.index = 0;
            a.sibling = null;
            return a;
        }
        function f(b, c, d) {
            b.index = d;
            if (!a) return b.flags |= 1048576, c;
            d = b.alternate;
            if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
            b.flags |= 2;
            return c;
        }
        function g(b) {
            a && null === b.alternate && (b.flags |= 2);
            return b;
        }
        function h(a, b, c, d) {
            if (null === b || 6 !== b.tag) return b = Kd(c, a.mode, d), b.return = a, b;
            b = e(b, c);
            b.return = a;
            return b;
        }
        function k(a, b, c, d) {
            var f = c.type;
            if (f === ha) return m(a, b, c.props.children, d, c.key);
            if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === qa && Hd(f) === b.type)) return d = e(b, c.props), d.ref = Fd(a, b, c), d.return = a, d;
            d = Ld(c.type, c.key, c.props, null, a.mode, d);
            d.ref = Fd(a, b, c);
            d.return = a;
            return d;
        }
        function l(a, b, c, d) {
            if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Md(c, a.mode, d), b.return = a, b;
            b = e(b, c.children || []);
            b.return = a;
            return b;
        }
        function m(a, b, c, d, f) {
            if (null === b || 7 !== b.tag) return b = Nd(c, a.mode, d, f), b.return = a, b;
            b = e(b, c);
            b.return = a;
            return b;
        }
        function r(a, b, c) {
            if ("string" === typeof b && "" !== b || "number" === typeof b) return b = Kd("" + b, a.mode, c), b.return = a, b;
            if ("object" === typeof b && null !== b) {
                switch(b.$$typeof){
                    case ea:
                        return c = Ld(b.type, b.key, b.props, null, a.mode, c), c.ref = Fd(a, null, b), c.return = a, c;
                    case fa:
                        return b = Md(b, a.mode, c), b.return = a, b;
                    case qa:
                        var d = b._init;
                        return r(a, d(b._payload), c);
                }
                if (Da(b) || ta(b)) return b = Nd(b, a.mode, c, null), b.return = a, b;
                Gd(a, b);
            }
            return null;
        }
        function p(a, b, c, d) {
            var e = null !== b ? b.key : null;
            if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
            if ("object" === typeof c && null !== c) {
                switch(c.$$typeof){
                    case ea:
                        return c.key === e ? k(a, b, c, d) : null;
                    case fa:
                        return c.key === e ? l(a, b, c, d) : null;
                    case qa:
                        return e = c._init, p(a, b, e(c._payload), d);
                }
                if (Da(c) || ta(c)) return null !== e ? null : m(a, b, c, d, null);
                Gd(a, c);
            }
            return null;
        }
        function B(a, b, c, d, e) {
            if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
            if ("object" === typeof d && null !== d) {
                switch(d.$$typeof){
                    case ea:
                        return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                    case fa:
                        return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                    case qa:
                        var f = d._init;
                        return B(a, b, c, f(d._payload), e);
                }
                if (Da(d) || ta(d)) return a = a.get(c) || null, m(b, a, d, e, null);
                Gd(b, d);
            }
            return null;
        }
        function w(e, g, h, k) {
            for(var l = null, m = null, u = g, t = g = 0, E = null; null !== u && t < h.length; t++){
                u.index > t ? (E = u, u = null) : E = u.sibling;
                var y = p(e, u, h[t], k);
                if (null === y) {
                    null === u && (u = E);
                    break;
                }
                a && u && null === y.alternate && b(e, u);
                g = f(y, g, t);
                null === m ? l = y : m.sibling = y;
                m = y;
                u = E;
            }
            if (t === h.length) return c(e, u), F && kd(e, t), l;
            if (null === u) {
                for(; t < h.length; t++)u = r(e, h[t], k), null !== u && (g = f(u, g, t), null === m ? l = u : m.sibling = u, m = u);
                F && kd(e, t);
                return l;
            }
            for(u = d(e, u); t < h.length; t++)E = B(u, e, t, h[t], k), null !== E && (a && null !== E.alternate && u.delete(null === E.key ? t : E.key), g = f(E, g, t), null === m ? l = E : m.sibling = E, m = E);
            a && u.forEach(function(a) {
                return b(e, a);
            });
            F && kd(e, t);
            return l;
        }
        function Y(e, g, h, k) {
            var l = ta(h);
            if ("function" !== typeof l) throw Error(n(150));
            h = l.call(h);
            if (null == h) throw Error(n(151));
            for(var u = l = null, m = g, t = g = 0, E = null, y = h.next(); null !== m && !y.done; t++, y = h.next()){
                m.index > t ? (E = m, m = null) : E = m.sibling;
                var w = p(e, m, y.value, k);
                if (null === w) {
                    null === m && (m = E);
                    break;
                }
                a && m && null === w.alternate && b(e, m);
                g = f(w, g, t);
                null === u ? l = w : u.sibling = w;
                u = w;
                m = E;
            }
            if (y.done) return c(e, m), F && kd(e, t), l;
            if (null === m) {
                for(; !y.done; t++, y = h.next())y = r(e, y.value, k), null !== y && (g = f(y, g, t), null === u ? l = y : u.sibling = y, u = y);
                F && kd(e, t);
                return l;
            }
            for(m = d(e, m); !y.done; t++, y = h.next())y = B(m, e, t, y.value, k), null !== y && (a && null !== y.alternate && m.delete(null === y.key ? t : y.key), g = f(y, g, t), null === u ? l = y : u.sibling = y, u = y);
            a && m.forEach(function(a) {
                return b(e, a);
            });
            F && kd(e, t);
            return l;
        }
        function ya(a, d, f, h) {
            "object" === typeof f && null !== f && f.type === ha && null === f.key && (f = f.props.children);
            if ("object" === typeof f && null !== f) {
                switch(f.$$typeof){
                    case ea:
                        a: {
                            for(var k = f.key, l = d; null !== l;){
                                if (l.key === k) {
                                    k = f.type;
                                    if (k === ha) {
                                        if (7 === l.tag) {
                                            c(a, l.sibling);
                                            d = e(l, f.props.children);
                                            d.return = a;
                                            a = d;
                                            break a;
                                        }
                                    } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === qa && Hd(k) === l.type) {
                                        c(a, l.sibling);
                                        d = e(l, f.props);
                                        d.ref = Fd(a, l, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    c(a, l);
                                    break;
                                } else b(a, l);
                                l = l.sibling;
                            }
                            f.type === ha ? (d = Nd(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Ld(f.type, f.key, f.props, null, a.mode, h), h.ref = Fd(a, d, f), h.return = a, a = h);
                        }
                        return g(a);
                    case fa:
                        a: {
                            for(l = f.key; null !== d;){
                                if (d.key === l) {
                                    if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                        c(a, d.sibling);
                                        d = e(d, f.children || []);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    } else {
                                        c(a, d);
                                        break;
                                    }
                                } else b(a, d);
                                d = d.sibling;
                            }
                            d = Md(f, a.mode, h);
                            d.return = a;
                            a = d;
                        }
                        return g(a);
                    case qa:
                        return l = f._init, ya(a, d, l(f._payload), h);
                }
                if (Da(f)) return w(a, d, f, h);
                if (ta(f)) return Y(a, d, f, h);
                Gd(a, f);
            }
            return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Kd(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
        }
        return ya;
    }
    var Od = Id(!0), Pd = Id(!1), Qd = ic(null), Rd = null, Sd = null, Td = null;
    function Ud() {
        Td = Sd = Rd = null;
    }
    function Vd(a, b, c) {
        Sa ? (v(Qd, b._currentValue), b._currentValue = c) : (v(Qd, b._currentValue2), b._currentValue2 = c);
    }
    function Wd(a) {
        var b = Qd.current;
        q(Qd);
        Sa ? a._currentValue = b : a._currentValue2 = b;
    }
    function Xd(a, b, c) {
        for(; null !== a;){
            var d = a.alternate;
            (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
            if (a === c) break;
            a = a.return;
        }
    }
    function Yd(a, b) {
        Rd = a;
        Td = Sd = null;
        a = a.dependencies;
        null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (G = !0), a.firstContext = null);
    }
    function Zd(a) {
        var b = Sa ? a._currentValue : a._currentValue2;
        if (Td !== a) {
            if (a = {
                context: a,
                memoizedValue: b,
                next: null
            }, null === Sd) {
                if (null === Rd) throw Error(n(308));
                Sd = a;
                Rd.dependencies = {
                    lanes: 0,
                    firstContext: a
                };
            } else Sd = Sd.next = a;
        }
        return b;
    }
    var $d = null;
    function ae(a) {
        null === $d ? $d = [
            a
        ] : $d.push(a);
    }
    function be(a, b, c, d) {
        var e = b.interleaved;
        null === e ? (c.next = c, ae(b)) : (c.next = e.next, e.next = c);
        b.interleaved = c;
        return ce(a, d);
    }
    function ce(a, b) {
        a.lanes |= b;
        var c = a.alternate;
        null !== c && (c.lanes |= b);
        c = a;
        for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
        return 3 === c.tag ? c.stateNode : null;
    }
    var de = !1;
    function ee(a) {
        a.updateQueue = {
            baseState: a.memoizedState,
            firstBaseUpdate: null,
            lastBaseUpdate: null,
            shared: {
                pending: null,
                interleaved: null,
                lanes: 0
            },
            effects: null
        };
    }
    function fe(a, b) {
        a = a.updateQueue;
        b.updateQueue === a && (b.updateQueue = {
            baseState: a.baseState,
            firstBaseUpdate: a.firstBaseUpdate,
            lastBaseUpdate: a.lastBaseUpdate,
            shared: a.shared,
            effects: a.effects
        });
    }
    function ge(a, b) {
        return {
            eventTime: a,
            lane: b,
            tag: 0,
            payload: null,
            callback: null,
            next: null
        };
    }
    function he(a, b, c) {
        var d = a.updateQueue;
        if (null === d) return null;
        d = d.shared;
        if (0 !== (H & 2)) {
            var e = d.pending;
            null === e ? b.next = b : (b.next = e.next, e.next = b);
            d.pending = b;
            return ce(a, c);
        }
        e = d.interleaved;
        null === e ? (b.next = b, ae(d)) : (b.next = e.next, e.next = b);
        d.interleaved = b;
        return ce(a, c);
    }
    function ie(a, b, c) {
        b = b.updateQueue;
        if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
            var d = b.lanes;
            d &= a.pendingLanes;
            c |= d;
            b.lanes = c;
            Hc(a, c);
        }
    }
    function je(a, b) {
        var c = a.updateQueue, d = a.alternate;
        if (null !== d && (d = d.updateQueue, c === d)) {
            var e = null, f = null;
            c = c.firstBaseUpdate;
            if (null !== c) {
                do {
                    var g = {
                        eventTime: c.eventTime,
                        lane: c.lane,
                        tag: c.tag,
                        payload: c.payload,
                        callback: c.callback,
                        next: null
                    };
                    null === f ? e = f = g : f = f.next = g;
                    c = c.next;
                }while (null !== c);
                null === f ? e = f = b : f = f.next = b;
            } else e = f = b;
            c = {
                baseState: d.baseState,
                firstBaseUpdate: e,
                lastBaseUpdate: f,
                shared: d.shared,
                effects: d.effects
            };
            a.updateQueue = c;
            return;
        }
        a = c.lastBaseUpdate;
        null === a ? c.firstBaseUpdate = b : a.next = b;
        c.lastBaseUpdate = b;
    }
    function ke(a, b, c, d) {
        var e = a.updateQueue;
        de = !1;
        var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
        if (null !== h) {
            e.shared.pending = null;
            var k = h, l = k.next;
            k.next = null;
            null === g ? f = l : g.next = l;
            g = k;
            var m = a.alternate;
            null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
        }
        if (null !== f) {
            var r = e.baseState;
            g = 0;
            m = l = k = null;
            h = f;
            do {
                var p = h.lane, B = h.eventTime;
                if ((d & p) === p) {
                    null !== m && (m = m.next = {
                        eventTime: B,
                        lane: 0,
                        tag: h.tag,
                        payload: h.payload,
                        callback: h.callback,
                        next: null
                    });
                    a: {
                        var w = a, Y = h;
                        p = b;
                        B = c;
                        switch(Y.tag){
                            case 1:
                                w = Y.payload;
                                if ("function" === typeof w) {
                                    r = w.call(B, r, p);
                                    break a;
                                }
                                r = w;
                                break a;
                            case 3:
                                w.flags = w.flags & -65537 | 128;
                            case 0:
                                w = Y.payload;
                                p = "function" === typeof w ? w.call(B, r, p) : w;
                                if (null === p || void 0 === p) break a;
                                r = ca({}, r, p);
                                break a;
                            case 2:
                                de = !0;
                        }
                    }
                    null !== h.callback && 0 !== h.lane && (a.flags |= 64, p = e.effects, null === p ? e.effects = [
                        h
                    ] : p.push(h));
                } else B = {
                    eventTime: B,
                    lane: p,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                }, null === m ? (l = m = B, k = r) : m = m.next = B, g |= p;
                h = h.next;
                if (null === h) {
                    if (h = e.shared.pending, null === h) break;
                    else p = h, h = p.next, p.next = null, e.lastBaseUpdate = p, e.shared.pending = null;
                }
            }while (1);
            null === m && (k = r);
            e.baseState = k;
            e.firstBaseUpdate = l;
            e.lastBaseUpdate = m;
            b = e.shared.interleaved;
            if (null !== b) {
                e = b;
                do g |= e.lane, e = e.next;
                while (e !== b);
            } else null === f && (e.shared.lanes = 0);
            le |= g;
            a.lanes = g;
            a.memoizedState = r;
        }
    }
    function me(a, b, c) {
        a = b.effects;
        b.effects = null;
        if (null !== a) for(b = 0; b < a.length; b++){
            var d = a[b], e = d.callback;
            if (null !== e) {
                d.callback = null;
                d = c;
                if ("function" !== typeof e) throw Error(n(191, e));
                e.call(d);
            }
        }
    }
    var ne = {}, oe = ic(ne), pe = ic(ne), qe = ic(ne);
    function re(a) {
        if (a === ne) throw Error(n(174));
        return a;
    }
    function se(a, b) {
        v(qe, b);
        v(pe, a);
        v(oe, ne);
        a = Fa(b);
        q(oe);
        v(oe, a);
    }
    function te() {
        q(oe);
        q(pe);
        q(qe);
    }
    function ue(a) {
        var b = re(qe.current), c = re(oe.current);
        b = Ga(c, a.type, b);
        c !== b && (v(pe, a), v(oe, b));
    }
    function ve(a) {
        pe.current === a && (q(oe), q(pe));
    }
    var I = ic(0);
    function we(a) {
        for(var b = a; null !== b;){
            if (13 === b.tag) {
                var c = b.memoizedState;
                if (null !== c && (c = c.dehydrated, null === c || Jb(c) || Kb(c))) return b;
            } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
                if (0 !== (b.flags & 128)) return b;
            } else if (null !== b.child) {
                b.child.return = b;
                b = b.child;
                continue;
            }
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
        return null;
    }
    var xe = [];
    function ye() {
        for(var a = 0; a < xe.length; a++){
            var b = xe[a];
            Sa ? b._workInProgressVersionPrimary = null : b._workInProgressVersionSecondary = null;
        }
        xe.length = 0;
    }
    var ze = da.ReactCurrentDispatcher, Ae = da.ReactCurrentBatchConfig, Be = 0, J = null, K = null, L = null, Ce = !1, De = !1, Ee = 0, Fe = 0;
    function M() {
        throw Error(n(321));
    }
    function Ge(a, b) {
        if (null === b) return !1;
        for(var c = 0; c < b.length && c < a.length; c++)if (!Vc(a[c], b[c])) return !1;
        return !0;
    }
    function He(a, b, c, d, e, f) {
        Be = f;
        J = b;
        b.memoizedState = null;
        b.updateQueue = null;
        b.lanes = 0;
        ze.current = null === a || null === a.memoizedState ? Ie : Je;
        a = c(d, e);
        if (De) {
            f = 0;
            do {
                De = !1;
                Ee = 0;
                if (25 <= f) throw Error(n(301));
                f += 1;
                L = K = null;
                b.updateQueue = null;
                ze.current = Ke;
                a = c(d, e);
            }while (De);
        }
        ze.current = Le;
        b = null !== K && null !== K.next;
        Be = 0;
        L = K = J = null;
        Ce = !1;
        if (b) throw Error(n(300));
        return a;
    }
    function Me() {
        var a = 0 !== Ee;
        Ee = 0;
        return a;
    }
    function Ne() {
        var a = {
            memoizedState: null,
            baseState: null,
            baseQueue: null,
            queue: null,
            next: null
        };
        null === L ? J.memoizedState = L = a : L = L.next = a;
        return L;
    }
    function Oe() {
        if (null === K) {
            var a = J.alternate;
            a = null !== a ? a.memoizedState : null;
        } else a = K.next;
        var b = null === L ? J.memoizedState : L.next;
        if (null !== b) L = b, K = a;
        else {
            if (null === a) throw Error(n(310));
            K = a;
            a = {
                memoizedState: K.memoizedState,
                baseState: K.baseState,
                baseQueue: K.baseQueue,
                queue: K.queue,
                next: null
            };
            null === L ? J.memoizedState = L = a : L = L.next = a;
        }
        return L;
    }
    function Pe(a, b) {
        return "function" === typeof b ? b(a) : b;
    }
    function Qe(a) {
        var b = Oe(), c = b.queue;
        if (null === c) throw Error(n(311));
        c.lastRenderedReducer = a;
        var d = K, e = d.baseQueue, f = c.pending;
        if (null !== f) {
            if (null !== e) {
                var g = e.next;
                e.next = f.next;
                f.next = g;
            }
            d.baseQueue = e = f;
            c.pending = null;
        }
        if (null !== e) {
            f = e.next;
            d = d.baseState;
            var h = g = null, k = null, l = f;
            do {
                var m = l.lane;
                if ((Be & m) === m) null !== k && (k = k.next = {
                    lane: 0,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
                else {
                    var r = {
                        lane: m,
                        action: l.action,
                        hasEagerState: l.hasEagerState,
                        eagerState: l.eagerState,
                        next: null
                    };
                    null === k ? (h = k = r, g = d) : k = k.next = r;
                    J.lanes |= m;
                    le |= m;
                }
                l = l.next;
            }while (null !== l && l !== f);
            null === k ? g = d : k.next = h;
            Vc(d, b.memoizedState) || (G = !0);
            b.memoizedState = d;
            b.baseState = g;
            b.baseQueue = k;
            c.lastRenderedState = d;
        }
        a = c.interleaved;
        if (null !== a) {
            e = a;
            do f = e.lane, J.lanes |= f, le |= f, e = e.next;
            while (e !== a);
        } else null === e && (c.lanes = 0);
        return [
            b.memoizedState,
            c.dispatch
        ];
    }
    function Re(a) {
        var b = Oe(), c = b.queue;
        if (null === c) throw Error(n(311));
        c.lastRenderedReducer = a;
        var d = c.dispatch, e = c.pending, f = b.memoizedState;
        if (null !== e) {
            c.pending = null;
            var g = e = e.next;
            do f = a(f, g.action), g = g.next;
            while (g !== e);
            Vc(f, b.memoizedState) || (G = !0);
            b.memoizedState = f;
            null === b.baseQueue && (b.baseState = f);
            c.lastRenderedState = f;
        }
        return [
            f,
            d
        ];
    }
    function Se() {}
    function Te(a, b) {
        var c = J, d = Oe(), e = b(), f = !Vc(d.memoizedState, e);
        f && (d.memoizedState = e, G = !0);
        d = d.queue;
        Ue(Ve.bind(null, c, d, a), [
            a
        ]);
        if (d.getSnapshot !== b || f || null !== L && L.memoizedState.tag & 1) {
            c.flags |= 2048;
            We(9, Xe.bind(null, c, d, e, b), void 0, null);
            if (null === N) throw Error(n(349));
            0 !== (Be & 30) || Ye(c, b, e);
        }
        return e;
    }
    function Ye(a, b, c) {
        a.flags |= 16384;
        a = {
            getSnapshot: b,
            value: c
        };
        b = J.updateQueue;
        null === b ? (b = {
            lastEffect: null,
            stores: null
        }, J.updateQueue = b, b.stores = [
            a
        ]) : (c = b.stores, null === c ? b.stores = [
            a
        ] : c.push(a));
    }
    function Xe(a, b, c, d) {
        b.value = c;
        b.getSnapshot = d;
        Ze(b) && $e(a);
    }
    function Ve(a, b, c) {
        return c(function() {
            Ze(b) && $e(a);
        });
    }
    function Ze(a) {
        var b = a.getSnapshot;
        a = a.value;
        try {
            var c = b();
            return !Vc(a, c);
        } catch (d) {
            return !0;
        }
    }
    function $e(a) {
        var b = ce(a, 1);
        null !== b && af(b, a, 1, -1);
    }
    function bf(a) {
        var b = Ne();
        "function" === typeof a && (a = a());
        b.memoizedState = b.baseState = a;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: Pe,
            lastRenderedState: a
        };
        b.queue = a;
        a = a.dispatch = cf.bind(null, J, a);
        return [
            b.memoizedState,
            a
        ];
    }
    function We(a, b, c, d) {
        a = {
            tag: a,
            create: b,
            destroy: c,
            deps: d,
            next: null
        };
        b = J.updateQueue;
        null === b ? (b = {
            lastEffect: null,
            stores: null
        }, J.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
        return a;
    }
    function df() {
        return Oe().memoizedState;
    }
    function ef(a, b, c, d) {
        var e = Ne();
        J.flags |= a;
        e.memoizedState = We(1 | b, c, void 0, void 0 === d ? null : d);
    }
    function ff(a, b, c, d) {
        var e = Oe();
        d = void 0 === d ? null : d;
        var f = void 0;
        if (null !== K) {
            var g = K.memoizedState;
            f = g.destroy;
            if (null !== d && Ge(d, g.deps)) {
                e.memoizedState = We(b, c, f, d);
                return;
            }
        }
        J.flags |= a;
        e.memoizedState = We(1 | b, c, f, d);
    }
    function gf(a, b) {
        return ef(8390656, 8, a, b);
    }
    function Ue(a, b) {
        return ff(2048, 8, a, b);
    }
    function hf(a, b) {
        return ff(4, 2, a, b);
    }
    function jf(a, b) {
        return ff(4, 4, a, b);
    }
    function kf(a, b) {
        if ("function" === typeof b) return a = a(), b(a), function() {
            b(null);
        };
        if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
            b.current = null;
        };
    }
    function lf(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return ff(4, 4, kf.bind(null, b, a), c);
    }
    function mf() {}
    function nf(a, b) {
        var c = Oe();
        b = void 0 === b ? null : b;
        var d = c.memoizedState;
        if (null !== d && null !== b && Ge(b, d[1])) return d[0];
        c.memoizedState = [
            a,
            b
        ];
        return a;
    }
    function of(a, b) {
        var c = Oe();
        b = void 0 === b ? null : b;
        var d = c.memoizedState;
        if (null !== d && null !== b && Ge(b, d[1])) return d[0];
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    }
    function pf(a, b, c) {
        if (0 === (Be & 21)) return a.baseState && (a.baseState = !1, G = !0), a.memoizedState = c;
        Vc(c, b) || (c = Dc(), J.lanes |= c, le |= c, a.baseState = !0);
        return b;
    }
    function qf(a, b) {
        var c = C;
        C = 0 !== c && 4 > c ? c : 4;
        a(!0);
        var d = Ae.transition;
        Ae.transition = {};
        try {
            a(!1), b();
        } finally{
            C = c, Ae.transition = d;
        }
    }
    function rf() {
        return Oe().memoizedState;
    }
    function sf(a, b, c) {
        var d = tf(a);
        c = {
            lane: d,
            action: c,
            hasEagerState: !1,
            eagerState: null,
            next: null
        };
        if (uf(a)) vf(b, c);
        else if (c = be(a, b, c, d), null !== c) {
            var e = O();
            af(c, a, d, e);
            wf(c, b, d);
        }
    }
    function cf(a, b, c) {
        var d = tf(a), e = {
            lane: d,
            action: c,
            hasEagerState: !1,
            eagerState: null,
            next: null
        };
        if (uf(a)) vf(b, e);
        else {
            var f = a.alternate;
            if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
                var g = b.lastRenderedState, h = f(g, c);
                e.hasEagerState = !0;
                e.eagerState = h;
                if (Vc(h, g)) {
                    var k = b.interleaved;
                    null === k ? (e.next = e, ae(b)) : (e.next = k.next, k.next = e);
                    b.interleaved = e;
                    return;
                }
            } catch (l) {} finally{}
            c = be(a, b, e, d);
            null !== c && (e = O(), af(c, a, d, e), wf(c, b, d));
        }
    }
    function uf(a) {
        var b = a.alternate;
        return a === J || null !== b && b === J;
    }
    function vf(a, b) {
        De = Ce = !0;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
    function wf(a, b, c) {
        if (0 !== (c & 4194240)) {
            var d = b.lanes;
            d &= a.pendingLanes;
            c |= d;
            b.lanes = c;
            Hc(a, c);
        }
    }
    var Le = {
        readContext: Zd,
        useCallback: M,
        useContext: M,
        useEffect: M,
        useImperativeHandle: M,
        useInsertionEffect: M,
        useLayoutEffect: M,
        useMemo: M,
        useReducer: M,
        useRef: M,
        useState: M,
        useDebugValue: M,
        useDeferredValue: M,
        useTransition: M,
        useMutableSource: M,
        useSyncExternalStore: M,
        useId: M,
        unstable_isNewReconciler: !1
    }, Ie = {
        readContext: Zd,
        useCallback: function(a, b) {
            Ne().memoizedState = [
                a,
                void 0 === b ? null : b
            ];
            return a;
        },
        useContext: Zd,
        useEffect: gf,
        useImperativeHandle: function(a, b, c) {
            c = null !== c && void 0 !== c ? c.concat([
                a
            ]) : null;
            return ef(4194308, 4, kf.bind(null, b, a), c);
        },
        useLayoutEffect: function(a, b) {
            return ef(4194308, 4, a, b);
        },
        useInsertionEffect: function(a, b) {
            return ef(4, 2, a, b);
        },
        useMemo: function(a, b) {
            var c = Ne();
            b = void 0 === b ? null : b;
            a = a();
            c.memoizedState = [
                a,
                b
            ];
            return a;
        },
        useReducer: function(a, b, c) {
            var d = Ne();
            b = void 0 !== c ? c(b) : b;
            d.memoizedState = d.baseState = b;
            a = {
                pending: null,
                interleaved: null,
                lanes: 0,
                dispatch: null,
                lastRenderedReducer: a,
                lastRenderedState: b
            };
            d.queue = a;
            a = a.dispatch = sf.bind(null, J, a);
            return [
                d.memoizedState,
                a
            ];
        },
        useRef: function(a) {
            var b = Ne();
            a = {
                current: a
            };
            return b.memoizedState = a;
        },
        useState: bf,
        useDebugValue: mf,
        useDeferredValue: function(a) {
            return Ne().memoizedState = a;
        },
        useTransition: function() {
            var a = bf(!1), b = a[0];
            a = qf.bind(null, a[1]);
            Ne().memoizedState = a;
            return [
                b,
                a
            ];
        },
        useMutableSource: function() {},
        useSyncExternalStore: function(a, b, c) {
            var d = J, e = Ne();
            if (F) {
                if (void 0 === c) throw Error(n(407));
                c = c();
            } else {
                c = b();
                if (null === N) throw Error(n(349));
                0 !== (Be & 30) || Ye(d, b, c);
            }
            e.memoizedState = c;
            var f = {
                value: c,
                getSnapshot: b
            };
            e.queue = f;
            gf(Ve.bind(null, d, f, a), [
                a
            ]);
            d.flags |= 2048;
            We(9, Xe.bind(null, d, f, c, b), void 0, null);
            return c;
        },
        useId: function() {
            var a = Ne(), b = N.identifierPrefix;
            if (F) {
                var c = jd;
                var d = id;
                c = (d & ~(1 << 32 - tc(d) - 1)).toString(32) + c;
                b = ":" + b + "R" + c;
                c = Ee++;
                0 < c && (b += "H" + c.toString(32));
                b += ":";
            } else c = Fe++, b = ":" + b + "r" + c.toString(32) + ":";
            return a.memoizedState = b;
        },
        unstable_isNewReconciler: !1
    }, Je = {
        readContext: Zd,
        useCallback: nf,
        useContext: Zd,
        useEffect: Ue,
        useImperativeHandle: lf,
        useInsertionEffect: hf,
        useLayoutEffect: jf,
        useMemo: of,
        useReducer: Qe,
        useRef: df,
        useState: function() {
            return Qe(Pe);
        },
        useDebugValue: mf,
        useDeferredValue: function(a) {
            var b = Oe();
            return pf(b, K.memoizedState, a);
        },
        useTransition: function() {
            var a = Qe(Pe)[0], b = Oe().memoizedState;
            return [
                a,
                b
            ];
        },
        useMutableSource: Se,
        useSyncExternalStore: Te,
        useId: rf,
        unstable_isNewReconciler: !1
    }, Ke = {
        readContext: Zd,
        useCallback: nf,
        useContext: Zd,
        useEffect: Ue,
        useImperativeHandle: lf,
        useInsertionEffect: hf,
        useLayoutEffect: jf,
        useMemo: of,
        useReducer: Re,
        useRef: df,
        useState: function() {
            return Re(Pe);
        },
        useDebugValue: mf,
        useDeferredValue: function(a) {
            var b = Oe();
            return null === K ? b.memoizedState = a : pf(b, K.memoizedState, a);
        },
        useTransition: function() {
            var a = Re(Pe)[0], b = Oe().memoizedState;
            return [
                a,
                b
            ];
        },
        useMutableSource: Se,
        useSyncExternalStore: Te,
        useId: rf,
        unstable_isNewReconciler: !1
    };
    function xf(a, b) {
        if (a && a.defaultProps) {
            b = ca({}, b);
            a = a.defaultProps;
            for(var c in a)void 0 === b[c] && (b[c] = a[c]);
            return b;
        }
        return b;
    }
    function yf(a, b, c, d) {
        b = a.memoizedState;
        c = c(d, b);
        c = null === c || void 0 === c ? b : ca({}, b, c);
        a.memoizedState = c;
        0 === a.lanes && (a.updateQueue.baseState = c);
    }
    var zf = {
        isMounted: function(a) {
            return (a = a._reactInternals) ? wa(a) === a : !1;
        },
        enqueueSetState: function(a, b, c) {
            a = a._reactInternals;
            var d = O(), e = tf(a), f = ge(d, e);
            f.payload = b;
            void 0 !== c && null !== c && (f.callback = c);
            b = he(a, f, e);
            null !== b && (af(b, a, e, d), ie(b, a, e));
        },
        enqueueReplaceState: function(a, b, c) {
            a = a._reactInternals;
            var d = O(), e = tf(a), f = ge(d, e);
            f.tag = 1;
            f.payload = b;
            void 0 !== c && null !== c && (f.callback = c);
            b = he(a, f, e);
            null !== b && (af(b, a, e, d), ie(b, a, e));
        },
        enqueueForceUpdate: function(a, b) {
            a = a._reactInternals;
            var c = O(), d = tf(a), e = ge(c, d);
            e.tag = 2;
            void 0 !== b && null !== b && (e.callback = b);
            b = he(a, e, d);
            null !== b && (af(b, a, d, c), ie(b, a, d));
        }
    };
    function Af(a, b, c, d, e, f, g) {
        a = a.stateNode;
        return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Dd(c, d) || !Dd(e, f) : !0;
    }
    function Bf(a, b, c) {
        var d = !1, e = jc;
        var f = b.contextType;
        "object" === typeof f && null !== f ? f = Zd(f) : (e = A(b) ? kc : x.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? mc(a, e) : jc);
        b = new b(c, f);
        a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
        b.updater = zf;
        a.stateNode = b;
        b._reactInternals = a;
        d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
        return b;
    }
    function Cf(a, b, c, d) {
        a = b.state;
        "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
        "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
        b.state !== a && zf.enqueueReplaceState(b, b.state, null);
    }
    function Df(a, b, c, d) {
        var e = a.stateNode;
        e.props = c;
        e.state = a.memoizedState;
        e.refs = {};
        ee(a);
        var f = b.contextType;
        "object" === typeof f && null !== f ? e.context = Zd(f) : (f = A(b) ? kc : x.current, e.context = mc(a, f));
        e.state = a.memoizedState;
        f = b.getDerivedStateFromProps;
        "function" === typeof f && (yf(a, b, f, c), e.state = a.memoizedState);
        "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && zf.enqueueReplaceState(e, e.state, null), ke(a, c, e, d), e.state = a.memoizedState);
        "function" === typeof e.componentDidMount && (a.flags |= 4194308);
    }
    function Ef(a, b) {
        try {
            var c = "", d = b;
            do c += Ed(d), d = d.return;
            while (d);
            var e = c;
        } catch (f) {
            e = "\nError generating stack: " + f.message + "\n" + f.stack;
        }
        return {
            value: a,
            source: b,
            stack: e,
            digest: null
        };
    }
    function Ff(a, b, c) {
        return {
            value: a,
            source: null,
            stack: null != c ? c : null,
            digest: null != b ? b : null
        };
    }
    function Gf(a, b) {
        try {
            console.error(b.value);
        } catch (c) {
            setTimeout(function() {
                throw c;
            });
        }
    }
    var Hf = "function" === typeof WeakMap ? WeakMap : Map;
    function If(a, b, c) {
        c = ge(-1, c);
        c.tag = 3;
        c.payload = {
            element: null
        };
        var d = b.value;
        c.callback = function() {
            Jf || (Jf = !0, Kf = d);
            Gf(a, b);
        };
        return c;
    }
    function Lf(a, b, c) {
        c = ge(-1, c);
        c.tag = 3;
        var d = a.type.getDerivedStateFromError;
        if ("function" === typeof d) {
            var e = b.value;
            c.payload = function() {
                return d(e);
            };
            c.callback = function() {
                Gf(a, b);
            };
        }
        var f = a.stateNode;
        null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
            Gf(a, b);
            "function" !== typeof d && (null === Mf ? Mf = new Set([
                this
            ]) : Mf.add(this));
            var c = b.stack;
            this.componentDidCatch(b.value, {
                componentStack: null !== c ? c : ""
            });
        });
        return c;
    }
    function Nf(a, b, c) {
        var d = a.pingCache;
        if (null === d) {
            d = a.pingCache = new Hf;
            var e = new Set;
            d.set(b, e);
        } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
        e.has(c) || (e.add(c), a = Of.bind(null, a, b, c), b.then(a, a));
    }
    function Pf(a) {
        do {
            var b;
            if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
            if (b) return a;
            a = a.return;
        }while (null !== a);
        return null;
    }
    function Qf(a, b, c, d, e) {
        if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = ge(-1, 1), b.tag = 2, he(c, b, 1))), c.lanes |= 1), a;
        a.flags |= 65536;
        a.lanes = e;
        return a;
    }
    var Rf = da.ReactCurrentOwner, G = !1;
    function P(a, b, c, d) {
        b.child = null === a ? Pd(b, null, c, d) : Od(b, a.child, c, d);
    }
    function Sf(a, b, c, d, e) {
        c = c.render;
        var f = b.ref;
        Yd(b, e);
        d = He(a, b, c, d, f, e);
        c = Me();
        if (null !== a && !G) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, Tf(a, b, e);
        F && c && md(b);
        b.flags |= 1;
        P(a, b, d, e);
        return b.child;
    }
    function Uf(a, b, c, d, e) {
        if (null === a) {
            var f = c.type;
            if ("function" === typeof f && !Vf(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, Wf(a, b, f, d, e);
            a = Ld(c.type, null, d, b, b.mode, e);
            a.ref = b.ref;
            a.return = b;
            return b.child = a;
        }
        f = a.child;
        if (0 === (a.lanes & e)) {
            var g = f.memoizedProps;
            c = c.compare;
            c = null !== c ? c : Dd;
            if (c(g, d) && a.ref === b.ref) return Tf(a, b, e);
        }
        b.flags |= 1;
        a = Jd(f, d);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    function Wf(a, b, c, d, e) {
        if (null !== a) {
            var f = a.memoizedProps;
            if (Dd(f, d) && a.ref === b.ref) {
                if (G = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && (G = !0);
                else return b.lanes = a.lanes, Tf(a, b, e);
            }
        }
        return Xf(a, b, c, d, e);
    }
    function Yf(a, b, c) {
        var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
        if ("hidden" === d.mode) {
            if (0 === (b.mode & 1)) b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            }, v(Zf, $f), $f |= c;
            else {
                if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                    baseLanes: a,
                    cachePool: null,
                    transitions: null
                }, b.updateQueue = null, v(Zf, $f), $f |= a, null;
                b.memoizedState = {
                    baseLanes: 0,
                    cachePool: null,
                    transitions: null
                };
                d = null !== f ? f.baseLanes : c;
                v(Zf, $f);
                $f |= d;
            }
        } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, v(Zf, $f), $f |= d;
        P(a, b, e, c);
        return b.child;
    }
    function ag(a, b) {
        var c = b.ref;
        if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
    }
    function Xf(a, b, c, d, e) {
        var f = A(c) ? kc : x.current;
        f = mc(b, f);
        Yd(b, e);
        c = He(a, b, c, d, f, e);
        d = Me();
        if (null !== a && !G) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, Tf(a, b, e);
        F && d && md(b);
        b.flags |= 1;
        P(a, b, c, e);
        return b.child;
    }
    function bg(a, b, c, d, e) {
        if (A(c)) {
            var f = !0;
            qc(b);
        } else f = !1;
        Yd(b, e);
        if (null === b.stateNode) cg(a, b), Bf(b, c, d), Df(b, c, d, e), d = !0;
        else if (null === a) {
            var g = b.stateNode, h = b.memoizedProps;
            g.props = h;
            var k = g.context, l = c.contextType;
            "object" === typeof l && null !== l ? l = Zd(l) : (l = A(c) ? kc : x.current, l = mc(b, l));
            var m = c.getDerivedStateFromProps, r = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
            r || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Cf(b, g, d, l);
            de = !1;
            var p = b.memoizedState;
            g.state = p;
            ke(b, d, g, e);
            k = b.memoizedState;
            h !== d || p !== k || z.current || de ? ("function" === typeof m && (yf(b, c, m, d), k = b.memoizedState), (h = de || Af(b, c, h, d, p, k, l)) ? (r || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
        } else {
            g = b.stateNode;
            fe(a, b);
            h = b.memoizedProps;
            l = b.type === b.elementType ? h : xf(b.type, h);
            g.props = l;
            r = b.pendingProps;
            p = g.context;
            k = c.contextType;
            "object" === typeof k && null !== k ? k = Zd(k) : (k = A(c) ? kc : x.current, k = mc(b, k));
            var B = c.getDerivedStateFromProps;
            (m = "function" === typeof B || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== r || p !== k) && Cf(b, g, d, k);
            de = !1;
            p = b.memoizedState;
            g.state = p;
            ke(b, d, g, e);
            var w = b.memoizedState;
            h !== r || p !== w || z.current || de ? ("function" === typeof B && (yf(b, c, B, d), w = b.memoizedState), (l = de || Af(b, c, l, d, p, w, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, w, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, w, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = w), g.props = d, g.state = w, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 1024), d = !1);
        }
        return dg(a, b, c, d, f, e);
    }
    function dg(a, b, c, d, e, f) {
        ag(a, b);
        var g = 0 !== (b.flags & 128);
        if (!d && !g) return e && rc(b, c, !1), Tf(a, b, f);
        d = b.stateNode;
        Rf.current = b;
        var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
        b.flags |= 1;
        null !== a && g ? (b.child = Od(b, a.child, null, f), b.child = Od(b, null, h, f)) : P(a, b, h, f);
        b.memoizedState = d.state;
        e && rc(b, c, !0);
        return b.child;
    }
    function eg(a) {
        var b = a.stateNode;
        b.pendingContext ? oc(a, b.pendingContext, b.pendingContext !== b.context) : b.context && oc(a, b.context, !1);
        se(a, b.containerInfo);
    }
    function fg(a, b, c, d, e) {
        Ad();
        Bd(e);
        b.flags |= 256;
        P(a, b, c, d);
        return b.child;
    }
    var gg = {
        dehydrated: null,
        treeContext: null,
        retryLane: 0
    };
    function hg(a) {
        return {
            baseLanes: a,
            cachePool: null,
            transitions: null
        };
    }
    function ig(a, b, c) {
        var d = b.pendingProps, e = I.current, f = !1, g = 0 !== (b.flags & 128), h;
        (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
        if (h) f = !0, b.flags &= -129;
        else if (null === a || null !== a.memoizedState) e |= 1;
        v(I, e & 1);
        if (null === a) {
            wd(b);
            a = b.memoizedState;
            if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : Kb(a) ? b.lanes = 8 : b.lanes = 1073741824, null;
            g = d.children;
            a = d.fallback;
            return f ? (d = b.mode, f = b.child, g = {
                mode: "hidden",
                children: g
            }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = jg(g, d, 0, null), a = Nd(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = hg(c), b.memoizedState = gg, a) : kg(b, g);
        }
        e = a.memoizedState;
        if (null !== e && (h = e.dehydrated, null !== h)) return lg(a, b, g, d, h, e, c);
        if (f) {
            f = d.fallback;
            g = b.mode;
            e = a.child;
            h = e.sibling;
            var k = {
                mode: "hidden",
                children: d.children
            };
            0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = Jd(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
            null !== h ? f = Jd(h, f) : (f = Nd(f, g, c, null), f.flags |= 2);
            f.return = b;
            d.return = b;
            d.sibling = f;
            b.child = d;
            d = f;
            f = b.child;
            g = a.child.memoizedState;
            g = null === g ? hg(c) : {
                baseLanes: g.baseLanes | c,
                cachePool: null,
                transitions: g.transitions
            };
            f.memoizedState = g;
            f.childLanes = a.childLanes & ~c;
            b.memoizedState = gg;
            return d;
        }
        f = a.child;
        a = f.sibling;
        d = Jd(f, {
            mode: "visible",
            children: d.children
        });
        0 === (b.mode & 1) && (d.lanes = c);
        d.return = b;
        d.sibling = null;
        null !== a && (c = b.deletions, null === c ? (b.deletions = [
            a
        ], b.flags |= 16) : c.push(a));
        b.child = d;
        b.memoizedState = null;
        return d;
    }
    function kg(a, b) {
        b = jg({
            mode: "visible",
            children: b
        }, a.mode, 0, null);
        b.return = a;
        return a.child = b;
    }
    function mg(a, b, c, d) {
        null !== d && Bd(d);
        Od(b, a.child, null, c);
        a = kg(b, b.pendingProps.children);
        a.flags |= 2;
        b.memoizedState = null;
        return a;
    }
    function lg(a, b, c, d, e, f, g) {
        if (c) {
            if (b.flags & 256) return b.flags &= -257, d = Ff(Error(n(422))), mg(a, b, g, d);
            if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
            f = d.fallback;
            e = b.mode;
            d = jg({
                mode: "visible",
                children: d.children
            }, e, 0, null);
            f = Nd(f, e, g, null);
            f.flags |= 2;
            d.return = b;
            f.return = b;
            d.sibling = f;
            b.child = d;
            0 !== (b.mode & 1) && Od(b, a.child, null, g);
            b.child.memoizedState = hg(g);
            b.memoizedState = gg;
            return f;
        }
        if (0 === (b.mode & 1)) return mg(a, b, g, null);
        if (Kb(e)) return d = Lb(e).digest, f = Error(n(419)), d = Ff(f, d, void 0), mg(a, b, g, d);
        c = 0 !== (g & a.childLanes);
        if (G || c) {
            d = N;
            if (null !== d) {
                switch(g & -g){
                    case 4:
                        e = 2;
                        break;
                    case 16:
                        e = 8;
                        break;
                    case 64:
                    case 128:
                    case 256:
                    case 512:
                    case 1024:
                    case 2048:
                    case 4096:
                    case 8192:
                    case 16384:
                    case 32768:
                    case 65536:
                    case 131072:
                    case 262144:
                    case 524288:
                    case 1048576:
                    case 2097152:
                    case 4194304:
                    case 8388608:
                    case 16777216:
                    case 33554432:
                    case 67108864:
                        e = 32;
                        break;
                    case 536870912:
                        e = 268435456;
                        break;
                    default:
                        e = 0;
                }
                e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
                0 !== e && e !== f.retryLane && (f.retryLane = e, ce(a, e), af(d, a, e, -1));
            }
            ng();
            d = Ff(Error(n(421)));
            return mg(a, b, g, d);
        }
        if (Jb(e)) return b.flags |= 128, b.child = a.child, b = og.bind(null, a), Mb(e, b), null;
        a = f.treeContext;
        Va && (pd = Qb(e), od = b, F = !0, rd = null, qd = !1, null !== a && (fd[gd++] = id, fd[gd++] = jd, fd[gd++] = hd, id = a.id, jd = a.overflow, hd = b));
        b = kg(b, d.children);
        b.flags |= 4096;
        return b;
    }
    function pg(a, b, c) {
        a.lanes |= b;
        var d = a.alternate;
        null !== d && (d.lanes |= b);
        Xd(a.return, b, c);
    }
    function qg(a, b, c, d, e) {
        var f = a.memoizedState;
        null === f ? a.memoizedState = {
            isBackwards: b,
            rendering: null,
            renderingStartTime: 0,
            last: d,
            tail: c,
            tailMode: e
        } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
    }
    function rg(a, b, c) {
        var d = b.pendingProps, e = d.revealOrder, f = d.tail;
        P(a, b, d.children, c);
        d = I.current;
        if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
        else {
            if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
                if (13 === a.tag) null !== a.memoizedState && pg(a, c, b);
                else if (19 === a.tag) pg(a, c, b);
                else if (null !== a.child) {
                    a.child.return = a;
                    a = a.child;
                    continue;
                }
                if (a === b) break a;
                for(; null === a.sibling;){
                    if (null === a.return || a.return === b) break a;
                    a = a.return;
                }
                a.sibling.return = a.return;
                a = a.sibling;
            }
            d &= 1;
        }
        v(I, d);
        if (0 === (b.mode & 1)) b.memoizedState = null;
        else switch(e){
            case "forwards":
                c = b.child;
                for(e = null; null !== c;)a = c.alternate, null !== a && null === we(a) && (e = c), c = c.sibling;
                c = e;
                null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
                qg(b, !1, e, c, f);
                break;
            case "backwards":
                c = null;
                e = b.child;
                for(b.child = null; null !== e;){
                    a = e.alternate;
                    if (null !== a && null === we(a)) {
                        b.child = e;
                        break;
                    }
                    a = e.sibling;
                    e.sibling = c;
                    c = e;
                    e = a;
                }
                qg(b, !0, c, null, f);
                break;
            case "together":
                qg(b, !1, null, null, void 0);
                break;
            default:
                b.memoizedState = null;
        }
        return b.child;
    }
    function cg(a, b) {
        0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
    }
    function Tf(a, b, c) {
        null !== a && (b.dependencies = a.dependencies);
        le |= b.lanes;
        if (0 === (c & b.childLanes)) return null;
        if (null !== a && b.child !== a.child) throw Error(n(153));
        if (null !== b.child) {
            a = b.child;
            c = Jd(a, a.pendingProps);
            b.child = c;
            for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Jd(a, a.pendingProps), c.return = b;
            c.sibling = null;
        }
        return b.child;
    }
    function sg(a, b, c) {
        switch(b.tag){
            case 3:
                eg(b);
                Ad();
                break;
            case 5:
                ue(b);
                break;
            case 1:
                A(b.type) && qc(b);
                break;
            case 4:
                se(b, b.stateNode.containerInfo);
                break;
            case 10:
                Vd(b, b.type._context, b.memoizedProps.value);
                break;
            case 13:
                var d = b.memoizedState;
                if (null !== d) {
                    if (null !== d.dehydrated) return v(I, I.current & 1), b.flags |= 128, null;
                    if (0 !== (c & b.child.childLanes)) return ig(a, b, c);
                    v(I, I.current & 1);
                    a = Tf(a, b, c);
                    return null !== a ? a.sibling : null;
                }
                v(I, I.current & 1);
                break;
            case 19:
                d = 0 !== (c & b.childLanes);
                if (0 !== (a.flags & 128)) {
                    if (d) return rg(a, b, c);
                    b.flags |= 128;
                }
                var e = b.memoizedState;
                null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
                v(I, I.current);
                if (d) break;
                else return null;
            case 22:
            case 23:
                return b.lanes = 0, Yf(a, b, c);
        }
        return Tf(a, b, c);
    }
    function tg(a) {
        a.flags |= 4;
    }
    function ug(a, b) {
        if (null !== a && a.child === b.child) return !0;
        if (0 !== (b.flags & 16)) return !1;
        for(a = b.child; null !== a;){
            if (0 !== (a.flags & 12854) || 0 !== (a.subtreeFlags & 12854)) return !1;
            a = a.sibling;
        }
        return !0;
    }
    var vg, wg, xg, yg;
    if (Ta) vg = function(a, b) {
        for(var c = b.child; null !== c;){
            if (5 === c.tag || 6 === c.tag) Ka(a, c.stateNode);
            else if (4 !== c.tag && null !== c.child) {
                c.child.return = c;
                c = c.child;
                continue;
            }
            if (c === b) break;
            for(; null === c.sibling;){
                if (null === c.return || c.return === b) return;
                c = c.return;
            }
            c.sibling.return = c.return;
            c = c.sibling;
        }
    }, wg = function() {}, xg = function(a, b, c, d, e) {
        a = a.memoizedProps;
        if (a !== d) {
            var f = b.stateNode, g = re(oe.current);
            c = Ma(f, c, a, d, e, g);
            (b.updateQueue = c) && tg(b);
        }
    }, yg = function(a, b, c, d) {
        c !== d && tg(b);
    };
    else if (Ua) {
        vg = function(a, b, c, d) {
            for(var e = b.child; null !== e;){
                if (5 === e.tag) {
                    var f = e.stateNode;
                    c && d && (f = Eb(f, e.type, e.memoizedProps, e));
                    Ka(a, f);
                } else if (6 === e.tag) f = e.stateNode, c && d && (f = Fb(f, e.memoizedProps, e)), Ka(a, f);
                else if (4 !== e.tag) {
                    if (22 === e.tag && null !== e.memoizedState) f = e.child, null !== f && (f.return = e), vg(a, e, !0, !0);
                    else if (null !== e.child) {
                        e.child.return = e;
                        e = e.child;
                        continue;
                    }
                }
                if (e === b) break;
                for(; null === e.sibling;){
                    if (null === e.return || e.return === b) return;
                    e = e.return;
                }
                e.sibling.return = e.return;
                e = e.sibling;
            }
        };
        var zg = function(a, b, c, d) {
            for(var e = b.child; null !== e;){
                if (5 === e.tag) {
                    var f = e.stateNode;
                    c && d && (f = Eb(f, e.type, e.memoizedProps, e));
                    Ab(a, f);
                } else if (6 === e.tag) f = e.stateNode, c && d && (f = Fb(f, e.memoizedProps, e)), Ab(a, f);
                else if (4 !== e.tag) {
                    if (22 === e.tag && null !== e.memoizedState) f = e.child, null !== f && (f.return = e), zg(a, e, !0, !0);
                    else if (null !== e.child) {
                        e.child.return = e;
                        e = e.child;
                        continue;
                    }
                }
                if (e === b) break;
                for(; null === e.sibling;){
                    if (null === e.return || e.return === b) return;
                    e = e.return;
                }
                e.sibling.return = e.return;
                e = e.sibling;
            }
        };
        wg = function(a, b) {
            var c = b.stateNode;
            if (!ug(a, b)) {
                a = c.containerInfo;
                var d = zb(a);
                zg(d, b, !1, !1);
                c.pendingChildren = d;
                tg(b);
                Bb(a, d);
            }
        };
        xg = function(a, b, c, d, e) {
            var f = a.stateNode, g = a.memoizedProps;
            if ((a = ug(a, b)) && g === d) b.stateNode = f;
            else {
                var h = b.stateNode, k = re(oe.current), l = null;
                g !== d && (l = Ma(h, c, g, d, e, k));
                a && null === l ? b.stateNode = f : (f = yb(f, l, c, g, d, b, a, h), La(f, c, d, e, k) && tg(b), b.stateNode = f, a ? tg(b) : vg(f, b, !1, !1));
            }
        };
        yg = function(a, b, c, d) {
            c !== d ? (a = re(qe.current), c = re(oe.current), b.stateNode = Oa(d, a, c, b), tg(b)) : b.stateNode = a.stateNode;
        };
    } else wg = function() {}, xg = function() {}, yg = function() {};
    function Ag(a, b) {
        if (!F) switch(a.tailMode){
            case "hidden":
                b = a.tail;
                for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
                null === c ? a.tail = null : c.sibling = null;
                break;
            case "collapsed":
                c = a.tail;
                for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
                null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
        }
    }
    function Q(a) {
        var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
        if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
        else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
        a.subtreeFlags |= d;
        a.childLanes = c;
        return b;
    }
    function Bg(a, b, c) {
        var d = b.pendingProps;
        nd(b);
        switch(b.tag){
            case 2:
            case 16:
            case 15:
            case 0:
            case 11:
            case 7:
            case 8:
            case 12:
            case 9:
            case 14:
                return Q(b), null;
            case 1:
                return A(b.type) && nc(), Q(b), null;
            case 3:
                c = b.stateNode;
                te();
                q(z);
                q(x);
                ye();
                c.pendingContext && (c.context = c.pendingContext, c.pendingContext = null);
                if (null === a || null === a.child) yd(b) ? tg(b) : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== rd && (Cg(rd), rd = null));
                wg(a, b);
                Q(b);
                return null;
            case 5:
                ve(b);
                c = re(qe.current);
                var e = b.type;
                if (null !== a && null != b.stateNode) xg(a, b, e, d, c), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
                else {
                    if (!d) {
                        if (null === b.stateNode) throw Error(n(166));
                        Q(b);
                        return null;
                    }
                    a = re(oe.current);
                    if (yd(b)) {
                        if (!Va) throw Error(n(175));
                        a = Rb(b.stateNode, b.type, b.memoizedProps, c, a, b, !qd);
                        b.updateQueue = a;
                        null !== a && tg(b);
                    } else {
                        var f = Ja(e, d, c, a, b);
                        vg(f, b, !1, !1);
                        b.stateNode = f;
                        La(f, e, d, c, a) && tg(b);
                    }
                    null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
                }
                Q(b);
                return null;
            case 6:
                if (a && null != b.stateNode) yg(a, b, a.memoizedProps, d);
                else {
                    if ("string" !== typeof d && null === b.stateNode) throw Error(n(166));
                    a = re(qe.current);
                    c = re(oe.current);
                    if (yd(b)) {
                        if (!Va) throw Error(n(176));
                        a = b.stateNode;
                        c = b.memoizedProps;
                        if (d = Sb(a, c, b, !qd)) {
                            if (e = od, null !== e) switch(e.tag){
                                case 3:
                                    $b(e.stateNode.containerInfo, a, c, 0 !== (e.mode & 1));
                                    break;
                                case 5:
                                    ac(e.type, e.memoizedProps, e.stateNode, a, c, 0 !== (e.mode & 1));
                            }
                        }
                        d && tg(b);
                    } else b.stateNode = Oa(d, a, c, b);
                }
                Q(b);
                return null;
            case 13:
                q(I);
                d = b.memoizedState;
                if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                    if (F && null !== pd && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) zd(), Ad(), b.flags |= 98560, e = !1;
                    else if (e = yd(b), null !== d && null !== d.dehydrated) {
                        if (null === a) {
                            if (!e) throw Error(n(318));
                            if (!Va) throw Error(n(344));
                            e = b.memoizedState;
                            e = null !== e ? e.dehydrated : null;
                            if (!e) throw Error(n(317));
                            Tb(e, b);
                        } else Ad(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                        Q(b);
                        e = !1;
                    } else null !== rd && (Cg(rd), rd = null), e = !0;
                    if (!e) return b.flags & 65536 ? b : null;
                }
                if (0 !== (b.flags & 128)) return b.lanes = c, b;
                c = null !== d;
                c !== (null !== a && null !== a.memoizedState) && c && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== (I.current & 1) ? 0 === R && (R = 3) : ng()));
                null !== b.updateQueue && (b.flags |= 4);
                Q(b);
                return null;
            case 4:
                return te(), wg(a, b), null === a && Xa(b.stateNode.containerInfo), Q(b), null;
            case 10:
                return Wd(b.type._context), Q(b), null;
            case 17:
                return A(b.type) && nc(), Q(b), null;
            case 19:
                q(I);
                e = b.memoizedState;
                if (null === e) return Q(b), null;
                d = 0 !== (b.flags & 128);
                f = e.rendering;
                if (null === f) {
                    if (d) Ag(e, !1);
                    else {
                        if (0 !== R || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                            f = we(a);
                            if (null !== f) {
                                b.flags |= 128;
                                Ag(e, !1);
                                a = f.updateQueue;
                                null !== a && (b.updateQueue = a, b.flags |= 4);
                                b.subtreeFlags = 0;
                                a = c;
                                for(c = b.child; null !== c;)d = c, e = a, d.flags &= 14680066, f = d.alternate, null === f ? (d.childLanes = 0, d.lanes = e, d.child = null, d.subtreeFlags = 0, d.memoizedProps = null, d.memoizedState = null, d.updateQueue = null, d.dependencies = null, d.stateNode = null) : (d.childLanes = f.childLanes, d.lanes = f.lanes, d.child = f.child, d.subtreeFlags = 0, d.deletions = null, d.memoizedProps = f.memoizedProps, d.memoizedState = f.memoizedState, d.updateQueue = f.updateQueue, d.type = f.type, e = f.dependencies, d.dependencies = null === e ? null : {
                                    lanes: e.lanes,
                                    firstContext: e.firstContext
                                }), c = c.sibling;
                                v(I, I.current & 1 | 2);
                                return b.child;
                            }
                            a = a.sibling;
                        }
                        null !== e.tail && D() > Dg && (b.flags |= 128, d = !0, Ag(e, !1), b.lanes = 4194304);
                    }
                } else {
                    if (!d) {
                        if (a = we(f), null !== a) {
                            if (b.flags |= 128, d = !0, a = a.updateQueue, null !== a && (b.updateQueue = a, b.flags |= 4), Ag(e, !0), null === e.tail && "hidden" === e.tailMode && !f.alternate && !F) return Q(b), null;
                        } else 2 * D() - e.renderingStartTime > Dg && 1073741824 !== c && (b.flags |= 128, d = !0, Ag(e, !1), b.lanes = 4194304);
                    }
                    e.isBackwards ? (f.sibling = b.child, b.child = f) : (a = e.last, null !== a ? a.sibling = f : b.child = f, e.last = f);
                }
                if (null !== e.tail) return b = e.tail, e.rendering = b, e.tail = b.sibling, e.renderingStartTime = D(), b.sibling = null, a = I.current, v(I, d ? a & 1 | 2 : a & 1), b;
                Q(b);
                return null;
            case 22:
            case 23:
                return Eg(), c = null !== b.memoizedState, null !== a && null !== a.memoizedState !== c && (b.flags |= 8192), c && 0 !== (b.mode & 1) ? 0 !== ($f & 1073741824) && (Q(b), Ta && b.subtreeFlags & 6 && (b.flags |= 8192)) : Q(b), null;
            case 24:
                return null;
            case 25:
                return null;
        }
        throw Error(n(156, b.tag));
    }
    function Fg(a, b) {
        nd(b);
        switch(b.tag){
            case 1:
                return A(b.type) && nc(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
            case 3:
                return te(), q(z), q(x), ye(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
            case 5:
                return ve(b), null;
            case 13:
                q(I);
                a = b.memoizedState;
                if (null !== a && null !== a.dehydrated) {
                    if (null === b.alternate) throw Error(n(340));
                    Ad();
                }
                a = b.flags;
                return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
            case 19:
                return q(I), null;
            case 4:
                return te(), null;
            case 10:
                return Wd(b.type._context), null;
            case 22:
            case 23:
                return Eg(), null;
            case 24:
                return null;
            default:
                return null;
        }
    }
    var Gg = !1, S = !1, Hg = "function" === typeof WeakSet ? WeakSet : Set, T = null;
    function Ig(a, b) {
        var c = a.ref;
        if (null !== c) {
            if ("function" === typeof c) try {
                c(null);
            } catch (d) {
                U(a, b, d);
            }
            else c.current = null;
        }
    }
    function Jg(a, b, c) {
        try {
            c();
        } catch (d) {
            U(a, b, d);
        }
    }
    var Kg = !1;
    function Lg(a, b) {
        Ha(a.containerInfo);
        for(T = b; null !== T;)if (a = T, b = a.child, 0 !== (a.subtreeFlags & 1028) && null !== b) b.return = a, T = b;
        else for(; null !== T;){
            a = T;
            try {
                var c = a.alternate;
                if (0 !== (a.flags & 1024)) switch(a.tag){
                    case 0:
                    case 11:
                    case 15:
                        break;
                    case 1:
                        if (null !== c) {
                            var d = c.memoizedProps, e = c.memoizedState, f = a.stateNode, g = f.getSnapshotBeforeUpdate(a.elementType === a.type ? d : xf(a.type, d), e);
                            f.__reactInternalSnapshotBeforeUpdate = g;
                        }
                        break;
                    case 3:
                        Ta && xb(a.stateNode.containerInfo);
                        break;
                    case 5:
                    case 6:
                    case 4:
                    case 17:
                        break;
                    default:
                        throw Error(n(163));
                }
            } catch (h) {
                U(a, a.return, h);
            }
            b = a.sibling;
            if (null !== b) {
                b.return = a.return;
                T = b;
                break;
            }
            T = a.return;
        }
        c = Kg;
        Kg = !1;
        return c;
    }
    function Mg(a, b, c) {
        var d = b.updateQueue;
        d = null !== d ? d.lastEffect : null;
        if (null !== d) {
            var e = d = d.next;
            do {
                if ((e.tag & a) === a) {
                    var f = e.destroy;
                    e.destroy = void 0;
                    void 0 !== f && Jg(b, c, f);
                }
                e = e.next;
            }while (e !== d);
        }
    }
    function Ng(a, b) {
        b = b.updateQueue;
        b = null !== b ? b.lastEffect : null;
        if (null !== b) {
            var c = b = b.next;
            do {
                if ((c.tag & a) === a) {
                    var d = c.create;
                    c.destroy = d();
                }
                c = c.next;
            }while (c !== b);
        }
    }
    function Og(a) {
        var b = a.ref;
        if (null !== b) {
            var c = a.stateNode;
            switch(a.tag){
                case 5:
                    a = Ea(c);
                    break;
                default:
                    a = c;
            }
            "function" === typeof b ? b(a) : b.current = a;
        }
    }
    function Pg(a) {
        var b = a.alternate;
        null !== b && (a.alternate = null, Pg(b));
        a.child = null;
        a.deletions = null;
        a.sibling = null;
        5 === a.tag && (b = a.stateNode, null !== b && Za(b));
        a.stateNode = null;
        a.return = null;
        a.dependencies = null;
        a.memoizedProps = null;
        a.memoizedState = null;
        a.pendingProps = null;
        a.stateNode = null;
        a.updateQueue = null;
    }
    function Qg(a) {
        return 5 === a.tag || 3 === a.tag || 4 === a.tag;
    }
    function Rg(a) {
        a: for(;;){
            for(; null === a.sibling;){
                if (null === a.return || Qg(a.return)) return null;
                a = a.return;
            }
            a.sibling.return = a.return;
            for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
                if (a.flags & 2) continue a;
                if (null === a.child || 4 === a.tag) continue a;
                else a.child.return = a, a = a.child;
            }
            if (!(a.flags & 2)) return a.stateNode;
        }
    }
    function Sg(a, b, c) {
        var d = a.tag;
        if (5 === d || 6 === d) a = a.stateNode, b ? pb(c, a, b) : kb(c, a);
        else if (4 !== d && (a = a.child, null !== a)) for(Sg(a, b, c), a = a.sibling; null !== a;)Sg(a, b, c), a = a.sibling;
    }
    function Tg(a, b, c) {
        var d = a.tag;
        if (5 === d || 6 === d) a = a.stateNode, b ? ob(c, a, b) : jb(c, a);
        else if (4 !== d && (a = a.child, null !== a)) for(Tg(a, b, c), a = a.sibling; null !== a;)Tg(a, b, c), a = a.sibling;
    }
    var V = null, Ug = !1;
    function Vg(a, b, c) {
        for(c = c.child; null !== c;)Wg(a, b, c), c = c.sibling;
    }
    function Wg(a, b, c) {
        if (Sc && "function" === typeof Sc.onCommitFiberUnmount) try {
            Sc.onCommitFiberUnmount(Rc, c);
        } catch (h) {}
        switch(c.tag){
            case 5:
                S || Ig(c, b);
            case 6:
                if (Ta) {
                    var d = V, e = Ug;
                    V = null;
                    Vg(a, b, c);
                    V = d;
                    Ug = e;
                    null !== V && (Ug ? rb(V, c.stateNode) : qb(V, c.stateNode));
                } else Vg(a, b, c);
                break;
            case 18:
                Ta && null !== V && (Ug ? Yb(V, c.stateNode) : Xb(V, c.stateNode));
                break;
            case 4:
                Ta ? (d = V, e = Ug, V = c.stateNode.containerInfo, Ug = !0, Vg(a, b, c), V = d, Ug = e) : (Ua && (d = c.stateNode.containerInfo, e = zb(d), Cb(d, e)), Vg(a, b, c));
                break;
            case 0:
            case 11:
            case 14:
            case 15:
                if (!S && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                    e = d = d.next;
                    do {
                        var f = e, g = f.destroy;
                        f = f.tag;
                        void 0 !== g && (0 !== (f & 2) ? Jg(c, b, g) : 0 !== (f & 4) && Jg(c, b, g));
                        e = e.next;
                    }while (e !== d);
                }
                Vg(a, b, c);
                break;
            case 1:
                if (!S && (Ig(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                    d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
                } catch (h) {
                    U(c, b, h);
                }
                Vg(a, b, c);
                break;
            case 21:
                Vg(a, b, c);
                break;
            case 22:
                c.mode & 1 ? (S = (d = S) || null !== c.memoizedState, Vg(a, b, c), S = d) : Vg(a, b, c);
                break;
            default:
                Vg(a, b, c);
        }
    }
    function Xg(a) {
        var b = a.updateQueue;
        if (null !== b) {
            a.updateQueue = null;
            var c = a.stateNode;
            null === c && (c = a.stateNode = new Hg);
            b.forEach(function(b) {
                var d = Yg.bind(null, a, b);
                c.has(b) || (c.add(b), b.then(d, d));
            });
        }
    }
    function Zg(a, b) {
        var c = b.deletions;
        if (null !== c) for(var d = 0; d < c.length; d++){
            var e = c[d];
            try {
                var f = a, g = b;
                if (Ta) {
                    var h = g;
                    a: for(; null !== h;){
                        switch(h.tag){
                            case 5:
                                V = h.stateNode;
                                Ug = !1;
                                break a;
                            case 3:
                                V = h.stateNode.containerInfo;
                                Ug = !0;
                                break a;
                            case 4:
                                V = h.stateNode.containerInfo;
                                Ug = !0;
                                break a;
                        }
                        h = h.return;
                    }
                    if (null === V) throw Error(n(160));
                    Wg(f, g, e);
                    V = null;
                    Ug = !1;
                } else Wg(f, g, e);
                var k = e.alternate;
                null !== k && (k.return = null);
                e.return = null;
            } catch (l) {
                U(e, b, l);
            }
        }
        if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$g(b, a), b = b.sibling;
    }
    function $g(a, b) {
        var c = a.alternate, d = a.flags;
        switch(a.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                Zg(b, a);
                ah(a);
                if (d & 4) {
                    try {
                        Mg(3, a, a.return), Ng(3, a);
                    } catch (p) {
                        U(a, a.return, p);
                    }
                    try {
                        Mg(5, a, a.return);
                    } catch (p) {
                        U(a, a.return, p);
                    }
                }
                break;
            case 1:
                Zg(b, a);
                ah(a);
                d & 512 && null !== c && Ig(c, c.return);
                break;
            case 5:
                Zg(b, a);
                ah(a);
                d & 512 && null !== c && Ig(c, c.return);
                if (Ta) {
                    if (a.flags & 32) {
                        var e = a.stateNode;
                        try {
                            sb(e);
                        } catch (p) {
                            U(a, a.return, p);
                        }
                    }
                    if (d & 4 && (e = a.stateNode, null != e)) {
                        var f = a.memoizedProps;
                        c = null !== c ? c.memoizedProps : f;
                        d = a.type;
                        b = a.updateQueue;
                        a.updateQueue = null;
                        if (null !== b) try {
                            nb(e, b, d, c, f, a);
                        } catch (p) {
                            U(a, a.return, p);
                        }
                    }
                }
                break;
            case 6:
                Zg(b, a);
                ah(a);
                if (d & 4 && Ta) {
                    if (null === a.stateNode) throw Error(n(162));
                    e = a.stateNode;
                    f = a.memoizedProps;
                    c = null !== c ? c.memoizedProps : f;
                    try {
                        lb(e, c, f);
                    } catch (p) {
                        U(a, a.return, p);
                    }
                }
                break;
            case 3:
                Zg(b, a);
                ah(a);
                if (d & 4) {
                    if (Ta && Va && null !== c && c.memoizedState.isDehydrated) try {
                        Vb(b.containerInfo);
                    } catch (p) {
                        U(a, a.return, p);
                    }
                    if (Ua) {
                        e = b.containerInfo;
                        f = b.pendingChildren;
                        try {
                            Cb(e, f);
                        } catch (p) {
                            U(a, a.return, p);
                        }
                    }
                }
                break;
            case 4:
                Zg(b, a);
                ah(a);
                if (d & 4 && Ua) {
                    f = a.stateNode;
                    e = f.containerInfo;
                    f = f.pendingChildren;
                    try {
                        Cb(e, f);
                    } catch (p) {
                        U(a, a.return, p);
                    }
                }
                break;
            case 13:
                Zg(b, a);
                ah(a);
                e = a.child;
                e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || (bh = D()));
                d & 4 && Xg(a);
                break;
            case 22:
                var g = null !== c && null !== c.memoizedState;
                a.mode & 1 ? (S = (c = S) || g, Zg(b, a), S = c) : Zg(b, a);
                ah(a);
                if (d & 8192) {
                    c = null !== a.memoizedState;
                    if ((a.stateNode.isHidden = c) && !g && 0 !== (a.mode & 1)) for(T = a, d = a.child; null !== d;){
                        for(b = T = d; null !== T;){
                            g = T;
                            var h = g.child;
                            switch(g.tag){
                                case 0:
                                case 11:
                                case 14:
                                case 15:
                                    Mg(4, g, g.return);
                                    break;
                                case 1:
                                    Ig(g, g.return);
                                    var k = g.stateNode;
                                    if ("function" === typeof k.componentWillUnmount) {
                                        var l = g, m = g.return;
                                        try {
                                            var r = l;
                                            k.props = r.memoizedProps;
                                            k.state = r.memoizedState;
                                            k.componentWillUnmount();
                                        } catch (p) {
                                            U(l, m, p);
                                        }
                                    }
                                    break;
                                case 5:
                                    Ig(g, g.return);
                                    break;
                                case 22:
                                    if (null !== g.memoizedState) {
                                        ch(b);
                                        continue;
                                    }
                            }
                            null !== h ? (h.return = g, T = h) : ch(b);
                        }
                        d = d.sibling;
                    }
                    if (Ta) {
                        a: if (d = null, Ta) for(b = a;;){
                            if (5 === b.tag) {
                                if (null === d) {
                                    d = b;
                                    try {
                                        e = b.stateNode, c ? tb(e) : vb(b.stateNode, b.memoizedProps);
                                    } catch (p) {
                                        U(a, a.return, p);
                                    }
                                }
                            } else if (6 === b.tag) {
                                if (null === d) try {
                                    f = b.stateNode, c ? ub(f) : wb(f, b.memoizedProps);
                                } catch (p) {
                                    U(a, a.return, p);
                                }
                            } else if ((22 !== b.tag && 23 !== b.tag || null === b.memoizedState || b === a) && null !== b.child) {
                                b.child.return = b;
                                b = b.child;
                                continue;
                            }
                            if (b === a) break a;
                            for(; null === b.sibling;){
                                if (null === b.return || b.return === a) break a;
                                d === b && (d = null);
                                b = b.return;
                            }
                            d === b && (d = null);
                            b.sibling.return = b.return;
                            b = b.sibling;
                        }
                    }
                }
                break;
            case 19:
                Zg(b, a);
                ah(a);
                d & 4 && Xg(a);
                break;
            case 21:
                break;
            default:
                Zg(b, a), ah(a);
        }
    }
    function ah(a) {
        var b = a.flags;
        if (b & 2) {
            try {
                if (Ta) {
                    b: {
                        for(var c = a.return; null !== c;){
                            if (Qg(c)) {
                                var d = c;
                                break b;
                            }
                            c = c.return;
                        }
                        throw Error(n(160));
                    }
                    switch(d.tag){
                        case 5:
                            var e = d.stateNode;
                            d.flags & 32 && (sb(e), d.flags &= -33);
                            var f = Rg(a);
                            Tg(a, f, e);
                            break;
                        case 3:
                        case 4:
                            var g = d.stateNode.containerInfo, h = Rg(a);
                            Sg(a, h, g);
                            break;
                        default:
                            throw Error(n(161));
                    }
                }
            } catch (k) {
                U(a, a.return, k);
            }
            a.flags &= -3;
        }
        b & 4096 && (a.flags &= -4097);
    }
    function dh(a, b, c) {
        T = a;
        eh(a, b, c);
    }
    function eh(a, b, c) {
        for(var d = 0 !== (a.mode & 1); null !== T;){
            var e = T, f = e.child;
            if (22 === e.tag && d) {
                var g = null !== e.memoizedState || Gg;
                if (!g) {
                    var h = e.alternate, k = null !== h && null !== h.memoizedState || S;
                    h = Gg;
                    var l = S;
                    Gg = g;
                    if ((S = k) && !l) for(T = e; null !== T;)g = T, k = g.child, 22 === g.tag && null !== g.memoizedState ? fh(e) : null !== k ? (k.return = g, T = k) : fh(e);
                    for(; null !== f;)T = f, eh(f, b, c), f = f.sibling;
                    T = e;
                    Gg = h;
                    S = l;
                }
                gh(a, b, c);
            } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, T = f) : gh(a, b, c);
        }
    }
    function gh(a) {
        for(; null !== T;){
            var b = T;
            if (0 !== (b.flags & 8772)) {
                var c = b.alternate;
                try {
                    if (0 !== (b.flags & 8772)) switch(b.tag){
                        case 0:
                        case 11:
                        case 15:
                            S || Ng(5, b);
                            break;
                        case 1:
                            var d = b.stateNode;
                            if (b.flags & 4 && !S) {
                                if (null === c) d.componentDidMount();
                                else {
                                    var e = b.elementType === b.type ? c.memoizedProps : xf(b.type, c.memoizedProps);
                                    d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                                }
                            }
                            var f = b.updateQueue;
                            null !== f && me(b, f, d);
                            break;
                        case 3:
                            var g = b.updateQueue;
                            if (null !== g) {
                                c = null;
                                if (null !== b.child) switch(b.child.tag){
                                    case 5:
                                        c = Ea(b.child.stateNode);
                                        break;
                                    case 1:
                                        c = b.child.stateNode;
                                }
                                me(b, g, c);
                            }
                            break;
                        case 5:
                            var h = b.stateNode;
                            null === c && b.flags & 4 && mb(h, b.type, b.memoizedProps, b);
                            break;
                        case 6:
                            break;
                        case 4:
                            break;
                        case 12:
                            break;
                        case 13:
                            if (Va && null === b.memoizedState) {
                                var k = b.alternate;
                                if (null !== k) {
                                    var l = k.memoizedState;
                                    if (null !== l) {
                                        var m = l.dehydrated;
                                        null !== m && Wb(m);
                                    }
                                }
                            }
                            break;
                        case 19:
                        case 17:
                        case 21:
                        case 22:
                        case 23:
                        case 25:
                            break;
                        default:
                            throw Error(n(163));
                    }
                    S || b.flags & 512 && Og(b);
                } catch (r) {
                    U(b, b.return, r);
                }
            }
            if (b === a) {
                T = null;
                break;
            }
            c = b.sibling;
            if (null !== c) {
                c.return = b.return;
                T = c;
                break;
            }
            T = b.return;
        }
    }
    function ch(a) {
        for(; null !== T;){
            var b = T;
            if (b === a) {
                T = null;
                break;
            }
            var c = b.sibling;
            if (null !== c) {
                c.return = b.return;
                T = c;
                break;
            }
            T = b.return;
        }
    }
    function fh(a) {
        for(; null !== T;){
            var b = T;
            try {
                switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        var c = b.return;
                        try {
                            Ng(4, b);
                        } catch (k) {
                            U(b, c, k);
                        }
                        break;
                    case 1:
                        var d = b.stateNode;
                        if ("function" === typeof d.componentDidMount) {
                            var e = b.return;
                            try {
                                d.componentDidMount();
                            } catch (k) {
                                U(b, e, k);
                            }
                        }
                        var f = b.return;
                        try {
                            Og(b);
                        } catch (k) {
                            U(b, f, k);
                        }
                        break;
                    case 5:
                        var g = b.return;
                        try {
                            Og(b);
                        } catch (k) {
                            U(b, g, k);
                        }
                }
            } catch (k) {
                U(b, b.return, k);
            }
            if (b === a) {
                T = null;
                break;
            }
            var h = b.sibling;
            if (null !== h) {
                h.return = b.return;
                T = h;
                break;
            }
            T = b.return;
        }
    }
    var hh = 0, ih = 1, jh = 2, kh = 3, lh = 4;
    if ("function" === typeof Symbol && Symbol.for) {
        var mh = Symbol.for;
        hh = mh("selector.component");
        ih = mh("selector.has_pseudo_class");
        jh = mh("selector.role");
        kh = mh("selector.test_id");
        lh = mh("selector.text");
    }
    function nh(a) {
        var b = Wa(a);
        if (null != b) {
            if ("string" !== typeof b.memoizedProps["data-testname"]) throw Error(n(364));
            return b;
        }
        a = cb(a);
        if (null === a) throw Error(n(362));
        return a.stateNode.current;
    }
    function oh(a, b) {
        switch(b.$$typeof){
            case hh:
                if (a.type === b.value) return !0;
                break;
            case ih:
                a: {
                    b = b.value;
                    a = [
                        a,
                        0
                    ];
                    for(var c = 0; c < a.length;){
                        var d = a[c++], e = a[c++], f = b[e];
                        if (5 !== d.tag || !fb(d)) {
                            for(; null != f && oh(d, f);)e++, f = b[e];
                            if (e === b.length) {
                                b = !0;
                                break a;
                            } else for(d = d.child; null !== d;)a.push(d, e), d = d.sibling;
                        }
                    }
                    b = !1;
                }
                return b;
            case jh:
                if (5 === a.tag && gb(a.stateNode, b.value)) return !0;
                break;
            case lh:
                if (5 === a.tag || 6 === a.tag) {
                    if (a = eb(a), null !== a && 0 <= a.indexOf(b.value)) return !0;
                }
                break;
            case kh:
                if (5 === a.tag && (a = a.memoizedProps["data-testname"], "string" === typeof a && a.toLowerCase() === b.value.toLowerCase())) return !0;
                break;
            default:
                throw Error(n(365));
        }
        return !1;
    }
    function ph(a) {
        switch(a.$$typeof){
            case hh:
                return "<" + (ua(a.value) || "Unknown") + ">";
            case ih:
                return ":has(" + (ph(a) || "") + ")";
            case jh:
                return '[role="' + a.value + '"]';
            case lh:
                return '"' + a.value + '"';
            case kh:
                return '[data-testname="' + a.value + '"]';
            default:
                throw Error(n(365));
        }
    }
    function qh(a, b) {
        var c = [];
        a = [
            a,
            0
        ];
        for(var d = 0; d < a.length;){
            var e = a[d++], f = a[d++], g = b[f];
            if (5 !== e.tag || !fb(e)) {
                for(; null != g && oh(e, g);)f++, g = b[f];
                if (f === b.length) c.push(e);
                else for(e = e.child; null !== e;)a.push(e, f), e = e.sibling;
            }
        }
        return c;
    }
    function rh(a, b) {
        if (!bb) throw Error(n(363));
        a = nh(a);
        a = qh(a, b);
        b = [];
        a = Array.from(a);
        for(var c = 0; c < a.length;){
            var d = a[c++];
            if (5 === d.tag) fb(d) || b.push(d.stateNode);
            else for(d = d.child; null !== d;)a.push(d), d = d.sibling;
        }
        return b;
    }
    var sh = Math.ceil, th = da.ReactCurrentDispatcher, uh = da.ReactCurrentOwner, W = da.ReactCurrentBatchConfig, H = 0, N = null, X = null, Z = 0, $f = 0, Zf = ic(0), R = 0, vh = null, le = 0, wh = 0, xh = 0, yh = null, zh = null, bh = 0, Dg = Infinity, Ah = null;
    function Bh() {
        Dg = D() + 500;
    }
    var Jf = !1, Kf = null, Mf = null, Ch = !1, Dh = null, Eh = 0, Fh = 0, Gh = null, Hh = -1, Ih = 0;
    function O() {
        return 0 !== (H & 6) ? D() : -1 !== Hh ? Hh : Hh = D();
    }
    function tf(a) {
        if (0 === (a.mode & 1)) return 1;
        if (0 !== (H & 2) && 0 !== Z) return Z & -Z;
        if (null !== Cd.transition) return 0 === Ih && (Ih = Dc()), Ih;
        a = C;
        return 0 !== a ? a : Ya();
    }
    function af(a, b, c, d) {
        if (50 < Fh) throw Fh = 0, Gh = null, Error(n(185));
        Fc(a, c, d);
        if (0 === (H & 2) || a !== N) a === N && (0 === (H & 2) && (wh |= c), 4 === R && Jh(a, Z)), Kh(a, d), 1 === c && 0 === H && 0 === (b.mode & 1) && (Bh(), Xc && ad());
    }
    function Kh(a, b) {
        var c = a.callbackNode;
        Bc(a, b);
        var d = zc(a, a === N ? Z : 0);
        if (0 === d) null !== c && Kc(c), a.callbackNode = null, a.callbackPriority = 0;
        else if (b = d & -d, a.callbackPriority !== b) {
            null != c && Kc(c);
            if (1 === b) 0 === a.tag ? $c(Lh.bind(null, a)) : Zc(Lh.bind(null, a)), $a ? ab(function() {
                0 === (H & 6) && ad();
            }) : Jc(Nc, ad), c = null;
            else {
                switch(Ic(d)){
                    case 1:
                        c = Nc;
                        break;
                    case 4:
                        c = Oc;
                        break;
                    case 16:
                        c = Pc;
                        break;
                    case 536870912:
                        c = Qc;
                        break;
                    default:
                        c = Pc;
                }
                c = Mh(c, Nh.bind(null, a));
            }
            a.callbackPriority = b;
            a.callbackNode = c;
        }
    }
    function Nh(a, b) {
        Hh = -1;
        Ih = 0;
        if (0 !== (H & 6)) throw Error(n(327));
        var c = a.callbackNode;
        if (Oh() && a.callbackNode !== c) return null;
        var d = zc(a, a === N ? Z : 0);
        if (0 === d) return null;
        if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = Ph(a, d);
        else {
            b = d;
            var e = H;
            H |= 2;
            var f = Qh();
            if (N !== a || Z !== b) Ah = null, Bh(), Rh(a, b);
            for(;;)try {
                Sh();
                break;
            } catch (h) {
                Th(a, h);
            }
            Ud();
            th.current = f;
            H = e;
            null !== X ? b = 0 : (N = null, Z = 0, b = R);
        }
        if (0 !== b) {
            2 === b && (e = Cc(a), 0 !== e && (d = e, b = Uh(a, e)));
            if (1 === b) throw c = vh, Rh(a, 0), Jh(a, d), Kh(a, D()), c;
            if (6 === b) Jh(a, d);
            else {
                e = a.current.alternate;
                if (0 === (d & 30) && !Vh(e) && (b = Ph(a, d), 2 === b && (f = Cc(a), 0 !== f && (d = f, b = Uh(a, f))), 1 === b)) throw c = vh, Rh(a, 0), Jh(a, d), Kh(a, D()), c;
                a.finishedWork = e;
                a.finishedLanes = d;
                switch(b){
                    case 0:
                    case 1:
                        throw Error(n(345));
                    case 2:
                        Wh(a, zh, Ah);
                        break;
                    case 3:
                        Jh(a, d);
                        if ((d & 130023424) === d && (b = bh + 500 - D(), 10 < b)) {
                            if (0 !== zc(a, 0)) break;
                            e = a.suspendedLanes;
                            if ((e & d) !== d) {
                                O();
                                a.pingedLanes |= a.suspendedLanes & e;
                                break;
                            }
                            a.timeoutHandle = Pa(Wh.bind(null, a, zh, Ah), b);
                            break;
                        }
                        Wh(a, zh, Ah);
                        break;
                    case 4:
                        Jh(a, d);
                        if ((d & 4194240) === d) break;
                        b = a.eventTimes;
                        for(e = -1; 0 < d;){
                            var g = 31 - tc(d);
                            f = 1 << g;
                            g = b[g];
                            g > e && (e = g);
                            d &= ~f;
                        }
                        d = e;
                        d = D() - d;
                        d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * sh(d / 1960)) - d;
                        if (10 < d) {
                            a.timeoutHandle = Pa(Wh.bind(null, a, zh, Ah), d);
                            break;
                        }
                        Wh(a, zh, Ah);
                        break;
                    case 5:
                        Wh(a, zh, Ah);
                        break;
                    default:
                        throw Error(n(329));
                }
            }
        }
        Kh(a, D());
        return a.callbackNode === c ? Nh.bind(null, a) : null;
    }
    function Uh(a, b) {
        var c = yh;
        a.current.memoizedState.isDehydrated && (Rh(a, b).flags |= 256);
        a = Ph(a, b);
        2 !== a && (b = zh, zh = c, null !== b && Cg(b));
        return a;
    }
    function Cg(a) {
        null === zh ? zh = a : zh.push.apply(zh, a);
    }
    function Vh(a) {
        for(var b = a;;){
            if (b.flags & 16384) {
                var c = b.updateQueue;
                if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                    var e = c[d], f = e.getSnapshot;
                    e = e.value;
                    try {
                        if (!Vc(f(), e)) return !1;
                    } catch (g) {
                        return !1;
                    }
                }
            }
            c = b.child;
            if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
            else {
                if (b === a) break;
                for(; null === b.sibling;){
                    if (null === b.return || b.return === a) return !0;
                    b = b.return;
                }
                b.sibling.return = b.return;
                b = b.sibling;
            }
        }
        return !0;
    }
    function Jh(a, b) {
        b &= ~xh;
        b &= ~wh;
        a.suspendedLanes |= b;
        a.pingedLanes &= ~b;
        for(a = a.expirationTimes; 0 < b;){
            var c = 31 - tc(b), d = 1 << c;
            a[c] = -1;
            b &= ~d;
        }
    }
    function Lh(a) {
        if (0 !== (H & 6)) throw Error(n(327));
        Oh();
        var b = zc(a, 0);
        if (0 === (b & 1)) return Kh(a, D()), null;
        var c = Ph(a, b);
        if (0 !== a.tag && 2 === c) {
            var d = Cc(a);
            0 !== d && (b = d, c = Uh(a, d));
        }
        if (1 === c) throw c = vh, Rh(a, 0), Jh(a, b), Kh(a, D()), c;
        if (6 === c) throw Error(n(345));
        a.finishedWork = a.current.alternate;
        a.finishedLanes = b;
        Wh(a, zh, Ah);
        Kh(a, D());
        return null;
    }
    function Xh(a) {
        null !== Dh && 0 === Dh.tag && 0 === (H & 6) && Oh();
        var b = H;
        H |= 1;
        var c = W.transition, d = C;
        try {
            if (W.transition = null, C = 1, a) return a();
        } finally{
            C = d, W.transition = c, H = b, 0 === (H & 6) && ad();
        }
    }
    function Eg() {
        $f = Zf.current;
        q(Zf);
    }
    function Rh(a, b) {
        a.finishedWork = null;
        a.finishedLanes = 0;
        var c = a.timeoutHandle;
        c !== Ra && (a.timeoutHandle = Ra, Qa(c));
        if (null !== X) for(c = X.return; null !== c;){
            var d = c;
            nd(d);
            switch(d.tag){
                case 1:
                    d = d.type.childContextTypes;
                    null !== d && void 0 !== d && nc();
                    break;
                case 3:
                    te();
                    q(z);
                    q(x);
                    ye();
                    break;
                case 5:
                    ve(d);
                    break;
                case 4:
                    te();
                    break;
                case 13:
                    q(I);
                    break;
                case 19:
                    q(I);
                    break;
                case 10:
                    Wd(d.type._context);
                    break;
                case 22:
                case 23:
                    Eg();
            }
            c = c.return;
        }
        N = a;
        X = a = Jd(a.current, null);
        Z = $f = b;
        R = 0;
        vh = null;
        xh = wh = le = 0;
        zh = yh = null;
        if (null !== $d) {
            for(b = 0; b < $d.length; b++)if (c = $d[b], d = c.interleaved, null !== d) {
                c.interleaved = null;
                var e = d.next, f = c.pending;
                if (null !== f) {
                    var g = f.next;
                    f.next = e;
                    d.next = g;
                }
                c.pending = d;
            }
            $d = null;
        }
        return a;
    }
    function Th(a, b) {
        do {
            var c = X;
            try {
                Ud();
                ze.current = Le;
                if (Ce) {
                    for(var d = J.memoizedState; null !== d;){
                        var e = d.queue;
                        null !== e && (e.pending = null);
                        d = d.next;
                    }
                    Ce = !1;
                }
                Be = 0;
                L = K = J = null;
                De = !1;
                Ee = 0;
                uh.current = null;
                if (null === c || null === c.return) {
                    R = 1;
                    vh = b;
                    X = null;
                    break;
                }
                a: {
                    var f = a, g = c.return, h = c, k = b;
                    b = Z;
                    h.flags |= 32768;
                    if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                        var l = k, m = h, r = m.tag;
                        if (0 === (m.mode & 1) && (0 === r || 11 === r || 15 === r)) {
                            var p = m.alternate;
                            p ? (m.updateQueue = p.updateQueue, m.memoizedState = p.memoizedState, m.lanes = p.lanes) : (m.updateQueue = null, m.memoizedState = null);
                        }
                        var B = Pf(g);
                        if (null !== B) {
                            B.flags &= -257;
                            Qf(B, g, h, f, b);
                            B.mode & 1 && Nf(f, l, b);
                            b = B;
                            k = l;
                            var w = b.updateQueue;
                            if (null === w) {
                                var Y = new Set;
                                Y.add(k);
                                b.updateQueue = Y;
                            } else w.add(k);
                            break a;
                        } else {
                            if (0 === (b & 1)) {
                                Nf(f, l, b);
                                ng();
                                break a;
                            }
                            k = Error(n(426));
                        }
                    } else if (F && h.mode & 1) {
                        var ya = Pf(g);
                        if (null !== ya) {
                            0 === (ya.flags & 65536) && (ya.flags |= 256);
                            Qf(ya, g, h, f, b);
                            Bd(Ef(k, h));
                            break a;
                        }
                    }
                    f = k = Ef(k, h);
                    4 !== R && (R = 2);
                    null === yh ? yh = [
                        f
                    ] : yh.push(f);
                    f = g;
                    do {
                        switch(f.tag){
                            case 3:
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var E = If(f, k, b);
                                je(f, E);
                                break a;
                            case 1:
                                h = k;
                                var u = f.type, t = f.stateNode;
                                if (0 === (f.flags & 128) && ("function" === typeof u.getDerivedStateFromError || null !== t && "function" === typeof t.componentDidCatch && (null === Mf || !Mf.has(t)))) {
                                    f.flags |= 65536;
                                    b &= -b;
                                    f.lanes |= b;
                                    var Db = Lf(f, h, b);
                                    je(f, Db);
                                    break a;
                                }
                        }
                        f = f.return;
                    }while (null !== f);
                }
                Yh(c);
            } catch (lc) {
                b = lc;
                X === c && null !== c && (X = c = c.return);
                continue;
            }
            break;
        }while (1);
    }
    function Qh() {
        var a = th.current;
        th.current = Le;
        return null === a ? Le : a;
    }
    function ng() {
        if (0 === R || 3 === R || 2 === R) R = 4;
        null === N || 0 === (le & 268435455) && 0 === (wh & 268435455) || Jh(N, Z);
    }
    function Ph(a, b) {
        var c = H;
        H |= 2;
        var d = Qh();
        if (N !== a || Z !== b) Ah = null, Rh(a, b);
        for(;;)try {
            Zh();
            break;
        } catch (e) {
            Th(a, e);
        }
        Ud();
        H = c;
        th.current = d;
        if (null !== X) throw Error(n(261));
        N = null;
        Z = 0;
        return R;
    }
    function Zh() {
        for(; null !== X;)$h(X);
    }
    function Sh() {
        for(; null !== X && !Lc();)$h(X);
    }
    function $h(a) {
        var b = ai(a.alternate, a, $f);
        a.memoizedProps = a.pendingProps;
        null === b ? Yh(a) : X = b;
        uh.current = null;
    }
    function Yh(a) {
        var b = a;
        do {
            var c = b.alternate;
            a = b.return;
            if (0 === (b.flags & 32768)) {
                if (c = Bg(c, b, $f), null !== c) {
                    X = c;
                    return;
                }
            } else {
                c = Fg(c, b);
                if (null !== c) {
                    c.flags &= 32767;
                    X = c;
                    return;
                }
                if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
                else {
                    R = 6;
                    X = null;
                    return;
                }
            }
            b = b.sibling;
            if (null !== b) {
                X = b;
                return;
            }
            X = b = a;
        }while (null !== b);
        0 === R && (R = 5);
    }
    function Wh(a, b, c) {
        var d = C, e = W.transition;
        try {
            W.transition = null, C = 1, bi(a, b, c, d);
        } finally{
            W.transition = e, C = d;
        }
        return null;
    }
    function bi(a, b, c, d) {
        do Oh();
        while (null !== Dh);
        if (0 !== (H & 6)) throw Error(n(327));
        c = a.finishedWork;
        var e = a.finishedLanes;
        if (null === c) return null;
        a.finishedWork = null;
        a.finishedLanes = 0;
        if (c === a.current) throw Error(n(177));
        a.callbackNode = null;
        a.callbackPriority = 0;
        var f = c.lanes | c.childLanes;
        Gc(a, f);
        a === N && (X = N = null, Z = 0);
        0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || Ch || (Ch = !0, Mh(Pc, function() {
            Oh();
            return null;
        }));
        f = 0 !== (c.flags & 15990);
        if (0 !== (c.subtreeFlags & 15990) || f) {
            f = W.transition;
            W.transition = null;
            var g = C;
            C = 1;
            var h = H;
            H |= 4;
            uh.current = null;
            Lg(a, c);
            $g(c, a);
            Ia(a.containerInfo);
            a.current = c;
            dh(c, a, e);
            Mc();
            H = h;
            C = g;
            W.transition = f;
        } else a.current = c;
        Ch && (Ch = !1, Dh = a, Eh = e);
        f = a.pendingLanes;
        0 === f && (Mf = null);
        Tc(c.stateNode, d);
        Kh(a, D());
        if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
            componentStack: e.stack,
            digest: e.digest
        });
        if (Jf) throw Jf = !1, a = Kf, Kf = null, a;
        0 !== (Eh & 1) && 0 !== a.tag && Oh();
        f = a.pendingLanes;
        0 !== (f & 1) ? a === Gh ? Fh++ : (Fh = 0, Gh = a) : Fh = 0;
        ad();
        return null;
    }
    function Oh() {
        if (null !== Dh) {
            var a = Ic(Eh), b = W.transition, c = C;
            try {
                W.transition = null;
                C = 16 > a ? 16 : a;
                if (null === Dh) var d = !1;
                else {
                    a = Dh;
                    Dh = null;
                    Eh = 0;
                    if (0 !== (H & 6)) throw Error(n(331));
                    var e = H;
                    H |= 4;
                    for(T = a.current; null !== T;){
                        var f = T, g = f.child;
                        if (0 !== (T.flags & 16)) {
                            var h = f.deletions;
                            if (null !== h) {
                                for(var k = 0; k < h.length; k++){
                                    var l = h[k];
                                    for(T = l; null !== T;){
                                        var m = T;
                                        switch(m.tag){
                                            case 0:
                                            case 11:
                                            case 15:
                                                Mg(8, m, f);
                                        }
                                        var r = m.child;
                                        if (null !== r) r.return = m, T = r;
                                        else for(; null !== T;){
                                            m = T;
                                            var p = m.sibling, B = m.return;
                                            Pg(m);
                                            if (m === l) {
                                                T = null;
                                                break;
                                            }
                                            if (null !== p) {
                                                p.return = B;
                                                T = p;
                                                break;
                                            }
                                            T = B;
                                        }
                                    }
                                }
                                var w = f.alternate;
                                if (null !== w) {
                                    var Y = w.child;
                                    if (null !== Y) {
                                        w.child = null;
                                        do {
                                            var ya = Y.sibling;
                                            Y.sibling = null;
                                            Y = ya;
                                        }while (null !== Y);
                                    }
                                }
                                T = f;
                            }
                        }
                        if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, T = g;
                        else b: for(; null !== T;){
                            f = T;
                            if (0 !== (f.flags & 2048)) switch(f.tag){
                                case 0:
                                case 11:
                                case 15:
                                    Mg(9, f, f.return);
                            }
                            var E = f.sibling;
                            if (null !== E) {
                                E.return = f.return;
                                T = E;
                                break b;
                            }
                            T = f.return;
                        }
                    }
                    var u = a.current;
                    for(T = u; null !== T;){
                        g = T;
                        var t = g.child;
                        if (0 !== (g.subtreeFlags & 2064) && null !== t) t.return = g, T = t;
                        else b: for(g = u; null !== T;){
                            h = T;
                            if (0 !== (h.flags & 2048)) try {
                                switch(h.tag){
                                    case 0:
                                    case 11:
                                    case 15:
                                        Ng(9, h);
                                }
                            } catch (lc) {
                                U(h, h.return, lc);
                            }
                            if (h === g) {
                                T = null;
                                break b;
                            }
                            var Db = h.sibling;
                            if (null !== Db) {
                                Db.return = h.return;
                                T = Db;
                                break b;
                            }
                            T = h.return;
                        }
                    }
                    H = e;
                    ad();
                    if (Sc && "function" === typeof Sc.onPostCommitFiberRoot) try {
                        Sc.onPostCommitFiberRoot(Rc, a);
                    } catch (lc) {}
                    d = !0;
                }
                return d;
            } finally{
                C = c, W.transition = b;
            }
        }
        return !1;
    }
    function ci(a, b, c) {
        b = Ef(c, b);
        b = If(a, b, 1);
        a = he(a, b, 1);
        b = O();
        null !== a && (Fc(a, 1, b), Kh(a, b));
    }
    function U(a, b, c) {
        if (3 === a.tag) ci(a, a, c);
        else for(; null !== b;){
            if (3 === b.tag) {
                ci(b, a, c);
                break;
            } else if (1 === b.tag) {
                var d = b.stateNode;
                if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Mf || !Mf.has(d))) {
                    a = Ef(c, a);
                    a = Lf(b, a, 1);
                    b = he(b, a, 1);
                    a = O();
                    null !== b && (Fc(b, 1, a), Kh(b, a));
                    break;
                }
            }
            b = b.return;
        }
    }
    function Of(a, b, c) {
        var d = a.pingCache;
        null !== d && d.delete(b);
        b = O();
        a.pingedLanes |= a.suspendedLanes & c;
        N === a && (Z & c) === c && (4 === R || 3 === R && (Z & 130023424) === Z && 500 > D() - bh ? Rh(a, 0) : xh |= c);
        Kh(a, b);
    }
    function di(a, b) {
        0 === b && (0 === (a.mode & 1) ? b = 1 : (b = xc, xc <<= 1, 0 === (xc & 130023424) && (xc = 4194304)));
        var c = O();
        a = ce(a, b);
        null !== a && (Fc(a, b, c), Kh(a, c));
    }
    function og(a) {
        var b = a.memoizedState, c = 0;
        null !== b && (c = b.retryLane);
        di(a, c);
    }
    function Yg(a, b) {
        var c = 0;
        switch(a.tag){
            case 13:
                var d = a.stateNode;
                var e = a.memoizedState;
                null !== e && (c = e.retryLane);
                break;
            case 19:
                d = a.stateNode;
                break;
            default:
                throw Error(n(314));
        }
        null !== d && d.delete(b);
        di(a, c);
    }
    var ai;
    ai = function(a, b, c) {
        if (null !== a) {
            if (a.memoizedProps !== b.pendingProps || z.current) G = !0;
            else {
                if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return G = !1, sg(a, b, c);
                G = 0 !== (a.flags & 131072) ? !0 : !1;
            }
        } else G = !1, F && 0 !== (b.flags & 1048576) && ld(b, ed, b.index);
        b.lanes = 0;
        switch(b.tag){
            case 2:
                var d = b.type;
                cg(a, b);
                a = b.pendingProps;
                var e = mc(b, x.current);
                Yd(b, c);
                e = He(null, b, d, a, e, c);
                var f = Me();
                b.flags |= 1;
                "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, A(d) ? (f = !0, qc(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, ee(b), e.updater = zf, b.stateNode = e, e._reactInternals = b, Df(b, d, a, c), b = dg(null, b, d, !0, f, c)) : (b.tag = 0, F && f && md(b), P(null, b, e, c), b = b.child);
                return b;
            case 16:
                d = b.elementType;
                a: {
                    cg(a, b);
                    a = b.pendingProps;
                    e = d._init;
                    d = e(d._payload);
                    b.type = d;
                    e = b.tag = ei(d);
                    a = xf(d, a);
                    switch(e){
                        case 0:
                            b = Xf(null, b, d, a, c);
                            break a;
                        case 1:
                            b = bg(null, b, d, a, c);
                            break a;
                        case 11:
                            b = Sf(null, b, d, a, c);
                            break a;
                        case 14:
                            b = Uf(null, b, d, xf(d.type, a), c);
                            break a;
                    }
                    throw Error(n(306, d, ""));
                }
                return b;
            case 0:
                return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : xf(d, e), Xf(a, b, d, e, c);
            case 1:
                return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : xf(d, e), bg(a, b, d, e, c);
            case 3:
                a: {
                    eg(b);
                    if (null === a) throw Error(n(387));
                    d = b.pendingProps;
                    f = b.memoizedState;
                    e = f.element;
                    fe(a, b);
                    ke(b, d, null, c);
                    var g = b.memoizedState;
                    d = g.element;
                    if (Va && f.isDehydrated) {
                        if (f = {
                            element: d,
                            isDehydrated: !1,
                            cache: g.cache,
                            pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                            transitions: g.transitions
                        }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                            e = Ef(Error(n(423)), b);
                            b = fg(a, b, d, c, e);
                            break a;
                        } else if (d !== e) {
                            e = Ef(Error(n(424)), b);
                            b = fg(a, b, d, c, e);
                            break a;
                        } else for(Va && (pd = Pb(b.stateNode.containerInfo), od = b, F = !0, rd = null, qd = !1), c = Pd(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                    } else {
                        Ad();
                        if (d === e) {
                            b = Tf(a, b, c);
                            break a;
                        }
                        P(a, b, d, c);
                    }
                    b = b.child;
                }
                return b;
            case 5:
                return ue(b), null === a && wd(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, Na(d, e) ? g = null : null !== f && Na(d, f) && (b.flags |= 32), ag(a, b), P(a, b, g, c), b.child;
            case 6:
                return null === a && wd(b), null;
            case 13:
                return ig(a, b, c);
            case 4:
                return se(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Od(b, null, d, c) : P(a, b, d, c), b.child;
            case 11:
                return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : xf(d, e), Sf(a, b, d, e, c);
            case 7:
                return P(a, b, b.pendingProps, c), b.child;
            case 8:
                return P(a, b, b.pendingProps.children, c), b.child;
            case 12:
                return P(a, b, b.pendingProps.children, c), b.child;
            case 10:
                a: {
                    d = b.type._context;
                    e = b.pendingProps;
                    f = b.memoizedProps;
                    g = e.value;
                    Vd(b, d, g);
                    if (null !== f) {
                        if (Vc(f.value, g)) {
                            if (f.children === e.children && !z.current) {
                                b = Tf(a, b, c);
                                break a;
                            }
                        } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                            var h = f.dependencies;
                            if (null !== h) {
                                g = f.child;
                                for(var k = h.firstContext; null !== k;){
                                    if (k.context === d) {
                                        if (1 === f.tag) {
                                            k = ge(-1, c & -c);
                                            k.tag = 2;
                                            var l = f.updateQueue;
                                            if (null !== l) {
                                                l = l.shared;
                                                var m = l.pending;
                                                null === m ? k.next = k : (k.next = m.next, m.next = k);
                                                l.pending = k;
                                            }
                                        }
                                        f.lanes |= c;
                                        k = f.alternate;
                                        null !== k && (k.lanes |= c);
                                        Xd(f.return, c, b);
                                        h.lanes |= c;
                                        break;
                                    }
                                    k = k.next;
                                }
                            } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                            else if (18 === f.tag) {
                                g = f.return;
                                if (null === g) throw Error(n(341));
                                g.lanes |= c;
                                h = g.alternate;
                                null !== h && (h.lanes |= c);
                                Xd(g, c, b);
                                g = f.sibling;
                            } else g = f.child;
                            if (null !== g) g.return = f;
                            else for(g = f; null !== g;){
                                if (g === b) {
                                    g = null;
                                    break;
                                }
                                f = g.sibling;
                                if (null !== f) {
                                    f.return = g.return;
                                    g = f;
                                    break;
                                }
                                g = g.return;
                            }
                            f = g;
                        }
                    }
                    P(a, b, e.children, c);
                    b = b.child;
                }
                return b;
            case 9:
                return e = b.type, d = b.pendingProps.children, Yd(b, c), e = Zd(e), d = d(e), b.flags |= 1, P(a, b, d, c), b.child;
            case 14:
                return d = b.type, e = xf(d, b.pendingProps), e = xf(d.type, e), Uf(a, b, d, e, c);
            case 15:
                return Wf(a, b, b.type, b.pendingProps, c);
            case 17:
                return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : xf(d, e), cg(a, b), b.tag = 1, A(d) ? (a = !0, qc(b)) : a = !1, Yd(b, c), Bf(b, d, e), Df(b, d, e, c), dg(null, b, d, !0, a, c);
            case 19:
                return rg(a, b, c);
            case 22:
                return Yf(a, b, c);
        }
        throw Error(n(156, b.tag));
    };
    function Mh(a, b) {
        return Jc(a, b);
    }
    function fi(a, b, c, d) {
        this.tag = a;
        this.key = c;
        this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
        this.index = 0;
        this.ref = null;
        this.pendingProps = b;
        this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
        this.mode = d;
        this.subtreeFlags = this.flags = 0;
        this.deletions = null;
        this.childLanes = this.lanes = 0;
        this.alternate = null;
    }
    function td(a, b, c, d) {
        return new fi(a, b, c, d);
    }
    function Vf(a) {
        a = a.prototype;
        return !(!a || !a.isReactComponent);
    }
    function ei(a) {
        if ("function" === typeof a) return Vf(a) ? 1 : 0;
        if (void 0 !== a && null !== a) {
            a = a.$$typeof;
            if (a === ma) return 11;
            if (a === pa) return 14;
        }
        return 2;
    }
    function Jd(a, b) {
        var c = a.alternate;
        null === c ? (c = td(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
        c.flags = a.flags & 14680064;
        c.childLanes = a.childLanes;
        c.lanes = a.lanes;
        c.child = a.child;
        c.memoizedProps = a.memoizedProps;
        c.memoizedState = a.memoizedState;
        c.updateQueue = a.updateQueue;
        b = a.dependencies;
        c.dependencies = null === b ? null : {
            lanes: b.lanes,
            firstContext: b.firstContext
        };
        c.sibling = a.sibling;
        c.index = a.index;
        c.ref = a.ref;
        return c;
    }
    function Ld(a, b, c, d, e, f) {
        var g = 2;
        d = a;
        if ("function" === typeof a) Vf(a) && (g = 1);
        else if ("string" === typeof a) g = 5;
        else a: switch(a){
            case ha:
                return Nd(c.children, e, f, b);
            case ia:
                g = 8;
                e |= 8;
                break;
            case ja:
                return a = td(12, c, b, e | 2), a.elementType = ja, a.lanes = f, a;
            case na:
                return a = td(13, c, b, e), a.elementType = na, a.lanes = f, a;
            case oa:
                return a = td(19, c, b, e), a.elementType = oa, a.lanes = f, a;
            case ra:
                return jg(c, e, f, b);
            default:
                if ("object" === typeof a && null !== a) switch(a.$$typeof){
                    case ka:
                        g = 10;
                        break a;
                    case la:
                        g = 9;
                        break a;
                    case ma:
                        g = 11;
                        break a;
                    case pa:
                        g = 14;
                        break a;
                    case qa:
                        g = 16;
                        d = null;
                        break a;
                }
                throw Error(n(130, null == a ? a : typeof a, ""));
        }
        b = td(g, c, b, e);
        b.elementType = a;
        b.type = d;
        b.lanes = f;
        return b;
    }
    function Nd(a, b, c, d) {
        a = td(7, a, d, b);
        a.lanes = c;
        return a;
    }
    function jg(a, b, c, d) {
        a = td(22, a, d, b);
        a.elementType = ra;
        a.lanes = c;
        a.stateNode = {
            isHidden: !1
        };
        return a;
    }
    function Kd(a, b, c) {
        a = td(6, a, null, b);
        a.lanes = c;
        return a;
    }
    function Md(a, b, c) {
        b = td(4, null !== a.children ? a.children : [], a.key, b);
        b.lanes = c;
        b.stateNode = {
            containerInfo: a.containerInfo,
            pendingChildren: null,
            implementation: a.implementation
        };
        return b;
    }
    function gi(a, b, c, d, e) {
        this.tag = b;
        this.containerInfo = a;
        this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
        this.timeoutHandle = Ra;
        this.callbackNode = this.pendingContext = this.context = null;
        this.callbackPriority = 0;
        this.eventTimes = Ec(0);
        this.expirationTimes = Ec(-1);
        this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
        this.entanglements = Ec(0);
        this.identifierPrefix = d;
        this.onRecoverableError = e;
        Va && (this.mutableSourceEagerHydrationData = null);
    }
    function hi(a, b, c, d, e, f, g, h, k) {
        a = new gi(a, b, c, h, k);
        1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
        f = td(3, null, null, b);
        a.current = f;
        f.stateNode = a;
        f.memoizedState = {
            element: d,
            isDehydrated: c,
            cache: null,
            transitions: null,
            pendingSuspenseBoundaries: null
        };
        ee(f);
        return a;
    }
    function ii(a) {
        if (!a) return jc;
        a = a._reactInternals;
        a: {
            if (wa(a) !== a || 1 !== a.tag) throw Error(n(170));
            var b = a;
            do {
                switch(b.tag){
                    case 3:
                        b = b.stateNode.context;
                        break a;
                    case 1:
                        if (A(b.type)) {
                            b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                            break a;
                        }
                }
                b = b.return;
            }while (null !== b);
            throw Error(n(171));
        }
        if (1 === a.tag) {
            var c = a.type;
            if (A(c)) return pc(a, c, b);
        }
        return b;
    }
    function ji(a) {
        var b = a._reactInternals;
        if (void 0 === b) {
            if ("function" === typeof a.render) throw Error(n(188));
            a = Object.keys(a).join(",");
            throw Error(n(268, a));
        }
        a = Aa(b);
        return null === a ? null : a.stateNode;
    }
    function ki(a, b) {
        a = a.memoizedState;
        if (null !== a && null !== a.dehydrated) {
            var c = a.retryLane;
            a.retryLane = 0 !== c && c < b ? c : b;
        }
    }
    function li(a, b) {
        ki(a, b);
        (a = a.alternate) && ki(a, b);
    }
    function mi(a) {
        a = Aa(a);
        return null === a ? null : a.stateNode;
    }
    function ni() {
        return null;
    }
    exports.attemptContinuousHydration = function(a) {
        if (13 === a.tag) {
            var b = ce(a, 134217728);
            if (null !== b) {
                var c = O();
                af(b, a, 134217728, c);
            }
            li(a, 134217728);
        }
    };
    exports.attemptDiscreteHydration = function(a) {
        if (13 === a.tag) {
            var b = ce(a, 1);
            if (null !== b) {
                var c = O();
                af(b, a, 1, c);
            }
            li(a, 1);
        }
    };
    exports.attemptHydrationAtCurrentPriority = function(a) {
        if (13 === a.tag) {
            var b = tf(a), c = ce(a, b);
            if (null !== c) {
                var d = O();
                af(c, a, b, d);
            }
            li(a, b);
        }
    };
    exports.attemptSynchronousHydration = function(a) {
        switch(a.tag){
            case 3:
                var b = a.stateNode;
                if (b.current.memoizedState.isDehydrated) {
                    var c = yc(b.pendingLanes);
                    0 !== c && (Hc(b, c | 1), Kh(b, D()), 0 === (H & 6) && (Bh(), ad()));
                }
                break;
            case 13:
                Xh(function() {
                    var b = ce(a, 1);
                    if (null !== b) {
                        var c = O();
                        af(b, a, 1, c);
                    }
                }), li(a, 1);
        }
    };
    exports.batchedUpdates = function(a, b) {
        var c = H;
        H |= 1;
        try {
            return a(b);
        } finally{
            H = c, 0 === H && (Bh(), Xc && ad());
        }
    };
    exports.createComponentSelector = function(a) {
        return {
            $$typeof: hh,
            value: a
        };
    };
    exports.createContainer = function(a, b, c, d, e, f, g) {
        return hi(a, b, !1, null, c, d, e, f, g);
    };
    exports.createHasPseudoClassSelector = function(a) {
        return {
            $$typeof: ih,
            value: a
        };
    };
    exports.createHydrationContainer = function(a, b, c, d, e, f, g, h, k) {
        a = hi(c, d, !0, a, e, f, g, h, k);
        a.context = ii(null);
        c = a.current;
        d = O();
        e = tf(c);
        f = ge(d, e);
        f.callback = void 0 !== b && null !== b ? b : null;
        he(c, f, e);
        a.current.lanes = e;
        Fc(a, e, d);
        Kh(a, d);
        return a;
    };
    exports.createPortal = function(a, b, c) {
        var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
        return {
            $$typeof: fa,
            key: null == d ? null : "" + d,
            children: a,
            containerInfo: b,
            implementation: c
        };
    };
    exports.createRoleSelector = function(a) {
        return {
            $$typeof: jh,
            value: a
        };
    };
    exports.createTestNameSelector = function(a) {
        return {
            $$typeof: kh,
            value: a
        };
    };
    exports.createTextSelector = function(a) {
        return {
            $$typeof: lh,
            value: a
        };
    };
    exports.deferredUpdates = function(a) {
        var b = C, c = W.transition;
        try {
            return W.transition = null, C = 16, a();
        } finally{
            C = b, W.transition = c;
        }
    };
    exports.discreteUpdates = function(a, b, c, d, e) {
        var f = C, g = W.transition;
        try {
            return W.transition = null, C = 1, a(b, c, d, e);
        } finally{
            C = f, W.transition = g, 0 === H && Bh();
        }
    };
    exports.findAllNodes = rh;
    exports.findBoundingRects = function(a, b) {
        if (!bb) throw Error(n(363));
        b = rh(a, b);
        a = [];
        for(var c = 0; c < b.length; c++)a.push(db(b[c]));
        for(b = a.length - 1; 0 < b; b--){
            c = a[b];
            for(var d = c.x, e = d + c.width, f = c.y, g = f + c.height, h = b - 1; 0 <= h; h--)if (b !== h) {
                var k = a[h], l = k.x, m = l + k.width, r = k.y, p = r + k.height;
                if (d >= l && f >= r && e <= m && g <= p) {
                    a.splice(b, 1);
                    break;
                } else if (!(d !== l || c.width !== k.width || p < f || r > g)) {
                    r > f && (k.height += r - f, k.y = f);
                    p < g && (k.height = g - r);
                    a.splice(b, 1);
                    break;
                } else if (!(f !== r || c.height !== k.height || m < d || l > e)) {
                    l > d && (k.width += l - d, k.x = d);
                    m < e && (k.width = e - l);
                    a.splice(b, 1);
                    break;
                }
            }
        }
        return a;
    };
    exports.findHostInstance = ji;
    exports.findHostInstanceWithNoPortals = function(a) {
        a = za(a);
        a = null !== a ? Ca(a) : null;
        return null === a ? null : a.stateNode;
    };
    exports.findHostInstanceWithWarning = function(a) {
        return ji(a);
    };
    exports.flushControlled = function(a) {
        var b = H;
        H |= 1;
        var c = W.transition, d = C;
        try {
            W.transition = null, C = 1, a();
        } finally{
            C = d, W.transition = c, H = b, 0 === H && (Bh(), ad());
        }
    };
    exports.flushPassiveEffects = Oh;
    exports.flushSync = Xh;
    exports.focusWithin = function(a, b) {
        if (!bb) throw Error(n(363));
        a = nh(a);
        b = qh(a, b);
        b = Array.from(b);
        for(a = 0; a < b.length;){
            var c = b[a++];
            if (!fb(c)) {
                if (5 === c.tag && hb(c.stateNode)) return !0;
                for(c = c.child; null !== c;)b.push(c), c = c.sibling;
            }
        }
        return !1;
    };
    exports.getCurrentUpdatePriority = function() {
        return C;
    };
    exports.getFindAllNodesFailureDescription = function(a, b) {
        if (!bb) throw Error(n(363));
        var c = 0, d = [];
        a = [
            nh(a),
            0
        ];
        for(var e = 0; e < a.length;){
            var f = a[e++], g = a[e++], h = b[g];
            if (5 !== f.tag || !fb(f)) {
                if (oh(f, h) && (d.push(ph(h)), g++, g > c && (c = g)), g < b.length) for(f = f.child; null !== f;)a.push(f, g), f = f.sibling;
            }
        }
        if (c < b.length) {
            for(a = []; c < b.length; c++)a.push(ph(b[c]));
            return "findAllNodes was able to match part of the selector:\n  " + (d.join(" > ") + "\n\nNo matching component was found for:\n  ") + a.join(" > ");
        }
        return null;
    };
    exports.getPublicRootInstance = function(a) {
        a = a.current;
        if (!a.child) return null;
        switch(a.child.tag){
            case 5:
                return Ea(a.child.stateNode);
            default:
                return a.child.stateNode;
        }
    };
    exports.injectIntoDevTools = function(a) {
        a = {
            bundleType: a.bundleType,
            version: a.version,
            rendererPackageName: a.rendererPackageName,
            rendererConfig: a.rendererConfig,
            overrideHookState: null,
            overrideHookStateDeletePath: null,
            overrideHookStateRenamePath: null,
            overrideProps: null,
            overridePropsDeletePath: null,
            overridePropsRenamePath: null,
            setErrorHandler: null,
            setSuspenseHandler: null,
            scheduleUpdate: null,
            currentDispatcherRef: da.ReactCurrentDispatcher,
            findHostInstanceByFiber: mi,
            findFiberByHostInstance: a.findFiberByHostInstance || ni,
            findHostInstancesForRefresh: null,
            scheduleRefresh: null,
            scheduleRoot: null,
            setRefreshHandler: null,
            getCurrentFiber: null,
            reconcilerVersion: "18.3.1"
        };
        if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) a = !1;
        else {
            var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;
            if (b.isDisabled || !b.supportsFiber) a = !0;
            else {
                try {
                    Rc = b.inject(a), Sc = b;
                } catch (c) {}
                a = b.checkDCE ? !0 : !1;
            }
        }
        return a;
    };
    exports.isAlreadyRendering = function() {
        return !1;
    };
    exports.observeVisibleRects = function(a, b, c, d) {
        if (!bb) throw Error(n(363));
        a = rh(a, b);
        var e = ib(a, c, d).disconnect;
        return {
            disconnect: function() {
                e();
            }
        };
    };
    exports.registerMutableSourceForHydration = function(a, b) {
        var c = b._getVersion;
        c = c(b._source);
        null == a.mutableSourceEagerHydrationData ? a.mutableSourceEagerHydrationData = [
            b,
            c
        ] : a.mutableSourceEagerHydrationData.push(b, c);
    };
    exports.runWithPriority = function(a, b) {
        var c = C;
        try {
            return C = a, b();
        } finally{
            C = c;
        }
    };
    exports.shouldError = function() {
        return null;
    };
    exports.shouldSuspend = function() {
        return !1;
    };
    exports.updateContainer = function(a, b, c, d) {
        var e = b.current, f = O(), g = tf(e);
        c = ii(c);
        null === b.context ? b.context = c : b.pendingContext = c;
        b = ge(f, g);
        b.payload = {
            element: a
        };
        d = void 0 === d ? null : d;
        null !== d && (b.callback = d);
        a = he(e, b, g);
        null !== a && (af(a, e, g, f), ie(a, e, g));
        return g;
    };
    return exports;
};

});

parcelRegister("6cmU7", function(module, exports) {

$parcel$export(module.exports, "ConcurrentRoot", function () { return $4835a159920f0f77$export$816aac48d41c2f81; }, function (v) { return $4835a159920f0f77$export$816aac48d41c2f81 = v; });
$parcel$export(module.exports, "ContinuousEventPriority", function () { return $4835a159920f0f77$export$3bb88615cd12cb3b; }, function (v) { return $4835a159920f0f77$export$3bb88615cd12cb3b = v; });
$parcel$export(module.exports, "DefaultEventPriority", function () { return $4835a159920f0f77$export$d46163d5c045f347; }, function (v) { return $4835a159920f0f77$export$d46163d5c045f347 = v; });
$parcel$export(module.exports, "DiscreteEventPriority", function () { return $4835a159920f0f77$export$8ee75c97f0333f15; }, function (v) { return $4835a159920f0f77$export$8ee75c97f0333f15 = v; });
$parcel$export(module.exports, "IdleEventPriority", function () { return $4835a159920f0f77$export$d1c113b83e1f881a; }, function (v) { return $4835a159920f0f77$export$d1c113b83e1f881a = v; });
$parcel$export(module.exports, "LegacyRoot", function () { return $4835a159920f0f77$export$ff78c4883554845d; }, function (v) { return $4835a159920f0f77$export$ff78c4883554845d = v; });
/**
 * @license React
 * react-reconciler-constants.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4835a159920f0f77$export$816aac48d41c2f81;
var $4835a159920f0f77$export$3bb88615cd12cb3b;
var $4835a159920f0f77$export$d46163d5c045f347;
var $4835a159920f0f77$export$8ee75c97f0333f15;
var $4835a159920f0f77$export$d1c113b83e1f881a;
var $4835a159920f0f77$export$ff78c4883554845d;
"use strict";
$4835a159920f0f77$export$816aac48d41c2f81 = 1;
$4835a159920f0f77$export$3bb88615cd12cb3b = 4;
$4835a159920f0f77$export$d46163d5c045f347 = 16;
$4835a159920f0f77$export$8ee75c97f0333f15 = 1;
$4835a159920f0f77$export$d1c113b83e1f881a = 536870912;
$4835a159920f0f77$export$ff78c4883554845d = 0;

});

var $3a516b44bc0ae84b$exports = {};
"use strict";

$3a516b44bc0ae84b$exports = (parcelRequire("9uDRS"));



var $69Mlo = parcelRequire("69Mlo");
var $858f075c68333da1$export$882461b6382ed46c;
var $858f075c68333da1$export$757ceba2d55c277e;
"use strict";
var $cdb8f5f32b095fe9$exports = {};
"use strict";
function $cdb8f5f32b095fe9$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($cdb8f5f32b095fe9$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$cdb8f5f32b095fe9$var$checkDCE();

$cdb8f5f32b095fe9$exports = (parcelRequire("58tS1"));


var $858f075c68333da1$var$i;
$858f075c68333da1$export$882461b6382ed46c = $cdb8f5f32b095fe9$exports.createRoot;
$858f075c68333da1$export$757ceba2d55c277e = $cdb8f5f32b095fe9$exports.hydrateRoot;




var $69Mlo = parcelRequire("69Mlo");


var $69Mlo = parcelRequire("69Mlo");
/**
 * Based on ReactArt.js
 * Copyright (c) 2017-present Lavrenov Anton.
 * All rights reserved.
 *
 * MIT
 */ var $f1cce3c2a91bf0cf$var$PI_OVER_180 = Math.PI / 180;
function $f1cce3c2a91bf0cf$var$detectBrowser() {
    return typeof window !== "undefined" && (({}).toString.call(window) === "[object Window]" || ({}).toString.call(window) === "[object global]");
}
const $f1cce3c2a91bf0cf$export$442f1a04865e4790 = typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof WorkerGlobalScope !== "undefined" ? self : {};
const $f1cce3c2a91bf0cf$export$b9f99057a3c7692 = {
    _global: $f1cce3c2a91bf0cf$export$442f1a04865e4790,
    version: "8.4.3",
    isBrowser: $f1cce3c2a91bf0cf$var$detectBrowser(),
    isUnminified: /param/.test((function(param) {}).toString()),
    dblClickWindow: 400,
    getAngle (angle) {
        return $f1cce3c2a91bf0cf$export$b9f99057a3c7692.angleDeg ? angle * $f1cce3c2a91bf0cf$var$PI_OVER_180 : angle;
    },
    enableTrace: false,
    pointerEventsEnabled: true,
    autoDrawEnabled: true,
    hitOnDragEnabled: false,
    capturePointerEventsEnabled: false,
    _mouseListenClick: false,
    _touchListenClick: false,
    _pointerListenClick: false,
    _mouseInDblClickWindow: false,
    _touchInDblClickWindow: false,
    _pointerInDblClickWindow: false,
    _mouseDblClickPointerId: null,
    _touchDblClickPointerId: null,
    _pointerDblClickPointerId: null,
    pixelRatio: typeof window !== "undefined" && window.devicePixelRatio || 1,
    dragDistance: 3,
    angleDeg: true,
    showWarnings: true,
    dragButtons: [
        0,
        1
    ],
    isDragging () {
        return $f1cce3c2a91bf0cf$export$b9f99057a3c7692["DD"].isDragging;
    },
    isDragReady () {
        return !!$f1cce3c2a91bf0cf$export$b9f99057a3c7692["DD"].node;
    },
    releaseCanvasOnDestroy: true,
    document: $f1cce3c2a91bf0cf$export$442f1a04865e4790.document,
    _injectGlobal (Konva) {
        $f1cce3c2a91bf0cf$export$442f1a04865e4790.Konva = Konva;
    }
};
const $f1cce3c2a91bf0cf$export$f7a70d87a5e829eb = (NodeClass)=>{
    $f1cce3c2a91bf0cf$export$b9f99057a3c7692[NodeClass.prototype.getClassName()] = NodeClass;
};
$f1cce3c2a91bf0cf$export$b9f99057a3c7692._injectGlobal($f1cce3c2a91bf0cf$export$b9f99057a3c7692);



class $4d54b3632f7367db$export$563a914cafbdc389 {
    constructor(m = [
        1,
        0,
        0,
        1,
        0,
        0
    ]){
        this.dirty = false;
        this.m = m && m.slice() || [
            1,
            0,
            0,
            1,
            0,
            0
        ];
    }
    reset() {
        this.m[0] = 1;
        this.m[1] = 0;
        this.m[2] = 0;
        this.m[3] = 1;
        this.m[4] = 0;
        this.m[5] = 0;
    }
    copy() {
        return new $4d54b3632f7367db$export$563a914cafbdc389(this.m);
    }
    copyInto(tr) {
        tr.m[0] = this.m[0];
        tr.m[1] = this.m[1];
        tr.m[2] = this.m[2];
        tr.m[3] = this.m[3];
        tr.m[4] = this.m[4];
        tr.m[5] = this.m[5];
    }
    point(point) {
        var m = this.m;
        return {
            x: m[0] * point.x + m[2] * point.y + m[4],
            y: m[1] * point.x + m[3] * point.y + m[5]
        };
    }
    translate(x, y) {
        this.m[4] += this.m[0] * x + this.m[2] * y;
        this.m[5] += this.m[1] * x + this.m[3] * y;
        return this;
    }
    scale(sx, sy) {
        this.m[0] *= sx;
        this.m[1] *= sx;
        this.m[2] *= sy;
        this.m[3] *= sy;
        return this;
    }
    rotate(rad) {
        var c = Math.cos(rad);
        var s = Math.sin(rad);
        var m11 = this.m[0] * c + this.m[2] * s;
        var m12 = this.m[1] * c + this.m[3] * s;
        var m21 = this.m[0] * -s + this.m[2] * c;
        var m22 = this.m[1] * -s + this.m[3] * c;
        this.m[0] = m11;
        this.m[1] = m12;
        this.m[2] = m21;
        this.m[3] = m22;
        return this;
    }
    getTranslation() {
        return {
            x: this.m[4],
            y: this.m[5]
        };
    }
    skew(sx, sy) {
        var m11 = this.m[0] + this.m[2] * sy;
        var m12 = this.m[1] + this.m[3] * sy;
        var m21 = this.m[2] + this.m[0] * sx;
        var m22 = this.m[3] + this.m[1] * sx;
        this.m[0] = m11;
        this.m[1] = m12;
        this.m[2] = m21;
        this.m[3] = m22;
        return this;
    }
    multiply(matrix) {
        var m11 = this.m[0] * matrix.m[0] + this.m[2] * matrix.m[1];
        var m12 = this.m[1] * matrix.m[0] + this.m[3] * matrix.m[1];
        var m21 = this.m[0] * matrix.m[2] + this.m[2] * matrix.m[3];
        var m22 = this.m[1] * matrix.m[2] + this.m[3] * matrix.m[3];
        var dx = this.m[0] * matrix.m[4] + this.m[2] * matrix.m[5] + this.m[4];
        var dy = this.m[1] * matrix.m[4] + this.m[3] * matrix.m[5] + this.m[5];
        this.m[0] = m11;
        this.m[1] = m12;
        this.m[2] = m21;
        this.m[3] = m22;
        this.m[4] = dx;
        this.m[5] = dy;
        return this;
    }
    invert() {
        var d = 1 / (this.m[0] * this.m[3] - this.m[1] * this.m[2]);
        var m0 = this.m[3] * d;
        var m1 = -this.m[1] * d;
        var m2 = -this.m[2] * d;
        var m3 = this.m[0] * d;
        var m4 = d * (this.m[2] * this.m[5] - this.m[3] * this.m[4]);
        var m5 = d * (this.m[1] * this.m[4] - this.m[0] * this.m[5]);
        this.m[0] = m0;
        this.m[1] = m1;
        this.m[2] = m2;
        this.m[3] = m3;
        this.m[4] = m4;
        this.m[5] = m5;
        return this;
    }
    getMatrix() {
        return this.m;
    }
    decompose() {
        var a = this.m[0];
        var b = this.m[1];
        var c = this.m[2];
        var d = this.m[3];
        var e = this.m[4];
        var f = this.m[5];
        var delta = a * d - b * c;
        let result = {
            x: e,
            y: f,
            rotation: 0,
            scaleX: 0,
            scaleY: 0,
            skewX: 0,
            skewY: 0
        };
        if (a != 0 || b != 0) {
            var r = Math.sqrt(a * a + b * b);
            result.rotation = b > 0 ? Math.acos(a / r) : -Math.acos(a / r);
            result.scaleX = r;
            result.scaleY = delta / r;
            result.skewX = (a * c + b * d) / delta;
            result.skewY = 0;
        } else if (c != 0 || d != 0) {
            var s = Math.sqrt(c * c + d * d);
            result.rotation = Math.PI / 2 - (d > 0 ? Math.acos(-c / s) : -Math.acos(c / s));
            result.scaleX = delta / s;
            result.scaleY = s;
            result.skewX = 0;
            result.skewY = (a * c + b * d) / delta;
        }
        result.rotation = $4d54b3632f7367db$export$f8f26dd395d7e1bd._getRotation(result.rotation);
        return result;
    }
}
var $4d54b3632f7367db$var$OBJECT_ARRAY = "[object Array]", $4d54b3632f7367db$var$OBJECT_NUMBER = "[object Number]", $4d54b3632f7367db$var$OBJECT_STRING = "[object String]", $4d54b3632f7367db$var$OBJECT_BOOLEAN = "[object Boolean]", $4d54b3632f7367db$var$PI_OVER_DEG180 = Math.PI / 180, $4d54b3632f7367db$var$DEG180_OVER_PI = 180 / Math.PI, $4d54b3632f7367db$var$HASH = "#", $4d54b3632f7367db$var$EMPTY_STRING = "", $4d54b3632f7367db$var$ZERO = "0", $4d54b3632f7367db$var$KONVA_WARNING = "Konva warning: ", $4d54b3632f7367db$var$KONVA_ERROR = "Konva error: ", $4d54b3632f7367db$var$RGB_PAREN = "rgb(", $4d54b3632f7367db$var$COLORS = {
    aliceblue: [
        240,
        248,
        255
    ],
    antiquewhite: [
        250,
        235,
        215
    ],
    aqua: [
        0,
        255,
        255
    ],
    aquamarine: [
        127,
        255,
        212
    ],
    azure: [
        240,
        255,
        255
    ],
    beige: [
        245,
        245,
        220
    ],
    bisque: [
        255,
        228,
        196
    ],
    black: [
        0,
        0,
        0
    ],
    blanchedalmond: [
        255,
        235,
        205
    ],
    blue: [
        0,
        0,
        255
    ],
    blueviolet: [
        138,
        43,
        226
    ],
    brown: [
        165,
        42,
        42
    ],
    burlywood: [
        222,
        184,
        135
    ],
    cadetblue: [
        95,
        158,
        160
    ],
    chartreuse: [
        127,
        255,
        0
    ],
    chocolate: [
        210,
        105,
        30
    ],
    coral: [
        255,
        127,
        80
    ],
    cornflowerblue: [
        100,
        149,
        237
    ],
    cornsilk: [
        255,
        248,
        220
    ],
    crimson: [
        220,
        20,
        60
    ],
    cyan: [
        0,
        255,
        255
    ],
    darkblue: [
        0,
        0,
        139
    ],
    darkcyan: [
        0,
        139,
        139
    ],
    darkgoldenrod: [
        184,
        132,
        11
    ],
    darkgray: [
        169,
        169,
        169
    ],
    darkgreen: [
        0,
        100,
        0
    ],
    darkgrey: [
        169,
        169,
        169
    ],
    darkkhaki: [
        189,
        183,
        107
    ],
    darkmagenta: [
        139,
        0,
        139
    ],
    darkolivegreen: [
        85,
        107,
        47
    ],
    darkorange: [
        255,
        140,
        0
    ],
    darkorchid: [
        153,
        50,
        204
    ],
    darkred: [
        139,
        0,
        0
    ],
    darksalmon: [
        233,
        150,
        122
    ],
    darkseagreen: [
        143,
        188,
        143
    ],
    darkslateblue: [
        72,
        61,
        139
    ],
    darkslategray: [
        47,
        79,
        79
    ],
    darkslategrey: [
        47,
        79,
        79
    ],
    darkturquoise: [
        0,
        206,
        209
    ],
    darkviolet: [
        148,
        0,
        211
    ],
    deeppink: [
        255,
        20,
        147
    ],
    deepskyblue: [
        0,
        191,
        255
    ],
    dimgray: [
        105,
        105,
        105
    ],
    dimgrey: [
        105,
        105,
        105
    ],
    dodgerblue: [
        30,
        144,
        255
    ],
    firebrick: [
        178,
        34,
        34
    ],
    floralwhite: [
        255,
        255,
        240
    ],
    forestgreen: [
        34,
        139,
        34
    ],
    fuchsia: [
        255,
        0,
        255
    ],
    gainsboro: [
        220,
        220,
        220
    ],
    ghostwhite: [
        248,
        248,
        255
    ],
    gold: [
        255,
        215,
        0
    ],
    goldenrod: [
        218,
        165,
        32
    ],
    gray: [
        128,
        128,
        128
    ],
    green: [
        0,
        128,
        0
    ],
    greenyellow: [
        173,
        255,
        47
    ],
    grey: [
        128,
        128,
        128
    ],
    honeydew: [
        240,
        255,
        240
    ],
    hotpink: [
        255,
        105,
        180
    ],
    indianred: [
        205,
        92,
        92
    ],
    indigo: [
        75,
        0,
        130
    ],
    ivory: [
        255,
        255,
        240
    ],
    khaki: [
        240,
        230,
        140
    ],
    lavender: [
        230,
        230,
        250
    ],
    lavenderblush: [
        255,
        240,
        245
    ],
    lawngreen: [
        124,
        252,
        0
    ],
    lemonchiffon: [
        255,
        250,
        205
    ],
    lightblue: [
        173,
        216,
        230
    ],
    lightcoral: [
        240,
        128,
        128
    ],
    lightcyan: [
        224,
        255,
        255
    ],
    lightgoldenrodyellow: [
        250,
        250,
        210
    ],
    lightgray: [
        211,
        211,
        211
    ],
    lightgreen: [
        144,
        238,
        144
    ],
    lightgrey: [
        211,
        211,
        211
    ],
    lightpink: [
        255,
        182,
        193
    ],
    lightsalmon: [
        255,
        160,
        122
    ],
    lightseagreen: [
        32,
        178,
        170
    ],
    lightskyblue: [
        135,
        206,
        250
    ],
    lightslategray: [
        119,
        136,
        153
    ],
    lightslategrey: [
        119,
        136,
        153
    ],
    lightsteelblue: [
        176,
        196,
        222
    ],
    lightyellow: [
        255,
        255,
        224
    ],
    lime: [
        0,
        255,
        0
    ],
    limegreen: [
        50,
        205,
        50
    ],
    linen: [
        250,
        240,
        230
    ],
    magenta: [
        255,
        0,
        255
    ],
    maroon: [
        128,
        0,
        0
    ],
    mediumaquamarine: [
        102,
        205,
        170
    ],
    mediumblue: [
        0,
        0,
        205
    ],
    mediumorchid: [
        186,
        85,
        211
    ],
    mediumpurple: [
        147,
        112,
        219
    ],
    mediumseagreen: [
        60,
        179,
        113
    ],
    mediumslateblue: [
        123,
        104,
        238
    ],
    mediumspringgreen: [
        0,
        250,
        154
    ],
    mediumturquoise: [
        72,
        209,
        204
    ],
    mediumvioletred: [
        199,
        21,
        133
    ],
    midnightblue: [
        25,
        25,
        112
    ],
    mintcream: [
        245,
        255,
        250
    ],
    mistyrose: [
        255,
        228,
        225
    ],
    moccasin: [
        255,
        228,
        181
    ],
    navajowhite: [
        255,
        222,
        173
    ],
    navy: [
        0,
        0,
        128
    ],
    oldlace: [
        253,
        245,
        230
    ],
    olive: [
        128,
        128,
        0
    ],
    olivedrab: [
        107,
        142,
        35
    ],
    orange: [
        255,
        165,
        0
    ],
    orangered: [
        255,
        69,
        0
    ],
    orchid: [
        218,
        112,
        214
    ],
    palegoldenrod: [
        238,
        232,
        170
    ],
    palegreen: [
        152,
        251,
        152
    ],
    paleturquoise: [
        175,
        238,
        238
    ],
    palevioletred: [
        219,
        112,
        147
    ],
    papayawhip: [
        255,
        239,
        213
    ],
    peachpuff: [
        255,
        218,
        185
    ],
    peru: [
        205,
        133,
        63
    ],
    pink: [
        255,
        192,
        203
    ],
    plum: [
        221,
        160,
        203
    ],
    powderblue: [
        176,
        224,
        230
    ],
    purple: [
        128,
        0,
        128
    ],
    rebeccapurple: [
        102,
        51,
        153
    ],
    red: [
        255,
        0,
        0
    ],
    rosybrown: [
        188,
        143,
        143
    ],
    royalblue: [
        65,
        105,
        225
    ],
    saddlebrown: [
        139,
        69,
        19
    ],
    salmon: [
        250,
        128,
        114
    ],
    sandybrown: [
        244,
        164,
        96
    ],
    seagreen: [
        46,
        139,
        87
    ],
    seashell: [
        255,
        245,
        238
    ],
    sienna: [
        160,
        82,
        45
    ],
    silver: [
        192,
        192,
        192
    ],
    skyblue: [
        135,
        206,
        235
    ],
    slateblue: [
        106,
        90,
        205
    ],
    slategray: [
        119,
        128,
        144
    ],
    slategrey: [
        119,
        128,
        144
    ],
    snow: [
        255,
        255,
        250
    ],
    springgreen: [
        0,
        255,
        127
    ],
    steelblue: [
        70,
        130,
        180
    ],
    tan: [
        210,
        180,
        140
    ],
    teal: [
        0,
        128,
        128
    ],
    thistle: [
        216,
        191,
        216
    ],
    transparent: [
        255,
        255,
        255,
        0
    ],
    tomato: [
        255,
        99,
        71
    ],
    turquoise: [
        64,
        224,
        208
    ],
    violet: [
        238,
        130,
        238
    ],
    wheat: [
        245,
        222,
        179
    ],
    white: [
        255,
        255,
        255
    ],
    whitesmoke: [
        245,
        245,
        245
    ],
    yellow: [
        255,
        255,
        0
    ],
    yellowgreen: [
        154,
        205,
        5
    ]
}, $4d54b3632f7367db$var$RGB_REGEX = /rgb\((\d{1,3}),(\d{1,3}),(\d{1,3})\)/, $4d54b3632f7367db$var$animQueue = [];
const $4d54b3632f7367db$var$req = typeof requestAnimationFrame !== "undefined" && requestAnimationFrame || function(f) {
    setTimeout(f, 60);
};
const $4d54b3632f7367db$export$f8f26dd395d7e1bd = {
    _isElement (obj) {
        return !!(obj && obj.nodeType == 1);
    },
    _isFunction (obj) {
        return !!(obj && obj.constructor && obj.call && obj.apply);
    },
    _isPlainObject (obj) {
        return !!obj && obj.constructor === Object;
    },
    _isArray (obj) {
        return Object.prototype.toString.call(obj) === $4d54b3632f7367db$var$OBJECT_ARRAY;
    },
    _isNumber (obj) {
        return Object.prototype.toString.call(obj) === $4d54b3632f7367db$var$OBJECT_NUMBER && !isNaN(obj) && isFinite(obj);
    },
    _isString (obj) {
        return Object.prototype.toString.call(obj) === $4d54b3632f7367db$var$OBJECT_STRING;
    },
    _isBoolean (obj) {
        return Object.prototype.toString.call(obj) === $4d54b3632f7367db$var$OBJECT_BOOLEAN;
    },
    isObject (val) {
        return val instanceof Object;
    },
    isValidSelector (selector) {
        if (typeof selector !== "string") return false;
        var firstChar = selector[0];
        return firstChar === "#" || firstChar === "." || firstChar === firstChar.toUpperCase();
    },
    _sign (number) {
        if (number === 0) return 1;
        if (number > 0) return 1;
        else return -1;
    },
    requestAnimFrame (callback) {
        $4d54b3632f7367db$var$animQueue.push(callback);
        if ($4d54b3632f7367db$var$animQueue.length === 1) $4d54b3632f7367db$var$req(function() {
            const queue = $4d54b3632f7367db$var$animQueue;
            $4d54b3632f7367db$var$animQueue = [];
            queue.forEach(function(cb) {
                cb();
            });
        });
    },
    createCanvasElement () {
        var canvas = document.createElement("canvas");
        try {
            canvas.style = canvas.style || {};
        } catch (e) {}
        return canvas;
    },
    createImageElement () {
        return document.createElement("img");
    },
    _isInDocument (el) {
        while(el = el.parentNode){
            if (el == document) return true;
        }
        return false;
    },
    _urlToImage (url, callback) {
        var imageObj = $4d54b3632f7367db$export$f8f26dd395d7e1bd.createImageElement();
        imageObj.onload = function() {
            callback(imageObj);
        };
        imageObj.src = url;
    },
    _rgbToHex (r, g, b) {
        return (16777216 + (r << 16) + (g << 8) + b).toString(16).slice(1);
    },
    _hexToRgb (hex) {
        hex = hex.replace($4d54b3632f7367db$var$HASH, $4d54b3632f7367db$var$EMPTY_STRING);
        var bigint = parseInt(hex, 16);
        return {
            r: bigint >> 16 & 255,
            g: bigint >> 8 & 255,
            b: bigint & 255
        };
    },
    getRandomColor () {
        var randColor = (Math.random() * 0xffffff << 0).toString(16);
        while(randColor.length < 6)randColor = $4d54b3632f7367db$var$ZERO + randColor;
        return $4d54b3632f7367db$var$HASH + randColor;
    },
    getRGB (color) {
        var rgb;
        if (color in $4d54b3632f7367db$var$COLORS) {
            rgb = $4d54b3632f7367db$var$COLORS[color];
            return {
                r: rgb[0],
                g: rgb[1],
                b: rgb[2]
            };
        } else if (color[0] === $4d54b3632f7367db$var$HASH) return this._hexToRgb(color.substring(1));
        else if (color.substr(0, 4) === $4d54b3632f7367db$var$RGB_PAREN) {
            rgb = $4d54b3632f7367db$var$RGB_REGEX.exec(color.replace(/ /g, ""));
            return {
                r: parseInt(rgb[1], 10),
                g: parseInt(rgb[2], 10),
                b: parseInt(rgb[3], 10)
            };
        } else return {
            r: 0,
            g: 0,
            b: 0
        };
    },
    colorToRGBA (str) {
        str = str || "black";
        return $4d54b3632f7367db$export$f8f26dd395d7e1bd._namedColorToRBA(str) || $4d54b3632f7367db$export$f8f26dd395d7e1bd._hex3ColorToRGBA(str) || $4d54b3632f7367db$export$f8f26dd395d7e1bd._hex4ColorToRGBA(str) || $4d54b3632f7367db$export$f8f26dd395d7e1bd._hex6ColorToRGBA(str) || $4d54b3632f7367db$export$f8f26dd395d7e1bd._hex8ColorToRGBA(str) || $4d54b3632f7367db$export$f8f26dd395d7e1bd._rgbColorToRGBA(str) || $4d54b3632f7367db$export$f8f26dd395d7e1bd._rgbaColorToRGBA(str) || $4d54b3632f7367db$export$f8f26dd395d7e1bd._hslColorToRGBA(str);
    },
    _namedColorToRBA (str) {
        var c = $4d54b3632f7367db$var$COLORS[str.toLowerCase()];
        if (!c) return null;
        return {
            r: c[0],
            g: c[1],
            b: c[2],
            a: 1
        };
    },
    _rgbColorToRGBA (str) {
        if (str.indexOf("rgb(") === 0) {
            str = str.match(/rgb\(([^)]+)\)/)[1];
            var parts = str.split(/ *, */).map(Number);
            return {
                r: parts[0],
                g: parts[1],
                b: parts[2],
                a: 1
            };
        }
    },
    _rgbaColorToRGBA (str) {
        if (str.indexOf("rgba(") === 0) {
            str = str.match(/rgba\(([^)]+)\)/)[1];
            var parts = str.split(/ *, */).map((n, index)=>{
                if (n.slice(-1) === "%") return index === 3 ? parseInt(n) / 100 : parseInt(n) / 100 * 255;
                return Number(n);
            });
            return {
                r: parts[0],
                g: parts[1],
                b: parts[2],
                a: parts[3]
            };
        }
    },
    _hex8ColorToRGBA (str) {
        if (str[0] === "#" && str.length === 9) return {
            r: parseInt(str.slice(1, 3), 16),
            g: parseInt(str.slice(3, 5), 16),
            b: parseInt(str.slice(5, 7), 16),
            a: parseInt(str.slice(7, 9), 16) / 0xff
        };
    },
    _hex6ColorToRGBA (str) {
        if (str[0] === "#" && str.length === 7) return {
            r: parseInt(str.slice(1, 3), 16),
            g: parseInt(str.slice(3, 5), 16),
            b: parseInt(str.slice(5, 7), 16),
            a: 1
        };
    },
    _hex4ColorToRGBA (str) {
        if (str[0] === "#" && str.length === 5) return {
            r: parseInt(str[1] + str[1], 16),
            g: parseInt(str[2] + str[2], 16),
            b: parseInt(str[3] + str[3], 16),
            a: parseInt(str[4] + str[4], 16) / 0xff
        };
    },
    _hex3ColorToRGBA (str) {
        if (str[0] === "#" && str.length === 4) return {
            r: parseInt(str[1] + str[1], 16),
            g: parseInt(str[2] + str[2], 16),
            b: parseInt(str[3] + str[3], 16),
            a: 1
        };
    },
    _hslColorToRGBA (str) {
        if (/hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.test(str)) {
            const [_, ...hsl] = /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(str);
            const h = Number(hsl[0]) / 360;
            const s = Number(hsl[1]) / 100;
            const l = Number(hsl[2]) / 100;
            let t2;
            let t3;
            let val;
            if (s === 0) {
                val = l * 255;
                return {
                    r: Math.round(val),
                    g: Math.round(val),
                    b: Math.round(val),
                    a: 1
                };
            }
            if (l < 0.5) t2 = l * (1 + s);
            else t2 = l + s - l * s;
            const t1 = 2 * l - t2;
            const rgb = [
                0,
                0,
                0
            ];
            for(let i = 0; i < 3; i++){
                t3 = h + 1 / 3 * -(i - 1);
                if (t3 < 0) t3++;
                if (t3 > 1) t3--;
                if (6 * t3 < 1) val = t1 + (t2 - t1) * 6 * t3;
                else if (2 * t3 < 1) val = t2;
                else if (3 * t3 < 2) val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
                else val = t1;
                rgb[i] = val * 255;
            }
            return {
                r: Math.round(rgb[0]),
                g: Math.round(rgb[1]),
                b: Math.round(rgb[2]),
                a: 1
            };
        }
    },
    haveIntersection (r1, r2) {
        return !(r2.x > r1.x + r1.width || r2.x + r2.width < r1.x || r2.y > r1.y + r1.height || r2.y + r2.height < r1.y);
    },
    cloneObject (obj) {
        var retObj = {};
        for(var key in obj){
            if (this._isPlainObject(obj[key])) retObj[key] = this.cloneObject(obj[key]);
            else if (this._isArray(obj[key])) retObj[key] = this.cloneArray(obj[key]);
            else retObj[key] = obj[key];
        }
        return retObj;
    },
    cloneArray (arr) {
        return arr.slice(0);
    },
    degToRad (deg) {
        return deg * $4d54b3632f7367db$var$PI_OVER_DEG180;
    },
    radToDeg (rad) {
        return rad * $4d54b3632f7367db$var$DEG180_OVER_PI;
    },
    _degToRad (deg) {
        $4d54b3632f7367db$export$f8f26dd395d7e1bd.warn("Util._degToRad is removed. Please use public Util.degToRad instead.");
        return $4d54b3632f7367db$export$f8f26dd395d7e1bd.degToRad(deg);
    },
    _radToDeg (rad) {
        $4d54b3632f7367db$export$f8f26dd395d7e1bd.warn("Util._radToDeg is removed. Please use public Util.radToDeg instead.");
        return $4d54b3632f7367db$export$f8f26dd395d7e1bd.radToDeg(rad);
    },
    _getRotation (radians) {
        return (0, $f1cce3c2a91bf0cf$export$b9f99057a3c7692).angleDeg ? $4d54b3632f7367db$export$f8f26dd395d7e1bd.radToDeg(radians) : radians;
    },
    _capitalize (str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    },
    throw (str) {
        throw new Error($4d54b3632f7367db$var$KONVA_ERROR + str);
    },
    error (str) {
        console.error($4d54b3632f7367db$var$KONVA_ERROR + str);
    },
    warn (str) {
        if (!(0, $f1cce3c2a91bf0cf$export$b9f99057a3c7692).showWarnings) return;
        console.warn($4d54b3632f7367db$var$KONVA_WARNING + str);
    },
    each (obj, func) {
        for(var key in obj)func(key, obj[key]);
    },
    _inRange (val, left, right) {
        return left <= val && val < right;
    },
    _getProjectionToSegment (x1, y1, x2, y2, x3, y3) {
        var x, y, dist;
        var pd2 = (x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2);
        if (pd2 == 0) {
            x = x1;
            y = y1;
            dist = (x3 - x2) * (x3 - x2) + (y3 - y2) * (y3 - y2);
        } else {
            var u = ((x3 - x1) * (x2 - x1) + (y3 - y1) * (y2 - y1)) / pd2;
            if (u < 0) {
                x = x1;
                y = y1;
                dist = (x1 - x3) * (x1 - x3) + (y1 - y3) * (y1 - y3);
            } else if (u > 1.0) {
                x = x2;
                y = y2;
                dist = (x2 - x3) * (x2 - x3) + (y2 - y3) * (y2 - y3);
            } else {
                x = x1 + u * (x2 - x1);
                y = y1 + u * (y2 - y1);
                dist = (x - x3) * (x - x3) + (y - y3) * (y - y3);
            }
        }
        return [
            x,
            y,
            dist
        ];
    },
    _getProjectionToLine (pt, line, isClosed) {
        var pc = $4d54b3632f7367db$export$f8f26dd395d7e1bd.cloneObject(pt);
        var dist = Number.MAX_VALUE;
        line.forEach(function(p1, i) {
            if (!isClosed && i === line.length - 1) return;
            var p2 = line[(i + 1) % line.length];
            var proj = $4d54b3632f7367db$export$f8f26dd395d7e1bd._getProjectionToSegment(p1.x, p1.y, p2.x, p2.y, pt.x, pt.y);
            var px = proj[0], py = proj[1], pdist = proj[2];
            if (pdist < dist) {
                pc.x = px;
                pc.y = py;
                dist = pdist;
            }
        });
        return pc;
    },
    _prepareArrayForTween (startArray, endArray, isClosed) {
        var n, start = [], end = [];
        if (startArray.length > endArray.length) {
            var temp = endArray;
            endArray = startArray;
            startArray = temp;
        }
        for(n = 0; n < startArray.length; n += 2)start.push({
            x: startArray[n],
            y: startArray[n + 1]
        });
        for(n = 0; n < endArray.length; n += 2)end.push({
            x: endArray[n],
            y: endArray[n + 1]
        });
        var newStart = [];
        end.forEach(function(point) {
            var pr = $4d54b3632f7367db$export$f8f26dd395d7e1bd._getProjectionToLine(point, start, isClosed);
            newStart.push(pr.x);
            newStart.push(pr.y);
        });
        return newStart;
    },
    _prepareToStringify (obj) {
        var desc;
        obj.visitedByCircularReferenceRemoval = true;
        for(var key in obj){
            if (!(obj.hasOwnProperty(key) && obj[key] && typeof obj[key] == "object")) continue;
            desc = Object.getOwnPropertyDescriptor(obj, key);
            if (obj[key].visitedByCircularReferenceRemoval || $4d54b3632f7367db$export$f8f26dd395d7e1bd._isElement(obj[key])) {
                if (desc.configurable) delete obj[key];
                else return null;
            } else if ($4d54b3632f7367db$export$f8f26dd395d7e1bd._prepareToStringify(obj[key]) === null) {
                if (desc.configurable) delete obj[key];
                else return null;
            }
        }
        delete obj.visitedByCircularReferenceRemoval;
        return obj;
    },
    _assign (target, source) {
        for(var key in source)target[key] = source[key];
        return target;
    },
    _getFirstPointerId (evt) {
        if (!evt.touches) return evt.pointerId || 999;
        else return evt.changedTouches[0].identifier;
    },
    releaseCanvas (...canvases) {
        if (!(0, $f1cce3c2a91bf0cf$export$b9f99057a3c7692).releaseCanvasOnDestroy) return;
        canvases.forEach((c)=>{
            c.width = 0;
            c.height = 0;
        });
    },
    drawRoundedRectPath (context, width, height, cornerRadius) {
        let topLeft = 0;
        let topRight = 0;
        let bottomLeft = 0;
        let bottomRight = 0;
        if (typeof cornerRadius === "number") topLeft = topRight = bottomLeft = bottomRight = Math.min(cornerRadius, width / 2, height / 2);
        else {
            topLeft = Math.min(cornerRadius[0] || 0, width / 2, height / 2);
            topRight = Math.min(cornerRadius[1] || 0, width / 2, height / 2);
            bottomRight = Math.min(cornerRadius[2] || 0, width / 2, height / 2);
            bottomLeft = Math.min(cornerRadius[3] || 0, width / 2, height / 2);
        }
        context.moveTo(topLeft, 0);
        context.lineTo(width - topRight, 0);
        context.arc(width - topRight, topRight, topRight, Math.PI * 3 / 2, 0, false);
        context.lineTo(width, height - bottomRight);
        context.arc(width - bottomRight, height - bottomRight, bottomRight, 0, Math.PI / 2, false);
        context.lineTo(bottomLeft, height);
        context.arc(bottomLeft, height - bottomLeft, bottomLeft, Math.PI / 2, Math.PI, false);
        context.lineTo(0, topLeft);
        context.arc(topLeft, topLeft, topLeft, Math.PI, Math.PI * 3 / 2, false);
    }
};






function $8d9e6be936d29d8a$var$_formatValue(val) {
    if ((0, $4d54b3632f7367db$export$f8f26dd395d7e1bd)._isString(val)) return '"' + val + '"';
    if (Object.prototype.toString.call(val) === "[object Number]") return val;
    if ((0, $4d54b3632f7367db$export$f8f26dd395d7e1bd)._isBoolean(val)) return val;
    return Object.prototype.toString.call(val);
}
function $8d9e6be936d29d8a$export$af51e4581c640b27(val) {
    if (val > 255) return 255;
    else if (val < 0) return 0;
    return Math.round(val);
}
function $8d9e6be936d29d8a$export$7078afdc21938e7(val) {
    if (val > 1) return 1;
    else if (val < 0.0001) return 0.0001;
    return val;
}
function $8d9e6be936d29d8a$export$6b1205b9fbe7de2c() {
    if ((0, $f1cce3c2a91bf0cf$export$b9f99057a3c7692).isUnminified) return function(val, attr) {
        if (!(0, $4d54b3632f7367db$export$f8f26dd395d7e1bd)._isNumber(val)) (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).warn($8d9e6be936d29d8a$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a number.');
        return val;
    };
}
function $8d9e6be936d29d8a$export$7d4ab1842c1b264b(noOfElements) {
    if ((0, $f1cce3c2a91bf0cf$export$b9f99057a3c7692).isUnminified) return function(val, attr) {
        let isNumber = (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd)._isNumber(val);
        let isValidArray = (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd)._isArray(val) && val.length == noOfElements;
        if (!isNumber && !isValidArray) (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).warn($8d9e6be936d29d8a$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a number or Array<number>(' + noOfElements + ")");
        return val;
    };
}
function $8d9e6be936d29d8a$export$3b7df2720ef33404() {
    if ((0, $f1cce3c2a91bf0cf$export$b9f99057a3c7692).isUnminified) return function(val, attr) {
        var isNumber = (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd)._isNumber(val);
        var isAuto = val === "auto";
        if (!(isNumber || isAuto)) (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).warn($8d9e6be936d29d8a$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a number or "auto".');
        return val;
    };
}
function $8d9e6be936d29d8a$export$5837c5b6cc5b4d63() {
    if ((0, $f1cce3c2a91bf0cf$export$b9f99057a3c7692).isUnminified) return function(val, attr) {
        if (!(0, $4d54b3632f7367db$export$f8f26dd395d7e1bd)._isString(val)) (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).warn($8d9e6be936d29d8a$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a string.');
        return val;
    };
}
function $8d9e6be936d29d8a$export$9c72f966a828cc68() {
    if ((0, $f1cce3c2a91bf0cf$export$b9f99057a3c7692).isUnminified) return function(val, attr) {
        const isString = (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd)._isString(val);
        const isGradient = Object.prototype.toString.call(val) === "[object CanvasGradient]" || val && val.addColorStop;
        if (!(isString || isGradient)) (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).warn($8d9e6be936d29d8a$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a string or a native gradient.');
        return val;
    };
}
function $8d9e6be936d29d8a$export$61d6863134de1cd() {
    if ((0, $f1cce3c2a91bf0cf$export$b9f99057a3c7692).isUnminified) return function(val, attr) {
        if (!(0, $4d54b3632f7367db$export$f8f26dd395d7e1bd)._isFunction(val)) (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).warn($8d9e6be936d29d8a$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a function.');
        return val;
    };
}
function $8d9e6be936d29d8a$export$42b6f8f340e9a165() {
    if ((0, $f1cce3c2a91bf0cf$export$b9f99057a3c7692).isUnminified) return function(val, attr) {
        const TypedArray = Int8Array ? Object.getPrototypeOf(Int8Array) : null;
        if (TypedArray && val instanceof TypedArray) return val;
        if (!(0, $4d54b3632f7367db$export$f8f26dd395d7e1bd)._isArray(val)) (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).warn($8d9e6be936d29d8a$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a array of numbers.');
        else val.forEach(function(item) {
            if (!(0, $4d54b3632f7367db$export$f8f26dd395d7e1bd)._isNumber(item)) (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).warn('"' + attr + '" attribute has non numeric element ' + item + ". Make sure that all elements are numbers.");
        });
        return val;
    };
}
function $8d9e6be936d29d8a$export$147fc8b6cd20fda1() {
    if ((0, $f1cce3c2a91bf0cf$export$b9f99057a3c7692).isUnminified) return function(val, attr) {
        var isBool = val === true || val === false;
        if (!isBool) (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).warn($8d9e6be936d29d8a$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a boolean.');
        return val;
    };
}
function $8d9e6be936d29d8a$export$5c1978fb8431d4a1(components) {
    if ((0, $f1cce3c2a91bf0cf$export$b9f99057a3c7692).isUnminified) return function(val, attr) {
        if (val === undefined || val === null) return val;
        if (!(0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).isObject(val)) (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).warn($8d9e6be936d29d8a$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be an object with properties ' + components);
        return val;
    };
}


var $e1d1e3911fd31488$var$GET = "get", $e1d1e3911fd31488$var$SET = "set";
const $e1d1e3911fd31488$export$8354032f3852ec50 = {
    addGetterSetter (constructor, attr, def, validator, after) {
        $e1d1e3911fd31488$export$8354032f3852ec50.addGetter(constructor, attr, def);
        $e1d1e3911fd31488$export$8354032f3852ec50.addSetter(constructor, attr, validator, after);
        $e1d1e3911fd31488$export$8354032f3852ec50.addOverloadedGetterSetter(constructor, attr);
    },
    addGetter (constructor, attr, def) {
        var method = $e1d1e3911fd31488$var$GET + (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd)._capitalize(attr);
        constructor.prototype[method] = constructor.prototype[method] || function() {
            var val = this.attrs[attr];
            return val === undefined ? def : val;
        };
    },
    addSetter (constructor, attr, validator, after) {
        var method = $e1d1e3911fd31488$var$SET + (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd)._capitalize(attr);
        if (!constructor.prototype[method]) $e1d1e3911fd31488$export$8354032f3852ec50.overWriteSetter(constructor, attr, validator, after);
    },
    overWriteSetter (constructor, attr, validator, after) {
        var method = $e1d1e3911fd31488$var$SET + (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd)._capitalize(attr);
        constructor.prototype[method] = function(val) {
            if (validator && val !== undefined && val !== null) val = validator.call(this, val, attr);
            this._setAttr(attr, val);
            if (after) after.call(this);
            return this;
        };
    },
    addComponentsGetterSetter (constructor, attr, components, validator, after) {
        var len = components.length, capitalize = (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd)._capitalize, getter = $e1d1e3911fd31488$var$GET + capitalize(attr), setter = $e1d1e3911fd31488$var$SET + capitalize(attr), n, component;
        constructor.prototype[getter] = function() {
            var ret = {};
            for(n = 0; n < len; n++){
                component = components[n];
                ret[component] = this.getAttr(attr + capitalize(component));
            }
            return ret;
        };
        var basicValidator = (0, $8d9e6be936d29d8a$export$5c1978fb8431d4a1)(components);
        constructor.prototype[setter] = function(val) {
            var oldVal = this.attrs[attr], key;
            if (validator) val = validator.call(this, val);
            if (basicValidator) basicValidator.call(this, val, attr);
            for(key in val){
                if (!val.hasOwnProperty(key)) continue;
                this._setAttr(attr + capitalize(key), val[key]);
            }
            if (!val) components.forEach((component)=>{
                this._setAttr(attr + capitalize(component), undefined);
            });
            this._fireChangeEvent(attr, oldVal, val);
            if (after) after.call(this);
            return this;
        };
        $e1d1e3911fd31488$export$8354032f3852ec50.addOverloadedGetterSetter(constructor, attr);
    },
    addOverloadedGetterSetter (constructor, attr) {
        var capitalizedAttr = (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd)._capitalize(attr), setter = $e1d1e3911fd31488$var$SET + capitalizedAttr, getter = $e1d1e3911fd31488$var$GET + capitalizedAttr;
        constructor.prototype[attr] = function() {
            if (arguments.length) {
                this[setter](arguments[0]);
                return this;
            }
            return this[getter]();
        };
    },
    addDeprecatedGetterSetter (constructor, attr, def, validator) {
        (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).error("Adding deprecated " + attr);
        var method = $e1d1e3911fd31488$var$GET + (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd)._capitalize(attr);
        var message = attr + " property is deprecated and will be removed soon. Look at Konva change log for more information.";
        constructor.prototype[method] = function() {
            (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).error(message);
            var val = this.attrs[attr];
            return val === undefined ? def : val;
        };
        $e1d1e3911fd31488$export$8354032f3852ec50.addSetter(constructor, attr, validator, function() {
            (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).error(message);
        });
        $e1d1e3911fd31488$export$8354032f3852ec50.addOverloadedGetterSetter(constructor, attr);
    },
    backCompat (constructor, methods) {
        (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).each(methods, function(oldMethodName, newMethodName) {
            var method = constructor.prototype[newMethodName];
            var oldGetter = $e1d1e3911fd31488$var$GET + (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd)._capitalize(oldMethodName);
            var oldSetter = $e1d1e3911fd31488$var$SET + (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd)._capitalize(oldMethodName);
            function deprecated() {
                method.apply(this, arguments);
                (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).error('"' + oldMethodName + '" method is deprecated and will be removed soon. Use ""' + newMethodName + '" instead.');
            }
            constructor.prototype[oldMethodName] = deprecated;
            constructor.prototype[oldGetter] = deprecated;
            constructor.prototype[oldSetter] = deprecated;
        });
    },
    afterSetFilter () {
        this._filterUpToDate = false;
    }
};





function $bed71fa021a52d88$var$simplifyArray(arr) {
    var retArr = [], len = arr.length, util = (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd), n, val;
    for(n = 0; n < len; n++){
        val = arr[n];
        if (util._isNumber(val)) val = Math.round(val * 1000) / 1000;
        else if (!util._isString(val)) val = val + "";
        retArr.push(val);
    }
    return retArr;
}
var $bed71fa021a52d88$var$COMMA = ",", $bed71fa021a52d88$var$OPEN_PAREN = "(", $bed71fa021a52d88$var$CLOSE_PAREN = ")", $bed71fa021a52d88$var$OPEN_PAREN_BRACKET = "([", $bed71fa021a52d88$var$CLOSE_BRACKET_PAREN = "])", $bed71fa021a52d88$var$SEMICOLON = ";", $bed71fa021a52d88$var$DOUBLE_PAREN = "()", $bed71fa021a52d88$var$EQUALS = "=", $bed71fa021a52d88$var$CONTEXT_METHODS = [
    "arc",
    "arcTo",
    "beginPath",
    "bezierCurveTo",
    "clearRect",
    "clip",
    "closePath",
    "createLinearGradient",
    "createPattern",
    "createRadialGradient",
    "drawImage",
    "ellipse",
    "fill",
    "fillText",
    "getImageData",
    "createImageData",
    "lineTo",
    "moveTo",
    "putImageData",
    "quadraticCurveTo",
    "rect",
    "restore",
    "rotate",
    "save",
    "scale",
    "setLineDash",
    "setTransform",
    "stroke",
    "strokeText",
    "transform",
    "translate"
];
var $bed71fa021a52d88$var$CONTEXT_PROPERTIES = [
    "fillStyle",
    "strokeStyle",
    "shadowColor",
    "shadowBlur",
    "shadowOffsetX",
    "shadowOffsetY",
    "lineCap",
    "lineDashOffset",
    "lineJoin",
    "lineWidth",
    "miterLimit",
    "font",
    "textAlign",
    "textBaseline",
    "globalAlpha",
    "globalCompositeOperation",
    "imageSmoothingEnabled"
];
const $bed71fa021a52d88$var$traceArrMax = 100;
class $bed71fa021a52d88$export$841858b892ce1f4c {
    constructor(canvas){
        this.canvas = canvas;
        if ((0, $f1cce3c2a91bf0cf$export$b9f99057a3c7692).enableTrace) {
            this.traceArr = [];
            this._enableTrace();
        }
    }
    fillShape(shape) {
        if (shape.fillEnabled()) this._fill(shape);
    }
    _fill(shape) {}
    strokeShape(shape) {
        if (shape.hasStroke()) this._stroke(shape);
    }
    _stroke(shape) {}
    fillStrokeShape(shape) {
        if (shape.attrs.fillAfterStrokeEnabled) {
            this.strokeShape(shape);
            this.fillShape(shape);
        } else {
            this.fillShape(shape);
            this.strokeShape(shape);
        }
    }
    getTrace(relaxed, rounded) {
        var traceArr = this.traceArr, len = traceArr.length, str = "", n, trace, method, args;
        for(n = 0; n < len; n++){
            trace = traceArr[n];
            method = trace.method;
            if (method) {
                args = trace.args;
                str += method;
                if (relaxed) str += $bed71fa021a52d88$var$DOUBLE_PAREN;
                else if ((0, $4d54b3632f7367db$export$f8f26dd395d7e1bd)._isArray(args[0])) str += $bed71fa021a52d88$var$OPEN_PAREN_BRACKET + args.join($bed71fa021a52d88$var$COMMA) + $bed71fa021a52d88$var$CLOSE_BRACKET_PAREN;
                else {
                    if (rounded) args = args.map((a)=>typeof a === "number" ? Math.floor(a) : a);
                    str += $bed71fa021a52d88$var$OPEN_PAREN + args.join($bed71fa021a52d88$var$COMMA) + $bed71fa021a52d88$var$CLOSE_PAREN;
                }
            } else {
                str += trace.property;
                if (!relaxed) str += $bed71fa021a52d88$var$EQUALS + trace.val;
            }
            str += $bed71fa021a52d88$var$SEMICOLON;
        }
        return str;
    }
    clearTrace() {
        this.traceArr = [];
    }
    _trace(str) {
        var traceArr = this.traceArr, len;
        traceArr.push(str);
        len = traceArr.length;
        if (len >= $bed71fa021a52d88$var$traceArrMax) traceArr.shift();
    }
    reset() {
        var pixelRatio = this.getCanvas().getPixelRatio();
        this.setTransform(1 * pixelRatio, 0, 0, 1 * pixelRatio, 0, 0);
    }
    getCanvas() {
        return this.canvas;
    }
    clear(bounds) {
        var canvas = this.getCanvas();
        if (bounds) this.clearRect(bounds.x || 0, bounds.y || 0, bounds.width || 0, bounds.height || 0);
        else this.clearRect(0, 0, canvas.getWidth() / canvas.pixelRatio, canvas.getHeight() / canvas.pixelRatio);
    }
    _applyLineCap(shape) {
        const lineCap = shape.attrs.lineCap;
        if (lineCap) this.setAttr("lineCap", lineCap);
    }
    _applyOpacity(shape) {
        var absOpacity = shape.getAbsoluteOpacity();
        if (absOpacity !== 1) this.setAttr("globalAlpha", absOpacity);
    }
    _applyLineJoin(shape) {
        const lineJoin = shape.attrs.lineJoin;
        if (lineJoin) this.setAttr("lineJoin", lineJoin);
    }
    setAttr(attr, val) {
        this._context[attr] = val;
    }
    arc(a0, a1, a2, a3, a4, a5) {
        this._context.arc(a0, a1, a2, a3, a4, a5);
    }
    arcTo(a0, a1, a2, a3, a4) {
        this._context.arcTo(a0, a1, a2, a3, a4);
    }
    beginPath() {
        this._context.beginPath();
    }
    bezierCurveTo(a0, a1, a2, a3, a4, a5) {
        this._context.bezierCurveTo(a0, a1, a2, a3, a4, a5);
    }
    clearRect(a0, a1, a2, a3) {
        this._context.clearRect(a0, a1, a2, a3);
    }
    clip() {
        this._context.clip();
    }
    closePath() {
        this._context.closePath();
    }
    createImageData(a0, a1) {
        var a = arguments;
        if (a.length === 2) return this._context.createImageData(a0, a1);
        else if (a.length === 1) return this._context.createImageData(a0);
    }
    createLinearGradient(a0, a1, a2, a3) {
        return this._context.createLinearGradient(a0, a1, a2, a3);
    }
    createPattern(a0, a1) {
        return this._context.createPattern(a0, a1);
    }
    createRadialGradient(a0, a1, a2, a3, a4, a5) {
        return this._context.createRadialGradient(a0, a1, a2, a3, a4, a5);
    }
    drawImage(a0, a1, a2, a3, a4, a5, a6, a7, a8) {
        var a = arguments, _context = this._context;
        if (a.length === 3) _context.drawImage(a0, a1, a2);
        else if (a.length === 5) _context.drawImage(a0, a1, a2, a3, a4);
        else if (a.length === 9) _context.drawImage(a0, a1, a2, a3, a4, a5, a6, a7, a8);
    }
    ellipse(a0, a1, a2, a3, a4, a5, a6, a7) {
        this._context.ellipse(a0, a1, a2, a3, a4, a5, a6, a7);
    }
    isPointInPath(x, y, path, fillRule) {
        if (path) return this._context.isPointInPath(path, x, y, fillRule);
        return this._context.isPointInPath(x, y, fillRule);
    }
    fill(path2d) {
        if (path2d) this._context.fill(path2d);
        else this._context.fill();
    }
    fillRect(x, y, width, height) {
        this._context.fillRect(x, y, width, height);
    }
    strokeRect(x, y, width, height) {
        this._context.strokeRect(x, y, width, height);
    }
    fillText(text, x, y, maxWidth) {
        if (maxWidth) this._context.fillText(text, x, y, maxWidth);
        else this._context.fillText(text, x, y);
    }
    measureText(text) {
        return this._context.measureText(text);
    }
    getImageData(a0, a1, a2, a3) {
        return this._context.getImageData(a0, a1, a2, a3);
    }
    lineTo(a0, a1) {
        this._context.lineTo(a0, a1);
    }
    moveTo(a0, a1) {
        this._context.moveTo(a0, a1);
    }
    rect(a0, a1, a2, a3) {
        this._context.rect(a0, a1, a2, a3);
    }
    putImageData(a0, a1, a2) {
        this._context.putImageData(a0, a1, a2);
    }
    quadraticCurveTo(a0, a1, a2, a3) {
        this._context.quadraticCurveTo(a0, a1, a2, a3);
    }
    restore() {
        this._context.restore();
    }
    rotate(a0) {
        this._context.rotate(a0);
    }
    save() {
        this._context.save();
    }
    scale(a0, a1) {
        this._context.scale(a0, a1);
    }
    setLineDash(a0) {
        if (this._context.setLineDash) this._context.setLineDash(a0);
        else if ("mozDash" in this._context) this._context["mozDash"] = a0;
        else if ("webkitLineDash" in this._context) this._context["webkitLineDash"] = a0;
    }
    getLineDash() {
        return this._context.getLineDash();
    }
    setTransform(a0, a1, a2, a3, a4, a5) {
        this._context.setTransform(a0, a1, a2, a3, a4, a5);
    }
    stroke(path2d) {
        if (path2d) this._context.stroke(path2d);
        else this._context.stroke();
    }
    strokeText(a0, a1, a2, a3) {
        this._context.strokeText(a0, a1, a2, a3);
    }
    transform(a0, a1, a2, a3, a4, a5) {
        this._context.transform(a0, a1, a2, a3, a4, a5);
    }
    translate(a0, a1) {
        this._context.translate(a0, a1);
    }
    _enableTrace() {
        var that = this, len = $bed71fa021a52d88$var$CONTEXT_METHODS.length, origSetter = this.setAttr, n, args;
        var func = function(methodName) {
            var origMethod = that[methodName], ret;
            that[methodName] = function() {
                args = $bed71fa021a52d88$var$simplifyArray(Array.prototype.slice.call(arguments, 0));
                ret = origMethod.apply(that, arguments);
                that._trace({
                    method: methodName,
                    args: args
                });
                return ret;
            };
        };
        for(n = 0; n < len; n++)func($bed71fa021a52d88$var$CONTEXT_METHODS[n]);
        that.setAttr = function() {
            origSetter.apply(that, arguments);
            var prop = arguments[0];
            var val = arguments[1];
            if (prop === "shadowOffsetX" || prop === "shadowOffsetY" || prop === "shadowBlur") val = val / this.canvas.getPixelRatio();
            that._trace({
                property: prop,
                val: val
            });
        };
    }
    _applyGlobalCompositeOperation(node) {
        const op = node.attrs.globalCompositeOperation;
        var def = !op || op === "source-over";
        if (!def) this.setAttr("globalCompositeOperation", op);
    }
}
$bed71fa021a52d88$var$CONTEXT_PROPERTIES.forEach(function(prop) {
    Object.defineProperty($bed71fa021a52d88$export$841858b892ce1f4c.prototype, prop, {
        get () {
            return this._context[prop];
        },
        set (val) {
            this._context[prop] = val;
        }
    });
});
class $bed71fa021a52d88$export$576380cfa99ddf20 extends $bed71fa021a52d88$export$841858b892ce1f4c {
    constructor(canvas){
        super(canvas);
        this._context = canvas._canvas.getContext("2d");
    }
    _fillColor(shape) {
        var fill = shape.fill();
        this.setAttr("fillStyle", fill);
        shape._fillFunc(this);
    }
    _fillPattern(shape) {
        this.setAttr("fillStyle", shape._getFillPattern());
        shape._fillFunc(this);
    }
    _fillLinearGradient(shape) {
        var grd = shape._getLinearGradient();
        if (grd) {
            this.setAttr("fillStyle", grd);
            shape._fillFunc(this);
        }
    }
    _fillRadialGradient(shape) {
        const grd = shape._getRadialGradient();
        if (grd) {
            this.setAttr("fillStyle", grd);
            shape._fillFunc(this);
        }
    }
    _fill(shape) {
        const hasColor = shape.fill(), fillPriority = shape.getFillPriority();
        if (hasColor && fillPriority === "color") {
            this._fillColor(shape);
            return;
        }
        const hasPattern = shape.getFillPatternImage();
        if (hasPattern && fillPriority === "pattern") {
            this._fillPattern(shape);
            return;
        }
        const hasLinearGradient = shape.getFillLinearGradientColorStops();
        if (hasLinearGradient && fillPriority === "linear-gradient") {
            this._fillLinearGradient(shape);
            return;
        }
        const hasRadialGradient = shape.getFillRadialGradientColorStops();
        if (hasRadialGradient && fillPriority === "radial-gradient") {
            this._fillRadialGradient(shape);
            return;
        }
        if (hasColor) this._fillColor(shape);
        else if (hasPattern) this._fillPattern(shape);
        else if (hasLinearGradient) this._fillLinearGradient(shape);
        else if (hasRadialGradient) this._fillRadialGradient(shape);
    }
    _strokeLinearGradient(shape) {
        const start = shape.getStrokeLinearGradientStartPoint(), end = shape.getStrokeLinearGradientEndPoint(), colorStops = shape.getStrokeLinearGradientColorStops(), grd = this.createLinearGradient(start.x, start.y, end.x, end.y);
        if (colorStops) {
            for(var n = 0; n < colorStops.length; n += 2)grd.addColorStop(colorStops[n], colorStops[n + 1]);
            this.setAttr("strokeStyle", grd);
        }
    }
    _stroke(shape) {
        var dash = shape.dash(), strokeScaleEnabled = shape.getStrokeScaleEnabled();
        if (shape.hasStroke()) {
            if (!strokeScaleEnabled) {
                this.save();
                var pixelRatio = this.getCanvas().getPixelRatio();
                this.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
            }
            this._applyLineCap(shape);
            if (dash && shape.dashEnabled()) {
                this.setLineDash(dash);
                this.setAttr("lineDashOffset", shape.dashOffset());
            }
            this.setAttr("lineWidth", shape.strokeWidth());
            if (!shape.getShadowForStrokeEnabled()) this.setAttr("shadowColor", "rgba(0,0,0,0)");
            var hasLinearGradient = shape.getStrokeLinearGradientColorStops();
            if (hasLinearGradient) this._strokeLinearGradient(shape);
            else this.setAttr("strokeStyle", shape.stroke());
            shape._strokeFunc(this);
            if (!strokeScaleEnabled) this.restore();
        }
    }
    _applyShadow(shape) {
        var _a, _b, _c;
        var color = (_a = shape.getShadowRGBA()) !== null && _a !== void 0 ? _a : "black", blur = (_b = shape.getShadowBlur()) !== null && _b !== void 0 ? _b : 5, offset = (_c = shape.getShadowOffset()) !== null && _c !== void 0 ? _c : {
            x: 0,
            y: 0
        }, scale = shape.getAbsoluteScale(), ratio = this.canvas.getPixelRatio(), scaleX = scale.x * ratio, scaleY = scale.y * ratio;
        this.setAttr("shadowColor", color);
        this.setAttr("shadowBlur", blur * Math.min(Math.abs(scaleX), Math.abs(scaleY)));
        this.setAttr("shadowOffsetX", offset.x * scaleX);
        this.setAttr("shadowOffsetY", offset.y * scaleY);
    }
}
class $bed71fa021a52d88$export$85eec7ef35542dce extends $bed71fa021a52d88$export$841858b892ce1f4c {
    constructor(canvas){
        super(canvas);
        this._context = canvas._canvas.getContext("2d", {
            willReadFrequently: true
        });
    }
    _fill(shape) {
        this.save();
        this.setAttr("fillStyle", shape.colorKey);
        shape._fillFuncHit(this);
        this.restore();
    }
    strokeShape(shape) {
        if (shape.hasHitStroke()) this._stroke(shape);
    }
    _stroke(shape) {
        if (shape.hasHitStroke()) {
            const strokeScaleEnabled = shape.getStrokeScaleEnabled();
            if (!strokeScaleEnabled) {
                this.save();
                var pixelRatio = this.getCanvas().getPixelRatio();
                this.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
            }
            this._applyLineCap(shape);
            var hitStrokeWidth = shape.hitStrokeWidth();
            var strokeWidth = hitStrokeWidth === "auto" ? shape.strokeWidth() : hitStrokeWidth;
            this.setAttr("lineWidth", strokeWidth);
            this.setAttr("strokeStyle", shape.colorKey);
            shape._strokeFuncHit(this);
            if (!strokeScaleEnabled) this.restore();
        }
    }
}





var $6ecdd92180d794bd$var$_pixelRatio;
function $6ecdd92180d794bd$var$getDevicePixelRatio() {
    if ($6ecdd92180d794bd$var$_pixelRatio) return $6ecdd92180d794bd$var$_pixelRatio;
    var canvas = (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).createCanvasElement();
    var context = canvas.getContext("2d");
    $6ecdd92180d794bd$var$_pixelRatio = function() {
        var devicePixelRatio = (0, $f1cce3c2a91bf0cf$export$b9f99057a3c7692)._global.devicePixelRatio || 1, backingStoreRatio = context.webkitBackingStorePixelRatio || context.mozBackingStorePixelRatio || context.msBackingStorePixelRatio || context.oBackingStorePixelRatio || context.backingStorePixelRatio || 1;
        return devicePixelRatio / backingStoreRatio;
    }();
    (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).releaseCanvas(canvas);
    return $6ecdd92180d794bd$var$_pixelRatio;
}
class $6ecdd92180d794bd$export$8d01c972ee8b14a9 {
    constructor(config){
        this.pixelRatio = 1;
        this.width = 0;
        this.height = 0;
        this.isCache = false;
        var conf = config || {};
        var pixelRatio = conf.pixelRatio || (0, $f1cce3c2a91bf0cf$export$b9f99057a3c7692).pixelRatio || $6ecdd92180d794bd$var$getDevicePixelRatio();
        this.pixelRatio = pixelRatio;
        this._canvas = (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).createCanvasElement();
        this._canvas.style.padding = "0";
        this._canvas.style.margin = "0";
        this._canvas.style.border = "0";
        this._canvas.style.background = "transparent";
        this._canvas.style.position = "absolute";
        this._canvas.style.top = "0";
        this._canvas.style.left = "0";
    }
    getContext() {
        return this.context;
    }
    getPixelRatio() {
        return this.pixelRatio;
    }
    setPixelRatio(pixelRatio) {
        var previousRatio = this.pixelRatio;
        this.pixelRatio = pixelRatio;
        this.setSize(this.getWidth() / previousRatio, this.getHeight() / previousRatio);
    }
    setWidth(width) {
        this.width = this._canvas.width = width * this.pixelRatio;
        this._canvas.style.width = width + "px";
        var pixelRatio = this.pixelRatio, _context = this.getContext()._context;
        _context.scale(pixelRatio, pixelRatio);
    }
    setHeight(height) {
        this.height = this._canvas.height = height * this.pixelRatio;
        this._canvas.style.height = height + "px";
        var pixelRatio = this.pixelRatio, _context = this.getContext()._context;
        _context.scale(pixelRatio, pixelRatio);
    }
    getWidth() {
        return this.width;
    }
    getHeight() {
        return this.height;
    }
    setSize(width, height) {
        this.setWidth(width || 0);
        this.setHeight(height || 0);
    }
    toDataURL(mimeType, quality) {
        try {
            return this._canvas.toDataURL(mimeType, quality);
        } catch (e) {
            try {
                return this._canvas.toDataURL();
            } catch (err) {
                (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).error("Unable to get data URL. " + err.message + " For more info read https://konvajs.org/docs/posts/Tainted_Canvas.html.");
                return "";
            }
        }
    }
}
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($6ecdd92180d794bd$export$8d01c972ee8b14a9, "pixelRatio", undefined, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)());
class $6ecdd92180d794bd$export$ee612225bd2e63be extends $6ecdd92180d794bd$export$8d01c972ee8b14a9 {
    constructor(config = {
        width: 0,
        height: 0
    }){
        super(config);
        this.context = new (0, $bed71fa021a52d88$export$576380cfa99ddf20)(this);
        this.setSize(config.width, config.height);
    }
}
class $6ecdd92180d794bd$export$43a2e1456e27dc84 extends $6ecdd92180d794bd$export$8d01c972ee8b14a9 {
    constructor(config = {
        width: 0,
        height: 0
    }){
        super(config);
        this.hitCanvas = true;
        this.context = new (0, $bed71fa021a52d88$export$85eec7ef35542dce)(this);
        this.setSize(config.width, config.height);
    }
}





const $8410d2afdfe04713$export$e34f1b340034d7f = {
    get isDragging () {
        var flag = false;
        $8410d2afdfe04713$export$e34f1b340034d7f._dragElements.forEach((elem)=>{
            if (elem.dragStatus === "dragging") flag = true;
        });
        return flag;
    },
    justDragged: false,
    get node () {
        var node;
        $8410d2afdfe04713$export$e34f1b340034d7f._dragElements.forEach((elem)=>{
            node = elem.node;
        });
        return node;
    },
    _dragElements: new Map(),
    _drag (evt) {
        const nodesToFireEvents = [];
        $8410d2afdfe04713$export$e34f1b340034d7f._dragElements.forEach((elem, key)=>{
            const { node: node } = elem;
            const stage = node.getStage();
            stage.setPointersPositions(evt);
            if (elem.pointerId === undefined) elem.pointerId = (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd)._getFirstPointerId(evt);
            const pos = stage._changedPointerPositions.find((pos)=>pos.id === elem.pointerId);
            if (!pos) return;
            if (elem.dragStatus !== "dragging") {
                var dragDistance = node.dragDistance();
                var distance = Math.max(Math.abs(pos.x - elem.startPointerPos.x), Math.abs(pos.y - elem.startPointerPos.y));
                if (distance < dragDistance) return;
                node.startDrag({
                    evt: evt
                });
                if (!node.isDragging()) return;
            }
            node._setDragPosition(evt, elem);
            nodesToFireEvents.push(node);
        });
        nodesToFireEvents.forEach((node)=>{
            node.fire("dragmove", {
                type: "dragmove",
                target: node,
                evt: evt
            }, true);
        });
    },
    _endDragBefore (evt) {
        const drawNodes = [];
        $8410d2afdfe04713$export$e34f1b340034d7f._dragElements.forEach((elem)=>{
            const { node: node } = elem;
            const stage = node.getStage();
            if (evt) stage.setPointersPositions(evt);
            const pos = stage._changedPointerPositions.find((pos)=>pos.id === elem.pointerId);
            if (!pos) return;
            if (elem.dragStatus === "dragging" || elem.dragStatus === "stopped") {
                $8410d2afdfe04713$export$e34f1b340034d7f.justDragged = true;
                (0, $f1cce3c2a91bf0cf$export$b9f99057a3c7692)._mouseListenClick = false;
                (0, $f1cce3c2a91bf0cf$export$b9f99057a3c7692)._touchListenClick = false;
                (0, $f1cce3c2a91bf0cf$export$b9f99057a3c7692)._pointerListenClick = false;
                elem.dragStatus = "stopped";
            }
            const drawNode = elem.node.getLayer() || elem.node instanceof (0, $f1cce3c2a91bf0cf$export$b9f99057a3c7692)["Stage"] && elem.node;
            if (drawNode && drawNodes.indexOf(drawNode) === -1) drawNodes.push(drawNode);
        });
        drawNodes.forEach((drawNode)=>{
            drawNode.draw();
        });
    },
    _endDragAfter (evt) {
        $8410d2afdfe04713$export$e34f1b340034d7f._dragElements.forEach((elem, key)=>{
            if (elem.dragStatus === "stopped") elem.node.fire("dragend", {
                type: "dragend",
                target: elem.node,
                evt: evt
            }, true);
            if (elem.dragStatus !== "dragging") $8410d2afdfe04713$export$e34f1b340034d7f._dragElements.delete(key);
        });
    }
};
if ((0, $f1cce3c2a91bf0cf$export$b9f99057a3c7692).isBrowser) {
    window.addEventListener("mouseup", $8410d2afdfe04713$export$e34f1b340034d7f._endDragBefore, true);
    window.addEventListener("touchend", $8410d2afdfe04713$export$e34f1b340034d7f._endDragBefore, true);
    window.addEventListener("mousemove", $8410d2afdfe04713$export$e34f1b340034d7f._drag);
    window.addEventListener("touchmove", $8410d2afdfe04713$export$e34f1b340034d7f._drag);
    window.addEventListener("mouseup", $8410d2afdfe04713$export$e34f1b340034d7f._endDragAfter, false);
    window.addEventListener("touchend", $8410d2afdfe04713$export$e34f1b340034d7f._endDragAfter, false);
}



var $97cb7af42217e259$var$ABSOLUTE_OPACITY = "absoluteOpacity", $97cb7af42217e259$var$ALL_LISTENERS = "allEventListeners", $97cb7af42217e259$var$ABSOLUTE_TRANSFORM = "absoluteTransform", $97cb7af42217e259$var$ABSOLUTE_SCALE = "absoluteScale", $97cb7af42217e259$var$CANVAS = "canvas", $97cb7af42217e259$var$CHANGE = "Change", $97cb7af42217e259$var$CHILDREN = "children", $97cb7af42217e259$var$KONVA = "konva", $97cb7af42217e259$var$LISTENING = "listening", $97cb7af42217e259$var$MOUSEENTER = "mouseenter", $97cb7af42217e259$var$MOUSELEAVE = "mouseleave", $97cb7af42217e259$var$NAME = "name", $97cb7af42217e259$var$SET = "set", $97cb7af42217e259$var$SHAPE = "Shape", $97cb7af42217e259$var$SPACE = " ", $97cb7af42217e259$var$STAGE = "stage", $97cb7af42217e259$var$TRANSFORM = "transform", $97cb7af42217e259$var$UPPER_STAGE = "Stage", $97cb7af42217e259$var$VISIBLE = "visible", $97cb7af42217e259$var$TRANSFORM_CHANGE_STR = [
    "xChange.konva",
    "yChange.konva",
    "scaleXChange.konva",
    "scaleYChange.konva",
    "skewXChange.konva",
    "skewYChange.konva",
    "rotationChange.konva",
    "offsetXChange.konva",
    "offsetYChange.konva",
    "transformsEnabledChange.konva"
].join($97cb7af42217e259$var$SPACE);
let $97cb7af42217e259$var$idCounter = 1;
class $97cb7af42217e259$export$85c928794f8d04d4 {
    constructor(config){
        this._id = $97cb7af42217e259$var$idCounter++;
        this.eventListeners = {};
        this.attrs = {};
        this.index = 0;
        this._allEventListeners = null;
        this.parent = null;
        this._cache = new Map();
        this._attachedDepsListeners = new Map();
        this._lastPos = null;
        this._batchingTransformChange = false;
        this._needClearTransformCache = false;
        this._filterUpToDate = false;
        this._isUnderCache = false;
        this._dragEventId = null;
        this._shouldFireChangeEvents = false;
        this.setAttrs(config);
        this._shouldFireChangeEvents = true;
    }
    hasChildren() {
        return false;
    }
    _clearCache(attr) {
        if ((attr === $97cb7af42217e259$var$TRANSFORM || attr === $97cb7af42217e259$var$ABSOLUTE_TRANSFORM) && this._cache.get(attr)) this._cache.get(attr).dirty = true;
        else if (attr) this._cache.delete(attr);
        else this._cache.clear();
    }
    _getCache(attr, privateGetter) {
        var cache = this._cache.get(attr);
        var isTransform = attr === $97cb7af42217e259$var$TRANSFORM || attr === $97cb7af42217e259$var$ABSOLUTE_TRANSFORM;
        var invalid = cache === undefined || isTransform && cache.dirty === true;
        if (invalid) {
            cache = privateGetter.call(this);
            this._cache.set(attr, cache);
        }
        return cache;
    }
    _calculate(name, deps, getter) {
        if (!this._attachedDepsListeners.get(name)) {
            const depsString = deps.map((dep)=>dep + "Change.konva").join($97cb7af42217e259$var$SPACE);
            this.on(depsString, ()=>{
                this._clearCache(name);
            });
            this._attachedDepsListeners.set(name, true);
        }
        return this._getCache(name, getter);
    }
    _getCanvasCache() {
        return this._cache.get($97cb7af42217e259$var$CANVAS);
    }
    _clearSelfAndDescendantCache(attr) {
        this._clearCache(attr);
        if (attr === $97cb7af42217e259$var$ABSOLUTE_TRANSFORM) this.fire("absoluteTransformChange");
    }
    clearCache() {
        if (this._cache.has($97cb7af42217e259$var$CANVAS)) {
            const { scene: scene, filter: filter, hit: hit } = this._cache.get($97cb7af42217e259$var$CANVAS);
            (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).releaseCanvas(scene, filter, hit);
            this._cache.delete($97cb7af42217e259$var$CANVAS);
        }
        this._clearSelfAndDescendantCache();
        this._requestDraw();
        return this;
    }
    cache(config) {
        var conf = config || {};
        var rect = {};
        if (conf.x === undefined || conf.y === undefined || conf.width === undefined || conf.height === undefined) rect = this.getClientRect({
            skipTransform: true,
            relativeTo: this.getParent()
        });
        var width = Math.ceil(conf.width || rect.width), height = Math.ceil(conf.height || rect.height), pixelRatio = conf.pixelRatio, x = conf.x === undefined ? Math.floor(rect.x) : conf.x, y = conf.y === undefined ? Math.floor(rect.y) : conf.y, offset = conf.offset || 0, drawBorder = conf.drawBorder || false, hitCanvasPixelRatio = conf.hitCanvasPixelRatio || 1;
        if (!width || !height) {
            (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).error("Can not cache the node. Width or height of the node equals 0. Caching is skipped.");
            return;
        }
        width += offset * 2 + 1;
        height += offset * 2 + 1;
        x -= offset;
        y -= offset;
        var cachedSceneCanvas = new (0, $6ecdd92180d794bd$export$ee612225bd2e63be)({
            pixelRatio: pixelRatio,
            width: width,
            height: height
        }), cachedFilterCanvas = new (0, $6ecdd92180d794bd$export$ee612225bd2e63be)({
            pixelRatio: pixelRatio,
            width: 0,
            height: 0
        }), cachedHitCanvas = new (0, $6ecdd92180d794bd$export$43a2e1456e27dc84)({
            pixelRatio: hitCanvasPixelRatio,
            width: width,
            height: height
        }), sceneContext = cachedSceneCanvas.getContext(), hitContext = cachedHitCanvas.getContext();
        cachedHitCanvas.isCache = true;
        cachedSceneCanvas.isCache = true;
        this._cache.delete($97cb7af42217e259$var$CANVAS);
        this._filterUpToDate = false;
        if (conf.imageSmoothingEnabled === false) {
            cachedSceneCanvas.getContext()._context.imageSmoothingEnabled = false;
            cachedFilterCanvas.getContext()._context.imageSmoothingEnabled = false;
        }
        sceneContext.save();
        hitContext.save();
        sceneContext.translate(-x, -y);
        hitContext.translate(-x, -y);
        this._isUnderCache = true;
        this._clearSelfAndDescendantCache($97cb7af42217e259$var$ABSOLUTE_OPACITY);
        this._clearSelfAndDescendantCache($97cb7af42217e259$var$ABSOLUTE_SCALE);
        this.drawScene(cachedSceneCanvas, this);
        this.drawHit(cachedHitCanvas, this);
        this._isUnderCache = false;
        sceneContext.restore();
        hitContext.restore();
        if (drawBorder) {
            sceneContext.save();
            sceneContext.beginPath();
            sceneContext.rect(0, 0, width, height);
            sceneContext.closePath();
            sceneContext.setAttr("strokeStyle", "red");
            sceneContext.setAttr("lineWidth", 5);
            sceneContext.stroke();
            sceneContext.restore();
        }
        this._cache.set($97cb7af42217e259$var$CANVAS, {
            scene: cachedSceneCanvas,
            filter: cachedFilterCanvas,
            hit: cachedHitCanvas,
            x: x,
            y: y
        });
        this._requestDraw();
        return this;
    }
    isCached() {
        return this._cache.has($97cb7af42217e259$var$CANVAS);
    }
    getClientRect(config) {
        throw new Error('abstract "getClientRect" method call');
    }
    _transformedRect(rect, top) {
        var points = [
            {
                x: rect.x,
                y: rect.y
            },
            {
                x: rect.x + rect.width,
                y: rect.y
            },
            {
                x: rect.x + rect.width,
                y: rect.y + rect.height
            },
            {
                x: rect.x,
                y: rect.y + rect.height
            }
        ];
        var minX, minY, maxX, maxY;
        var trans = this.getAbsoluteTransform(top);
        points.forEach(function(point) {
            var transformed = trans.point(point);
            if (minX === undefined) {
                minX = maxX = transformed.x;
                minY = maxY = transformed.y;
            }
            minX = Math.min(minX, transformed.x);
            minY = Math.min(minY, transformed.y);
            maxX = Math.max(maxX, transformed.x);
            maxY = Math.max(maxY, transformed.y);
        });
        return {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        };
    }
    _drawCachedSceneCanvas(context) {
        context.save();
        context._applyOpacity(this);
        context._applyGlobalCompositeOperation(this);
        const canvasCache = this._getCanvasCache();
        context.translate(canvasCache.x, canvasCache.y);
        var cacheCanvas = this._getCachedSceneCanvas();
        var ratio = cacheCanvas.pixelRatio;
        context.drawImage(cacheCanvas._canvas, 0, 0, cacheCanvas.width / ratio, cacheCanvas.height / ratio);
        context.restore();
    }
    _drawCachedHitCanvas(context) {
        var canvasCache = this._getCanvasCache(), hitCanvas = canvasCache.hit;
        context.save();
        context.translate(canvasCache.x, canvasCache.y);
        context.drawImage(hitCanvas._canvas, 0, 0, hitCanvas.width / hitCanvas.pixelRatio, hitCanvas.height / hitCanvas.pixelRatio);
        context.restore();
    }
    _getCachedSceneCanvas() {
        var filters = this.filters(), cachedCanvas = this._getCanvasCache(), sceneCanvas = cachedCanvas.scene, filterCanvas = cachedCanvas.filter, filterContext = filterCanvas.getContext(), len, imageData, n, filter;
        if (filters) {
            if (!this._filterUpToDate) {
                var ratio = sceneCanvas.pixelRatio;
                filterCanvas.setSize(sceneCanvas.width / sceneCanvas.pixelRatio, sceneCanvas.height / sceneCanvas.pixelRatio);
                try {
                    len = filters.length;
                    filterContext.clear();
                    filterContext.drawImage(sceneCanvas._canvas, 0, 0, sceneCanvas.getWidth() / ratio, sceneCanvas.getHeight() / ratio);
                    imageData = filterContext.getImageData(0, 0, filterCanvas.getWidth(), filterCanvas.getHeight());
                    for(n = 0; n < len; n++){
                        filter = filters[n];
                        if (typeof filter !== "function") {
                            (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).error("Filter should be type of function, but got " + typeof filter + " instead. Please check correct filters");
                            continue;
                        }
                        filter.call(this, imageData);
                        filterContext.putImageData(imageData, 0, 0);
                    }
                } catch (e) {
                    (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).error("Unable to apply filter. " + e.message + " This post my help you https://konvajs.org/docs/posts/Tainted_Canvas.html.");
                }
                this._filterUpToDate = true;
            }
            return filterCanvas;
        }
        return sceneCanvas;
    }
    on(evtStr, handler) {
        this._cache && this._cache.delete($97cb7af42217e259$var$ALL_LISTENERS);
        if (arguments.length === 3) return this._delegate.apply(this, arguments);
        var events = evtStr.split($97cb7af42217e259$var$SPACE), len = events.length, n, event, parts, baseEvent, name;
        for(n = 0; n < len; n++){
            event = events[n];
            parts = event.split(".");
            baseEvent = parts[0];
            name = parts[1] || "";
            if (!this.eventListeners[baseEvent]) this.eventListeners[baseEvent] = [];
            this.eventListeners[baseEvent].push({
                name: name,
                handler: handler
            });
        }
        return this;
    }
    off(evtStr, callback) {
        var events = (evtStr || "").split($97cb7af42217e259$var$SPACE), len = events.length, n, t, event, parts, baseEvent, name;
        this._cache && this._cache.delete($97cb7af42217e259$var$ALL_LISTENERS);
        if (!evtStr) for(t in this.eventListeners)this._off(t);
        for(n = 0; n < len; n++){
            event = events[n];
            parts = event.split(".");
            baseEvent = parts[0];
            name = parts[1];
            if (baseEvent) {
                if (this.eventListeners[baseEvent]) this._off(baseEvent, name, callback);
            } else for(t in this.eventListeners)this._off(t, name, callback);
        }
        return this;
    }
    dispatchEvent(evt) {
        var e = {
            target: this,
            type: evt.type,
            evt: evt
        };
        this.fire(evt.type, e);
        return this;
    }
    addEventListener(type, handler) {
        this.on(type, function(evt) {
            handler.call(this, evt.evt);
        });
        return this;
    }
    removeEventListener(type) {
        this.off(type);
        return this;
    }
    _delegate(event, selector, handler) {
        var stopNode = this;
        this.on(event, function(evt) {
            var targets = evt.target.findAncestors(selector, true, stopNode);
            for(var i = 0; i < targets.length; i++){
                evt = (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).cloneObject(evt);
                evt.currentTarget = targets[i];
                handler.call(targets[i], evt);
            }
        });
    }
    remove() {
        if (this.isDragging()) this.stopDrag();
        (0, $8410d2afdfe04713$export$e34f1b340034d7f)._dragElements.delete(this._id);
        this._remove();
        return this;
    }
    _clearCaches() {
        this._clearSelfAndDescendantCache($97cb7af42217e259$var$ABSOLUTE_TRANSFORM);
        this._clearSelfAndDescendantCache($97cb7af42217e259$var$ABSOLUTE_OPACITY);
        this._clearSelfAndDescendantCache($97cb7af42217e259$var$ABSOLUTE_SCALE);
        this._clearSelfAndDescendantCache($97cb7af42217e259$var$STAGE);
        this._clearSelfAndDescendantCache($97cb7af42217e259$var$VISIBLE);
        this._clearSelfAndDescendantCache($97cb7af42217e259$var$LISTENING);
    }
    _remove() {
        this._clearCaches();
        var parent = this.getParent();
        if (parent && parent.children) {
            parent.children.splice(this.index, 1);
            parent._setChildrenIndices();
            this.parent = null;
        }
    }
    destroy() {
        this.remove();
        this.clearCache();
        return this;
    }
    getAttr(attr) {
        var method = "get" + (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd)._capitalize(attr);
        if ((0, $4d54b3632f7367db$export$f8f26dd395d7e1bd)._isFunction(this[method])) return this[method]();
        return this.attrs[attr];
    }
    getAncestors() {
        var parent = this.getParent(), ancestors = [];
        while(parent){
            ancestors.push(parent);
            parent = parent.getParent();
        }
        return ancestors;
    }
    getAttrs() {
        return this.attrs || {};
    }
    setAttrs(config) {
        this._batchTransformChanges(()=>{
            var key, method;
            if (!config) return this;
            for(key in config){
                if (key === $97cb7af42217e259$var$CHILDREN) continue;
                method = $97cb7af42217e259$var$SET + (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd)._capitalize(key);
                if ((0, $4d54b3632f7367db$export$f8f26dd395d7e1bd)._isFunction(this[method])) this[method](config[key]);
                else this._setAttr(key, config[key]);
            }
        });
        return this;
    }
    isListening() {
        return this._getCache($97cb7af42217e259$var$LISTENING, this._isListening);
    }
    _isListening(relativeTo) {
        const listening = this.listening();
        if (!listening) return false;
        const parent = this.getParent();
        if (parent && parent !== relativeTo && this !== relativeTo) return parent._isListening(relativeTo);
        else return true;
    }
    isVisible() {
        return this._getCache($97cb7af42217e259$var$VISIBLE, this._isVisible);
    }
    _isVisible(relativeTo) {
        const visible = this.visible();
        if (!visible) return false;
        const parent = this.getParent();
        if (parent && parent !== relativeTo && this !== relativeTo) return parent._isVisible(relativeTo);
        else return true;
    }
    shouldDrawHit(top, skipDragCheck = false) {
        if (top) return this._isVisible(top) && this._isListening(top);
        var layer = this.getLayer();
        var layerUnderDrag = false;
        (0, $8410d2afdfe04713$export$e34f1b340034d7f)._dragElements.forEach((elem)=>{
            if (elem.dragStatus !== "dragging") return;
            else if (elem.node.nodeType === "Stage") layerUnderDrag = true;
            else if (elem.node.getLayer() === layer) layerUnderDrag = true;
        });
        var dragSkip = !skipDragCheck && !(0, $f1cce3c2a91bf0cf$export$b9f99057a3c7692).hitOnDragEnabled && layerUnderDrag;
        return this.isListening() && this.isVisible() && !dragSkip;
    }
    show() {
        this.visible(true);
        return this;
    }
    hide() {
        this.visible(false);
        return this;
    }
    getZIndex() {
        return this.index || 0;
    }
    getAbsoluteZIndex() {
        var depth = this.getDepth(), that = this, index = 0, nodes, len, n, child;
        function addChildren(children) {
            nodes = [];
            len = children.length;
            for(n = 0; n < len; n++){
                child = children[n];
                index++;
                if (child.nodeType !== $97cb7af42217e259$var$SHAPE) nodes = nodes.concat(child.getChildren().slice());
                if (child._id === that._id) n = len;
            }
            if (nodes.length > 0 && nodes[0].getDepth() <= depth) addChildren(nodes);
        }
        if (that.nodeType !== $97cb7af42217e259$var$UPPER_STAGE) addChildren(that.getStage().getChildren());
        return index;
    }
    getDepth() {
        var depth = 0, parent = this.parent;
        while(parent){
            depth++;
            parent = parent.parent;
        }
        return depth;
    }
    _batchTransformChanges(func) {
        this._batchingTransformChange = true;
        func();
        this._batchingTransformChange = false;
        if (this._needClearTransformCache) {
            this._clearCache($97cb7af42217e259$var$TRANSFORM);
            this._clearSelfAndDescendantCache($97cb7af42217e259$var$ABSOLUTE_TRANSFORM);
        }
        this._needClearTransformCache = false;
    }
    setPosition(pos) {
        this._batchTransformChanges(()=>{
            this.x(pos.x);
            this.y(pos.y);
        });
        return this;
    }
    getPosition() {
        return {
            x: this.x(),
            y: this.y()
        };
    }
    getRelativePointerPosition() {
        if (!this.getStage()) return null;
        var pos = this.getStage().getPointerPosition();
        if (!pos) return null;
        var transform = this.getAbsoluteTransform().copy();
        transform.invert();
        return transform.point(pos);
    }
    getAbsolutePosition(top) {
        let haveCachedParent = false;
        let parent = this.parent;
        while(parent){
            if (parent.isCached()) {
                haveCachedParent = true;
                break;
            }
            parent = parent.parent;
        }
        if (haveCachedParent && !top) top = true;
        var absoluteMatrix = this.getAbsoluteTransform(top).getMatrix(), absoluteTransform = new (0, $4d54b3632f7367db$export$563a914cafbdc389)(), offset = this.offset();
        absoluteTransform.m = absoluteMatrix.slice();
        absoluteTransform.translate(offset.x, offset.y);
        return absoluteTransform.getTranslation();
    }
    setAbsolutePosition(pos) {
        var origTrans = this._clearTransform();
        this.attrs.x = origTrans.x;
        this.attrs.y = origTrans.y;
        delete origTrans.x;
        delete origTrans.y;
        this._clearCache($97cb7af42217e259$var$TRANSFORM);
        var it = this._getAbsoluteTransform().copy();
        it.invert();
        it.translate(pos.x, pos.y);
        pos = {
            x: this.attrs.x + it.getTranslation().x,
            y: this.attrs.y + it.getTranslation().y
        };
        this._setTransform(origTrans);
        this.setPosition({
            x: pos.x,
            y: pos.y
        });
        this._clearCache($97cb7af42217e259$var$TRANSFORM);
        this._clearSelfAndDescendantCache($97cb7af42217e259$var$ABSOLUTE_TRANSFORM);
        return this;
    }
    _setTransform(trans) {
        var key;
        for(key in trans)this.attrs[key] = trans[key];
    }
    _clearTransform() {
        var trans = {
            x: this.x(),
            y: this.y(),
            rotation: this.rotation(),
            scaleX: this.scaleX(),
            scaleY: this.scaleY(),
            offsetX: this.offsetX(),
            offsetY: this.offsetY(),
            skewX: this.skewX(),
            skewY: this.skewY()
        };
        this.attrs.x = 0;
        this.attrs.y = 0;
        this.attrs.rotation = 0;
        this.attrs.scaleX = 1;
        this.attrs.scaleY = 1;
        this.attrs.offsetX = 0;
        this.attrs.offsetY = 0;
        this.attrs.skewX = 0;
        this.attrs.skewY = 0;
        return trans;
    }
    move(change) {
        var changeX = change.x, changeY = change.y, x = this.x(), y = this.y();
        if (changeX !== undefined) x += changeX;
        if (changeY !== undefined) y += changeY;
        this.setPosition({
            x: x,
            y: y
        });
        return this;
    }
    _eachAncestorReverse(func, top) {
        var family = [], parent = this.getParent(), len, n;
        if (top && top._id === this._id) return;
        family.unshift(this);
        while(parent && (!top || parent._id !== top._id)){
            family.unshift(parent);
            parent = parent.parent;
        }
        len = family.length;
        for(n = 0; n < len; n++)func(family[n]);
    }
    rotate(theta) {
        this.rotation(this.rotation() + theta);
        return this;
    }
    moveToTop() {
        if (!this.parent) {
            (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).warn("Node has no parent. moveToTop function is ignored.");
            return false;
        }
        var index = this.index, len = this.parent.getChildren().length;
        if (index < len - 1) {
            this.parent.children.splice(index, 1);
            this.parent.children.push(this);
            this.parent._setChildrenIndices();
            return true;
        }
        return false;
    }
    moveUp() {
        if (!this.parent) {
            (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).warn("Node has no parent. moveUp function is ignored.");
            return false;
        }
        var index = this.index, len = this.parent.getChildren().length;
        if (index < len - 1) {
            this.parent.children.splice(index, 1);
            this.parent.children.splice(index + 1, 0, this);
            this.parent._setChildrenIndices();
            return true;
        }
        return false;
    }
    moveDown() {
        if (!this.parent) {
            (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).warn("Node has no parent. moveDown function is ignored.");
            return false;
        }
        var index = this.index;
        if (index > 0) {
            this.parent.children.splice(index, 1);
            this.parent.children.splice(index - 1, 0, this);
            this.parent._setChildrenIndices();
            return true;
        }
        return false;
    }
    moveToBottom() {
        if (!this.parent) {
            (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).warn("Node has no parent. moveToBottom function is ignored.");
            return false;
        }
        var index = this.index;
        if (index > 0) {
            this.parent.children.splice(index, 1);
            this.parent.children.unshift(this);
            this.parent._setChildrenIndices();
            return true;
        }
        return false;
    }
    setZIndex(zIndex) {
        if (!this.parent) {
            (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).warn("Node has no parent. zIndex parameter is ignored.");
            return this;
        }
        if (zIndex < 0 || zIndex >= this.parent.children.length) (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).warn("Unexpected value " + zIndex + " for zIndex property. zIndex is just index of a node in children of its parent. Expected value is from 0 to " + (this.parent.children.length - 1) + ".");
        var index = this.index;
        this.parent.children.splice(index, 1);
        this.parent.children.splice(zIndex, 0, this);
        this.parent._setChildrenIndices();
        return this;
    }
    getAbsoluteOpacity() {
        return this._getCache($97cb7af42217e259$var$ABSOLUTE_OPACITY, this._getAbsoluteOpacity);
    }
    _getAbsoluteOpacity() {
        var absOpacity = this.opacity();
        var parent = this.getParent();
        if (parent && !parent._isUnderCache) absOpacity *= parent.getAbsoluteOpacity();
        return absOpacity;
    }
    moveTo(newContainer) {
        if (this.getParent() !== newContainer) {
            this._remove();
            newContainer.add(this);
        }
        return this;
    }
    toObject() {
        var obj = {}, attrs = this.getAttrs(), key, val, getter, defaultValue, nonPlainObject;
        obj.attrs = {};
        for(key in attrs){
            val = attrs[key];
            nonPlainObject = (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).isObject(val) && !(0, $4d54b3632f7367db$export$f8f26dd395d7e1bd)._isPlainObject(val) && !(0, $4d54b3632f7367db$export$f8f26dd395d7e1bd)._isArray(val);
            if (nonPlainObject) continue;
            getter = typeof this[key] === "function" && this[key];
            delete attrs[key];
            defaultValue = getter ? getter.call(this) : null;
            attrs[key] = val;
            if (defaultValue !== val) obj.attrs[key] = val;
        }
        obj.className = this.getClassName();
        return (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd)._prepareToStringify(obj);
    }
    toJSON() {
        return JSON.stringify(this.toObject());
    }
    getParent() {
        return this.parent;
    }
    findAncestors(selector, includeSelf, stopNode) {
        var res = [];
        if (includeSelf && this._isMatch(selector)) res.push(this);
        var ancestor = this.parent;
        while(ancestor){
            if (ancestor === stopNode) return res;
            if (ancestor._isMatch(selector)) res.push(ancestor);
            ancestor = ancestor.parent;
        }
        return res;
    }
    isAncestorOf(node) {
        return false;
    }
    findAncestor(selector, includeSelf, stopNode) {
        return this.findAncestors(selector, includeSelf, stopNode)[0];
    }
    _isMatch(selector) {
        if (!selector) return false;
        if (typeof selector === "function") return selector(this);
        var selectorArr = selector.replace(/ /g, "").split(","), len = selectorArr.length, n, sel;
        for(n = 0; n < len; n++){
            sel = selectorArr[n];
            if (!(0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).isValidSelector(sel)) {
                (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).warn('Selector "' + sel + '" is invalid. Allowed selectors examples are "#foo", ".bar" or "Group".');
                (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).warn('If you have a custom shape with such className, please change it to start with upper letter like "Triangle".');
                (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).warn("Konva is awesome, right?");
            }
            if (sel.charAt(0) === "#") {
                if (this.id() === sel.slice(1)) return true;
            } else if (sel.charAt(0) === ".") {
                if (this.hasName(sel.slice(1))) return true;
            } else if (this.className === sel || this.nodeType === sel) return true;
        }
        return false;
    }
    getLayer() {
        var parent = this.getParent();
        return parent ? parent.getLayer() : null;
    }
    getStage() {
        return this._getCache($97cb7af42217e259$var$STAGE, this._getStage);
    }
    _getStage() {
        var parent = this.getParent();
        if (parent) return parent.getStage();
        else return undefined;
    }
    fire(eventType, evt = {}, bubble) {
        evt.target = evt.target || this;
        if (bubble) this._fireAndBubble(eventType, evt);
        else this._fire(eventType, evt);
        return this;
    }
    getAbsoluteTransform(top) {
        if (top) return this._getAbsoluteTransform(top);
        else return this._getCache($97cb7af42217e259$var$ABSOLUTE_TRANSFORM, this._getAbsoluteTransform);
    }
    _getAbsoluteTransform(top) {
        var at;
        if (top) {
            at = new (0, $4d54b3632f7367db$export$563a914cafbdc389)();
            this._eachAncestorReverse(function(node) {
                var transformsEnabled = node.transformsEnabled();
                if (transformsEnabled === "all") at.multiply(node.getTransform());
                else if (transformsEnabled === "position") at.translate(node.x() - node.offsetX(), node.y() - node.offsetY());
            }, top);
            return at;
        } else {
            at = this._cache.get($97cb7af42217e259$var$ABSOLUTE_TRANSFORM) || new (0, $4d54b3632f7367db$export$563a914cafbdc389)();
            if (this.parent) this.parent.getAbsoluteTransform().copyInto(at);
            else at.reset();
            var transformsEnabled = this.transformsEnabled();
            if (transformsEnabled === "all") at.multiply(this.getTransform());
            else if (transformsEnabled === "position") {
                const x = this.attrs.x || 0;
                const y = this.attrs.y || 0;
                const offsetX = this.attrs.offsetX || 0;
                const offsetY = this.attrs.offsetY || 0;
                at.translate(x - offsetX, y - offsetY);
            }
            at.dirty = false;
            return at;
        }
    }
    getAbsoluteScale(top) {
        var parent = this;
        while(parent){
            if (parent._isUnderCache) top = parent;
            parent = parent.getParent();
        }
        const transform = this.getAbsoluteTransform(top);
        const attrs = transform.decompose();
        return {
            x: attrs.scaleX,
            y: attrs.scaleY
        };
    }
    getAbsoluteRotation() {
        return this.getAbsoluteTransform().decompose().rotation;
    }
    getTransform() {
        return this._getCache($97cb7af42217e259$var$TRANSFORM, this._getTransform);
    }
    _getTransform() {
        var _a, _b;
        var m = this._cache.get($97cb7af42217e259$var$TRANSFORM) || new (0, $4d54b3632f7367db$export$563a914cafbdc389)();
        m.reset();
        var x = this.x(), y = this.y(), rotation = (0, $f1cce3c2a91bf0cf$export$b9f99057a3c7692).getAngle(this.rotation()), scaleX = (_a = this.attrs.scaleX) !== null && _a !== void 0 ? _a : 1, scaleY = (_b = this.attrs.scaleY) !== null && _b !== void 0 ? _b : 1, skewX = this.attrs.skewX || 0, skewY = this.attrs.skewY || 0, offsetX = this.attrs.offsetX || 0, offsetY = this.attrs.offsetY || 0;
        if (x !== 0 || y !== 0) m.translate(x, y);
        if (rotation !== 0) m.rotate(rotation);
        if (skewX !== 0 || skewY !== 0) m.skew(skewX, skewY);
        if (scaleX !== 1 || scaleY !== 1) m.scale(scaleX, scaleY);
        if (offsetX !== 0 || offsetY !== 0) m.translate(-1 * offsetX, -1 * offsetY);
        m.dirty = false;
        return m;
    }
    clone(obj) {
        var attrs = (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).cloneObject(this.attrs), key, allListeners, len, n, listener;
        for(key in obj)attrs[key] = obj[key];
        var node = new this.constructor(attrs);
        for(key in this.eventListeners){
            allListeners = this.eventListeners[key];
            len = allListeners.length;
            for(n = 0; n < len; n++){
                listener = allListeners[n];
                if (listener.name.indexOf($97cb7af42217e259$var$KONVA) < 0) {
                    if (!node.eventListeners[key]) node.eventListeners[key] = [];
                    node.eventListeners[key].push(listener);
                }
            }
        }
        return node;
    }
    _toKonvaCanvas(config) {
        config = config || {};
        var box = this.getClientRect();
        var stage = this.getStage(), x = config.x !== undefined ? config.x : Math.floor(box.x), y = config.y !== undefined ? config.y : Math.floor(box.y), pixelRatio = config.pixelRatio || 1, canvas = new (0, $6ecdd92180d794bd$export$ee612225bd2e63be)({
            width: config.width || Math.ceil(box.width) || (stage ? stage.width() : 0),
            height: config.height || Math.ceil(box.height) || (stage ? stage.height() : 0),
            pixelRatio: pixelRatio
        }), context = canvas.getContext();
        if (config.imageSmoothingEnabled === false) context._context.imageSmoothingEnabled = false;
        context.save();
        if (x || y) context.translate(-1 * x, -1 * y);
        this.drawScene(canvas);
        context.restore();
        return canvas;
    }
    toCanvas(config) {
        return this._toKonvaCanvas(config)._canvas;
    }
    toDataURL(config) {
        config = config || {};
        var mimeType = config.mimeType || null, quality = config.quality || null;
        var url = this._toKonvaCanvas(config).toDataURL(mimeType, quality);
        if (config.callback) config.callback(url);
        return url;
    }
    toImage(config) {
        return new Promise((resolve, reject)=>{
            try {
                const callback = config === null || config === void 0 ? void 0 : config.callback;
                if (callback) delete config.callback;
                (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd)._urlToImage(this.toDataURL(config), function(img) {
                    resolve(img);
                    callback === null || callback === void 0 || callback(img);
                });
            } catch (err) {
                reject(err);
            }
        });
    }
    toBlob(config) {
        return new Promise((resolve, reject)=>{
            try {
                const callback = config === null || config === void 0 ? void 0 : config.callback;
                if (callback) delete config.callback;
                this.toCanvas(config).toBlob((blob)=>{
                    resolve(blob);
                    callback === null || callback === void 0 || callback(blob);
                });
            } catch (err) {
                reject(err);
            }
        });
    }
    setSize(size) {
        this.width(size.width);
        this.height(size.height);
        return this;
    }
    getSize() {
        return {
            width: this.width(),
            height: this.height()
        };
    }
    getClassName() {
        return this.className || this.nodeType;
    }
    getType() {
        return this.nodeType;
    }
    getDragDistance() {
        if (this.attrs.dragDistance !== undefined) return this.attrs.dragDistance;
        else if (this.parent) return this.parent.getDragDistance();
        else return (0, $f1cce3c2a91bf0cf$export$b9f99057a3c7692).dragDistance;
    }
    _off(type, name, callback) {
        var evtListeners = this.eventListeners[type], i, evtName, handler;
        for(i = 0; i < evtListeners.length; i++){
            evtName = evtListeners[i].name;
            handler = evtListeners[i].handler;
            if ((evtName !== "konva" || name === "konva") && (!name || evtName === name) && (!callback || callback === handler)) {
                evtListeners.splice(i, 1);
                if (evtListeners.length === 0) {
                    delete this.eventListeners[type];
                    break;
                }
                i--;
            }
        }
    }
    _fireChangeEvent(attr, oldVal, newVal) {
        this._fire(attr + $97cb7af42217e259$var$CHANGE, {
            oldVal: oldVal,
            newVal: newVal
        });
    }
    addName(name) {
        if (!this.hasName(name)) {
            var oldName = this.name();
            var newName = oldName ? oldName + " " + name : name;
            this.name(newName);
        }
        return this;
    }
    hasName(name) {
        if (!name) return false;
        const fullName = this.name();
        if (!fullName) return false;
        var names = (fullName || "").split(/\s/g);
        return names.indexOf(name) !== -1;
    }
    removeName(name) {
        var names = (this.name() || "").split(/\s/g);
        var index = names.indexOf(name);
        if (index !== -1) {
            names.splice(index, 1);
            this.name(names.join(" "));
        }
        return this;
    }
    setAttr(attr, val) {
        var func = this[$97cb7af42217e259$var$SET + (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd)._capitalize(attr)];
        if ((0, $4d54b3632f7367db$export$f8f26dd395d7e1bd)._isFunction(func)) func.call(this, val);
        else this._setAttr(attr, val);
        return this;
    }
    _requestDraw() {
        if ((0, $f1cce3c2a91bf0cf$export$b9f99057a3c7692).autoDrawEnabled) {
            const drawNode = this.getLayer() || this.getStage();
            drawNode === null || drawNode === void 0 || drawNode.batchDraw();
        }
    }
    _setAttr(key, val) {
        var oldVal = this.attrs[key];
        if (oldVal === val && !(0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).isObject(val)) return;
        if (val === undefined || val === null) delete this.attrs[key];
        else this.attrs[key] = val;
        if (this._shouldFireChangeEvents) this._fireChangeEvent(key, oldVal, val);
        this._requestDraw();
    }
    _setComponentAttr(key, component, val) {
        var oldVal;
        if (val !== undefined) {
            oldVal = this.attrs[key];
            if (!oldVal) this.attrs[key] = this.getAttr(key);
            this.attrs[key][component] = val;
            this._fireChangeEvent(key, oldVal, val);
        }
    }
    _fireAndBubble(eventType, evt, compareShape) {
        if (evt && this.nodeType === $97cb7af42217e259$var$SHAPE) evt.target = this;
        var shouldStop = (eventType === $97cb7af42217e259$var$MOUSEENTER || eventType === $97cb7af42217e259$var$MOUSELEAVE) && (compareShape && (this === compareShape || this.isAncestorOf && this.isAncestorOf(compareShape)) || this.nodeType === "Stage" && !compareShape);
        if (!shouldStop) {
            this._fire(eventType, evt);
            var stopBubble = (eventType === $97cb7af42217e259$var$MOUSEENTER || eventType === $97cb7af42217e259$var$MOUSELEAVE) && compareShape && compareShape.isAncestorOf && compareShape.isAncestorOf(this) && !compareShape.isAncestorOf(this.parent);
            if ((evt && !evt.cancelBubble || !evt) && this.parent && this.parent.isListening() && !stopBubble) {
                if (compareShape && compareShape.parent) this._fireAndBubble.call(this.parent, eventType, evt, compareShape);
                else this._fireAndBubble.call(this.parent, eventType, evt);
            }
        }
    }
    _getProtoListeners(eventType) {
        let listeners = this._cache.get($97cb7af42217e259$var$ALL_LISTENERS);
        if (!listeners) {
            listeners = {};
            let obj = Object.getPrototypeOf(this);
            while(obj){
                if (!obj.eventListeners) {
                    obj = Object.getPrototypeOf(obj);
                    continue;
                }
                for(var event in obj.eventListeners){
                    const newEvents = obj.eventListeners[event];
                    const oldEvents = listeners[event] || [];
                    listeners[event] = newEvents.concat(oldEvents);
                }
                obj = Object.getPrototypeOf(obj);
            }
            this._cache.set($97cb7af42217e259$var$ALL_LISTENERS, listeners);
        }
        return listeners[eventType];
    }
    _fire(eventType, evt) {
        evt = evt || {};
        evt.currentTarget = this;
        evt.type = eventType;
        const topListeners = this._getProtoListeners(eventType);
        if (topListeners) for(var i = 0; i < topListeners.length; i++)topListeners[i].handler.call(this, evt);
        const selfListeners = this.eventListeners[eventType];
        if (selfListeners) for(var i = 0; i < selfListeners.length; i++)selfListeners[i].handler.call(this, evt);
    }
    draw() {
        this.drawScene();
        this.drawHit();
        return this;
    }
    _createDragElement(evt) {
        var pointerId = evt ? evt.pointerId : undefined;
        var stage = this.getStage();
        var ap = this.getAbsolutePosition();
        var pos = stage._getPointerById(pointerId) || stage._changedPointerPositions[0] || ap;
        (0, $8410d2afdfe04713$export$e34f1b340034d7f)._dragElements.set(this._id, {
            node: this,
            startPointerPos: pos,
            offset: {
                x: pos.x - ap.x,
                y: pos.y - ap.y
            },
            dragStatus: "ready",
            pointerId: pointerId
        });
    }
    startDrag(evt, bubbleEvent = true) {
        if (!(0, $8410d2afdfe04713$export$e34f1b340034d7f)._dragElements.has(this._id)) this._createDragElement(evt);
        const elem = (0, $8410d2afdfe04713$export$e34f1b340034d7f)._dragElements.get(this._id);
        elem.dragStatus = "dragging";
        this.fire("dragstart", {
            type: "dragstart",
            target: this,
            evt: evt && evt.evt
        }, bubbleEvent);
    }
    _setDragPosition(evt, elem) {
        const pos = this.getStage()._getPointerById(elem.pointerId);
        if (!pos) return;
        var newNodePos = {
            x: pos.x - elem.offset.x,
            y: pos.y - elem.offset.y
        };
        var dbf = this.dragBoundFunc();
        if (dbf !== undefined) {
            const bounded = dbf.call(this, newNodePos, evt);
            if (!bounded) (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).warn("dragBoundFunc did not return any value. That is unexpected behavior. You must return new absolute position from dragBoundFunc.");
            else newNodePos = bounded;
        }
        if (!this._lastPos || this._lastPos.x !== newNodePos.x || this._lastPos.y !== newNodePos.y) {
            this.setAbsolutePosition(newNodePos);
            this._requestDraw();
        }
        this._lastPos = newNodePos;
    }
    stopDrag(evt) {
        const elem = (0, $8410d2afdfe04713$export$e34f1b340034d7f)._dragElements.get(this._id);
        if (elem) elem.dragStatus = "stopped";
        (0, $8410d2afdfe04713$export$e34f1b340034d7f)._endDragBefore(evt);
        (0, $8410d2afdfe04713$export$e34f1b340034d7f)._endDragAfter(evt);
    }
    setDraggable(draggable) {
        this._setAttr("draggable", draggable);
        this._dragChange();
    }
    isDragging() {
        const elem = (0, $8410d2afdfe04713$export$e34f1b340034d7f)._dragElements.get(this._id);
        return elem ? elem.dragStatus === "dragging" : false;
    }
    _listenDrag() {
        this._dragCleanup();
        this.on("mousedown.konva touchstart.konva", function(evt) {
            var shouldCheckButton = evt.evt["button"] !== undefined;
            var canDrag = !shouldCheckButton || (0, $f1cce3c2a91bf0cf$export$b9f99057a3c7692).dragButtons.indexOf(evt.evt["button"]) >= 0;
            if (!canDrag) return;
            if (this.isDragging()) return;
            var hasDraggingChild = false;
            (0, $8410d2afdfe04713$export$e34f1b340034d7f)._dragElements.forEach((elem)=>{
                if (this.isAncestorOf(elem.node)) hasDraggingChild = true;
            });
            if (!hasDraggingChild) this._createDragElement(evt);
        });
    }
    _dragChange() {
        if (this.attrs.draggable) this._listenDrag();
        else {
            this._dragCleanup();
            var stage = this.getStage();
            if (!stage) return;
            const dragElement = (0, $8410d2afdfe04713$export$e34f1b340034d7f)._dragElements.get(this._id);
            const isDragging = dragElement && dragElement.dragStatus === "dragging";
            const isReady = dragElement && dragElement.dragStatus === "ready";
            if (isDragging) this.stopDrag();
            else if (isReady) (0, $8410d2afdfe04713$export$e34f1b340034d7f)._dragElements.delete(this._id);
        }
    }
    _dragCleanup() {
        this.off("mousedown.konva");
        this.off("touchstart.konva");
    }
    isClientRectOnScreen(margin = {
        x: 0,
        y: 0
    }) {
        const stage = this.getStage();
        if (!stage) return false;
        const screenRect = {
            x: -margin.x,
            y: -margin.y,
            width: stage.width() + 2 * margin.x,
            height: stage.height() + 2 * margin.y
        };
        return (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).haveIntersection(screenRect, this.getClientRect());
    }
    static create(data, container) {
        if ((0, $4d54b3632f7367db$export$f8f26dd395d7e1bd)._isString(data)) data = JSON.parse(data);
        return this._createNode(data, container);
    }
    static _createNode(obj, container) {
        var className = $97cb7af42217e259$export$85c928794f8d04d4.prototype.getClassName.call(obj), children = obj.children, no, len, n;
        if (container) obj.attrs.container = container;
        if (!(0, $f1cce3c2a91bf0cf$export$b9f99057a3c7692)[className]) {
            (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).warn('Can not find a node with class name "' + className + '". Fallback to "Shape".');
            className = "Shape";
        }
        const Class = (0, $f1cce3c2a91bf0cf$export$b9f99057a3c7692)[className];
        no = new Class(obj.attrs);
        if (children) {
            len = children.length;
            for(n = 0; n < len; n++)no.add($97cb7af42217e259$export$85c928794f8d04d4._createNode(children[n]));
        }
        return no;
    }
}
$97cb7af42217e259$export$85c928794f8d04d4.prototype.nodeType = "Node";
$97cb7af42217e259$export$85c928794f8d04d4.prototype._attrsAffectingSize = [];
$97cb7af42217e259$export$85c928794f8d04d4.prototype.eventListeners = {};
$97cb7af42217e259$export$85c928794f8d04d4.prototype.on.call($97cb7af42217e259$export$85c928794f8d04d4.prototype, $97cb7af42217e259$var$TRANSFORM_CHANGE_STR, function() {
    if (this._batchingTransformChange) {
        this._needClearTransformCache = true;
        return;
    }
    this._clearCache($97cb7af42217e259$var$TRANSFORM);
    this._clearSelfAndDescendantCache($97cb7af42217e259$var$ABSOLUTE_TRANSFORM);
});
$97cb7af42217e259$export$85c928794f8d04d4.prototype.on.call($97cb7af42217e259$export$85c928794f8d04d4.prototype, "visibleChange.konva", function() {
    this._clearSelfAndDescendantCache($97cb7af42217e259$var$VISIBLE);
});
$97cb7af42217e259$export$85c928794f8d04d4.prototype.on.call($97cb7af42217e259$export$85c928794f8d04d4.prototype, "listeningChange.konva", function() {
    this._clearSelfAndDescendantCache($97cb7af42217e259$var$LISTENING);
});
$97cb7af42217e259$export$85c928794f8d04d4.prototype.on.call($97cb7af42217e259$export$85c928794f8d04d4.prototype, "opacityChange.konva", function() {
    this._clearSelfAndDescendantCache($97cb7af42217e259$var$ABSOLUTE_OPACITY);
});
const $97cb7af42217e259$var$addGetterSetter = (0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter;
$97cb7af42217e259$var$addGetterSetter($97cb7af42217e259$export$85c928794f8d04d4, "zIndex");
$97cb7af42217e259$var$addGetterSetter($97cb7af42217e259$export$85c928794f8d04d4, "absolutePosition");
$97cb7af42217e259$var$addGetterSetter($97cb7af42217e259$export$85c928794f8d04d4, "position");
$97cb7af42217e259$var$addGetterSetter($97cb7af42217e259$export$85c928794f8d04d4, "x", 0, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)());
$97cb7af42217e259$var$addGetterSetter($97cb7af42217e259$export$85c928794f8d04d4, "y", 0, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)());
$97cb7af42217e259$var$addGetterSetter($97cb7af42217e259$export$85c928794f8d04d4, "globalCompositeOperation", "source-over", (0, $8d9e6be936d29d8a$export$5837c5b6cc5b4d63)());
$97cb7af42217e259$var$addGetterSetter($97cb7af42217e259$export$85c928794f8d04d4, "opacity", 1, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)());
$97cb7af42217e259$var$addGetterSetter($97cb7af42217e259$export$85c928794f8d04d4, "name", "", (0, $8d9e6be936d29d8a$export$5837c5b6cc5b4d63)());
$97cb7af42217e259$var$addGetterSetter($97cb7af42217e259$export$85c928794f8d04d4, "id", "", (0, $8d9e6be936d29d8a$export$5837c5b6cc5b4d63)());
$97cb7af42217e259$var$addGetterSetter($97cb7af42217e259$export$85c928794f8d04d4, "rotation", 0, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)());
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addComponentsGetterSetter($97cb7af42217e259$export$85c928794f8d04d4, "scale", [
    "x",
    "y"
]);
$97cb7af42217e259$var$addGetterSetter($97cb7af42217e259$export$85c928794f8d04d4, "scaleX", 1, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)());
$97cb7af42217e259$var$addGetterSetter($97cb7af42217e259$export$85c928794f8d04d4, "scaleY", 1, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)());
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addComponentsGetterSetter($97cb7af42217e259$export$85c928794f8d04d4, "skew", [
    "x",
    "y"
]);
$97cb7af42217e259$var$addGetterSetter($97cb7af42217e259$export$85c928794f8d04d4, "skewX", 0, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)());
$97cb7af42217e259$var$addGetterSetter($97cb7af42217e259$export$85c928794f8d04d4, "skewY", 0, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)());
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addComponentsGetterSetter($97cb7af42217e259$export$85c928794f8d04d4, "offset", [
    "x",
    "y"
]);
$97cb7af42217e259$var$addGetterSetter($97cb7af42217e259$export$85c928794f8d04d4, "offsetX", 0, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)());
$97cb7af42217e259$var$addGetterSetter($97cb7af42217e259$export$85c928794f8d04d4, "offsetY", 0, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)());
$97cb7af42217e259$var$addGetterSetter($97cb7af42217e259$export$85c928794f8d04d4, "dragDistance", null, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)());
$97cb7af42217e259$var$addGetterSetter($97cb7af42217e259$export$85c928794f8d04d4, "width", 0, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)());
$97cb7af42217e259$var$addGetterSetter($97cb7af42217e259$export$85c928794f8d04d4, "height", 0, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)());
$97cb7af42217e259$var$addGetterSetter($97cb7af42217e259$export$85c928794f8d04d4, "listening", true, (0, $8d9e6be936d29d8a$export$147fc8b6cd20fda1)());
$97cb7af42217e259$var$addGetterSetter($97cb7af42217e259$export$85c928794f8d04d4, "preventDefault", true, (0, $8d9e6be936d29d8a$export$147fc8b6cd20fda1)());
$97cb7af42217e259$var$addGetterSetter($97cb7af42217e259$export$85c928794f8d04d4, "filters", null, function(val) {
    this._filterUpToDate = false;
    return val;
});
$97cb7af42217e259$var$addGetterSetter($97cb7af42217e259$export$85c928794f8d04d4, "visible", true, (0, $8d9e6be936d29d8a$export$147fc8b6cd20fda1)());
$97cb7af42217e259$var$addGetterSetter($97cb7af42217e259$export$85c928794f8d04d4, "transformsEnabled", "all", (0, $8d9e6be936d29d8a$export$5837c5b6cc5b4d63)());
$97cb7af42217e259$var$addGetterSetter($97cb7af42217e259$export$85c928794f8d04d4, "size");
$97cb7af42217e259$var$addGetterSetter($97cb7af42217e259$export$85c928794f8d04d4, "dragBoundFunc");
$97cb7af42217e259$var$addGetterSetter($97cb7af42217e259$export$85c928794f8d04d4, "draggable", false, (0, $8d9e6be936d29d8a$export$147fc8b6cd20fda1)());
(0, $e1d1e3911fd31488$export$8354032f3852ec50).backCompat($97cb7af42217e259$export$85c928794f8d04d4, {
    rotateDeg: "rotate",
    setRotationDeg: "setRotation",
    getRotationDeg: "getRotation"
});





class $f298365ca3013a23$export$42a852a2b6b56249 extends (0, $97cb7af42217e259$export$85c928794f8d04d4) {
    constructor(){
        super(...arguments);
        this.children = [];
    }
    getChildren(filterFunc) {
        if (!filterFunc) return this.children || [];
        const children = this.children || [];
        var results = [];
        children.forEach(function(child) {
            if (filterFunc(child)) results.push(child);
        });
        return results;
    }
    hasChildren() {
        return this.getChildren().length > 0;
    }
    removeChildren() {
        this.getChildren().forEach((child)=>{
            child.parent = null;
            child.index = 0;
            child.remove();
        });
        this.children = [];
        this._requestDraw();
        return this;
    }
    destroyChildren() {
        this.getChildren().forEach((child)=>{
            child.parent = null;
            child.index = 0;
            child.destroy();
        });
        this.children = [];
        this._requestDraw();
        return this;
    }
    add(...children) {
        if (children.length === 0) return this;
        if (children.length > 1) {
            for(var i = 0; i < children.length; i++)this.add(children[i]);
            return this;
        }
        const child = children[0];
        if (child.getParent()) {
            child.moveTo(this);
            return this;
        }
        this._validateAdd(child);
        child.index = this.getChildren().length;
        child.parent = this;
        child._clearCaches();
        this.getChildren().push(child);
        this._fire("add", {
            child: child
        });
        this._requestDraw();
        return this;
    }
    destroy() {
        if (this.hasChildren()) this.destroyChildren();
        super.destroy();
        return this;
    }
    find(selector) {
        return this._generalFind(selector, false);
    }
    findOne(selector) {
        var result = this._generalFind(selector, true);
        return result.length > 0 ? result[0] : undefined;
    }
    _generalFind(selector, findOne) {
        var retArr = [];
        this._descendants((node)=>{
            const valid = node._isMatch(selector);
            if (valid) retArr.push(node);
            if (valid && findOne) return true;
            return false;
        });
        return retArr;
    }
    _descendants(fn) {
        let shouldStop = false;
        const children = this.getChildren();
        for (const child of children){
            shouldStop = fn(child);
            if (shouldStop) return true;
            if (!child.hasChildren()) continue;
            shouldStop = child._descendants(fn);
            if (shouldStop) return true;
        }
        return false;
    }
    toObject() {
        var obj = (0, $97cb7af42217e259$export$85c928794f8d04d4).prototype.toObject.call(this);
        obj.children = [];
        this.getChildren().forEach((child)=>{
            obj.children.push(child.toObject());
        });
        return obj;
    }
    isAncestorOf(node) {
        var parent = node.getParent();
        while(parent){
            if (parent._id === this._id) return true;
            parent = parent.getParent();
        }
        return false;
    }
    clone(obj) {
        var node = (0, $97cb7af42217e259$export$85c928794f8d04d4).prototype.clone.call(this, obj);
        this.getChildren().forEach(function(no) {
            node.add(no.clone());
        });
        return node;
    }
    getAllIntersections(pos) {
        var arr = [];
        this.find("Shape").forEach(function(shape) {
            if (shape.isVisible() && shape.intersects(pos)) arr.push(shape);
        });
        return arr;
    }
    _clearSelfAndDescendantCache(attr) {
        var _a;
        super._clearSelfAndDescendantCache(attr);
        if (this.isCached()) return;
        (_a = this.children) === null || _a === void 0 || _a.forEach(function(node) {
            node._clearSelfAndDescendantCache(attr);
        });
    }
    _setChildrenIndices() {
        var _a;
        (_a = this.children) === null || _a === void 0 || _a.forEach(function(child, n) {
            child.index = n;
        });
        this._requestDraw();
    }
    drawScene(can, top) {
        var layer = this.getLayer(), canvas = can || layer && layer.getCanvas(), context = canvas && canvas.getContext(), cachedCanvas = this._getCanvasCache(), cachedSceneCanvas = cachedCanvas && cachedCanvas.scene;
        var caching = canvas && canvas.isCache;
        if (!this.isVisible() && !caching) return this;
        if (cachedSceneCanvas) {
            context.save();
            var m = this.getAbsoluteTransform(top).getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
            this._drawCachedSceneCanvas(context);
            context.restore();
        } else this._drawChildren("drawScene", canvas, top);
        return this;
    }
    drawHit(can, top) {
        if (!this.shouldDrawHit(top)) return this;
        var layer = this.getLayer(), canvas = can || layer && layer.hitCanvas, context = canvas && canvas.getContext(), cachedCanvas = this._getCanvasCache(), cachedHitCanvas = cachedCanvas && cachedCanvas.hit;
        if (cachedHitCanvas) {
            context.save();
            var m = this.getAbsoluteTransform(top).getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
            this._drawCachedHitCanvas(context);
            context.restore();
        } else this._drawChildren("drawHit", canvas, top);
        return this;
    }
    _drawChildren(drawMethod, canvas, top) {
        var _a;
        var context = canvas && canvas.getContext(), clipWidth = this.clipWidth(), clipHeight = this.clipHeight(), clipFunc = this.clipFunc(), hasClip = clipWidth && clipHeight || clipFunc;
        const selfCache = top === this;
        if (hasClip) {
            context.save();
            var transform = this.getAbsoluteTransform(top);
            var m = transform.getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
            context.beginPath();
            if (clipFunc) clipFunc.call(this, context, this);
            else {
                var clipX = this.clipX();
                var clipY = this.clipY();
                context.rect(clipX, clipY, clipWidth, clipHeight);
            }
            context.clip();
            m = transform.copy().invert().getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
        }
        var hasComposition = !selfCache && this.globalCompositeOperation() !== "source-over" && drawMethod === "drawScene";
        if (hasComposition) {
            context.save();
            context._applyGlobalCompositeOperation(this);
        }
        (_a = this.children) === null || _a === void 0 || _a.forEach(function(child) {
            child[drawMethod](canvas, top);
        });
        if (hasComposition) context.restore();
        if (hasClip) context.restore();
    }
    getClientRect(config) {
        var _a;
        config = config || {};
        var skipTransform = config.skipTransform;
        var relativeTo = config.relativeTo;
        var minX, minY, maxX, maxY;
        var selfRect = {
            x: Infinity,
            y: Infinity,
            width: 0,
            height: 0
        };
        var that = this;
        (_a = this.children) === null || _a === void 0 || _a.forEach(function(child) {
            if (!child.visible()) return;
            var rect = child.getClientRect({
                relativeTo: that,
                skipShadow: config.skipShadow,
                skipStroke: config.skipStroke
            });
            if (rect.width === 0 && rect.height === 0) return;
            if (minX === undefined) {
                minX = rect.x;
                minY = rect.y;
                maxX = rect.x + rect.width;
                maxY = rect.y + rect.height;
            } else {
                minX = Math.min(minX, rect.x);
                minY = Math.min(minY, rect.y);
                maxX = Math.max(maxX, rect.x + rect.width);
                maxY = Math.max(maxY, rect.y + rect.height);
            }
        });
        var shapes = this.find("Shape");
        var hasVisible = false;
        for(var i = 0; i < shapes.length; i++){
            var shape = shapes[i];
            if (shape._isVisible(this)) {
                hasVisible = true;
                break;
            }
        }
        if (hasVisible && minX !== undefined) selfRect = {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        };
        else selfRect = {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        };
        if (!skipTransform) return this._transformedRect(selfRect, relativeTo);
        return selfRect;
    }
}
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addComponentsGetterSetter($f298365ca3013a23$export$42a852a2b6b56249, "clip", [
    "x",
    "y",
    "width",
    "height"
]);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($f298365ca3013a23$export$42a852a2b6b56249, "clipX", undefined, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)());
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($f298365ca3013a23$export$42a852a2b6b56249, "clipY", undefined, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)());
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($f298365ca3013a23$export$42a852a2b6b56249, "clipWidth", undefined, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)());
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($f298365ca3013a23$export$42a852a2b6b56249, "clipHeight", undefined, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)());
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($f298365ca3013a23$export$42a852a2b6b56249, "clipFunc");









const $96e9ded006ceb1d5$var$Captures = new Map();
const $96e9ded006ceb1d5$var$SUPPORT_POINTER_EVENTS = (0, $f1cce3c2a91bf0cf$export$b9f99057a3c7692)._global["PointerEvent"] !== undefined;
function $96e9ded006ceb1d5$export$a55e3aaa85f15b00(pointerId) {
    return $96e9ded006ceb1d5$var$Captures.get(pointerId);
}
function $96e9ded006ceb1d5$export$c30017717ce2168e(evt) {
    return {
        evt: evt,
        pointerId: evt.pointerId
    };
}
function $96e9ded006ceb1d5$export$3b42bc7c43025bad(pointerId, shape) {
    return $96e9ded006ceb1d5$var$Captures.get(pointerId) === shape;
}
function $96e9ded006ceb1d5$export$1cab177b65f17c5a(pointerId, shape) {
    $96e9ded006ceb1d5$export$50f687f23c43e4d9(pointerId);
    const stage = shape.getStage();
    if (!stage) return;
    $96e9ded006ceb1d5$var$Captures.set(pointerId, shape);
    if ($96e9ded006ceb1d5$var$SUPPORT_POINTER_EVENTS) shape._fire("gotpointercapture", $96e9ded006ceb1d5$export$c30017717ce2168e(new PointerEvent("gotpointercapture")));
}
function $96e9ded006ceb1d5$export$50f687f23c43e4d9(pointerId, target) {
    const shape = $96e9ded006ceb1d5$var$Captures.get(pointerId);
    if (!shape) return;
    const stage = shape.getStage();
    stage && stage.content;
    $96e9ded006ceb1d5$var$Captures.delete(pointerId);
    if ($96e9ded006ceb1d5$var$SUPPORT_POINTER_EVENTS) shape._fire("lostpointercapture", $96e9ded006ceb1d5$export$c30017717ce2168e(new PointerEvent("lostpointercapture")));
}


var $6d48d6d6f577c60e$var$STAGE = "Stage", $6d48d6d6f577c60e$var$STRING = "string", $6d48d6d6f577c60e$var$PX = "px", $6d48d6d6f577c60e$var$MOUSEOUT = "mouseout", $6d48d6d6f577c60e$var$MOUSELEAVE = "mouseleave", $6d48d6d6f577c60e$var$MOUSEOVER = "mouseover", $6d48d6d6f577c60e$var$MOUSEENTER = "mouseenter", $6d48d6d6f577c60e$var$MOUSEMOVE = "mousemove", $6d48d6d6f577c60e$var$MOUSEDOWN = "mousedown", $6d48d6d6f577c60e$var$MOUSEUP = "mouseup", $6d48d6d6f577c60e$var$POINTERMOVE = "pointermove", $6d48d6d6f577c60e$var$POINTERDOWN = "pointerdown", $6d48d6d6f577c60e$var$POINTERUP = "pointerup", $6d48d6d6f577c60e$var$POINTERCANCEL = "pointercancel", $6d48d6d6f577c60e$var$LOSTPOINTERCAPTURE = "lostpointercapture", $6d48d6d6f577c60e$var$POINTEROUT = "pointerout", $6d48d6d6f577c60e$var$POINTERLEAVE = "pointerleave", $6d48d6d6f577c60e$var$POINTEROVER = "pointerover", $6d48d6d6f577c60e$var$POINTERENTER = "pointerenter", $6d48d6d6f577c60e$var$CONTEXTMENU = "contextmenu", $6d48d6d6f577c60e$var$TOUCHSTART = "touchstart", $6d48d6d6f577c60e$var$TOUCHEND = "touchend", $6d48d6d6f577c60e$var$TOUCHMOVE = "touchmove", $6d48d6d6f577c60e$var$TOUCHCANCEL = "touchcancel", $6d48d6d6f577c60e$var$WHEEL = "wheel", $6d48d6d6f577c60e$var$MAX_LAYERS_NUMBER = 5, $6d48d6d6f577c60e$var$EVENTS = [
    [
        $6d48d6d6f577c60e$var$MOUSEENTER,
        "_pointerenter"
    ],
    [
        $6d48d6d6f577c60e$var$MOUSEDOWN,
        "_pointerdown"
    ],
    [
        $6d48d6d6f577c60e$var$MOUSEMOVE,
        "_pointermove"
    ],
    [
        $6d48d6d6f577c60e$var$MOUSEUP,
        "_pointerup"
    ],
    [
        $6d48d6d6f577c60e$var$MOUSELEAVE,
        "_pointerleave"
    ],
    [
        $6d48d6d6f577c60e$var$TOUCHSTART,
        "_pointerdown"
    ],
    [
        $6d48d6d6f577c60e$var$TOUCHMOVE,
        "_pointermove"
    ],
    [
        $6d48d6d6f577c60e$var$TOUCHEND,
        "_pointerup"
    ],
    [
        $6d48d6d6f577c60e$var$TOUCHCANCEL,
        "_pointercancel"
    ],
    [
        $6d48d6d6f577c60e$var$MOUSEOVER,
        "_pointerover"
    ],
    [
        $6d48d6d6f577c60e$var$WHEEL,
        "_wheel"
    ],
    [
        $6d48d6d6f577c60e$var$CONTEXTMENU,
        "_contextmenu"
    ],
    [
        $6d48d6d6f577c60e$var$POINTERDOWN,
        "_pointerdown"
    ],
    [
        $6d48d6d6f577c60e$var$POINTERMOVE,
        "_pointermove"
    ],
    [
        $6d48d6d6f577c60e$var$POINTERUP,
        "_pointerup"
    ],
    [
        $6d48d6d6f577c60e$var$POINTERCANCEL,
        "_pointercancel"
    ],
    [
        $6d48d6d6f577c60e$var$LOSTPOINTERCAPTURE,
        "_lostpointercapture"
    ]
];
const $6d48d6d6f577c60e$var$EVENTS_MAP = {
    mouse: {
        [$6d48d6d6f577c60e$var$POINTEROUT]: $6d48d6d6f577c60e$var$MOUSEOUT,
        [$6d48d6d6f577c60e$var$POINTERLEAVE]: $6d48d6d6f577c60e$var$MOUSELEAVE,
        [$6d48d6d6f577c60e$var$POINTEROVER]: $6d48d6d6f577c60e$var$MOUSEOVER,
        [$6d48d6d6f577c60e$var$POINTERENTER]: $6d48d6d6f577c60e$var$MOUSEENTER,
        [$6d48d6d6f577c60e$var$POINTERMOVE]: $6d48d6d6f577c60e$var$MOUSEMOVE,
        [$6d48d6d6f577c60e$var$POINTERDOWN]: $6d48d6d6f577c60e$var$MOUSEDOWN,
        [$6d48d6d6f577c60e$var$POINTERUP]: $6d48d6d6f577c60e$var$MOUSEUP,
        [$6d48d6d6f577c60e$var$POINTERCANCEL]: "mousecancel",
        pointerclick: "click",
        pointerdblclick: "dblclick"
    },
    touch: {
        [$6d48d6d6f577c60e$var$POINTEROUT]: "touchout",
        [$6d48d6d6f577c60e$var$POINTERLEAVE]: "touchleave",
        [$6d48d6d6f577c60e$var$POINTEROVER]: "touchover",
        [$6d48d6d6f577c60e$var$POINTERENTER]: "touchenter",
        [$6d48d6d6f577c60e$var$POINTERMOVE]: $6d48d6d6f577c60e$var$TOUCHMOVE,
        [$6d48d6d6f577c60e$var$POINTERDOWN]: $6d48d6d6f577c60e$var$TOUCHSTART,
        [$6d48d6d6f577c60e$var$POINTERUP]: $6d48d6d6f577c60e$var$TOUCHEND,
        [$6d48d6d6f577c60e$var$POINTERCANCEL]: $6d48d6d6f577c60e$var$TOUCHCANCEL,
        pointerclick: "tap",
        pointerdblclick: "dbltap"
    },
    pointer: {
        [$6d48d6d6f577c60e$var$POINTEROUT]: $6d48d6d6f577c60e$var$POINTEROUT,
        [$6d48d6d6f577c60e$var$POINTERLEAVE]: $6d48d6d6f577c60e$var$POINTERLEAVE,
        [$6d48d6d6f577c60e$var$POINTEROVER]: $6d48d6d6f577c60e$var$POINTEROVER,
        [$6d48d6d6f577c60e$var$POINTERENTER]: $6d48d6d6f577c60e$var$POINTERENTER,
        [$6d48d6d6f577c60e$var$POINTERMOVE]: $6d48d6d6f577c60e$var$POINTERMOVE,
        [$6d48d6d6f577c60e$var$POINTERDOWN]: $6d48d6d6f577c60e$var$POINTERDOWN,
        [$6d48d6d6f577c60e$var$POINTERUP]: $6d48d6d6f577c60e$var$POINTERUP,
        [$6d48d6d6f577c60e$var$POINTERCANCEL]: $6d48d6d6f577c60e$var$POINTERCANCEL,
        pointerclick: "pointerclick",
        pointerdblclick: "pointerdblclick"
    }
};
const $6d48d6d6f577c60e$var$getEventType = (type)=>{
    if (type.indexOf("pointer") >= 0) return "pointer";
    if (type.indexOf("touch") >= 0) return "touch";
    return "mouse";
};
const $6d48d6d6f577c60e$var$getEventsMap = (eventType)=>{
    const type = $6d48d6d6f577c60e$var$getEventType(eventType);
    if (type === "pointer") return (0, $f1cce3c2a91bf0cf$export$b9f99057a3c7692).pointerEventsEnabled && $6d48d6d6f577c60e$var$EVENTS_MAP.pointer;
    if (type === "touch") return $6d48d6d6f577c60e$var$EVENTS_MAP.touch;
    if (type === "mouse") return $6d48d6d6f577c60e$var$EVENTS_MAP.mouse;
};
function $6d48d6d6f577c60e$var$checkNoClip(attrs = {}) {
    if (attrs.clipFunc || attrs.clipWidth || attrs.clipHeight) (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).warn("Stage does not support clipping. Please use clip for Layers or Groups.");
    return attrs;
}
const $6d48d6d6f577c60e$var$NO_POINTERS_MESSAGE = `Pointer position is missing and not registered by the stage. Looks like it is outside of the stage container. You can set it manually from event: stage.setPointersPositions(event);`;
const $6d48d6d6f577c60e$export$1bfcff8d7c4bf05 = [];
class $6d48d6d6f577c60e$export$208cd1682bd0e4b6 extends (0, $f298365ca3013a23$export$42a852a2b6b56249) {
    constructor(config){
        super($6d48d6d6f577c60e$var$checkNoClip(config));
        this._pointerPositions = [];
        this._changedPointerPositions = [];
        this._buildDOM();
        this._bindContentEvents();
        $6d48d6d6f577c60e$export$1bfcff8d7c4bf05.push(this);
        this.on("widthChange.konva heightChange.konva", this._resizeDOM);
        this.on("visibleChange.konva", this._checkVisibility);
        this.on("clipWidthChange.konva clipHeightChange.konva clipFuncChange.konva", ()=>{
            $6d48d6d6f577c60e$var$checkNoClip(this.attrs);
        });
        this._checkVisibility();
    }
    _validateAdd(child) {
        const isLayer = child.getType() === "Layer";
        const isFastLayer = child.getType() === "FastLayer";
        const valid = isLayer || isFastLayer;
        if (!valid) (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).throw("You may only add layers to the stage.");
    }
    _checkVisibility() {
        if (!this.content) return;
        const style = this.visible() ? "" : "none";
        this.content.style.display = style;
    }
    setContainer(container) {
        if (typeof container === $6d48d6d6f577c60e$var$STRING) {
            if (container.charAt(0) === ".") {
                var className = container.slice(1);
                container = document.getElementsByClassName(className)[0];
            } else {
                var id;
                if (container.charAt(0) !== "#") id = container;
                else id = container.slice(1);
                container = document.getElementById(id);
            }
            if (!container) throw "Can not find container in document with id " + id;
        }
        this._setAttr("container", container);
        if (this.content) {
            if (this.content.parentElement) this.content.parentElement.removeChild(this.content);
            container.appendChild(this.content);
        }
        return this;
    }
    shouldDrawHit() {
        return true;
    }
    clear() {
        var layers = this.children, len = layers.length, n;
        for(n = 0; n < len; n++)layers[n].clear();
        return this;
    }
    clone(obj) {
        if (!obj) obj = {};
        obj.container = typeof document !== "undefined" && document.createElement("div");
        return (0, $f298365ca3013a23$export$42a852a2b6b56249).prototype.clone.call(this, obj);
    }
    destroy() {
        super.destroy();
        var content = this.content;
        if (content && (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd)._isInDocument(content)) this.container().removeChild(content);
        var index = $6d48d6d6f577c60e$export$1bfcff8d7c4bf05.indexOf(this);
        if (index > -1) $6d48d6d6f577c60e$export$1bfcff8d7c4bf05.splice(index, 1);
        (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).releaseCanvas(this.bufferCanvas._canvas, this.bufferHitCanvas._canvas);
        return this;
    }
    getPointerPosition() {
        const pos = this._pointerPositions[0] || this._changedPointerPositions[0];
        if (!pos) {
            (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).warn($6d48d6d6f577c60e$var$NO_POINTERS_MESSAGE);
            return null;
        }
        return {
            x: pos.x,
            y: pos.y
        };
    }
    _getPointerById(id) {
        return this._pointerPositions.find((p)=>p.id === id);
    }
    getPointersPositions() {
        return this._pointerPositions;
    }
    getStage() {
        return this;
    }
    getContent() {
        return this.content;
    }
    _toKonvaCanvas(config) {
        config = config || {};
        config.x = config.x || 0;
        config.y = config.y || 0;
        config.width = config.width || this.width();
        config.height = config.height || this.height();
        var canvas = new (0, $6ecdd92180d794bd$export$ee612225bd2e63be)({
            width: config.width,
            height: config.height,
            pixelRatio: config.pixelRatio || 1
        });
        var _context = canvas.getContext()._context;
        var layers = this.children;
        if (config.x || config.y) _context.translate(-1 * config.x, -1 * config.y);
        layers.forEach(function(layer) {
            if (!layer.isVisible()) return;
            var layerCanvas = layer._toKonvaCanvas(config);
            _context.drawImage(layerCanvas._canvas, config.x, config.y, layerCanvas.getWidth() / layerCanvas.getPixelRatio(), layerCanvas.getHeight() / layerCanvas.getPixelRatio());
        });
        return canvas;
    }
    getIntersection(pos) {
        if (!pos) return null;
        var layers = this.children, len = layers.length, end = len - 1, n;
        for(n = end; n >= 0; n--){
            const shape = layers[n].getIntersection(pos);
            if (shape) return shape;
        }
        return null;
    }
    _resizeDOM() {
        var width = this.width();
        var height = this.height();
        if (this.content) {
            this.content.style.width = width + $6d48d6d6f577c60e$var$PX;
            this.content.style.height = height + $6d48d6d6f577c60e$var$PX;
        }
        this.bufferCanvas.setSize(width, height);
        this.bufferHitCanvas.setSize(width, height);
        this.children.forEach((layer)=>{
            layer.setSize({
                width: width,
                height: height
            });
            layer.draw();
        });
    }
    add(layer, ...rest) {
        if (arguments.length > 1) {
            for(var i = 0; i < arguments.length; i++)this.add(arguments[i]);
            return this;
        }
        super.add(layer);
        var length = this.children.length;
        if (length > $6d48d6d6f577c60e$var$MAX_LAYERS_NUMBER) (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).warn("The stage has " + length + " layers. Recommended maximum number of layers is 3-5. Adding more layers into the stage may drop the performance. Rethink your tree structure, you can use Konva.Group.");
        layer.setSize({
            width: this.width(),
            height: this.height()
        });
        layer.draw();
        if ((0, $f1cce3c2a91bf0cf$export$b9f99057a3c7692).isBrowser) this.content.appendChild(layer.canvas._canvas);
        return this;
    }
    getParent() {
        return null;
    }
    getLayer() {
        return null;
    }
    hasPointerCapture(pointerId) {
        return $96e9ded006ceb1d5$export$3b42bc7c43025bad(pointerId, this);
    }
    setPointerCapture(pointerId) {
        $96e9ded006ceb1d5$export$1cab177b65f17c5a(pointerId, this);
    }
    releaseCapture(pointerId) {
        $96e9ded006ceb1d5$export$50f687f23c43e4d9(pointerId, this);
    }
    getLayers() {
        return this.children;
    }
    _bindContentEvents() {
        if (!(0, $f1cce3c2a91bf0cf$export$b9f99057a3c7692).isBrowser) return;
        $6d48d6d6f577c60e$var$EVENTS.forEach(([event, methodName])=>{
            this.content.addEventListener(event, (evt)=>{
                this[methodName](evt);
            }, {
                passive: false
            });
        });
    }
    _pointerenter(evt) {
        this.setPointersPositions(evt);
        const events = $6d48d6d6f577c60e$var$getEventsMap(evt.type);
        this._fire(events.pointerenter, {
            evt: evt,
            target: this,
            currentTarget: this
        });
    }
    _pointerover(evt) {
        this.setPointersPositions(evt);
        const events = $6d48d6d6f577c60e$var$getEventsMap(evt.type);
        this._fire(events.pointerover, {
            evt: evt,
            target: this,
            currentTarget: this
        });
    }
    _getTargetShape(evenType) {
        let shape = this[evenType + "targetShape"];
        if (shape && !shape.getStage()) shape = null;
        return shape;
    }
    _pointerleave(evt) {
        const events = $6d48d6d6f577c60e$var$getEventsMap(evt.type);
        const eventType = $6d48d6d6f577c60e$var$getEventType(evt.type);
        if (!events) return;
        this.setPointersPositions(evt);
        var targetShape = this._getTargetShape(eventType);
        var eventsEnabled = !(0, $8410d2afdfe04713$export$e34f1b340034d7f).isDragging || (0, $f1cce3c2a91bf0cf$export$b9f99057a3c7692).hitOnDragEnabled;
        if (targetShape && eventsEnabled) {
            targetShape._fireAndBubble(events.pointerout, {
                evt: evt
            });
            targetShape._fireAndBubble(events.pointerleave, {
                evt: evt
            });
            this._fire(events.pointerleave, {
                evt: evt,
                target: this,
                currentTarget: this
            });
            this[eventType + "targetShape"] = null;
        } else if (eventsEnabled) {
            this._fire(events.pointerleave, {
                evt: evt,
                target: this,
                currentTarget: this
            });
            this._fire(events.pointerout, {
                evt: evt,
                target: this,
                currentTarget: this
            });
        }
        this.pointerPos = undefined;
        this._pointerPositions = [];
    }
    _pointerdown(evt) {
        const events = $6d48d6d6f577c60e$var$getEventsMap(evt.type);
        const eventType = $6d48d6d6f577c60e$var$getEventType(evt.type);
        if (!events) return;
        this.setPointersPositions(evt);
        var triggeredOnShape = false;
        this._changedPointerPositions.forEach((pos)=>{
            var shape = this.getIntersection(pos);
            (0, $8410d2afdfe04713$export$e34f1b340034d7f).justDragged = false;
            (0, $f1cce3c2a91bf0cf$export$b9f99057a3c7692)["_" + eventType + "ListenClick"] = true;
            const hasShape = shape && shape.isListening();
            if (!hasShape) return;
            if ((0, $f1cce3c2a91bf0cf$export$b9f99057a3c7692).capturePointerEventsEnabled) shape.setPointerCapture(pos.id);
            this[eventType + "ClickStartShape"] = shape;
            shape._fireAndBubble(events.pointerdown, {
                evt: evt,
                pointerId: pos.id
            });
            triggeredOnShape = true;
            const isTouch = evt.type.indexOf("touch") >= 0;
            if (shape.preventDefault() && evt.cancelable && isTouch) evt.preventDefault();
        });
        if (!triggeredOnShape) this._fire(events.pointerdown, {
            evt: evt,
            target: this,
            currentTarget: this,
            pointerId: this._pointerPositions[0].id
        });
    }
    _pointermove(evt) {
        const events = $6d48d6d6f577c60e$var$getEventsMap(evt.type);
        const eventType = $6d48d6d6f577c60e$var$getEventType(evt.type);
        if (!events) return;
        if ((0, $8410d2afdfe04713$export$e34f1b340034d7f).isDragging && (0, $8410d2afdfe04713$export$e34f1b340034d7f).node.preventDefault() && evt.cancelable) evt.preventDefault();
        this.setPointersPositions(evt);
        var eventsEnabled = !(0, $8410d2afdfe04713$export$e34f1b340034d7f).isDragging || (0, $f1cce3c2a91bf0cf$export$b9f99057a3c7692).hitOnDragEnabled;
        if (!eventsEnabled) return;
        var processedShapesIds = {};
        let triggeredOnShape = false;
        var targetShape = this._getTargetShape(eventType);
        this._changedPointerPositions.forEach((pos)=>{
            const shape = $96e9ded006ceb1d5$export$a55e3aaa85f15b00(pos.id) || this.getIntersection(pos);
            const pointerId = pos.id;
            const event = {
                evt: evt,
                pointerId: pointerId
            };
            var differentTarget = targetShape !== shape;
            if (differentTarget && targetShape) {
                targetShape._fireAndBubble(events.pointerout, Object.assign({}, event), shape);
                targetShape._fireAndBubble(events.pointerleave, Object.assign({}, event), shape);
            }
            if (shape) {
                if (processedShapesIds[shape._id]) return;
                processedShapesIds[shape._id] = true;
            }
            if (shape && shape.isListening()) {
                triggeredOnShape = true;
                if (differentTarget) {
                    shape._fireAndBubble(events.pointerover, Object.assign({}, event), targetShape);
                    shape._fireAndBubble(events.pointerenter, Object.assign({}, event), targetShape);
                    this[eventType + "targetShape"] = shape;
                }
                shape._fireAndBubble(events.pointermove, Object.assign({}, event));
            } else if (targetShape) {
                this._fire(events.pointerover, {
                    evt: evt,
                    target: this,
                    currentTarget: this,
                    pointerId: pointerId
                });
                this[eventType + "targetShape"] = null;
            }
        });
        if (!triggeredOnShape) this._fire(events.pointermove, {
            evt: evt,
            target: this,
            currentTarget: this,
            pointerId: this._changedPointerPositions[0].id
        });
    }
    _pointerup(evt) {
        const events = $6d48d6d6f577c60e$var$getEventsMap(evt.type);
        const eventType = $6d48d6d6f577c60e$var$getEventType(evt.type);
        if (!events) return;
        this.setPointersPositions(evt);
        const clickStartShape = this[eventType + "ClickStartShape"];
        const clickEndShape = this[eventType + "ClickEndShape"];
        var processedShapesIds = {};
        let triggeredOnShape = false;
        this._changedPointerPositions.forEach((pos)=>{
            const shape = $96e9ded006ceb1d5$export$a55e3aaa85f15b00(pos.id) || this.getIntersection(pos);
            if (shape) {
                shape.releaseCapture(pos.id);
                if (processedShapesIds[shape._id]) return;
                processedShapesIds[shape._id] = true;
            }
            const pointerId = pos.id;
            const event = {
                evt: evt,
                pointerId: pointerId
            };
            let fireDblClick = false;
            if ((0, $f1cce3c2a91bf0cf$export$b9f99057a3c7692)["_" + eventType + "InDblClickWindow"]) {
                fireDblClick = true;
                clearTimeout(this[eventType + "DblTimeout"]);
            } else if (!(0, $8410d2afdfe04713$export$e34f1b340034d7f).justDragged) {
                (0, $f1cce3c2a91bf0cf$export$b9f99057a3c7692)["_" + eventType + "InDblClickWindow"] = true;
                clearTimeout(this[eventType + "DblTimeout"]);
            }
            this[eventType + "DblTimeout"] = setTimeout(function() {
                (0, $f1cce3c2a91bf0cf$export$b9f99057a3c7692)["_" + eventType + "InDblClickWindow"] = false;
            }, (0, $f1cce3c2a91bf0cf$export$b9f99057a3c7692).dblClickWindow);
            if (shape && shape.isListening()) {
                triggeredOnShape = true;
                this[eventType + "ClickEndShape"] = shape;
                shape._fireAndBubble(events.pointerup, Object.assign({}, event));
                if ((0, $f1cce3c2a91bf0cf$export$b9f99057a3c7692)["_" + eventType + "ListenClick"] && clickStartShape && clickStartShape === shape) {
                    shape._fireAndBubble(events.pointerclick, Object.assign({}, event));
                    if (fireDblClick && clickEndShape && clickEndShape === shape) shape._fireAndBubble(events.pointerdblclick, Object.assign({}, event));
                }
            } else {
                this[eventType + "ClickEndShape"] = null;
                if ((0, $f1cce3c2a91bf0cf$export$b9f99057a3c7692)["_" + eventType + "ListenClick"]) this._fire(events.pointerclick, {
                    evt: evt,
                    target: this,
                    currentTarget: this,
                    pointerId: pointerId
                });
                if (fireDblClick) this._fire(events.pointerdblclick, {
                    evt: evt,
                    target: this,
                    currentTarget: this,
                    pointerId: pointerId
                });
            }
        });
        if (!triggeredOnShape) this._fire(events.pointerup, {
            evt: evt,
            target: this,
            currentTarget: this,
            pointerId: this._changedPointerPositions[0].id
        });
        (0, $f1cce3c2a91bf0cf$export$b9f99057a3c7692)["_" + eventType + "ListenClick"] = false;
        if (evt.cancelable && eventType !== "touch") evt.preventDefault();
    }
    _contextmenu(evt) {
        this.setPointersPositions(evt);
        var shape = this.getIntersection(this.getPointerPosition());
        if (shape && shape.isListening()) shape._fireAndBubble($6d48d6d6f577c60e$var$CONTEXTMENU, {
            evt: evt
        });
        else this._fire($6d48d6d6f577c60e$var$CONTEXTMENU, {
            evt: evt,
            target: this,
            currentTarget: this
        });
    }
    _wheel(evt) {
        this.setPointersPositions(evt);
        var shape = this.getIntersection(this.getPointerPosition());
        if (shape && shape.isListening()) shape._fireAndBubble($6d48d6d6f577c60e$var$WHEEL, {
            evt: evt
        });
        else this._fire($6d48d6d6f577c60e$var$WHEEL, {
            evt: evt,
            target: this,
            currentTarget: this
        });
    }
    _pointercancel(evt) {
        this.setPointersPositions(evt);
        const shape = $96e9ded006ceb1d5$export$a55e3aaa85f15b00(evt.pointerId) || this.getIntersection(this.getPointerPosition());
        if (shape) shape._fireAndBubble($6d48d6d6f577c60e$var$POINTERUP, $96e9ded006ceb1d5$export$c30017717ce2168e(evt));
        $96e9ded006ceb1d5$export$50f687f23c43e4d9(evt.pointerId);
    }
    _lostpointercapture(evt) {
        $96e9ded006ceb1d5$export$50f687f23c43e4d9(evt.pointerId);
    }
    setPointersPositions(evt) {
        var contentPosition = this._getContentPosition(), x = null, y = null;
        evt = evt ? evt : window.event;
        if (evt.touches !== undefined) {
            this._pointerPositions = [];
            this._changedPointerPositions = [];
            Array.prototype.forEach.call(evt.touches, (touch)=>{
                this._pointerPositions.push({
                    id: touch.identifier,
                    x: (touch.clientX - contentPosition.left) / contentPosition.scaleX,
                    y: (touch.clientY - contentPosition.top) / contentPosition.scaleY
                });
            });
            Array.prototype.forEach.call(evt.changedTouches || evt.touches, (touch)=>{
                this._changedPointerPositions.push({
                    id: touch.identifier,
                    x: (touch.clientX - contentPosition.left) / contentPosition.scaleX,
                    y: (touch.clientY - contentPosition.top) / contentPosition.scaleY
                });
            });
        } else {
            x = (evt.clientX - contentPosition.left) / contentPosition.scaleX;
            y = (evt.clientY - contentPosition.top) / contentPosition.scaleY;
            this.pointerPos = {
                x: x,
                y: y
            };
            this._pointerPositions = [
                {
                    x: x,
                    y: y,
                    id: (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd)._getFirstPointerId(evt)
                }
            ];
            this._changedPointerPositions = [
                {
                    x: x,
                    y: y,
                    id: (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd)._getFirstPointerId(evt)
                }
            ];
        }
    }
    _setPointerPosition(evt) {
        (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).warn('Method _setPointerPosition is deprecated. Use "stage.setPointersPositions(event)" instead.');
        this.setPointersPositions(evt);
    }
    _getContentPosition() {
        if (!this.content || !this.content.getBoundingClientRect) return {
            top: 0,
            left: 0,
            scaleX: 1,
            scaleY: 1
        };
        var rect = this.content.getBoundingClientRect();
        return {
            top: rect.top,
            left: rect.left,
            scaleX: rect.width / this.content.clientWidth || 1,
            scaleY: rect.height / this.content.clientHeight || 1
        };
    }
    _buildDOM() {
        this.bufferCanvas = new (0, $6ecdd92180d794bd$export$ee612225bd2e63be)({
            width: this.width(),
            height: this.height()
        });
        this.bufferHitCanvas = new (0, $6ecdd92180d794bd$export$43a2e1456e27dc84)({
            pixelRatio: 1,
            width: this.width(),
            height: this.height()
        });
        if (!(0, $f1cce3c2a91bf0cf$export$b9f99057a3c7692).isBrowser) return;
        var container = this.container();
        if (!container) throw "Stage has no container. A container is required.";
        container.innerHTML = "";
        this.content = document.createElement("div");
        this.content.style.position = "relative";
        this.content.style.userSelect = "none";
        this.content.className = "konvajs-content";
        this.content.setAttribute("role", "presentation");
        container.appendChild(this.content);
        this._resizeDOM();
    }
    cache() {
        (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).warn("Cache function is not allowed for stage. You may use cache only for layers, groups and shapes.");
        return this;
    }
    clearCache() {
        return this;
    }
    batchDraw() {
        this.getChildren().forEach(function(layer) {
            layer.batchDraw();
        });
        return this;
    }
}
$6d48d6d6f577c60e$export$208cd1682bd0e4b6.prototype.nodeType = $6d48d6d6f577c60e$var$STAGE;
(0, $f1cce3c2a91bf0cf$export$f7a70d87a5e829eb)($6d48d6d6f577c60e$export$208cd1682bd0e4b6);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($6d48d6d6f577c60e$export$208cd1682bd0e4b6, "container");














var $3bfe60cc136fb197$var$HAS_SHADOW = "hasShadow";
var $3bfe60cc136fb197$var$SHADOW_RGBA = "shadowRGBA";
var $3bfe60cc136fb197$var$patternImage = "patternImage";
var $3bfe60cc136fb197$var$linearGradient = "linearGradient";
var $3bfe60cc136fb197$var$radialGradient = "radialGradient";
let $3bfe60cc136fb197$var$dummyContext;
function $3bfe60cc136fb197$var$getDummyContext() {
    if ($3bfe60cc136fb197$var$dummyContext) return $3bfe60cc136fb197$var$dummyContext;
    $3bfe60cc136fb197$var$dummyContext = (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).createCanvasElement().getContext("2d");
    return $3bfe60cc136fb197$var$dummyContext;
}
const $3bfe60cc136fb197$export$4ff7fc6f1af248b5 = {};
function $3bfe60cc136fb197$var$_fillFunc(context) {
    context.fill();
}
function $3bfe60cc136fb197$var$_strokeFunc(context) {
    context.stroke();
}
function $3bfe60cc136fb197$var$_fillFuncHit(context) {
    context.fill();
}
function $3bfe60cc136fb197$var$_strokeFuncHit(context) {
    context.stroke();
}
function $3bfe60cc136fb197$var$_clearHasShadowCache() {
    this._clearCache($3bfe60cc136fb197$var$HAS_SHADOW);
}
function $3bfe60cc136fb197$var$_clearGetShadowRGBACache() {
    this._clearCache($3bfe60cc136fb197$var$SHADOW_RGBA);
}
function $3bfe60cc136fb197$var$_clearFillPatternCache() {
    this._clearCache($3bfe60cc136fb197$var$patternImage);
}
function $3bfe60cc136fb197$var$_clearLinearGradientCache() {
    this._clearCache($3bfe60cc136fb197$var$linearGradient);
}
function $3bfe60cc136fb197$var$_clearRadialGradientCache() {
    this._clearCache($3bfe60cc136fb197$var$radialGradient);
}
class $3bfe60cc136fb197$export$6428a7f2611ef1fa extends (0, $97cb7af42217e259$export$85c928794f8d04d4) {
    constructor(config){
        super(config);
        let key;
        while(true){
            key = (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).getRandomColor();
            if (key && !(key in $3bfe60cc136fb197$export$4ff7fc6f1af248b5)) break;
        }
        this.colorKey = key;
        $3bfe60cc136fb197$export$4ff7fc6f1af248b5[key] = this;
    }
    getContext() {
        (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).warn("shape.getContext() method is deprecated. Please do not use it.");
        return this.getLayer().getContext();
    }
    getCanvas() {
        (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).warn("shape.getCanvas() method is deprecated. Please do not use it.");
        return this.getLayer().getCanvas();
    }
    getSceneFunc() {
        return this.attrs.sceneFunc || this["_sceneFunc"];
    }
    getHitFunc() {
        return this.attrs.hitFunc || this["_hitFunc"];
    }
    hasShadow() {
        return this._getCache($3bfe60cc136fb197$var$HAS_SHADOW, this._hasShadow);
    }
    _hasShadow() {
        return this.shadowEnabled() && this.shadowOpacity() !== 0 && !!(this.shadowColor() || this.shadowBlur() || this.shadowOffsetX() || this.shadowOffsetY());
    }
    _getFillPattern() {
        return this._getCache($3bfe60cc136fb197$var$patternImage, this.__getFillPattern);
    }
    __getFillPattern() {
        if (this.fillPatternImage()) {
            var ctx = $3bfe60cc136fb197$var$getDummyContext();
            const pattern = ctx.createPattern(this.fillPatternImage(), this.fillPatternRepeat() || "repeat");
            if (pattern && pattern.setTransform) {
                const tr = new (0, $4d54b3632f7367db$export$563a914cafbdc389)();
                tr.translate(this.fillPatternX(), this.fillPatternY());
                tr.rotate((0, $f1cce3c2a91bf0cf$export$b9f99057a3c7692).getAngle(this.fillPatternRotation()));
                tr.scale(this.fillPatternScaleX(), this.fillPatternScaleY());
                tr.translate(-1 * this.fillPatternOffsetX(), -1 * this.fillPatternOffsetY());
                const m = tr.getMatrix();
                const matrix = typeof DOMMatrix === "undefined" ? {
                    a: m[0],
                    b: m[1],
                    c: m[2],
                    d: m[3],
                    e: m[4],
                    f: m[5]
                } : new DOMMatrix(m);
                pattern.setTransform(matrix);
            }
            return pattern;
        }
    }
    _getLinearGradient() {
        return this._getCache($3bfe60cc136fb197$var$linearGradient, this.__getLinearGradient);
    }
    __getLinearGradient() {
        var colorStops = this.fillLinearGradientColorStops();
        if (colorStops) {
            var ctx = $3bfe60cc136fb197$var$getDummyContext();
            var start = this.fillLinearGradientStartPoint();
            var end = this.fillLinearGradientEndPoint();
            var grd = ctx.createLinearGradient(start.x, start.y, end.x, end.y);
            for(var n = 0; n < colorStops.length; n += 2)grd.addColorStop(colorStops[n], colorStops[n + 1]);
            return grd;
        }
    }
    _getRadialGradient() {
        return this._getCache($3bfe60cc136fb197$var$radialGradient, this.__getRadialGradient);
    }
    __getRadialGradient() {
        var colorStops = this.fillRadialGradientColorStops();
        if (colorStops) {
            var ctx = $3bfe60cc136fb197$var$getDummyContext();
            var start = this.fillRadialGradientStartPoint();
            var end = this.fillRadialGradientEndPoint();
            var grd = ctx.createRadialGradient(start.x, start.y, this.fillRadialGradientStartRadius(), end.x, end.y, this.fillRadialGradientEndRadius());
            for(var n = 0; n < colorStops.length; n += 2)grd.addColorStop(colorStops[n], colorStops[n + 1]);
            return grd;
        }
    }
    getShadowRGBA() {
        return this._getCache($3bfe60cc136fb197$var$SHADOW_RGBA, this._getShadowRGBA);
    }
    _getShadowRGBA() {
        if (!this.hasShadow()) return;
        var rgba = (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).colorToRGBA(this.shadowColor());
        if (rgba) return "rgba(" + rgba.r + "," + rgba.g + "," + rgba.b + "," + rgba.a * (this.shadowOpacity() || 1) + ")";
    }
    hasFill() {
        return this._calculate("hasFill", [
            "fillEnabled",
            "fill",
            "fillPatternImage",
            "fillLinearGradientColorStops",
            "fillRadialGradientColorStops"
        ], ()=>{
            return this.fillEnabled() && !!(this.fill() || this.fillPatternImage() || this.fillLinearGradientColorStops() || this.fillRadialGradientColorStops());
        });
    }
    hasStroke() {
        return this._calculate("hasStroke", [
            "strokeEnabled",
            "strokeWidth",
            "stroke",
            "strokeLinearGradientColorStops"
        ], ()=>{
            return this.strokeEnabled() && this.strokeWidth() && !!(this.stroke() || this.strokeLinearGradientColorStops());
        });
    }
    hasHitStroke() {
        const width = this.hitStrokeWidth();
        if (width === "auto") return this.hasStroke();
        return this.strokeEnabled() && !!width;
    }
    intersects(point) {
        var stage = this.getStage(), bufferHitCanvas = stage.bufferHitCanvas, p;
        bufferHitCanvas.getContext().clear();
        this.drawHit(bufferHitCanvas, null, true);
        p = bufferHitCanvas.context.getImageData(Math.round(point.x), Math.round(point.y), 1, 1).data;
        return p[3] > 0;
    }
    destroy() {
        (0, $97cb7af42217e259$export$85c928794f8d04d4).prototype.destroy.call(this);
        delete $3bfe60cc136fb197$export$4ff7fc6f1af248b5[this.colorKey];
        delete this.colorKey;
        return this;
    }
    _useBufferCanvas(forceFill) {
        var _a;
        if (!this.getStage()) return false;
        const perfectDrawEnabled = (_a = this.attrs.perfectDrawEnabled) !== null && _a !== void 0 ? _a : true;
        if (!perfectDrawEnabled) return false;
        const hasFill = forceFill || this.hasFill();
        const hasStroke = this.hasStroke();
        const isTransparent = this.getAbsoluteOpacity() !== 1;
        if (hasFill && hasStroke && isTransparent) return true;
        const hasShadow = this.hasShadow();
        const strokeForShadow = this.shadowForStrokeEnabled();
        if (hasFill && hasStroke && hasShadow && strokeForShadow) return true;
        return false;
    }
    setStrokeHitEnabled(val) {
        (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).warn("strokeHitEnabled property is deprecated. Please use hitStrokeWidth instead.");
        if (val) this.hitStrokeWidth("auto");
        else this.hitStrokeWidth(0);
    }
    getStrokeHitEnabled() {
        if (this.hitStrokeWidth() === 0) return false;
        else return true;
    }
    getSelfRect() {
        var size = this.size();
        return {
            x: this._centroid ? -size.width / 2 : 0,
            y: this._centroid ? -size.height / 2 : 0,
            width: size.width,
            height: size.height
        };
    }
    getClientRect(config = {}) {
        const skipTransform = config.skipTransform;
        const relativeTo = config.relativeTo;
        const fillRect = this.getSelfRect();
        const applyStroke = !config.skipStroke && this.hasStroke();
        const strokeWidth = applyStroke && this.strokeWidth() || 0;
        const fillAndStrokeWidth = fillRect.width + strokeWidth;
        const fillAndStrokeHeight = fillRect.height + strokeWidth;
        const applyShadow = !config.skipShadow && this.hasShadow();
        const shadowOffsetX = applyShadow ? this.shadowOffsetX() : 0;
        const shadowOffsetY = applyShadow ? this.shadowOffsetY() : 0;
        const preWidth = fillAndStrokeWidth + Math.abs(shadowOffsetX);
        const preHeight = fillAndStrokeHeight + Math.abs(shadowOffsetY);
        const blurRadius = applyShadow && this.shadowBlur() || 0;
        const width = preWidth + blurRadius * 2;
        const height = preHeight + blurRadius * 2;
        const rect = {
            width: width,
            height: height,
            x: -(strokeWidth / 2 + blurRadius) + Math.min(shadowOffsetX, 0) + fillRect.x,
            y: -(strokeWidth / 2 + blurRadius) + Math.min(shadowOffsetY, 0) + fillRect.y
        };
        if (!skipTransform) return this._transformedRect(rect, relativeTo);
        return rect;
    }
    drawScene(can, top) {
        var layer = this.getLayer(), canvas = can || layer.getCanvas(), context = canvas.getContext(), cachedCanvas = this._getCanvasCache(), drawFunc = this.getSceneFunc(), hasShadow = this.hasShadow(), stage, bufferCanvas, bufferContext;
        var skipBuffer = canvas.isCache;
        var cachingSelf = top === this;
        if (!this.isVisible() && !cachingSelf) return this;
        if (cachedCanvas) {
            context.save();
            var m = this.getAbsoluteTransform(top).getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
            this._drawCachedSceneCanvas(context);
            context.restore();
            return this;
        }
        if (!drawFunc) return this;
        context.save();
        if (this._useBufferCanvas() && !skipBuffer) {
            stage = this.getStage();
            bufferCanvas = stage.bufferCanvas;
            bufferContext = bufferCanvas.getContext();
            bufferContext.clear();
            bufferContext.save();
            bufferContext._applyLineJoin(this);
            var o = this.getAbsoluteTransform(top).getMatrix();
            bufferContext.transform(o[0], o[1], o[2], o[3], o[4], o[5]);
            drawFunc.call(this, bufferContext, this);
            bufferContext.restore();
            var ratio = bufferCanvas.pixelRatio;
            if (hasShadow) context._applyShadow(this);
            context._applyOpacity(this);
            context._applyGlobalCompositeOperation(this);
            context.drawImage(bufferCanvas._canvas, 0, 0, bufferCanvas.width / ratio, bufferCanvas.height / ratio);
        } else {
            context._applyLineJoin(this);
            if (!cachingSelf) {
                var o = this.getAbsoluteTransform(top).getMatrix();
                context.transform(o[0], o[1], o[2], o[3], o[4], o[5]);
                context._applyOpacity(this);
                context._applyGlobalCompositeOperation(this);
            }
            if (hasShadow) context._applyShadow(this);
            drawFunc.call(this, context, this);
        }
        context.restore();
        return this;
    }
    drawHit(can, top, skipDragCheck = false) {
        if (!this.shouldDrawHit(top, skipDragCheck)) return this;
        var layer = this.getLayer(), canvas = can || layer.hitCanvas, context = canvas && canvas.getContext(), drawFunc = this.hitFunc() || this.sceneFunc(), cachedCanvas = this._getCanvasCache(), cachedHitCanvas = cachedCanvas && cachedCanvas.hit;
        if (!this.colorKey) (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).warn("Looks like your canvas has a destroyed shape in it. Do not reuse shape after you destroyed it. If you want to reuse shape you should call remove() instead of destroy()");
        if (cachedHitCanvas) {
            context.save();
            var m = this.getAbsoluteTransform(top).getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
            this._drawCachedHitCanvas(context);
            context.restore();
            return this;
        }
        if (!drawFunc) return this;
        context.save();
        context._applyLineJoin(this);
        const selfCache = this === top;
        if (!selfCache) {
            var o = this.getAbsoluteTransform(top).getMatrix();
            context.transform(o[0], o[1], o[2], o[3], o[4], o[5]);
        }
        drawFunc.call(this, context, this);
        context.restore();
        return this;
    }
    drawHitFromCache(alphaThreshold = 0) {
        var cachedCanvas = this._getCanvasCache(), sceneCanvas = this._getCachedSceneCanvas(), hitCanvas = cachedCanvas.hit, hitContext = hitCanvas.getContext(), hitWidth = hitCanvas.getWidth(), hitHeight = hitCanvas.getHeight(), hitImageData, hitData, len, rgbColorKey, i, alpha;
        hitContext.clear();
        hitContext.drawImage(sceneCanvas._canvas, 0, 0, hitWidth, hitHeight);
        try {
            hitImageData = hitContext.getImageData(0, 0, hitWidth, hitHeight);
            hitData = hitImageData.data;
            len = hitData.length;
            rgbColorKey = (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd)._hexToRgb(this.colorKey);
            for(i = 0; i < len; i += 4){
                alpha = hitData[i + 3];
                if (alpha > alphaThreshold) {
                    hitData[i] = rgbColorKey.r;
                    hitData[i + 1] = rgbColorKey.g;
                    hitData[i + 2] = rgbColorKey.b;
                    hitData[i + 3] = 255;
                } else hitData[i + 3] = 0;
            }
            hitContext.putImageData(hitImageData, 0, 0);
        } catch (e) {
            (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).error("Unable to draw hit graph from cached scene canvas. " + e.message);
        }
        return this;
    }
    hasPointerCapture(pointerId) {
        return $96e9ded006ceb1d5$export$3b42bc7c43025bad(pointerId, this);
    }
    setPointerCapture(pointerId) {
        $96e9ded006ceb1d5$export$1cab177b65f17c5a(pointerId, this);
    }
    releaseCapture(pointerId) {
        $96e9ded006ceb1d5$export$50f687f23c43e4d9(pointerId, this);
    }
}
$3bfe60cc136fb197$export$6428a7f2611ef1fa.prototype._fillFunc = $3bfe60cc136fb197$var$_fillFunc;
$3bfe60cc136fb197$export$6428a7f2611ef1fa.prototype._strokeFunc = $3bfe60cc136fb197$var$_strokeFunc;
$3bfe60cc136fb197$export$6428a7f2611ef1fa.prototype._fillFuncHit = $3bfe60cc136fb197$var$_fillFuncHit;
$3bfe60cc136fb197$export$6428a7f2611ef1fa.prototype._strokeFuncHit = $3bfe60cc136fb197$var$_strokeFuncHit;
$3bfe60cc136fb197$export$6428a7f2611ef1fa.prototype._centroid = false;
$3bfe60cc136fb197$export$6428a7f2611ef1fa.prototype.nodeType = "Shape";
(0, $f1cce3c2a91bf0cf$export$f7a70d87a5e829eb)($3bfe60cc136fb197$export$6428a7f2611ef1fa);
$3bfe60cc136fb197$export$6428a7f2611ef1fa.prototype.eventListeners = {};
$3bfe60cc136fb197$export$6428a7f2611ef1fa.prototype.on.call($3bfe60cc136fb197$export$6428a7f2611ef1fa.prototype, "shadowColorChange.konva shadowBlurChange.konva shadowOffsetChange.konva shadowOpacityChange.konva shadowEnabledChange.konva", $3bfe60cc136fb197$var$_clearHasShadowCache);
$3bfe60cc136fb197$export$6428a7f2611ef1fa.prototype.on.call($3bfe60cc136fb197$export$6428a7f2611ef1fa.prototype, "shadowColorChange.konva shadowOpacityChange.konva shadowEnabledChange.konva", $3bfe60cc136fb197$var$_clearGetShadowRGBACache);
$3bfe60cc136fb197$export$6428a7f2611ef1fa.prototype.on.call($3bfe60cc136fb197$export$6428a7f2611ef1fa.prototype, "fillPriorityChange.konva fillPatternImageChange.konva fillPatternRepeatChange.konva fillPatternScaleXChange.konva fillPatternScaleYChange.konva fillPatternOffsetXChange.konva fillPatternOffsetYChange.konva fillPatternXChange.konva fillPatternYChange.konva fillPatternRotationChange.konva", $3bfe60cc136fb197$var$_clearFillPatternCache);
$3bfe60cc136fb197$export$6428a7f2611ef1fa.prototype.on.call($3bfe60cc136fb197$export$6428a7f2611ef1fa.prototype, "fillPriorityChange.konva fillLinearGradientColorStopsChange.konva fillLinearGradientStartPointXChange.konva fillLinearGradientStartPointYChange.konva fillLinearGradientEndPointXChange.konva fillLinearGradientEndPointYChange.konva", $3bfe60cc136fb197$var$_clearLinearGradientCache);
$3bfe60cc136fb197$export$6428a7f2611ef1fa.prototype.on.call($3bfe60cc136fb197$export$6428a7f2611ef1fa.prototype, "fillPriorityChange.konva fillRadialGradientColorStopsChange.konva fillRadialGradientStartPointXChange.konva fillRadialGradientStartPointYChange.konva fillRadialGradientEndPointXChange.konva fillRadialGradientEndPointYChange.konva fillRadialGradientStartRadiusChange.konva fillRadialGradientEndRadiusChange.konva", $3bfe60cc136fb197$var$_clearRadialGradientCache);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($3bfe60cc136fb197$export$6428a7f2611ef1fa, "stroke", undefined, (0, $8d9e6be936d29d8a$export$9c72f966a828cc68)());
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($3bfe60cc136fb197$export$6428a7f2611ef1fa, "strokeWidth", 2, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)());
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($3bfe60cc136fb197$export$6428a7f2611ef1fa, "fillAfterStrokeEnabled", false);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($3bfe60cc136fb197$export$6428a7f2611ef1fa, "hitStrokeWidth", "auto", (0, $8d9e6be936d29d8a$export$3b7df2720ef33404)());
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($3bfe60cc136fb197$export$6428a7f2611ef1fa, "strokeHitEnabled", true, (0, $8d9e6be936d29d8a$export$147fc8b6cd20fda1)());
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($3bfe60cc136fb197$export$6428a7f2611ef1fa, "perfectDrawEnabled", true, (0, $8d9e6be936d29d8a$export$147fc8b6cd20fda1)());
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($3bfe60cc136fb197$export$6428a7f2611ef1fa, "shadowForStrokeEnabled", true, (0, $8d9e6be936d29d8a$export$147fc8b6cd20fda1)());
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($3bfe60cc136fb197$export$6428a7f2611ef1fa, "lineJoin");
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($3bfe60cc136fb197$export$6428a7f2611ef1fa, "lineCap");
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($3bfe60cc136fb197$export$6428a7f2611ef1fa, "sceneFunc");
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($3bfe60cc136fb197$export$6428a7f2611ef1fa, "hitFunc");
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($3bfe60cc136fb197$export$6428a7f2611ef1fa, "dash");
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($3bfe60cc136fb197$export$6428a7f2611ef1fa, "dashOffset", 0, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)());
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($3bfe60cc136fb197$export$6428a7f2611ef1fa, "shadowColor", undefined, (0, $8d9e6be936d29d8a$export$5837c5b6cc5b4d63)());
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($3bfe60cc136fb197$export$6428a7f2611ef1fa, "shadowBlur", 0, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)());
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($3bfe60cc136fb197$export$6428a7f2611ef1fa, "shadowOpacity", 1, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)());
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addComponentsGetterSetter($3bfe60cc136fb197$export$6428a7f2611ef1fa, "shadowOffset", [
    "x",
    "y"
]);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($3bfe60cc136fb197$export$6428a7f2611ef1fa, "shadowOffsetX", 0, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)());
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($3bfe60cc136fb197$export$6428a7f2611ef1fa, "shadowOffsetY", 0, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)());
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($3bfe60cc136fb197$export$6428a7f2611ef1fa, "fillPatternImage");
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($3bfe60cc136fb197$export$6428a7f2611ef1fa, "fill", undefined, (0, $8d9e6be936d29d8a$export$9c72f966a828cc68)());
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($3bfe60cc136fb197$export$6428a7f2611ef1fa, "fillPatternX", 0, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)());
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($3bfe60cc136fb197$export$6428a7f2611ef1fa, "fillPatternY", 0, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)());
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($3bfe60cc136fb197$export$6428a7f2611ef1fa, "fillLinearGradientColorStops");
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($3bfe60cc136fb197$export$6428a7f2611ef1fa, "strokeLinearGradientColorStops");
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($3bfe60cc136fb197$export$6428a7f2611ef1fa, "fillRadialGradientStartRadius", 0);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($3bfe60cc136fb197$export$6428a7f2611ef1fa, "fillRadialGradientEndRadius", 0);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($3bfe60cc136fb197$export$6428a7f2611ef1fa, "fillRadialGradientColorStops");
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($3bfe60cc136fb197$export$6428a7f2611ef1fa, "fillPatternRepeat", "repeat");
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($3bfe60cc136fb197$export$6428a7f2611ef1fa, "fillEnabled", true);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($3bfe60cc136fb197$export$6428a7f2611ef1fa, "strokeEnabled", true);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($3bfe60cc136fb197$export$6428a7f2611ef1fa, "shadowEnabled", true);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($3bfe60cc136fb197$export$6428a7f2611ef1fa, "dashEnabled", true);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($3bfe60cc136fb197$export$6428a7f2611ef1fa, "strokeScaleEnabled", true);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($3bfe60cc136fb197$export$6428a7f2611ef1fa, "fillPriority", "color");
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addComponentsGetterSetter($3bfe60cc136fb197$export$6428a7f2611ef1fa, "fillPatternOffset", [
    "x",
    "y"
]);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($3bfe60cc136fb197$export$6428a7f2611ef1fa, "fillPatternOffsetX", 0, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)());
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($3bfe60cc136fb197$export$6428a7f2611ef1fa, "fillPatternOffsetY", 0, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)());
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addComponentsGetterSetter($3bfe60cc136fb197$export$6428a7f2611ef1fa, "fillPatternScale", [
    "x",
    "y"
]);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($3bfe60cc136fb197$export$6428a7f2611ef1fa, "fillPatternScaleX", 1, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)());
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($3bfe60cc136fb197$export$6428a7f2611ef1fa, "fillPatternScaleY", 1, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)());
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addComponentsGetterSetter($3bfe60cc136fb197$export$6428a7f2611ef1fa, "fillLinearGradientStartPoint", [
    "x",
    "y"
]);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addComponentsGetterSetter($3bfe60cc136fb197$export$6428a7f2611ef1fa, "strokeLinearGradientStartPoint", [
    "x",
    "y"
]);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($3bfe60cc136fb197$export$6428a7f2611ef1fa, "fillLinearGradientStartPointX", 0);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($3bfe60cc136fb197$export$6428a7f2611ef1fa, "strokeLinearGradientStartPointX", 0);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($3bfe60cc136fb197$export$6428a7f2611ef1fa, "fillLinearGradientStartPointY", 0);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($3bfe60cc136fb197$export$6428a7f2611ef1fa, "strokeLinearGradientStartPointY", 0);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addComponentsGetterSetter($3bfe60cc136fb197$export$6428a7f2611ef1fa, "fillLinearGradientEndPoint", [
    "x",
    "y"
]);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addComponentsGetterSetter($3bfe60cc136fb197$export$6428a7f2611ef1fa, "strokeLinearGradientEndPoint", [
    "x",
    "y"
]);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($3bfe60cc136fb197$export$6428a7f2611ef1fa, "fillLinearGradientEndPointX", 0);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($3bfe60cc136fb197$export$6428a7f2611ef1fa, "strokeLinearGradientEndPointX", 0);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($3bfe60cc136fb197$export$6428a7f2611ef1fa, "fillLinearGradientEndPointY", 0);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($3bfe60cc136fb197$export$6428a7f2611ef1fa, "strokeLinearGradientEndPointY", 0);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addComponentsGetterSetter($3bfe60cc136fb197$export$6428a7f2611ef1fa, "fillRadialGradientStartPoint", [
    "x",
    "y"
]);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($3bfe60cc136fb197$export$6428a7f2611ef1fa, "fillRadialGradientStartPointX", 0);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($3bfe60cc136fb197$export$6428a7f2611ef1fa, "fillRadialGradientStartPointY", 0);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addComponentsGetterSetter($3bfe60cc136fb197$export$6428a7f2611ef1fa, "fillRadialGradientEndPoint", [
    "x",
    "y"
]);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($3bfe60cc136fb197$export$6428a7f2611ef1fa, "fillRadialGradientEndPointX", 0);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($3bfe60cc136fb197$export$6428a7f2611ef1fa, "fillRadialGradientEndPointY", 0);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($3bfe60cc136fb197$export$6428a7f2611ef1fa, "fillPatternRotation", 0);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).backCompat($3bfe60cc136fb197$export$6428a7f2611ef1fa, {
    dashArray: "dash",
    getDashArray: "getDash",
    setDashArray: "getDash",
    drawFunc: "sceneFunc",
    getDrawFunc: "getSceneFunc",
    setDrawFunc: "setSceneFunc",
    drawHitFunc: "hitFunc",
    getDrawHitFunc: "getHitFunc",
    setDrawHitFunc: "setHitFunc"
});



var $c5d1086649a430c0$var$HASH = "#", $c5d1086649a430c0$var$BEFORE_DRAW = "beforeDraw", $c5d1086649a430c0$var$DRAW = "draw", $c5d1086649a430c0$var$INTERSECTION_OFFSETS = [
    {
        x: 0,
        y: 0
    },
    {
        x: -1,
        y: -1
    },
    {
        x: 1,
        y: -1
    },
    {
        x: 1,
        y: 1
    },
    {
        x: -1,
        y: 1
    }
], $c5d1086649a430c0$var$INTERSECTION_OFFSETS_LEN = $c5d1086649a430c0$var$INTERSECTION_OFFSETS.length;
class $c5d1086649a430c0$export$936d0764594b6eb3 extends (0, $f298365ca3013a23$export$42a852a2b6b56249) {
    constructor(config){
        super(config);
        this.canvas = new (0, $6ecdd92180d794bd$export$ee612225bd2e63be)();
        this.hitCanvas = new (0, $6ecdd92180d794bd$export$43a2e1456e27dc84)({
            pixelRatio: 1
        });
        this._waitingForDraw = false;
        this.on("visibleChange.konva", this._checkVisibility);
        this._checkVisibility();
        this.on("imageSmoothingEnabledChange.konva", this._setSmoothEnabled);
        this._setSmoothEnabled();
    }
    createPNGStream() {
        const c = this.canvas._canvas;
        return c.createPNGStream();
    }
    getCanvas() {
        return this.canvas;
    }
    getNativeCanvasElement() {
        return this.canvas._canvas;
    }
    getHitCanvas() {
        return this.hitCanvas;
    }
    getContext() {
        return this.getCanvas().getContext();
    }
    clear(bounds) {
        this.getContext().clear(bounds);
        this.getHitCanvas().getContext().clear(bounds);
        return this;
    }
    setZIndex(index) {
        super.setZIndex(index);
        var stage = this.getStage();
        if (stage && stage.content) {
            stage.content.removeChild(this.getNativeCanvasElement());
            if (index < stage.children.length - 1) stage.content.insertBefore(this.getNativeCanvasElement(), stage.children[index + 1].getCanvas()._canvas);
            else stage.content.appendChild(this.getNativeCanvasElement());
        }
        return this;
    }
    moveToTop() {
        (0, $97cb7af42217e259$export$85c928794f8d04d4).prototype.moveToTop.call(this);
        var stage = this.getStage();
        if (stage && stage.content) {
            stage.content.removeChild(this.getNativeCanvasElement());
            stage.content.appendChild(this.getNativeCanvasElement());
        }
        return true;
    }
    moveUp() {
        var moved = (0, $97cb7af42217e259$export$85c928794f8d04d4).prototype.moveUp.call(this);
        if (!moved) return false;
        var stage = this.getStage();
        if (!stage || !stage.content) return false;
        stage.content.removeChild(this.getNativeCanvasElement());
        if (this.index < stage.children.length - 1) stage.content.insertBefore(this.getNativeCanvasElement(), stage.children[this.index + 1].getCanvas()._canvas);
        else stage.content.appendChild(this.getNativeCanvasElement());
        return true;
    }
    moveDown() {
        if ((0, $97cb7af42217e259$export$85c928794f8d04d4).prototype.moveDown.call(this)) {
            var stage = this.getStage();
            if (stage) {
                var children = stage.children;
                if (stage.content) {
                    stage.content.removeChild(this.getNativeCanvasElement());
                    stage.content.insertBefore(this.getNativeCanvasElement(), children[this.index + 1].getCanvas()._canvas);
                }
            }
            return true;
        }
        return false;
    }
    moveToBottom() {
        if ((0, $97cb7af42217e259$export$85c928794f8d04d4).prototype.moveToBottom.call(this)) {
            var stage = this.getStage();
            if (stage) {
                var children = stage.children;
                if (stage.content) {
                    stage.content.removeChild(this.getNativeCanvasElement());
                    stage.content.insertBefore(this.getNativeCanvasElement(), children[1].getCanvas()._canvas);
                }
            }
            return true;
        }
        return false;
    }
    getLayer() {
        return this;
    }
    remove() {
        var _canvas = this.getNativeCanvasElement();
        (0, $97cb7af42217e259$export$85c928794f8d04d4).prototype.remove.call(this);
        if (_canvas && _canvas.parentNode && (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd)._isInDocument(_canvas)) _canvas.parentNode.removeChild(_canvas);
        return this;
    }
    getStage() {
        return this.parent;
    }
    setSize({ width: width, height: height }) {
        this.canvas.setSize(width, height);
        this.hitCanvas.setSize(width, height);
        this._setSmoothEnabled();
        return this;
    }
    _validateAdd(child) {
        var type = child.getType();
        if (type !== "Group" && type !== "Shape") (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).throw("You may only add groups and shapes to a layer.");
    }
    _toKonvaCanvas(config) {
        config = config || {};
        config.width = config.width || this.getWidth();
        config.height = config.height || this.getHeight();
        config.x = config.x !== undefined ? config.x : this.x();
        config.y = config.y !== undefined ? config.y : this.y();
        return (0, $97cb7af42217e259$export$85c928794f8d04d4).prototype._toKonvaCanvas.call(this, config);
    }
    _checkVisibility() {
        const visible = this.visible();
        if (visible) this.canvas._canvas.style.display = "block";
        else this.canvas._canvas.style.display = "none";
    }
    _setSmoothEnabled() {
        this.getContext()._context.imageSmoothingEnabled = this.imageSmoothingEnabled();
    }
    getWidth() {
        if (this.parent) return this.parent.width();
    }
    setWidth() {
        (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).warn('Can not change width of layer. Use "stage.width(value)" function instead.');
    }
    getHeight() {
        if (this.parent) return this.parent.height();
    }
    setHeight() {
        (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).warn('Can not change height of layer. Use "stage.height(value)" function instead.');
    }
    batchDraw() {
        if (!this._waitingForDraw) {
            this._waitingForDraw = true;
            (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).requestAnimFrame(()=>{
                this.draw();
                this._waitingForDraw = false;
            });
        }
        return this;
    }
    getIntersection(pos) {
        if (!this.isListening() || !this.isVisible()) return null;
        var spiralSearchDistance = 1;
        var continueSearch = false;
        while(true){
            for(let i = 0; i < $c5d1086649a430c0$var$INTERSECTION_OFFSETS_LEN; i++){
                const intersectionOffset = $c5d1086649a430c0$var$INTERSECTION_OFFSETS[i];
                const obj = this._getIntersection({
                    x: pos.x + intersectionOffset.x * spiralSearchDistance,
                    y: pos.y + intersectionOffset.y * spiralSearchDistance
                });
                const shape = obj.shape;
                if (shape) return shape;
                continueSearch = !!obj.antialiased;
                if (!obj.antialiased) break;
            }
            if (continueSearch) spiralSearchDistance += 1;
            else return null;
        }
    }
    _getIntersection(pos) {
        const ratio = this.hitCanvas.pixelRatio;
        const p = this.hitCanvas.context.getImageData(Math.round(pos.x * ratio), Math.round(pos.y * ratio), 1, 1).data;
        const p3 = p[3];
        if (p3 === 255) {
            const colorKey = (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd)._rgbToHex(p[0], p[1], p[2]);
            const shape = (0, $3bfe60cc136fb197$export$4ff7fc6f1af248b5)[$c5d1086649a430c0$var$HASH + colorKey];
            if (shape) return {
                shape: shape
            };
            return {
                antialiased: true
            };
        } else if (p3 > 0) return {
            antialiased: true
        };
        return {};
    }
    drawScene(can, top) {
        var layer = this.getLayer(), canvas = can || layer && layer.getCanvas();
        this._fire($c5d1086649a430c0$var$BEFORE_DRAW, {
            node: this
        });
        if (this.clearBeforeDraw()) canvas.getContext().clear();
        (0, $f298365ca3013a23$export$42a852a2b6b56249).prototype.drawScene.call(this, canvas, top);
        this._fire($c5d1086649a430c0$var$DRAW, {
            node: this
        });
        return this;
    }
    drawHit(can, top) {
        var layer = this.getLayer(), canvas = can || layer && layer.hitCanvas;
        if (layer && layer.clearBeforeDraw()) layer.getHitCanvas().getContext().clear();
        (0, $f298365ca3013a23$export$42a852a2b6b56249).prototype.drawHit.call(this, canvas, top);
        return this;
    }
    enableHitGraph() {
        this.hitGraphEnabled(true);
        return this;
    }
    disableHitGraph() {
        this.hitGraphEnabled(false);
        return this;
    }
    setHitGraphEnabled(val) {
        (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).warn("hitGraphEnabled method is deprecated. Please use layer.listening() instead.");
        this.listening(val);
    }
    getHitGraphEnabled(val) {
        (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).warn("hitGraphEnabled method is deprecated. Please use layer.listening() instead.");
        return this.listening();
    }
    toggleHitCanvas() {
        if (!this.parent || !this.parent["content"]) return;
        var parent = this.parent;
        var added = !!this.hitCanvas._canvas.parentNode;
        if (added) parent.content.removeChild(this.hitCanvas._canvas);
        else parent.content.appendChild(this.hitCanvas._canvas);
    }
    destroy() {
        (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).releaseCanvas(this.getNativeCanvasElement(), this.getHitCanvas()._canvas);
        return super.destroy();
    }
}
$c5d1086649a430c0$export$936d0764594b6eb3.prototype.nodeType = "Layer";
(0, $f1cce3c2a91bf0cf$export$f7a70d87a5e829eb)($c5d1086649a430c0$export$936d0764594b6eb3);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($c5d1086649a430c0$export$936d0764594b6eb3, "imageSmoothingEnabled", true);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($c5d1086649a430c0$export$936d0764594b6eb3, "clearBeforeDraw", true);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($c5d1086649a430c0$export$936d0764594b6eb3, "hitGraphEnabled", true, (0, $8d9e6be936d29d8a$export$147fc8b6cd20fda1)());





class $d5da4ff9bb1b1662$export$92d64f29192d1118 extends (0, $c5d1086649a430c0$export$936d0764594b6eb3) {
    constructor(attrs){
        super(attrs);
        this.listening(false);
        (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).warn('Konva.Fast layer is deprecated. Please use "new Konva.Layer({ listening: false })" instead.');
    }
}
$d5da4ff9bb1b1662$export$92d64f29192d1118.prototype.nodeType = "FastLayer";
(0, $f1cce3c2a91bf0cf$export$f7a70d87a5e829eb)($d5da4ff9bb1b1662$export$92d64f29192d1118);





class $5147287ae7dd04c0$export$eb2fcfdbd7ba97d4 extends (0, $f298365ca3013a23$export$42a852a2b6b56249) {
    _validateAdd(child) {
        var type = child.getType();
        if (type !== "Group" && type !== "Shape") (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).throw("You may only add groups and shapes to groups.");
    }
}
$5147287ae7dd04c0$export$eb2fcfdbd7ba97d4.prototype.nodeType = "Group";
(0, $f1cce3c2a91bf0cf$export$f7a70d87a5e829eb)($5147287ae7dd04c0$export$eb2fcfdbd7ba97d4);






var $24351191da7e43e2$var$now = function() {
    if ((0, $f1cce3c2a91bf0cf$export$442f1a04865e4790).performance && (0, $f1cce3c2a91bf0cf$export$442f1a04865e4790).performance.now) return function() {
        return (0, $f1cce3c2a91bf0cf$export$442f1a04865e4790).performance.now();
    };
    return function() {
        return new Date().getTime();
    };
}();
class $24351191da7e43e2$export$c35d437ae5945fcd {
    constructor(func, layers){
        this.id = $24351191da7e43e2$export$c35d437ae5945fcd.animIdCounter++;
        this.frame = {
            time: 0,
            timeDiff: 0,
            lastTime: $24351191da7e43e2$var$now(),
            frameRate: 0
        };
        this.func = func;
        this.setLayers(layers);
    }
    setLayers(layers) {
        var lays = [];
        if (!layers) lays = [];
        else if (layers.length > 0) lays = layers;
        else lays = [
            layers
        ];
        this.layers = lays;
        return this;
    }
    getLayers() {
        return this.layers;
    }
    addLayer(layer) {
        var layers = this.layers, len = layers.length, n;
        for(n = 0; n < len; n++){
            if (layers[n]._id === layer._id) return false;
        }
        this.layers.push(layer);
        return true;
    }
    isRunning() {
        var a = $24351191da7e43e2$export$c35d437ae5945fcd, animations = a.animations, len = animations.length, n;
        for(n = 0; n < len; n++){
            if (animations[n].id === this.id) return true;
        }
        return false;
    }
    start() {
        this.stop();
        this.frame.timeDiff = 0;
        this.frame.lastTime = $24351191da7e43e2$var$now();
        $24351191da7e43e2$export$c35d437ae5945fcd._addAnimation(this);
        return this;
    }
    stop() {
        $24351191da7e43e2$export$c35d437ae5945fcd._removeAnimation(this);
        return this;
    }
    _updateFrameObject(time) {
        this.frame.timeDiff = time - this.frame.lastTime;
        this.frame.lastTime = time;
        this.frame.time += this.frame.timeDiff;
        this.frame.frameRate = 1000 / this.frame.timeDiff;
    }
    static _addAnimation(anim) {
        this.animations.push(anim);
        this._handleAnimation();
    }
    static _removeAnimation(anim) {
        var id = anim.id, animations = this.animations, len = animations.length, n;
        for(n = 0; n < len; n++)if (animations[n].id === id) {
            this.animations.splice(n, 1);
            break;
        }
    }
    static _runFrames() {
        var layerHash = {}, animations = this.animations, anim, layers, func, n, i, layersLen, layer, key, needRedraw;
        for(n = 0; n < animations.length; n++){
            anim = animations[n];
            layers = anim.layers;
            func = anim.func;
            anim._updateFrameObject($24351191da7e43e2$var$now());
            layersLen = layers.length;
            if (func) needRedraw = func.call(anim, anim.frame) !== false;
            else needRedraw = true;
            if (!needRedraw) continue;
            for(i = 0; i < layersLen; i++){
                layer = layers[i];
                if (layer._id !== undefined) layerHash[layer._id] = layer;
            }
        }
        for(key in layerHash){
            if (!layerHash.hasOwnProperty(key)) continue;
            layerHash[key].batchDraw();
        }
    }
    static _animationLoop() {
        var Anim = $24351191da7e43e2$export$c35d437ae5945fcd;
        if (Anim.animations.length) {
            Anim._runFrames();
            (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).requestAnimFrame(Anim._animationLoop);
        } else Anim.animRunning = false;
    }
    static _handleAnimation() {
        if (!this.animRunning) {
            this.animRunning = true;
            (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).requestAnimFrame(this._animationLoop);
        }
    }
}
$24351191da7e43e2$export$c35d437ae5945fcd.animations = [];
$24351191da7e43e2$export$c35d437ae5945fcd.animIdCounter = 0;
$24351191da7e43e2$export$c35d437ae5945fcd.animRunning = false;






var $483a044147f14968$var$blacklist = {
    node: 1,
    duration: 1,
    easing: 1,
    onFinish: 1,
    yoyo: 1
}, $483a044147f14968$var$PAUSED = 1, $483a044147f14968$var$PLAYING = 2, $483a044147f14968$var$REVERSING = 3, $483a044147f14968$var$idCounter = 0, $483a044147f14968$var$colorAttrs = [
    "fill",
    "stroke",
    "shadowColor"
];
class $483a044147f14968$var$TweenEngine {
    constructor(prop, propFunc, func, begin, finish, duration, yoyo){
        this.prop = prop;
        this.propFunc = propFunc;
        this.begin = begin;
        this._pos = begin;
        this.duration = duration;
        this._change = 0;
        this.prevPos = 0;
        this.yoyo = yoyo;
        this._time = 0;
        this._position = 0;
        this._startTime = 0;
        this._finish = 0;
        this.func = func;
        this._change = finish - this.begin;
        this.pause();
    }
    fire(str) {
        var handler = this[str];
        if (handler) handler();
    }
    setTime(t) {
        if (t > this.duration) {
            if (this.yoyo) {
                this._time = this.duration;
                this.reverse();
            } else this.finish();
        } else if (t < 0) {
            if (this.yoyo) {
                this._time = 0;
                this.play();
            } else this.reset();
        } else {
            this._time = t;
            this.update();
        }
    }
    getTime() {
        return this._time;
    }
    setPosition(p) {
        this.prevPos = this._pos;
        this.propFunc(p);
        this._pos = p;
    }
    getPosition(t) {
        if (t === undefined) t = this._time;
        return this.func(t, this.begin, this._change, this.duration);
    }
    play() {
        this.state = $483a044147f14968$var$PLAYING;
        this._startTime = this.getTimer() - this._time;
        this.onEnterFrame();
        this.fire("onPlay");
    }
    reverse() {
        this.state = $483a044147f14968$var$REVERSING;
        this._time = this.duration - this._time;
        this._startTime = this.getTimer() - this._time;
        this.onEnterFrame();
        this.fire("onReverse");
    }
    seek(t) {
        this.pause();
        this._time = t;
        this.update();
        this.fire("onSeek");
    }
    reset() {
        this.pause();
        this._time = 0;
        this.update();
        this.fire("onReset");
    }
    finish() {
        this.pause();
        this._time = this.duration;
        this.update();
        this.fire("onFinish");
    }
    update() {
        this.setPosition(this.getPosition(this._time));
        this.fire("onUpdate");
    }
    onEnterFrame() {
        var t = this.getTimer() - this._startTime;
        if (this.state === $483a044147f14968$var$PLAYING) this.setTime(t);
        else if (this.state === $483a044147f14968$var$REVERSING) this.setTime(this.duration - t);
    }
    pause() {
        this.state = $483a044147f14968$var$PAUSED;
        this.fire("onPause");
    }
    getTimer() {
        return new Date().getTime();
    }
}
class $483a044147f14968$export$208a41d6b4e37b97 {
    constructor(config){
        var that = this, node = config.node, nodeId = node._id, duration, easing = config.easing || $483a044147f14968$export$ade85cc9682adcc5.Linear, yoyo = !!config.yoyo, key;
        if (typeof config.duration === "undefined") duration = 0.3;
        else if (config.duration === 0) duration = 0.001;
        else duration = config.duration;
        this.node = node;
        this._id = $483a044147f14968$var$idCounter++;
        var layers = node.getLayer() || (node instanceof (0, $f1cce3c2a91bf0cf$export$b9f99057a3c7692)["Stage"] ? node.getLayers() : null);
        if (!layers) (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).error("Tween constructor have `node` that is not in a layer. Please add node into layer first.");
        this.anim = new (0, $24351191da7e43e2$export$c35d437ae5945fcd)(function() {
            that.tween.onEnterFrame();
        }, layers);
        this.tween = new $483a044147f14968$var$TweenEngine(key, function(i) {
            that._tweenFunc(i);
        }, easing, 0, 1, duration * 1000, yoyo);
        this._addListeners();
        if (!$483a044147f14968$export$208a41d6b4e37b97.attrs[nodeId]) $483a044147f14968$export$208a41d6b4e37b97.attrs[nodeId] = {};
        if (!$483a044147f14968$export$208a41d6b4e37b97.attrs[nodeId][this._id]) $483a044147f14968$export$208a41d6b4e37b97.attrs[nodeId][this._id] = {};
        if (!$483a044147f14968$export$208a41d6b4e37b97.tweens[nodeId]) $483a044147f14968$export$208a41d6b4e37b97.tweens[nodeId] = {};
        for(key in config)if ($483a044147f14968$var$blacklist[key] === undefined) this._addAttr(key, config[key]);
        this.reset();
        this.onFinish = config.onFinish;
        this.onReset = config.onReset;
        this.onUpdate = config.onUpdate;
    }
    _addAttr(key, end) {
        var node = this.node, nodeId = node._id, start, diff, tweenId, n, len, trueEnd, trueStart, endRGBA;
        tweenId = $483a044147f14968$export$208a41d6b4e37b97.tweens[nodeId][key];
        if (tweenId) delete $483a044147f14968$export$208a41d6b4e37b97.attrs[nodeId][tweenId][key];
        start = node.getAttr(key);
        if ((0, $4d54b3632f7367db$export$f8f26dd395d7e1bd)._isArray(end)) {
            diff = [];
            len = Math.max(end.length, start.length);
            if (key === "points" && end.length !== start.length) {
                if (end.length > start.length) {
                    trueStart = start;
                    start = (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd)._prepareArrayForTween(start, end, node.closed());
                } else {
                    trueEnd = end;
                    end = (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd)._prepareArrayForTween(end, start, node.closed());
                }
            }
            if (key.indexOf("fill") === 0) {
                for(n = 0; n < len; n++)if (n % 2 === 0) diff.push(end[n] - start[n]);
                else {
                    var startRGBA = (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).colorToRGBA(start[n]);
                    endRGBA = (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).colorToRGBA(end[n]);
                    start[n] = startRGBA;
                    diff.push({
                        r: endRGBA.r - startRGBA.r,
                        g: endRGBA.g - startRGBA.g,
                        b: endRGBA.b - startRGBA.b,
                        a: endRGBA.a - startRGBA.a
                    });
                }
            } else for(n = 0; n < len; n++)diff.push(end[n] - start[n]);
        } else if ($483a044147f14968$var$colorAttrs.indexOf(key) !== -1) {
            start = (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).colorToRGBA(start);
            endRGBA = (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).colorToRGBA(end);
            diff = {
                r: endRGBA.r - start.r,
                g: endRGBA.g - start.g,
                b: endRGBA.b - start.b,
                a: endRGBA.a - start.a
            };
        } else diff = end - start;
        $483a044147f14968$export$208a41d6b4e37b97.attrs[nodeId][this._id][key] = {
            start: start,
            diff: diff,
            end: end,
            trueEnd: trueEnd,
            trueStart: trueStart
        };
        $483a044147f14968$export$208a41d6b4e37b97.tweens[nodeId][key] = this._id;
    }
    _tweenFunc(i) {
        var node = this.node, attrs = $483a044147f14968$export$208a41d6b4e37b97.attrs[node._id][this._id], key, attr, start, diff, newVal, n, len, end;
        for(key in attrs){
            attr = attrs[key];
            start = attr.start;
            diff = attr.diff;
            end = attr.end;
            if ((0, $4d54b3632f7367db$export$f8f26dd395d7e1bd)._isArray(start)) {
                newVal = [];
                len = Math.max(start.length, end.length);
                if (key.indexOf("fill") === 0) {
                    for(n = 0; n < len; n++)if (n % 2 === 0) newVal.push((start[n] || 0) + diff[n] * i);
                    else newVal.push("rgba(" + Math.round(start[n].r + diff[n].r * i) + "," + Math.round(start[n].g + diff[n].g * i) + "," + Math.round(start[n].b + diff[n].b * i) + "," + (start[n].a + diff[n].a * i) + ")");
                } else for(n = 0; n < len; n++)newVal.push((start[n] || 0) + diff[n] * i);
            } else if ($483a044147f14968$var$colorAttrs.indexOf(key) !== -1) newVal = "rgba(" + Math.round(start.r + diff.r * i) + "," + Math.round(start.g + diff.g * i) + "," + Math.round(start.b + diff.b * i) + "," + (start.a + diff.a * i) + ")";
            else newVal = start + diff * i;
            node.setAttr(key, newVal);
        }
    }
    _addListeners() {
        this.tween.onPlay = ()=>{
            this.anim.start();
        };
        this.tween.onReverse = ()=>{
            this.anim.start();
        };
        this.tween.onPause = ()=>{
            this.anim.stop();
        };
        this.tween.onFinish = ()=>{
            var node = this.node;
            var attrs = $483a044147f14968$export$208a41d6b4e37b97.attrs[node._id][this._id];
            if (attrs.points && attrs.points.trueEnd) node.setAttr("points", attrs.points.trueEnd);
            if (this.onFinish) this.onFinish.call(this);
        };
        this.tween.onReset = ()=>{
            var node = this.node;
            var attrs = $483a044147f14968$export$208a41d6b4e37b97.attrs[node._id][this._id];
            if (attrs.points && attrs.points.trueStart) node.points(attrs.points.trueStart);
            if (this.onReset) this.onReset();
        };
        this.tween.onUpdate = ()=>{
            if (this.onUpdate) this.onUpdate.call(this);
        };
    }
    play() {
        this.tween.play();
        return this;
    }
    reverse() {
        this.tween.reverse();
        return this;
    }
    reset() {
        this.tween.reset();
        return this;
    }
    seek(t) {
        this.tween.seek(t * 1000);
        return this;
    }
    pause() {
        this.tween.pause();
        return this;
    }
    finish() {
        this.tween.finish();
        return this;
    }
    destroy() {
        var nodeId = this.node._id, thisId = this._id, attrs = $483a044147f14968$export$208a41d6b4e37b97.tweens[nodeId], key;
        this.pause();
        for(key in attrs)delete $483a044147f14968$export$208a41d6b4e37b97.tweens[nodeId][key];
        delete $483a044147f14968$export$208a41d6b4e37b97.attrs[nodeId][thisId];
    }
}
$483a044147f14968$export$208a41d6b4e37b97.attrs = {};
$483a044147f14968$export$208a41d6b4e37b97.tweens = {};
(0, $97cb7af42217e259$export$85c928794f8d04d4).prototype.to = function(params) {
    var onFinish = params.onFinish;
    params.node = this;
    params.onFinish = function() {
        this.destroy();
        if (onFinish) onFinish();
    };
    var tween = new $483a044147f14968$export$208a41d6b4e37b97(params);
    tween.play();
};
const $483a044147f14968$export$ade85cc9682adcc5 = {
    BackEaseIn (t, b, c, d) {
        var s = 1.70158;
        return c * (t /= d) * t * ((s + 1) * t - s) + b;
    },
    BackEaseOut (t, b, c, d) {
        var s = 1.70158;
        return c * ((t = t / d - 1) * t * ((s + 1) * t + s) + 1) + b;
    },
    BackEaseInOut (t, b, c, d) {
        var s = 1.70158;
        if ((t /= d / 2) < 1) return c / 2 * (t * t * (((s *= 1.525) + 1) * t - s)) + b;
        return c / 2 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2) + b;
    },
    ElasticEaseIn (t, b, c, d, a, p) {
        var s = 0;
        if (t === 0) return b;
        if ((t /= d) === 1) return b + c;
        if (!p) p = d * 0.3;
        if (!a || a < Math.abs(c)) {
            a = c;
            s = p / 4;
        } else s = p / (2 * Math.PI) * Math.asin(c / a);
        return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p)) + b;
    },
    ElasticEaseOut (t, b, c, d, a, p) {
        var s = 0;
        if (t === 0) return b;
        if ((t /= d) === 1) return b + c;
        if (!p) p = d * 0.3;
        if (!a || a < Math.abs(c)) {
            a = c;
            s = p / 4;
        } else s = p / (2 * Math.PI) * Math.asin(c / a);
        return a * Math.pow(2, -10 * t) * Math.sin((t * d - s) * (2 * Math.PI) / p) + c + b;
    },
    ElasticEaseInOut (t, b, c, d, a, p) {
        var s = 0;
        if (t === 0) return b;
        if ((t /= d / 2) === 2) return b + c;
        if (!p) p = d * (0.3 * 1.5);
        if (!a || a < Math.abs(c)) {
            a = c;
            s = p / 4;
        } else s = p / (2 * Math.PI) * Math.asin(c / a);
        if (t < 1) return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p)) + b;
        return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p) * 0.5 + c + b;
    },
    BounceEaseOut (t, b, c, d) {
        if ((t /= d) < 1 / 2.75) return c * (7.5625 * t * t) + b;
        else if (t < 2 / 2.75) return c * (7.5625 * (t -= 1.5 / 2.75) * t + 0.75) + b;
        else if (t < 2.5 / 2.75) return c * (7.5625 * (t -= 2.25 / 2.75) * t + 0.9375) + b;
        else return c * (7.5625 * (t -= 2.625 / 2.75) * t + 0.984375) + b;
    },
    BounceEaseIn (t, b, c, d) {
        return c - $483a044147f14968$export$ade85cc9682adcc5.BounceEaseOut(d - t, 0, c, d) + b;
    },
    BounceEaseInOut (t, b, c, d) {
        if (t < d / 2) return $483a044147f14968$export$ade85cc9682adcc5.BounceEaseIn(t * 2, 0, c, d) * 0.5 + b;
        else return $483a044147f14968$export$ade85cc9682adcc5.BounceEaseOut(t * 2 - d, 0, c, d) * 0.5 + c * 0.5 + b;
    },
    EaseIn (t, b, c, d) {
        return c * (t /= d) * t + b;
    },
    EaseOut (t, b, c, d) {
        return -c * (t /= d) * (t - 2) + b;
    },
    EaseInOut (t, b, c, d) {
        if ((t /= d / 2) < 1) return c / 2 * t * t + b;
        return -c / 2 * (--t * (t - 2) - 1) + b;
    },
    StrongEaseIn (t, b, c, d) {
        return c * (t /= d) * t * t * t * t + b;
    },
    StrongEaseOut (t, b, c, d) {
        return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
    },
    StrongEaseInOut (t, b, c, d) {
        if ((t /= d / 2) < 1) return c / 2 * t * t * t * t * t + b;
        return c / 2 * ((t -= 2) * t * t * t * t + 2) + b;
    },
    Linear (t, b, c, d) {
        return c * t / d + b;
    }
};




const $8d1588919b81b1e4$export$b9f99057a3c7692 = (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd)._assign((0, $f1cce3c2a91bf0cf$export$b9f99057a3c7692), {
    Util: $4d54b3632f7367db$export$f8f26dd395d7e1bd,
    Transform: $4d54b3632f7367db$export$563a914cafbdc389,
    Node: $97cb7af42217e259$export$85c928794f8d04d4,
    Container: $f298365ca3013a23$export$42a852a2b6b56249,
    Stage: $6d48d6d6f577c60e$export$208cd1682bd0e4b6,
    stages: $6d48d6d6f577c60e$export$1bfcff8d7c4bf05,
    Layer: $c5d1086649a430c0$export$936d0764594b6eb3,
    FastLayer: $d5da4ff9bb1b1662$export$92d64f29192d1118,
    Group: $5147287ae7dd04c0$export$eb2fcfdbd7ba97d4,
    DD: $8410d2afdfe04713$export$e34f1b340034d7f,
    Shape: $3bfe60cc136fb197$export$6428a7f2611ef1fa,
    shapes: $3bfe60cc136fb197$export$4ff7fc6f1af248b5,
    Animation: $24351191da7e43e2$export$c35d437ae5945fcd,
    Tween: $483a044147f14968$export$208a41d6b4e37b97,
    Easings: $483a044147f14968$export$ade85cc9682adcc5,
    Context: $bed71fa021a52d88$export$841858b892ce1f4c,
    Canvas: $6ecdd92180d794bd$export$8d01c972ee8b14a9
});
var $8d1588919b81b1e4$export$2e2bcd8739ae039 = $8d1588919b81b1e4$export$b9f99057a3c7692;






class $d45099c50280ff31$export$6ef80ffb606dd232 extends (0, $3bfe60cc136fb197$export$6428a7f2611ef1fa) {
    _sceneFunc(context) {
        var angle = (0, $f1cce3c2a91bf0cf$export$b9f99057a3c7692).getAngle(this.angle()), clockwise = this.clockwise();
        context.beginPath();
        context.arc(0, 0, this.outerRadius(), 0, angle, clockwise);
        context.arc(0, 0, this.innerRadius(), angle, 0, !clockwise);
        context.closePath();
        context.fillStrokeShape(this);
    }
    getWidth() {
        return this.outerRadius() * 2;
    }
    getHeight() {
        return this.outerRadius() * 2;
    }
    setWidth(width) {
        this.outerRadius(width / 2);
    }
    setHeight(height) {
        this.outerRadius(height / 2);
    }
    getSelfRect() {
        const innerRadius = this.innerRadius();
        const outerRadius = this.outerRadius();
        const clockwise = this.clockwise();
        const angle = (0, $f1cce3c2a91bf0cf$export$b9f99057a3c7692).getAngle(clockwise ? 360 - this.angle() : this.angle());
        const boundLeftRatio = Math.cos(Math.min(angle, Math.PI));
        const boundRightRatio = 1;
        const boundTopRatio = Math.sin(Math.min(Math.max(Math.PI, angle), 3 * Math.PI / 2));
        const boundBottomRatio = Math.sin(Math.min(angle, Math.PI / 2));
        const boundLeft = boundLeftRatio * (boundLeftRatio > 0 ? innerRadius : outerRadius);
        const boundRight = boundRightRatio * (boundRightRatio > 0 ? outerRadius : innerRadius);
        const boundTop = boundTopRatio * (boundTopRatio > 0 ? innerRadius : outerRadius);
        const boundBottom = boundBottomRatio * (boundBottomRatio > 0 ? outerRadius : innerRadius);
        return {
            x: boundLeft,
            y: clockwise ? -1 * boundBottom : boundTop,
            width: boundRight - boundLeft,
            height: boundBottom - boundTop
        };
    }
}
$d45099c50280ff31$export$6ef80ffb606dd232.prototype._centroid = true;
$d45099c50280ff31$export$6ef80ffb606dd232.prototype.className = "Arc";
$d45099c50280ff31$export$6ef80ffb606dd232.prototype._attrsAffectingSize = [
    "innerRadius",
    "outerRadius"
];
(0, $f1cce3c2a91bf0cf$export$f7a70d87a5e829eb)($d45099c50280ff31$export$6ef80ffb606dd232);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($d45099c50280ff31$export$6ef80ffb606dd232, "innerRadius", 0, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)());
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($d45099c50280ff31$export$6ef80ffb606dd232, "outerRadius", 0, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)());
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($d45099c50280ff31$export$6ef80ffb606dd232, "angle", 0, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)());
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($d45099c50280ff31$export$6ef80ffb606dd232, "clockwise", false, (0, $8d9e6be936d29d8a$export$147fc8b6cd20fda1)());







function $2a894264b44ee8c9$var$getControlPoints(x0, y0, x1, y1, x2, y2, t) {
    var d01 = Math.sqrt(Math.pow(x1 - x0, 2) + Math.pow(y1 - y0, 2)), d12 = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2)), fa = t * d01 / (d01 + d12), fb = t * d12 / (d01 + d12), p1x = x1 - fa * (x2 - x0), p1y = y1 - fa * (y2 - y0), p2x = x1 + fb * (x2 - x0), p2y = y1 + fb * (y2 - y0);
    return [
        p1x,
        p1y,
        p2x,
        p2y
    ];
}
function $2a894264b44ee8c9$var$expandPoints(p, tension) {
    var len = p.length, allPoints = [], n, cp;
    for(n = 2; n < len - 2; n += 2){
        cp = $2a894264b44ee8c9$var$getControlPoints(p[n - 2], p[n - 1], p[n], p[n + 1], p[n + 2], p[n + 3], tension);
        if (isNaN(cp[0])) continue;
        allPoints.push(cp[0]);
        allPoints.push(cp[1]);
        allPoints.push(p[n]);
        allPoints.push(p[n + 1]);
        allPoints.push(cp[2]);
        allPoints.push(cp[3]);
    }
    return allPoints;
}
class $2a894264b44ee8c9$export$17d680238e50603e extends (0, $3bfe60cc136fb197$export$6428a7f2611ef1fa) {
    constructor(config){
        super(config);
        this.on("pointsChange.konva tensionChange.konva closedChange.konva bezierChange.konva", function() {
            this._clearCache("tensionPoints");
        });
    }
    _sceneFunc(context) {
        var points = this.points(), length = points.length, tension = this.tension(), closed = this.closed(), bezier = this.bezier(), tp, len, n;
        if (!length) return;
        context.beginPath();
        context.moveTo(points[0], points[1]);
        if (tension !== 0 && length > 4) {
            tp = this.getTensionPoints();
            len = tp.length;
            n = closed ? 0 : 4;
            if (!closed) context.quadraticCurveTo(tp[0], tp[1], tp[2], tp[3]);
            while(n < len - 2)context.bezierCurveTo(tp[n++], tp[n++], tp[n++], tp[n++], tp[n++], tp[n++]);
            if (!closed) context.quadraticCurveTo(tp[len - 2], tp[len - 1], points[length - 2], points[length - 1]);
        } else if (bezier) {
            n = 2;
            while(n < length)context.bezierCurveTo(points[n++], points[n++], points[n++], points[n++], points[n++], points[n++]);
        } else for(n = 2; n < length; n += 2)context.lineTo(points[n], points[n + 1]);
        if (closed) {
            context.closePath();
            context.fillStrokeShape(this);
        } else context.strokeShape(this);
    }
    getTensionPoints() {
        return this._getCache("tensionPoints", this._getTensionPoints);
    }
    _getTensionPoints() {
        if (this.closed()) return this._getTensionPointsClosed();
        else return $2a894264b44ee8c9$var$expandPoints(this.points(), this.tension());
    }
    _getTensionPointsClosed() {
        var p = this.points(), len = p.length, tension = this.tension(), firstControlPoints = $2a894264b44ee8c9$var$getControlPoints(p[len - 2], p[len - 1], p[0], p[1], p[2], p[3], tension), lastControlPoints = $2a894264b44ee8c9$var$getControlPoints(p[len - 4], p[len - 3], p[len - 2], p[len - 1], p[0], p[1], tension), middle = $2a894264b44ee8c9$var$expandPoints(p, tension), tp = [
            firstControlPoints[2],
            firstControlPoints[3]
        ].concat(middle).concat([
            lastControlPoints[0],
            lastControlPoints[1],
            p[len - 2],
            p[len - 1],
            lastControlPoints[2],
            lastControlPoints[3],
            firstControlPoints[0],
            firstControlPoints[1],
            p[0],
            p[1]
        ]);
        return tp;
    }
    getWidth() {
        return this.getSelfRect().width;
    }
    getHeight() {
        return this.getSelfRect().height;
    }
    getSelfRect() {
        var points = this.points();
        if (points.length < 4) return {
            x: points[0] || 0,
            y: points[1] || 0,
            width: 0,
            height: 0
        };
        if (this.tension() !== 0) points = [
            points[0],
            points[1],
            ...this._getTensionPoints(),
            points[points.length - 2],
            points[points.length - 1]
        ];
        else points = this.points();
        var minX = points[0];
        var maxX = points[0];
        var minY = points[1];
        var maxY = points[1];
        var x, y;
        for(var i = 0; i < points.length / 2; i++){
            x = points[i * 2];
            y = points[i * 2 + 1];
            minX = Math.min(minX, x);
            maxX = Math.max(maxX, x);
            minY = Math.min(minY, y);
            maxY = Math.max(maxY, y);
        }
        return {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        };
    }
}
$2a894264b44ee8c9$export$17d680238e50603e.prototype.className = "Line";
$2a894264b44ee8c9$export$17d680238e50603e.prototype._attrsAffectingSize = [
    "points",
    "bezier",
    "tension"
];
(0, $f1cce3c2a91bf0cf$export$f7a70d87a5e829eb)($2a894264b44ee8c9$export$17d680238e50603e);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($2a894264b44ee8c9$export$17d680238e50603e, "closed", false);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($2a894264b44ee8c9$export$17d680238e50603e, "bezier", false);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($2a894264b44ee8c9$export$17d680238e50603e, "tension", 0, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)());
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($2a894264b44ee8c9$export$17d680238e50603e, "points", [], (0, $8d9e6be936d29d8a$export$42b6f8f340e9a165)());







class $78ea6556da6c35e2$export$4b2950bdac9b6ee9 extends (0, $3bfe60cc136fb197$export$6428a7f2611ef1fa) {
    constructor(config){
        super(config);
        this.dataArray = [];
        this.pathLength = 0;
        this.dataArray = $78ea6556da6c35e2$export$4b2950bdac9b6ee9.parsePathData(this.data());
        this.pathLength = 0;
        for(var i = 0; i < this.dataArray.length; ++i)this.pathLength += this.dataArray[i].pathLength;
        this.on("dataChange.konva", function() {
            this.dataArray = $78ea6556da6c35e2$export$4b2950bdac9b6ee9.parsePathData(this.data());
            this.pathLength = 0;
            for(var i = 0; i < this.dataArray.length; ++i)this.pathLength += this.dataArray[i].pathLength;
        });
    }
    _sceneFunc(context) {
        var ca = this.dataArray;
        context.beginPath();
        var isClosed = false;
        for(var n = 0; n < ca.length; n++){
            var c = ca[n].command;
            var p = ca[n].points;
            switch(c){
                case "L":
                    context.lineTo(p[0], p[1]);
                    break;
                case "M":
                    context.moveTo(p[0], p[1]);
                    break;
                case "C":
                    context.bezierCurveTo(p[0], p[1], p[2], p[3], p[4], p[5]);
                    break;
                case "Q":
                    context.quadraticCurveTo(p[0], p[1], p[2], p[3]);
                    break;
                case "A":
                    var cx = p[0], cy = p[1], rx = p[2], ry = p[3], theta = p[4], dTheta = p[5], psi = p[6], fs = p[7];
                    var r = rx > ry ? rx : ry;
                    var scaleX = rx > ry ? 1 : rx / ry;
                    var scaleY = rx > ry ? ry / rx : 1;
                    context.translate(cx, cy);
                    context.rotate(psi);
                    context.scale(scaleX, scaleY);
                    context.arc(0, 0, r, theta, theta + dTheta, 1 - fs);
                    context.scale(1 / scaleX, 1 / scaleY);
                    context.rotate(-psi);
                    context.translate(-cx, -cy);
                    break;
                case "z":
                    isClosed = true;
                    context.closePath();
                    break;
            }
        }
        if (!isClosed && !this.hasFill()) context.strokeShape(this);
        else context.fillStrokeShape(this);
    }
    getSelfRect() {
        var points = [];
        this.dataArray.forEach(function(data) {
            if (data.command === "A") {
                var start = data.points[4];
                var dTheta = data.points[5];
                var end = data.points[4] + dTheta;
                var inc = Math.PI / 180.0;
                if (Math.abs(start - end) < inc) inc = Math.abs(start - end);
                if (dTheta < 0) for(let t = start - inc; t > end; t -= inc){
                    const point = $78ea6556da6c35e2$export$4b2950bdac9b6ee9.getPointOnEllipticalArc(data.points[0], data.points[1], data.points[2], data.points[3], t, 0);
                    points.push(point.x, point.y);
                }
                else for(let t = start + inc; t < end; t += inc){
                    const point = $78ea6556da6c35e2$export$4b2950bdac9b6ee9.getPointOnEllipticalArc(data.points[0], data.points[1], data.points[2], data.points[3], t, 0);
                    points.push(point.x, point.y);
                }
            } else if (data.command === "C") for(let t = 0.0; t <= 1; t += 0.01){
                const point = $78ea6556da6c35e2$export$4b2950bdac9b6ee9.getPointOnCubicBezier(t, data.start.x, data.start.y, data.points[0], data.points[1], data.points[2], data.points[3], data.points[4], data.points[5]);
                points.push(point.x, point.y);
            }
            else points = points.concat(data.points);
        });
        var minX = points[0];
        var maxX = points[0];
        var minY = points[1];
        var maxY = points[1];
        var x, y;
        for(var i = 0; i < points.length / 2; i++){
            x = points[i * 2];
            y = points[i * 2 + 1];
            if (!isNaN(x)) {
                minX = Math.min(minX, x);
                maxX = Math.max(maxX, x);
            }
            if (!isNaN(y)) {
                minY = Math.min(minY, y);
                maxY = Math.max(maxY, y);
            }
        }
        return {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        };
    }
    getLength() {
        return this.pathLength;
    }
    getPointAtLength(length) {
        var point, i = 0, ii = this.dataArray.length;
        if (!ii) return null;
        while(i < ii && length > this.dataArray[i].pathLength){
            length -= this.dataArray[i].pathLength;
            ++i;
        }
        if (i === ii) {
            point = this.dataArray[i - 1].points.slice(-2);
            return {
                x: point[0],
                y: point[1]
            };
        }
        if (length < 0.01) {
            point = this.dataArray[i].points.slice(0, 2);
            return {
                x: point[0],
                y: point[1]
            };
        }
        var cp = this.dataArray[i];
        var p = cp.points;
        switch(cp.command){
            case "L":
                return $78ea6556da6c35e2$export$4b2950bdac9b6ee9.getPointOnLine(length, cp.start.x, cp.start.y, p[0], p[1]);
            case "C":
                return $78ea6556da6c35e2$export$4b2950bdac9b6ee9.getPointOnCubicBezier(length / cp.pathLength, cp.start.x, cp.start.y, p[0], p[1], p[2], p[3], p[4], p[5]);
            case "Q":
                return $78ea6556da6c35e2$export$4b2950bdac9b6ee9.getPointOnQuadraticBezier(length / cp.pathLength, cp.start.x, cp.start.y, p[0], p[1], p[2], p[3]);
            case "A":
                var cx = p[0], cy = p[1], rx = p[2], ry = p[3], theta = p[4], dTheta = p[5], psi = p[6];
                theta += dTheta * length / cp.pathLength;
                return $78ea6556da6c35e2$export$4b2950bdac9b6ee9.getPointOnEllipticalArc(cx, cy, rx, ry, theta, psi);
        }
        return null;
    }
    static getLineLength(x1, y1, x2, y2) {
        return Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
    }
    static getPointOnLine(dist, P1x, P1y, P2x, P2y, fromX, fromY) {
        if (fromX === undefined) fromX = P1x;
        if (fromY === undefined) fromY = P1y;
        var m = (P2y - P1y) / (P2x - P1x + 0.00000001);
        var run = Math.sqrt(dist * dist / (1 + m * m));
        if (P2x < P1x) run *= -1;
        var rise = m * run;
        var pt;
        if (P2x === P1x) pt = {
            x: fromX,
            y: fromY + rise
        };
        else if ((fromY - P1y) / (fromX - P1x + 0.00000001) === m) pt = {
            x: fromX + run,
            y: fromY + rise
        };
        else {
            var ix, iy;
            var len = this.getLineLength(P1x, P1y, P2x, P2y);
            var u = (fromX - P1x) * (P2x - P1x) + (fromY - P1y) * (P2y - P1y);
            u = u / (len * len);
            ix = P1x + u * (P2x - P1x);
            iy = P1y + u * (P2y - P1y);
            var pRise = this.getLineLength(fromX, fromY, ix, iy);
            var pRun = Math.sqrt(dist * dist - pRise * pRise);
            run = Math.sqrt(pRun * pRun / (1 + m * m));
            if (P2x < P1x) run *= -1;
            rise = m * run;
            pt = {
                x: ix + run,
                y: iy + rise
            };
        }
        return pt;
    }
    static getPointOnCubicBezier(pct, P1x, P1y, P2x, P2y, P3x, P3y, P4x, P4y) {
        function CB1(t) {
            return t * t * t;
        }
        function CB2(t) {
            return 3 * t * t * (1 - t);
        }
        function CB3(t) {
            return 3 * t * (1 - t) * (1 - t);
        }
        function CB4(t) {
            return (1 - t) * (1 - t) * (1 - t);
        }
        var x = P4x * CB1(pct) + P3x * CB2(pct) + P2x * CB3(pct) + P1x * CB4(pct);
        var y = P4y * CB1(pct) + P3y * CB2(pct) + P2y * CB3(pct) + P1y * CB4(pct);
        return {
            x: x,
            y: y
        };
    }
    static getPointOnQuadraticBezier(pct, P1x, P1y, P2x, P2y, P3x, P3y) {
        function QB1(t) {
            return t * t;
        }
        function QB2(t) {
            return 2 * t * (1 - t);
        }
        function QB3(t) {
            return (1 - t) * (1 - t);
        }
        var x = P3x * QB1(pct) + P2x * QB2(pct) + P1x * QB3(pct);
        var y = P3y * QB1(pct) + P2y * QB2(pct) + P1y * QB3(pct);
        return {
            x: x,
            y: y
        };
    }
    static getPointOnEllipticalArc(cx, cy, rx, ry, theta, psi) {
        var cosPsi = Math.cos(psi), sinPsi = Math.sin(psi);
        var pt = {
            x: rx * Math.cos(theta),
            y: ry * Math.sin(theta)
        };
        return {
            x: cx + (pt.x * cosPsi - pt.y * sinPsi),
            y: cy + (pt.x * sinPsi + pt.y * cosPsi)
        };
    }
    static parsePathData(data) {
        if (!data) return [];
        var cs = data;
        var cc = [
            "m",
            "M",
            "l",
            "L",
            "v",
            "V",
            "h",
            "H",
            "z",
            "Z",
            "c",
            "C",
            "q",
            "Q",
            "t",
            "T",
            "s",
            "S",
            "a",
            "A"
        ];
        cs = cs.replace(new RegExp(" ", "g"), ",");
        for(var n = 0; n < cc.length; n++)cs = cs.replace(new RegExp(cc[n], "g"), "|" + cc[n]);
        var arr = cs.split("|");
        var ca = [];
        var coords = [];
        var cpx = 0;
        var cpy = 0;
        var re = /([-+]?((\d+\.\d+)|((\d+)|(\.\d+)))(?:e[-+]?\d+)?)/gi;
        var match;
        for(n = 1; n < arr.length; n++){
            var str = arr[n];
            var c = str.charAt(0);
            str = str.slice(1);
            coords.length = 0;
            while(match = re.exec(str))coords.push(match[0]);
            var p = [];
            for(var j = 0, jlen = coords.length; j < jlen; j++){
                if (coords[j] === "00") {
                    p.push(0, 0);
                    continue;
                }
                var parsed = parseFloat(coords[j]);
                if (!isNaN(parsed)) p.push(parsed);
                else p.push(0);
            }
            while(p.length > 0){
                if (isNaN(p[0])) break;
                var cmd = null;
                var points = [];
                var startX = cpx, startY = cpy;
                var prevCmd, ctlPtx, ctlPty;
                var rx, ry, psi, fa, fs, x1, y1;
                switch(c){
                    case "l":
                        cpx += p.shift();
                        cpy += p.shift();
                        cmd = "L";
                        points.push(cpx, cpy);
                        break;
                    case "L":
                        cpx = p.shift();
                        cpy = p.shift();
                        points.push(cpx, cpy);
                        break;
                    case "m":
                        var dx = p.shift();
                        var dy = p.shift();
                        cpx += dx;
                        cpy += dy;
                        cmd = "M";
                        if (ca.length > 2 && ca[ca.length - 1].command === "z") {
                            for(var idx = ca.length - 2; idx >= 0; idx--)if (ca[idx].command === "M") {
                                cpx = ca[idx].points[0] + dx;
                                cpy = ca[idx].points[1] + dy;
                                break;
                            }
                        }
                        points.push(cpx, cpy);
                        c = "l";
                        break;
                    case "M":
                        cpx = p.shift();
                        cpy = p.shift();
                        cmd = "M";
                        points.push(cpx, cpy);
                        c = "L";
                        break;
                    case "h":
                        cpx += p.shift();
                        cmd = "L";
                        points.push(cpx, cpy);
                        break;
                    case "H":
                        cpx = p.shift();
                        cmd = "L";
                        points.push(cpx, cpy);
                        break;
                    case "v":
                        cpy += p.shift();
                        cmd = "L";
                        points.push(cpx, cpy);
                        break;
                    case "V":
                        cpy = p.shift();
                        cmd = "L";
                        points.push(cpx, cpy);
                        break;
                    case "C":
                        points.push(p.shift(), p.shift(), p.shift(), p.shift());
                        cpx = p.shift();
                        cpy = p.shift();
                        points.push(cpx, cpy);
                        break;
                    case "c":
                        points.push(cpx + p.shift(), cpy + p.shift(), cpx + p.shift(), cpy + p.shift());
                        cpx += p.shift();
                        cpy += p.shift();
                        cmd = "C";
                        points.push(cpx, cpy);
                        break;
                    case "S":
                        ctlPtx = cpx;
                        ctlPty = cpy;
                        prevCmd = ca[ca.length - 1];
                        if (prevCmd.command === "C") {
                            ctlPtx = cpx + (cpx - prevCmd.points[2]);
                            ctlPty = cpy + (cpy - prevCmd.points[3]);
                        }
                        points.push(ctlPtx, ctlPty, p.shift(), p.shift());
                        cpx = p.shift();
                        cpy = p.shift();
                        cmd = "C";
                        points.push(cpx, cpy);
                        break;
                    case "s":
                        ctlPtx = cpx;
                        ctlPty = cpy;
                        prevCmd = ca[ca.length - 1];
                        if (prevCmd.command === "C") {
                            ctlPtx = cpx + (cpx - prevCmd.points[2]);
                            ctlPty = cpy + (cpy - prevCmd.points[3]);
                        }
                        points.push(ctlPtx, ctlPty, cpx + p.shift(), cpy + p.shift());
                        cpx += p.shift();
                        cpy += p.shift();
                        cmd = "C";
                        points.push(cpx, cpy);
                        break;
                    case "Q":
                        points.push(p.shift(), p.shift());
                        cpx = p.shift();
                        cpy = p.shift();
                        points.push(cpx, cpy);
                        break;
                    case "q":
                        points.push(cpx + p.shift(), cpy + p.shift());
                        cpx += p.shift();
                        cpy += p.shift();
                        cmd = "Q";
                        points.push(cpx, cpy);
                        break;
                    case "T":
                        ctlPtx = cpx;
                        ctlPty = cpy;
                        prevCmd = ca[ca.length - 1];
                        if (prevCmd.command === "Q") {
                            ctlPtx = cpx + (cpx - prevCmd.points[0]);
                            ctlPty = cpy + (cpy - prevCmd.points[1]);
                        }
                        cpx = p.shift();
                        cpy = p.shift();
                        cmd = "Q";
                        points.push(ctlPtx, ctlPty, cpx, cpy);
                        break;
                    case "t":
                        ctlPtx = cpx;
                        ctlPty = cpy;
                        prevCmd = ca[ca.length - 1];
                        if (prevCmd.command === "Q") {
                            ctlPtx = cpx + (cpx - prevCmd.points[0]);
                            ctlPty = cpy + (cpy - prevCmd.points[1]);
                        }
                        cpx += p.shift();
                        cpy += p.shift();
                        cmd = "Q";
                        points.push(ctlPtx, ctlPty, cpx, cpy);
                        break;
                    case "A":
                        rx = p.shift();
                        ry = p.shift();
                        psi = p.shift();
                        fa = p.shift();
                        fs = p.shift();
                        x1 = cpx;
                        y1 = cpy;
                        cpx = p.shift();
                        cpy = p.shift();
                        cmd = "A";
                        points = this.convertEndpointToCenterParameterization(x1, y1, cpx, cpy, fa, fs, rx, ry, psi);
                        break;
                    case "a":
                        rx = p.shift();
                        ry = p.shift();
                        psi = p.shift();
                        fa = p.shift();
                        fs = p.shift();
                        x1 = cpx;
                        y1 = cpy;
                        cpx += p.shift();
                        cpy += p.shift();
                        cmd = "A";
                        points = this.convertEndpointToCenterParameterization(x1, y1, cpx, cpy, fa, fs, rx, ry, psi);
                        break;
                }
                ca.push({
                    command: cmd || c,
                    points: points,
                    start: {
                        x: startX,
                        y: startY
                    },
                    pathLength: this.calcLength(startX, startY, cmd || c, points)
                });
            }
            if (c === "z" || c === "Z") ca.push({
                command: "z",
                points: [],
                start: undefined,
                pathLength: 0
            });
        }
        return ca;
    }
    static calcLength(x, y, cmd, points) {
        var len, p1, p2, t;
        var path = $78ea6556da6c35e2$export$4b2950bdac9b6ee9;
        switch(cmd){
            case "L":
                return path.getLineLength(x, y, points[0], points[1]);
            case "C":
                len = 0.0;
                p1 = path.getPointOnCubicBezier(0, x, y, points[0], points[1], points[2], points[3], points[4], points[5]);
                for(t = 0.01; t <= 1; t += 0.01){
                    p2 = path.getPointOnCubicBezier(t, x, y, points[0], points[1], points[2], points[3], points[4], points[5]);
                    len += path.getLineLength(p1.x, p1.y, p2.x, p2.y);
                    p1 = p2;
                }
                return len;
            case "Q":
                len = 0.0;
                p1 = path.getPointOnQuadraticBezier(0, x, y, points[0], points[1], points[2], points[3]);
                for(t = 0.01; t <= 1; t += 0.01){
                    p2 = path.getPointOnQuadraticBezier(t, x, y, points[0], points[1], points[2], points[3]);
                    len += path.getLineLength(p1.x, p1.y, p2.x, p2.y);
                    p1 = p2;
                }
                return len;
            case "A":
                len = 0.0;
                var start = points[4];
                var dTheta = points[5];
                var end = points[4] + dTheta;
                var inc = Math.PI / 180.0;
                if (Math.abs(start - end) < inc) inc = Math.abs(start - end);
                p1 = path.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], start, 0);
                if (dTheta < 0) for(t = start - inc; t > end; t -= inc){
                    p2 = path.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], t, 0);
                    len += path.getLineLength(p1.x, p1.y, p2.x, p2.y);
                    p1 = p2;
                }
                else for(t = start + inc; t < end; t += inc){
                    p2 = path.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], t, 0);
                    len += path.getLineLength(p1.x, p1.y, p2.x, p2.y);
                    p1 = p2;
                }
                p2 = path.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], end, 0);
                len += path.getLineLength(p1.x, p1.y, p2.x, p2.y);
                return len;
        }
        return 0;
    }
    static convertEndpointToCenterParameterization(x1, y1, x2, y2, fa, fs, rx, ry, psiDeg) {
        var psi = psiDeg * (Math.PI / 180.0);
        var xp = Math.cos(psi) * (x1 - x2) / 2.0 + Math.sin(psi) * (y1 - y2) / 2.0;
        var yp = -1 * Math.sin(psi) * (x1 - x2) / 2.0 + Math.cos(psi) * (y1 - y2) / 2.0;
        var lambda = xp * xp / (rx * rx) + yp * yp / (ry * ry);
        if (lambda > 1) {
            rx *= Math.sqrt(lambda);
            ry *= Math.sqrt(lambda);
        }
        var f = Math.sqrt((rx * rx * (ry * ry) - rx * rx * (yp * yp) - ry * ry * (xp * xp)) / (rx * rx * (yp * yp) + ry * ry * (xp * xp)));
        if (fa === fs) f *= -1;
        if (isNaN(f)) f = 0;
        var cxp = f * rx * yp / ry;
        var cyp = f * -ry * xp / rx;
        var cx = (x1 + x2) / 2.0 + Math.cos(psi) * cxp - Math.sin(psi) * cyp;
        var cy = (y1 + y2) / 2.0 + Math.sin(psi) * cxp + Math.cos(psi) * cyp;
        var vMag = function(v) {
            return Math.sqrt(v[0] * v[0] + v[1] * v[1]);
        };
        var vRatio = function(u, v) {
            return (u[0] * v[0] + u[1] * v[1]) / (vMag(u) * vMag(v));
        };
        var vAngle = function(u, v) {
            return (u[0] * v[1] < u[1] * v[0] ? -1 : 1) * Math.acos(vRatio(u, v));
        };
        var theta = vAngle([
            1,
            0
        ], [
            (xp - cxp) / rx,
            (yp - cyp) / ry
        ]);
        var u = [
            (xp - cxp) / rx,
            (yp - cyp) / ry
        ];
        var v = [
            (-1 * xp - cxp) / rx,
            (-1 * yp - cyp) / ry
        ];
        var dTheta = vAngle(u, v);
        if (vRatio(u, v) <= -1) dTheta = Math.PI;
        if (vRatio(u, v) >= 1) dTheta = 0;
        if (fs === 0 && dTheta > 0) dTheta = dTheta - 2 * Math.PI;
        if (fs === 1 && dTheta < 0) dTheta = dTheta + 2 * Math.PI;
        return [
            cx,
            cy,
            rx,
            ry,
            theta,
            dTheta,
            psi,
            fs
        ];
    }
}
$78ea6556da6c35e2$export$4b2950bdac9b6ee9.prototype.className = "Path";
$78ea6556da6c35e2$export$4b2950bdac9b6ee9.prototype._attrsAffectingSize = [
    "data"
];
(0, $f1cce3c2a91bf0cf$export$f7a70d87a5e829eb)($78ea6556da6c35e2$export$4b2950bdac9b6ee9);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($78ea6556da6c35e2$export$4b2950bdac9b6ee9, "data");


class $2a0e2f808fa98650$export$21b07c8f274aebd5 extends (0, $2a894264b44ee8c9$export$17d680238e50603e) {
    _sceneFunc(ctx) {
        super._sceneFunc(ctx);
        var PI2 = Math.PI * 2;
        var points = this.points();
        var tp = points;
        var fromTension = this.tension() !== 0 && points.length > 4;
        if (fromTension) tp = this.getTensionPoints();
        var length = this.pointerLength();
        var n = points.length;
        var dx, dy;
        if (fromTension) {
            const lp = [
                tp[tp.length - 4],
                tp[tp.length - 3],
                tp[tp.length - 2],
                tp[tp.length - 1],
                points[n - 2],
                points[n - 1]
            ];
            const lastLength = (0, $78ea6556da6c35e2$export$4b2950bdac9b6ee9).calcLength(tp[tp.length - 4], tp[tp.length - 3], "C", lp);
            const previous = (0, $78ea6556da6c35e2$export$4b2950bdac9b6ee9).getPointOnQuadraticBezier(Math.min(1, 1 - length / lastLength), lp[0], lp[1], lp[2], lp[3], lp[4], lp[5]);
            dx = points[n - 2] - previous.x;
            dy = points[n - 1] - previous.y;
        } else {
            dx = points[n - 2] - points[n - 4];
            dy = points[n - 1] - points[n - 3];
        }
        var radians = (Math.atan2(dy, dx) + PI2) % PI2;
        var width = this.pointerWidth();
        if (this.pointerAtEnding()) {
            ctx.save();
            ctx.beginPath();
            ctx.translate(points[n - 2], points[n - 1]);
            ctx.rotate(radians);
            ctx.moveTo(0, 0);
            ctx.lineTo(-length, width / 2);
            ctx.lineTo(-length, -width / 2);
            ctx.closePath();
            ctx.restore();
            this.__fillStroke(ctx);
        }
        if (this.pointerAtBeginning()) {
            ctx.save();
            ctx.beginPath();
            ctx.translate(points[0], points[1]);
            if (fromTension) {
                dx = (tp[0] + tp[2]) / 2 - points[0];
                dy = (tp[1] + tp[3]) / 2 - points[1];
            } else {
                dx = points[2] - points[0];
                dy = points[3] - points[1];
            }
            ctx.rotate((Math.atan2(-dy, -dx) + PI2) % PI2);
            ctx.moveTo(0, 0);
            ctx.lineTo(-length, width / 2);
            ctx.lineTo(-length, -width / 2);
            ctx.closePath();
            ctx.restore();
            this.__fillStroke(ctx);
        }
    }
    __fillStroke(ctx) {
        var isDashEnabled = this.dashEnabled();
        if (isDashEnabled) {
            this.attrs.dashEnabled = false;
            ctx.setLineDash([]);
        }
        ctx.fillStrokeShape(this);
        if (isDashEnabled) this.attrs.dashEnabled = true;
    }
    getSelfRect() {
        const lineRect = super.getSelfRect();
        const offset = this.pointerWidth() / 2;
        return {
            x: lineRect.x - offset,
            y: lineRect.y - offset,
            width: lineRect.width + offset * 2,
            height: lineRect.height + offset * 2
        };
    }
}
$2a0e2f808fa98650$export$21b07c8f274aebd5.prototype.className = "Arrow";
(0, $f1cce3c2a91bf0cf$export$f7a70d87a5e829eb)($2a0e2f808fa98650$export$21b07c8f274aebd5);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($2a0e2f808fa98650$export$21b07c8f274aebd5, "pointerLength", 10, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)());
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($2a0e2f808fa98650$export$21b07c8f274aebd5, "pointerWidth", 10, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)());
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($2a0e2f808fa98650$export$21b07c8f274aebd5, "pointerAtBeginning", false);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($2a0e2f808fa98650$export$21b07c8f274aebd5, "pointerAtEnding", true);






class $290cdf94c489e2d1$export$c89a927ffc67e6fa extends (0, $3bfe60cc136fb197$export$6428a7f2611ef1fa) {
    _sceneFunc(context) {
        context.beginPath();
        context.arc(0, 0, this.attrs.radius || 0, 0, Math.PI * 2, false);
        context.closePath();
        context.fillStrokeShape(this);
    }
    getWidth() {
        return this.radius() * 2;
    }
    getHeight() {
        return this.radius() * 2;
    }
    setWidth(width) {
        if (this.radius() !== width / 2) this.radius(width / 2);
    }
    setHeight(height) {
        if (this.radius() !== height / 2) this.radius(height / 2);
    }
}
$290cdf94c489e2d1$export$c89a927ffc67e6fa.prototype._centroid = true;
$290cdf94c489e2d1$export$c89a927ffc67e6fa.prototype.className = "Circle";
$290cdf94c489e2d1$export$c89a927ffc67e6fa.prototype._attrsAffectingSize = [
    "radius"
];
(0, $f1cce3c2a91bf0cf$export$f7a70d87a5e829eb)($290cdf94c489e2d1$export$c89a927ffc67e6fa);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($290cdf94c489e2d1$export$c89a927ffc67e6fa, "radius", 0, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)());






class $87bb524290f16dd5$export$80b0269ab108fa11 extends (0, $3bfe60cc136fb197$export$6428a7f2611ef1fa) {
    _sceneFunc(context) {
        var rx = this.radiusX(), ry = this.radiusY();
        context.beginPath();
        context.save();
        if (rx !== ry) context.scale(1, ry / rx);
        context.arc(0, 0, rx, 0, Math.PI * 2, false);
        context.restore();
        context.closePath();
        context.fillStrokeShape(this);
    }
    getWidth() {
        return this.radiusX() * 2;
    }
    getHeight() {
        return this.radiusY() * 2;
    }
    setWidth(width) {
        this.radiusX(width / 2);
    }
    setHeight(height) {
        this.radiusY(height / 2);
    }
}
$87bb524290f16dd5$export$80b0269ab108fa11.prototype.className = "Ellipse";
$87bb524290f16dd5$export$80b0269ab108fa11.prototype._centroid = true;
$87bb524290f16dd5$export$80b0269ab108fa11.prototype._attrsAffectingSize = [
    "radiusX",
    "radiusY"
];
(0, $f1cce3c2a91bf0cf$export$f7a70d87a5e829eb)($87bb524290f16dd5$export$80b0269ab108fa11);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addComponentsGetterSetter($87bb524290f16dd5$export$80b0269ab108fa11, "radius", [
    "x",
    "y"
]);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($87bb524290f16dd5$export$80b0269ab108fa11, "radiusX", 0, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)());
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($87bb524290f16dd5$export$80b0269ab108fa11, "radiusY", 0, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)());







class $c10569d3249cdecf$export$3e431a229df88919 extends (0, $3bfe60cc136fb197$export$6428a7f2611ef1fa) {
    constructor(attrs){
        super(attrs);
        this.on("imageChange.konva", ()=>{
            this._setImageLoad();
        });
        this._setImageLoad();
    }
    _setImageLoad() {
        const image = this.image();
        if (image && image.complete) return;
        if (image && image.readyState === 4) return;
        if (image && image["addEventListener"]) image["addEventListener"]("load", ()=>{
            this._requestDraw();
        });
    }
    _useBufferCanvas() {
        return super._useBufferCanvas(true);
    }
    _sceneFunc(context) {
        const width = this.getWidth();
        const height = this.getHeight();
        const cornerRadius = this.cornerRadius();
        const image = this.attrs.image;
        let params;
        if (image) {
            const cropWidth = this.attrs.cropWidth;
            const cropHeight = this.attrs.cropHeight;
            if (cropWidth && cropHeight) params = [
                image,
                this.cropX(),
                this.cropY(),
                cropWidth,
                cropHeight,
                0,
                0,
                width,
                height
            ];
            else params = [
                image,
                0,
                0,
                width,
                height
            ];
        }
        if (this.hasFill() || this.hasStroke() || cornerRadius) {
            context.beginPath();
            cornerRadius ? (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).drawRoundedRectPath(context, width, height, cornerRadius) : context.rect(0, 0, width, height);
            context.closePath();
            context.fillStrokeShape(this);
        }
        if (image) {
            if (cornerRadius) context.clip();
            context.drawImage.apply(context, params);
        }
    }
    _hitFunc(context) {
        var width = this.width(), height = this.height(), cornerRadius = this.cornerRadius();
        context.beginPath();
        if (!cornerRadius) context.rect(0, 0, width, height);
        else (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).drawRoundedRectPath(context, width, height, cornerRadius);
        context.closePath();
        context.fillStrokeShape(this);
    }
    getWidth() {
        var _a, _b;
        return (_a = this.attrs.width) !== null && _a !== void 0 ? _a : (_b = this.image()) === null || _b === void 0 ? void 0 : _b.width;
    }
    getHeight() {
        var _a, _b;
        return (_a = this.attrs.height) !== null && _a !== void 0 ? _a : (_b = this.image()) === null || _b === void 0 ? void 0 : _b.height;
    }
    static fromURL(url, callback, onError = null) {
        var img = (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).createImageElement();
        img.onload = function() {
            var image = new $c10569d3249cdecf$export$3e431a229df88919({
                image: img
            });
            callback(image);
        };
        img.onerror = onError;
        img.crossOrigin = "Anonymous";
        img.src = url;
    }
}
$c10569d3249cdecf$export$3e431a229df88919.prototype.className = "Image";
(0, $f1cce3c2a91bf0cf$export$f7a70d87a5e829eb)($c10569d3249cdecf$export$3e431a229df88919);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($c10569d3249cdecf$export$3e431a229df88919, "cornerRadius", 0, (0, $8d9e6be936d29d8a$export$7d4ab1842c1b264b)(4));
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($c10569d3249cdecf$export$3e431a229df88919, "image");
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addComponentsGetterSetter($c10569d3249cdecf$export$3e431a229df88919, "crop", [
    "x",
    "y",
    "width",
    "height"
]);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($c10569d3249cdecf$export$3e431a229df88919, "cropX", 0, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)());
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($c10569d3249cdecf$export$3e431a229df88919, "cropY", 0, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)());
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($c10569d3249cdecf$export$3e431a229df88919, "cropWidth", 0, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)());
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($c10569d3249cdecf$export$3e431a229df88919, "cropHeight", 0, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)());







var $7760c087bffc0d19$var$ATTR_CHANGE_LIST = [
    "fontFamily",
    "fontSize",
    "fontStyle",
    "padding",
    "lineHeight",
    "text",
    "width",
    "height",
    "pointerDirection",
    "pointerWidth",
    "pointerHeight"
], $7760c087bffc0d19$var$CHANGE_KONVA = "Change.konva", $7760c087bffc0d19$var$NONE = "none", $7760c087bffc0d19$var$UP = "up", $7760c087bffc0d19$var$RIGHT = "right", $7760c087bffc0d19$var$DOWN = "down", $7760c087bffc0d19$var$LEFT = "left", $7760c087bffc0d19$var$attrChangeListLen = $7760c087bffc0d19$var$ATTR_CHANGE_LIST.length;
class $7760c087bffc0d19$export$b04be29aa201d4f5 extends (0, $5147287ae7dd04c0$export$eb2fcfdbd7ba97d4) {
    constructor(config){
        super(config);
        this.on("add.konva", function(evt) {
            this._addListeners(evt.child);
            this._sync();
        });
    }
    getText() {
        return this.find("Text")[0];
    }
    getTag() {
        return this.find("Tag")[0];
    }
    _addListeners(text) {
        var that = this, n;
        var func = function() {
            that._sync();
        };
        for(n = 0; n < $7760c087bffc0d19$var$attrChangeListLen; n++)text.on($7760c087bffc0d19$var$ATTR_CHANGE_LIST[n] + $7760c087bffc0d19$var$CHANGE_KONVA, func);
    }
    getWidth() {
        return this.getText().width();
    }
    getHeight() {
        return this.getText().height();
    }
    _sync() {
        var text = this.getText(), tag = this.getTag(), width, height, pointerDirection, pointerWidth, x, y, pointerHeight;
        if (text && tag) {
            width = text.width();
            height = text.height();
            pointerDirection = tag.pointerDirection();
            pointerWidth = tag.pointerWidth();
            pointerHeight = tag.pointerHeight();
            x = 0;
            y = 0;
            switch(pointerDirection){
                case $7760c087bffc0d19$var$UP:
                    x = width / 2;
                    y = -1 * pointerHeight;
                    break;
                case $7760c087bffc0d19$var$RIGHT:
                    x = width + pointerWidth;
                    y = height / 2;
                    break;
                case $7760c087bffc0d19$var$DOWN:
                    x = width / 2;
                    y = height + pointerHeight;
                    break;
                case $7760c087bffc0d19$var$LEFT:
                    x = -1 * pointerWidth;
                    y = height / 2;
                    break;
            }
            tag.setAttrs({
                x: -1 * x,
                y: -1 * y,
                width: width,
                height: height
            });
            text.setAttrs({
                x: -1 * x,
                y: -1 * y
            });
        }
    }
}
$7760c087bffc0d19$export$b04be29aa201d4f5.prototype.className = "Label";
(0, $f1cce3c2a91bf0cf$export$f7a70d87a5e829eb)($7760c087bffc0d19$export$b04be29aa201d4f5);
class $7760c087bffc0d19$export$3288d34c523a1192 extends (0, $3bfe60cc136fb197$export$6428a7f2611ef1fa) {
    _sceneFunc(context) {
        var width = this.width(), height = this.height(), pointerDirection = this.pointerDirection(), pointerWidth = this.pointerWidth(), pointerHeight = this.pointerHeight(), cornerRadius = this.cornerRadius();
        let topLeft = 0;
        let topRight = 0;
        let bottomLeft = 0;
        let bottomRight = 0;
        if (typeof cornerRadius === "number") topLeft = topRight = bottomLeft = bottomRight = Math.min(cornerRadius, width / 2, height / 2);
        else {
            topLeft = Math.min(cornerRadius[0] || 0, width / 2, height / 2);
            topRight = Math.min(cornerRadius[1] || 0, width / 2, height / 2);
            bottomRight = Math.min(cornerRadius[2] || 0, width / 2, height / 2);
            bottomLeft = Math.min(cornerRadius[3] || 0, width / 2, height / 2);
        }
        context.beginPath();
        context.moveTo(topLeft, 0);
        if (pointerDirection === $7760c087bffc0d19$var$UP) {
            context.lineTo((width - pointerWidth) / 2, 0);
            context.lineTo(width / 2, -1 * pointerHeight);
            context.lineTo((width + pointerWidth) / 2, 0);
        }
        context.lineTo(width - topRight, 0);
        context.arc(width - topRight, topRight, topRight, Math.PI * 3 / 2, 0, false);
        if (pointerDirection === $7760c087bffc0d19$var$RIGHT) {
            context.lineTo(width, (height - pointerHeight) / 2);
            context.lineTo(width + pointerWidth, height / 2);
            context.lineTo(width, (height + pointerHeight) / 2);
        }
        context.lineTo(width, height - bottomRight);
        context.arc(width - bottomRight, height - bottomRight, bottomRight, 0, Math.PI / 2, false);
        if (pointerDirection === $7760c087bffc0d19$var$DOWN) {
            context.lineTo((width + pointerWidth) / 2, height);
            context.lineTo(width / 2, height + pointerHeight);
            context.lineTo((width - pointerWidth) / 2, height);
        }
        context.lineTo(bottomLeft, height);
        context.arc(bottomLeft, height - bottomLeft, bottomLeft, Math.PI / 2, Math.PI, false);
        if (pointerDirection === $7760c087bffc0d19$var$LEFT) {
            context.lineTo(0, (height + pointerHeight) / 2);
            context.lineTo(-1 * pointerWidth, height / 2);
            context.lineTo(0, (height - pointerHeight) / 2);
        }
        context.lineTo(0, topLeft);
        context.arc(topLeft, topLeft, topLeft, Math.PI, Math.PI * 3 / 2, false);
        context.closePath();
        context.fillStrokeShape(this);
    }
    getSelfRect() {
        var x = 0, y = 0, pointerWidth = this.pointerWidth(), pointerHeight = this.pointerHeight(), direction = this.pointerDirection(), width = this.width(), height = this.height();
        if (direction === $7760c087bffc0d19$var$UP) {
            y -= pointerHeight;
            height += pointerHeight;
        } else if (direction === $7760c087bffc0d19$var$DOWN) height += pointerHeight;
        else if (direction === $7760c087bffc0d19$var$LEFT) {
            x -= pointerWidth * 1.5;
            width += pointerWidth;
        } else if (direction === $7760c087bffc0d19$var$RIGHT) width += pointerWidth * 1.5;
        return {
            x: x,
            y: y,
            width: width,
            height: height
        };
    }
}
$7760c087bffc0d19$export$3288d34c523a1192.prototype.className = "Tag";
(0, $f1cce3c2a91bf0cf$export$f7a70d87a5e829eb)($7760c087bffc0d19$export$3288d34c523a1192);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($7760c087bffc0d19$export$3288d34c523a1192, "pointerDirection", $7760c087bffc0d19$var$NONE);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($7760c087bffc0d19$export$3288d34c523a1192, "pointerWidth", 0, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)());
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($7760c087bffc0d19$export$3288d34c523a1192, "pointerHeight", 0, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)());
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($7760c087bffc0d19$export$3288d34c523a1192, "cornerRadius", 0, (0, $8d9e6be936d29d8a$export$7d4ab1842c1b264b)(4));









class $179d0400af9c0c44$export$c79fc6492f3af13d extends (0, $3bfe60cc136fb197$export$6428a7f2611ef1fa) {
    _sceneFunc(context) {
        var cornerRadius = this.cornerRadius(), width = this.width(), height = this.height();
        context.beginPath();
        if (!cornerRadius) context.rect(0, 0, width, height);
        else (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).drawRoundedRectPath(context, width, height, cornerRadius);
        context.closePath();
        context.fillStrokeShape(this);
    }
}
$179d0400af9c0c44$export$c79fc6492f3af13d.prototype.className = "Rect";
(0, $f1cce3c2a91bf0cf$export$f7a70d87a5e829eb)($179d0400af9c0c44$export$c79fc6492f3af13d);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($179d0400af9c0c44$export$c79fc6492f3af13d, "cornerRadius", 0, (0, $8d9e6be936d29d8a$export$7d4ab1842c1b264b)(4));






class $9542af7733498607$export$e2ee866164812ecd extends (0, $3bfe60cc136fb197$export$6428a7f2611ef1fa) {
    _sceneFunc(context) {
        const points = this._getPoints();
        context.beginPath();
        context.moveTo(points[0].x, points[0].y);
        for(var n = 1; n < points.length; n++)context.lineTo(points[n].x, points[n].y);
        context.closePath();
        context.fillStrokeShape(this);
    }
    _getPoints() {
        const sides = this.attrs.sides;
        const radius = this.attrs.radius || 0;
        const points = [];
        for(var n = 0; n < sides; n++)points.push({
            x: radius * Math.sin(n * 2 * Math.PI / sides),
            y: -1 * radius * Math.cos(n * 2 * Math.PI / sides)
        });
        return points;
    }
    getSelfRect() {
        const points = this._getPoints();
        var minX = points[0].x;
        var maxX = points[0].y;
        var minY = points[0].x;
        var maxY = points[0].y;
        points.forEach((point)=>{
            minX = Math.min(minX, point.x);
            maxX = Math.max(maxX, point.x);
            minY = Math.min(minY, point.y);
            maxY = Math.max(maxY, point.y);
        });
        return {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        };
    }
    getWidth() {
        return this.radius() * 2;
    }
    getHeight() {
        return this.radius() * 2;
    }
    setWidth(width) {
        this.radius(width / 2);
    }
    setHeight(height) {
        this.radius(height / 2);
    }
}
$9542af7733498607$export$e2ee866164812ecd.prototype.className = "RegularPolygon";
$9542af7733498607$export$e2ee866164812ecd.prototype._centroid = true;
$9542af7733498607$export$e2ee866164812ecd.prototype._attrsAffectingSize = [
    "radius"
];
(0, $f1cce3c2a91bf0cf$export$f7a70d87a5e829eb)($9542af7733498607$export$e2ee866164812ecd);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($9542af7733498607$export$e2ee866164812ecd, "radius", 0, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)());
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($9542af7733498607$export$e2ee866164812ecd, "sides", 0, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)());






var $9023172e11ac7f75$var$PIx2 = Math.PI * 2;
class $9023172e11ac7f75$export$a6e3577650b6d6d7 extends (0, $3bfe60cc136fb197$export$6428a7f2611ef1fa) {
    _sceneFunc(context) {
        context.beginPath();
        context.arc(0, 0, this.innerRadius(), 0, $9023172e11ac7f75$var$PIx2, false);
        context.moveTo(this.outerRadius(), 0);
        context.arc(0, 0, this.outerRadius(), $9023172e11ac7f75$var$PIx2, 0, true);
        context.closePath();
        context.fillStrokeShape(this);
    }
    getWidth() {
        return this.outerRadius() * 2;
    }
    getHeight() {
        return this.outerRadius() * 2;
    }
    setWidth(width) {
        this.outerRadius(width / 2);
    }
    setHeight(height) {
        this.outerRadius(height / 2);
    }
}
$9023172e11ac7f75$export$a6e3577650b6d6d7.prototype.className = "Ring";
$9023172e11ac7f75$export$a6e3577650b6d6d7.prototype._centroid = true;
$9023172e11ac7f75$export$a6e3577650b6d6d7.prototype._attrsAffectingSize = [
    "innerRadius",
    "outerRadius"
];
(0, $f1cce3c2a91bf0cf$export$f7a70d87a5e829eb)($9023172e11ac7f75$export$a6e3577650b6d6d7);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($9023172e11ac7f75$export$a6e3577650b6d6d7, "innerRadius", 0, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)());
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($9023172e11ac7f75$export$a6e3577650b6d6d7, "outerRadius", 0, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)());







class $26c792054d1523b2$export$3075603db8e6204c extends (0, $3bfe60cc136fb197$export$6428a7f2611ef1fa) {
    constructor(config){
        super(config);
        this._updated = true;
        this.anim = new (0, $24351191da7e43e2$export$c35d437ae5945fcd)(()=>{
            var updated = this._updated;
            this._updated = false;
            return updated;
        });
        this.on("animationChange.konva", function() {
            this.frameIndex(0);
        });
        this.on("frameIndexChange.konva", function() {
            this._updated = true;
        });
        this.on("frameRateChange.konva", function() {
            if (!this.anim.isRunning()) return;
            clearInterval(this.interval);
            this._setInterval();
        });
    }
    _sceneFunc(context) {
        var anim = this.animation(), index = this.frameIndex(), ix4 = index * 4, set = this.animations()[anim], offsets = this.frameOffsets(), x = set[ix4 + 0], y = set[ix4 + 1], width = set[ix4 + 2], height = set[ix4 + 3], image = this.image();
        if (this.hasFill() || this.hasStroke()) {
            context.beginPath();
            context.rect(0, 0, width, height);
            context.closePath();
            context.fillStrokeShape(this);
        }
        if (image) {
            if (offsets) {
                var offset = offsets[anim], ix2 = index * 2;
                context.drawImage(image, x, y, width, height, offset[ix2 + 0], offset[ix2 + 1], width, height);
            } else context.drawImage(image, x, y, width, height, 0, 0, width, height);
        }
    }
    _hitFunc(context) {
        var anim = this.animation(), index = this.frameIndex(), ix4 = index * 4, set = this.animations()[anim], offsets = this.frameOffsets(), width = set[ix4 + 2], height = set[ix4 + 3];
        context.beginPath();
        if (offsets) {
            var offset = offsets[anim];
            var ix2 = index * 2;
            context.rect(offset[ix2 + 0], offset[ix2 + 1], width, height);
        } else context.rect(0, 0, width, height);
        context.closePath();
        context.fillShape(this);
    }
    _useBufferCanvas() {
        return super._useBufferCanvas(true);
    }
    _setInterval() {
        var that = this;
        this.interval = setInterval(function() {
            that._updateIndex();
        }, 1000 / this.frameRate());
    }
    start() {
        if (this.isRunning()) return;
        var layer = this.getLayer();
        this.anim.setLayers(layer);
        this._setInterval();
        this.anim.start();
    }
    stop() {
        this.anim.stop();
        clearInterval(this.interval);
    }
    isRunning() {
        return this.anim.isRunning();
    }
    _updateIndex() {
        var index = this.frameIndex(), animation = this.animation(), animations = this.animations(), anim = animations[animation], len = anim.length / 4;
        if (index < len - 1) this.frameIndex(index + 1);
        else this.frameIndex(0);
    }
}
$26c792054d1523b2$export$3075603db8e6204c.prototype.className = "Sprite";
(0, $f1cce3c2a91bf0cf$export$f7a70d87a5e829eb)($26c792054d1523b2$export$3075603db8e6204c);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($26c792054d1523b2$export$3075603db8e6204c, "animation");
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($26c792054d1523b2$export$3075603db8e6204c, "animations");
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($26c792054d1523b2$export$3075603db8e6204c, "frameOffsets");
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($26c792054d1523b2$export$3075603db8e6204c, "image");
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($26c792054d1523b2$export$3075603db8e6204c, "frameIndex", 0, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)());
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($26c792054d1523b2$export$3075603db8e6204c, "frameRate", 17, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)());
(0, $e1d1e3911fd31488$export$8354032f3852ec50).backCompat($26c792054d1523b2$export$3075603db8e6204c, {
    index: "frameIndex",
    getIndex: "getFrameIndex",
    setIndex: "setFrameIndex"
});






class $027af3cf1eed306d$export$1644ba17714857f1 extends (0, $3bfe60cc136fb197$export$6428a7f2611ef1fa) {
    _sceneFunc(context) {
        var innerRadius = this.innerRadius(), outerRadius = this.outerRadius(), numPoints = this.numPoints();
        context.beginPath();
        context.moveTo(0, 0 - outerRadius);
        for(var n = 1; n < numPoints * 2; n++){
            var radius = n % 2 === 0 ? outerRadius : innerRadius;
            var x = radius * Math.sin(n * Math.PI / numPoints);
            var y = -1 * radius * Math.cos(n * Math.PI / numPoints);
            context.lineTo(x, y);
        }
        context.closePath();
        context.fillStrokeShape(this);
    }
    getWidth() {
        return this.outerRadius() * 2;
    }
    getHeight() {
        return this.outerRadius() * 2;
    }
    setWidth(width) {
        this.outerRadius(width / 2);
    }
    setHeight(height) {
        this.outerRadius(height / 2);
    }
}
$027af3cf1eed306d$export$1644ba17714857f1.prototype.className = "Star";
$027af3cf1eed306d$export$1644ba17714857f1.prototype._centroid = true;
$027af3cf1eed306d$export$1644ba17714857f1.prototype._attrsAffectingSize = [
    "innerRadius",
    "outerRadius"
];
(0, $f1cce3c2a91bf0cf$export$f7a70d87a5e829eb)($027af3cf1eed306d$export$1644ba17714857f1);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($027af3cf1eed306d$export$1644ba17714857f1, "numPoints", 5, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)());
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($027af3cf1eed306d$export$1644ba17714857f1, "innerRadius", 0, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)());
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($027af3cf1eed306d$export$1644ba17714857f1, "outerRadius", 0, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)());







function $1886c67fae9befe1$export$b9ca061da17f2d30(string) {
    return Array.from(string);
}
var $1886c67fae9befe1$var$AUTO = "auto", $1886c67fae9befe1$var$CENTER = "center", $1886c67fae9befe1$var$JUSTIFY = "justify", $1886c67fae9befe1$var$CHANGE_KONVA = "Change.konva", $1886c67fae9befe1$var$CONTEXT_2D = "2d", $1886c67fae9befe1$var$DASH = "-", $1886c67fae9befe1$var$LEFT = "left", $1886c67fae9befe1$var$TEXT = "text", $1886c67fae9befe1$var$TEXT_UPPER = "Text", $1886c67fae9befe1$var$TOP = "top", $1886c67fae9befe1$var$BOTTOM = "bottom", $1886c67fae9befe1$var$MIDDLE = "middle", $1886c67fae9befe1$var$NORMAL = "normal", $1886c67fae9befe1$var$PX_SPACE = "px ", $1886c67fae9befe1$var$SPACE = " ", $1886c67fae9befe1$var$RIGHT = "right", $1886c67fae9befe1$var$WORD = "word", $1886c67fae9befe1$var$CHAR = "char", $1886c67fae9befe1$var$NONE = "none", $1886c67fae9befe1$var$ELLIPSIS = "\u2026", $1886c67fae9befe1$var$ATTR_CHANGE_LIST = [
    "fontFamily",
    "fontSize",
    "fontStyle",
    "fontVariant",
    "padding",
    "align",
    "verticalAlign",
    "lineHeight",
    "text",
    "width",
    "height",
    "wrap",
    "ellipsis",
    "letterSpacing"
], $1886c67fae9befe1$var$attrChangeListLen = $1886c67fae9befe1$var$ATTR_CHANGE_LIST.length;
function $1886c67fae9befe1$var$normalizeFontFamily(fontFamily) {
    return fontFamily.split(",").map((family)=>{
        family = family.trim();
        const hasSpace = family.indexOf(" ") >= 0;
        const hasQuotes = family.indexOf('"') >= 0 || family.indexOf("'") >= 0;
        if (hasSpace && !hasQuotes) family = `"${family}"`;
        return family;
    }).join(", ");
}
var $1886c67fae9befe1$var$dummyContext;
function $1886c67fae9befe1$var$getDummyContext() {
    if ($1886c67fae9befe1$var$dummyContext) return $1886c67fae9befe1$var$dummyContext;
    $1886c67fae9befe1$var$dummyContext = (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).createCanvasElement().getContext($1886c67fae9befe1$var$CONTEXT_2D);
    return $1886c67fae9befe1$var$dummyContext;
}
function $1886c67fae9befe1$var$_fillFunc(context) {
    context.fillText(this._partialText, this._partialTextX, this._partialTextY);
}
function $1886c67fae9befe1$var$_strokeFunc(context) {
    context.strokeText(this._partialText, this._partialTextX, this._partialTextY);
}
function $1886c67fae9befe1$var$checkDefaultFill(config) {
    config = config || {};
    if (!config.fillLinearGradientColorStops && !config.fillRadialGradientColorStops && !config.fillPatternImage) config.fill = config.fill || "black";
    return config;
}
class $1886c67fae9befe1$export$5f1af8db9871e1d6 extends (0, $3bfe60cc136fb197$export$6428a7f2611ef1fa) {
    constructor(config){
        super($1886c67fae9befe1$var$checkDefaultFill(config));
        this._partialTextX = 0;
        this._partialTextY = 0;
        for(var n = 0; n < $1886c67fae9befe1$var$attrChangeListLen; n++)this.on($1886c67fae9befe1$var$ATTR_CHANGE_LIST[n] + $1886c67fae9befe1$var$CHANGE_KONVA, this._setTextData);
        this._setTextData();
    }
    _sceneFunc(context) {
        var textArr = this.textArr, textArrLen = textArr.length;
        if (!this.text()) return;
        var padding = this.padding(), fontSize = this.fontSize(), lineHeightPx = this.lineHeight() * fontSize, verticalAlign = this.verticalAlign(), alignY = 0, align = this.align(), totalWidth = this.getWidth(), letterSpacing = this.letterSpacing(), fill = this.fill(), textDecoration = this.textDecoration(), shouldUnderline = textDecoration.indexOf("underline") !== -1, shouldLineThrough = textDecoration.indexOf("line-through") !== -1, n;
        var translateY = 0;
        var translateY = lineHeightPx / 2;
        var lineTranslateX = 0;
        var lineTranslateY = 0;
        context.setAttr("font", this._getContextFont());
        context.setAttr("textBaseline", $1886c67fae9befe1$var$MIDDLE);
        context.setAttr("textAlign", $1886c67fae9befe1$var$LEFT);
        if (verticalAlign === $1886c67fae9befe1$var$MIDDLE) alignY = (this.getHeight() - textArrLen * lineHeightPx - padding * 2) / 2;
        else if (verticalAlign === $1886c67fae9befe1$var$BOTTOM) alignY = this.getHeight() - textArrLen * lineHeightPx - padding * 2;
        context.translate(padding, alignY + padding);
        for(n = 0; n < textArrLen; n++){
            var lineTranslateX = 0;
            var lineTranslateY = 0;
            var obj = textArr[n], text = obj.text, width = obj.width, lastLine = obj.lastInParagraph, spacesNumber, oneWord, lineWidth;
            context.save();
            if (align === $1886c67fae9befe1$var$RIGHT) lineTranslateX += totalWidth - width - padding * 2;
            else if (align === $1886c67fae9befe1$var$CENTER) lineTranslateX += (totalWidth - width - padding * 2) / 2;
            if (shouldUnderline) {
                context.save();
                context.beginPath();
                context.moveTo(lineTranslateX, translateY + lineTranslateY + Math.round(fontSize / 2));
                spacesNumber = text.split(" ").length - 1;
                oneWord = spacesNumber === 0;
                lineWidth = align === $1886c67fae9befe1$var$JUSTIFY && !lastLine ? totalWidth - padding * 2 : width;
                context.lineTo(lineTranslateX + Math.round(lineWidth), translateY + lineTranslateY + Math.round(fontSize / 2));
                context.lineWidth = fontSize / 15;
                const gradient = this._getLinearGradient();
                context.strokeStyle = gradient || fill;
                context.stroke();
                context.restore();
            }
            if (shouldLineThrough) {
                context.save();
                context.beginPath();
                context.moveTo(lineTranslateX, translateY + lineTranslateY);
                spacesNumber = text.split(" ").length - 1;
                oneWord = spacesNumber === 0;
                lineWidth = align === $1886c67fae9befe1$var$JUSTIFY && lastLine && !oneWord ? totalWidth - padding * 2 : width;
                context.lineTo(lineTranslateX + Math.round(lineWidth), translateY + lineTranslateY);
                context.lineWidth = fontSize / 15;
                const gradient = this._getLinearGradient();
                context.strokeStyle = gradient || fill;
                context.stroke();
                context.restore();
            }
            if (letterSpacing !== 0 || align === $1886c67fae9befe1$var$JUSTIFY) {
                spacesNumber = text.split(" ").length - 1;
                var array = $1886c67fae9befe1$export$b9ca061da17f2d30(text);
                for(var li = 0; li < array.length; li++){
                    var letter = array[li];
                    if (letter === " " && !lastLine && align === $1886c67fae9befe1$var$JUSTIFY) lineTranslateX += (totalWidth - padding * 2 - width) / spacesNumber;
                    this._partialTextX = lineTranslateX;
                    this._partialTextY = translateY + lineTranslateY;
                    this._partialText = letter;
                    context.fillStrokeShape(this);
                    lineTranslateX += this.measureSize(letter).width + letterSpacing;
                }
            } else {
                this._partialTextX = lineTranslateX;
                this._partialTextY = translateY + lineTranslateY;
                this._partialText = text;
                context.fillStrokeShape(this);
            }
            context.restore();
            if (textArrLen > 1) translateY += lineHeightPx;
        }
    }
    _hitFunc(context) {
        var width = this.getWidth(), height = this.getHeight();
        context.beginPath();
        context.rect(0, 0, width, height);
        context.closePath();
        context.fillStrokeShape(this);
    }
    setText(text) {
        var str = (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd)._isString(text) ? text : text === null || text === undefined ? "" : text + "";
        this._setAttr($1886c67fae9befe1$var$TEXT, str);
        return this;
    }
    getWidth() {
        var isAuto = this.attrs.width === $1886c67fae9befe1$var$AUTO || this.attrs.width === undefined;
        return isAuto ? this.getTextWidth() + this.padding() * 2 : this.attrs.width;
    }
    getHeight() {
        var isAuto = this.attrs.height === $1886c67fae9befe1$var$AUTO || this.attrs.height === undefined;
        return isAuto ? this.fontSize() * this.textArr.length * this.lineHeight() + this.padding() * 2 : this.attrs.height;
    }
    getTextWidth() {
        return this.textWidth;
    }
    getTextHeight() {
        (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).warn("text.getTextHeight() method is deprecated. Use text.height() - for full height and text.fontSize() - for one line height.");
        return this.textHeight;
    }
    measureSize(text) {
        var _context = $1886c67fae9befe1$var$getDummyContext(), fontSize = this.fontSize(), metrics;
        _context.save();
        _context.font = this._getContextFont();
        metrics = _context.measureText(text);
        _context.restore();
        return {
            width: metrics.width,
            height: fontSize
        };
    }
    _getContextFont() {
        return this.fontStyle() + $1886c67fae9befe1$var$SPACE + this.fontVariant() + $1886c67fae9befe1$var$SPACE + (this.fontSize() + $1886c67fae9befe1$var$PX_SPACE) + $1886c67fae9befe1$var$normalizeFontFamily(this.fontFamily());
    }
    _addTextLine(line) {
        const align = this.align();
        if (align === $1886c67fae9befe1$var$JUSTIFY) line = line.trim();
        var width = this._getTextWidth(line);
        return this.textArr.push({
            text: line,
            width: width,
            lastInParagraph: false
        });
    }
    _getTextWidth(text) {
        var letterSpacing = this.letterSpacing();
        var length = text.length;
        return $1886c67fae9befe1$var$getDummyContext().measureText(text).width + (length ? letterSpacing * (length - 1) : 0);
    }
    _setTextData() {
        var lines = this.text().split("\n"), fontSize = +this.fontSize(), textWidth = 0, lineHeightPx = this.lineHeight() * fontSize, width = this.attrs.width, height = this.attrs.height, fixedWidth = width !== $1886c67fae9befe1$var$AUTO && width !== undefined, fixedHeight = height !== $1886c67fae9befe1$var$AUTO && height !== undefined, padding = this.padding(), maxWidth = width - padding * 2, maxHeightPx = height - padding * 2, currentHeightPx = 0, wrap = this.wrap(), shouldWrap = wrap !== $1886c67fae9befe1$var$NONE, wrapAtWord = wrap !== $1886c67fae9befe1$var$CHAR && shouldWrap, shouldAddEllipsis = this.ellipsis();
        this.textArr = [];
        $1886c67fae9befe1$var$getDummyContext().font = this._getContextFont();
        var additionalWidth = shouldAddEllipsis ? this._getTextWidth($1886c67fae9befe1$var$ELLIPSIS) : 0;
        for(var i = 0, max = lines.length; i < max; ++i){
            var line = lines[i];
            var lineWidth = this._getTextWidth(line);
            if (fixedWidth && lineWidth > maxWidth) while(line.length > 0){
                var low = 0, high = line.length, match = "", matchWidth = 0;
                while(low < high){
                    var mid = low + high >>> 1, substr = line.slice(0, mid + 1), substrWidth = this._getTextWidth(substr) + additionalWidth;
                    if (substrWidth <= maxWidth) {
                        low = mid + 1;
                        match = substr;
                        matchWidth = substrWidth;
                    } else high = mid;
                }
                if (match) {
                    if (wrapAtWord) {
                        var wrapIndex;
                        var nextChar = line[match.length];
                        var nextIsSpaceOrDash = nextChar === $1886c67fae9befe1$var$SPACE || nextChar === $1886c67fae9befe1$var$DASH;
                        if (nextIsSpaceOrDash && matchWidth <= maxWidth) wrapIndex = match.length;
                        else wrapIndex = Math.max(match.lastIndexOf($1886c67fae9befe1$var$SPACE), match.lastIndexOf($1886c67fae9befe1$var$DASH)) + 1;
                        if (wrapIndex > 0) {
                            low = wrapIndex;
                            match = match.slice(0, low);
                            matchWidth = this._getTextWidth(match);
                        }
                    }
                    match = match.trimRight();
                    this._addTextLine(match);
                    textWidth = Math.max(textWidth, matchWidth);
                    currentHeightPx += lineHeightPx;
                    var shouldHandleEllipsis = this._shouldHandleEllipsis(currentHeightPx);
                    if (shouldHandleEllipsis) {
                        this._tryToAddEllipsisToLastLine();
                        break;
                    }
                    line = line.slice(low);
                    line = line.trimLeft();
                    if (line.length > 0) {
                        lineWidth = this._getTextWidth(line);
                        if (lineWidth <= maxWidth) {
                            this._addTextLine(line);
                            currentHeightPx += lineHeightPx;
                            textWidth = Math.max(textWidth, lineWidth);
                            break;
                        }
                    }
                } else break;
            }
            else {
                this._addTextLine(line);
                currentHeightPx += lineHeightPx;
                textWidth = Math.max(textWidth, lineWidth);
                if (this._shouldHandleEllipsis(currentHeightPx) && i < max - 1) this._tryToAddEllipsisToLastLine();
            }
            if (this.textArr[this.textArr.length - 1]) this.textArr[this.textArr.length - 1].lastInParagraph = true;
            if (fixedHeight && currentHeightPx + lineHeightPx > maxHeightPx) break;
        }
        this.textHeight = fontSize;
        this.textWidth = textWidth;
    }
    _shouldHandleEllipsis(currentHeightPx) {
        var fontSize = +this.fontSize(), lineHeightPx = this.lineHeight() * fontSize, height = this.attrs.height, fixedHeight = height !== $1886c67fae9befe1$var$AUTO && height !== undefined, padding = this.padding(), maxHeightPx = height - padding * 2, wrap = this.wrap(), shouldWrap = wrap !== $1886c67fae9befe1$var$NONE;
        return !shouldWrap || fixedHeight && currentHeightPx + lineHeightPx > maxHeightPx;
    }
    _tryToAddEllipsisToLastLine() {
        var width = this.attrs.width, fixedWidth = width !== $1886c67fae9befe1$var$AUTO && width !== undefined, padding = this.padding(), maxWidth = width - padding * 2, shouldAddEllipsis = this.ellipsis();
        var lastLine = this.textArr[this.textArr.length - 1];
        if (!lastLine || !shouldAddEllipsis) return;
        if (fixedWidth) {
            var haveSpace = this._getTextWidth(lastLine.text + $1886c67fae9befe1$var$ELLIPSIS) < maxWidth;
            if (!haveSpace) lastLine.text = lastLine.text.slice(0, lastLine.text.length - 3);
        }
        this.textArr.splice(this.textArr.length - 1, 1);
        this._addTextLine(lastLine.text + $1886c67fae9befe1$var$ELLIPSIS);
    }
    getStrokeScaleEnabled() {
        return true;
    }
}
$1886c67fae9befe1$export$5f1af8db9871e1d6.prototype._fillFunc = $1886c67fae9befe1$var$_fillFunc;
$1886c67fae9befe1$export$5f1af8db9871e1d6.prototype._strokeFunc = $1886c67fae9befe1$var$_strokeFunc;
$1886c67fae9befe1$export$5f1af8db9871e1d6.prototype.className = $1886c67fae9befe1$var$TEXT_UPPER;
$1886c67fae9befe1$export$5f1af8db9871e1d6.prototype._attrsAffectingSize = [
    "text",
    "fontSize",
    "padding",
    "wrap",
    "lineHeight",
    "letterSpacing"
];
(0, $f1cce3c2a91bf0cf$export$f7a70d87a5e829eb)($1886c67fae9befe1$export$5f1af8db9871e1d6);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).overWriteSetter($1886c67fae9befe1$export$5f1af8db9871e1d6, "width", (0, $8d9e6be936d29d8a$export$3b7df2720ef33404)());
(0, $e1d1e3911fd31488$export$8354032f3852ec50).overWriteSetter($1886c67fae9befe1$export$5f1af8db9871e1d6, "height", (0, $8d9e6be936d29d8a$export$3b7df2720ef33404)());
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($1886c67fae9befe1$export$5f1af8db9871e1d6, "fontFamily", "Arial");
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($1886c67fae9befe1$export$5f1af8db9871e1d6, "fontSize", 12, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)());
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($1886c67fae9befe1$export$5f1af8db9871e1d6, "fontStyle", $1886c67fae9befe1$var$NORMAL);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($1886c67fae9befe1$export$5f1af8db9871e1d6, "fontVariant", $1886c67fae9befe1$var$NORMAL);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($1886c67fae9befe1$export$5f1af8db9871e1d6, "padding", 0, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)());
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($1886c67fae9befe1$export$5f1af8db9871e1d6, "align", $1886c67fae9befe1$var$LEFT);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($1886c67fae9befe1$export$5f1af8db9871e1d6, "verticalAlign", $1886c67fae9befe1$var$TOP);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($1886c67fae9befe1$export$5f1af8db9871e1d6, "lineHeight", 1, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)());
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($1886c67fae9befe1$export$5f1af8db9871e1d6, "wrap", $1886c67fae9befe1$var$WORD);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($1886c67fae9befe1$export$5f1af8db9871e1d6, "ellipsis", false, (0, $8d9e6be936d29d8a$export$147fc8b6cd20fda1)());
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($1886c67fae9befe1$export$5f1af8db9871e1d6, "letterSpacing", 0, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)());
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($1886c67fae9befe1$export$5f1af8db9871e1d6, "text", "", (0, $8d9e6be936d29d8a$export$5837c5b6cc5b4d63)());
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($1886c67fae9befe1$export$5f1af8db9871e1d6, "textDecoration", "");









var $282e9c4915b34bd1$var$EMPTY_STRING = "", $282e9c4915b34bd1$var$NORMAL = "normal";
function $282e9c4915b34bd1$var$_fillFunc(context) {
    context.fillText(this.partialText, 0, 0);
}
function $282e9c4915b34bd1$var$_strokeFunc(context) {
    context.strokeText(this.partialText, 0, 0);
}
class $282e9c4915b34bd1$export$f7e34a95cc06fac7 extends (0, $3bfe60cc136fb197$export$6428a7f2611ef1fa) {
    constructor(config){
        super(config);
        this.dummyCanvas = (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).createCanvasElement();
        this.dataArray = [];
        this.dataArray = (0, $78ea6556da6c35e2$export$4b2950bdac9b6ee9).parsePathData(this.attrs.data);
        this.on("dataChange.konva", function() {
            this.dataArray = (0, $78ea6556da6c35e2$export$4b2950bdac9b6ee9).parsePathData(this.attrs.data);
            this._setTextData();
        });
        this.on("textChange.konva alignChange.konva letterSpacingChange.konva kerningFuncChange.konva fontSizeChange.konva fontFamilyChange.konva", this._setTextData);
        this._setTextData();
    }
    _sceneFunc(context) {
        context.setAttr("font", this._getContextFont());
        context.setAttr("textBaseline", this.textBaseline());
        context.setAttr("textAlign", "left");
        context.save();
        var textDecoration = this.textDecoration();
        var fill = this.fill();
        var fontSize = this.fontSize();
        var glyphInfo = this.glyphInfo;
        if (textDecoration === "underline") context.beginPath();
        for(var i = 0; i < glyphInfo.length; i++){
            context.save();
            var p0 = glyphInfo[i].p0;
            context.translate(p0.x, p0.y);
            context.rotate(glyphInfo[i].rotation);
            this.partialText = glyphInfo[i].text;
            context.fillStrokeShape(this);
            if (textDecoration === "underline") {
                if (i === 0) context.moveTo(0, fontSize / 2 + 1);
                context.lineTo(fontSize, fontSize / 2 + 1);
            }
            context.restore();
        }
        if (textDecoration === "underline") {
            context.strokeStyle = fill;
            context.lineWidth = fontSize / 20;
            context.stroke();
        }
        context.restore();
    }
    _hitFunc(context) {
        context.beginPath();
        var glyphInfo = this.glyphInfo;
        if (glyphInfo.length >= 1) {
            var p0 = glyphInfo[0].p0;
            context.moveTo(p0.x, p0.y);
        }
        for(var i = 0; i < glyphInfo.length; i++){
            var p1 = glyphInfo[i].p1;
            context.lineTo(p1.x, p1.y);
        }
        context.setAttr("lineWidth", this.fontSize());
        context.setAttr("strokeStyle", this.colorKey);
        context.stroke();
    }
    getTextWidth() {
        return this.textWidth;
    }
    getTextHeight() {
        (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).warn("text.getTextHeight() method is deprecated. Use text.height() - for full height and text.fontSize() - for one line height.");
        return this.textHeight;
    }
    setText(text) {
        return (0, $1886c67fae9befe1$export$5f1af8db9871e1d6).prototype.setText.call(this, text);
    }
    _getContextFont() {
        return (0, $1886c67fae9befe1$export$5f1af8db9871e1d6).prototype._getContextFont.call(this);
    }
    _getTextSize(text) {
        var dummyCanvas = this.dummyCanvas;
        var _context = dummyCanvas.getContext("2d");
        _context.save();
        _context.font = this._getContextFont();
        var metrics = _context.measureText(text);
        _context.restore();
        return {
            width: metrics.width,
            height: parseInt(this.attrs.fontSize, 10)
        };
    }
    _setTextData() {
        var that = this;
        var size = this._getTextSize(this.attrs.text);
        var letterSpacing = this.letterSpacing();
        var align = this.align();
        var kerningFunc = this.kerningFunc();
        this.textWidth = size.width;
        this.textHeight = size.height;
        var textFullWidth = Math.max(this.textWidth + ((this.attrs.text || "").length - 1) * letterSpacing, 0);
        this.glyphInfo = [];
        var fullPathWidth = 0;
        for(var l = 0; l < that.dataArray.length; l++)if (that.dataArray[l].pathLength > 0) fullPathWidth += that.dataArray[l].pathLength;
        var offset = 0;
        if (align === "center") offset = Math.max(0, fullPathWidth / 2 - textFullWidth / 2);
        if (align === "right") offset = Math.max(0, fullPathWidth - textFullWidth);
        var charArr = (0, $1886c67fae9befe1$export$b9ca061da17f2d30)(this.text());
        var spacesNumber = this.text().split(" ").length - 1;
        var p0, p1, pathCmd;
        var pIndex = -1;
        var currentT = 0;
        var getNextPathSegment = function() {
            currentT = 0;
            var pathData = that.dataArray;
            for(var j = pIndex + 1; j < pathData.length; j++){
                if (pathData[j].pathLength > 0) {
                    pIndex = j;
                    return pathData[j];
                } else if (pathData[j].command === "M") p0 = {
                    x: pathData[j].points[0],
                    y: pathData[j].points[1]
                };
            }
            return {};
        };
        var findSegmentToFitCharacter = function(c) {
            var glyphWidth = that._getTextSize(c).width + letterSpacing;
            if (c === " " && align === "justify") glyphWidth += (fullPathWidth - textFullWidth) / spacesNumber;
            var currLen = 0;
            var attempts = 0;
            p1 = undefined;
            while(Math.abs(glyphWidth - currLen) / glyphWidth > 0.01 && attempts < 20){
                attempts++;
                var cumulativePathLength = currLen;
                while(pathCmd === undefined){
                    pathCmd = getNextPathSegment();
                    if (pathCmd && cumulativePathLength + pathCmd.pathLength < glyphWidth) {
                        cumulativePathLength += pathCmd.pathLength;
                        pathCmd = undefined;
                    }
                }
                if (Object.keys(pathCmd).length === 0 || p0 === undefined) return undefined;
                var needNewSegment = false;
                switch(pathCmd.command){
                    case "L":
                        if ((0, $78ea6556da6c35e2$export$4b2950bdac9b6ee9).getLineLength(p0.x, p0.y, pathCmd.points[0], pathCmd.points[1]) > glyphWidth) p1 = (0, $78ea6556da6c35e2$export$4b2950bdac9b6ee9).getPointOnLine(glyphWidth, p0.x, p0.y, pathCmd.points[0], pathCmd.points[1], p0.x, p0.y);
                        else pathCmd = undefined;
                        break;
                    case "A":
                        var start = pathCmd.points[4];
                        var dTheta = pathCmd.points[5];
                        var end = pathCmd.points[4] + dTheta;
                        if (currentT === 0) currentT = start + 0.00000001;
                        else if (glyphWidth > currLen) currentT += Math.PI / 180.0 * dTheta / Math.abs(dTheta);
                        else currentT -= Math.PI / 360.0 * dTheta / Math.abs(dTheta);
                        if (dTheta < 0 && currentT < end || dTheta >= 0 && currentT > end) {
                            currentT = end;
                            needNewSegment = true;
                        }
                        p1 = (0, $78ea6556da6c35e2$export$4b2950bdac9b6ee9).getPointOnEllipticalArc(pathCmd.points[0], pathCmd.points[1], pathCmd.points[2], pathCmd.points[3], currentT, pathCmd.points[6]);
                        break;
                    case "C":
                        if (currentT === 0) {
                            if (glyphWidth > pathCmd.pathLength) currentT = 0.00000001;
                            else currentT = glyphWidth / pathCmd.pathLength;
                        } else if (glyphWidth > currLen) currentT += (glyphWidth - currLen) / pathCmd.pathLength / 2;
                        else currentT = Math.max(currentT - (currLen - glyphWidth) / pathCmd.pathLength / 2, 0);
                        if (currentT > 1.0) {
                            currentT = 1.0;
                            needNewSegment = true;
                        }
                        p1 = (0, $78ea6556da6c35e2$export$4b2950bdac9b6ee9).getPointOnCubicBezier(currentT, pathCmd.start.x, pathCmd.start.y, pathCmd.points[0], pathCmd.points[1], pathCmd.points[2], pathCmd.points[3], pathCmd.points[4], pathCmd.points[5]);
                        break;
                    case "Q":
                        if (currentT === 0) currentT = glyphWidth / pathCmd.pathLength;
                        else if (glyphWidth > currLen) currentT += (glyphWidth - currLen) / pathCmd.pathLength;
                        else currentT -= (currLen - glyphWidth) / pathCmd.pathLength;
                        if (currentT > 1.0) {
                            currentT = 1.0;
                            needNewSegment = true;
                        }
                        p1 = (0, $78ea6556da6c35e2$export$4b2950bdac9b6ee9).getPointOnQuadraticBezier(currentT, pathCmd.start.x, pathCmd.start.y, pathCmd.points[0], pathCmd.points[1], pathCmd.points[2], pathCmd.points[3]);
                        break;
                }
                if (p1 !== undefined) currLen = (0, $78ea6556da6c35e2$export$4b2950bdac9b6ee9).getLineLength(p0.x, p0.y, p1.x, p1.y);
                if (needNewSegment) {
                    needNewSegment = false;
                    pathCmd = undefined;
                }
            }
        };
        var testChar = "C";
        var glyphWidth = that._getTextSize(testChar).width + letterSpacing;
        var lettersInOffset = offset / glyphWidth - 1;
        for(var k = 0; k < lettersInOffset; k++){
            findSegmentToFitCharacter(testChar);
            if (p0 === undefined || p1 === undefined) break;
            p0 = p1;
        }
        for(var i = 0; i < charArr.length; i++){
            findSegmentToFitCharacter(charArr[i]);
            if (p0 === undefined || p1 === undefined) break;
            var width = (0, $78ea6556da6c35e2$export$4b2950bdac9b6ee9).getLineLength(p0.x, p0.y, p1.x, p1.y);
            var kern = 0;
            if (kerningFunc) try {
                kern = kerningFunc(charArr[i - 1], charArr[i]) * this.fontSize();
            } catch (e) {
                kern = 0;
            }
            p0.x += kern;
            p1.x += kern;
            this.textWidth += kern;
            var midpoint = (0, $78ea6556da6c35e2$export$4b2950bdac9b6ee9).getPointOnLine(kern + width / 2.0, p0.x, p0.y, p1.x, p1.y);
            var rotation = Math.atan2(p1.y - p0.y, p1.x - p0.x);
            this.glyphInfo.push({
                transposeX: midpoint.x,
                transposeY: midpoint.y,
                text: charArr[i],
                rotation: rotation,
                p0: p0,
                p1: p1
            });
            p0 = p1;
        }
    }
    getSelfRect() {
        if (!this.glyphInfo.length) return {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        };
        var points = [];
        this.glyphInfo.forEach(function(info) {
            points.push(info.p0.x);
            points.push(info.p0.y);
            points.push(info.p1.x);
            points.push(info.p1.y);
        });
        var minX = points[0] || 0;
        var maxX = points[0] || 0;
        var minY = points[1] || 0;
        var maxY = points[1] || 0;
        var x, y;
        for(var i = 0; i < points.length / 2; i++){
            x = points[i * 2];
            y = points[i * 2 + 1];
            minX = Math.min(minX, x);
            maxX = Math.max(maxX, x);
            minY = Math.min(minY, y);
            maxY = Math.max(maxY, y);
        }
        var fontSize = this.fontSize();
        return {
            x: minX - fontSize / 2,
            y: minY - fontSize / 2,
            width: maxX - minX + fontSize,
            height: maxY - minY + fontSize
        };
    }
    destroy() {
        (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).releaseCanvas(this.dummyCanvas);
        return super.destroy();
    }
}
$282e9c4915b34bd1$export$f7e34a95cc06fac7.prototype._fillFunc = $282e9c4915b34bd1$var$_fillFunc;
$282e9c4915b34bd1$export$f7e34a95cc06fac7.prototype._strokeFunc = $282e9c4915b34bd1$var$_strokeFunc;
$282e9c4915b34bd1$export$f7e34a95cc06fac7.prototype._fillFuncHit = $282e9c4915b34bd1$var$_fillFunc;
$282e9c4915b34bd1$export$f7e34a95cc06fac7.prototype._strokeFuncHit = $282e9c4915b34bd1$var$_strokeFunc;
$282e9c4915b34bd1$export$f7e34a95cc06fac7.prototype.className = "TextPath";
$282e9c4915b34bd1$export$f7e34a95cc06fac7.prototype._attrsAffectingSize = [
    "text",
    "fontSize",
    "data"
];
(0, $f1cce3c2a91bf0cf$export$f7a70d87a5e829eb)($282e9c4915b34bd1$export$f7e34a95cc06fac7);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($282e9c4915b34bd1$export$f7e34a95cc06fac7, "data");
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($282e9c4915b34bd1$export$f7e34a95cc06fac7, "fontFamily", "Arial");
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($282e9c4915b34bd1$export$f7e34a95cc06fac7, "fontSize", 12, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)());
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($282e9c4915b34bd1$export$f7e34a95cc06fac7, "fontStyle", $282e9c4915b34bd1$var$NORMAL);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($282e9c4915b34bd1$export$f7e34a95cc06fac7, "align", "left");
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($282e9c4915b34bd1$export$f7e34a95cc06fac7, "letterSpacing", 0, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)());
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($282e9c4915b34bd1$export$f7e34a95cc06fac7, "textBaseline", "middle");
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($282e9c4915b34bd1$export$f7e34a95cc06fac7, "fontVariant", $282e9c4915b34bd1$var$NORMAL);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($282e9c4915b34bd1$export$f7e34a95cc06fac7, "text", $282e9c4915b34bd1$var$EMPTY_STRING);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($282e9c4915b34bd1$export$f7e34a95cc06fac7, "textDecoration", null);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($282e9c4915b34bd1$export$f7e34a95cc06fac7, "kerningFunc", null);










var $c3dfaa80c0c40989$var$EVENTS_NAME = "tr-konva";
var $c3dfaa80c0c40989$var$ATTR_CHANGE_LIST = [
    "resizeEnabledChange",
    "rotateAnchorOffsetChange",
    "rotateEnabledChange",
    "enabledAnchorsChange",
    "anchorSizeChange",
    "borderEnabledChange",
    "borderStrokeChange",
    "borderStrokeWidthChange",
    "borderDashChange",
    "anchorStrokeChange",
    "anchorStrokeWidthChange",
    "anchorFillChange",
    "anchorCornerRadiusChange",
    "ignoreStrokeChange"
].map((e)=>e + `.${$c3dfaa80c0c40989$var$EVENTS_NAME}`).join(" ");
var $c3dfaa80c0c40989$var$NODES_RECT = "nodesRect";
var $c3dfaa80c0c40989$var$TRANSFORM_CHANGE_STR = [
    "widthChange",
    "heightChange",
    "scaleXChange",
    "scaleYChange",
    "skewXChange",
    "skewYChange",
    "rotationChange",
    "offsetXChange",
    "offsetYChange",
    "transformsEnabledChange",
    "strokeWidthChange"
];
var $c3dfaa80c0c40989$var$ANGLES = {
    "top-left": -45,
    "top-center": 0,
    "top-right": 45,
    "middle-right": -90,
    "middle-left": 90,
    "bottom-left": -135,
    "bottom-center": 180,
    "bottom-right": 135
};
const $c3dfaa80c0c40989$var$TOUCH_DEVICE = "ontouchstart" in (0, $f1cce3c2a91bf0cf$export$b9f99057a3c7692)._global;
function $c3dfaa80c0c40989$var$getCursor(anchorName, rad) {
    if (anchorName === "rotater") return "crosshair";
    rad += (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).degToRad($c3dfaa80c0c40989$var$ANGLES[anchorName] || 0);
    var angle = ((0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).radToDeg(rad) % 360 + 360) % 360;
    if ((0, $4d54b3632f7367db$export$f8f26dd395d7e1bd)._inRange(angle, 337.5, 360) || (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd)._inRange(angle, 0, 22.5)) return "ns-resize";
    else if ((0, $4d54b3632f7367db$export$f8f26dd395d7e1bd)._inRange(angle, 22.5, 67.5)) return "nesw-resize";
    else if ((0, $4d54b3632f7367db$export$f8f26dd395d7e1bd)._inRange(angle, 67.5, 112.5)) return "ew-resize";
    else if ((0, $4d54b3632f7367db$export$f8f26dd395d7e1bd)._inRange(angle, 112.5, 157.5)) return "nwse-resize";
    else if ((0, $4d54b3632f7367db$export$f8f26dd395d7e1bd)._inRange(angle, 157.5, 202.5)) return "ns-resize";
    else if ((0, $4d54b3632f7367db$export$f8f26dd395d7e1bd)._inRange(angle, 202.5, 247.5)) return "nesw-resize";
    else if ((0, $4d54b3632f7367db$export$f8f26dd395d7e1bd)._inRange(angle, 247.5, 292.5)) return "ew-resize";
    else if ((0, $4d54b3632f7367db$export$f8f26dd395d7e1bd)._inRange(angle, 292.5, 337.5)) return "nwse-resize";
    else {
        (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).error("Transformer has unknown angle for cursor detection: " + angle);
        return "pointer";
    }
}
var $c3dfaa80c0c40989$var$ANCHORS_NAMES = [
    "top-left",
    "top-center",
    "top-right",
    "middle-right",
    "middle-left",
    "bottom-left",
    "bottom-center",
    "bottom-right"
];
var $c3dfaa80c0c40989$var$MAX_SAFE_INTEGER = 100000000;
function $c3dfaa80c0c40989$var$getCenter(shape) {
    return {
        x: shape.x + shape.width / 2 * Math.cos(shape.rotation) + shape.height / 2 * Math.sin(-shape.rotation),
        y: shape.y + shape.height / 2 * Math.cos(shape.rotation) + shape.width / 2 * Math.sin(shape.rotation)
    };
}
function $c3dfaa80c0c40989$var$rotateAroundPoint(shape, angleRad, point) {
    const x = point.x + (shape.x - point.x) * Math.cos(angleRad) - (shape.y - point.y) * Math.sin(angleRad);
    const y = point.y + (shape.x - point.x) * Math.sin(angleRad) + (shape.y - point.y) * Math.cos(angleRad);
    return Object.assign(Object.assign({}, shape), {
        rotation: shape.rotation + angleRad,
        x: x,
        y: y
    });
}
function $c3dfaa80c0c40989$var$rotateAroundCenter(shape, deltaRad) {
    const center = $c3dfaa80c0c40989$var$getCenter(shape);
    return $c3dfaa80c0c40989$var$rotateAroundPoint(shape, deltaRad, center);
}
function $c3dfaa80c0c40989$var$getSnap(snaps, newRotationRad, tol) {
    let snapped = newRotationRad;
    for(let i = 0; i < snaps.length; i++){
        const angle = (0, $f1cce3c2a91bf0cf$export$b9f99057a3c7692).getAngle(snaps[i]);
        const absDiff = Math.abs(angle - newRotationRad) % (Math.PI * 2);
        const dif = Math.min(absDiff, Math.PI * 2 - absDiff);
        if (dif < tol) snapped = angle;
    }
    return snapped;
}
class $c3dfaa80c0c40989$export$f993aef960936087 extends (0, $5147287ae7dd04c0$export$eb2fcfdbd7ba97d4) {
    constructor(config){
        super(config);
        this._transforming = false;
        this._createElements();
        this._handleMouseMove = this._handleMouseMove.bind(this);
        this._handleMouseUp = this._handleMouseUp.bind(this);
        this.update = this.update.bind(this);
        this.on($c3dfaa80c0c40989$var$ATTR_CHANGE_LIST, this.update);
        if (this.getNode()) this.update();
    }
    attachTo(node) {
        this.setNode(node);
        return this;
    }
    setNode(node) {
        (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).warn("tr.setNode(shape), tr.node(shape) and tr.attachTo(shape) methods are deprecated. Please use tr.nodes(nodesArray) instead.");
        return this.setNodes([
            node
        ]);
    }
    getNode() {
        return this._nodes && this._nodes[0];
    }
    _getEventNamespace() {
        return $c3dfaa80c0c40989$var$EVENTS_NAME + this._id;
    }
    setNodes(nodes = []) {
        if (this._nodes && this._nodes.length) this.detach();
        const filteredNodes = nodes.filter((node)=>{
            if (node.isAncestorOf(this)) {
                (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).error("Konva.Transformer cannot be an a child of the node you are trying to attach");
                return false;
            }
            return true;
        });
        this._nodes = nodes = filteredNodes;
        if (nodes.length === 1 && this.useSingleNodeRotation()) this.rotation(nodes[0].getAbsoluteRotation());
        else this.rotation(0);
        this._nodes.forEach((node)=>{
            const onChange = ()=>{
                if (this.nodes().length === 1 && this.useSingleNodeRotation()) this.rotation(this.nodes()[0].getAbsoluteRotation());
                this._resetTransformCache();
                if (!this._transforming && !this.isDragging()) this.update();
            };
            const additionalEvents = node._attrsAffectingSize.map((prop)=>prop + "Change." + this._getEventNamespace()).join(" ");
            node.on(additionalEvents, onChange);
            node.on($c3dfaa80c0c40989$var$TRANSFORM_CHANGE_STR.map((e)=>e + `.${this._getEventNamespace()}`).join(" "), onChange);
            node.on(`absoluteTransformChange.${this._getEventNamespace()}`, onChange);
            this._proxyDrag(node);
        });
        this._resetTransformCache();
        var elementsCreated = !!this.findOne(".top-left");
        if (elementsCreated) this.update();
        return this;
    }
    _proxyDrag(node) {
        let lastPos;
        node.on(`dragstart.${this._getEventNamespace()}`, (e)=>{
            lastPos = node.getAbsolutePosition();
            if (!this.isDragging() && node !== this.findOne(".back")) this.startDrag(e, false);
        });
        node.on(`dragmove.${this._getEventNamespace()}`, (e)=>{
            if (!lastPos) return;
            const abs = node.getAbsolutePosition();
            const dx = abs.x - lastPos.x;
            const dy = abs.y - lastPos.y;
            this.nodes().forEach((otherNode)=>{
                if (otherNode === node) return;
                if (otherNode.isDragging()) return;
                const otherAbs = otherNode.getAbsolutePosition();
                otherNode.setAbsolutePosition({
                    x: otherAbs.x + dx,
                    y: otherAbs.y + dy
                });
                otherNode.startDrag(e);
            });
            lastPos = null;
        });
    }
    getNodes() {
        return this._nodes || [];
    }
    getActiveAnchor() {
        return this._movingAnchorName;
    }
    detach() {
        if (this._nodes) this._nodes.forEach((node)=>{
            node.off("." + this._getEventNamespace());
        });
        this._nodes = [];
        this._resetTransformCache();
    }
    _resetTransformCache() {
        this._clearCache($c3dfaa80c0c40989$var$NODES_RECT);
        this._clearCache("transform");
        this._clearSelfAndDescendantCache("absoluteTransform");
    }
    _getNodeRect() {
        return this._getCache($c3dfaa80c0c40989$var$NODES_RECT, this.__getNodeRect);
    }
    __getNodeShape(node, rot = this.rotation(), relative) {
        var rect = node.getClientRect({
            skipTransform: true,
            skipShadow: true,
            skipStroke: this.ignoreStroke()
        });
        var absScale = node.getAbsoluteScale(relative);
        var absPos = node.getAbsolutePosition(relative);
        var dx = rect.x * absScale.x - node.offsetX() * absScale.x;
        var dy = rect.y * absScale.y - node.offsetY() * absScale.y;
        const rotation = ((0, $f1cce3c2a91bf0cf$export$b9f99057a3c7692).getAngle(node.getAbsoluteRotation()) + Math.PI * 2) % (Math.PI * 2);
        const box = {
            x: absPos.x + dx * Math.cos(rotation) + dy * Math.sin(-rotation),
            y: absPos.y + dy * Math.cos(rotation) + dx * Math.sin(rotation),
            width: rect.width * absScale.x,
            height: rect.height * absScale.y,
            rotation: rotation
        };
        return $c3dfaa80c0c40989$var$rotateAroundPoint(box, -(0, $f1cce3c2a91bf0cf$export$b9f99057a3c7692).getAngle(rot), {
            x: 0,
            y: 0
        });
    }
    __getNodeRect() {
        var node = this.getNode();
        if (!node) return {
            x: -$c3dfaa80c0c40989$var$MAX_SAFE_INTEGER,
            y: -$c3dfaa80c0c40989$var$MAX_SAFE_INTEGER,
            width: 0,
            height: 0,
            rotation: 0
        };
        const totalPoints = [];
        this.nodes().map((node)=>{
            const box = node.getClientRect({
                skipTransform: true,
                skipShadow: true,
                skipStroke: this.ignoreStroke()
            });
            var points = [
                {
                    x: box.x,
                    y: box.y
                },
                {
                    x: box.x + box.width,
                    y: box.y
                },
                {
                    x: box.x + box.width,
                    y: box.y + box.height
                },
                {
                    x: box.x,
                    y: box.y + box.height
                }
            ];
            var trans = node.getAbsoluteTransform();
            points.forEach(function(point) {
                var transformed = trans.point(point);
                totalPoints.push(transformed);
            });
        });
        const tr = new (0, $4d54b3632f7367db$export$563a914cafbdc389)();
        tr.rotate(-(0, $f1cce3c2a91bf0cf$export$b9f99057a3c7692).getAngle(this.rotation()));
        var minX, minY, maxX, maxY;
        totalPoints.forEach(function(point) {
            var transformed = tr.point(point);
            if (minX === undefined) {
                minX = maxX = transformed.x;
                minY = maxY = transformed.y;
            }
            minX = Math.min(minX, transformed.x);
            minY = Math.min(minY, transformed.y);
            maxX = Math.max(maxX, transformed.x);
            maxY = Math.max(maxY, transformed.y);
        });
        tr.invert();
        const p = tr.point({
            x: minX,
            y: minY
        });
        return {
            x: p.x,
            y: p.y,
            width: maxX - minX,
            height: maxY - minY,
            rotation: (0, $f1cce3c2a91bf0cf$export$b9f99057a3c7692).getAngle(this.rotation())
        };
    }
    getX() {
        return this._getNodeRect().x;
    }
    getY() {
        return this._getNodeRect().y;
    }
    getWidth() {
        return this._getNodeRect().width;
    }
    getHeight() {
        return this._getNodeRect().height;
    }
    _createElements() {
        this._createBack();
        $c3dfaa80c0c40989$var$ANCHORS_NAMES.forEach((function(name) {
            this._createAnchor(name);
        }).bind(this));
        this._createAnchor("rotater");
    }
    _createAnchor(name) {
        var anchor = new (0, $179d0400af9c0c44$export$c79fc6492f3af13d)({
            stroke: "rgb(0, 161, 255)",
            fill: "white",
            strokeWidth: 1,
            name: name + " _anchor",
            dragDistance: 0,
            draggable: true,
            hitStrokeWidth: $c3dfaa80c0c40989$var$TOUCH_DEVICE ? 10 : "auto"
        });
        var self = this;
        anchor.on("mousedown touchstart", function(e) {
            self._handleMouseDown(e);
        });
        anchor.on("dragstart", (e)=>{
            anchor.stopDrag();
            e.cancelBubble = true;
        });
        anchor.on("dragend", (e)=>{
            e.cancelBubble = true;
        });
        anchor.on("mouseenter", ()=>{
            var rad = (0, $f1cce3c2a91bf0cf$export$b9f99057a3c7692).getAngle(this.rotation());
            var cursor = $c3dfaa80c0c40989$var$getCursor(name, rad);
            anchor.getStage().content && (anchor.getStage().content.style.cursor = cursor);
            this._cursorChange = true;
        });
        anchor.on("mouseout", ()=>{
            anchor.getStage().content && (anchor.getStage().content.style.cursor = "");
            this._cursorChange = false;
        });
        this.add(anchor);
    }
    _createBack() {
        var back = new (0, $3bfe60cc136fb197$export$6428a7f2611ef1fa)({
            name: "back",
            width: 0,
            height: 0,
            draggable: true,
            sceneFunc (ctx) {
                var tr = this.getParent();
                var padding = tr.padding();
                ctx.beginPath();
                ctx.rect(-padding, -padding, this.width() + padding * 2, this.height() + padding * 2);
                ctx.moveTo(this.width() / 2, -padding);
                if (tr.rotateEnabled()) ctx.lineTo(this.width() / 2, -tr.rotateAnchorOffset() * (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd)._sign(this.height()) - padding);
                ctx.fillStrokeShape(this);
            },
            hitFunc: (ctx, shape)=>{
                if (!this.shouldOverdrawWholeArea()) return;
                var padding = this.padding();
                ctx.beginPath();
                ctx.rect(-padding, -padding, shape.width() + padding * 2, shape.height() + padding * 2);
                ctx.fillStrokeShape(shape);
            }
        });
        this.add(back);
        this._proxyDrag(back);
        back.on("dragstart", (e)=>{
            e.cancelBubble = true;
        });
        back.on("dragmove", (e)=>{
            e.cancelBubble = true;
        });
        back.on("dragend", (e)=>{
            e.cancelBubble = true;
        });
        this.on("dragmove", (e)=>{
            this.update();
        });
    }
    _handleMouseDown(e) {
        this._movingAnchorName = e.target.name().split(" ")[0];
        var attrs = this._getNodeRect();
        var width = attrs.width;
        var height = attrs.height;
        var hypotenuse = Math.sqrt(Math.pow(width, 2) + Math.pow(height, 2));
        this.sin = Math.abs(height / hypotenuse);
        this.cos = Math.abs(width / hypotenuse);
        if (typeof window !== "undefined") {
            window.addEventListener("mousemove", this._handleMouseMove);
            window.addEventListener("touchmove", this._handleMouseMove);
            window.addEventListener("mouseup", this._handleMouseUp, true);
            window.addEventListener("touchend", this._handleMouseUp, true);
        }
        this._transforming = true;
        var ap = e.target.getAbsolutePosition();
        var pos = e.target.getStage().getPointerPosition();
        this._anchorDragOffset = {
            x: pos.x - ap.x,
            y: pos.y - ap.y
        };
        this._fire("transformstart", {
            evt: e.evt,
            target: this.getNode()
        });
        this._nodes.forEach((target)=>{
            target._fire("transformstart", {
                evt: e.evt,
                target: target
            });
        });
    }
    _handleMouseMove(e) {
        var x, y, newHypotenuse;
        var anchorNode = this.findOne("." + this._movingAnchorName);
        var stage = anchorNode.getStage();
        stage.setPointersPositions(e);
        const pp = stage.getPointerPosition();
        let newNodePos = {
            x: pp.x - this._anchorDragOffset.x,
            y: pp.y - this._anchorDragOffset.y
        };
        const oldAbs = anchorNode.getAbsolutePosition();
        if (this.anchorDragBoundFunc()) newNodePos = this.anchorDragBoundFunc()(oldAbs, newNodePos, e);
        anchorNode.setAbsolutePosition(newNodePos);
        const newAbs = anchorNode.getAbsolutePosition();
        if (oldAbs.x === newAbs.x && oldAbs.y === newAbs.y) return;
        if (this._movingAnchorName === "rotater") {
            var attrs = this._getNodeRect();
            x = anchorNode.x() - attrs.width / 2;
            y = -anchorNode.y() + attrs.height / 2;
            let delta = Math.atan2(-y, x) + Math.PI / 2;
            if (attrs.height < 0) delta -= Math.PI;
            var oldRotation = (0, $f1cce3c2a91bf0cf$export$b9f99057a3c7692).getAngle(this.rotation());
            const newRotation = oldRotation + delta;
            const tol = (0, $f1cce3c2a91bf0cf$export$b9f99057a3c7692).getAngle(this.rotationSnapTolerance());
            const snappedRot = $c3dfaa80c0c40989$var$getSnap(this.rotationSnaps(), newRotation, tol);
            const diff = snappedRot - attrs.rotation;
            const shape = $c3dfaa80c0c40989$var$rotateAroundCenter(attrs, diff);
            this._fitNodesInto(shape, e);
            return;
        }
        var keepProportion = this.keepRatio() || e.shiftKey;
        var centeredScaling = this.centeredScaling() || e.altKey;
        if (this._movingAnchorName === "top-left") {
            if (keepProportion) {
                var comparePoint = centeredScaling ? {
                    x: this.width() / 2,
                    y: this.height() / 2
                } : {
                    x: this.findOne(".bottom-right").x(),
                    y: this.findOne(".bottom-right").y()
                };
                newHypotenuse = Math.sqrt(Math.pow(comparePoint.x - anchorNode.x(), 2) + Math.pow(comparePoint.y - anchorNode.y(), 2));
                var reverseX = this.findOne(".top-left").x() > comparePoint.x ? -1 : 1;
                var reverseY = this.findOne(".top-left").y() > comparePoint.y ? -1 : 1;
                x = newHypotenuse * this.cos * reverseX;
                y = newHypotenuse * this.sin * reverseY;
                this.findOne(".top-left").x(comparePoint.x - x);
                this.findOne(".top-left").y(comparePoint.y - y);
            }
        } else if (this._movingAnchorName === "top-center") this.findOne(".top-left").y(anchorNode.y());
        else if (this._movingAnchorName === "top-right") {
            if (keepProportion) {
                var comparePoint = centeredScaling ? {
                    x: this.width() / 2,
                    y: this.height() / 2
                } : {
                    x: this.findOne(".bottom-left").x(),
                    y: this.findOne(".bottom-left").y()
                };
                newHypotenuse = Math.sqrt(Math.pow(anchorNode.x() - comparePoint.x, 2) + Math.pow(comparePoint.y - anchorNode.y(), 2));
                var reverseX = this.findOne(".top-right").x() < comparePoint.x ? -1 : 1;
                var reverseY = this.findOne(".top-right").y() > comparePoint.y ? -1 : 1;
                x = newHypotenuse * this.cos * reverseX;
                y = newHypotenuse * this.sin * reverseY;
                this.findOne(".top-right").x(comparePoint.x + x);
                this.findOne(".top-right").y(comparePoint.y - y);
            }
            var pos = anchorNode.position();
            this.findOne(".top-left").y(pos.y);
            this.findOne(".bottom-right").x(pos.x);
        } else if (this._movingAnchorName === "middle-left") this.findOne(".top-left").x(anchorNode.x());
        else if (this._movingAnchorName === "middle-right") this.findOne(".bottom-right").x(anchorNode.x());
        else if (this._movingAnchorName === "bottom-left") {
            if (keepProportion) {
                var comparePoint = centeredScaling ? {
                    x: this.width() / 2,
                    y: this.height() / 2
                } : {
                    x: this.findOne(".top-right").x(),
                    y: this.findOne(".top-right").y()
                };
                newHypotenuse = Math.sqrt(Math.pow(comparePoint.x - anchorNode.x(), 2) + Math.pow(anchorNode.y() - comparePoint.y, 2));
                var reverseX = comparePoint.x < anchorNode.x() ? -1 : 1;
                var reverseY = anchorNode.y() < comparePoint.y ? -1 : 1;
                x = newHypotenuse * this.cos * reverseX;
                y = newHypotenuse * this.sin * reverseY;
                anchorNode.x(comparePoint.x - x);
                anchorNode.y(comparePoint.y + y);
            }
            pos = anchorNode.position();
            this.findOne(".top-left").x(pos.x);
            this.findOne(".bottom-right").y(pos.y);
        } else if (this._movingAnchorName === "bottom-center") this.findOne(".bottom-right").y(anchorNode.y());
        else if (this._movingAnchorName === "bottom-right") {
            if (keepProportion) {
                var comparePoint = centeredScaling ? {
                    x: this.width() / 2,
                    y: this.height() / 2
                } : {
                    x: this.findOne(".top-left").x(),
                    y: this.findOne(".top-left").y()
                };
                newHypotenuse = Math.sqrt(Math.pow(anchorNode.x() - comparePoint.x, 2) + Math.pow(anchorNode.y() - comparePoint.y, 2));
                var reverseX = this.findOne(".bottom-right").x() < comparePoint.x ? -1 : 1;
                var reverseY = this.findOne(".bottom-right").y() < comparePoint.y ? -1 : 1;
                x = newHypotenuse * this.cos * reverseX;
                y = newHypotenuse * this.sin * reverseY;
                this.findOne(".bottom-right").x(comparePoint.x + x);
                this.findOne(".bottom-right").y(comparePoint.y + y);
            }
        } else console.error(new Error("Wrong position argument of selection resizer: " + this._movingAnchorName));
        var centeredScaling = this.centeredScaling() || e.altKey;
        if (centeredScaling) {
            var topLeft = this.findOne(".top-left");
            var bottomRight = this.findOne(".bottom-right");
            var topOffsetX = topLeft.x();
            var topOffsetY = topLeft.y();
            var bottomOffsetX = this.getWidth() - bottomRight.x();
            var bottomOffsetY = this.getHeight() - bottomRight.y();
            bottomRight.move({
                x: -topOffsetX,
                y: -topOffsetY
            });
            topLeft.move({
                x: bottomOffsetX,
                y: bottomOffsetY
            });
        }
        var absPos = this.findOne(".top-left").getAbsolutePosition();
        x = absPos.x;
        y = absPos.y;
        var width = this.findOne(".bottom-right").x() - this.findOne(".top-left").x();
        var height = this.findOne(".bottom-right").y() - this.findOne(".top-left").y();
        this._fitNodesInto({
            x: x,
            y: y,
            width: width,
            height: height,
            rotation: (0, $f1cce3c2a91bf0cf$export$b9f99057a3c7692).getAngle(this.rotation())
        }, e);
    }
    _handleMouseUp(e) {
        this._removeEvents(e);
    }
    getAbsoluteTransform() {
        return this.getTransform();
    }
    _removeEvents(e) {
        if (this._transforming) {
            this._transforming = false;
            if (typeof window !== "undefined") {
                window.removeEventListener("mousemove", this._handleMouseMove);
                window.removeEventListener("touchmove", this._handleMouseMove);
                window.removeEventListener("mouseup", this._handleMouseUp, true);
                window.removeEventListener("touchend", this._handleMouseUp, true);
            }
            var node = this.getNode();
            this._fire("transformend", {
                evt: e,
                target: node
            });
            if (node) this._nodes.forEach((target)=>{
                target._fire("transformend", {
                    evt: e,
                    target: target
                });
            });
            this._movingAnchorName = null;
        }
    }
    _fitNodesInto(newAttrs, evt) {
        var oldAttrs = this._getNodeRect();
        const minSize = 1;
        if ((0, $4d54b3632f7367db$export$f8f26dd395d7e1bd)._inRange(newAttrs.width, -this.padding() * 2 - minSize, minSize)) {
            this.update();
            return;
        }
        if ((0, $4d54b3632f7367db$export$f8f26dd395d7e1bd)._inRange(newAttrs.height, -this.padding() * 2 - minSize, minSize)) {
            this.update();
            return;
        }
        const allowNegativeScale = this.flipEnabled();
        var t = new (0, $4d54b3632f7367db$export$563a914cafbdc389)();
        t.rotate((0, $f1cce3c2a91bf0cf$export$b9f99057a3c7692).getAngle(this.rotation()));
        if (this._movingAnchorName && newAttrs.width < 0 && this._movingAnchorName.indexOf("left") >= 0) {
            const offset = t.point({
                x: -this.padding() * 2,
                y: 0
            });
            newAttrs.x += offset.x;
            newAttrs.y += offset.y;
            newAttrs.width += this.padding() * 2;
            this._movingAnchorName = this._movingAnchorName.replace("left", "right");
            this._anchorDragOffset.x -= offset.x;
            this._anchorDragOffset.y -= offset.y;
            if (!allowNegativeScale) {
                this.update();
                return;
            }
        } else if (this._movingAnchorName && newAttrs.width < 0 && this._movingAnchorName.indexOf("right") >= 0) {
            const offset = t.point({
                x: this.padding() * 2,
                y: 0
            });
            this._movingAnchorName = this._movingAnchorName.replace("right", "left");
            this._anchorDragOffset.x -= offset.x;
            this._anchorDragOffset.y -= offset.y;
            newAttrs.width += this.padding() * 2;
            if (!allowNegativeScale) {
                this.update();
                return;
            }
        }
        if (this._movingAnchorName && newAttrs.height < 0 && this._movingAnchorName.indexOf("top") >= 0) {
            const offset = t.point({
                x: 0,
                y: -this.padding() * 2
            });
            newAttrs.x += offset.x;
            newAttrs.y += offset.y;
            this._movingAnchorName = this._movingAnchorName.replace("top", "bottom");
            this._anchorDragOffset.x -= offset.x;
            this._anchorDragOffset.y -= offset.y;
            newAttrs.height += this.padding() * 2;
            if (!allowNegativeScale) {
                this.update();
                return;
            }
        } else if (this._movingAnchorName && newAttrs.height < 0 && this._movingAnchorName.indexOf("bottom") >= 0) {
            const offset = t.point({
                x: 0,
                y: this.padding() * 2
            });
            this._movingAnchorName = this._movingAnchorName.replace("bottom", "top");
            this._anchorDragOffset.x -= offset.x;
            this._anchorDragOffset.y -= offset.y;
            newAttrs.height += this.padding() * 2;
            if (!allowNegativeScale) {
                this.update();
                return;
            }
        }
        if (this.boundBoxFunc()) {
            const bounded = this.boundBoxFunc()(oldAttrs, newAttrs);
            if (bounded) newAttrs = bounded;
            else (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).warn("boundBoxFunc returned falsy. You should return new bound rect from it!");
        }
        const baseSize = 10000000;
        const oldTr = new (0, $4d54b3632f7367db$export$563a914cafbdc389)();
        oldTr.translate(oldAttrs.x, oldAttrs.y);
        oldTr.rotate(oldAttrs.rotation);
        oldTr.scale(oldAttrs.width / baseSize, oldAttrs.height / baseSize);
        const newTr = new (0, $4d54b3632f7367db$export$563a914cafbdc389)();
        newTr.translate(newAttrs.x, newAttrs.y);
        newTr.rotate(newAttrs.rotation);
        newTr.scale(newAttrs.width / baseSize, newAttrs.height / baseSize);
        const delta = newTr.multiply(oldTr.invert());
        this._nodes.forEach((node)=>{
            var _a;
            const parentTransform = node.getParent().getAbsoluteTransform();
            const localTransform = node.getTransform().copy();
            localTransform.translate(node.offsetX(), node.offsetY());
            const newLocalTransform = new (0, $4d54b3632f7367db$export$563a914cafbdc389)();
            newLocalTransform.multiply(parentTransform.copy().invert()).multiply(delta).multiply(parentTransform).multiply(localTransform);
            const attrs = newLocalTransform.decompose();
            node.setAttrs(attrs);
            this._fire("transform", {
                evt: evt,
                target: node
            });
            node._fire("transform", {
                evt: evt,
                target: node
            });
            (_a = node.getLayer()) === null || _a === void 0 || _a.batchDraw();
        });
        this.rotation((0, $4d54b3632f7367db$export$f8f26dd395d7e1bd)._getRotation(newAttrs.rotation));
        this._resetTransformCache();
        this.update();
        this.getLayer().batchDraw();
    }
    forceUpdate() {
        this._resetTransformCache();
        this.update();
    }
    _batchChangeChild(selector, attrs) {
        const anchor = this.findOne(selector);
        anchor.setAttrs(attrs);
    }
    update() {
        var _a;
        var attrs = this._getNodeRect();
        this.rotation((0, $4d54b3632f7367db$export$f8f26dd395d7e1bd)._getRotation(attrs.rotation));
        var width = attrs.width;
        var height = attrs.height;
        var enabledAnchors = this.enabledAnchors();
        var resizeEnabled = this.resizeEnabled();
        var padding = this.padding();
        var anchorSize = this.anchorSize();
        this.find("._anchor").forEach((node)=>{
            node.setAttrs({
                width: anchorSize,
                height: anchorSize,
                offsetX: anchorSize / 2,
                offsetY: anchorSize / 2,
                stroke: this.anchorStroke(),
                strokeWidth: this.anchorStrokeWidth(),
                fill: this.anchorFill(),
                cornerRadius: this.anchorCornerRadius()
            });
        });
        this._batchChangeChild(".top-left", {
            x: 0,
            y: 0,
            offsetX: anchorSize / 2 + padding,
            offsetY: anchorSize / 2 + padding,
            visible: resizeEnabled && enabledAnchors.indexOf("top-left") >= 0
        });
        this._batchChangeChild(".top-center", {
            x: width / 2,
            y: 0,
            offsetY: anchorSize / 2 + padding,
            visible: resizeEnabled && enabledAnchors.indexOf("top-center") >= 0
        });
        this._batchChangeChild(".top-right", {
            x: width,
            y: 0,
            offsetX: anchorSize / 2 - padding,
            offsetY: anchorSize / 2 + padding,
            visible: resizeEnabled && enabledAnchors.indexOf("top-right") >= 0
        });
        this._batchChangeChild(".middle-left", {
            x: 0,
            y: height / 2,
            offsetX: anchorSize / 2 + padding,
            visible: resizeEnabled && enabledAnchors.indexOf("middle-left") >= 0
        });
        this._batchChangeChild(".middle-right", {
            x: width,
            y: height / 2,
            offsetX: anchorSize / 2 - padding,
            visible: resizeEnabled && enabledAnchors.indexOf("middle-right") >= 0
        });
        this._batchChangeChild(".bottom-left", {
            x: 0,
            y: height,
            offsetX: anchorSize / 2 + padding,
            offsetY: anchorSize / 2 - padding,
            visible: resizeEnabled && enabledAnchors.indexOf("bottom-left") >= 0
        });
        this._batchChangeChild(".bottom-center", {
            x: width / 2,
            y: height,
            offsetY: anchorSize / 2 - padding,
            visible: resizeEnabled && enabledAnchors.indexOf("bottom-center") >= 0
        });
        this._batchChangeChild(".bottom-right", {
            x: width,
            y: height,
            offsetX: anchorSize / 2 - padding,
            offsetY: anchorSize / 2 - padding,
            visible: resizeEnabled && enabledAnchors.indexOf("bottom-right") >= 0
        });
        this._batchChangeChild(".rotater", {
            x: width / 2,
            y: -this.rotateAnchorOffset() * (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd)._sign(height) - padding,
            visible: this.rotateEnabled()
        });
        this._batchChangeChild(".back", {
            width: width,
            height: height,
            visible: this.borderEnabled(),
            stroke: this.borderStroke(),
            strokeWidth: this.borderStrokeWidth(),
            dash: this.borderDash(),
            x: 0,
            y: 0
        });
        (_a = this.getLayer()) === null || _a === void 0 || _a.batchDraw();
    }
    isTransforming() {
        return this._transforming;
    }
    stopTransform() {
        if (this._transforming) {
            this._removeEvents();
            var anchorNode = this.findOne("." + this._movingAnchorName);
            if (anchorNode) anchorNode.stopDrag();
        }
    }
    destroy() {
        if (this.getStage() && this._cursorChange) this.getStage().content && (this.getStage().content.style.cursor = "");
        (0, $5147287ae7dd04c0$export$eb2fcfdbd7ba97d4).prototype.destroy.call(this);
        this.detach();
        this._removeEvents();
        return this;
    }
    toObject() {
        return (0, $97cb7af42217e259$export$85c928794f8d04d4).prototype.toObject.call(this);
    }
    clone(obj) {
        var node = (0, $97cb7af42217e259$export$85c928794f8d04d4).prototype.clone.call(this, obj);
        return node;
    }
    getClientRect() {
        if (this.nodes().length > 0) return super.getClientRect();
        else return {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        };
    }
}
function $c3dfaa80c0c40989$var$validateAnchors(val) {
    if (!(val instanceof Array)) (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).warn("enabledAnchors value should be an array");
    if (val instanceof Array) val.forEach(function(name) {
        if ($c3dfaa80c0c40989$var$ANCHORS_NAMES.indexOf(name) === -1) (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).warn("Unknown anchor name: " + name + ". Available names are: " + $c3dfaa80c0c40989$var$ANCHORS_NAMES.join(", "));
    });
    return val || [];
}
$c3dfaa80c0c40989$export$f993aef960936087.prototype.className = "Transformer";
(0, $f1cce3c2a91bf0cf$export$f7a70d87a5e829eb)($c3dfaa80c0c40989$export$f993aef960936087);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($c3dfaa80c0c40989$export$f993aef960936087, "enabledAnchors", $c3dfaa80c0c40989$var$ANCHORS_NAMES, $c3dfaa80c0c40989$var$validateAnchors);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($c3dfaa80c0c40989$export$f993aef960936087, "flipEnabled", true, (0, $8d9e6be936d29d8a$export$147fc8b6cd20fda1)());
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($c3dfaa80c0c40989$export$f993aef960936087, "resizeEnabled", true);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($c3dfaa80c0c40989$export$f993aef960936087, "anchorSize", 10, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)());
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($c3dfaa80c0c40989$export$f993aef960936087, "rotateEnabled", true);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($c3dfaa80c0c40989$export$f993aef960936087, "rotationSnaps", []);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($c3dfaa80c0c40989$export$f993aef960936087, "rotateAnchorOffset", 50, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)());
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($c3dfaa80c0c40989$export$f993aef960936087, "rotationSnapTolerance", 5, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)());
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($c3dfaa80c0c40989$export$f993aef960936087, "borderEnabled", true);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($c3dfaa80c0c40989$export$f993aef960936087, "anchorStroke", "rgb(0, 161, 255)");
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($c3dfaa80c0c40989$export$f993aef960936087, "anchorStrokeWidth", 1, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)());
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($c3dfaa80c0c40989$export$f993aef960936087, "anchorFill", "white");
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($c3dfaa80c0c40989$export$f993aef960936087, "anchorCornerRadius", 0, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)());
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($c3dfaa80c0c40989$export$f993aef960936087, "borderStroke", "rgb(0, 161, 255)");
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($c3dfaa80c0c40989$export$f993aef960936087, "borderStrokeWidth", 1, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)());
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($c3dfaa80c0c40989$export$f993aef960936087, "borderDash");
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($c3dfaa80c0c40989$export$f993aef960936087, "keepRatio", true);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($c3dfaa80c0c40989$export$f993aef960936087, "centeredScaling", false);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($c3dfaa80c0c40989$export$f993aef960936087, "ignoreStroke", false);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($c3dfaa80c0c40989$export$f993aef960936087, "padding", 0, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)());
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($c3dfaa80c0c40989$export$f993aef960936087, "node");
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($c3dfaa80c0c40989$export$f993aef960936087, "nodes");
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($c3dfaa80c0c40989$export$f993aef960936087, "boundBoxFunc");
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($c3dfaa80c0c40989$export$f993aef960936087, "anchorDragBoundFunc");
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($c3dfaa80c0c40989$export$f993aef960936087, "shouldOverdrawWholeArea", false);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($c3dfaa80c0c40989$export$f993aef960936087, "useSingleNodeRotation", true);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).backCompat($c3dfaa80c0c40989$export$f993aef960936087, {
    lineEnabled: "borderEnabled",
    rotateHandlerOffset: "rotateAnchorOffset",
    enabledHandlers: "enabledAnchors"
});






class $7d49d8fdd04c2d0a$export$28718c7785907330 extends (0, $3bfe60cc136fb197$export$6428a7f2611ef1fa) {
    _sceneFunc(context) {
        context.beginPath();
        context.arc(0, 0, this.radius(), 0, (0, $f1cce3c2a91bf0cf$export$b9f99057a3c7692).getAngle(this.angle()), this.clockwise());
        context.lineTo(0, 0);
        context.closePath();
        context.fillStrokeShape(this);
    }
    getWidth() {
        return this.radius() * 2;
    }
    getHeight() {
        return this.radius() * 2;
    }
    setWidth(width) {
        this.radius(width / 2);
    }
    setHeight(height) {
        this.radius(height / 2);
    }
}
$7d49d8fdd04c2d0a$export$28718c7785907330.prototype.className = "Wedge";
$7d49d8fdd04c2d0a$export$28718c7785907330.prototype._centroid = true;
$7d49d8fdd04c2d0a$export$28718c7785907330.prototype._attrsAffectingSize = [
    "radius"
];
(0, $f1cce3c2a91bf0cf$export$f7a70d87a5e829eb)($7d49d8fdd04c2d0a$export$28718c7785907330);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($7d49d8fdd04c2d0a$export$28718c7785907330, "radius", 0, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)());
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($7d49d8fdd04c2d0a$export$28718c7785907330, "angle", 0, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)());
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter($7d49d8fdd04c2d0a$export$28718c7785907330, "clockwise", false);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).backCompat($7d49d8fdd04c2d0a$export$28718c7785907330, {
    angleDeg: "angle",
    getAngleDeg: "getAngle",
    setAngleDeg: "setAngle"
});





function $0bea724f27991d6f$var$BlurStack() {
    this.r = 0;
    this.g = 0;
    this.b = 0;
    this.a = 0;
    this.next = null;
}
var $0bea724f27991d6f$var$mul_table = [
    512,
    512,
    456,
    512,
    328,
    456,
    335,
    512,
    405,
    328,
    271,
    456,
    388,
    335,
    292,
    512,
    454,
    405,
    364,
    328,
    298,
    271,
    496,
    456,
    420,
    388,
    360,
    335,
    312,
    292,
    273,
    512,
    482,
    454,
    428,
    405,
    383,
    364,
    345,
    328,
    312,
    298,
    284,
    271,
    259,
    496,
    475,
    456,
    437,
    420,
    404,
    388,
    374,
    360,
    347,
    335,
    323,
    312,
    302,
    292,
    282,
    273,
    265,
    512,
    497,
    482,
    468,
    454,
    441,
    428,
    417,
    405,
    394,
    383,
    373,
    364,
    354,
    345,
    337,
    328,
    320,
    312,
    305,
    298,
    291,
    284,
    278,
    271,
    265,
    259,
    507,
    496,
    485,
    475,
    465,
    456,
    446,
    437,
    428,
    420,
    412,
    404,
    396,
    388,
    381,
    374,
    367,
    360,
    354,
    347,
    341,
    335,
    329,
    323,
    318,
    312,
    307,
    302,
    297,
    292,
    287,
    282,
    278,
    273,
    269,
    265,
    261,
    512,
    505,
    497,
    489,
    482,
    475,
    468,
    461,
    454,
    447,
    441,
    435,
    428,
    422,
    417,
    411,
    405,
    399,
    394,
    389,
    383,
    378,
    373,
    368,
    364,
    359,
    354,
    350,
    345,
    341,
    337,
    332,
    328,
    324,
    320,
    316,
    312,
    309,
    305,
    301,
    298,
    294,
    291,
    287,
    284,
    281,
    278,
    274,
    271,
    268,
    265,
    262,
    259,
    257,
    507,
    501,
    496,
    491,
    485,
    480,
    475,
    470,
    465,
    460,
    456,
    451,
    446,
    442,
    437,
    433,
    428,
    424,
    420,
    416,
    412,
    408,
    404,
    400,
    396,
    392,
    388,
    385,
    381,
    377,
    374,
    370,
    367,
    363,
    360,
    357,
    354,
    350,
    347,
    344,
    341,
    338,
    335,
    332,
    329,
    326,
    323,
    320,
    318,
    315,
    312,
    310,
    307,
    304,
    302,
    299,
    297,
    294,
    292,
    289,
    287,
    285,
    282,
    280,
    278,
    275,
    273,
    271,
    269,
    267,
    265,
    263,
    261,
    259
];
var $0bea724f27991d6f$var$shg_table = [
    9,
    11,
    12,
    13,
    13,
    14,
    14,
    15,
    15,
    15,
    15,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    18,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24
];
function $0bea724f27991d6f$var$filterGaussBlurRGBA(imageData, radius) {
    var pixels = imageData.data, width = imageData.width, height = imageData.height;
    var x, y, i, p, yp, yi, yw, r_sum, g_sum, b_sum, a_sum, r_out_sum, g_out_sum, b_out_sum, a_out_sum, r_in_sum, g_in_sum, b_in_sum, a_in_sum, pr, pg, pb, pa, rbs;
    var div = radius + radius + 1, widthMinus1 = width - 1, heightMinus1 = height - 1, radiusPlus1 = radius + 1, sumFactor = radiusPlus1 * (radiusPlus1 + 1) / 2, stackStart = new $0bea724f27991d6f$var$BlurStack(), stackEnd = null, stack = stackStart, stackIn = null, stackOut = null, mul_sum = $0bea724f27991d6f$var$mul_table[radius], shg_sum = $0bea724f27991d6f$var$shg_table[radius];
    for(i = 1; i < div; i++){
        stack = stack.next = new $0bea724f27991d6f$var$BlurStack();
        if (i === radiusPlus1) stackEnd = stack;
    }
    stack.next = stackStart;
    yw = yi = 0;
    for(y = 0; y < height; y++){
        r_in_sum = g_in_sum = b_in_sum = a_in_sum = r_sum = g_sum = b_sum = a_sum = 0;
        r_out_sum = radiusPlus1 * (pr = pixels[yi]);
        g_out_sum = radiusPlus1 * (pg = pixels[yi + 1]);
        b_out_sum = radiusPlus1 * (pb = pixels[yi + 2]);
        a_out_sum = radiusPlus1 * (pa = pixels[yi + 3]);
        r_sum += sumFactor * pr;
        g_sum += sumFactor * pg;
        b_sum += sumFactor * pb;
        a_sum += sumFactor * pa;
        stack = stackStart;
        for(i = 0; i < radiusPlus1; i++){
            stack.r = pr;
            stack.g = pg;
            stack.b = pb;
            stack.a = pa;
            stack = stack.next;
        }
        for(i = 1; i < radiusPlus1; i++){
            p = yi + ((widthMinus1 < i ? widthMinus1 : i) << 2);
            r_sum += (stack.r = pr = pixels[p]) * (rbs = radiusPlus1 - i);
            g_sum += (stack.g = pg = pixels[p + 1]) * rbs;
            b_sum += (stack.b = pb = pixels[p + 2]) * rbs;
            a_sum += (stack.a = pa = pixels[p + 3]) * rbs;
            r_in_sum += pr;
            g_in_sum += pg;
            b_in_sum += pb;
            a_in_sum += pa;
            stack = stack.next;
        }
        stackIn = stackStart;
        stackOut = stackEnd;
        for(x = 0; x < width; x++){
            pixels[yi + 3] = pa = a_sum * mul_sum >> shg_sum;
            if (pa !== 0) {
                pa = 255 / pa;
                pixels[yi] = (r_sum * mul_sum >> shg_sum) * pa;
                pixels[yi + 1] = (g_sum * mul_sum >> shg_sum) * pa;
                pixels[yi + 2] = (b_sum * mul_sum >> shg_sum) * pa;
            } else pixels[yi] = pixels[yi + 1] = pixels[yi + 2] = 0;
            r_sum -= r_out_sum;
            g_sum -= g_out_sum;
            b_sum -= b_out_sum;
            a_sum -= a_out_sum;
            r_out_sum -= stackIn.r;
            g_out_sum -= stackIn.g;
            b_out_sum -= stackIn.b;
            a_out_sum -= stackIn.a;
            p = yw + ((p = x + radius + 1) < widthMinus1 ? p : widthMinus1) << 2;
            r_in_sum += stackIn.r = pixels[p];
            g_in_sum += stackIn.g = pixels[p + 1];
            b_in_sum += stackIn.b = pixels[p + 2];
            a_in_sum += stackIn.a = pixels[p + 3];
            r_sum += r_in_sum;
            g_sum += g_in_sum;
            b_sum += b_in_sum;
            a_sum += a_in_sum;
            stackIn = stackIn.next;
            r_out_sum += pr = stackOut.r;
            g_out_sum += pg = stackOut.g;
            b_out_sum += pb = stackOut.b;
            a_out_sum += pa = stackOut.a;
            r_in_sum -= pr;
            g_in_sum -= pg;
            b_in_sum -= pb;
            a_in_sum -= pa;
            stackOut = stackOut.next;
            yi += 4;
        }
        yw += width;
    }
    for(x = 0; x < width; x++){
        g_in_sum = b_in_sum = a_in_sum = r_in_sum = g_sum = b_sum = a_sum = r_sum = 0;
        yi = x << 2;
        r_out_sum = radiusPlus1 * (pr = pixels[yi]);
        g_out_sum = radiusPlus1 * (pg = pixels[yi + 1]);
        b_out_sum = radiusPlus1 * (pb = pixels[yi + 2]);
        a_out_sum = radiusPlus1 * (pa = pixels[yi + 3]);
        r_sum += sumFactor * pr;
        g_sum += sumFactor * pg;
        b_sum += sumFactor * pb;
        a_sum += sumFactor * pa;
        stack = stackStart;
        for(i = 0; i < radiusPlus1; i++){
            stack.r = pr;
            stack.g = pg;
            stack.b = pb;
            stack.a = pa;
            stack = stack.next;
        }
        yp = width;
        for(i = 1; i <= radius; i++){
            yi = yp + x << 2;
            r_sum += (stack.r = pr = pixels[yi]) * (rbs = radiusPlus1 - i);
            g_sum += (stack.g = pg = pixels[yi + 1]) * rbs;
            b_sum += (stack.b = pb = pixels[yi + 2]) * rbs;
            a_sum += (stack.a = pa = pixels[yi + 3]) * rbs;
            r_in_sum += pr;
            g_in_sum += pg;
            b_in_sum += pb;
            a_in_sum += pa;
            stack = stack.next;
            if (i < heightMinus1) yp += width;
        }
        yi = x;
        stackIn = stackStart;
        stackOut = stackEnd;
        for(y = 0; y < height; y++){
            p = yi << 2;
            pixels[p + 3] = pa = a_sum * mul_sum >> shg_sum;
            if (pa > 0) {
                pa = 255 / pa;
                pixels[p] = (r_sum * mul_sum >> shg_sum) * pa;
                pixels[p + 1] = (g_sum * mul_sum >> shg_sum) * pa;
                pixels[p + 2] = (b_sum * mul_sum >> shg_sum) * pa;
            } else pixels[p] = pixels[p + 1] = pixels[p + 2] = 0;
            r_sum -= r_out_sum;
            g_sum -= g_out_sum;
            b_sum -= b_out_sum;
            a_sum -= a_out_sum;
            r_out_sum -= stackIn.r;
            g_out_sum -= stackIn.g;
            b_out_sum -= stackIn.b;
            a_out_sum -= stackIn.a;
            p = x + ((p = y + radiusPlus1) < heightMinus1 ? p : heightMinus1) * width << 2;
            r_sum += r_in_sum += stackIn.r = pixels[p];
            g_sum += g_in_sum += stackIn.g = pixels[p + 1];
            b_sum += b_in_sum += stackIn.b = pixels[p + 2];
            a_sum += a_in_sum += stackIn.a = pixels[p + 3];
            stackIn = stackIn.next;
            r_out_sum += pr = stackOut.r;
            g_out_sum += pg = stackOut.g;
            b_out_sum += pb = stackOut.b;
            a_out_sum += pa = stackOut.a;
            r_in_sum -= pr;
            g_in_sum -= pg;
            b_in_sum -= pb;
            a_in_sum -= pa;
            stackOut = stackOut.next;
            yi += width;
        }
    }
}
const $0bea724f27991d6f$export$975a268f2c733e4 = function Blur(imageData) {
    var radius = Math.round(this.blurRadius());
    if (radius > 0) $0bea724f27991d6f$var$filterGaussBlurRGBA(imageData, radius);
};
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter((0, $97cb7af42217e259$export$85c928794f8d04d4), "blurRadius", 0, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)(), (0, $e1d1e3911fd31488$export$8354032f3852ec50).afterSetFilter);





const $bc35b6a386676707$export$a2d0d82739cac11f = function(imageData) {
    var brightness = this.brightness() * 255, data = imageData.data, len = data.length, i;
    for(i = 0; i < len; i += 4){
        data[i] += brightness;
        data[i + 1] += brightness;
        data[i + 2] += brightness;
    }
};
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter((0, $97cb7af42217e259$export$85c928794f8d04d4), "brightness", 0, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)(), (0, $e1d1e3911fd31488$export$8354032f3852ec50).afterSetFilter);





const $37308778ac6e8ceb$export$656ae42051d0ca86 = function(imageData) {
    var adjust = Math.pow((this.contrast() + 100) / 100, 2);
    var data = imageData.data, nPixels = data.length, red = 150, green = 150, blue = 150, i;
    for(i = 0; i < nPixels; i += 4){
        red = data[i];
        green = data[i + 1];
        blue = data[i + 2];
        red /= 255;
        red -= 0.5;
        red *= adjust;
        red += 0.5;
        red *= 255;
        green /= 255;
        green -= 0.5;
        green *= adjust;
        green += 0.5;
        green *= 255;
        blue /= 255;
        blue -= 0.5;
        blue *= adjust;
        blue += 0.5;
        blue *= 255;
        red = red < 0 ? 0 : red > 255 ? 255 : red;
        green = green < 0 ? 0 : green > 255 ? 255 : green;
        blue = blue < 0 ? 0 : blue > 255 ? 255 : blue;
        data[i] = red;
        data[i + 1] = green;
        data[i + 2] = blue;
    }
};
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter((0, $97cb7af42217e259$export$85c928794f8d04d4), "contrast", 0, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)(), (0, $e1d1e3911fd31488$export$8354032f3852ec50).afterSetFilter);






const $8d1d69d148a576e7$export$3c8699b389eb838 = function(imageData) {
    var strength = this.embossStrength() * 10, greyLevel = this.embossWhiteLevel() * 255, direction = this.embossDirection(), blend = this.embossBlend(), dirY = 0, dirX = 0, data = imageData.data, w = imageData.width, h = imageData.height, w4 = w * 4, y = h;
    switch(direction){
        case "top-left":
            dirY = -1;
            dirX = -1;
            break;
        case "top":
            dirY = -1;
            dirX = 0;
            break;
        case "top-right":
            dirY = -1;
            dirX = 1;
            break;
        case "right":
            dirY = 0;
            dirX = 1;
            break;
        case "bottom-right":
            dirY = 1;
            dirX = 1;
            break;
        case "bottom":
            dirY = 1;
            dirX = 0;
            break;
        case "bottom-left":
            dirY = 1;
            dirX = -1;
            break;
        case "left":
            dirY = 0;
            dirX = -1;
            break;
        default:
            (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).error("Unknown emboss direction: " + direction);
    }
    do {
        var offsetY = (y - 1) * w4;
        var otherY = dirY;
        if (y + otherY < 1) otherY = 0;
        if (y + otherY > h) otherY = 0;
        var offsetYOther = (y - 1 + otherY) * w * 4;
        var x = w;
        do {
            var offset = offsetY + (x - 1) * 4;
            var otherX = dirX;
            if (x + otherX < 1) otherX = 0;
            if (x + otherX > w) otherX = 0;
            var offsetOther = offsetYOther + (x - 1 + otherX) * 4;
            var dR = data[offset] - data[offsetOther];
            var dG = data[offset + 1] - data[offsetOther + 1];
            var dB = data[offset + 2] - data[offsetOther + 2];
            var dif = dR;
            var absDif = dif > 0 ? dif : -dif;
            var absG = dG > 0 ? dG : -dG;
            var absB = dB > 0 ? dB : -dB;
            if (absG > absDif) dif = dG;
            if (absB > absDif) dif = dB;
            dif *= strength;
            if (blend) {
                var r = data[offset] + dif;
                var g = data[offset + 1] + dif;
                var b = data[offset + 2] + dif;
                data[offset] = r > 255 ? 255 : r < 0 ? 0 : r;
                data[offset + 1] = g > 255 ? 255 : g < 0 ? 0 : g;
                data[offset + 2] = b > 255 ? 255 : b < 0 ? 0 : b;
            } else {
                var grey = greyLevel - dif;
                if (grey < 0) grey = 0;
                else if (grey > 255) grey = 255;
                data[offset] = data[offset + 1] = data[offset + 2] = grey;
            }
        }while (--x);
    }while (--y);
};
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter((0, $97cb7af42217e259$export$85c928794f8d04d4), "embossStrength", 0.5, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)(), (0, $e1d1e3911fd31488$export$8354032f3852ec50).afterSetFilter);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter((0, $97cb7af42217e259$export$85c928794f8d04d4), "embossWhiteLevel", 0.5, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)(), (0, $e1d1e3911fd31488$export$8354032f3852ec50).afterSetFilter);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter((0, $97cb7af42217e259$export$85c928794f8d04d4), "embossDirection", "top-left", null, (0, $e1d1e3911fd31488$export$8354032f3852ec50).afterSetFilter);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter((0, $97cb7af42217e259$export$85c928794f8d04d4), "embossBlend", false, null, (0, $e1d1e3911fd31488$export$8354032f3852ec50).afterSetFilter);





function $edaf921f7291661f$var$remap(fromValue, fromMin, fromMax, toMin, toMax) {
    var fromRange = fromMax - fromMin, toRange = toMax - toMin, toValue;
    if (fromRange === 0) return toMin + toRange / 2;
    if (toRange === 0) return toMin;
    toValue = (fromValue - fromMin) / fromRange;
    toValue = toRange * toValue + toMin;
    return toValue;
}
const $edaf921f7291661f$export$5cb8e8388f951d6f = function(imageData) {
    var data = imageData.data, nSubPixels = data.length, rMin = data[0], rMax = rMin, r, gMin = data[1], gMax = gMin, g, bMin = data[2], bMax = bMin, b, i;
    var enhanceAmount = this.enhance();
    if (enhanceAmount === 0) return;
    for(i = 0; i < nSubPixels; i += 4){
        r = data[i + 0];
        if (r < rMin) rMin = r;
        else if (r > rMax) rMax = r;
        g = data[i + 1];
        if (g < gMin) gMin = g;
        else if (g > gMax) gMax = g;
        b = data[i + 2];
        if (b < bMin) bMin = b;
        else if (b > bMax) bMax = b;
    }
    if (rMax === rMin) {
        rMax = 255;
        rMin = 0;
    }
    if (gMax === gMin) {
        gMax = 255;
        gMin = 0;
    }
    if (bMax === bMin) {
        bMax = 255;
        bMin = 0;
    }
    var rMid, rGoalMax, rGoalMin, gMid, gGoalMax, gGoalMin, bMid, bGoalMax, bGoalMin;
    if (enhanceAmount > 0) {
        rGoalMax = rMax + enhanceAmount * (255 - rMax);
        rGoalMin = rMin - enhanceAmount * (rMin - 0);
        gGoalMax = gMax + enhanceAmount * (255 - gMax);
        gGoalMin = gMin - enhanceAmount * (gMin - 0);
        bGoalMax = bMax + enhanceAmount * (255 - bMax);
        bGoalMin = bMin - enhanceAmount * (bMin - 0);
    } else {
        rMid = (rMax + rMin) * 0.5;
        rGoalMax = rMax + enhanceAmount * (rMax - rMid);
        rGoalMin = rMin + enhanceAmount * (rMin - rMid);
        gMid = (gMax + gMin) * 0.5;
        gGoalMax = gMax + enhanceAmount * (gMax - gMid);
        gGoalMin = gMin + enhanceAmount * (gMin - gMid);
        bMid = (bMax + bMin) * 0.5;
        bGoalMax = bMax + enhanceAmount * (bMax - bMid);
        bGoalMin = bMin + enhanceAmount * (bMin - bMid);
    }
    for(i = 0; i < nSubPixels; i += 4){
        data[i + 0] = $edaf921f7291661f$var$remap(data[i + 0], rMin, rMax, rGoalMin, rGoalMax);
        data[i + 1] = $edaf921f7291661f$var$remap(data[i + 1], gMin, gMax, gGoalMin, gGoalMax);
        data[i + 2] = $edaf921f7291661f$var$remap(data[i + 2], bMin, bMax, bGoalMin, bGoalMax);
    }
};
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter((0, $97cb7af42217e259$export$85c928794f8d04d4), "enhance", 0, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)(), (0, $e1d1e3911fd31488$export$8354032f3852ec50).afterSetFilter);


const $8b80de4ca41ae55e$export$e2b0a794e83ca071 = function(imageData) {
    var data = imageData.data, len = data.length, i, brightness;
    for(i = 0; i < len; i += 4){
        brightness = 0.34 * data[i] + 0.5 * data[i + 1] + 0.16 * data[i + 2];
        data[i] = brightness;
        data[i + 1] = brightness;
        data[i + 2] = brightness;
    }
};





(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter((0, $97cb7af42217e259$export$85c928794f8d04d4), "hue", 0, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)(), (0, $e1d1e3911fd31488$export$8354032f3852ec50).afterSetFilter);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter((0, $97cb7af42217e259$export$85c928794f8d04d4), "saturation", 0, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)(), (0, $e1d1e3911fd31488$export$8354032f3852ec50).afterSetFilter);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter((0, $97cb7af42217e259$export$85c928794f8d04d4), "luminance", 0, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)(), (0, $e1d1e3911fd31488$export$8354032f3852ec50).afterSetFilter);
const $cedefb8849cbcd11$export$46d8b0f9bc8f87a2 = function(imageData) {
    var data = imageData.data, nPixels = data.length, v = 1, s = Math.pow(2, this.saturation()), h = Math.abs(this.hue() + 360) % 360, l = this.luminance() * 127, i;
    var vsu = v * s * Math.cos(h * Math.PI / 180), vsw = v * s * Math.sin(h * Math.PI / 180);
    var rr = 0.299 * v + 0.701 * vsu + 0.167 * vsw, rg = 0.587 * v - 0.587 * vsu + 0.33 * vsw, rb = 0.114 * v - 0.114 * vsu - 0.497 * vsw;
    var gr = 0.299 * v - 0.299 * vsu - 0.328 * vsw, gg = 0.587 * v + 0.413 * vsu + 0.035 * vsw, gb = 0.114 * v - 0.114 * vsu + 0.293 * vsw;
    var br = 0.299 * v - 0.3 * vsu + 1.25 * vsw, bg = 0.587 * v - 0.586 * vsu - 1.05 * vsw, bb = 0.114 * v + 0.886 * vsu - 0.2 * vsw;
    var r, g, b, a;
    for(i = 0; i < nPixels; i += 4){
        r = data[i + 0];
        g = data[i + 1];
        b = data[i + 2];
        a = data[i + 3];
        data[i + 0] = rr * r + rg * g + rb * b + l;
        data[i + 1] = gr * r + gg * g + gb * b + l;
        data[i + 2] = br * r + bg * g + bb * b + l;
        data[i + 3] = a;
    }
};





const $0e8b0235b1bf3934$export$d2edaecd208aed43 = function(imageData) {
    var data = imageData.data, nPixels = data.length, v = Math.pow(2, this.value()), s = Math.pow(2, this.saturation()), h = Math.abs(this.hue() + 360) % 360, i;
    var vsu = v * s * Math.cos(h * Math.PI / 180), vsw = v * s * Math.sin(h * Math.PI / 180);
    var rr = 0.299 * v + 0.701 * vsu + 0.167 * vsw, rg = 0.587 * v - 0.587 * vsu + 0.33 * vsw, rb = 0.114 * v - 0.114 * vsu - 0.497 * vsw;
    var gr = 0.299 * v - 0.299 * vsu - 0.328 * vsw, gg = 0.587 * v + 0.413 * vsu + 0.035 * vsw, gb = 0.114 * v - 0.114 * vsu + 0.293 * vsw;
    var br = 0.299 * v - 0.3 * vsu + 1.25 * vsw, bg = 0.587 * v - 0.586 * vsu - 1.05 * vsw, bb = 0.114 * v + 0.886 * vsu - 0.2 * vsw;
    var r, g, b, a;
    for(i = 0; i < nPixels; i += 4){
        r = data[i + 0];
        g = data[i + 1];
        b = data[i + 2];
        a = data[i + 3];
        data[i + 0] = rr * r + rg * g + rb * b;
        data[i + 1] = gr * r + gg * g + gb * b;
        data[i + 2] = br * r + bg * g + bb * b;
        data[i + 3] = a;
    }
};
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter((0, $97cb7af42217e259$export$85c928794f8d04d4), "hue", 0, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)(), (0, $e1d1e3911fd31488$export$8354032f3852ec50).afterSetFilter);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter((0, $97cb7af42217e259$export$85c928794f8d04d4), "saturation", 0, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)(), (0, $e1d1e3911fd31488$export$8354032f3852ec50).afterSetFilter);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter((0, $97cb7af42217e259$export$85c928794f8d04d4), "value", 0, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)(), (0, $e1d1e3911fd31488$export$8354032f3852ec50).afterSetFilter);


const $c46b1225b4afeef8$export$1073348d81b17440 = function(imageData) {
    var data = imageData.data, len = data.length, i;
    for(i = 0; i < len; i += 4){
        data[i] = 255 - data[i];
        data[i + 1] = 255 - data[i + 1];
        data[i + 2] = 255 - data[i + 2];
    }
};






var $5c27f8c35d16b69d$var$ToPolar = function(src, dst, opt) {
    var srcPixels = src.data, dstPixels = dst.data, xSize = src.width, ySize = src.height, xMid = opt.polarCenterX || xSize / 2, yMid = opt.polarCenterY || ySize / 2, i, x, y, r = 0, g = 0, b = 0, a = 0;
    var rad, rMax = Math.sqrt(xMid * xMid + yMid * yMid);
    x = xSize - xMid;
    y = ySize - yMid;
    rad = Math.sqrt(x * x + y * y);
    rMax = rad > rMax ? rad : rMax;
    var rSize = ySize, tSize = xSize, radius, theta;
    var conversion = 360 / tSize * Math.PI / 180, sin, cos;
    for(theta = 0; theta < tSize; theta += 1){
        sin = Math.sin(theta * conversion);
        cos = Math.cos(theta * conversion);
        for(radius = 0; radius < rSize; radius += 1){
            x = Math.floor(xMid + rMax * radius / rSize * cos);
            y = Math.floor(yMid + rMax * radius / rSize * sin);
            i = (y * xSize + x) * 4;
            r = srcPixels[i + 0];
            g = srcPixels[i + 1];
            b = srcPixels[i + 2];
            a = srcPixels[i + 3];
            i = (theta + radius * xSize) * 4;
            dstPixels[i + 0] = r;
            dstPixels[i + 1] = g;
            dstPixels[i + 2] = b;
            dstPixels[i + 3] = a;
        }
    }
};
var $5c27f8c35d16b69d$var$FromPolar = function(src, dst, opt) {
    var srcPixels = src.data, dstPixels = dst.data, xSize = src.width, ySize = src.height, xMid = opt.polarCenterX || xSize / 2, yMid = opt.polarCenterY || ySize / 2, i, x, y, dx, dy, r = 0, g = 0, b = 0, a = 0;
    var rad, rMax = Math.sqrt(xMid * xMid + yMid * yMid);
    x = xSize - xMid;
    y = ySize - yMid;
    rad = Math.sqrt(x * x + y * y);
    rMax = rad > rMax ? rad : rMax;
    var rSize = ySize, tSize = xSize, radius, theta, phaseShift = opt.polarRotation || 0;
    var x1, y1;
    for(x = 0; x < xSize; x += 1)for(y = 0; y < ySize; y += 1){
        dx = x - xMid;
        dy = y - yMid;
        radius = Math.sqrt(dx * dx + dy * dy) * rSize / rMax;
        theta = (Math.atan2(dy, dx) * 180 / Math.PI + 360 + phaseShift) % 360;
        theta = theta * tSize / 360;
        x1 = Math.floor(theta);
        y1 = Math.floor(radius);
        i = (y1 * xSize + x1) * 4;
        r = srcPixels[i + 0];
        g = srcPixels[i + 1];
        b = srcPixels[i + 2];
        a = srcPixels[i + 3];
        i = (y * xSize + x) * 4;
        dstPixels[i + 0] = r;
        dstPixels[i + 1] = g;
        dstPixels[i + 2] = b;
        dstPixels[i + 3] = a;
    }
};
const $5c27f8c35d16b69d$export$e731e8a0fd067155 = function(imageData) {
    var xSize = imageData.width, ySize = imageData.height;
    var x, y, xoff, i, r, g, b, a, srcPos, dstPos;
    var power = Math.round(this.kaleidoscopePower());
    var angle = Math.round(this.kaleidoscopeAngle());
    var offset = Math.floor(xSize * (angle % 360) / 360);
    if (power < 1) return;
    var tempCanvas = (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).createCanvasElement();
    tempCanvas.width = xSize;
    tempCanvas.height = ySize;
    var scratchData = tempCanvas.getContext("2d").getImageData(0, 0, xSize, ySize);
    (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).releaseCanvas(tempCanvas);
    $5c27f8c35d16b69d$var$ToPolar(imageData, scratchData, {
        polarCenterX: xSize / 2,
        polarCenterY: ySize / 2
    });
    var minSectionSize = xSize / Math.pow(2, power);
    while(minSectionSize <= 8){
        minSectionSize = minSectionSize * 2;
        power -= 1;
    }
    minSectionSize = Math.ceil(minSectionSize);
    var sectionSize = minSectionSize;
    var xStart = 0, xEnd = sectionSize, xDelta = 1;
    if (offset + minSectionSize > xSize) {
        xStart = sectionSize;
        xEnd = 0;
        xDelta = -1;
    }
    for(y = 0; y < ySize; y += 1)for(x = xStart; x !== xEnd; x += xDelta){
        xoff = Math.round(x + offset) % xSize;
        srcPos = (xSize * y + xoff) * 4;
        r = scratchData.data[srcPos + 0];
        g = scratchData.data[srcPos + 1];
        b = scratchData.data[srcPos + 2];
        a = scratchData.data[srcPos + 3];
        dstPos = (xSize * y + x) * 4;
        scratchData.data[dstPos + 0] = r;
        scratchData.data[dstPos + 1] = g;
        scratchData.data[dstPos + 2] = b;
        scratchData.data[dstPos + 3] = a;
    }
    for(y = 0; y < ySize; y += 1){
        sectionSize = Math.floor(minSectionSize);
        for(i = 0; i < power; i += 1){
            for(x = 0; x < sectionSize + 1; x += 1){
                srcPos = (xSize * y + x) * 4;
                r = scratchData.data[srcPos + 0];
                g = scratchData.data[srcPos + 1];
                b = scratchData.data[srcPos + 2];
                a = scratchData.data[srcPos + 3];
                dstPos = (xSize * y + sectionSize * 2 - x - 1) * 4;
                scratchData.data[dstPos + 0] = r;
                scratchData.data[dstPos + 1] = g;
                scratchData.data[dstPos + 2] = b;
                scratchData.data[dstPos + 3] = a;
            }
            sectionSize *= 2;
        }
    }
    $5c27f8c35d16b69d$var$FromPolar(scratchData, imageData, {
        polarRotation: 0
    });
};
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter((0, $97cb7af42217e259$export$85c928794f8d04d4), "kaleidoscopePower", 2, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)(), (0, $e1d1e3911fd31488$export$8354032f3852ec50).afterSetFilter);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter((0, $97cb7af42217e259$export$85c928794f8d04d4), "kaleidoscopeAngle", 0, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)(), (0, $e1d1e3911fd31488$export$8354032f3852ec50).afterSetFilter);





function $48c6d7423b59aa91$var$pixelAt(idata, x, y) {
    var idx = (y * idata.width + x) * 4;
    var d = [];
    d.push(idata.data[idx++], idata.data[idx++], idata.data[idx++], idata.data[idx++]);
    return d;
}
function $48c6d7423b59aa91$var$rgbDistance(p1, p2) {
    return Math.sqrt(Math.pow(p1[0] - p2[0], 2) + Math.pow(p1[1] - p2[1], 2) + Math.pow(p1[2] - p2[2], 2));
}
function $48c6d7423b59aa91$var$rgbMean(pTab) {
    var m = [
        0,
        0,
        0
    ];
    for(var i = 0; i < pTab.length; i++){
        m[0] += pTab[i][0];
        m[1] += pTab[i][1];
        m[2] += pTab[i][2];
    }
    m[0] /= pTab.length;
    m[1] /= pTab.length;
    m[2] /= pTab.length;
    return m;
}
function $48c6d7423b59aa91$var$backgroundMask(idata, threshold) {
    var rgbv_no = $48c6d7423b59aa91$var$pixelAt(idata, 0, 0);
    var rgbv_ne = $48c6d7423b59aa91$var$pixelAt(idata, idata.width - 1, 0);
    var rgbv_so = $48c6d7423b59aa91$var$pixelAt(idata, 0, idata.height - 1);
    var rgbv_se = $48c6d7423b59aa91$var$pixelAt(idata, idata.width - 1, idata.height - 1);
    var thres = threshold || 10;
    if ($48c6d7423b59aa91$var$rgbDistance(rgbv_no, rgbv_ne) < thres && $48c6d7423b59aa91$var$rgbDistance(rgbv_ne, rgbv_se) < thres && $48c6d7423b59aa91$var$rgbDistance(rgbv_se, rgbv_so) < thres && $48c6d7423b59aa91$var$rgbDistance(rgbv_so, rgbv_no) < thres) {
        var mean = $48c6d7423b59aa91$var$rgbMean([
            rgbv_ne,
            rgbv_no,
            rgbv_se,
            rgbv_so
        ]);
        var mask = [];
        for(var i = 0; i < idata.width * idata.height; i++){
            var d = $48c6d7423b59aa91$var$rgbDistance(mean, [
                idata.data[i * 4],
                idata.data[i * 4 + 1],
                idata.data[i * 4 + 2]
            ]);
            mask[i] = d < thres ? 0 : 255;
        }
        return mask;
    }
}
function $48c6d7423b59aa91$var$applyMask(idata, mask) {
    for(var i = 0; i < idata.width * idata.height; i++)idata.data[4 * i + 3] = mask[i];
}
function $48c6d7423b59aa91$var$erodeMask(mask, sw, sh) {
    var weights = [
        1,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        1
    ];
    var side = Math.round(Math.sqrt(weights.length));
    var halfSide = Math.floor(side / 2);
    var maskResult = [];
    for(var y = 0; y < sh; y++)for(var x = 0; x < sw; x++){
        var so = y * sw + x;
        var a = 0;
        for(var cy = 0; cy < side; cy++)for(var cx = 0; cx < side; cx++){
            var scy = y + cy - halfSide;
            var scx = x + cx - halfSide;
            if (scy >= 0 && scy < sh && scx >= 0 && scx < sw) {
                var srcOff = scy * sw + scx;
                var wt = weights[cy * side + cx];
                a += mask[srcOff] * wt;
            }
        }
        maskResult[so] = a === 2040 ? 255 : 0;
    }
    return maskResult;
}
function $48c6d7423b59aa91$var$dilateMask(mask, sw, sh) {
    var weights = [
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1
    ];
    var side = Math.round(Math.sqrt(weights.length));
    var halfSide = Math.floor(side / 2);
    var maskResult = [];
    for(var y = 0; y < sh; y++)for(var x = 0; x < sw; x++){
        var so = y * sw + x;
        var a = 0;
        for(var cy = 0; cy < side; cy++)for(var cx = 0; cx < side; cx++){
            var scy = y + cy - halfSide;
            var scx = x + cx - halfSide;
            if (scy >= 0 && scy < sh && scx >= 0 && scx < sw) {
                var srcOff = scy * sw + scx;
                var wt = weights[cy * side + cx];
                a += mask[srcOff] * wt;
            }
        }
        maskResult[so] = a >= 1020 ? 255 : 0;
    }
    return maskResult;
}
function $48c6d7423b59aa91$var$smoothEdgeMask(mask, sw, sh) {
    var weights = [
        1 / 9,
        1 / 9,
        1 / 9,
        1 / 9,
        1 / 9,
        1 / 9,
        1 / 9,
        1 / 9,
        1 / 9
    ];
    var side = Math.round(Math.sqrt(weights.length));
    var halfSide = Math.floor(side / 2);
    var maskResult = [];
    for(var y = 0; y < sh; y++)for(var x = 0; x < sw; x++){
        var so = y * sw + x;
        var a = 0;
        for(var cy = 0; cy < side; cy++)for(var cx = 0; cx < side; cx++){
            var scy = y + cy - halfSide;
            var scx = x + cx - halfSide;
            if (scy >= 0 && scy < sh && scx >= 0 && scx < sw) {
                var srcOff = scy * sw + scx;
                var wt = weights[cy * side + cx];
                a += mask[srcOff] * wt;
            }
        }
        maskResult[so] = a;
    }
    return maskResult;
}
const $48c6d7423b59aa91$export$991dcf7284de63d = function(imageData) {
    var threshold = this.threshold(), mask = $48c6d7423b59aa91$var$backgroundMask(imageData, threshold);
    if (mask) {
        mask = $48c6d7423b59aa91$var$erodeMask(mask, imageData.width, imageData.height);
        mask = $48c6d7423b59aa91$var$dilateMask(mask, imageData.width, imageData.height);
        mask = $48c6d7423b59aa91$var$smoothEdgeMask(mask, imageData.width, imageData.height);
        $48c6d7423b59aa91$var$applyMask(imageData, mask);
    }
    return imageData;
};
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter((0, $97cb7af42217e259$export$85c928794f8d04d4), "threshold", 0, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)(), (0, $e1d1e3911fd31488$export$8354032f3852ec50).afterSetFilter);





const $975cbfb420335d2d$export$484d33a0500a4ce1 = function(imageData) {
    var amount = this.noise() * 255, data = imageData.data, nPixels = data.length, half = amount / 2, i;
    for(i = 0; i < nPixels; i += 4){
        data[i + 0] += half - 2 * half * Math.random();
        data[i + 1] += half - 2 * half * Math.random();
        data[i + 2] += half - 2 * half * Math.random();
    }
};
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter((0, $97cb7af42217e259$export$85c928794f8d04d4), "noise", 0.2, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)(), (0, $e1d1e3911fd31488$export$8354032f3852ec50).afterSetFilter);






const $e96eb623b3488046$export$63396595bf5aeaa7 = function(imageData) {
    var pixelSize = Math.ceil(this.pixelSize()), width = imageData.width, height = imageData.height, x, y, i, red, green, blue, alpha, nBinsX = Math.ceil(width / pixelSize), nBinsY = Math.ceil(height / pixelSize), xBinStart, xBinEnd, yBinStart, yBinEnd, xBin, yBin, pixelsInBin, data = imageData.data;
    if (pixelSize <= 0) {
        (0, $4d54b3632f7367db$export$f8f26dd395d7e1bd).error("pixelSize value can not be <= 0");
        return;
    }
    for(xBin = 0; xBin < nBinsX; xBin += 1)for(yBin = 0; yBin < nBinsY; yBin += 1){
        red = 0;
        green = 0;
        blue = 0;
        alpha = 0;
        xBinStart = xBin * pixelSize;
        xBinEnd = xBinStart + pixelSize;
        yBinStart = yBin * pixelSize;
        yBinEnd = yBinStart + pixelSize;
        pixelsInBin = 0;
        for(x = xBinStart; x < xBinEnd; x += 1){
            if (x >= width) continue;
            for(y = yBinStart; y < yBinEnd; y += 1){
                if (y >= height) continue;
                i = (width * y + x) * 4;
                red += data[i + 0];
                green += data[i + 1];
                blue += data[i + 2];
                alpha += data[i + 3];
                pixelsInBin += 1;
            }
        }
        red = red / pixelsInBin;
        green = green / pixelsInBin;
        blue = blue / pixelsInBin;
        alpha = alpha / pixelsInBin;
        for(x = xBinStart; x < xBinEnd; x += 1){
            if (x >= width) continue;
            for(y = yBinStart; y < yBinEnd; y += 1){
                if (y >= height) continue;
                i = (width * y + x) * 4;
                data[i + 0] = red;
                data[i + 1] = green;
                data[i + 2] = blue;
                data[i + 3] = alpha;
            }
        }
    }
};
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter((0, $97cb7af42217e259$export$85c928794f8d04d4), "pixelSize", 8, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)(), (0, $e1d1e3911fd31488$export$8354032f3852ec50).afterSetFilter);





const $7cf4cbbd1892caf6$export$ccda2563bc5d1354 = function(imageData) {
    var levels = Math.round(this.levels() * 254) + 1, data = imageData.data, len = data.length, scale = 255 / levels, i;
    for(i = 0; i < len; i += 1)data[i] = Math.floor(data[i] / scale) * scale;
};
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter((0, $97cb7af42217e259$export$85c928794f8d04d4), "levels", 0.5, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)(), (0, $e1d1e3911fd31488$export$8354032f3852ec50).afterSetFilter);





const $a77f0ea65873e04f$export$8f9ece5a47764b93 = function(imageData) {
    var data = imageData.data, nPixels = data.length, red = this.red(), green = this.green(), blue = this.blue(), i, brightness;
    for(i = 0; i < nPixels; i += 4){
        brightness = (0.34 * data[i] + 0.5 * data[i + 1] + 0.16 * data[i + 2]) / 255;
        data[i] = brightness * red;
        data[i + 1] = brightness * green;
        data[i + 2] = brightness * blue;
        data[i + 3] = data[i + 3];
    }
};
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter((0, $97cb7af42217e259$export$85c928794f8d04d4), "red", 0, function(val) {
    this._filterUpToDate = false;
    if (val > 255) return 255;
    else if (val < 0) return 0;
    else return Math.round(val);
});
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter((0, $97cb7af42217e259$export$85c928794f8d04d4), "green", 0, function(val) {
    this._filterUpToDate = false;
    if (val > 255) return 255;
    else if (val < 0) return 0;
    else return Math.round(val);
});
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter((0, $97cb7af42217e259$export$85c928794f8d04d4), "blue", 0, (0, $8d9e6be936d29d8a$export$af51e4581c640b27), (0, $e1d1e3911fd31488$export$8354032f3852ec50).afterSetFilter);





const $4179bfb242181e18$export$f50470518fe8f14a = function(imageData) {
    var data = imageData.data, nPixels = data.length, red = this.red(), green = this.green(), blue = this.blue(), alpha = this.alpha(), i, ia;
    for(i = 0; i < nPixels; i += 4){
        ia = 1 - alpha;
        data[i] = red * alpha + data[i] * ia;
        data[i + 1] = green * alpha + data[i + 1] * ia;
        data[i + 2] = blue * alpha + data[i + 2] * ia;
    }
};
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter((0, $97cb7af42217e259$export$85c928794f8d04d4), "red", 0, function(val) {
    this._filterUpToDate = false;
    if (val > 255) return 255;
    else if (val < 0) return 0;
    else return Math.round(val);
});
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter((0, $97cb7af42217e259$export$85c928794f8d04d4), "green", 0, function(val) {
    this._filterUpToDate = false;
    if (val > 255) return 255;
    else if (val < 0) return 0;
    else return Math.round(val);
});
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter((0, $97cb7af42217e259$export$85c928794f8d04d4), "blue", 0, (0, $8d9e6be936d29d8a$export$af51e4581c640b27), (0, $e1d1e3911fd31488$export$8354032f3852ec50).afterSetFilter);
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter((0, $97cb7af42217e259$export$85c928794f8d04d4), "alpha", 1, function(val) {
    this._filterUpToDate = false;
    if (val > 1) return 1;
    else if (val < 0) return 0;
    else return val;
});


const $9fe71f9651e2487a$export$1eeb4741c69006fa = function(imageData) {
    var data = imageData.data, nPixels = data.length, i, r, g, b;
    for(i = 0; i < nPixels; i += 4){
        r = data[i + 0];
        g = data[i + 1];
        b = data[i + 2];
        data[i + 0] = Math.min(255, r * 0.393 + g * 0.769 + b * 0.189);
        data[i + 1] = Math.min(255, r * 0.349 + g * 0.686 + b * 0.168);
        data[i + 2] = Math.min(255, r * 0.272 + g * 0.534 + b * 0.131);
    }
};


const $b3c7d9583a9ae0cf$export$d60d51c3865bca60 = function(imageData) {
    var data = imageData.data, w = imageData.width, h = imageData.height, w4 = w * 4, y = h;
    do {
        var offsetY = (y - 1) * w4;
        var x = w;
        do {
            var offset = offsetY + (x - 1) * 4;
            var r = data[offset];
            var g = data[offset + 1];
            var b = data[offset + 2];
            if (r > 127) r = 255 - r;
            if (g > 127) g = 255 - g;
            if (b > 127) b = 255 - b;
            data[offset] = r;
            data[offset + 1] = g;
            data[offset + 2] = b;
        }while (--x);
    }while (--y);
};





const $3eccc95b84bd035b$export$14f770b2ce0bb8ad = function(imageData) {
    var level = this.threshold() * 255, data = imageData.data, len = data.length, i;
    for(i = 0; i < len; i += 1)data[i] = data[i] < level ? 0 : 255;
};
(0, $e1d1e3911fd31488$export$8354032f3852ec50).addGetterSetter((0, $97cb7af42217e259$export$85c928794f8d04d4), "threshold", 0.5, (0, $8d9e6be936d29d8a$export$6b1205b9fbe7de2c)(), (0, $e1d1e3911fd31488$export$8354032f3852ec50).afterSetFilter);


const $05a39a3ce1ca754b$export$b9f99057a3c7692 = (0, $8d1588919b81b1e4$export$b9f99057a3c7692).Util._assign((0, $8d1588919b81b1e4$export$b9f99057a3c7692), {
    Arc: $d45099c50280ff31$export$6ef80ffb606dd232,
    Arrow: $2a0e2f808fa98650$export$21b07c8f274aebd5,
    Circle: $290cdf94c489e2d1$export$c89a927ffc67e6fa,
    Ellipse: $87bb524290f16dd5$export$80b0269ab108fa11,
    Image: $c10569d3249cdecf$export$3e431a229df88919,
    Label: $7760c087bffc0d19$export$b04be29aa201d4f5,
    Tag: $7760c087bffc0d19$export$3288d34c523a1192,
    Line: $2a894264b44ee8c9$export$17d680238e50603e,
    Path: $78ea6556da6c35e2$export$4b2950bdac9b6ee9,
    Rect: $179d0400af9c0c44$export$c79fc6492f3af13d,
    RegularPolygon: $9542af7733498607$export$e2ee866164812ecd,
    Ring: $9023172e11ac7f75$export$a6e3577650b6d6d7,
    Sprite: $26c792054d1523b2$export$3075603db8e6204c,
    Star: $027af3cf1eed306d$export$1644ba17714857f1,
    Text: $1886c67fae9befe1$export$5f1af8db9871e1d6,
    TextPath: $282e9c4915b34bd1$export$f7e34a95cc06fac7,
    Transformer: $c3dfaa80c0c40989$export$f993aef960936087,
    Wedge: $7d49d8fdd04c2d0a$export$28718c7785907330,
    Filters: {
        Blur: $0bea724f27991d6f$export$975a268f2c733e4,
        Brighten: $bc35b6a386676707$export$a2d0d82739cac11f,
        Contrast: $37308778ac6e8ceb$export$656ae42051d0ca86,
        Emboss: $8d1d69d148a576e7$export$3c8699b389eb838,
        Enhance: $edaf921f7291661f$export$5cb8e8388f951d6f,
        Grayscale: $8b80de4ca41ae55e$export$e2b0a794e83ca071,
        HSL: $cedefb8849cbcd11$export$46d8b0f9bc8f87a2,
        HSV: $0e8b0235b1bf3934$export$d2edaecd208aed43,
        Invert: $c46b1225b4afeef8$export$1073348d81b17440,
        Kaleidoscope: $5c27f8c35d16b69d$export$e731e8a0fd067155,
        Mask: $48c6d7423b59aa91$export$991dcf7284de63d,
        Noise: $975cbfb420335d2d$export$484d33a0500a4ce1,
        Pixelate: $e96eb623b3488046$export$63396595bf5aeaa7,
        Posterize: $7cf4cbbd1892caf6$export$ccda2563bc5d1354,
        RGB: $a77f0ea65873e04f$export$8f9ece5a47764b93,
        RGBA: $4179bfb242181e18$export$f50470518fe8f14a,
        Sepia: $9fe71f9651e2487a$export$1eeb4741c69006fa,
        Solarize: $b3c7d9583a9ae0cf$export$d60d51c3865bca60,
        Threshold: $3eccc95b84bd035b$export$14f770b2ce0bb8ad
    }
});


var $4c9be156930480fe$export$2e2bcd8739ae039 = (0, $05a39a3ce1ca754b$export$b9f99057a3c7692);


/**
 * Based on ReactArt.js
 * Copyright (c) 2017-present Lavrenov Anton.
 * All rights reserved.
 *
 * MIT
 */ 
var $69Mlo = parcelRequire("69Mlo");

var $8bf8c5cb1bb85357$export$2e2bcd8739ae039 = (0, $8d1588919b81b1e4$export$b9f99057a3c7692);


var $a597390ea3f469a5$exports = {};
"use strict";

$a597390ea3f469a5$exports = (parcelRequire("jAXlF"));


var $2e6a749cb91bd087$exports = {};
"use strict";

$2e6a749cb91bd087$exports = (parcelRequire("6cmU7"));


var $b7ea2beb2ece2d4a$exports = {};

$parcel$export($b7ea2beb2ece2d4a$exports, "appendInitialChild", function () { return $b7ea2beb2ece2d4a$export$b1cefef778e97ee8; });
$parcel$export($b7ea2beb2ece2d4a$exports, "createInstance", function () { return $b7ea2beb2ece2d4a$export$99152e8d49ca4e7d; });
$parcel$export($b7ea2beb2ece2d4a$exports, "createTextInstance", function () { return $b7ea2beb2ece2d4a$export$d1ef805cf7083486; });
$parcel$export($b7ea2beb2ece2d4a$exports, "finalizeInitialChildren", function () { return $b7ea2beb2ece2d4a$export$7bb0b211bcb5abfd; });
$parcel$export($b7ea2beb2ece2d4a$exports, "getPublicInstance", function () { return $b7ea2beb2ece2d4a$export$d2475cc200518c86; });
$parcel$export($b7ea2beb2ece2d4a$exports, "prepareForCommit", function () { return $b7ea2beb2ece2d4a$export$ba5994afaabfdb0c; });
$parcel$export($b7ea2beb2ece2d4a$exports, "preparePortalMount", function () { return $b7ea2beb2ece2d4a$export$e15c8ecd0a0092b2; });
$parcel$export($b7ea2beb2ece2d4a$exports, "prepareUpdate", function () { return $b7ea2beb2ece2d4a$export$c885331d842f22b5; });
$parcel$export($b7ea2beb2ece2d4a$exports, "resetAfterCommit", function () { return $b7ea2beb2ece2d4a$export$683e88f306512aed; });
$parcel$export($b7ea2beb2ece2d4a$exports, "resetTextContent", function () { return $b7ea2beb2ece2d4a$export$2119d6fc5d6f51aa; });
$parcel$export($b7ea2beb2ece2d4a$exports, "shouldDeprioritizeSubtree", function () { return $b7ea2beb2ece2d4a$export$70ab89a99d11d186; });
$parcel$export($b7ea2beb2ece2d4a$exports, "getRootHostContext", function () { return $b7ea2beb2ece2d4a$export$dce2ca0b0f5feeb5; });
$parcel$export($b7ea2beb2ece2d4a$exports, "getChildHostContext", function () { return $b7ea2beb2ece2d4a$export$1236a84b6992d37a; });
$parcel$export($b7ea2beb2ece2d4a$exports, "scheduleTimeout", function () { return $b7ea2beb2ece2d4a$export$5f4d6617421d489b; });
$parcel$export($b7ea2beb2ece2d4a$exports, "cancelTimeout", function () { return $b7ea2beb2ece2d4a$export$f78ec70d8091ca88; });
$parcel$export($b7ea2beb2ece2d4a$exports, "noTimeout", function () { return $b7ea2beb2ece2d4a$export$78506abae4a4951d; });
$parcel$export($b7ea2beb2ece2d4a$exports, "shouldSetTextContent", function () { return $b7ea2beb2ece2d4a$export$c82139d6d374ec34; });
$parcel$export($b7ea2beb2ece2d4a$exports, "isPrimaryRenderer", function () { return $b7ea2beb2ece2d4a$export$a5fcb8abea5b71a4; });
$parcel$export($b7ea2beb2ece2d4a$exports, "warnsIfNotActing", function () { return $b7ea2beb2ece2d4a$export$2516db7323c01bd5; });
$parcel$export($b7ea2beb2ece2d4a$exports, "supportsMutation", function () { return $b7ea2beb2ece2d4a$export$20f97ad47f9ebeb; });
$parcel$export($b7ea2beb2ece2d4a$exports, "appendChild", function () { return $b7ea2beb2ece2d4a$export$1b8e57c9ea42f1d2; });
$parcel$export($b7ea2beb2ece2d4a$exports, "appendChildToContainer", function () { return $b7ea2beb2ece2d4a$export$5e391de19acdf645; });
$parcel$export($b7ea2beb2ece2d4a$exports, "insertBefore", function () { return $b7ea2beb2ece2d4a$export$86b68c7dbeb53c22; });
$parcel$export($b7ea2beb2ece2d4a$exports, "insertInContainerBefore", function () { return $b7ea2beb2ece2d4a$export$7ec3655259385e44; });
$parcel$export($b7ea2beb2ece2d4a$exports, "removeChild", function () { return $b7ea2beb2ece2d4a$export$7ae609f7af59e4f7; });
$parcel$export($b7ea2beb2ece2d4a$exports, "removeChildFromContainer", function () { return $b7ea2beb2ece2d4a$export$2e4ef5d75a473f1a; });
$parcel$export($b7ea2beb2ece2d4a$exports, "commitTextUpdate", function () { return $b7ea2beb2ece2d4a$export$50a92d0155bee474; });
$parcel$export($b7ea2beb2ece2d4a$exports, "commitMount", function () { return $b7ea2beb2ece2d4a$export$fe90794743fbfeb0; });
$parcel$export($b7ea2beb2ece2d4a$exports, "commitUpdate", function () { return $b7ea2beb2ece2d4a$export$fd8222818e57ec6; });
$parcel$export($b7ea2beb2ece2d4a$exports, "hideInstance", function () { return $b7ea2beb2ece2d4a$export$6db9fd2b8188b8b7; });
$parcel$export($b7ea2beb2ece2d4a$exports, "hideTextInstance", function () { return $b7ea2beb2ece2d4a$export$17ed9cbd9cb3aad2; });
$parcel$export($b7ea2beb2ece2d4a$exports, "unhideInstance", function () { return $b7ea2beb2ece2d4a$export$933e25c2090d1941; });
$parcel$export($b7ea2beb2ece2d4a$exports, "unhideTextInstance", function () { return $b7ea2beb2ece2d4a$export$8ff685cdcb7326ff; });
$parcel$export($b7ea2beb2ece2d4a$exports, "clearContainer", function () { return $b7ea2beb2ece2d4a$export$28e08eff11ac64f6; });
$parcel$export($b7ea2beb2ece2d4a$exports, "detachDeletedInstance", function () { return $b7ea2beb2ece2d4a$export$92ab91999be04e45; });
$parcel$export($b7ea2beb2ece2d4a$exports, "getCurrentEventPriority", function () { return $b7ea2beb2ece2d4a$export$e23f0d5a7e18b951; });
$parcel$export($b7ea2beb2ece2d4a$exports, "now", function () { return (parcelRequire("euyry")).unstable_now; });
$parcel$export($b7ea2beb2ece2d4a$exports, "idlePriority", function () { return (parcelRequire("euyry")).unstable_IdlePriority; });
$parcel$export($b7ea2beb2ece2d4a$exports, "run", function () { return (parcelRequire("euyry")).unstable_runWithPriority; });


const $c41cca0690581380$var$propsToSkip = {
    children: true,
    ref: true,
    key: true,
    style: true,
    forwardedRef: true,
    unstable_applyCache: true,
    unstable_applyDrawHitFromCache: true
};
let $c41cca0690581380$var$zIndexWarningShowed = false;
let $c41cca0690581380$var$dragWarningShowed = false;
const $c41cca0690581380$export$3a20cc353cdae1b2 = ".react-konva-event";
let $c41cca0690581380$var$useStrictMode = false;
function $c41cca0690581380$export$5a38dcef855281ce(value) {
    $c41cca0690581380$var$useStrictMode = value;
}
const $c41cca0690581380$var$DRAGGABLE_WARNING = `ReactKonva: You have a Konva node with draggable = true and position defined but no onDragMove or onDragEnd events are handled.
Position of a node will be changed during drag&drop, so you should update state of the react app as well.
Consider to add onDragMove or onDragEnd events.
For more info see: https://github.com/konvajs/react-konva/issues/256
`;
const $c41cca0690581380$var$Z_INDEX_WARNING = `ReactKonva: You are using "zIndex" attribute for a Konva node.
react-konva may get confused with ordering. Just define correct order of elements in your render function of a component.
For more info see: https://github.com/konvajs/react-konva/issues/194
`;
const $c41cca0690581380$var$EMPTY_PROPS = {};
function $c41cca0690581380$export$25d4dd8d7c7a61f6(instance, props, oldProps = $c41cca0690581380$var$EMPTY_PROPS) {
    // don't use zIndex in react-konva
    if (!$c41cca0690581380$var$zIndexWarningShowed && "zIndex" in props) {
        console.warn($c41cca0690581380$var$Z_INDEX_WARNING);
        $c41cca0690581380$var$zIndexWarningShowed = true;
    }
    // check correct draggable usage
    if (!$c41cca0690581380$var$dragWarningShowed && props.draggable) {
        var hasPosition = props.x !== undefined || props.y !== undefined;
        var hasEvents = props.onDragEnd || props.onDragMove;
        if (hasPosition && !hasEvents) {
            console.warn($c41cca0690581380$var$DRAGGABLE_WARNING);
            $c41cca0690581380$var$dragWarningShowed = true;
        }
    }
    // check old props
    // we need to unset properties that are not in new props
    // and remove all events
    for(var key in oldProps){
        if ($c41cca0690581380$var$propsToSkip[key]) continue;
        var isEvent = key.slice(0, 2) === "on";
        var propChanged = oldProps[key] !== props[key];
        // if that is a changed event, we need to remove it
        if (isEvent && propChanged) {
            var eventName = key.substr(2).toLowerCase();
            if (eventName.substr(0, 7) === "content") eventName = "content" + eventName.substr(7, 1).toUpperCase() + eventName.substr(8);
            instance.off(eventName, oldProps[key]);
        }
        var toRemove = !props.hasOwnProperty(key);
        if (toRemove) instance.setAttr(key, undefined);
    }
    var strictUpdate = $c41cca0690581380$var$useStrictMode || props._useStrictMode;
    var updatedProps = {};
    var hasUpdates = false;
    const newEvents = {};
    for(var key in props){
        if ($c41cca0690581380$var$propsToSkip[key]) continue;
        var isEvent = key.slice(0, 2) === "on";
        var toAdd = oldProps[key] !== props[key];
        if (isEvent && toAdd) {
            var eventName = key.substr(2).toLowerCase();
            if (eventName.substr(0, 7) === "content") eventName = "content" + eventName.substr(7, 1).toUpperCase() + eventName.substr(8);
            // check that event is not undefined
            if (props[key]) newEvents[eventName] = props[key];
        }
        if (!isEvent && (props[key] !== oldProps[key] || strictUpdate && props[key] !== instance.getAttr(key))) {
            hasUpdates = true;
            updatedProps[key] = props[key];
        }
    }
    if (hasUpdates) {
        instance.setAttrs(updatedProps);
        $c41cca0690581380$export$8d64f55d8bab80d4(instance);
    }
    // subscribe to events AFTER we set attrs
    // we need it to fix https://github.com/konvajs/react-konva/issues/471
    // settings attrs may add events. Like "draggable: true" will add "mousedown" listener
    for(var eventName in newEvents)instance.on(eventName + $c41cca0690581380$export$3a20cc353cdae1b2, newEvents[eventName]);
}
function $c41cca0690581380$export$8d64f55d8bab80d4(node) {
    if (!(0, $f1cce3c2a91bf0cf$export$b9f99057a3c7692).autoDrawEnabled) {
        var drawingNode = node.getLayer() || node.getStage();
        drawingNode && drawingNode.batchDraw();
    }
}



var $euyry = parcelRequire("euyry");

const $b7ea2beb2ece2d4a$var$NO_CONTEXT = {};
const $b7ea2beb2ece2d4a$var$UPDATE_SIGNAL = {};
// for react-spring capability
(0, $8bf8c5cb1bb85357$export$2e2bcd8739ae039).Node.prototype._applyProps = (0, $c41cca0690581380$export$25d4dd8d7c7a61f6);
function $b7ea2beb2ece2d4a$export$b1cefef778e97ee8(parentInstance, child) {
    if (typeof child === "string") {
        // Noop for string children of Text (eg <Text>foo</Text>)
        console.error(`Do not use plain text as child of Konva.Node. You are using text: ${child}`);
        return;
    }
    parentInstance.add(child);
    (0, $c41cca0690581380$export$8d64f55d8bab80d4)(parentInstance);
}
function $b7ea2beb2ece2d4a$export$99152e8d49ca4e7d(type, props, internalInstanceHandle) {
    let NodeClass = (0, $8bf8c5cb1bb85357$export$2e2bcd8739ae039)[type];
    if (!NodeClass) {
        console.error(`Konva has no node with the type ${type}. Group will be used instead. If you use minimal version of react-konva, just import required nodes into Konva: "import "konva/lib/shapes/${type}"  If you want to render DOM elements as part of canvas tree take a look into this demo: https://konvajs.github.io/docs/react/DOM_Portal.html`);
        NodeClass = (0, $8bf8c5cb1bb85357$export$2e2bcd8739ae039).Group;
    }
    // we need to split props into events and non events
    // we we can pass non events into constructor directly
    // that way the performance should be better
    // we we apply change "applyNodeProps"
    // then it will trigger change events on first run
    // but we don't need them!
    const propsWithoutEvents = {};
    const propsWithOnlyEvents = {};
    for(var key in props){
        var isEvent = key.slice(0, 2) === "on";
        if (isEvent) propsWithOnlyEvents[key] = props[key];
        else propsWithoutEvents[key] = props[key];
    }
    const instance = new NodeClass(propsWithoutEvents);
    (0, $c41cca0690581380$export$25d4dd8d7c7a61f6)(instance, propsWithOnlyEvents);
    return instance;
}
function $b7ea2beb2ece2d4a$export$d1ef805cf7083486(text, rootContainerInstance, internalInstanceHandle) {
    console.error(`Text components are not supported for now in ReactKonva. Your text is: "${text}"`);
}
function $b7ea2beb2ece2d4a$export$7bb0b211bcb5abfd(domElement, type, props) {
    return false;
}
function $b7ea2beb2ece2d4a$export$d2475cc200518c86(instance) {
    return instance;
}
function $b7ea2beb2ece2d4a$export$ba5994afaabfdb0c() {
    return null;
}
function $b7ea2beb2ece2d4a$export$e15c8ecd0a0092b2() {
    return null;
}
function $b7ea2beb2ece2d4a$export$c885331d842f22b5(domElement, type, oldProps, newProps) {
    return $b7ea2beb2ece2d4a$var$UPDATE_SIGNAL;
}
function $b7ea2beb2ece2d4a$export$683e88f306512aed() {
// Noop
}
function $b7ea2beb2ece2d4a$export$2119d6fc5d6f51aa(domElement) {
// Noop
}
function $b7ea2beb2ece2d4a$export$70ab89a99d11d186(type, props) {
    return false;
}
function $b7ea2beb2ece2d4a$export$dce2ca0b0f5feeb5() {
    return $b7ea2beb2ece2d4a$var$NO_CONTEXT;
}
function $b7ea2beb2ece2d4a$export$1236a84b6992d37a() {
    return $b7ea2beb2ece2d4a$var$NO_CONTEXT;
}
const $b7ea2beb2ece2d4a$export$5f4d6617421d489b = setTimeout;
const $b7ea2beb2ece2d4a$export$f78ec70d8091ca88 = clearTimeout;
const $b7ea2beb2ece2d4a$export$78506abae4a4951d = -1;
function $b7ea2beb2ece2d4a$export$c82139d6d374ec34(type, props) {
    return false;
}
const $b7ea2beb2ece2d4a$export$a5fcb8abea5b71a4 = false;
const $b7ea2beb2ece2d4a$export$2516db7323c01bd5 = true;
const $b7ea2beb2ece2d4a$export$20f97ad47f9ebeb = true;
function $b7ea2beb2ece2d4a$export$1b8e57c9ea42f1d2(parentInstance, child) {
    if (child.parent === parentInstance) child.moveToTop();
    else parentInstance.add(child);
    (0, $c41cca0690581380$export$8d64f55d8bab80d4)(parentInstance);
}
function $b7ea2beb2ece2d4a$export$5e391de19acdf645(parentInstance, child) {
    if (child.parent === parentInstance) child.moveToTop();
    else parentInstance.add(child);
    (0, $c41cca0690581380$export$8d64f55d8bab80d4)(parentInstance);
}
function $b7ea2beb2ece2d4a$export$86b68c7dbeb53c22(parentInstance, child, beforeChild) {
    // child._remove() will not stop dragging
    // but child.remove() will stop it, but we don't need it
    // removing will reset zIndexes
    child._remove();
    parentInstance.add(child);
    child.setZIndex(beforeChild.getZIndex());
    (0, $c41cca0690581380$export$8d64f55d8bab80d4)(parentInstance);
}
function $b7ea2beb2ece2d4a$export$7ec3655259385e44(parentInstance, child, beforeChild) {
    $b7ea2beb2ece2d4a$export$86b68c7dbeb53c22(parentInstance, child, beforeChild);
}
function $b7ea2beb2ece2d4a$export$7ae609f7af59e4f7(parentInstance, child) {
    child.destroy();
    child.off((0, $c41cca0690581380$export$3a20cc353cdae1b2));
    (0, $c41cca0690581380$export$8d64f55d8bab80d4)(parentInstance);
}
function $b7ea2beb2ece2d4a$export$2e4ef5d75a473f1a(parentInstance, child) {
    child.destroy();
    child.off((0, $c41cca0690581380$export$3a20cc353cdae1b2));
    (0, $c41cca0690581380$export$8d64f55d8bab80d4)(parentInstance);
}
function $b7ea2beb2ece2d4a$export$50a92d0155bee474(textInstance, oldText, newText) {
    console.error(`Text components are not yet supported in ReactKonva. You text is: "${newText}"`);
}
function $b7ea2beb2ece2d4a$export$fe90794743fbfeb0(instance, type, newProps) {
// Noop
}
function $b7ea2beb2ece2d4a$export$fd8222818e57ec6(instance, updatePayload, type, oldProps, newProps) {
    (0, $c41cca0690581380$export$25d4dd8d7c7a61f6)(instance, newProps, oldProps);
}
function $b7ea2beb2ece2d4a$export$6db9fd2b8188b8b7(instance) {
    instance.hide();
    (0, $c41cca0690581380$export$8d64f55d8bab80d4)(instance);
}
function $b7ea2beb2ece2d4a$export$17ed9cbd9cb3aad2(textInstance) {
// Noop
}
function $b7ea2beb2ece2d4a$export$933e25c2090d1941(instance, props) {
    if (props.visible == null || props.visible) instance.show();
}
function $b7ea2beb2ece2d4a$export$8ff685cdcb7326ff(textInstance, text) {
// Noop
}
function $b7ea2beb2ece2d4a$export$28e08eff11ac64f6(container) {
// Noop
}
function $b7ea2beb2ece2d4a$export$92ab91999be04e45() {}
const $b7ea2beb2ece2d4a$export$e23f0d5a7e18b951 = ()=>(0, $2e6a749cb91bd087$exports.DefaultEventPriority);




var $69Mlo = parcelRequire("69Mlo");
var $dc948532762f7869$var$__defProp = Object.defineProperty;
var $dc948532762f7869$var$__defProps = Object.defineProperties;
var $dc948532762f7869$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $dc948532762f7869$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $dc948532762f7869$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $dc948532762f7869$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $dc948532762f7869$var$__defNormalProp = (obj, key, value)=>key in obj ? $dc948532762f7869$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $dc948532762f7869$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($dc948532762f7869$var$__hasOwnProp.call(b, prop)) $dc948532762f7869$var$__defNormalProp(a, prop, b[prop]);
    if ($dc948532762f7869$var$__getOwnPropSymbols) {
        for (var prop of $dc948532762f7869$var$__getOwnPropSymbols(b))if ($dc948532762f7869$var$__propIsEnum.call(b, prop)) $dc948532762f7869$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $dc948532762f7869$var$__spreadProps = (a, b)=>$dc948532762f7869$var$__defProps(a, $dc948532762f7869$var$__getOwnPropDescs(b));
var $dc948532762f7869$var$_a, $dc948532762f7869$var$_b;
const $dc948532762f7869$var$useIsomorphicLayoutEffect = typeof window !== "undefined" && ((($dc948532762f7869$var$_a = window.document) == null ? void 0 : $dc948532762f7869$var$_a.createElement) || (($dc948532762f7869$var$_b = window.navigator) == null ? void 0 : $dc948532762f7869$var$_b.product) === "ReactNative") ? $69Mlo.useLayoutEffect : $69Mlo.useEffect;
function $dc948532762f7869$export$e2f435051054a3fd(fiber, ascending, selector) {
    if (!fiber) return;
    if (selector(fiber) === true) return fiber;
    let child = ascending ? fiber.return : fiber.child;
    while(child){
        const match = $dc948532762f7869$export$e2f435051054a3fd(child, ascending, selector);
        if (match) return match;
        child = ascending ? null : child.sibling;
    }
}
function $dc948532762f7869$var$wrapContext(context) {
    try {
        return Object.defineProperties(context, {
            _currentRenderer: {
                get () {
                    return null;
                },
                set () {}
            },
            _currentRenderer2: {
                get () {
                    return null;
                },
                set () {}
            }
        });
    } catch (_) {
        return context;
    }
}
const $dc948532762f7869$var$error = console.error;
console.error = function() {
    const message = [
        ...arguments
    ].join("");
    if ((message == null ? void 0 : message.startsWith("Warning:")) && message.includes("useContext")) {
        console.error = $dc948532762f7869$var$error;
        return;
    }
    return $dc948532762f7869$var$error.apply(this, arguments);
};
const $dc948532762f7869$var$FiberContext = $dc948532762f7869$var$wrapContext($69Mlo.createContext(null));
class $dc948532762f7869$export$5a20fcbfd44d38b7 extends $69Mlo.Component {
    render() {
        return /* @__PURE__ */ $69Mlo.createElement($dc948532762f7869$var$FiberContext.Provider, {
            value: this._reactInternals
        }, this.props.children);
    }
}
function $dc948532762f7869$export$69c8591d5df5c7d6() {
    const root = $69Mlo.useContext($dc948532762f7869$var$FiberContext);
    if (root === null) throw new Error("its-fine: useFiber must be called within a <FiberProvider />!");
    const id = $69Mlo.useId();
    const fiber = $69Mlo.useMemo(()=>{
        for (const maybeFiber of [
            root,
            root == null ? void 0 : root.alternate
        ]){
            if (!maybeFiber) continue;
            const fiber2 = $dc948532762f7869$export$e2f435051054a3fd(maybeFiber, false, (node)=>{
                let state = node.memoizedState;
                while(state){
                    if (state.memoizedState === id) return true;
                    state = state.next;
                }
            });
            if (fiber2) return fiber2;
        }
    }, [
        root,
        id
    ]);
    return fiber;
}
function $dc948532762f7869$export$b537cf6ebaf7ff54() {
    const fiber = $dc948532762f7869$export$69c8591d5df5c7d6();
    const root = $69Mlo.useMemo(()=>$dc948532762f7869$export$e2f435051054a3fd(fiber, true, (node)=>{
            var _a2;
            return ((_a2 = node.stateNode) == null ? void 0 : _a2.containerInfo) != null;
        }), [
        fiber
    ]);
    return root == null ? void 0 : root.stateNode.containerInfo;
}
function $dc948532762f7869$export$aec415ac1d7388b6(type) {
    const fiber = $dc948532762f7869$export$69c8591d5df5c7d6();
    const childRef = $69Mlo.useRef();
    $dc948532762f7869$var$useIsomorphicLayoutEffect(()=>{
        var _a2;
        childRef.current = (_a2 = $dc948532762f7869$export$e2f435051054a3fd(fiber, false, (node)=>typeof node.type === "string" && (type === void 0 || node.type === type))) == null ? void 0 : _a2.stateNode;
    }, [
        fiber
    ]);
    return childRef;
}
function $dc948532762f7869$export$b57c9fdd1434988b(type) {
    const fiber = $dc948532762f7869$export$69c8591d5df5c7d6();
    const parentRef = $69Mlo.useRef();
    $dc948532762f7869$var$useIsomorphicLayoutEffect(()=>{
        var _a2;
        parentRef.current = (_a2 = $dc948532762f7869$export$e2f435051054a3fd(fiber, true, (node)=>typeof node.type === "string" && (type === void 0 || node.type === type))) == null ? void 0 : _a2.stateNode;
    }, [
        fiber
    ]);
    return parentRef;
}
function $dc948532762f7869$export$8859381a76e56404() {
    const fiber = $dc948532762f7869$export$69c8591d5df5c7d6();
    const [contextMap] = $69Mlo.useState(()=>/* @__PURE__ */ new Map());
    contextMap.clear();
    let node = fiber;
    while(node){
        if (node.type && typeof node.type === "object") {
            const enableRenderableContext = node.type._context === void 0 && node.type.Provider === node.type;
            const context = enableRenderableContext ? node.type : node.type._context;
            if (context && context !== $dc948532762f7869$var$FiberContext && !contextMap.has(context)) contextMap.set(context, $69Mlo.useContext($dc948532762f7869$var$wrapContext(context)));
        }
        node = node.return;
    }
    return contextMap;
}
function $dc948532762f7869$export$39579d26c695d393() {
    const contextMap = $dc948532762f7869$export$8859381a76e56404();
    return $69Mlo.useMemo(()=>Array.from(contextMap.keys()).reduce((Prev, context)=>(props)=>/* @__PURE__ */ $69Mlo.createElement(Prev, null, /* @__PURE__ */ $69Mlo.createElement(context.Provider, $dc948532762f7869$var$__spreadProps($dc948532762f7869$var$__spreadValues({}, props), {
                    value: contextMap.get(context)
                }))), (props)=>/* @__PURE__ */ $69Mlo.createElement($dc948532762f7869$export$5a20fcbfd44d38b7, $dc948532762f7869$var$__spreadValues({}, props))), [
        contextMap
    ]);
}


"use strict";
function $03522d94dd76bbd0$var$usePrevious(value) {
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($69Mlo))).useRef({});
    (0, (/*@__PURE__*/$parcel$interopDefault($69Mlo))).useLayoutEffect(()=>{
        ref.current = value;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($69Mlo))).useLayoutEffect(()=>{
        return ()=>{
            // when using suspense it is possible that stage is unmounted
            // but React still keep component ref
            // in that case we need to manually flush props
            // we have a special test for that
            ref.current = {};
        };
    }, []);
    return ref.current;
}
const $03522d94dd76bbd0$var$StageWrap = (props)=>{
    const container = (0, (/*@__PURE__*/$parcel$interopDefault($69Mlo))).useRef();
    const stage = (0, (/*@__PURE__*/$parcel$interopDefault($69Mlo))).useRef();
    const fiberRef = (0, (/*@__PURE__*/$parcel$interopDefault($69Mlo))).useRef();
    const oldProps = $03522d94dd76bbd0$var$usePrevious(props);
    const Bridge = (0, $dc948532762f7869$export$39579d26c695d393)();
    const _setRef = (stage)=>{
        const { forwardedRef: forwardedRef } = props;
        if (!forwardedRef) return;
        if (typeof forwardedRef === "function") forwardedRef(stage);
        else forwardedRef.current = stage;
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($69Mlo))).useLayoutEffect(()=>{
        stage.current = new (0, $8bf8c5cb1bb85357$export$2e2bcd8739ae039).Stage({
            width: props.width,
            height: props.height,
            container: container.current
        });
        _setRef(stage.current);
        // @ts-ignore
        fiberRef.current = $03522d94dd76bbd0$export$1998d71d1bc35390.createContainer(stage.current, (0, $2e6a749cb91bd087$exports.LegacyRoot), false, null);
        $03522d94dd76bbd0$export$1998d71d1bc35390.updateContainer((0, (/*@__PURE__*/$parcel$interopDefault($69Mlo))).createElement(Bridge, {}, props.children), fiberRef.current);
        return ()=>{
            if (!(0, $8bf8c5cb1bb85357$export$2e2bcd8739ae039).isBrowser) return;
            _setRef(null);
            $03522d94dd76bbd0$export$1998d71d1bc35390.updateContainer(null, fiberRef.current, null);
            stage.current.destroy();
        };
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($69Mlo))).useLayoutEffect(()=>{
        _setRef(stage.current);
        (0, $c41cca0690581380$export$25d4dd8d7c7a61f6)(stage.current, props, oldProps);
        $03522d94dd76bbd0$export$1998d71d1bc35390.updateContainer((0, (/*@__PURE__*/$parcel$interopDefault($69Mlo))).createElement(Bridge, {}, props.children), fiberRef.current, null);
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($69Mlo))).createElement("div", {
        ref: container,
        id: props.id,
        accessKey: props.accessKey,
        className: props.className,
        role: props.role,
        style: props.style,
        tabIndex: props.tabIndex,
        title: props.title
    });
};
const $03522d94dd76bbd0$export$936d0764594b6eb3 = "Layer";
const $03522d94dd76bbd0$export$92d64f29192d1118 = "FastLayer";
const $03522d94dd76bbd0$export$eb2fcfdbd7ba97d4 = "Group";
const $03522d94dd76bbd0$export$b04be29aa201d4f5 = "Label";
const $03522d94dd76bbd0$export$c79fc6492f3af13d = "Rect";
const $03522d94dd76bbd0$export$c89a927ffc67e6fa = "Circle";
const $03522d94dd76bbd0$export$80b0269ab108fa11 = "Ellipse";
const $03522d94dd76bbd0$export$28718c7785907330 = "Wedge";
const $03522d94dd76bbd0$export$17d680238e50603e = "Line";
const $03522d94dd76bbd0$export$3075603db8e6204c = "Sprite";
const $03522d94dd76bbd0$export$3e431a229df88919 = "Image";
const $03522d94dd76bbd0$export$5f1af8db9871e1d6 = "Text";
const $03522d94dd76bbd0$export$f7e34a95cc06fac7 = "TextPath";
const $03522d94dd76bbd0$export$1644ba17714857f1 = "Star";
const $03522d94dd76bbd0$export$a6e3577650b6d6d7 = "Ring";
const $03522d94dd76bbd0$export$6ef80ffb606dd232 = "Arc";
const $03522d94dd76bbd0$export$3288d34c523a1192 = "Tag";
const $03522d94dd76bbd0$export$4b2950bdac9b6ee9 = "Path";
const $03522d94dd76bbd0$export$e2ee866164812ecd = "RegularPolygon";
const $03522d94dd76bbd0$export$21b07c8f274aebd5 = "Arrow";
const $03522d94dd76bbd0$export$6428a7f2611ef1fa = "Shape";
const $03522d94dd76bbd0$export$f993aef960936087 = "Transformer";
const $03522d94dd76bbd0$export$1998d71d1bc35390 = (0, (/*@__PURE__*/$parcel$interopDefault($a597390ea3f469a5$exports)))($b7ea2beb2ece2d4a$exports);
$03522d94dd76bbd0$export$1998d71d1bc35390.injectIntoDevTools({
    // @ts-ignore
    findHostInstanceByFiber: ()=>null,
    bundleType: 0,
    version: (0, (/*@__PURE__*/$parcel$interopDefault($69Mlo))).version,
    rendererPackageName: "react-konva"
});
const $03522d94dd76bbd0$export$208cd1682bd0e4b6 = (0, (/*@__PURE__*/$parcel$interopDefault($69Mlo))).forwardRef((props, ref)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($69Mlo))).createElement((0, $dc948532762f7869$export$5a20fcbfd44d38b7), {}, (0, (/*@__PURE__*/$parcel$interopDefault($69Mlo))).createElement($03522d94dd76bbd0$var$StageWrap, {
        ...props,
        forwardedRef: ref
    }));
});
const $03522d94dd76bbd0$export$2e548393fba9b338 = (0, $c41cca0690581380$export$5a38dcef855281ce);


"use strict";


const $b6ca3dd5c1566f88$var$dark = {
    fgColor: "white",
    bgColor: "#231F20"
};
const $b6ca3dd5c1566f88$var$light = {
    fgColor: "black",
    bgColor: "white"
};
const $b6ca3dd5c1566f88$export$1d8e462b9ec86de2 = {
    Dark: $b6ca3dd5c1566f88$var$dark,
    Light: $b6ca3dd5c1566f88$var$light
};


var $0c2016b6cbdb1dee$exports = {};
$0c2016b6cbdb1dee$exports = new URL("md-logo.dcf23458.png", import.meta.url).toString();


var $1cb6f77dbd191419$exports = {};
"use strict";
Object.defineProperty($1cb6f77dbd191419$exports, "__esModule", {
    value: true
});
$1cb6f77dbd191419$exports.changeDpiBlob = $1cb6f77dbd191419$var$changeDpiBlob;
$1cb6f77dbd191419$exports.changeDpiDataUrl = $1cb6f77dbd191419$var$changeDpiDataUrl;
function $1cb6f77dbd191419$var$_toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    } else return Array.from(arr);
}
function $1cb6f77dbd191419$var$createPngDataTable() {
    /* Table of CRCs of all 8-bit messages. */ var crcTable = new Int32Array(256);
    for(var n = 0; n < 256; n++){
        var c = n;
        for(var k = 0; k < 8; k++)c = c & 1 ? 0xedb88320 ^ c >>> 1 : c >>> 1;
        crcTable[n] = c;
    }
    return crcTable;
}
function $1cb6f77dbd191419$var$calcCrc(buf) {
    var c = -1;
    if (!$1cb6f77dbd191419$var$pngDataTable) $1cb6f77dbd191419$var$pngDataTable = $1cb6f77dbd191419$var$createPngDataTable();
    for(var n = 0; n < buf.length; n++)c = $1cb6f77dbd191419$var$pngDataTable[(c ^ buf[n]) & 0xFF] ^ c >>> 8;
    return c ^ -1;
}
var $1cb6f77dbd191419$var$pngDataTable = void 0;
var $1cb6f77dbd191419$var$PNG = "image/png";
var $1cb6f77dbd191419$var$JPEG = "image/jpeg";
// those are 3 possible signature of the physBlock in base64.
// the pHYs signature block is preceed by the 4 bytes of lenght. The length of
// the block is always 9 bytes. So a phys block has always this signature:
// 0 0 0 9 p H Y s.
// However the data64 encoding aligns we will always find one of those 3 strings.
// this allow us to find this particular occurence of the pHYs block without
// converting from b64 back to string
var $1cb6f77dbd191419$var$b64PhysSignature1 = "AAlwSFlz";
var $1cb6f77dbd191419$var$b64PhysSignature2 = "AAAJcEhZ";
var $1cb6f77dbd191419$var$b64PhysSignature3 = "AAAACXBI";
var $1cb6f77dbd191419$var$_P = "p".charCodeAt(0);
var $1cb6f77dbd191419$var$_H = "H".charCodeAt(0);
var $1cb6f77dbd191419$var$_Y = "Y".charCodeAt(0);
var $1cb6f77dbd191419$var$_S = "s".charCodeAt(0);
function $1cb6f77dbd191419$var$changeDpiBlob(blob, dpi) {
    // 33 bytes are ok for pngs and jpegs
    // to contain the information.
    var headerChunk = blob.slice(0, 33);
    return new Promise(function(resolve, reject) {
        var fileReader = new FileReader();
        fileReader.onload = function() {
            var dataArray = new Uint8Array(fileReader.result);
            var tail = blob.slice(33);
            var changedArray = $1cb6f77dbd191419$var$changeDpiOnArray(dataArray, dpi, blob.type);
            resolve(new Blob([
                changedArray,
                tail
            ], {
                type: blob.type
            }));
        };
        fileReader.readAsArrayBuffer(headerChunk);
    });
}
function $1cb6f77dbd191419$var$changeDpiDataUrl(base64Image, dpi) {
    var dataSplitted = base64Image.split(",");
    var format = dataSplitted[0];
    var body = dataSplitted[1];
    var type = void 0;
    var headerLength = void 0;
    var overwritepHYs = false;
    if (format.indexOf($1cb6f77dbd191419$var$PNG) !== -1) {
        type = $1cb6f77dbd191419$var$PNG;
        var b64Index = $1cb6f77dbd191419$var$detectPhysChunkFromDataUrl(body);
        // 28 bytes in dataUrl are 21bytes, length of phys chunk with everything inside.
        if (b64Index >= 0) {
            headerLength = Math.ceil((b64Index + 28) / 3) * 4;
            overwritepHYs = true;
        } else headerLength = 44;
    }
    if (format.indexOf($1cb6f77dbd191419$var$JPEG) !== -1) {
        type = $1cb6f77dbd191419$var$JPEG;
        headerLength = 24;
    }
    // 33 bytes are ok for pngs and jpegs
    // to contain the information.
    var stringHeader = body.substring(0, headerLength);
    var restOfData = body.substring(headerLength);
    var headerBytes = atob(stringHeader);
    var dataArray = new Uint8Array(headerBytes.length);
    for(var i = 0; i < dataArray.length; i++)dataArray[i] = headerBytes.charCodeAt(i);
    var finalArray = $1cb6f77dbd191419$var$changeDpiOnArray(dataArray, dpi, type, overwritepHYs);
    var base64Header = btoa(String.fromCharCode.apply(String, $1cb6f77dbd191419$var$_toConsumableArray(finalArray)));
    return [
        format,
        ",",
        base64Header,
        restOfData
    ].join("");
}
function $1cb6f77dbd191419$var$detectPhysChunkFromDataUrl(data) {
    var b64index = data.indexOf($1cb6f77dbd191419$var$b64PhysSignature1);
    if (b64index === -1) b64index = data.indexOf($1cb6f77dbd191419$var$b64PhysSignature2);
    if (b64index === -1) b64index = data.indexOf($1cb6f77dbd191419$var$b64PhysSignature3);
    // if b64index === -1 chunk is not found
    return b64index;
}
function $1cb6f77dbd191419$var$searchStartOfPhys(data) {
    var length = data.length - 1;
    // we check from the end since we cut the string in proximity of the header
    // the header is within 21 bytes from the end.
    for(var i = length; i >= 4; i--){
        if (data[i - 4] === 9 && data[i - 3] === $1cb6f77dbd191419$var$_P && data[i - 2] === $1cb6f77dbd191419$var$_H && data[i - 1] === $1cb6f77dbd191419$var$_Y && data[i] === $1cb6f77dbd191419$var$_S) return i - 3;
    }
}
function $1cb6f77dbd191419$var$changeDpiOnArray(dataArray, dpi, format, overwritepHYs) {
    if (format === $1cb6f77dbd191419$var$JPEG) {
        dataArray[13] = 1; // 1 pixel per inch or 2 pixel per cm
        dataArray[14] = dpi >> 8; // dpiX high byte
        dataArray[15] = dpi & 0xff; // dpiX low byte
        dataArray[16] = dpi >> 8; // dpiY high byte
        dataArray[17] = dpi & 0xff; // dpiY low byte
        return dataArray;
    }
    if (format === $1cb6f77dbd191419$var$PNG) {
        var physChunk = new Uint8Array(13);
        // chunk header pHYs
        // 9 bytes of data
        // 4 bytes of crc
        // this multiplication is because the standard is dpi per meter.
        dpi *= 39.3701;
        physChunk[0] = $1cb6f77dbd191419$var$_P;
        physChunk[1] = $1cb6f77dbd191419$var$_H;
        physChunk[2] = $1cb6f77dbd191419$var$_Y;
        physChunk[3] = $1cb6f77dbd191419$var$_S;
        physChunk[4] = dpi >>> 24; // dpiX highest byte
        physChunk[5] = dpi >>> 16; // dpiX veryhigh byte
        physChunk[6] = dpi >>> 8; // dpiX high byte
        physChunk[7] = dpi & 0xff; // dpiX low byte
        physChunk[8] = physChunk[4]; // dpiY highest byte
        physChunk[9] = physChunk[5]; // dpiY veryhigh byte
        physChunk[10] = physChunk[6]; // dpiY high byte
        physChunk[11] = physChunk[7]; // dpiY low byte
        physChunk[12] = 1; // dot per meter....
        var crc = $1cb6f77dbd191419$var$calcCrc(physChunk);
        var crcChunk = new Uint8Array(4);
        crcChunk[0] = crc >>> 24;
        crcChunk[1] = crc >>> 16;
        crcChunk[2] = crc >>> 8;
        crcChunk[3] = crc & 0xff;
        if (overwritepHYs) {
            var startingIndex = $1cb6f77dbd191419$var$searchStartOfPhys(dataArray);
            dataArray.set(physChunk, startingIndex);
            dataArray.set(crcChunk, startingIndex + 13);
            return dataArray;
        } else {
            // i need to give back an array of data that is divisible by 3 so that
            // dataurl encoding gives me integers, for luck this chunk is 17 + 4 = 21
            // if it was we could add a text chunk contaning some info, untill desired
            // length is met.
            // chunk structur 4 bytes for length is 9
            var chunkLength = new Uint8Array(4);
            chunkLength[0] = 0;
            chunkLength[1] = 0;
            chunkLength[2] = 0;
            chunkLength[3] = 9;
            var finalHeader = new Uint8Array(54);
            finalHeader.set(dataArray, 0);
            finalHeader.set(chunkLength, 33);
            finalHeader.set(physChunk, 37);
            finalHeader.set(crcChunk, 50);
            return finalHeader;
        }
    }
}


var $4852980c32d42d7f$exports = {};
/* Web Font Loader v1.6.28 - (c) Adobe Systems, Google. License: Apache 2.0 */ (function() {
    function aa(a, b, c) {
        return a.call.apply(a.bind, arguments);
    }
    function ba(a, b, c) {
        if (!a) throw Error();
        if (2 < arguments.length) {
            var d = Array.prototype.slice.call(arguments, 2);
            return function() {
                var c = Array.prototype.slice.call(arguments);
                Array.prototype.unshift.apply(c, d);
                return a.apply(b, c);
            };
        }
        return function() {
            return a.apply(b, arguments);
        };
    }
    function p(a, b, c) {
        p = Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? aa : ba;
        return p.apply(null, arguments);
    }
    var q = Date.now || function() {
        return +new Date;
    };
    function ca(a, b) {
        this.a = a;
        this.o = b || a;
        this.c = this.o.document;
    }
    var da = !!window.FontFace;
    function t(a, b, c, d) {
        b = a.c.createElement(b);
        if (c) for(var e in c)c.hasOwnProperty(e) && ("style" == e ? b.style.cssText = c[e] : b.setAttribute(e, c[e]));
        d && b.appendChild(a.c.createTextNode(d));
        return b;
    }
    function u(a, b, c) {
        a = a.c.getElementsByTagName(b)[0];
        a || (a = document.documentElement);
        a.insertBefore(c, a.lastChild);
    }
    function v(a) {
        a.parentNode && a.parentNode.removeChild(a);
    }
    function w(a, b, c) {
        b = b || [];
        c = c || [];
        for(var d = a.className.split(/\s+/), e = 0; e < b.length; e += 1){
            for(var f = !1, g = 0; g < d.length; g += 1)if (b[e] === d[g]) {
                f = !0;
                break;
            }
            f || d.push(b[e]);
        }
        b = [];
        for(e = 0; e < d.length; e += 1){
            f = !1;
            for(g = 0; g < c.length; g += 1)if (d[e] === c[g]) {
                f = !0;
                break;
            }
            f || b.push(d[e]);
        }
        a.className = b.join(" ").replace(/\s+/g, " ").replace(/^\s+|\s+$/, "");
    }
    function y(a, b) {
        for(var c = a.className.split(/\s+/), d = 0, e = c.length; d < e; d++)if (c[d] == b) return !0;
        return !1;
    }
    function ea(a) {
        return a.o.location.hostname || a.a.location.hostname;
    }
    function z(a, b, c) {
        function d() {
            m && e && f && (m(g), m = null);
        }
        b = t(a, "link", {
            rel: "stylesheet",
            href: b,
            media: "all"
        });
        var e = !1, f = !0, g = null, m = c || null;
        da ? (b.onload = function() {
            e = !0;
            d();
        }, b.onerror = function() {
            e = !0;
            g = Error("Stylesheet failed to load");
            d();
        }) : setTimeout(function() {
            e = !0;
            d();
        }, 0);
        u(a, "head", b);
    }
    function A(a, b, c, d) {
        var e = a.c.getElementsByTagName("head")[0];
        if (e) {
            var f = t(a, "script", {
                src: b
            }), g = !1;
            f.onload = f.onreadystatechange = function() {
                g || this.readyState && "loaded" != this.readyState && "complete" != this.readyState || (g = !0, c && c(null), f.onload = f.onreadystatechange = null, "HEAD" == f.parentNode.tagName && e.removeChild(f));
            };
            e.appendChild(f);
            setTimeout(function() {
                g || (g = !0, c && c(Error("Script load timeout")));
            }, d || 5E3);
            return f;
        }
        return null;
    }
    function B() {
        this.a = 0;
        this.c = null;
    }
    function C(a) {
        a.a++;
        return function() {
            a.a--;
            D(a);
        };
    }
    function E(a, b) {
        a.c = b;
        D(a);
    }
    function D(a) {
        0 == a.a && a.c && (a.c(), a.c = null);
    }
    function F(a) {
        this.a = a || "-";
    }
    F.prototype.c = function(a) {
        for(var b = [], c = 0; c < arguments.length; c++)b.push(arguments[c].replace(/[\W_]+/g, "").toLowerCase());
        return b.join(this.a);
    };
    function G(a, b) {
        this.c = a;
        this.f = 4;
        this.a = "n";
        var c = (b || "n4").match(/^([nio])([1-9])$/i);
        c && (this.a = c[1], this.f = parseInt(c[2], 10));
    }
    function fa(a) {
        return H(a) + " " + (a.f + "00") + " 300px " + I(a.c);
    }
    function I(a) {
        var b = [];
        a = a.split(/,\s*/);
        for(var c = 0; c < a.length; c++){
            var d = a[c].replace(/['"]/g, "");
            -1 != d.indexOf(" ") || /^\d/.test(d) ? b.push("'" + d + "'") : b.push(d);
        }
        return b.join(",");
    }
    function J(a) {
        return a.a + a.f;
    }
    function H(a) {
        var b = "normal";
        "o" === a.a ? b = "oblique" : "i" === a.a && (b = "italic");
        return b;
    }
    function ga(a) {
        var b = 4, c = "n", d = null;
        a && ((d = a.match(/(normal|oblique|italic)/i)) && d[1] && (c = d[1].substr(0, 1).toLowerCase()), (d = a.match(/([1-9]00|normal|bold)/i)) && d[1] && (/bold/i.test(d[1]) ? b = 7 : /[1-9]00/.test(d[1]) && (b = parseInt(d[1].substr(0, 1), 10))));
        return c + b;
    }
    function ha(a, b) {
        this.c = a;
        this.f = a.o.document.documentElement;
        this.h = b;
        this.a = new F("-");
        this.j = !1 !== b.events;
        this.g = !1 !== b.classes;
    }
    function ia(a) {
        a.g && w(a.f, [
            a.a.c("wf", "loading")
        ]);
        K(a, "loading");
    }
    function L(a) {
        if (a.g) {
            var b = y(a.f, a.a.c("wf", "active")), c = [], d = [
                a.a.c("wf", "loading")
            ];
            b || c.push(a.a.c("wf", "inactive"));
            w(a.f, c, d);
        }
        K(a, "inactive");
    }
    function K(a, b, c) {
        if (a.j && a.h[b]) {
            if (c) a.h[b](c.c, J(c));
            else a.h[b]();
        }
    }
    function ja() {
        this.c = {};
    }
    function ka(a, b, c) {
        var d = [], e;
        for(e in b)if (b.hasOwnProperty(e)) {
            var f = a.c[e];
            f && d.push(f(b[e], c));
        }
        return d;
    }
    function M(a, b) {
        this.c = a;
        this.f = b;
        this.a = t(this.c, "span", {
            "aria-hidden": "true"
        }, this.f);
    }
    function N(a) {
        u(a.c, "body", a.a);
    }
    function O(a) {
        return "display:block;position:absolute;top:-9999px;left:-9999px;font-size:300px;width:auto;height:auto;line-height:normal;margin:0;padding:0;font-variant:normal;white-space:nowrap;font-family:" + I(a.c) + ";" + ("font-style:" + H(a) + ";font-weight:" + (a.f + "00") + ";");
    }
    function P(a, b, c, d, e, f) {
        this.g = a;
        this.j = b;
        this.a = d;
        this.c = c;
        this.f = e || 3E3;
        this.h = f || void 0;
    }
    P.prototype.start = function() {
        var a = this.c.o.document, b = this, c = q(), d = new Promise(function(d, e) {
            function f() {
                q() - c >= b.f ? e() : a.fonts.load(fa(b.a), b.h).then(function(a) {
                    1 <= a.length ? d() : setTimeout(f, 25);
                }, function() {
                    e();
                });
            }
            f();
        }), e = null, f = new Promise(function(a, d) {
            e = setTimeout(d, b.f);
        });
        Promise.race([
            f,
            d
        ]).then(function() {
            e && (clearTimeout(e), e = null);
            b.g(b.a);
        }, function() {
            b.j(b.a);
        });
    };
    function Q(a, b, c, d, e, f, g) {
        this.v = a;
        this.B = b;
        this.c = c;
        this.a = d;
        this.s = g || "BESbswy";
        this.f = {};
        this.w = e || 3E3;
        this.u = f || null;
        this.m = this.j = this.h = this.g = null;
        this.g = new M(this.c, this.s);
        this.h = new M(this.c, this.s);
        this.j = new M(this.c, this.s);
        this.m = new M(this.c, this.s);
        a = new G(this.a.c + ",serif", J(this.a));
        a = O(a);
        this.g.a.style.cssText = a;
        a = new G(this.a.c + ",sans-serif", J(this.a));
        a = O(a);
        this.h.a.style.cssText = a;
        a = new G("serif", J(this.a));
        a = O(a);
        this.j.a.style.cssText = a;
        a = new G("sans-serif", J(this.a));
        a = O(a);
        this.m.a.style.cssText = a;
        N(this.g);
        N(this.h);
        N(this.j);
        N(this.m);
    }
    var R = {
        D: "serif",
        C: "sans-serif"
    }, S = null;
    function T() {
        if (null === S) {
            var a = /AppleWebKit\/([0-9]+)(?:\.([0-9]+))/.exec(window.navigator.userAgent);
            S = !!a && (536 > parseInt(a[1], 10) || 536 === parseInt(a[1], 10) && 11 >= parseInt(a[2], 10));
        }
        return S;
    }
    Q.prototype.start = function() {
        this.f.serif = this.j.a.offsetWidth;
        this.f["sans-serif"] = this.m.a.offsetWidth;
        this.A = q();
        U(this);
    };
    function la(a, b, c) {
        for(var d in R)if (R.hasOwnProperty(d) && b === a.f[R[d]] && c === a.f[R[d]]) return !0;
        return !1;
    }
    function U(a) {
        var b = a.g.a.offsetWidth, c = a.h.a.offsetWidth, d;
        (d = b === a.f.serif && c === a.f["sans-serif"]) || (d = T() && la(a, b, c));
        d ? q() - a.A >= a.w ? T() && la(a, b, c) && (null === a.u || a.u.hasOwnProperty(a.a.c)) ? V(a, a.v) : V(a, a.B) : ma(a) : V(a, a.v);
    }
    function ma(a) {
        setTimeout(p(function() {
            U(this);
        }, a), 50);
    }
    function V(a, b) {
        setTimeout(p(function() {
            v(this.g.a);
            v(this.h.a);
            v(this.j.a);
            v(this.m.a);
            b(this.a);
        }, a), 0);
    }
    function W(a, b, c) {
        this.c = a;
        this.a = b;
        this.f = 0;
        this.m = this.j = !1;
        this.s = c;
    }
    var X = null;
    W.prototype.g = function(a) {
        var b = this.a;
        b.g && w(b.f, [
            b.a.c("wf", a.c, J(a).toString(), "active")
        ], [
            b.a.c("wf", a.c, J(a).toString(), "loading"),
            b.a.c("wf", a.c, J(a).toString(), "inactive")
        ]);
        K(b, "fontactive", a);
        this.m = !0;
        na(this);
    };
    W.prototype.h = function(a) {
        var b = this.a;
        if (b.g) {
            var c = y(b.f, b.a.c("wf", a.c, J(a).toString(), "active")), d = [], e = [
                b.a.c("wf", a.c, J(a).toString(), "loading")
            ];
            c || d.push(b.a.c("wf", a.c, J(a).toString(), "inactive"));
            w(b.f, d, e);
        }
        K(b, "fontinactive", a);
        na(this);
    };
    function na(a) {
        0 == --a.f && a.j && (a.m ? (a = a.a, a.g && w(a.f, [
            a.a.c("wf", "active")
        ], [
            a.a.c("wf", "loading"),
            a.a.c("wf", "inactive")
        ]), K(a, "active")) : L(a.a));
    }
    function oa(a) {
        this.j = a;
        this.a = new ja;
        this.h = 0;
        this.f = this.g = !0;
    }
    oa.prototype.load = function(a) {
        this.c = new ca(this.j, a.context || this.j);
        this.g = !1 !== a.events;
        this.f = !1 !== a.classes;
        pa(this, new ha(this.c, a), a);
    };
    function qa(a, b, c, d, e) {
        var f = 0 == --a.h;
        (a.f || a.g) && setTimeout(function() {
            var a = e || null, m = d || null || {};
            if (0 === c.length && f) L(b.a);
            else {
                b.f += c.length;
                f && (b.j = f);
                var h, l = [];
                for(h = 0; h < c.length; h++){
                    var k = c[h], n = m[k.c], r = b.a, x = k;
                    r.g && w(r.f, [
                        r.a.c("wf", x.c, J(x).toString(), "loading")
                    ]);
                    K(r, "fontloading", x);
                    r = null;
                    if (null === X) {
                        if (window.FontFace) {
                            var x = /Gecko.*Firefox\/(\d+)/.exec(window.navigator.userAgent), xa = /OS X.*Version\/10\..*Safari/.exec(window.navigator.userAgent) && /Apple/.exec(window.navigator.vendor);
                            X = x ? 42 < parseInt(x[1], 10) : xa ? !1 : !0;
                        } else X = !1;
                    }
                    X ? r = new P(p(b.g, b), p(b.h, b), b.c, k, b.s, n) : r = new Q(p(b.g, b), p(b.h, b), b.c, k, b.s, a, n);
                    l.push(r);
                }
                for(h = 0; h < l.length; h++)l[h].start();
            }
        }, 0);
    }
    function pa(a, b, c) {
        var d = [], e = c.timeout;
        ia(b);
        var d = ka(a.a, c, a.c), f = new W(a.c, b, e);
        a.h = d.length;
        b = 0;
        for(c = d.length; b < c; b++)d[b].load(function(b, d, c) {
            qa(a, f, b, d, c);
        });
    }
    function ra(a, b) {
        this.c = a;
        this.a = b;
    }
    ra.prototype.load = function(a) {
        function b() {
            if (f["__mti_fntLst" + d]) {
                var c = f["__mti_fntLst" + d](), e = [], h;
                if (c) for(var l = 0; l < c.length; l++){
                    var k = c[l].fontfamily;
                    void 0 != c[l].fontStyle && void 0 != c[l].fontWeight ? (h = c[l].fontStyle + c[l].fontWeight, e.push(new G(k, h))) : e.push(new G(k));
                }
                a(e);
            } else setTimeout(function() {
                b();
            }, 50);
        }
        var c = this, d = c.a.projectId, e = c.a.version;
        if (d) {
            var f = c.c.o;
            A(this.c, (c.a.api || "https://fast.fonts.net/jsapi") + "/" + d + ".js" + (e ? "?v=" + e : ""), function(e) {
                e ? a([]) : (f["__MonotypeConfiguration__" + d] = function() {
                    return c.a;
                }, b());
            }).id = "__MonotypeAPIScript__" + d;
        } else a([]);
    };
    function sa(a, b) {
        this.c = a;
        this.a = b;
    }
    sa.prototype.load = function(a) {
        var b, c, d = this.a.urls || [], e = this.a.families || [], f = this.a.testStrings || {}, g = new B;
        b = 0;
        for(c = d.length; b < c; b++)z(this.c, d[b], C(g));
        var m = [];
        b = 0;
        for(c = e.length; b < c; b++)if (d = e[b].split(":"), d[1]) for(var h = d[1].split(","), l = 0; l < h.length; l += 1)m.push(new G(d[0], h[l]));
        else m.push(new G(d[0]));
        E(g, function() {
            a(m, f);
        });
    };
    function ta(a, b) {
        a ? this.c = a : this.c = ua;
        this.a = [];
        this.f = [];
        this.g = b || "";
    }
    var ua = "https://fonts.googleapis.com/css";
    function va(a, b) {
        for(var c = b.length, d = 0; d < c; d++){
            var e = b[d].split(":");
            3 == e.length && a.f.push(e.pop());
            var f = "";
            2 == e.length && "" != e[1] && (f = ":");
            a.a.push(e.join(f));
        }
    }
    function wa(a) {
        if (0 == a.a.length) throw Error("No fonts to load!");
        if (-1 != a.c.indexOf("kit=")) return a.c;
        for(var b = a.a.length, c = [], d = 0; d < b; d++)c.push(a.a[d].replace(/ /g, "+"));
        b = a.c + "?family=" + c.join("%7C");
        0 < a.f.length && (b += "&subset=" + a.f.join(","));
        0 < a.g.length && (b += "&text=" + encodeURIComponent(a.g));
        return b;
    }
    function ya(a) {
        this.f = a;
        this.a = [];
        this.c = {};
    }
    var za = {
        latin: "BESbswy",
        "latin-ext": "\xe7\xf6\xfc\u011F\u015F",
        cyrillic: "\u0439\u044F\u0416",
        greek: "\u03B1\u03B2\u03A3",
        khmer: "\u1780\u1781\u1782",
        Hanuman: "\u1780\u1781\u1782"
    }, Aa = {
        thin: "1",
        extralight: "2",
        "extra-light": "2",
        ultralight: "2",
        "ultra-light": "2",
        light: "3",
        regular: "4",
        book: "4",
        medium: "5",
        "semi-bold": "6",
        semibold: "6",
        "demi-bold": "6",
        demibold: "6",
        bold: "7",
        "extra-bold": "8",
        extrabold: "8",
        "ultra-bold": "8",
        ultrabold: "8",
        black: "9",
        heavy: "9",
        l: "3",
        r: "4",
        b: "7"
    }, Ba = {
        i: "i",
        italic: "i",
        n: "n",
        normal: "n"
    }, Ca = /^(thin|(?:(?:extra|ultra)-?)?light|regular|book|medium|(?:(?:semi|demi|extra|ultra)-?)?bold|black|heavy|l|r|b|[1-9]00)?(n|i|normal|italic)?$/;
    function Da(a) {
        for(var b = a.f.length, c = 0; c < b; c++){
            var d = a.f[c].split(":"), e = d[0].replace(/\+/g, " "), f = [
                "n4"
            ];
            if (2 <= d.length) {
                var g;
                var m = d[1];
                g = [];
                if (m) for(var m = m.split(","), h = m.length, l = 0; l < h; l++){
                    var k;
                    k = m[l];
                    if (k.match(/^[\w-]+$/)) {
                        var n = Ca.exec(k.toLowerCase());
                        if (null == n) k = "";
                        else {
                            k = n[2];
                            k = null == k || "" == k ? "n" : Ba[k];
                            n = n[1];
                            if (null == n || "" == n) n = "4";
                            else var r = Aa[n], n = r ? r : isNaN(n) ? "4" : n.substr(0, 1);
                            k = [
                                k,
                                n
                            ].join("");
                        }
                    } else k = "";
                    k && g.push(k);
                }
                0 < g.length && (f = g);
                3 == d.length && (d = d[2], g = [], d = d ? d.split(",") : g, 0 < d.length && (d = za[d[0]]) && (a.c[e] = d));
            }
            a.c[e] || (d = za[e]) && (a.c[e] = d);
            for(d = 0; d < f.length; d += 1)a.a.push(new G(e, f[d]));
        }
    }
    function Ea(a, b) {
        this.c = a;
        this.a = b;
    }
    var Fa = {
        Arimo: !0,
        Cousine: !0,
        Tinos: !0
    };
    Ea.prototype.load = function(a) {
        var b = new B, c = this.c, d = new ta(this.a.api, this.a.text), e = this.a.families;
        va(d, e);
        var f = new ya(e);
        Da(f);
        z(c, wa(d), C(b));
        E(b, function() {
            a(f.a, f.c, Fa);
        });
    };
    function Ga(a, b) {
        this.c = a;
        this.a = b;
    }
    Ga.prototype.load = function(a) {
        var b = this.a.id, c = this.c.o;
        b ? A(this.c, (this.a.api || "https://use.typekit.net") + "/" + b + ".js", function(b) {
            if (b) a([]);
            else if (c.Typekit && c.Typekit.config && c.Typekit.config.fn) {
                b = c.Typekit.config.fn;
                for(var e = [], f = 0; f < b.length; f += 2)for(var g = b[f], m = b[f + 1], h = 0; h < m.length; h++)e.push(new G(g, m[h]));
                try {
                    c.Typekit.load({
                        events: !1,
                        classes: !1,
                        async: !0
                    });
                } catch (l) {}
                a(e);
            }
        }, 2E3) : a([]);
    };
    function Ha(a, b) {
        this.c = a;
        this.f = b;
        this.a = [];
    }
    Ha.prototype.load = function(a) {
        var b = this.f.id, c = this.c.o, d = this;
        b ? (c.__webfontfontdeckmodule__ || (c.__webfontfontdeckmodule__ = {}), c.__webfontfontdeckmodule__[b] = function(b, c) {
            for(var g = 0, m = c.fonts.length; g < m; ++g){
                var h = c.fonts[g];
                d.a.push(new G(h.name, ga("font-weight:" + h.weight + ";font-style:" + h.style)));
            }
            a(d.a);
        }, A(this.c, (this.f.api || "https://f.fontdeck.com/s/css/js/") + ea(this.c) + "/" + b + ".js", function(b) {
            b && a([]);
        })) : a([]);
    };
    var Y = new oa(window);
    Y.a.c.custom = function(a, b) {
        return new sa(b, a);
    };
    Y.a.c.fontdeck = function(a, b) {
        return new Ha(b, a);
    };
    Y.a.c.monotype = function(a, b) {
        return new ra(b, a);
    };
    Y.a.c.typekit = function(a, b) {
        return new Ga(b, a);
    };
    Y.a.c.google = function(a, b) {
        return new Ea(b, a);
    };
    var Z = {
        load: p(Y.load, Y)
    };
    "function" === typeof define && define.amd ? define(function() {
        return Z;
    }) : (0, $4852980c32d42d7f$exports) ? $4852980c32d42d7f$exports = Z : (window.WebFont = Z, window.WebFontConfig && Y.load(window.WebFontConfig));
})();


const $806b4f03ea604a37$var$PPM_FACTOR = 11.811;
function $806b4f03ea604a37$var$calculateCentering(containerHeight, elementHeight, yOffset = 0) {
    return (containerHeight - elementHeight) / 2 + yOffset;
}
const $806b4f03ea604a37$var$AlbumArt = ({ src: src, width: width, height: height, x: x, y: y })=>{
    const [displayWidth, setDisplayWidth] = (0, $69Mlo.useState)(width);
    const [displayHeight, setDisplayHeight] = (0, $69Mlo.useState)(height);
    const [scaleFactor, setScaleFactor] = (0, $69Mlo.useState)(1);
    const image = new Image();
    image.crossOrigin = "anonymous";
    image.addEventListener("load", ()=>{
        if (image.width >= image.height) {
            setDisplayWidth(width);
            setScaleFactor(width / image.width);
            setDisplayHeight(image.height * scaleFactor);
        } else {
            setDisplayHeight(height);
            setScaleFactor(height / image.height);
            setDisplayWidth(image.width * scaleFactor);
        }
    });
    image.src = src;
    return /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsx)((0, $03522d94dd76bbd0$export$3e431a229df88919), {
        image: image,
        x: $806b4f03ea604a37$var$calculateCentering(width, displayWidth, x),
        y: $806b4f03ea604a37$var$calculateCentering(height, displayHeight, y),
        width: displayWidth,
        height: displayHeight
    });
};
const $806b4f03ea604a37$var$MDLogo = ({ x: x, y: y, headerHeight: headerHeight })=>{
    const [displayWidth, setDisplayWidth] = (0, $69Mlo.useState)(0);
    const [displayHeight, setDisplayHeight] = (0, $69Mlo.useState)(0);
    const image = new Image();
    image.crossOrigin = "anonymous";
    image.addEventListener("load", ()=>{
        setDisplayHeight(image.height / $806b4f03ea604a37$var$PPM_FACTOR);
        setDisplayWidth(image.width / $806b4f03ea604a37$var$PPM_FACTOR);
    });
    image.src = $0c2016b6cbdb1dee$exports;
    return /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsx)((0, $03522d94dd76bbd0$export$3e431a229df88919), {
        image: image,
        x: x - displayWidth,
        y: $806b4f03ea604a37$var$calculateCentering(headerHeight, displayHeight, y),
        width: displayWidth,
        height: displayHeight
    });
};
const $806b4f03ea604a37$var$Meta = ({ artist: artist, album: album, year: year, color: color, fontSize: fontSize, lineHeight: lineHeight, containerHeight: containerHeight, yOffset: yOffset, margin: margin, font: font, width: width })=>{
    const combinedString = (0, $69Mlo.useMemo)(()=>{
        return [
            album,
            artist,
            year
        ].join("\n");
    }, [
        artist,
        album,
        year
    ]);
    return /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsx)((0, $03522d94dd76bbd0$export$5f1af8db9871e1d6), {
        fontSize: fontSize,
        text: combinedString,
        fontFamily: font,
        fontVariant: "bold",
        fill: color,
        x: margin,
        y: yOffset,
        lineHeight: lineHeight / fontSize,
        width: width - margin * 2,
        height: containerHeight,
        verticalAlign: "middle"
    });
};
const $806b4f03ea604a37$export$66d167152c83103b = ({ width: width, height: height, theme: theme = (0, $b6ca3dd5c1566f88$export$1d8e462b9ec86de2).Dark, leftMargin: leftMargin, headerHeight: headerHeight, fontSize: fontSize, lineHeight: lineHeight, metaContainerHeight: metaContainerHeight, meta: meta, uppercase: uppercase, font: font })=>{
    const ARROW_HEIGHT = 1.25;
    const ARROW_Y = $806b4f03ea604a37$var$calculateCentering(headerHeight, ARROW_HEIGHT, 0);
    const stage = (0, $69Mlo.useRef)(null);
    const [fontLoaded, setFontLoaded] = (0, $69Mlo.useState)(false);
    const downloadArt = (e)=>{
        if (!stage.current) return;
        let url = stage.current.toDataURL();
        url = (0, $1cb6f77dbd191419$exports.changeDpiDataUrl)(url, 300);
        e.currentTarget.download = `${meta.album}-label.png`;
        e.currentTarget.href = url;
    };
    const redraw = ()=>{
        if (!stage.current) return;
        stage.current.draw();
    };
    (0, $69Mlo.useEffect)(()=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($4852980c32d42d7f$exports))).load({
            typekit: {
                id: "elb5ydo"
            },
            google: {
                families: [
                    "Atkinson Hyperlegible:bold",
                    "B612:bold"
                ]
            },
            active: ()=>setFontLoaded(true)
        });
    });
    return /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsxs)((0, $3a516b44bc0ae84b$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsxs)((0, $03522d94dd76bbd0$export$208cd1682bd0e4b6), {
                ref: stage,
                width: width * $806b4f03ea604a37$var$PPM_FACTOR,
                height: height * $806b4f03ea604a37$var$PPM_FACTOR,
                scaleX: $806b4f03ea604a37$var$PPM_FACTOR,
                scaleY: $806b4f03ea604a37$var$PPM_FACTOR,
                children: [
                    /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsx)((0, $03522d94dd76bbd0$export$936d0764594b6eb3), {
                        children: /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsx)((0, $03522d94dd76bbd0$export$c79fc6492f3af13d), {
                            height: 54,
                            width: 38,
                            fill: theme.bgColor
                        })
                    }),
                    /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsxs)((0, $03522d94dd76bbd0$export$936d0764594b6eb3), {
                        children: [
                            headerHeight > 0 && /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsxs)((0, $3a516b44bc0ae84b$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsx)((0, $03522d94dd76bbd0$export$17d680238e50603e), {
                                        fill: theme.fgColor,
                                        closed: true,
                                        points: [
                                            leftMargin + ARROW_HEIGHT,
                                            ARROW_Y,
                                            leftMargin + ARROW_HEIGHT * 2,
                                            ARROW_Y + ARROW_HEIGHT,
                                            leftMargin,
                                            ARROW_Y + ARROW_HEIGHT
                                        ]
                                    }),
                                    fontLoaded ? /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsx)((0, $03522d94dd76bbd0$export$5f1af8db9871e1d6), {
                                        offsetY: fontSize,
                                        x: 5.5,
                                        y: ARROW_HEIGHT + ARROW_Y,
                                        fontSize: fontSize,
                                        fontFamily: font,
                                        fontVariant: "bold",
                                        text: "INSERT THIS END",
                                        fill: theme.fgColor,
                                        lineHeight: fontSize
                                    }) : null,
                                    /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsx)($806b4f03ea604a37$var$MDLogo, {
                                        y: 0,
                                        x: width - leftMargin,
                                        headerHeight: headerHeight
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsx)($806b4f03ea604a37$var$AlbumArt, {
                                src: meta.artURL.toString(),
                                height: width,
                                width: width,
                                x: 0,
                                y: headerHeight
                            }),
                            fontLoaded ? /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsx)($806b4f03ea604a37$var$Meta, {
                                album: uppercase ? meta.album.toUpperCase() : meta.album,
                                artist: uppercase ? meta.artist.toUpperCase() : meta.artist,
                                year: uppercase ? meta.year.toUpperCase() : meta.year,
                                color: theme.fgColor,
                                containerHeight: metaContainerHeight,
                                fontSize: fontSize,
                                lineHeight: lineHeight,
                                yOffset: width + headerHeight,
                                margin: leftMargin,
                                font: font,
                                width: width
                            }) : null
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsx)("a", {
                        className: "btn",
                        onClick: downloadArt,
                        children: "download label"
                    }),
                    /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsx)("a", {
                        className: "btn",
                        onClick: redraw,
                        children: "redraw (fixes broken fonts and artifacts)"
                    })
                ]
            })
        ]
    });
};


var $c8ce35f1cfb0824d$exports = {};
$c8ce35f1cfb0824d$exports = new URL("glass-beach.1ddc32ca.jpg", import.meta.url).toString();


var $811813c21f5814fb$exports = {};
$811813c21f5814fb$exports = new URL("dogleg.143dbd86.jpg", import.meta.url).toString();


var $d7bda81722e6000f$exports = {};
$d7bda81722e6000f$exports = new URL("somewhere-city.99d3ebc1.jpg", import.meta.url).toString();


var $13499cd549ae2e86$exports = {};
$13499cd549ae2e86$exports = new URL("somoku-hodo.d2415a3b.jpg", import.meta.url).toString();


var $2e2ff32fce4ed462$exports = {};
$2e2ff32fce4ed462$exports = new URL("three-cheers.eaebb867.jpg", import.meta.url).toString();


var $121d6be411fbe860$exports = {};
$121d6be411fbe860$exports = new URL("implementation.7f55dea8.jpg", import.meta.url).toString();


var $371c0371179521c9$exports = {};
$371c0371179521c9$exports = new URL("crap-shit.32285363.jpg", import.meta.url).toString();


var $e29dbb337177fc2a$exports = {};
$e29dbb337177fc2a$exports = new URL("unhappy-refrain.3d520614.jpg", import.meta.url).toString();


var $3c21672e879343a0$exports = {};
$3c21672e879343a0$exports = new URL("cutiemarks.6b094e23.jpg", import.meta.url).toString();


var $d6f85008834c609d$exports = {};
$d6f85008834c609d$exports = new URL("neo-wax-bloom.f0a32ba6.jpg", import.meta.url).toString();


var $57bf673b8ffc6878$exports = {};
$57bf673b8ffc6878$exports = new URL("cmiygl.b6424ce4.jpg", import.meta.url).toString();


var $acb0a2f8f73e2dfd$exports = {};
$acb0a2f8f73e2dfd$exports = new URL("ultrapop.d2eb5712.jpg", import.meta.url).toString();


var $c15329fc17596b6a$exports = {};
$c15329fc17596b6a$exports = new URL("savior.31abdd46.jpg", import.meta.url).toString();


var $ed91c9dea8661800$exports = {};
$ed91c9dea8661800$exports = new URL("wallsocket.d12b9f92.jpg", import.meta.url).toString();


var $378147cf65c4297b$exports = {};
$378147cf65c4297b$exports = new URL("wacca.96e7ab21.jpg", import.meta.url).toString();


var $5cccc448fcdc2b45$exports = {};
$5cccc448fcdc2b45$exports = new URL("constant-companions.c9d1990e.png", import.meta.url).toString();


const $f4bb255c547a3373$export$d34f41cc438e4bab = [
    {
        artist: "glass beach",
        album: "the first glass beach album",
        year: "2019",
        artURL: new URL($c8ce35f1cfb0824d$exports)
    },
    {
        artist: "dogleg",
        album: "melee",
        year: "2020",
        artURL: new URL($811813c21f5814fb$exports)
    },
    {
        artist: "origami angel",
        album: "somewhere city",
        year: "2019",
        artURL: new URL($d7bda81722e6000f$exports)
    },
    {
        artist: "\u9577\u8C37\u5DDD\u767D\u7D19",
        album: "\u8349\u6728\u840C\u52D5",
        year: "2018",
        artURL: new URL($13499cd549ae2e86$exports)
    },
    {
        artist: "my chemical romance",
        album: "three cheers for sweet revenge",
        year: "2004",
        artURL: new URL($2e2ff32fce4ed462$exports)
    },
    {
        artist: "DV-i",
        album: "implementation",
        year: "2020",
        artURL: new URL($121d6be411fbe860$exports)
    },
    {
        artist: "girls rituals",
        album: "crap shit",
        year: "2020",
        artURL: new URL($371c0371179521c9$exports)
    },
    {
        artist: "wowaka",
        album: "unhappy refrain",
        year: "2011",
        artURL: new URL($e29dbb337177fc2a$exports)
    },
    {
        artist: "vylet pony",
        album: "cutiemarks",
        year: "2021",
        artURL: new URL($3c21672e879343a0$exports)
    },
    {
        artist: "iglooghost",
        album: "Ne\u014D Wax Bloom",
        year: "2017",
        artURL: new URL($d6f85008834c609d$exports)
    },
    {
        artist: "Tyler, the Creator",
        album: "CALL ME IF YOU GET LOST",
        year: "2021",
        artURL: new URL($57bf673b8ffc6878$exports)
    },
    {
        album: "ULTRAPOP",
        artist: "The Armed",
        year: "2021",
        artURL: new URL($acb0a2f8f73e2dfd$exports)
    },
    {
        album: "SAVIOR",
        artist: "telebasher",
        year: "2023",
        artURL: new URL($c15329fc17596b6a$exports)
    },
    {
        album: "Wallsocket",
        artist: "underscores",
        year: "2023",
        artURL: new URL($ed91c9dea8661800$exports)
    },
    {
        album: "WACCA Complete Album",
        artist: "Various Artists",
        year: "2022",
        artURL: new URL($378147cf65c4297b$exports)
    },
    {
        album: "Constant Companions",
        artist: "Jamie Paige",
        year: "2024",
        artURL: new URL($5cccc448fcdc2b45$exports)
    }
];
function $f4bb255c547a3373$export$bdef285c96428927() {
    return $f4bb255c547a3373$export$d34f41cc438e4bab[Math.floor(Math.random() * $f4bb255c547a3373$export$d34f41cc438e4bab.length)];
}



const $66a3da211923d90f$export$86fbec116b87613f = ()=>{
    const [meta, setMeta] = (0, $69Mlo.useState)((0, $f4bb255c547a3373$export$bdef285c96428927)());
    const [uppercase, setUppercase] = (0, $69Mlo.useState)(true);
    const [hideHeader, setHideHeader] = (0, $69Mlo.useState)(false);
    const [theme, setTheme] = (0, $69Mlo.useState)((0, $b6ca3dd5c1566f88$export$1d8e462b9ec86de2).Dark);
    const [font, setFont] = (0, $69Mlo.useState)("futura-pt-bold");
    function newPreset() {
        let i = 0;
        while(i < 3){
            const candidate = (0, $f4bb255c547a3373$export$bdef285c96428927)();
            if (candidate.album !== meta.album) {
                setMeta(candidate);
                return;
            }
            i++;
        }
        setMeta((0, $f4bb255c547a3373$export$bdef285c96428927)());
    }
    return /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsxs)("div", {
        className: "container",
        children: [
            /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsx)((0, $806b4f03ea604a37$export$66d167152c83103b), {
                width: 38,
                height: 54,
                theme: theme,
                fontSize: 1.76,
                headerHeight: hideHeader ? 0 : 5,
                leftMargin: 2,
                lineHeight: 2.12,
                metaContainerHeight: hideHeader ? 16 : 11,
                meta: meta,
                uppercase: uppercase,
                font: font
            }),
            /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsxs)("label", {
                        children: [
                            "album",
                            " ",
                            /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsx)("input", {
                                type: "text",
                                value: meta.album,
                                onChange: ({ currentTarget: currentTarget })=>setMeta({
                                        ...meta,
                                        album: currentTarget.value
                                    })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsxs)("label", {
                        children: [
                            "artist",
                            " ",
                            /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsx)("input", {
                                type: "text",
                                value: meta.artist,
                                onChange: ({ currentTarget: currentTarget })=>setMeta({
                                        ...meta,
                                        artist: currentTarget.value
                                    })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsxs)("label", {
                        children: [
                            "year",
                            " ",
                            /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsx)("input", {
                                type: "text",
                                value: meta.year,
                                onChange: ({ currentTarget: currentTarget })=>setMeta({
                                        ...meta,
                                        year: currentTarget.value
                                    })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsx)("br", {})
                ]
            }),
            /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsxs)("label", {
                children: [
                    "album art (preferably square, at least 500px wide)",
                    /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsxs)("div", {
                        className: "file-field input-field",
                        children: [
                            /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsxs)("div", {
                                className: "btn",
                                children: [
                                    /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsx)("span", {
                                        children: "File"
                                    }),
                                    /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsx)("input", {
                                        type: "file",
                                        accept: "image/*",
                                        onChange: ({ currentTarget: currentTarget })=>{
                                            const reader = new FileReader();
                                            reader.onload = function() {
                                                setMeta({
                                                    ...meta,
                                                    artURL: typeof reader.result === "string" ? new URL(reader.result) : meta.artURL
                                                });
                                            };
                                            if (currentTarget.files) reader.readAsDataURL(currentTarget.files[0]);
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsx)("div", {
                                className: "file-path-wrapper",
                                children: /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsx)("input", {
                                    className: "file-path validate",
                                    type: "text"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsxs)("label", {
                children: [
                    "theme",
                    /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsx)("p", {
                        children: /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsxs)("label", {
                            children: [
                                /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsx)("input", {
                                    className: "with-gap",
                                    name: "theme",
                                    value: "dark",
                                    type: "radio",
                                    checked: theme === (0, $b6ca3dd5c1566f88$export$1d8e462b9ec86de2).Dark,
                                    onChange: ()=>setTheme((0, $b6ca3dd5c1566f88$export$1d8e462b9ec86de2).Dark)
                                }),
                                /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsx)("span", {
                                    children: "Dark"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsx)("p", {
                        children: /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsxs)("label", {
                            children: [
                                /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsx)("input", {
                                    className: "with-gap",
                                    name: "theme",
                                    value: "light",
                                    type: "radio",
                                    checked: theme === (0, $b6ca3dd5c1566f88$export$1d8e462b9ec86de2).Light,
                                    onChange: ()=>setTheme((0, $b6ca3dd5c1566f88$export$1d8e462b9ec86de2).Light)
                                }),
                                /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsx)("span", {
                                    children: "Light"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsxs)("label", {
                children: [
                    "font",
                    /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsx)("p", {
                        children: /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsxs)("label", {
                            children: [
                                /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsx)("input", {
                                    className: "with-gap",
                                    type: "radio",
                                    checked: font === "futura-pt-bold",
                                    onChange: ()=>setFont("futura-pt-bold")
                                }),
                                /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsx)("span", {
                                    children: "Futura"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsx)("p", {
                        children: /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsxs)("label", {
                            children: [
                                /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsx)("input", {
                                    className: "with-gap",
                                    type: "radio",
                                    checked: font === "Atkinson Hyperlegible",
                                    onChange: ()=>setFont("Atkinson Hyperlegible")
                                }),
                                /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsx)("span", {
                                    children: "Atkinson Hyperlegible"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsx)("p", {
                        children: /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsxs)("label", {
                            children: [
                                /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsx)("input", {
                                    className: "with-gap",
                                    type: "radio",
                                    checked: font === "B612",
                                    onChange: ()=>setFont("B612")
                                }),
                                /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsx)("span", {
                                    children: "B612"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsx)("label", {
                children: /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsx)("p", {
                    children: /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsxs)("label", {
                        children: [
                            /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsx)("input", {
                                type: "checkbox",
                                className: "filled-in",
                                checked: uppercase,
                                onChange: ()=>setUppercase((val)=>!val)
                            }),
                            /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsx)("span", {
                                children: "uppercase"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsx)("label", {
                children: /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsx)("p", {
                    children: /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsxs)("label", {
                        children: [
                            /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsx)("input", {
                                type: "checkbox",
                                className: "filled-in",
                                checked: hideHeader,
                                onChange: ()=>setHideHeader((val)=>!val)
                            }),
                            /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsx)("span", {
                                children: "hide header"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsx)("button", {
                className: "btn-small",
                onClick: ()=>newPreset(),
                children: "new random preset"
            }),
            /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsxs)("p", {
                children: [
                    "developed by ",
                    /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsx)("a", {
                        href: "https://cohost.org/jkap",
                        children: "jae kaplan"
                    }),
                    ". dm me on ",
                    /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsx)("a", {
                        href: "https://reddit.com/u/yrfriendjkap",
                        children: "reddit"
                    }),
                    " ",
                    "if you need help or have questions"
                ]
            }),
            /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsxs)("p", {
                children: [
                    "if you found this helpful, please consider throwing me a couple bucks ",
                    /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsx)("a", {
                        href: "https://ko-fi.com/jkap",
                        children: "on ko-fi!"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsx)("a", {
                        href: "https://github.com/jkap/minidisc-label-maker",
                        children: "check out the code on github!"
                    }),
                    " ",
                    "it's not very good but it gets the job done."
                ]
            }),
            /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsxs)("p", {
                children: [
                    "design inspired by",
                    " ",
                    /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsx)("a", {
                        href: "https://www.reddit.com/r/minidisc/comments/ful65q/recording_session_minidiscs_with_custom_labels/",
                        children: "/u/aaarchvz"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsxs)("p", {
                children: [
                    "want more customization? check out",
                    " ",
                    /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsx)("a", {
                        href: "https://md-cover-designer.web.app/cover",
                        children: "MD Cover Designer"
                    }),
                    " ",
                    "by ",
                    /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsx)("a", {
                        href: "https://reddit.com/u/RunePML",
                        children: "/u/RunePML"
                    })
                ]
            })
        ]
    });
};



var $846f5c1113900f24$exports = {};
$846f5c1113900f24$exports = new URL("service-worker.js", import.meta.url).toString();


navigator.serviceWorker.register($846f5c1113900f24$exports);
const $e4f8672d2203721a$var$container = document.getElementById("root");
const $e4f8672d2203721a$var$root = (0, $858f075c68333da1$export$882461b6382ed46c)($e4f8672d2203721a$var$container);
$e4f8672d2203721a$var$root.render(/*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($69Mlo))).StrictMode, {
    children: /*#__PURE__*/ (0, $3a516b44bc0ae84b$exports.jsx)((0, $66a3da211923d90f$export$86fbec116b87613f), {})
}));


//# sourceMappingURL=index.857eb48a.js.map
